import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: any;
  float8: any;
  geography: any;
  geometry: any;
  jsonb: any;
  numeric: any;
  timestamptz: any;
  uuid: any;
};

export type AcceptCollegeInviteInput = {
  inviteId: Scalars['uuid'];
};

export type AcceptCollegeInviteOutput = {
  __typename?: 'AcceptCollegeInviteOutput';
  valid: Scalars['Boolean'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type CreateHighSchoolTeamInput = {
  high_school_id: Scalars['uuid'];
  members: Array<Scalars['String']>;
  name: Scalars['String'];
  primary_game: Scalars['String'];
};

export type CreateHighSchoolTeamOutput = {
  __typename?: 'CreateHighSchoolTeamOutput';
  comments?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  notFound?: Maybe<Array<Maybe<Scalars['String']>>>;
  status: Scalars['String'];
};

export type CreatePlayerTeamInput = {
  members: Array<Scalars['String']>;
  name: Scalars['String'];
  player_profile_id: Scalars['uuid'];
  primary_game: Scalars['String'];
};

export type CreatePlayerTeamOutput = {
  __typename?: 'CreatePlayerTeamOutput';
  comments?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  notFound?: Maybe<Array<Maybe<Scalars['String']>>>;
  status: Scalars['String'];
};

export type EditHighSchoolTeamInput = {
  high_school_id: Scalars['uuid'];
  id: Scalars['uuid'];
  members: Array<Scalars['String']>;
  name: Scalars['String'];
  primary_game: Scalars['String'];
  team_captain?: InputMaybe<Scalars['String']>;
};

export type EditHighSchoolTeamOutput = {
  __typename?: 'EditHighSchoolTeamOutput';
  comments?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  notFound?: Maybe<Array<Maybe<Scalars['String']>>>;
  status: Scalars['String'];
};

export type EditPlayerTeamInput = {
  id: Scalars['uuid'];
  members: Array<Scalars['String']>;
  name: Scalars['String'];
  primary_game: Scalars['String'];
  team_captain?: InputMaybe<Scalars['String']>;
};

export type EditPlayerTeamOutput = {
  __typename?: 'EditPlayerTeamOutput';
  comments?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  notFound?: Maybe<Array<Maybe<Scalars['String']>>>;
  status: Scalars['String'];
};

export type EventTicketPaymentIntent = {
  eventRegistrationId: Scalars['uuid'];
};

export type EventTicketPaymentIntentOutput = {
  __typename?: 'EventTicketPaymentIntentOutput';
  paymentSecret: Scalars['String'];
};

export type FileUploadUrlRequestInput = {
  filename: Scalars['String'];
  mime: Scalars['String'];
};

export type FileUploadUrlRequestOutput = {
  __typename?: 'FileUploadUrlRequestOutput';
  id: Scalars['uuid'];
  key: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type GetAllVerifiedHighSchoolNamesOutput = {
  __typename?: 'GetAllVerifiedHighSchoolNamesOutput';
  highSchoolData?: Maybe<VerifiedHighSchoolData>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type InviteHighSchoolColleagueActionInput = {
  emails: Array<Scalars['String']>;
  highSchoolId: Scalars['uuid'];
};

export type InviteHighSchoolColleagueActionOutput = {
  __typename?: 'InviteHighSchoolColleagueActionOutput';
  message: Scalars['String'];
  status: Scalars['String'];
};

export type InvitePlayersToTeamActionInput = {
  members: Array<Scalars['String']>;
  teamId: Scalars['uuid'];
};

export type InvitePlayersToTeamActionOutput = {
  __typename?: 'InvitePlayersToTeamActionOutput';
  alreadyInvited?: Maybe<Array<Maybe<Scalars['String']>>>;
  notFound?: Maybe<Array<Maybe<Scalars['String']>>>;
  status: Scalars['String'];
};

export type PasswordResetOutput = {
  __typename?: 'PasswordResetOutput';
  status?: Maybe<Scalars['Boolean']>;
};

export type RedeemCollegeReferralCodeInsertInput = {
  codeKey: Scalars['String'];
  collegeId: Scalars['uuid'];
};

export type RedeemCollegeReferralCodeInsertOutput = {
  __typename?: 'RedeemCollegeReferralCodeInsertOutput';
  codeId: Scalars['uuid'];
};

export type RedeemPlayerReferralCodeInsertInput = {
  codeKey: Scalars['String'];
  playerId: Scalars['uuid'];
};

export type RedeemPlayerReferralCodeInsertOutput = {
  __typename?: 'RedeemPlayerReferralCodeInsertOutput';
  codeId: Scalars['uuid'];
};

export type RemoveChildPlayerOutput = {
  __typename?: 'RemoveChildPlayerOutput';
  valid: Scalars['Boolean'];
};

export type SendMassPlayerMessageInput = {
  followed_players?: InputMaybe<Scalars['Boolean']>;
  message_template: Scalars['String'];
  preferred_study_fields: Scalars['jsonb'];
  primary_game?: InputMaybe<Scalars['uuid']>;
  states?: InputMaybe<Scalars['jsonb']>;
  user_id: Scalars['String'];
};

export type SendMassPlayerMessageOutput = {
  __typename?: 'SendMassPlayerMessageOutput';
  messages_sent: Scalars['numeric'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type SubmitPlayerProfileUpdateEspinDraftPlayerProfileInsertInput = {
  ack_displayed?: InputMaybe<Scalars['Boolean']>;
  ack_terms?: InputMaybe<Scalars['Boolean']>;
  ack_waiver?: InputMaybe<Scalars['Boolean']>;
  bio?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['date']>;
  city?: InputMaybe<Scalars['String']>;
  college_coach_email?: InputMaybe<Scalars['String']>;
  college_coach_name?: InputMaybe<Scalars['String']>;
  college_name?: InputMaybe<Scalars['String']>;
  committed_to_college?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  discord?: InputMaybe<Scalars['String']>;
  ethnicity?: InputMaybe<SubmitPlayerProfileUpdateEspinEthnicityOptionsEnum>;
  facebook?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<SubmitPlayerProfileUpdateEspinGenderOptionsEnum>;
  gender_not_listed_entry?: InputMaybe<Scalars['String']>;
  gpa?: InputMaybe<Scalars['numeric']>;
  graduating_class?: InputMaybe<Scalars['String']>;
  hs_coach_email?: InputMaybe<Scalars['String']>;
  hs_coach_name?: InputMaybe<Scalars['String']>;
  hs_name?: InputMaybe<Scalars['String']>;
  in_game_username?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_hs?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  linked_high_school?: InputMaybe<Scalars['uuid']>;
  parent_email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  preferred_schools?: InputMaybe<Scalars['jsonb']>;
  preferred_study_fields?: InputMaybe<Scalars['jsonb']>;
  primary_game?: InputMaybe<Scalars['uuid']>;
  primary_game_rank?: InputMaybe<Scalars['String']>;
  primary_game_role?: InputMaybe<Scalars['String']>;
  primary_game_tracker?: InputMaybe<Scalars['String']>;
  profile_image_id?: InputMaybe<Scalars['uuid']>;
  spin_username?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tiktok?: InputMaybe<Scalars['String']>;
  twitch?: InputMaybe<Scalars['String']>;
  twitch_channel?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  user_source?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  youtube_channel?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export enum SubmitPlayerProfileUpdateEspinEthnicityOptionsEnum {
  /** Asian or Pacific Islander */
  AsianOrPacificIslander = 'asian_or_pacific_islander',
  /** Black or African American */
  BlackOrAfricanAmerican = 'black_or_african_american',
  /** Hispanic or Latino */
  HispanicOrLatino = 'hispanic_or_latino',
  /** Multiracial or Biracial */
  MultiracialOrBiracial = 'multiracial_or_biracial',
  /** Native American or Alaskan Native */
  NativeAmericanOrAlaskanNative = 'native_american_or_alaskan_native',
  /** A race/ethnicity not listed here */
  NotListed = 'not_listed',
  /** Prefer not to say */
  PreferNotToSay = 'prefer_not_to_say',
  /** White or Caucasian */
  WhiteOrCaucasian = 'white_or_caucasian'
}

export enum SubmitPlayerProfileUpdateEspinGenderOptionsEnum {
  /** Female */
  Female = 'female',
  /** Male */
  Male = 'male',
  /** Non-Conforming */
  Nonconforming = 'nonconforming',
  /** Not Listed */
  NotListed = 'not_listed',
  /** Prefer not to say */
  PreferNotToSay = 'prefer_not_to_say'
}

export type SubmitPlayerProfileUpdateOutput = {
  __typename?: 'SubmitPlayerProfileUpdateOutput';
  comments: Scalars['String'];
  id?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
};

export type VerifiedHighSchool = {
  __typename?: 'VerifiedHighSchool';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type VerifiedHighSchoolData = {
  __typename?: 'VerifiedHighSchoolData';
  highSchools?: Maybe<Array<Maybe<VerifiedHighSchool>>>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** Available language terms on CEH landing site */
export type Cehsite_Ms_Available_Site_Terms = {
  __typename?: 'cehsite_ms_available_site_terms';
  description: Scalars['String'];
  key: Scalars['String'];
};

/** aggregated selection of "cehsite.ms_available_site_terms" */
export type Cehsite_Ms_Available_Site_Terms_Aggregate = {
  __typename?: 'cehsite_ms_available_site_terms_aggregate';
  aggregate?: Maybe<Cehsite_Ms_Available_Site_Terms_Aggregate_Fields>;
  nodes: Array<Cehsite_Ms_Available_Site_Terms>;
};

/** aggregate fields of "cehsite.ms_available_site_terms" */
export type Cehsite_Ms_Available_Site_Terms_Aggregate_Fields = {
  __typename?: 'cehsite_ms_available_site_terms_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Cehsite_Ms_Available_Site_Terms_Max_Fields>;
  min?: Maybe<Cehsite_Ms_Available_Site_Terms_Min_Fields>;
};


/** aggregate fields of "cehsite.ms_available_site_terms" */
export type Cehsite_Ms_Available_Site_Terms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cehsite_Ms_Available_Site_Terms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cehsite.ms_available_site_terms". All fields are combined with a logical 'AND'. */
export type Cehsite_Ms_Available_Site_Terms_Bool_Exp = {
  _and?: InputMaybe<Array<Cehsite_Ms_Available_Site_Terms_Bool_Exp>>;
  _not?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Bool_Exp>;
  _or?: InputMaybe<Array<Cehsite_Ms_Available_Site_Terms_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cehsite.ms_available_site_terms" */
export enum Cehsite_Ms_Available_Site_Terms_Constraint {
  /** unique or primary key constraint on columns "key" */
  MsSiteTermsEnumPkey = 'ms_site_terms_enum_pkey'
}

export enum Cehsite_Ms_Available_Site_Terms_Enum {
  /** Brand description for charlotte phoenix */
  BrandCltDescription = 'brand_clt_description',
  /** Brand description for CLT events */
  BrandCltEventsDescription = 'brand_clt_events_description',
  /** Brand description for Emerge */
  BrandEmergeDescription = 'brand_emerge_description',
  /** Brand description for Spin */
  BrandSpinDescription = 'brand_spin_description',
  /** Copy appearing under "Contact Us" */
  ContactUsCopy = 'contact_us_copy',
  /** Text for CAROLINA ESPORTS HUB BRANDS */
  HubBrandDescription = 'hub_brand_description',
  /** Under "Our Mission" */
  MissonStatement = 'misson_statement',
  /** Copy appearing above newsletter signup at bottom of the page */
  NewsletterCopyHeader = 'newsletter_copy_header',
  /** Under "Our History" */
  OurHistoryCopy = 'our_history_copy',
  /** Text to appear under main header */
  TopHeroDescription = 'top_hero_description'
}

/** Boolean expression to compare columns of type "cehsite_ms_available_site_terms_enum". All fields are combined with logical 'AND'. */
export type Cehsite_Ms_Available_Site_Terms_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Enum>;
  _in?: InputMaybe<Array<Cehsite_Ms_Available_Site_Terms_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Enum>;
  _nin?: InputMaybe<Array<Cehsite_Ms_Available_Site_Terms_Enum>>;
};

/** input type for inserting data into table "cehsite.ms_available_site_terms" */
export type Cehsite_Ms_Available_Site_Terms_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cehsite_Ms_Available_Site_Terms_Max_Fields = {
  __typename?: 'cehsite_ms_available_site_terms_max_fields';
  description?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Cehsite_Ms_Available_Site_Terms_Min_Fields = {
  __typename?: 'cehsite_ms_available_site_terms_min_fields';
  description?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cehsite.ms_available_site_terms" */
export type Cehsite_Ms_Available_Site_Terms_Mutation_Response = {
  __typename?: 'cehsite_ms_available_site_terms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cehsite_Ms_Available_Site_Terms>;
};

/** on_conflict condition type for table "cehsite.ms_available_site_terms" */
export type Cehsite_Ms_Available_Site_Terms_On_Conflict = {
  constraint: Cehsite_Ms_Available_Site_Terms_Constraint;
  update_columns?: Array<Cehsite_Ms_Available_Site_Terms_Update_Column>;
  where?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Bool_Exp>;
};

/** Ordering options when selecting data from "cehsite.ms_available_site_terms". */
export type Cehsite_Ms_Available_Site_Terms_Order_By = {
  description?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cehsite.ms_available_site_terms */
export type Cehsite_Ms_Available_Site_Terms_Pk_Columns_Input = {
  key: Scalars['String'];
};

/** select columns of table "cehsite.ms_available_site_terms" */
export enum Cehsite_Ms_Available_Site_Terms_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Key = 'key'
}

/** input type for updating data in table "cehsite.ms_available_site_terms" */
export type Cehsite_Ms_Available_Site_Terms_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "cehsite_ms_available_site_terms" */
export type Cehsite_Ms_Available_Site_Terms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cehsite_Ms_Available_Site_Terms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cehsite_Ms_Available_Site_Terms_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
};

/** update columns of table "cehsite.ms_available_site_terms" */
export enum Cehsite_Ms_Available_Site_Terms_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Key = 'key'
}

export type Cehsite_Ms_Available_Site_Terms_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cehsite_Ms_Available_Site_Terms_Bool_Exp;
};

/** Contact form entries for CEH microsite */
export type Cehsite_Ms_Contact_Form_Entry = {
  __typename?: 'cehsite_ms_contact_form_entry';
  created_at?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  id: Scalars['uuid'];
  message?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "cehsite.ms_contact_form_entry" */
export type Cehsite_Ms_Contact_Form_Entry_Aggregate = {
  __typename?: 'cehsite_ms_contact_form_entry_aggregate';
  aggregate?: Maybe<Cehsite_Ms_Contact_Form_Entry_Aggregate_Fields>;
  nodes: Array<Cehsite_Ms_Contact_Form_Entry>;
};

/** aggregate fields of "cehsite.ms_contact_form_entry" */
export type Cehsite_Ms_Contact_Form_Entry_Aggregate_Fields = {
  __typename?: 'cehsite_ms_contact_form_entry_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Cehsite_Ms_Contact_Form_Entry_Max_Fields>;
  min?: Maybe<Cehsite_Ms_Contact_Form_Entry_Min_Fields>;
};


/** aggregate fields of "cehsite.ms_contact_form_entry" */
export type Cehsite_Ms_Contact_Form_Entry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cehsite_Ms_Contact_Form_Entry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cehsite.ms_contact_form_entry". All fields are combined with a logical 'AND'. */
export type Cehsite_Ms_Contact_Form_Entry_Bool_Exp = {
  _and?: InputMaybe<Array<Cehsite_Ms_Contact_Form_Entry_Bool_Exp>>;
  _not?: InputMaybe<Cehsite_Ms_Contact_Form_Entry_Bool_Exp>;
  _or?: InputMaybe<Array<Cehsite_Ms_Contact_Form_Entry_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cehsite.ms_contact_form_entry" */
export enum Cehsite_Ms_Contact_Form_Entry_Constraint {
  /** unique or primary key constraint on columns "id" */
  MsContactFormEntryPkey = 'ms_contact_form_entry_pkey'
}

/** input type for inserting data into table "cehsite.ms_contact_form_entry" */
export type Cehsite_Ms_Contact_Form_Entry_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Cehsite_Ms_Contact_Form_Entry_Max_Fields = {
  __typename?: 'cehsite_ms_contact_form_entry_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Cehsite_Ms_Contact_Form_Entry_Min_Fields = {
  __typename?: 'cehsite_ms_contact_form_entry_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "cehsite.ms_contact_form_entry" */
export type Cehsite_Ms_Contact_Form_Entry_Mutation_Response = {
  __typename?: 'cehsite_ms_contact_form_entry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cehsite_Ms_Contact_Form_Entry>;
};

/** on_conflict condition type for table "cehsite.ms_contact_form_entry" */
export type Cehsite_Ms_Contact_Form_Entry_On_Conflict = {
  constraint: Cehsite_Ms_Contact_Form_Entry_Constraint;
  update_columns?: Array<Cehsite_Ms_Contact_Form_Entry_Update_Column>;
  where?: InputMaybe<Cehsite_Ms_Contact_Form_Entry_Bool_Exp>;
};

/** Ordering options when selecting data from "cehsite.ms_contact_form_entry". */
export type Cehsite_Ms_Contact_Form_Entry_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cehsite.ms_contact_form_entry */
export type Cehsite_Ms_Contact_Form_Entry_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "cehsite.ms_contact_form_entry" */
export enum Cehsite_Ms_Contact_Form_Entry_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "cehsite.ms_contact_form_entry" */
export type Cehsite_Ms_Contact_Form_Entry_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "cehsite_ms_contact_form_entry" */
export type Cehsite_Ms_Contact_Form_Entry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cehsite_Ms_Contact_Form_Entry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cehsite_Ms_Contact_Form_Entry_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "cehsite.ms_contact_form_entry" */
export enum Cehsite_Ms_Contact_Form_Entry_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Cehsite_Ms_Contact_Form_Entry_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cehsite_Ms_Contact_Form_Entry_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cehsite_Ms_Contact_Form_Entry_Bool_Exp;
};

/** Email signups for the microsite */
export type Cehsite_Ms_Newsletter_Signup = {
  __typename?: 'cehsite_ms_newsletter_signup';
  created_at?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

/** aggregated selection of "cehsite.ms_newsletter_signup" */
export type Cehsite_Ms_Newsletter_Signup_Aggregate = {
  __typename?: 'cehsite_ms_newsletter_signup_aggregate';
  aggregate?: Maybe<Cehsite_Ms_Newsletter_Signup_Aggregate_Fields>;
  nodes: Array<Cehsite_Ms_Newsletter_Signup>;
};

/** aggregate fields of "cehsite.ms_newsletter_signup" */
export type Cehsite_Ms_Newsletter_Signup_Aggregate_Fields = {
  __typename?: 'cehsite_ms_newsletter_signup_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Cehsite_Ms_Newsletter_Signup_Max_Fields>;
  min?: Maybe<Cehsite_Ms_Newsletter_Signup_Min_Fields>;
};


/** aggregate fields of "cehsite.ms_newsletter_signup" */
export type Cehsite_Ms_Newsletter_Signup_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cehsite_Ms_Newsletter_Signup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cehsite.ms_newsletter_signup". All fields are combined with a logical 'AND'. */
export type Cehsite_Ms_Newsletter_Signup_Bool_Exp = {
  _and?: InputMaybe<Array<Cehsite_Ms_Newsletter_Signup_Bool_Exp>>;
  _not?: InputMaybe<Cehsite_Ms_Newsletter_Signup_Bool_Exp>;
  _or?: InputMaybe<Array<Cehsite_Ms_Newsletter_Signup_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cehsite.ms_newsletter_signup" */
export enum Cehsite_Ms_Newsletter_Signup_Constraint {
  /** unique or primary key constraint on columns "email" */
  MsNewsletterSignupEmailKey = 'ms_newsletter_signup_email_key',
  /** unique or primary key constraint on columns "id" */
  MsNewsletterSignupPkey = 'ms_newsletter_signup_pkey'
}

/** input type for inserting data into table "cehsite.ms_newsletter_signup" */
export type Cehsite_Ms_Newsletter_Signup_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cehsite_Ms_Newsletter_Signup_Max_Fields = {
  __typename?: 'cehsite_ms_newsletter_signup_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Cehsite_Ms_Newsletter_Signup_Min_Fields = {
  __typename?: 'cehsite_ms_newsletter_signup_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cehsite.ms_newsletter_signup" */
export type Cehsite_Ms_Newsletter_Signup_Mutation_Response = {
  __typename?: 'cehsite_ms_newsletter_signup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cehsite_Ms_Newsletter_Signup>;
};

/** on_conflict condition type for table "cehsite.ms_newsletter_signup" */
export type Cehsite_Ms_Newsletter_Signup_On_Conflict = {
  constraint: Cehsite_Ms_Newsletter_Signup_Constraint;
  update_columns?: Array<Cehsite_Ms_Newsletter_Signup_Update_Column>;
  where?: InputMaybe<Cehsite_Ms_Newsletter_Signup_Bool_Exp>;
};

/** Ordering options when selecting data from "cehsite.ms_newsletter_signup". */
export type Cehsite_Ms_Newsletter_Signup_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cehsite.ms_newsletter_signup */
export type Cehsite_Ms_Newsletter_Signup_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "cehsite.ms_newsletter_signup" */
export enum Cehsite_Ms_Newsletter_Signup_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Phone = 'phone'
}

/** input type for updating data in table "cehsite.ms_newsletter_signup" */
export type Cehsite_Ms_Newsletter_Signup_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "cehsite_ms_newsletter_signup" */
export type Cehsite_Ms_Newsletter_Signup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cehsite_Ms_Newsletter_Signup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cehsite_Ms_Newsletter_Signup_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** update columns of table "cehsite.ms_newsletter_signup" */
export enum Cehsite_Ms_Newsletter_Signup_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Phone = 'phone'
}

export type Cehsite_Ms_Newsletter_Signup_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cehsite_Ms_Newsletter_Signup_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cehsite_Ms_Newsletter_Signup_Bool_Exp;
};

/** Key value for managing content text */
export type Cehsite_Ms_Site_Content = {
  __typename?: 'cehsite_ms_site_content';
  key: Cehsite_Ms_Available_Site_Terms_Enum;
  value: Scalars['String'];
};

/** aggregated selection of "cehsite.ms_site_content" */
export type Cehsite_Ms_Site_Content_Aggregate = {
  __typename?: 'cehsite_ms_site_content_aggregate';
  aggregate?: Maybe<Cehsite_Ms_Site_Content_Aggregate_Fields>;
  nodes: Array<Cehsite_Ms_Site_Content>;
};

/** aggregate fields of "cehsite.ms_site_content" */
export type Cehsite_Ms_Site_Content_Aggregate_Fields = {
  __typename?: 'cehsite_ms_site_content_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Cehsite_Ms_Site_Content_Max_Fields>;
  min?: Maybe<Cehsite_Ms_Site_Content_Min_Fields>;
};


/** aggregate fields of "cehsite.ms_site_content" */
export type Cehsite_Ms_Site_Content_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cehsite_Ms_Site_Content_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cehsite.ms_site_content". All fields are combined with a logical 'AND'. */
export type Cehsite_Ms_Site_Content_Bool_Exp = {
  _and?: InputMaybe<Array<Cehsite_Ms_Site_Content_Bool_Exp>>;
  _not?: InputMaybe<Cehsite_Ms_Site_Content_Bool_Exp>;
  _or?: InputMaybe<Array<Cehsite_Ms_Site_Content_Bool_Exp>>;
  key?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Enum_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cehsite.ms_site_content" */
export enum Cehsite_Ms_Site_Content_Constraint {
  /** unique or primary key constraint on columns "key" */
  SiteContentPkey = 'site_content_pkey'
}

/** input type for inserting data into table "cehsite.ms_site_content" */
export type Cehsite_Ms_Site_Content_Insert_Input = {
  key?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Enum>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cehsite_Ms_Site_Content_Max_Fields = {
  __typename?: 'cehsite_ms_site_content_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Cehsite_Ms_Site_Content_Min_Fields = {
  __typename?: 'cehsite_ms_site_content_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cehsite.ms_site_content" */
export type Cehsite_Ms_Site_Content_Mutation_Response = {
  __typename?: 'cehsite_ms_site_content_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cehsite_Ms_Site_Content>;
};

/** on_conflict condition type for table "cehsite.ms_site_content" */
export type Cehsite_Ms_Site_Content_On_Conflict = {
  constraint: Cehsite_Ms_Site_Content_Constraint;
  update_columns?: Array<Cehsite_Ms_Site_Content_Update_Column>;
  where?: InputMaybe<Cehsite_Ms_Site_Content_Bool_Exp>;
};

/** Ordering options when selecting data from "cehsite.ms_site_content". */
export type Cehsite_Ms_Site_Content_Order_By = {
  key?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cehsite.ms_site_content */
export type Cehsite_Ms_Site_Content_Pk_Columns_Input = {
  key: Cehsite_Ms_Available_Site_Terms_Enum;
};

/** select columns of table "cehsite.ms_site_content" */
export enum Cehsite_Ms_Site_Content_Select_Column {
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "cehsite.ms_site_content" */
export type Cehsite_Ms_Site_Content_Set_Input = {
  key?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Enum>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "cehsite_ms_site_content" */
export type Cehsite_Ms_Site_Content_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cehsite_Ms_Site_Content_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cehsite_Ms_Site_Content_Stream_Cursor_Value_Input = {
  key?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Enum>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "cehsite.ms_site_content" */
export enum Cehsite_Ms_Site_Content_Update_Column {
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

export type Cehsite_Ms_Site_Content_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cehsite_Ms_Site_Content_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cehsite_Ms_Site_Content_Bool_Exp;
};

/** Files for uploads, downloads and usage in system */
export type Content_File = {
  __typename?: 'content_file';
  base_url?: Maybe<Scalars['String']>;
  cdn_url?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  ext?: Maybe<Scalars['String']>;
  /** An object relationship */
  file_metadata?: Maybe<Content_File_Metadata>;
  /** An object relationship */
  file_status: Content_File_Status;
  id: Scalars['uuid'];
  mime: Scalars['String'];
  original_name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['String']>;
  status: Content_File_Status_Enum;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "content.file" */
export type Content_File_Aggregate = {
  __typename?: 'content_file_aggregate';
  aggregate?: Maybe<Content_File_Aggregate_Fields>;
  nodes: Array<Content_File>;
};

/** aggregate fields of "content.file" */
export type Content_File_Aggregate_Fields = {
  __typename?: 'content_file_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Content_File_Max_Fields>;
  min?: Maybe<Content_File_Min_Fields>;
};


/** aggregate fields of "content.file" */
export type Content_File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Content_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "content.file". All fields are combined with a logical 'AND'. */
export type Content_File_Bool_Exp = {
  _and?: InputMaybe<Array<Content_File_Bool_Exp>>;
  _not?: InputMaybe<Content_File_Bool_Exp>;
  _or?: InputMaybe<Array<Content_File_Bool_Exp>>;
  base_url?: InputMaybe<String_Comparison_Exp>;
  cdn_url?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ext?: InputMaybe<String_Comparison_Exp>;
  file_metadata?: InputMaybe<Content_File_Metadata_Bool_Exp>;
  file_status?: InputMaybe<Content_File_Status_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mime?: InputMaybe<String_Comparison_Exp>;
  original_name?: InputMaybe<String_Comparison_Exp>;
  owner_id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Content_File_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "content.file" */
export enum Content_File_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilePkey = 'file_pkey'
}

/** input type for inserting data into table "content.file" */
export type Content_File_Insert_Input = {
  base_url?: InputMaybe<Scalars['String']>;
  cdn_url?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  ext?: InputMaybe<Scalars['String']>;
  file_metadata?: InputMaybe<Content_File_Metadata_Obj_Rel_Insert_Input>;
  file_status?: InputMaybe<Content_File_Status_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  mime?: InputMaybe<Scalars['String']>;
  original_name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Content_File_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Content_File_Max_Fields = {
  __typename?: 'content_file_max_fields';
  base_url?: Maybe<Scalars['String']>;
  cdn_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  ext?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  mime?: Maybe<Scalars['String']>;
  original_name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Metadata for files */
export type Content_File_Metadata = {
  __typename?: 'content_file_metadata';
  file_id: Scalars['uuid'];
};

/** aggregated selection of "content.file_metadata" */
export type Content_File_Metadata_Aggregate = {
  __typename?: 'content_file_metadata_aggregate';
  aggregate?: Maybe<Content_File_Metadata_Aggregate_Fields>;
  nodes: Array<Content_File_Metadata>;
};

/** aggregate fields of "content.file_metadata" */
export type Content_File_Metadata_Aggregate_Fields = {
  __typename?: 'content_file_metadata_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Content_File_Metadata_Max_Fields>;
  min?: Maybe<Content_File_Metadata_Min_Fields>;
};


/** aggregate fields of "content.file_metadata" */
export type Content_File_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Content_File_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "content.file_metadata". All fields are combined with a logical 'AND'. */
export type Content_File_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Content_File_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Content_File_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Content_File_Metadata_Bool_Exp>>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "content.file_metadata" */
export enum Content_File_Metadata_Constraint {
  /** unique or primary key constraint on columns "file_id" */
  FileMetadataPkey = 'file_metadata_pkey'
}

/** input type for inserting data into table "content.file_metadata" */
export type Content_File_Metadata_Insert_Input = {
  file_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Content_File_Metadata_Max_Fields = {
  __typename?: 'content_file_metadata_max_fields';
  file_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Content_File_Metadata_Min_Fields = {
  __typename?: 'content_file_metadata_min_fields';
  file_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "content.file_metadata" */
export type Content_File_Metadata_Mutation_Response = {
  __typename?: 'content_file_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Content_File_Metadata>;
};

/** input type for inserting object relation for remote table "content.file_metadata" */
export type Content_File_Metadata_Obj_Rel_Insert_Input = {
  data: Content_File_Metadata_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Content_File_Metadata_On_Conflict>;
};

/** on_conflict condition type for table "content.file_metadata" */
export type Content_File_Metadata_On_Conflict = {
  constraint: Content_File_Metadata_Constraint;
  update_columns?: Array<Content_File_Metadata_Update_Column>;
  where?: InputMaybe<Content_File_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "content.file_metadata". */
export type Content_File_Metadata_Order_By = {
  file_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: content.file_metadata */
export type Content_File_Metadata_Pk_Columns_Input = {
  file_id: Scalars['uuid'];
};

/** select columns of table "content.file_metadata" */
export enum Content_File_Metadata_Select_Column {
  /** column name */
  FileId = 'file_id'
}

/** input type for updating data in table "content.file_metadata" */
export type Content_File_Metadata_Set_Input = {
  file_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "content_file_metadata" */
export type Content_File_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Content_File_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Content_File_Metadata_Stream_Cursor_Value_Input = {
  file_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "content.file_metadata" */
export enum Content_File_Metadata_Update_Column {
  /** column name */
  FileId = 'file_id'
}

export type Content_File_Metadata_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Content_File_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Content_File_Metadata_Bool_Exp;
};

/** aggregate min on columns */
export type Content_File_Min_Fields = {
  __typename?: 'content_file_min_fields';
  base_url?: Maybe<Scalars['String']>;
  cdn_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  ext?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  mime?: Maybe<Scalars['String']>;
  original_name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "content.file" */
export type Content_File_Mutation_Response = {
  __typename?: 'content_file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Content_File>;
};

/** input type for inserting object relation for remote table "content.file" */
export type Content_File_Obj_Rel_Insert_Input = {
  data: Content_File_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Content_File_On_Conflict>;
};

/** on_conflict condition type for table "content.file" */
export type Content_File_On_Conflict = {
  constraint: Content_File_Constraint;
  update_columns?: Array<Content_File_Update_Column>;
  where?: InputMaybe<Content_File_Bool_Exp>;
};

/** Ordering options when selecting data from "content.file". */
export type Content_File_Order_By = {
  base_url?: InputMaybe<Order_By>;
  cdn_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ext?: InputMaybe<Order_By>;
  file_metadata?: InputMaybe<Content_File_Metadata_Order_By>;
  file_status?: InputMaybe<Content_File_Status_Order_By>;
  id?: InputMaybe<Order_By>;
  mime?: InputMaybe<Order_By>;
  original_name?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: content.file */
export type Content_File_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "content.file" */
export enum Content_File_Select_Column {
  /** column name */
  BaseUrl = 'base_url',
  /** column name */
  CdnUrl = 'cdn_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Ext = 'ext',
  /** column name */
  Id = 'id',
  /** column name */
  Mime = 'mime',
  /** column name */
  OriginalName = 'original_name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "content.file" */
export type Content_File_Set_Input = {
  base_url?: InputMaybe<Scalars['String']>;
  cdn_url?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  ext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  mime?: InputMaybe<Scalars['String']>;
  original_name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Content_File_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Status for files in content */
export type Content_File_Status = {
  __typename?: 'content_file_status';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "content.file_status" */
export type Content_File_Status_Aggregate = {
  __typename?: 'content_file_status_aggregate';
  aggregate?: Maybe<Content_File_Status_Aggregate_Fields>;
  nodes: Array<Content_File_Status>;
};

/** aggregate fields of "content.file_status" */
export type Content_File_Status_Aggregate_Fields = {
  __typename?: 'content_file_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Content_File_Status_Max_Fields>;
  min?: Maybe<Content_File_Status_Min_Fields>;
};


/** aggregate fields of "content.file_status" */
export type Content_File_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Content_File_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "content.file_status". All fields are combined with a logical 'AND'. */
export type Content_File_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Content_File_Status_Bool_Exp>>;
  _not?: InputMaybe<Content_File_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Content_File_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "content.file_status" */
export enum Content_File_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  FileStatusPkey = 'file_status_pkey'
}

export enum Content_File_Status_Enum {
  /** Upload url generated, awaiting file */
  PendingUpload = 'pending_upload',
  /** File is publicly available */
  Ready = 'ready'
}

/** Boolean expression to compare columns of type "content_file_status_enum". All fields are combined with logical 'AND'. */
export type Content_File_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Content_File_Status_Enum>;
  _in?: InputMaybe<Array<Content_File_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Content_File_Status_Enum>;
  _nin?: InputMaybe<Array<Content_File_Status_Enum>>;
};

/** input type for inserting data into table "content.file_status" */
export type Content_File_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Content_File_Status_Max_Fields = {
  __typename?: 'content_file_status_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Content_File_Status_Min_Fields = {
  __typename?: 'content_file_status_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "content.file_status" */
export type Content_File_Status_Mutation_Response = {
  __typename?: 'content_file_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Content_File_Status>;
};

/** input type for inserting object relation for remote table "content.file_status" */
export type Content_File_Status_Obj_Rel_Insert_Input = {
  data: Content_File_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Content_File_Status_On_Conflict>;
};

/** on_conflict condition type for table "content.file_status" */
export type Content_File_Status_On_Conflict = {
  constraint: Content_File_Status_Constraint;
  update_columns?: Array<Content_File_Status_Update_Column>;
  where?: InputMaybe<Content_File_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "content.file_status". */
export type Content_File_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: content.file_status */
export type Content_File_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "content.file_status" */
export enum Content_File_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "content.file_status" */
export type Content_File_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "content_file_status" */
export type Content_File_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Content_File_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Content_File_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "content.file_status" */
export enum Content_File_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Content_File_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Content_File_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Content_File_Status_Bool_Exp;
};

/** Streaming cursor of the table "content_file" */
export type Content_File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Content_File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Content_File_Stream_Cursor_Value_Input = {
  base_url?: InputMaybe<Scalars['String']>;
  cdn_url?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  ext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  mime?: InputMaybe<Scalars['String']>;
  original_name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Content_File_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "content.file" */
export enum Content_File_Update_Column {
  /** column name */
  BaseUrl = 'base_url',
  /** column name */
  CdnUrl = 'cdn_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Ext = 'ext',
  /** column name */
  Id = 'id',
  /** column name */
  Mime = 'mime',
  /** column name */
  OriginalName = 'original_name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Content_File_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Content_File_Set_Input>;
  /** filter the rows which have to be updated */
  where: Content_File_Bool_Exp;
};

/** Media link table - data contains necessary info to render */
export type Content_Media_Link = {
  __typename?: 'content_media_link';
  id: Scalars['uuid'];
  link_data: Scalars['String'];
  link_type: Content_Media_Link_Type_Enum;
};

/** aggregated selection of "content.media_link" */
export type Content_Media_Link_Aggregate = {
  __typename?: 'content_media_link_aggregate';
  aggregate?: Maybe<Content_Media_Link_Aggregate_Fields>;
  nodes: Array<Content_Media_Link>;
};

/** aggregate fields of "content.media_link" */
export type Content_Media_Link_Aggregate_Fields = {
  __typename?: 'content_media_link_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Content_Media_Link_Max_Fields>;
  min?: Maybe<Content_Media_Link_Min_Fields>;
};


/** aggregate fields of "content.media_link" */
export type Content_Media_Link_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Content_Media_Link_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "content.media_link". All fields are combined with a logical 'AND'. */
export type Content_Media_Link_Bool_Exp = {
  _and?: InputMaybe<Array<Content_Media_Link_Bool_Exp>>;
  _not?: InputMaybe<Content_Media_Link_Bool_Exp>;
  _or?: InputMaybe<Array<Content_Media_Link_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  link_data?: InputMaybe<String_Comparison_Exp>;
  link_type?: InputMaybe<Content_Media_Link_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "content.media_link" */
export enum Content_Media_Link_Constraint {
  /** unique or primary key constraint on columns "id" */
  MediaLinkPkey = 'media_link_pkey'
}

/** input type for inserting data into table "content.media_link" */
export type Content_Media_Link_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  link_data?: InputMaybe<Scalars['String']>;
  link_type?: InputMaybe<Content_Media_Link_Type_Enum>;
};

/** aggregate max on columns */
export type Content_Media_Link_Max_Fields = {
  __typename?: 'content_media_link_max_fields';
  id?: Maybe<Scalars['uuid']>;
  link_data?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Content_Media_Link_Min_Fields = {
  __typename?: 'content_media_link_min_fields';
  id?: Maybe<Scalars['uuid']>;
  link_data?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "content.media_link" */
export type Content_Media_Link_Mutation_Response = {
  __typename?: 'content_media_link_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Content_Media_Link>;
};

/** input type for inserting object relation for remote table "content.media_link" */
export type Content_Media_Link_Obj_Rel_Insert_Input = {
  data: Content_Media_Link_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Content_Media_Link_On_Conflict>;
};

/** on_conflict condition type for table "content.media_link" */
export type Content_Media_Link_On_Conflict = {
  constraint: Content_Media_Link_Constraint;
  update_columns?: Array<Content_Media_Link_Update_Column>;
  where?: InputMaybe<Content_Media_Link_Bool_Exp>;
};

/** Ordering options when selecting data from "content.media_link". */
export type Content_Media_Link_Order_By = {
  id?: InputMaybe<Order_By>;
  link_data?: InputMaybe<Order_By>;
  link_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: content.media_link */
export type Content_Media_Link_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "content.media_link" */
export enum Content_Media_Link_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LinkData = 'link_data',
  /** column name */
  LinkType = 'link_type'
}

/** input type for updating data in table "content.media_link" */
export type Content_Media_Link_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  link_data?: InputMaybe<Scalars['String']>;
  link_type?: InputMaybe<Content_Media_Link_Type_Enum>;
};

/** Streaming cursor of the table "content_media_link" */
export type Content_Media_Link_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Content_Media_Link_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Content_Media_Link_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  link_data?: InputMaybe<Scalars['String']>;
  link_type?: InputMaybe<Content_Media_Link_Type_Enum>;
};

/** Enum describing media link type (YT, Twitch, etc) */
export type Content_Media_Link_Type = {
  __typename?: 'content_media_link_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "content.media_link_type" */
export type Content_Media_Link_Type_Aggregate = {
  __typename?: 'content_media_link_type_aggregate';
  aggregate?: Maybe<Content_Media_Link_Type_Aggregate_Fields>;
  nodes: Array<Content_Media_Link_Type>;
};

/** aggregate fields of "content.media_link_type" */
export type Content_Media_Link_Type_Aggregate_Fields = {
  __typename?: 'content_media_link_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Content_Media_Link_Type_Max_Fields>;
  min?: Maybe<Content_Media_Link_Type_Min_Fields>;
};


/** aggregate fields of "content.media_link_type" */
export type Content_Media_Link_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Content_Media_Link_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "content.media_link_type". All fields are combined with a logical 'AND'. */
export type Content_Media_Link_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Content_Media_Link_Type_Bool_Exp>>;
  _not?: InputMaybe<Content_Media_Link_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Content_Media_Link_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "content.media_link_type" */
export enum Content_Media_Link_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  MediaLinkTypePkey = 'media_link_type_pkey'
}

export enum Content_Media_Link_Type_Enum {
  /** Twitch Clip */
  TwitchClip = 'twitch_clip',
  /** Twitch Channel */
  TwitchStream = 'twitch_stream',
  /** Twitch Video */
  TwitchVideo = 'twitch_video',
  /** YouTube Channel */
  YoutubeChannel = 'youtube_channel',
  /** Youtube Video */
  YoutubeVideo = 'youtube_video'
}

/** Boolean expression to compare columns of type "content_media_link_type_enum". All fields are combined with logical 'AND'. */
export type Content_Media_Link_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Content_Media_Link_Type_Enum>;
  _in?: InputMaybe<Array<Content_Media_Link_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Content_Media_Link_Type_Enum>;
  _nin?: InputMaybe<Array<Content_Media_Link_Type_Enum>>;
};

/** input type for inserting data into table "content.media_link_type" */
export type Content_Media_Link_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Content_Media_Link_Type_Max_Fields = {
  __typename?: 'content_media_link_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Content_Media_Link_Type_Min_Fields = {
  __typename?: 'content_media_link_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "content.media_link_type" */
export type Content_Media_Link_Type_Mutation_Response = {
  __typename?: 'content_media_link_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Content_Media_Link_Type>;
};

/** on_conflict condition type for table "content.media_link_type" */
export type Content_Media_Link_Type_On_Conflict = {
  constraint: Content_Media_Link_Type_Constraint;
  update_columns?: Array<Content_Media_Link_Type_Update_Column>;
  where?: InputMaybe<Content_Media_Link_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "content.media_link_type". */
export type Content_Media_Link_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: content.media_link_type */
export type Content_Media_Link_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "content.media_link_type" */
export enum Content_Media_Link_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "content.media_link_type" */
export type Content_Media_Link_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "content_media_link_type" */
export type Content_Media_Link_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Content_Media_Link_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Content_Media_Link_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "content.media_link_type" */
export enum Content_Media_Link_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Content_Media_Link_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Content_Media_Link_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Content_Media_Link_Type_Bool_Exp;
};

/** update columns of table "content.media_link" */
export enum Content_Media_Link_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LinkData = 'link_data',
  /** column name */
  LinkType = 'link_type'
}

export type Content_Media_Link_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Content_Media_Link_Set_Input>;
  /** filter the rows which have to be updated */
  where: Content_Media_Link_Bool_Exp;
};

/** Project enums */
export type Content_Project_Name = {
  __typename?: 'content_project_name';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "content.project_name" */
export type Content_Project_Name_Aggregate = {
  __typename?: 'content_project_name_aggregate';
  aggregate?: Maybe<Content_Project_Name_Aggregate_Fields>;
  nodes: Array<Content_Project_Name>;
};

/** aggregate fields of "content.project_name" */
export type Content_Project_Name_Aggregate_Fields = {
  __typename?: 'content_project_name_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Content_Project_Name_Max_Fields>;
  min?: Maybe<Content_Project_Name_Min_Fields>;
};


/** aggregate fields of "content.project_name" */
export type Content_Project_Name_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Content_Project_Name_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "content.project_name". All fields are combined with a logical 'AND'. */
export type Content_Project_Name_Bool_Exp = {
  _and?: InputMaybe<Array<Content_Project_Name_Bool_Exp>>;
  _not?: InputMaybe<Content_Project_Name_Bool_Exp>;
  _or?: InputMaybe<Array<Content_Project_Name_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "content.project_name" */
export enum Content_Project_Name_Constraint {
  /** unique or primary key constraint on columns "name" */
  ProjectNamePkey = 'project_name_pkey'
}

export enum Content_Project_Name_Enum {
  /** Spin  */
  Spin = 'spin'
}

/** Boolean expression to compare columns of type "content_project_name_enum". All fields are combined with logical 'AND'. */
export type Content_Project_Name_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Content_Project_Name_Enum>;
  _in?: InputMaybe<Array<Content_Project_Name_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Content_Project_Name_Enum>;
  _nin?: InputMaybe<Array<Content_Project_Name_Enum>>;
};

/** input type for inserting data into table "content.project_name" */
export type Content_Project_Name_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Content_Project_Name_Max_Fields = {
  __typename?: 'content_project_name_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Content_Project_Name_Min_Fields = {
  __typename?: 'content_project_name_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "content.project_name" */
export type Content_Project_Name_Mutation_Response = {
  __typename?: 'content_project_name_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Content_Project_Name>;
};

/** on_conflict condition type for table "content.project_name" */
export type Content_Project_Name_On_Conflict = {
  constraint: Content_Project_Name_Constraint;
  update_columns?: Array<Content_Project_Name_Update_Column>;
  where?: InputMaybe<Content_Project_Name_Bool_Exp>;
};

/** Ordering options when selecting data from "content.project_name". */
export type Content_Project_Name_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: content.project_name */
export type Content_Project_Name_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "content.project_name" */
export enum Content_Project_Name_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "content.project_name" */
export type Content_Project_Name_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "content_project_name" */
export type Content_Project_Name_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Content_Project_Name_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Content_Project_Name_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "content.project_name" */
export enum Content_Project_Name_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Content_Project_Name_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Content_Project_Name_Set_Input>;
  /** filter the rows which have to be updated */
  where: Content_Project_Name_Bool_Exp;
};

/** Content Status */
export type Content_Status = {
  __typename?: 'content_status';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "content.status" */
export type Content_Status_Aggregate = {
  __typename?: 'content_status_aggregate';
  aggregate?: Maybe<Content_Status_Aggregate_Fields>;
  nodes: Array<Content_Status>;
};

/** aggregate fields of "content.status" */
export type Content_Status_Aggregate_Fields = {
  __typename?: 'content_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Content_Status_Max_Fields>;
  min?: Maybe<Content_Status_Min_Fields>;
};


/** aggregate fields of "content.status" */
export type Content_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Content_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "content.status". All fields are combined with a logical 'AND'. */
export type Content_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Content_Status_Bool_Exp>>;
  _not?: InputMaybe<Content_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Content_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "content.status" */
export enum Content_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  StatusPkey = 'status_pkey'
}

export enum Content_Status_Enum {
  /** Draft content */
  Draft = 'draft',
  /** Published content */
  Published = 'published',
  /** In review */
  Review = 'review'
}

/** Boolean expression to compare columns of type "content_status_enum". All fields are combined with logical 'AND'. */
export type Content_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Content_Status_Enum>;
  _in?: InputMaybe<Array<Content_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Content_Status_Enum>;
  _nin?: InputMaybe<Array<Content_Status_Enum>>;
};

/** input type for inserting data into table "content.status" */
export type Content_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Content_Status_Max_Fields = {
  __typename?: 'content_status_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Content_Status_Min_Fields = {
  __typename?: 'content_status_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "content.status" */
export type Content_Status_Mutation_Response = {
  __typename?: 'content_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Content_Status>;
};

/** input type for inserting object relation for remote table "content.status" */
export type Content_Status_Obj_Rel_Insert_Input = {
  data: Content_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Content_Status_On_Conflict>;
};

/** on_conflict condition type for table "content.status" */
export type Content_Status_On_Conflict = {
  constraint: Content_Status_Constraint;
  update_columns?: Array<Content_Status_Update_Column>;
  where?: InputMaybe<Content_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "content.status". */
export type Content_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: content.status */
export type Content_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "content.status" */
export enum Content_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "content.status" */
export type Content_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "content_status" */
export type Content_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Content_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Content_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "content.status" */
export enum Content_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Content_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Content_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Content_Status_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** Addresses in system */
export type Espin_Address = {
  __typename?: 'espin_address';
  city: Scalars['String'];
  /** An array relationship */
  colleges: Array<Espin_College>;
  /** An aggregate relationship */
  colleges_aggregate: Espin_College_Aggregate;
  country?: Maybe<Scalars['String']>;
  /** An array relationship */
  high_schools: Array<Espin_High_School>;
  /** An aggregate relationship */
  high_schools_aggregate: Espin_High_School_Aggregate;
  id: Scalars['uuid'];
  location?: Maybe<Scalars['geography']>;
  needs_geo_update: Scalars['Boolean'];
  /** An array relationship */
  parent_profiles: Array<Espin_Parent_Profile>;
  /** An aggregate relationship */
  parent_profiles_aggregate: Espin_Parent_Profile_Aggregate;
  /** An array relationship */
  player_profiles: Array<Espin_Player_Profile>;
  /** An aggregate relationship */
  player_profiles_aggregate: Espin_Player_Profile_Aggregate;
  state: Scalars['String'];
  street_one?: Maybe<Scalars['String']>;
  street_three?: Maybe<Scalars['String']>;
  street_two?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};


/** Addresses in system */
export type Espin_AddressCollegesArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Order_By>>;
  where?: InputMaybe<Espin_College_Bool_Exp>;
};


/** Addresses in system */
export type Espin_AddressColleges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Order_By>>;
  where?: InputMaybe<Espin_College_Bool_Exp>;
};


/** Addresses in system */
export type Espin_AddressHigh_SchoolsArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Order_By>>;
  where?: InputMaybe<Espin_High_School_Bool_Exp>;
};


/** Addresses in system */
export type Espin_AddressHigh_Schools_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Order_By>>;
  where?: InputMaybe<Espin_High_School_Bool_Exp>;
};


/** Addresses in system */
export type Espin_AddressParent_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Parent_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Parent_Profile_Order_By>>;
  where?: InputMaybe<Espin_Parent_Profile_Bool_Exp>;
};


/** Addresses in system */
export type Espin_AddressParent_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Parent_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Parent_Profile_Order_By>>;
  where?: InputMaybe<Espin_Parent_Profile_Bool_Exp>;
};


/** Addresses in system */
export type Espin_AddressPlayer_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};


/** Addresses in system */
export type Espin_AddressPlayer_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};

/** aggregated selection of "espin.address" */
export type Espin_Address_Aggregate = {
  __typename?: 'espin_address_aggregate';
  aggregate?: Maybe<Espin_Address_Aggregate_Fields>;
  nodes: Array<Espin_Address>;
};

/** aggregate fields of "espin.address" */
export type Espin_Address_Aggregate_Fields = {
  __typename?: 'espin_address_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Address_Max_Fields>;
  min?: Maybe<Espin_Address_Min_Fields>;
};


/** aggregate fields of "espin.address" */
export type Espin_Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.address". All fields are combined with a logical 'AND'. */
export type Espin_Address_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Address_Bool_Exp>>;
  _not?: InputMaybe<Espin_Address_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Address_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  colleges?: InputMaybe<Espin_College_Bool_Exp>;
  colleges_aggregate?: InputMaybe<Espin_College_Aggregate_Bool_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  high_schools?: InputMaybe<Espin_High_School_Bool_Exp>;
  high_schools_aggregate?: InputMaybe<Espin_High_School_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  needs_geo_update?: InputMaybe<Boolean_Comparison_Exp>;
  parent_profiles?: InputMaybe<Espin_Parent_Profile_Bool_Exp>;
  parent_profiles_aggregate?: InputMaybe<Espin_Parent_Profile_Aggregate_Bool_Exp>;
  player_profiles?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  player_profiles_aggregate?: InputMaybe<Espin_Player_Profile_Aggregate_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street_one?: InputMaybe<String_Comparison_Exp>;
  street_three?: InputMaybe<String_Comparison_Exp>;
  street_two?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.address" */
export enum Espin_Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressPkey = 'address_pkey'
}

/** input type for inserting data into table "espin.address" */
export type Espin_Address_Insert_Input = {
  city?: InputMaybe<Scalars['String']>;
  colleges?: InputMaybe<Espin_College_Arr_Rel_Insert_Input>;
  country?: InputMaybe<Scalars['String']>;
  high_schools?: InputMaybe<Espin_High_School_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['geography']>;
  needs_geo_update?: InputMaybe<Scalars['Boolean']>;
  parent_profiles?: InputMaybe<Espin_Parent_Profile_Arr_Rel_Insert_Input>;
  player_profiles?: InputMaybe<Espin_Player_Profile_Arr_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  street_one?: InputMaybe<Scalars['String']>;
  street_three?: InputMaybe<Scalars['String']>;
  street_two?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Address_Max_Fields = {
  __typename?: 'espin_address_max_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  street_one?: Maybe<Scalars['String']>;
  street_three?: Maybe<Scalars['String']>;
  street_two?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Address_Min_Fields = {
  __typename?: 'espin_address_min_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  street_one?: Maybe<Scalars['String']>;
  street_three?: Maybe<Scalars['String']>;
  street_two?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.address" */
export type Espin_Address_Mutation_Response = {
  __typename?: 'espin_address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Address>;
};

/** input type for inserting object relation for remote table "espin.address" */
export type Espin_Address_Obj_Rel_Insert_Input = {
  data: Espin_Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Address_On_Conflict>;
};

/** on_conflict condition type for table "espin.address" */
export type Espin_Address_On_Conflict = {
  constraint: Espin_Address_Constraint;
  update_columns?: Array<Espin_Address_Update_Column>;
  where?: InputMaybe<Espin_Address_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.address". */
export type Espin_Address_Order_By = {
  city?: InputMaybe<Order_By>;
  colleges_aggregate?: InputMaybe<Espin_College_Aggregate_Order_By>;
  country?: InputMaybe<Order_By>;
  high_schools_aggregate?: InputMaybe<Espin_High_School_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  needs_geo_update?: InputMaybe<Order_By>;
  parent_profiles_aggregate?: InputMaybe<Espin_Parent_Profile_Aggregate_Order_By>;
  player_profiles_aggregate?: InputMaybe<Espin_Player_Profile_Aggregate_Order_By>;
  state?: InputMaybe<Order_By>;
  street_one?: InputMaybe<Order_By>;
  street_three?: InputMaybe<Order_By>;
  street_two?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.address */
export type Espin_Address_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.address" */
export enum Espin_Address_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  NeedsGeoUpdate = 'needs_geo_update',
  /** column name */
  State = 'state',
  /** column name */
  StreetOne = 'street_one',
  /** column name */
  StreetThree = 'street_three',
  /** column name */
  StreetTwo = 'street_two',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "espin.address" */
export type Espin_Address_Set_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['geography']>;
  needs_geo_update?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  street_one?: InputMaybe<Scalars['String']>;
  street_three?: InputMaybe<Scalars['String']>;
  street_two?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_address" */
export type Espin_Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Address_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['geography']>;
  needs_geo_update?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  street_one?: InputMaybe<Scalars['String']>;
  street_three?: InputMaybe<Scalars['String']>;
  street_two?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.address" */
export enum Espin_Address_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  NeedsGeoUpdate = 'needs_geo_update',
  /** column name */
  State = 'state',
  /** column name */
  StreetOne = 'street_one',
  /** column name */
  StreetThree = 'street_three',
  /** column name */
  StreetTwo = 'street_two',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Zip = 'zip'
}

export type Espin_Address_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Address_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Address_Bool_Exp;
};

/** Boolean feature flags in system */
export type Espin_Boolean_Feature_Flag = {
  __typename?: 'espin_boolean_feature_flag';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value: Scalars['Boolean'];
};

/** aggregated selection of "espin.boolean_feature_flag" */
export type Espin_Boolean_Feature_Flag_Aggregate = {
  __typename?: 'espin_boolean_feature_flag_aggregate';
  aggregate?: Maybe<Espin_Boolean_Feature_Flag_Aggregate_Fields>;
  nodes: Array<Espin_Boolean_Feature_Flag>;
};

/** aggregate fields of "espin.boolean_feature_flag" */
export type Espin_Boolean_Feature_Flag_Aggregate_Fields = {
  __typename?: 'espin_boolean_feature_flag_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Boolean_Feature_Flag_Max_Fields>;
  min?: Maybe<Espin_Boolean_Feature_Flag_Min_Fields>;
};


/** aggregate fields of "espin.boolean_feature_flag" */
export type Espin_Boolean_Feature_Flag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Boolean_Feature_Flag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.boolean_feature_flag". All fields are combined with a logical 'AND'. */
export type Espin_Boolean_Feature_Flag_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Boolean_Feature_Flag_Bool_Exp>>;
  _not?: InputMaybe<Espin_Boolean_Feature_Flag_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Boolean_Feature_Flag_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.boolean_feature_flag" */
export enum Espin_Boolean_Feature_Flag_Constraint {
  /** unique or primary key constraint on columns "name" */
  BooleanFeatureFlagPkey = 'boolean_feature_flag_pkey'
}

/** input type for inserting data into table "espin.boolean_feature_flag" */
export type Espin_Boolean_Feature_Flag_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Espin_Boolean_Feature_Flag_Max_Fields = {
  __typename?: 'espin_boolean_feature_flag_max_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Boolean_Feature_Flag_Min_Fields = {
  __typename?: 'espin_boolean_feature_flag_min_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.boolean_feature_flag" */
export type Espin_Boolean_Feature_Flag_Mutation_Response = {
  __typename?: 'espin_boolean_feature_flag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Boolean_Feature_Flag>;
};

/** on_conflict condition type for table "espin.boolean_feature_flag" */
export type Espin_Boolean_Feature_Flag_On_Conflict = {
  constraint: Espin_Boolean_Feature_Flag_Constraint;
  update_columns?: Array<Espin_Boolean_Feature_Flag_Update_Column>;
  where?: InputMaybe<Espin_Boolean_Feature_Flag_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.boolean_feature_flag". */
export type Espin_Boolean_Feature_Flag_Order_By = {
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.boolean_feature_flag */
export type Espin_Boolean_Feature_Flag_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.boolean_feature_flag" */
export enum Espin_Boolean_Feature_Flag_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "espin.boolean_feature_flag" */
export type Espin_Boolean_Feature_Flag_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "espin_boolean_feature_flag" */
export type Espin_Boolean_Feature_Flag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Boolean_Feature_Flag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Boolean_Feature_Flag_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "espin.boolean_feature_flag" */
export enum Espin_Boolean_Feature_Flag_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value'
}

export type Espin_Boolean_Feature_Flag_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Boolean_Feature_Flag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Boolean_Feature_Flag_Bool_Exp;
};

/** Profile info for the coach */
export type Espin_Coach_Profile = {
  __typename?: 'espin_coach_profile';
  id: Scalars['uuid'];
};

/** aggregated selection of "espin.coach_profile" */
export type Espin_Coach_Profile_Aggregate = {
  __typename?: 'espin_coach_profile_aggregate';
  aggregate?: Maybe<Espin_Coach_Profile_Aggregate_Fields>;
  nodes: Array<Espin_Coach_Profile>;
};

/** aggregate fields of "espin.coach_profile" */
export type Espin_Coach_Profile_Aggregate_Fields = {
  __typename?: 'espin_coach_profile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Coach_Profile_Max_Fields>;
  min?: Maybe<Espin_Coach_Profile_Min_Fields>;
};


/** aggregate fields of "espin.coach_profile" */
export type Espin_Coach_Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Coach_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.coach_profile". All fields are combined with a logical 'AND'. */
export type Espin_Coach_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Coach_Profile_Bool_Exp>>;
  _not?: InputMaybe<Espin_Coach_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Coach_Profile_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.coach_profile" */
export enum Espin_Coach_Profile_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoachProfilePkey = 'coach_profile_pkey'
}

/** input type for inserting data into table "espin.coach_profile" */
export type Espin_Coach_Profile_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Espin_Coach_Profile_Max_Fields = {
  __typename?: 'espin_coach_profile_max_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Espin_Coach_Profile_Min_Fields = {
  __typename?: 'espin_coach_profile_min_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "espin.coach_profile" */
export type Espin_Coach_Profile_Mutation_Response = {
  __typename?: 'espin_coach_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Coach_Profile>;
};

/** on_conflict condition type for table "espin.coach_profile" */
export type Espin_Coach_Profile_On_Conflict = {
  constraint: Espin_Coach_Profile_Constraint;
  update_columns?: Array<Espin_Coach_Profile_Update_Column>;
  where?: InputMaybe<Espin_Coach_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.coach_profile". */
export type Espin_Coach_Profile_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.coach_profile */
export type Espin_Coach_Profile_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.coach_profile" */
export enum Espin_Coach_Profile_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "espin.coach_profile" */
export type Espin_Coach_Profile_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "espin_coach_profile" */
export type Espin_Coach_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Coach_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Coach_Profile_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "espin.coach_profile" */
export enum Espin_Coach_Profile_Update_Column {
  /** column name */
  Id = 'id'
}

export type Espin_Coach_Profile_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Coach_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Coach_Profile_Bool_Exp;
};

/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_College = {
  __typename?: 'espin_college';
  academic_notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  address?: Maybe<Espin_Address>;
  address_id?: Maybe<Scalars['uuid']>;
  att_college_fair: Scalars['Boolean'];
  bio?: Maybe<Scalars['String']>;
  /** An array relationship */
  college_games: Array<Espin_College_Game>;
  /** An aggregate relationship */
  college_games_aggregate: Espin_College_Game_Aggregate;
  /** An array relationship */
  college_images: Array<Espin_College_Image>;
  /** An aggregate relationship */
  college_images_aggregate: Espin_College_Image_Aggregate;
  /** An object relationship */
  college_owner?: Maybe<Espin_College_Profile>;
  /** An object relationship */
  college_preferences?: Maybe<Espin_College_Preferences>;
  /** An array relationship */
  college_profiles: Array<Espin_College_Profile>;
  /** An aggregate relationship */
  college_profiles_aggregate: Espin_College_Profile_Aggregate;
  /** An array relationship */
  college_staff_members: Array<Espin_College_Staff_Member>;
  /** An aggregate relationship */
  college_staff_members_aggregate: Espin_College_Staff_Member_Aggregate;
  college_subscription_id?: Maybe<Scalars['uuid']>;
  contact_email?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  follows: Array<Espin_Follow>;
  /** An aggregate relationship */
  follows_aggregate: Espin_Follow_Aggregate;
  /** An object relationship */
  header_media_link?: Maybe<Content_Media_Link>;
  header_media_link_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  in_state_tuition?: Maybe<Scalars['String']>;
  /** An object relationship */
  logo?: Maybe<Content_File>;
  logo_id?: Maybe<Scalars['uuid']>;
  manual_subtier?: Maybe<Scalars['Int']>;
  /** An array relationship */
  messages: Array<Espin_Message>;
  /** An aggregate relationship */
  messages_aggregate: Espin_Message_Aggregate;
  migration_id?: Maybe<Scalars['String']>;
  min_act?: Maybe<Scalars['String']>;
  min_gpa?: Maybe<Scalars['String']>;
  min_sat?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  out_of_state_tuition?: Maybe<Scalars['String']>;
  owner_profile_id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  /** An array relationship */
  profile_views: Array<Espin_Profile_View>;
  /** An aggregate relationship */
  profile_views_aggregate: Espin_Profile_View_Aggregate;
  program_name?: Maybe<Scalars['String']>;
  scholarships: Scalars['Boolean'];
  slug?: Maybe<Scalars['String']>;
  /** An object relationship */
  socials?: Maybe<Espin_Social>;
  socials_id?: Maybe<Scalars['uuid']>;
  status: Espin_College_Verification_Status_Type_Enum;
  /** An array relationship */
  stickied_colleges: Array<Espin_Stickied_College>;
  /** An aggregate relationship */
  stickied_colleges_aggregate: Espin_Stickied_College_Aggregate;
  subscribed: Scalars['Boolean'];
  /** An object relationship */
  subscription?: Maybe<Espin_College_Subscription>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** True = Varsity, False = Club */
  varsity: Scalars['Boolean'];
  /** Admin ONLY field to allow verified */
  verified: Scalars['Boolean'];
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeCollege_GamesArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Game_Order_By>>;
  where?: InputMaybe<Espin_College_Game_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeCollege_Games_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Game_Order_By>>;
  where?: InputMaybe<Espin_College_Game_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeCollege_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Image_Order_By>>;
  where?: InputMaybe<Espin_College_Image_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeCollege_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Image_Order_By>>;
  where?: InputMaybe<Espin_College_Image_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeCollege_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Profile_Order_By>>;
  where?: InputMaybe<Espin_College_Profile_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeCollege_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Profile_Order_By>>;
  where?: InputMaybe<Espin_College_Profile_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeCollege_Staff_MembersArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Staff_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Staff_Member_Order_By>>;
  where?: InputMaybe<Espin_College_Staff_Member_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeCollege_Staff_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Staff_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Staff_Member_Order_By>>;
  where?: InputMaybe<Espin_College_Staff_Member_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeFollowsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Order_By>>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeFollows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Order_By>>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeMessagesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Order_By>>;
  where?: InputMaybe<Espin_Message_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Order_By>>;
  where?: InputMaybe<Espin_Message_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeProfile_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeProfile_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeStickied_CollegesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Stickied_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Stickied_College_Order_By>>;
  where?: InputMaybe<Espin_Stickied_College_Bool_Exp>;
};


/** NOTE - subbed column is to allow manual subscriptions */
export type Espin_CollegeStickied_Colleges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Stickied_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Stickied_College_Order_By>>;
  where?: InputMaybe<Espin_Stickied_College_Bool_Exp>;
};

/** aggregated selection of "espin.college" */
export type Espin_College_Aggregate = {
  __typename?: 'espin_college_aggregate';
  aggregate?: Maybe<Espin_College_Aggregate_Fields>;
  nodes: Array<Espin_College>;
};

export type Espin_College_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Espin_College_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Espin_College_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Espin_College_Aggregate_Bool_Exp_Count>;
};

export type Espin_College_Aggregate_Bool_Exp_Bool_And = {
  arguments: Espin_College_Select_Column_Espin_College_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_College_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_College_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Espin_College_Select_Column_Espin_College_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_College_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_College_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_College_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_College_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.college" */
export type Espin_College_Aggregate_Fields = {
  __typename?: 'espin_college_aggregate_fields';
  avg?: Maybe<Espin_College_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_College_Max_Fields>;
  min?: Maybe<Espin_College_Min_Fields>;
  stddev?: Maybe<Espin_College_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_College_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_College_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_College_Sum_Fields>;
  var_pop?: Maybe<Espin_College_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_College_Var_Samp_Fields>;
  variance?: Maybe<Espin_College_Variance_Fields>;
};


/** aggregate fields of "espin.college" */
export type Espin_College_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_College_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.college" */
export type Espin_College_Aggregate_Order_By = {
  avg?: InputMaybe<Espin_College_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_College_Max_Order_By>;
  min?: InputMaybe<Espin_College_Min_Order_By>;
  stddev?: InputMaybe<Espin_College_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Espin_College_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Espin_College_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Espin_College_Sum_Order_By>;
  var_pop?: InputMaybe<Espin_College_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Espin_College_Var_Samp_Order_By>;
  variance?: InputMaybe<Espin_College_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "espin.college" */
export type Espin_College_Arr_Rel_Insert_Input = {
  data: Array<Espin_College_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_College_On_Conflict>;
};

/** columns and relationships of "espin.college_automatic_message_response_type" */
export type Espin_College_Automatic_Message_Response_Type = {
  __typename?: 'espin_college_automatic_message_response_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.college_automatic_message_response_type" */
export type Espin_College_Automatic_Message_Response_Type_Aggregate = {
  __typename?: 'espin_college_automatic_message_response_type_aggregate';
  aggregate?: Maybe<Espin_College_Automatic_Message_Response_Type_Aggregate_Fields>;
  nodes: Array<Espin_College_Automatic_Message_Response_Type>;
};

/** aggregate fields of "espin.college_automatic_message_response_type" */
export type Espin_College_Automatic_Message_Response_Type_Aggregate_Fields = {
  __typename?: 'espin_college_automatic_message_response_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_College_Automatic_Message_Response_Type_Max_Fields>;
  min?: Maybe<Espin_College_Automatic_Message_Response_Type_Min_Fields>;
};


/** aggregate fields of "espin.college_automatic_message_response_type" */
export type Espin_College_Automatic_Message_Response_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_College_Automatic_Message_Response_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.college_automatic_message_response_type". All fields are combined with a logical 'AND'. */
export type Espin_College_Automatic_Message_Response_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_College_Automatic_Message_Response_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_College_Automatic_Message_Response_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.college_automatic_message_response_type" */
export enum Espin_College_Automatic_Message_Response_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  CollegeAutomaticMessageResponseTypePkey = 'college_automatic_message_response_type_pkey'
}

export enum Espin_College_Automatic_Message_Response_Type_Enum {
  /** Subscriber-only custom text for message response */
  CustomResponse = 'custom_response',
  /** Default option */
  DefaultResponse = 'default_response',
  /** Disables automatic response message */
  NoResponse = 'no_response'
}

/** Boolean expression to compare columns of type "espin_college_automatic_message_response_type_enum". All fields are combined with logical 'AND'. */
export type Espin_College_Automatic_Message_Response_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Enum>;
  _in?: InputMaybe<Array<Espin_College_Automatic_Message_Response_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_College_Automatic_Message_Response_Type_Enum>>;
};

/** input type for inserting data into table "espin.college_automatic_message_response_type" */
export type Espin_College_Automatic_Message_Response_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_College_Automatic_Message_Response_Type_Max_Fields = {
  __typename?: 'espin_college_automatic_message_response_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_College_Automatic_Message_Response_Type_Min_Fields = {
  __typename?: 'espin_college_automatic_message_response_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.college_automatic_message_response_type" */
export type Espin_College_Automatic_Message_Response_Type_Mutation_Response = {
  __typename?: 'espin_college_automatic_message_response_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_College_Automatic_Message_Response_Type>;
};

/** on_conflict condition type for table "espin.college_automatic_message_response_type" */
export type Espin_College_Automatic_Message_Response_Type_On_Conflict = {
  constraint: Espin_College_Automatic_Message_Response_Type_Constraint;
  update_columns?: Array<Espin_College_Automatic_Message_Response_Type_Update_Column>;
  where?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.college_automatic_message_response_type". */
export type Espin_College_Automatic_Message_Response_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.college_automatic_message_response_type */
export type Espin_College_Automatic_Message_Response_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.college_automatic_message_response_type" */
export enum Espin_College_Automatic_Message_Response_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.college_automatic_message_response_type" */
export type Espin_College_Automatic_Message_Response_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_college_automatic_message_response_type" */
export type Espin_College_Automatic_Message_Response_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_College_Automatic_Message_Response_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_College_Automatic_Message_Response_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.college_automatic_message_response_type" */
export enum Espin_College_Automatic_Message_Response_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_College_Automatic_Message_Response_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_College_Automatic_Message_Response_Type_Bool_Exp;
};

/** aggregate avg on columns */
export type Espin_College_Avg_Fields = {
  __typename?: 'espin_college_avg_fields';
  manual_subtier?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "espin.college" */
export type Espin_College_Avg_Order_By = {
  manual_subtier?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "espin.college". All fields are combined with a logical 'AND'. */
export type Espin_College_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_College_Bool_Exp>>;
  _not?: InputMaybe<Espin_College_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_College_Bool_Exp>>;
  academic_notes?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<Espin_Address_Bool_Exp>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  att_college_fair?: InputMaybe<Boolean_Comparison_Exp>;
  bio?: InputMaybe<String_Comparison_Exp>;
  college_games?: InputMaybe<Espin_College_Game_Bool_Exp>;
  college_games_aggregate?: InputMaybe<Espin_College_Game_Aggregate_Bool_Exp>;
  college_images?: InputMaybe<Espin_College_Image_Bool_Exp>;
  college_images_aggregate?: InputMaybe<Espin_College_Image_Aggregate_Bool_Exp>;
  college_owner?: InputMaybe<Espin_College_Profile_Bool_Exp>;
  college_preferences?: InputMaybe<Espin_College_Preferences_Bool_Exp>;
  college_profiles?: InputMaybe<Espin_College_Profile_Bool_Exp>;
  college_profiles_aggregate?: InputMaybe<Espin_College_Profile_Aggregate_Bool_Exp>;
  college_staff_members?: InputMaybe<Espin_College_Staff_Member_Bool_Exp>;
  college_staff_members_aggregate?: InputMaybe<Espin_College_Staff_Member_Aggregate_Bool_Exp>;
  college_subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  follows?: InputMaybe<Espin_Follow_Bool_Exp>;
  follows_aggregate?: InputMaybe<Espin_Follow_Aggregate_Bool_Exp>;
  header_media_link?: InputMaybe<Content_Media_Link_Bool_Exp>;
  header_media_link_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_state_tuition?: InputMaybe<String_Comparison_Exp>;
  logo?: InputMaybe<Content_File_Bool_Exp>;
  logo_id?: InputMaybe<Uuid_Comparison_Exp>;
  manual_subtier?: InputMaybe<Int_Comparison_Exp>;
  messages?: InputMaybe<Espin_Message_Bool_Exp>;
  messages_aggregate?: InputMaybe<Espin_Message_Aggregate_Bool_Exp>;
  migration_id?: InputMaybe<String_Comparison_Exp>;
  min_act?: InputMaybe<String_Comparison_Exp>;
  min_gpa?: InputMaybe<String_Comparison_Exp>;
  min_sat?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  out_of_state_tuition?: InputMaybe<String_Comparison_Exp>;
  owner_profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  profile_views?: InputMaybe<Espin_Profile_View_Bool_Exp>;
  profile_views_aggregate?: InputMaybe<Espin_Profile_View_Aggregate_Bool_Exp>;
  program_name?: InputMaybe<String_Comparison_Exp>;
  scholarships?: InputMaybe<Boolean_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  socials?: InputMaybe<Espin_Social_Bool_Exp>;
  socials_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Espin_College_Verification_Status_Type_Enum_Comparison_Exp>;
  stickied_colleges?: InputMaybe<Espin_Stickied_College_Bool_Exp>;
  stickied_colleges_aggregate?: InputMaybe<Espin_Stickied_College_Aggregate_Bool_Exp>;
  subscribed?: InputMaybe<Boolean_Comparison_Exp>;
  subscription?: InputMaybe<Espin_College_Subscription_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  varsity?: InputMaybe<Boolean_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.college" */
export enum Espin_College_Constraint {
  /** unique or primary key constraint on columns "id" */
  CollegePkey = 'college_pkey',
  /** unique or primary key constraint on columns "slug" */
  CollegeSlugKey = 'college_slug_key'
}

/** College to Game Join table */
export type Espin_College_Game = {
  __typename?: 'espin_college_game';
  /** An object relationship */
  college: Espin_College;
  college_id: Scalars['uuid'];
  /** An array relationship */
  college_rosters: Array<Espin_College_Roster>;
  /** An aggregate relationship */
  college_rosters_aggregate: Espin_College_Roster_Aggregate;
  /** An object relationship */
  game: Espin_Game;
  game_id: Scalars['String'];
  id: Scalars['uuid'];
};


/** College to Game Join table */
export type Espin_College_GameCollege_RostersArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Roster_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Roster_Order_By>>;
  where?: InputMaybe<Espin_College_Roster_Bool_Exp>;
};


/** College to Game Join table */
export type Espin_College_GameCollege_Rosters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Roster_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Roster_Order_By>>;
  where?: InputMaybe<Espin_College_Roster_Bool_Exp>;
};

/** aggregated selection of "espin.college_game" */
export type Espin_College_Game_Aggregate = {
  __typename?: 'espin_college_game_aggregate';
  aggregate?: Maybe<Espin_College_Game_Aggregate_Fields>;
  nodes: Array<Espin_College_Game>;
};

export type Espin_College_Game_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_College_Game_Aggregate_Bool_Exp_Count>;
};

export type Espin_College_Game_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_College_Game_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_College_Game_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.college_game" */
export type Espin_College_Game_Aggregate_Fields = {
  __typename?: 'espin_college_game_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_College_Game_Max_Fields>;
  min?: Maybe<Espin_College_Game_Min_Fields>;
};


/** aggregate fields of "espin.college_game" */
export type Espin_College_Game_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_College_Game_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.college_game" */
export type Espin_College_Game_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_College_Game_Max_Order_By>;
  min?: InputMaybe<Espin_College_Game_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.college_game" */
export type Espin_College_Game_Arr_Rel_Insert_Input = {
  data: Array<Espin_College_Game_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_College_Game_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.college_game". All fields are combined with a logical 'AND'. */
export type Espin_College_Game_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_College_Game_Bool_Exp>>;
  _not?: InputMaybe<Espin_College_Game_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_College_Game_Bool_Exp>>;
  college?: InputMaybe<Espin_College_Bool_Exp>;
  college_id?: InputMaybe<Uuid_Comparison_Exp>;
  college_rosters?: InputMaybe<Espin_College_Roster_Bool_Exp>;
  college_rosters_aggregate?: InputMaybe<Espin_College_Roster_Aggregate_Bool_Exp>;
  game?: InputMaybe<Espin_Game_Bool_Exp>;
  game_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.college_game" */
export enum Espin_College_Game_Constraint {
  /** unique or primary key constraint on columns "id" */
  CollegeGamesPkey = 'college_games_pkey'
}

/** input type for inserting data into table "espin.college_game" */
export type Espin_College_Game_Insert_Input = {
  college?: InputMaybe<Espin_College_Obj_Rel_Insert_Input>;
  college_id?: InputMaybe<Scalars['uuid']>;
  college_rosters?: InputMaybe<Espin_College_Roster_Arr_Rel_Insert_Input>;
  game?: InputMaybe<Espin_Game_Obj_Rel_Insert_Input>;
  game_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Espin_College_Game_Max_Fields = {
  __typename?: 'espin_college_game_max_fields';
  college_id?: Maybe<Scalars['uuid']>;
  game_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "espin.college_game" */
export type Espin_College_Game_Max_Order_By = {
  college_id?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_College_Game_Min_Fields = {
  __typename?: 'espin_college_game_min_fields';
  college_id?: Maybe<Scalars['uuid']>;
  game_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "espin.college_game" */
export type Espin_College_Game_Min_Order_By = {
  college_id?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.college_game" */
export type Espin_College_Game_Mutation_Response = {
  __typename?: 'espin_college_game_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_College_Game>;
};

/** on_conflict condition type for table "espin.college_game" */
export type Espin_College_Game_On_Conflict = {
  constraint: Espin_College_Game_Constraint;
  update_columns?: Array<Espin_College_Game_Update_Column>;
  where?: InputMaybe<Espin_College_Game_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.college_game". */
export type Espin_College_Game_Order_By = {
  college?: InputMaybe<Espin_College_Order_By>;
  college_id?: InputMaybe<Order_By>;
  college_rosters_aggregate?: InputMaybe<Espin_College_Roster_Aggregate_Order_By>;
  game?: InputMaybe<Espin_Game_Order_By>;
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.college_game */
export type Espin_College_Game_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.college_game" */
export enum Espin_College_Game_Select_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "espin.college_game" */
export type Espin_College_Game_Set_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  game_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "espin_college_game" */
export type Espin_College_Game_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_College_Game_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_College_Game_Stream_Cursor_Value_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  game_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "espin.college_game" */
export enum Espin_College_Game_Update_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id'
}

export type Espin_College_Game_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_College_Game_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_College_Game_Bool_Exp;
};

/** Images for college gallery */
export type Espin_College_Image = {
  __typename?: 'espin_college_image';
  /** An object relationship */
  college: Espin_College;
  college_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  file?: Maybe<Content_File>;
  file_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  order: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "espin.college_image" */
export type Espin_College_Image_Aggregate = {
  __typename?: 'espin_college_image_aggregate';
  aggregate?: Maybe<Espin_College_Image_Aggregate_Fields>;
  nodes: Array<Espin_College_Image>;
};

export type Espin_College_Image_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_College_Image_Aggregate_Bool_Exp_Count>;
};

export type Espin_College_Image_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_College_Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_College_Image_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.college_image" */
export type Espin_College_Image_Aggregate_Fields = {
  __typename?: 'espin_college_image_aggregate_fields';
  avg?: Maybe<Espin_College_Image_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_College_Image_Max_Fields>;
  min?: Maybe<Espin_College_Image_Min_Fields>;
  stddev?: Maybe<Espin_College_Image_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_College_Image_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_College_Image_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_College_Image_Sum_Fields>;
  var_pop?: Maybe<Espin_College_Image_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_College_Image_Var_Samp_Fields>;
  variance?: Maybe<Espin_College_Image_Variance_Fields>;
};


/** aggregate fields of "espin.college_image" */
export type Espin_College_Image_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_College_Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.college_image" */
export type Espin_College_Image_Aggregate_Order_By = {
  avg?: InputMaybe<Espin_College_Image_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_College_Image_Max_Order_By>;
  min?: InputMaybe<Espin_College_Image_Min_Order_By>;
  stddev?: InputMaybe<Espin_College_Image_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Espin_College_Image_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Espin_College_Image_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Espin_College_Image_Sum_Order_By>;
  var_pop?: InputMaybe<Espin_College_Image_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Espin_College_Image_Var_Samp_Order_By>;
  variance?: InputMaybe<Espin_College_Image_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "espin.college_image" */
export type Espin_College_Image_Arr_Rel_Insert_Input = {
  data: Array<Espin_College_Image_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_College_Image_On_Conflict>;
};

/** aggregate avg on columns */
export type Espin_College_Image_Avg_Fields = {
  __typename?: 'espin_college_image_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "espin.college_image" */
export type Espin_College_Image_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "espin.college_image". All fields are combined with a logical 'AND'. */
export type Espin_College_Image_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_College_Image_Bool_Exp>>;
  _not?: InputMaybe<Espin_College_Image_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_College_Image_Bool_Exp>>;
  college?: InputMaybe<Espin_College_Bool_Exp>;
  college_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Content_File_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.college_image" */
export enum Espin_College_Image_Constraint {
  /** unique or primary key constraint on columns "id" */
  CollegeImagePkey = 'college_image_pkey'
}

/** input type for incrementing numeric columns in table "espin.college_image" */
export type Espin_College_Image_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.college_image" */
export type Espin_College_Image_Insert_Input = {
  college?: InputMaybe<Espin_College_Obj_Rel_Insert_Input>;
  college_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  file?: InputMaybe<Content_File_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Espin_College_Image_Max_Fields = {
  __typename?: 'espin_college_image_max_fields';
  college_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "espin.college_image" */
export type Espin_College_Image_Max_Order_By = {
  college_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_College_Image_Min_Fields = {
  __typename?: 'espin_college_image_min_fields';
  college_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "espin.college_image" */
export type Espin_College_Image_Min_Order_By = {
  college_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.college_image" */
export type Espin_College_Image_Mutation_Response = {
  __typename?: 'espin_college_image_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_College_Image>;
};

/** on_conflict condition type for table "espin.college_image" */
export type Espin_College_Image_On_Conflict = {
  constraint: Espin_College_Image_Constraint;
  update_columns?: Array<Espin_College_Image_Update_Column>;
  where?: InputMaybe<Espin_College_Image_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.college_image". */
export type Espin_College_Image_Order_By = {
  college?: InputMaybe<Espin_College_Order_By>;
  college_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  file?: InputMaybe<Content_File_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.college_image */
export type Espin_College_Image_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.college_image" */
export enum Espin_College_Image_Select_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "espin.college_image" */
export type Espin_College_Image_Set_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Espin_College_Image_Stddev_Fields = {
  __typename?: 'espin_college_image_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "espin.college_image" */
export type Espin_College_Image_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Espin_College_Image_Stddev_Pop_Fields = {
  __typename?: 'espin_college_image_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "espin.college_image" */
export type Espin_College_Image_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Espin_College_Image_Stddev_Samp_Fields = {
  __typename?: 'espin_college_image_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "espin.college_image" */
export type Espin_College_Image_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "espin_college_image" */
export type Espin_College_Image_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_College_Image_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_College_Image_Stream_Cursor_Value_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Espin_College_Image_Sum_Fields = {
  __typename?: 'espin_college_image_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "espin.college_image" */
export type Espin_College_Image_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "espin.college_image" */
export enum Espin_College_Image_Update_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Espin_College_Image_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_College_Image_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_College_Image_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_College_Image_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_College_Image_Var_Pop_Fields = {
  __typename?: 'espin_college_image_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "espin.college_image" */
export type Espin_College_Image_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Espin_College_Image_Var_Samp_Fields = {
  __typename?: 'espin_college_image_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "espin.college_image" */
export type Espin_College_Image_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Espin_College_Image_Variance_Fields = {
  __typename?: 'espin_college_image_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "espin.college_image" */
export type Espin_College_Image_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "espin.college" */
export type Espin_College_Inc_Input = {
  manual_subtier?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.college" */
export type Espin_College_Insert_Input = {
  academic_notes?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Espin_Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['uuid']>;
  att_college_fair?: InputMaybe<Scalars['Boolean']>;
  bio?: InputMaybe<Scalars['String']>;
  college_games?: InputMaybe<Espin_College_Game_Arr_Rel_Insert_Input>;
  college_images?: InputMaybe<Espin_College_Image_Arr_Rel_Insert_Input>;
  college_owner?: InputMaybe<Espin_College_Profile_Obj_Rel_Insert_Input>;
  college_preferences?: InputMaybe<Espin_College_Preferences_Obj_Rel_Insert_Input>;
  college_profiles?: InputMaybe<Espin_College_Profile_Arr_Rel_Insert_Input>;
  college_staff_members?: InputMaybe<Espin_College_Staff_Member_Arr_Rel_Insert_Input>;
  college_subscription_id?: InputMaybe<Scalars['uuid']>;
  contact_email?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  follows?: InputMaybe<Espin_Follow_Arr_Rel_Insert_Input>;
  header_media_link?: InputMaybe<Content_Media_Link_Obj_Rel_Insert_Input>;
  header_media_link_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  in_state_tuition?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Content_File_Obj_Rel_Insert_Input>;
  logo_id?: InputMaybe<Scalars['uuid']>;
  manual_subtier?: InputMaybe<Scalars['Int']>;
  messages?: InputMaybe<Espin_Message_Arr_Rel_Insert_Input>;
  migration_id?: InputMaybe<Scalars['String']>;
  min_act?: InputMaybe<Scalars['String']>;
  min_gpa?: InputMaybe<Scalars['String']>;
  min_sat?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  out_of_state_tuition?: InputMaybe<Scalars['String']>;
  owner_profile_id?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  profile_views?: InputMaybe<Espin_Profile_View_Arr_Rel_Insert_Input>;
  program_name?: InputMaybe<Scalars['String']>;
  scholarships?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  socials?: InputMaybe<Espin_Social_Obj_Rel_Insert_Input>;
  socials_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_College_Verification_Status_Type_Enum>;
  stickied_colleges?: InputMaybe<Espin_Stickied_College_Arr_Rel_Insert_Input>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
  subscription?: InputMaybe<Espin_College_Subscription_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  /** True = Varsity, False = Club */
  varsity?: InputMaybe<Scalars['Boolean']>;
  /** Admin ONLY field to allow verified */
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** Invites for college users */
export type Espin_College_Invite = {
  __typename?: 'espin_college_invite';
  /** An object relationship */
  college: Espin_College;
  college_id: Scalars['uuid'];
  email: Scalars['String'];
  id: Scalars['uuid'];
  status: Espin_Invite_Status_Type_Enum;
};

/** aggregated selection of "espin.college_invite" */
export type Espin_College_Invite_Aggregate = {
  __typename?: 'espin_college_invite_aggregate';
  aggregate?: Maybe<Espin_College_Invite_Aggregate_Fields>;
  nodes: Array<Espin_College_Invite>;
};

/** aggregate fields of "espin.college_invite" */
export type Espin_College_Invite_Aggregate_Fields = {
  __typename?: 'espin_college_invite_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_College_Invite_Max_Fields>;
  min?: Maybe<Espin_College_Invite_Min_Fields>;
};


/** aggregate fields of "espin.college_invite" */
export type Espin_College_Invite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_College_Invite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.college_invite". All fields are combined with a logical 'AND'. */
export type Espin_College_Invite_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_College_Invite_Bool_Exp>>;
  _not?: InputMaybe<Espin_College_Invite_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_College_Invite_Bool_Exp>>;
  college?: InputMaybe<Espin_College_Bool_Exp>;
  college_id?: InputMaybe<Uuid_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.college_invite" */
export enum Espin_College_Invite_Constraint {
  /** unique or primary key constraint on columns "college_id", "email" */
  CollegeInviteEmailCollegeIdKey = 'college_invite_email_college_id_key',
  /** unique or primary key constraint on columns "email" */
  CollegeInviteEmailKey = 'college_invite_email_key',
  /** unique or primary key constraint on columns "id" */
  CollegeInvitePkey = 'college_invite_pkey'
}

/** input type for inserting data into table "espin.college_invite" */
export type Espin_College_Invite_Insert_Input = {
  college?: InputMaybe<Espin_College_Obj_Rel_Insert_Input>;
  college_id?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum>;
};

/** aggregate max on columns */
export type Espin_College_Invite_Max_Fields = {
  __typename?: 'espin_college_invite_max_fields';
  college_id?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Espin_College_Invite_Min_Fields = {
  __typename?: 'espin_college_invite_min_fields';
  college_id?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "espin.college_invite" */
export type Espin_College_Invite_Mutation_Response = {
  __typename?: 'espin_college_invite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_College_Invite>;
};

/** on_conflict condition type for table "espin.college_invite" */
export type Espin_College_Invite_On_Conflict = {
  constraint: Espin_College_Invite_Constraint;
  update_columns?: Array<Espin_College_Invite_Update_Column>;
  where?: InputMaybe<Espin_College_Invite_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.college_invite". */
export type Espin_College_Invite_Order_By = {
  college?: InputMaybe<Espin_College_Order_By>;
  college_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.college_invite */
export type Espin_College_Invite_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.college_invite" */
export enum Espin_College_Invite_Select_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "espin.college_invite" */
export type Espin_College_Invite_Set_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum>;
};

/** Streaming cursor of the table "espin_college_invite" */
export type Espin_College_Invite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_College_Invite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_College_Invite_Stream_Cursor_Value_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum>;
};

/** update columns of table "espin.college_invite" */
export enum Espin_College_Invite_Update_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status'
}

export type Espin_College_Invite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_College_Invite_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_College_Invite_Bool_Exp;
};

/** aggregate max on columns */
export type Espin_College_Max_Fields = {
  __typename?: 'espin_college_max_fields';
  academic_notes?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  college_subscription_id?: Maybe<Scalars['uuid']>;
  contact_email?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  header_media_link_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  in_state_tuition?: Maybe<Scalars['String']>;
  logo_id?: Maybe<Scalars['uuid']>;
  manual_subtier?: Maybe<Scalars['Int']>;
  migration_id?: Maybe<Scalars['String']>;
  min_act?: Maybe<Scalars['String']>;
  min_gpa?: Maybe<Scalars['String']>;
  min_sat?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  out_of_state_tuition?: Maybe<Scalars['String']>;
  owner_profile_id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  program_name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  socials_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "espin.college" */
export type Espin_College_Max_Order_By = {
  academic_notes?: InputMaybe<Order_By>;
  address_id?: InputMaybe<Order_By>;
  bio?: InputMaybe<Order_By>;
  college_subscription_id?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  header_media_link_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_state_tuition?: InputMaybe<Order_By>;
  logo_id?: InputMaybe<Order_By>;
  manual_subtier?: InputMaybe<Order_By>;
  migration_id?: InputMaybe<Order_By>;
  min_act?: InputMaybe<Order_By>;
  min_gpa?: InputMaybe<Order_By>;
  min_sat?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  out_of_state_tuition?: InputMaybe<Order_By>;
  owner_profile_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  program_name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  socials_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_College_Min_Fields = {
  __typename?: 'espin_college_min_fields';
  academic_notes?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  college_subscription_id?: Maybe<Scalars['uuid']>;
  contact_email?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  header_media_link_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  in_state_tuition?: Maybe<Scalars['String']>;
  logo_id?: Maybe<Scalars['uuid']>;
  manual_subtier?: Maybe<Scalars['Int']>;
  migration_id?: Maybe<Scalars['String']>;
  min_act?: Maybe<Scalars['String']>;
  min_gpa?: Maybe<Scalars['String']>;
  min_sat?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  out_of_state_tuition?: Maybe<Scalars['String']>;
  owner_profile_id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  program_name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  socials_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "espin.college" */
export type Espin_College_Min_Order_By = {
  academic_notes?: InputMaybe<Order_By>;
  address_id?: InputMaybe<Order_By>;
  bio?: InputMaybe<Order_By>;
  college_subscription_id?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  header_media_link_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_state_tuition?: InputMaybe<Order_By>;
  logo_id?: InputMaybe<Order_By>;
  manual_subtier?: InputMaybe<Order_By>;
  migration_id?: InputMaybe<Order_By>;
  min_act?: InputMaybe<Order_By>;
  min_gpa?: InputMaybe<Order_By>;
  min_sat?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  out_of_state_tuition?: InputMaybe<Order_By>;
  owner_profile_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  program_name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  socials_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.college" */
export type Espin_College_Mutation_Response = {
  __typename?: 'espin_college_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_College>;
};

/** input type for inserting object relation for remote table "espin.college" */
export type Espin_College_Obj_Rel_Insert_Input = {
  data: Espin_College_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_College_On_Conflict>;
};

/** on_conflict condition type for table "espin.college" */
export type Espin_College_On_Conflict = {
  constraint: Espin_College_Constraint;
  update_columns?: Array<Espin_College_Update_Column>;
  where?: InputMaybe<Espin_College_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.college". */
export type Espin_College_Order_By = {
  academic_notes?: InputMaybe<Order_By>;
  address?: InputMaybe<Espin_Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  att_college_fair?: InputMaybe<Order_By>;
  bio?: InputMaybe<Order_By>;
  college_games_aggregate?: InputMaybe<Espin_College_Game_Aggregate_Order_By>;
  college_images_aggregate?: InputMaybe<Espin_College_Image_Aggregate_Order_By>;
  college_owner?: InputMaybe<Espin_College_Profile_Order_By>;
  college_preferences?: InputMaybe<Espin_College_Preferences_Order_By>;
  college_profiles_aggregate?: InputMaybe<Espin_College_Profile_Aggregate_Order_By>;
  college_staff_members_aggregate?: InputMaybe<Espin_College_Staff_Member_Aggregate_Order_By>;
  college_subscription_id?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  follows_aggregate?: InputMaybe<Espin_Follow_Aggregate_Order_By>;
  header_media_link?: InputMaybe<Content_Media_Link_Order_By>;
  header_media_link_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_state_tuition?: InputMaybe<Order_By>;
  logo?: InputMaybe<Content_File_Order_By>;
  logo_id?: InputMaybe<Order_By>;
  manual_subtier?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Espin_Message_Aggregate_Order_By>;
  migration_id?: InputMaybe<Order_By>;
  min_act?: InputMaybe<Order_By>;
  min_gpa?: InputMaybe<Order_By>;
  min_sat?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  out_of_state_tuition?: InputMaybe<Order_By>;
  owner_profile_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  profile_views_aggregate?: InputMaybe<Espin_Profile_View_Aggregate_Order_By>;
  program_name?: InputMaybe<Order_By>;
  scholarships?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  socials?: InputMaybe<Espin_Social_Order_By>;
  socials_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stickied_colleges_aggregate?: InputMaybe<Espin_Stickied_College_Aggregate_Order_By>;
  subscribed?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Espin_College_Subscription_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  varsity?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.college */
export type Espin_College_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "espin.college_preferences" */
export type Espin_College_Preferences = {
  __typename?: 'espin_college_preferences';
  automatic_message_custom?: Maybe<Scalars['String']>;
  automatic_message_response_type: Espin_College_Automatic_Message_Response_Type_Enum;
  /** An object relationship */
  college: Espin_College;
  college_id: Scalars['uuid'];
  id: Scalars['uuid'];
};

/** aggregated selection of "espin.college_preferences" */
export type Espin_College_Preferences_Aggregate = {
  __typename?: 'espin_college_preferences_aggregate';
  aggregate?: Maybe<Espin_College_Preferences_Aggregate_Fields>;
  nodes: Array<Espin_College_Preferences>;
};

/** aggregate fields of "espin.college_preferences" */
export type Espin_College_Preferences_Aggregate_Fields = {
  __typename?: 'espin_college_preferences_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_College_Preferences_Max_Fields>;
  min?: Maybe<Espin_College_Preferences_Min_Fields>;
};


/** aggregate fields of "espin.college_preferences" */
export type Espin_College_Preferences_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_College_Preferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.college_preferences". All fields are combined with a logical 'AND'. */
export type Espin_College_Preferences_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_College_Preferences_Bool_Exp>>;
  _not?: InputMaybe<Espin_College_Preferences_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_College_Preferences_Bool_Exp>>;
  automatic_message_custom?: InputMaybe<String_Comparison_Exp>;
  automatic_message_response_type?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Enum_Comparison_Exp>;
  college?: InputMaybe<Espin_College_Bool_Exp>;
  college_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.college_preferences" */
export enum Espin_College_Preferences_Constraint {
  /** unique or primary key constraint on columns "college_id" */
  CollegePreferencesCollegeIdKey = 'college_preferences_college_id_key',
  /** unique or primary key constraint on columns "id" */
  CollegePreferencesPkey = 'college_preferences_pkey'
}

/** input type for inserting data into table "espin.college_preferences" */
export type Espin_College_Preferences_Insert_Input = {
  automatic_message_custom?: InputMaybe<Scalars['String']>;
  automatic_message_response_type?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Enum>;
  college?: InputMaybe<Espin_College_Obj_Rel_Insert_Input>;
  college_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Espin_College_Preferences_Max_Fields = {
  __typename?: 'espin_college_preferences_max_fields';
  automatic_message_custom?: Maybe<Scalars['String']>;
  college_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Espin_College_Preferences_Min_Fields = {
  __typename?: 'espin_college_preferences_min_fields';
  automatic_message_custom?: Maybe<Scalars['String']>;
  college_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "espin.college_preferences" */
export type Espin_College_Preferences_Mutation_Response = {
  __typename?: 'espin_college_preferences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_College_Preferences>;
};

/** input type for inserting object relation for remote table "espin.college_preferences" */
export type Espin_College_Preferences_Obj_Rel_Insert_Input = {
  data: Espin_College_Preferences_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_College_Preferences_On_Conflict>;
};

/** on_conflict condition type for table "espin.college_preferences" */
export type Espin_College_Preferences_On_Conflict = {
  constraint: Espin_College_Preferences_Constraint;
  update_columns?: Array<Espin_College_Preferences_Update_Column>;
  where?: InputMaybe<Espin_College_Preferences_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.college_preferences". */
export type Espin_College_Preferences_Order_By = {
  automatic_message_custom?: InputMaybe<Order_By>;
  automatic_message_response_type?: InputMaybe<Order_By>;
  college?: InputMaybe<Espin_College_Order_By>;
  college_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.college_preferences */
export type Espin_College_Preferences_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.college_preferences" */
export enum Espin_College_Preferences_Select_Column {
  /** column name */
  AutomaticMessageCustom = 'automatic_message_custom',
  /** column name */
  AutomaticMessageResponseType = 'automatic_message_response_type',
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "espin.college_preferences" */
export type Espin_College_Preferences_Set_Input = {
  automatic_message_custom?: InputMaybe<Scalars['String']>;
  automatic_message_response_type?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Enum>;
  college_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "espin_college_preferences" */
export type Espin_College_Preferences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_College_Preferences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_College_Preferences_Stream_Cursor_Value_Input = {
  automatic_message_custom?: InputMaybe<Scalars['String']>;
  automatic_message_response_type?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Enum>;
  college_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "espin.college_preferences" */
export enum Espin_College_Preferences_Update_Column {
  /** column name */
  AutomaticMessageCustom = 'automatic_message_custom',
  /** column name */
  AutomaticMessageResponseType = 'automatic_message_response_type',
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  Id = 'id'
}

export type Espin_College_Preferences_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_College_Preferences_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_College_Preferences_Bool_Exp;
};

/** Profile info for the college users. Links to college itself */
export type Espin_College_Profile = {
  __typename?: 'espin_college_profile';
  /** An object relationship */
  college: Espin_College;
  college_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  last_group_message?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: Espin_User;
  user_id: Scalars['String'];
};

/** aggregated selection of "espin.college_profile" */
export type Espin_College_Profile_Aggregate = {
  __typename?: 'espin_college_profile_aggregate';
  aggregate?: Maybe<Espin_College_Profile_Aggregate_Fields>;
  nodes: Array<Espin_College_Profile>;
};

export type Espin_College_Profile_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_College_Profile_Aggregate_Bool_Exp_Count>;
};

export type Espin_College_Profile_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_College_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_College_Profile_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.college_profile" */
export type Espin_College_Profile_Aggregate_Fields = {
  __typename?: 'espin_college_profile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_College_Profile_Max_Fields>;
  min?: Maybe<Espin_College_Profile_Min_Fields>;
};


/** aggregate fields of "espin.college_profile" */
export type Espin_College_Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_College_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.college_profile" */
export type Espin_College_Profile_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_College_Profile_Max_Order_By>;
  min?: InputMaybe<Espin_College_Profile_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.college_profile" */
export type Espin_College_Profile_Arr_Rel_Insert_Input = {
  data: Array<Espin_College_Profile_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_College_Profile_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.college_profile". All fields are combined with a logical 'AND'. */
export type Espin_College_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_College_Profile_Bool_Exp>>;
  _not?: InputMaybe<Espin_College_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_College_Profile_Bool_Exp>>;
  college?: InputMaybe<Espin_College_Bool_Exp>;
  college_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_group_message?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Espin_User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.college_profile" */
export enum Espin_College_Profile_Constraint {
  /** unique or primary key constraint on columns "id" */
  CollegeProfilePkey = 'college_profile_pkey',
  /** unique or primary key constraint on columns "user_id" */
  CollegeProfileUserIdKey = 'college_profile_user_id_key'
}

/** input type for inserting data into table "espin.college_profile" */
export type Espin_College_Profile_Insert_Input = {
  college?: InputMaybe<Espin_College_Obj_Rel_Insert_Input>;
  college_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_group_message?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_College_Profile_Max_Fields = {
  __typename?: 'espin_college_profile_max_fields';
  college_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_group_message?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.college_profile" */
export type Espin_College_Profile_Max_Order_By = {
  college_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_group_message?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_College_Profile_Min_Fields = {
  __typename?: 'espin_college_profile_min_fields';
  college_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_group_message?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.college_profile" */
export type Espin_College_Profile_Min_Order_By = {
  college_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_group_message?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.college_profile" */
export type Espin_College_Profile_Mutation_Response = {
  __typename?: 'espin_college_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_College_Profile>;
};

/** input type for inserting object relation for remote table "espin.college_profile" */
export type Espin_College_Profile_Obj_Rel_Insert_Input = {
  data: Espin_College_Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_College_Profile_On_Conflict>;
};

/** on_conflict condition type for table "espin.college_profile" */
export type Espin_College_Profile_On_Conflict = {
  constraint: Espin_College_Profile_Constraint;
  update_columns?: Array<Espin_College_Profile_Update_Column>;
  where?: InputMaybe<Espin_College_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.college_profile". */
export type Espin_College_Profile_Order_By = {
  college?: InputMaybe<Espin_College_Order_By>;
  college_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_group_message?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Espin_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.college_profile */
export type Espin_College_Profile_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.college_profile" */
export enum Espin_College_Profile_Select_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastGroupMessage = 'last_group_message',
  /** column name */
  LastName = 'last_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "espin.college_profile" */
export type Espin_College_Profile_Set_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_group_message?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_college_profile" */
export type Espin_College_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_College_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_College_Profile_Stream_Cursor_Value_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_group_message?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.college_profile" */
export enum Espin_College_Profile_Update_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastGroupMessage = 'last_group_message',
  /** column name */
  LastName = 'last_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Espin_College_Profile_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_College_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_College_Profile_Bool_Exp;
};

/** columns and relationships of "espin.college_roster" */
export type Espin_College_Roster = {
  __typename?: 'espin_college_roster';
  college_game_id: Scalars['uuid'];
  /** An array relationship */
  college_games: Array<Espin_College_Game>;
  /** An aggregate relationship */
  college_games_aggregate: Espin_College_Game_Aggregate;
  first_name?: Maybe<Scalars['String']>;
  gamertag: Scalars['String'];
  id: Scalars['uuid'];
  last_name?: Maybe<Scalars['String']>;
};


/** columns and relationships of "espin.college_roster" */
export type Espin_College_RosterCollege_GamesArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Game_Order_By>>;
  where?: InputMaybe<Espin_College_Game_Bool_Exp>;
};


/** columns and relationships of "espin.college_roster" */
export type Espin_College_RosterCollege_Games_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Game_Order_By>>;
  where?: InputMaybe<Espin_College_Game_Bool_Exp>;
};

/** aggregated selection of "espin.college_roster" */
export type Espin_College_Roster_Aggregate = {
  __typename?: 'espin_college_roster_aggregate';
  aggregate?: Maybe<Espin_College_Roster_Aggregate_Fields>;
  nodes: Array<Espin_College_Roster>;
};

export type Espin_College_Roster_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_College_Roster_Aggregate_Bool_Exp_Count>;
};

export type Espin_College_Roster_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_College_Roster_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_College_Roster_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.college_roster" */
export type Espin_College_Roster_Aggregate_Fields = {
  __typename?: 'espin_college_roster_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_College_Roster_Max_Fields>;
  min?: Maybe<Espin_College_Roster_Min_Fields>;
};


/** aggregate fields of "espin.college_roster" */
export type Espin_College_Roster_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_College_Roster_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.college_roster" */
export type Espin_College_Roster_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_College_Roster_Max_Order_By>;
  min?: InputMaybe<Espin_College_Roster_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.college_roster" */
export type Espin_College_Roster_Arr_Rel_Insert_Input = {
  data: Array<Espin_College_Roster_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_College_Roster_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.college_roster". All fields are combined with a logical 'AND'. */
export type Espin_College_Roster_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_College_Roster_Bool_Exp>>;
  _not?: InputMaybe<Espin_College_Roster_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_College_Roster_Bool_Exp>>;
  college_game_id?: InputMaybe<Uuid_Comparison_Exp>;
  college_games?: InputMaybe<Espin_College_Game_Bool_Exp>;
  college_games_aggregate?: InputMaybe<Espin_College_Game_Aggregate_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  gamertag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.college_roster" */
export enum Espin_College_Roster_Constraint {
  /** unique or primary key constraint on columns "id" */
  CollegeRostersPkey = 'college_rosters_pkey'
}

/** input type for inserting data into table "espin.college_roster" */
export type Espin_College_Roster_Insert_Input = {
  college_game_id?: InputMaybe<Scalars['uuid']>;
  college_games?: InputMaybe<Espin_College_Game_Arr_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']>;
  gamertag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_College_Roster_Max_Fields = {
  __typename?: 'espin_college_roster_max_fields';
  college_game_id?: Maybe<Scalars['uuid']>;
  first_name?: Maybe<Scalars['String']>;
  gamertag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.college_roster" */
export type Espin_College_Roster_Max_Order_By = {
  college_game_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gamertag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_College_Roster_Min_Fields = {
  __typename?: 'espin_college_roster_min_fields';
  college_game_id?: Maybe<Scalars['uuid']>;
  first_name?: Maybe<Scalars['String']>;
  gamertag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.college_roster" */
export type Espin_College_Roster_Min_Order_By = {
  college_game_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gamertag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.college_roster" */
export type Espin_College_Roster_Mutation_Response = {
  __typename?: 'espin_college_roster_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_College_Roster>;
};

/** on_conflict condition type for table "espin.college_roster" */
export type Espin_College_Roster_On_Conflict = {
  constraint: Espin_College_Roster_Constraint;
  update_columns?: Array<Espin_College_Roster_Update_Column>;
  where?: InputMaybe<Espin_College_Roster_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.college_roster". */
export type Espin_College_Roster_Order_By = {
  college_game_id?: InputMaybe<Order_By>;
  college_games_aggregate?: InputMaybe<Espin_College_Game_Aggregate_Order_By>;
  first_name?: InputMaybe<Order_By>;
  gamertag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.college_roster */
export type Espin_College_Roster_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.college_roster" */
export enum Espin_College_Roster_Select_Column {
  /** column name */
  CollegeGameId = 'college_game_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gamertag = 'gamertag',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name'
}

/** input type for updating data in table "espin.college_roster" */
export type Espin_College_Roster_Set_Input = {
  college_game_id?: InputMaybe<Scalars['uuid']>;
  first_name?: InputMaybe<Scalars['String']>;
  gamertag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_college_roster" */
export type Espin_College_Roster_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_College_Roster_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_College_Roster_Stream_Cursor_Value_Input = {
  college_game_id?: InputMaybe<Scalars['uuid']>;
  first_name?: InputMaybe<Scalars['String']>;
  gamertag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.college_roster" */
export enum Espin_College_Roster_Update_Column {
  /** column name */
  CollegeGameId = 'college_game_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gamertag = 'gamertag',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name'
}

export type Espin_College_Roster_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_College_Roster_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_College_Roster_Bool_Exp;
};

/** select columns of table "espin.college" */
export enum Espin_College_Select_Column {
  /** column name */
  AcademicNotes = 'academic_notes',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AttCollegeFair = 'att_college_fair',
  /** column name */
  Bio = 'bio',
  /** column name */
  CollegeSubscriptionId = 'college_subscription_id',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HeaderMediaLinkId = 'header_media_link_id',
  /** column name */
  Id = 'id',
  /** column name */
  InStateTuition = 'in_state_tuition',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  ManualSubtier = 'manual_subtier',
  /** column name */
  MigrationId = 'migration_id',
  /** column name */
  MinAct = 'min_act',
  /** column name */
  MinGpa = 'min_gpa',
  /** column name */
  MinSat = 'min_sat',
  /** column name */
  Name = 'name',
  /** column name */
  OutOfStateTuition = 'out_of_state_tuition',
  /** column name */
  OwnerProfileId = 'owner_profile_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProgramName = 'program_name',
  /** column name */
  Scholarships = 'scholarships',
  /** column name */
  Slug = 'slug',
  /** column name */
  SocialsId = 'socials_id',
  /** column name */
  Status = 'status',
  /** column name */
  Subscribed = 'subscribed',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Varsity = 'varsity',
  /** column name */
  Verified = 'verified'
}

/** select "espin_college_aggregate_bool_exp_bool_and_arguments_columns" columns of table "espin.college" */
export enum Espin_College_Select_Column_Espin_College_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AttCollegeFair = 'att_college_fair',
  /** column name */
  Scholarships = 'scholarships',
  /** column name */
  Subscribed = 'subscribed',
  /** column name */
  Varsity = 'varsity',
  /** column name */
  Verified = 'verified'
}

/** select "espin_college_aggregate_bool_exp_bool_or_arguments_columns" columns of table "espin.college" */
export enum Espin_College_Select_Column_Espin_College_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AttCollegeFair = 'att_college_fair',
  /** column name */
  Scholarships = 'scholarships',
  /** column name */
  Subscribed = 'subscribed',
  /** column name */
  Varsity = 'varsity',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "espin.college" */
export type Espin_College_Set_Input = {
  academic_notes?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['uuid']>;
  att_college_fair?: InputMaybe<Scalars['Boolean']>;
  bio?: InputMaybe<Scalars['String']>;
  college_subscription_id?: InputMaybe<Scalars['uuid']>;
  contact_email?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  header_media_link_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  in_state_tuition?: InputMaybe<Scalars['String']>;
  logo_id?: InputMaybe<Scalars['uuid']>;
  manual_subtier?: InputMaybe<Scalars['Int']>;
  migration_id?: InputMaybe<Scalars['String']>;
  min_act?: InputMaybe<Scalars['String']>;
  min_gpa?: InputMaybe<Scalars['String']>;
  min_sat?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  out_of_state_tuition?: InputMaybe<Scalars['String']>;
  owner_profile_id?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  program_name?: InputMaybe<Scalars['String']>;
  scholarships?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  socials_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_College_Verification_Status_Type_Enum>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  /** True = Varsity, False = Club */
  varsity?: InputMaybe<Scalars['Boolean']>;
  /** Admin ONLY field to allow verified */
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** A plain list of college staff members */
export type Espin_College_Staff_Member = {
  __typename?: 'espin_college_staff_member';
  /** An object relationship */
  college: Espin_College;
  college_id: Scalars['uuid'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  position: Scalars['String'];
};

/** aggregated selection of "espin.college_staff_member" */
export type Espin_College_Staff_Member_Aggregate = {
  __typename?: 'espin_college_staff_member_aggregate';
  aggregate?: Maybe<Espin_College_Staff_Member_Aggregate_Fields>;
  nodes: Array<Espin_College_Staff_Member>;
};

export type Espin_College_Staff_Member_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_College_Staff_Member_Aggregate_Bool_Exp_Count>;
};

export type Espin_College_Staff_Member_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_College_Staff_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_College_Staff_Member_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.college_staff_member" */
export type Espin_College_Staff_Member_Aggregate_Fields = {
  __typename?: 'espin_college_staff_member_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_College_Staff_Member_Max_Fields>;
  min?: Maybe<Espin_College_Staff_Member_Min_Fields>;
};


/** aggregate fields of "espin.college_staff_member" */
export type Espin_College_Staff_Member_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_College_Staff_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.college_staff_member" */
export type Espin_College_Staff_Member_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_College_Staff_Member_Max_Order_By>;
  min?: InputMaybe<Espin_College_Staff_Member_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.college_staff_member" */
export type Espin_College_Staff_Member_Arr_Rel_Insert_Input = {
  data: Array<Espin_College_Staff_Member_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_College_Staff_Member_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.college_staff_member". All fields are combined with a logical 'AND'. */
export type Espin_College_Staff_Member_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_College_Staff_Member_Bool_Exp>>;
  _not?: InputMaybe<Espin_College_Staff_Member_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_College_Staff_Member_Bool_Exp>>;
  college?: InputMaybe<Espin_College_Bool_Exp>;
  college_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  position?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.college_staff_member" */
export enum Espin_College_Staff_Member_Constraint {
  /** unique or primary key constraint on columns "id" */
  CollegeStaffMemberPkey = 'college_staff_member_pkey'
}

/** input type for inserting data into table "espin.college_staff_member" */
export type Espin_College_Staff_Member_Insert_Input = {
  college?: InputMaybe<Espin_College_Obj_Rel_Insert_Input>;
  college_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_College_Staff_Member_Max_Fields = {
  __typename?: 'espin_college_staff_member_max_fields';
  college_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.college_staff_member" */
export type Espin_College_Staff_Member_Max_Order_By = {
  college_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_College_Staff_Member_Min_Fields = {
  __typename?: 'espin_college_staff_member_min_fields';
  college_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.college_staff_member" */
export type Espin_College_Staff_Member_Min_Order_By = {
  college_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.college_staff_member" */
export type Espin_College_Staff_Member_Mutation_Response = {
  __typename?: 'espin_college_staff_member_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_College_Staff_Member>;
};

/** on_conflict condition type for table "espin.college_staff_member" */
export type Espin_College_Staff_Member_On_Conflict = {
  constraint: Espin_College_Staff_Member_Constraint;
  update_columns?: Array<Espin_College_Staff_Member_Update_Column>;
  where?: InputMaybe<Espin_College_Staff_Member_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.college_staff_member". */
export type Espin_College_Staff_Member_Order_By = {
  college?: InputMaybe<Espin_College_Order_By>;
  college_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.college_staff_member */
export type Espin_College_Staff_Member_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.college_staff_member" */
export enum Espin_College_Staff_Member_Select_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Position = 'position'
}

/** input type for updating data in table "espin.college_staff_member" */
export type Espin_College_Staff_Member_Set_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_college_staff_member" */
export type Espin_College_Staff_Member_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_College_Staff_Member_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_College_Staff_Member_Stream_Cursor_Value_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.college_staff_member" */
export enum Espin_College_Staff_Member_Update_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Position = 'position'
}

export type Espin_College_Staff_Member_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_College_Staff_Member_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_College_Staff_Member_Bool_Exp;
};

/** aggregate stddev on columns */
export type Espin_College_Stddev_Fields = {
  __typename?: 'espin_college_stddev_fields';
  manual_subtier?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "espin.college" */
export type Espin_College_Stddev_Order_By = {
  manual_subtier?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Espin_College_Stddev_Pop_Fields = {
  __typename?: 'espin_college_stddev_pop_fields';
  manual_subtier?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "espin.college" */
export type Espin_College_Stddev_Pop_Order_By = {
  manual_subtier?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Espin_College_Stddev_Samp_Fields = {
  __typename?: 'espin_college_stddev_samp_fields';
  manual_subtier?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "espin.college" */
export type Espin_College_Stddev_Samp_Order_By = {
  manual_subtier?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "espin_college" */
export type Espin_College_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_College_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_College_Stream_Cursor_Value_Input = {
  academic_notes?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['uuid']>;
  att_college_fair?: InputMaybe<Scalars['Boolean']>;
  bio?: InputMaybe<Scalars['String']>;
  college_subscription_id?: InputMaybe<Scalars['uuid']>;
  contact_email?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  header_media_link_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  in_state_tuition?: InputMaybe<Scalars['String']>;
  logo_id?: InputMaybe<Scalars['uuid']>;
  manual_subtier?: InputMaybe<Scalars['Int']>;
  migration_id?: InputMaybe<Scalars['String']>;
  min_act?: InputMaybe<Scalars['String']>;
  min_gpa?: InputMaybe<Scalars['String']>;
  min_sat?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  out_of_state_tuition?: InputMaybe<Scalars['String']>;
  owner_profile_id?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  program_name?: InputMaybe<Scalars['String']>;
  scholarships?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  socials_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_College_Verification_Status_Type_Enum>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  /** True = Varsity, False = Club */
  varsity?: InputMaybe<Scalars['Boolean']>;
  /** Admin ONLY field to allow verified */
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** College subscription statuses */
export type Espin_College_Subscription = {
  __typename?: 'espin_college_subscription';
  /** An array relationship */
  colleges: Array<Espin_College>;
  /** An aggregate relationship */
  colleges_aggregate: Espin_College_Aggregate;
  expires: Scalars['bigint'];
  id: Scalars['uuid'];
  plan: Espin_Paid_Product_Enum;
  /** An object relationship */
  referral_code_redemption?: Maybe<Espin_Referral_Code_Redemption>;
  referral_code_redemption_id?: Maybe<Scalars['uuid']>;
  status: Espin_Subscription_Status_Enum;
  sub_tier: Espin_Subscription_Tier_Type_Enum;
};


/** College subscription statuses */
export type Espin_College_SubscriptionCollegesArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Order_By>>;
  where?: InputMaybe<Espin_College_Bool_Exp>;
};


/** College subscription statuses */
export type Espin_College_SubscriptionColleges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Order_By>>;
  where?: InputMaybe<Espin_College_Bool_Exp>;
};

/** aggregated selection of "espin.college_subscription" */
export type Espin_College_Subscription_Aggregate = {
  __typename?: 'espin_college_subscription_aggregate';
  aggregate?: Maybe<Espin_College_Subscription_Aggregate_Fields>;
  nodes: Array<Espin_College_Subscription>;
};

/** aggregate fields of "espin.college_subscription" */
export type Espin_College_Subscription_Aggregate_Fields = {
  __typename?: 'espin_college_subscription_aggregate_fields';
  avg?: Maybe<Espin_College_Subscription_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_College_Subscription_Max_Fields>;
  min?: Maybe<Espin_College_Subscription_Min_Fields>;
  stddev?: Maybe<Espin_College_Subscription_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_College_Subscription_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_College_Subscription_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_College_Subscription_Sum_Fields>;
  var_pop?: Maybe<Espin_College_Subscription_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_College_Subscription_Var_Samp_Fields>;
  variance?: Maybe<Espin_College_Subscription_Variance_Fields>;
};


/** aggregate fields of "espin.college_subscription" */
export type Espin_College_Subscription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_College_Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Espin_College_Subscription_Avg_Fields = {
  __typename?: 'espin_college_subscription_avg_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.college_subscription". All fields are combined with a logical 'AND'. */
export type Espin_College_Subscription_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_College_Subscription_Bool_Exp>>;
  _not?: InputMaybe<Espin_College_Subscription_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_College_Subscription_Bool_Exp>>;
  colleges?: InputMaybe<Espin_College_Bool_Exp>;
  colleges_aggregate?: InputMaybe<Espin_College_Aggregate_Bool_Exp>;
  expires?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  plan?: InputMaybe<Espin_Paid_Product_Enum_Comparison_Exp>;
  referral_code_redemption?: InputMaybe<Espin_Referral_Code_Redemption_Bool_Exp>;
  referral_code_redemption_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Espin_Subscription_Status_Enum_Comparison_Exp>;
  sub_tier?: InputMaybe<Espin_Subscription_Tier_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.college_subscription" */
export enum Espin_College_Subscription_Constraint {
  /** unique or primary key constraint on columns "id" */
  CollegeSubscriptionPkey = 'college_subscription_pkey'
}

/** input type for incrementing numeric columns in table "espin.college_subscription" */
export type Espin_College_Subscription_Inc_Input = {
  expires?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "espin.college_subscription" */
export type Espin_College_Subscription_Insert_Input = {
  colleges?: InputMaybe<Espin_College_Arr_Rel_Insert_Input>;
  expires?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  plan?: InputMaybe<Espin_Paid_Product_Enum>;
  referral_code_redemption?: InputMaybe<Espin_Referral_Code_Redemption_Obj_Rel_Insert_Input>;
  referral_code_redemption_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Subscription_Status_Enum>;
  sub_tier?: InputMaybe<Espin_Subscription_Tier_Type_Enum>;
};

/** aggregate max on columns */
export type Espin_College_Subscription_Max_Fields = {
  __typename?: 'espin_college_subscription_max_fields';
  expires?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  referral_code_redemption_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Espin_College_Subscription_Min_Fields = {
  __typename?: 'espin_college_subscription_min_fields';
  expires?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  referral_code_redemption_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "espin.college_subscription" */
export type Espin_College_Subscription_Mutation_Response = {
  __typename?: 'espin_college_subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_College_Subscription>;
};

/** input type for inserting object relation for remote table "espin.college_subscription" */
export type Espin_College_Subscription_Obj_Rel_Insert_Input = {
  data: Espin_College_Subscription_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_College_Subscription_On_Conflict>;
};

/** on_conflict condition type for table "espin.college_subscription" */
export type Espin_College_Subscription_On_Conflict = {
  constraint: Espin_College_Subscription_Constraint;
  update_columns?: Array<Espin_College_Subscription_Update_Column>;
  where?: InputMaybe<Espin_College_Subscription_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.college_subscription". */
export type Espin_College_Subscription_Order_By = {
  colleges_aggregate?: InputMaybe<Espin_College_Aggregate_Order_By>;
  expires?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  referral_code_redemption?: InputMaybe<Espin_Referral_Code_Redemption_Order_By>;
  referral_code_redemption_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sub_tier?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.college_subscription */
export type Espin_College_Subscription_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.college_subscription" */
export enum Espin_College_Subscription_Select_Column {
  /** column name */
  Expires = 'expires',
  /** column name */
  Id = 'id',
  /** column name */
  Plan = 'plan',
  /** column name */
  ReferralCodeRedemptionId = 'referral_code_redemption_id',
  /** column name */
  Status = 'status',
  /** column name */
  SubTier = 'sub_tier'
}

/** input type for updating data in table "espin.college_subscription" */
export type Espin_College_Subscription_Set_Input = {
  expires?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  plan?: InputMaybe<Espin_Paid_Product_Enum>;
  referral_code_redemption_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Subscription_Status_Enum>;
  sub_tier?: InputMaybe<Espin_Subscription_Tier_Type_Enum>;
};

/** aggregate stddev on columns */
export type Espin_College_Subscription_Stddev_Fields = {
  __typename?: 'espin_college_subscription_stddev_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_College_Subscription_Stddev_Pop_Fields = {
  __typename?: 'espin_college_subscription_stddev_pop_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_College_Subscription_Stddev_Samp_Fields = {
  __typename?: 'espin_college_subscription_stddev_samp_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_college_subscription" */
export type Espin_College_Subscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_College_Subscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_College_Subscription_Stream_Cursor_Value_Input = {
  expires?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  plan?: InputMaybe<Espin_Paid_Product_Enum>;
  referral_code_redemption_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Subscription_Status_Enum>;
  sub_tier?: InputMaybe<Espin_Subscription_Tier_Type_Enum>;
};

/** aggregate sum on columns */
export type Espin_College_Subscription_Sum_Fields = {
  __typename?: 'espin_college_subscription_sum_fields';
  expires?: Maybe<Scalars['bigint']>;
};

/** update columns of table "espin.college_subscription" */
export enum Espin_College_Subscription_Update_Column {
  /** column name */
  Expires = 'expires',
  /** column name */
  Id = 'id',
  /** column name */
  Plan = 'plan',
  /** column name */
  ReferralCodeRedemptionId = 'referral_code_redemption_id',
  /** column name */
  Status = 'status',
  /** column name */
  SubTier = 'sub_tier'
}

export type Espin_College_Subscription_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_College_Subscription_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_College_Subscription_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_College_Subscription_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_College_Subscription_Var_Pop_Fields = {
  __typename?: 'espin_college_subscription_var_pop_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_College_Subscription_Var_Samp_Fields = {
  __typename?: 'espin_college_subscription_var_samp_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_College_Subscription_Variance_Fields = {
  __typename?: 'espin_college_subscription_variance_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Espin_College_Sum_Fields = {
  __typename?: 'espin_college_sum_fields';
  manual_subtier?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "espin.college" */
export type Espin_College_Sum_Order_By = {
  manual_subtier?: InputMaybe<Order_By>;
};

/** update columns of table "espin.college" */
export enum Espin_College_Update_Column {
  /** column name */
  AcademicNotes = 'academic_notes',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AttCollegeFair = 'att_college_fair',
  /** column name */
  Bio = 'bio',
  /** column name */
  CollegeSubscriptionId = 'college_subscription_id',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HeaderMediaLinkId = 'header_media_link_id',
  /** column name */
  Id = 'id',
  /** column name */
  InStateTuition = 'in_state_tuition',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  ManualSubtier = 'manual_subtier',
  /** column name */
  MigrationId = 'migration_id',
  /** column name */
  MinAct = 'min_act',
  /** column name */
  MinGpa = 'min_gpa',
  /** column name */
  MinSat = 'min_sat',
  /** column name */
  Name = 'name',
  /** column name */
  OutOfStateTuition = 'out_of_state_tuition',
  /** column name */
  OwnerProfileId = 'owner_profile_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProgramName = 'program_name',
  /** column name */
  Scholarships = 'scholarships',
  /** column name */
  Slug = 'slug',
  /** column name */
  SocialsId = 'socials_id',
  /** column name */
  Status = 'status',
  /** column name */
  Subscribed = 'subscribed',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Varsity = 'varsity',
  /** column name */
  Verified = 'verified'
}

export type Espin_College_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_College_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_College_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_College_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_College_Var_Pop_Fields = {
  __typename?: 'espin_college_var_pop_fields';
  manual_subtier?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "espin.college" */
export type Espin_College_Var_Pop_Order_By = {
  manual_subtier?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Espin_College_Var_Samp_Fields = {
  __typename?: 'espin_college_var_samp_fields';
  manual_subtier?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "espin.college" */
export type Espin_College_Var_Samp_Order_By = {
  manual_subtier?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Espin_College_Variance_Fields = {
  __typename?: 'espin_college_variance_fields';
  manual_subtier?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "espin.college" */
export type Espin_College_Variance_Order_By = {
  manual_subtier?: InputMaybe<Order_By>;
};

/** Status of the info for a college + whether it needs verification or not */
export type Espin_College_Verification_Status_Type = {
  __typename?: 'espin_college_verification_status_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.college_verification_status_type" */
export type Espin_College_Verification_Status_Type_Aggregate = {
  __typename?: 'espin_college_verification_status_type_aggregate';
  aggregate?: Maybe<Espin_College_Verification_Status_Type_Aggregate_Fields>;
  nodes: Array<Espin_College_Verification_Status_Type>;
};

/** aggregate fields of "espin.college_verification_status_type" */
export type Espin_College_Verification_Status_Type_Aggregate_Fields = {
  __typename?: 'espin_college_verification_status_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_College_Verification_Status_Type_Max_Fields>;
  min?: Maybe<Espin_College_Verification_Status_Type_Min_Fields>;
};


/** aggregate fields of "espin.college_verification_status_type" */
export type Espin_College_Verification_Status_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_College_Verification_Status_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.college_verification_status_type". All fields are combined with a logical 'AND'. */
export type Espin_College_Verification_Status_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_College_Verification_Status_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_College_Verification_Status_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_College_Verification_Status_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.college_verification_status_type" */
export enum Espin_College_Verification_Status_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  CollegeVerificationStatusTypePkey = 'college_verification_status_type_pkey'
}

export enum Espin_College_Verification_Status_Type_Enum {
  /** Initial creation, not ready to be verified */
  Draft = 'draft',
  /** Queued for verification */
  NeedsVerification = 'needs_verification'
}

/** Boolean expression to compare columns of type "espin_college_verification_status_type_enum". All fields are combined with logical 'AND'. */
export type Espin_College_Verification_Status_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_College_Verification_Status_Type_Enum>;
  _in?: InputMaybe<Array<Espin_College_Verification_Status_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_College_Verification_Status_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_College_Verification_Status_Type_Enum>>;
};

/** input type for inserting data into table "espin.college_verification_status_type" */
export type Espin_College_Verification_Status_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_College_Verification_Status_Type_Max_Fields = {
  __typename?: 'espin_college_verification_status_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_College_Verification_Status_Type_Min_Fields = {
  __typename?: 'espin_college_verification_status_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.college_verification_status_type" */
export type Espin_College_Verification_Status_Type_Mutation_Response = {
  __typename?: 'espin_college_verification_status_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_College_Verification_Status_Type>;
};

/** on_conflict condition type for table "espin.college_verification_status_type" */
export type Espin_College_Verification_Status_Type_On_Conflict = {
  constraint: Espin_College_Verification_Status_Type_Constraint;
  update_columns?: Array<Espin_College_Verification_Status_Type_Update_Column>;
  where?: InputMaybe<Espin_College_Verification_Status_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.college_verification_status_type". */
export type Espin_College_Verification_Status_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.college_verification_status_type */
export type Espin_College_Verification_Status_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.college_verification_status_type" */
export enum Espin_College_Verification_Status_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.college_verification_status_type" */
export type Espin_College_Verification_Status_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_college_verification_status_type" */
export type Espin_College_Verification_Status_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_College_Verification_Status_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_College_Verification_Status_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.college_verification_status_type" */
export enum Espin_College_Verification_Status_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_College_Verification_Status_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_College_Verification_Status_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_College_Verification_Status_Type_Bool_Exp;
};

/** Holding tank for player profile changes to be approved / rejected */
export type Espin_Draft_Player_Profile = {
  __typename?: 'espin_draft_player_profile';
  bio?: Maybe<Scalars['String']>;
  birthdate: Scalars['date'];
  city: Scalars['String'];
  college_coach_email?: Maybe<Scalars['String']>;
  college_coach_name?: Maybe<Scalars['String']>;
  college_name?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  discord?: Maybe<Scalars['String']>;
  ethnicity: Espin_Ethnicity_Options_Enum;
  facebook?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  gender: Espin_Gender_Options_Enum;
  gender_not_listed_entry?: Maybe<Scalars['String']>;
  gpa: Scalars['numeric'];
  graduating_class: Scalars['String'];
  hs_coach_email?: Maybe<Scalars['String']>;
  hs_coach_name?: Maybe<Scalars['String']>;
  hs_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  in_game_username: Scalars['String'];
  instagram?: Maybe<Scalars['String']>;
  /** Boolean switch for is high school or college (related to their data) */
  is_hs: Scalars['Boolean'];
  last_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  moderation_status: Espin_Moderation_Status;
  preferred_schools: Scalars['jsonb'];
  preferred_study_fields?: Maybe<Scalars['jsonb']>;
  primary_game: Scalars['uuid'];
  primary_game_rank: Scalars['String'];
  primary_game_role: Scalars['String'];
  primary_game_tracker: Scalars['String'];
  spin_username: Scalars['String'];
  state: Scalars['String'];
  status: Espin_Moderation_Status_Enum;
  tiktok?: Maybe<Scalars['String']>;
  twitch?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Espin_User;
  user_id: Scalars['String'];
  youtube?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};


/** Holding tank for player profile changes to be approved / rejected */
export type Espin_Draft_Player_ProfilePreferred_SchoolsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Holding tank for player profile changes to be approved / rejected */
export type Espin_Draft_Player_ProfilePreferred_Study_FieldsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "espin.draft_player_profile" */
export type Espin_Draft_Player_Profile_Aggregate = {
  __typename?: 'espin_draft_player_profile_aggregate';
  aggregate?: Maybe<Espin_Draft_Player_Profile_Aggregate_Fields>;
  nodes: Array<Espin_Draft_Player_Profile>;
};

/** aggregate fields of "espin.draft_player_profile" */
export type Espin_Draft_Player_Profile_Aggregate_Fields = {
  __typename?: 'espin_draft_player_profile_aggregate_fields';
  avg?: Maybe<Espin_Draft_Player_Profile_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Draft_Player_Profile_Max_Fields>;
  min?: Maybe<Espin_Draft_Player_Profile_Min_Fields>;
  stddev?: Maybe<Espin_Draft_Player_Profile_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Draft_Player_Profile_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Draft_Player_Profile_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Draft_Player_Profile_Sum_Fields>;
  var_pop?: Maybe<Espin_Draft_Player_Profile_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Draft_Player_Profile_Var_Samp_Fields>;
  variance?: Maybe<Espin_Draft_Player_Profile_Variance_Fields>;
};


/** aggregate fields of "espin.draft_player_profile" */
export type Espin_Draft_Player_Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Draft_Player_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Espin_Draft_Player_Profile_Append_Input = {
  preferred_schools?: InputMaybe<Scalars['jsonb']>;
  preferred_study_fields?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Espin_Draft_Player_Profile_Avg_Fields = {
  __typename?: 'espin_draft_player_profile_avg_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.draft_player_profile". All fields are combined with a logical 'AND'. */
export type Espin_Draft_Player_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Draft_Player_Profile_Bool_Exp>>;
  _not?: InputMaybe<Espin_Draft_Player_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Draft_Player_Profile_Bool_Exp>>;
  bio?: InputMaybe<String_Comparison_Exp>;
  birthdate?: InputMaybe<Date_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  college_coach_email?: InputMaybe<String_Comparison_Exp>;
  college_coach_name?: InputMaybe<String_Comparison_Exp>;
  college_name?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  discord?: InputMaybe<String_Comparison_Exp>;
  ethnicity?: InputMaybe<Espin_Ethnicity_Options_Enum_Comparison_Exp>;
  facebook?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<Espin_Gender_Options_Enum_Comparison_Exp>;
  gender_not_listed_entry?: InputMaybe<String_Comparison_Exp>;
  gpa?: InputMaybe<Numeric_Comparison_Exp>;
  graduating_class?: InputMaybe<String_Comparison_Exp>;
  hs_coach_email?: InputMaybe<String_Comparison_Exp>;
  hs_coach_name?: InputMaybe<String_Comparison_Exp>;
  hs_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_game_username?: InputMaybe<String_Comparison_Exp>;
  instagram?: InputMaybe<String_Comparison_Exp>;
  is_hs?: InputMaybe<Boolean_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  moderation_status?: InputMaybe<Espin_Moderation_Status_Bool_Exp>;
  preferred_schools?: InputMaybe<Jsonb_Comparison_Exp>;
  preferred_study_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  primary_game?: InputMaybe<Uuid_Comparison_Exp>;
  primary_game_rank?: InputMaybe<String_Comparison_Exp>;
  primary_game_role?: InputMaybe<String_Comparison_Exp>;
  primary_game_tracker?: InputMaybe<String_Comparison_Exp>;
  spin_username?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Espin_Moderation_Status_Enum_Comparison_Exp>;
  tiktok?: InputMaybe<String_Comparison_Exp>;
  twitch?: InputMaybe<String_Comparison_Exp>;
  twitter?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Espin_User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  youtube?: InputMaybe<String_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.draft_player_profile" */
export enum Espin_Draft_Player_Profile_Constraint {
  /** unique or primary key constraint on columns "id" */
  DraftPlayerProfilePkey = 'draft_player_profile_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Espin_Draft_Player_Profile_Delete_At_Path_Input = {
  preferred_schools?: InputMaybe<Array<Scalars['String']>>;
  preferred_study_fields?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Espin_Draft_Player_Profile_Delete_Elem_Input = {
  preferred_schools?: InputMaybe<Scalars['Int']>;
  preferred_study_fields?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Espin_Draft_Player_Profile_Delete_Key_Input = {
  preferred_schools?: InputMaybe<Scalars['String']>;
  preferred_study_fields?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "espin.draft_player_profile" */
export type Espin_Draft_Player_Profile_Inc_Input = {
  gpa?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "espin.draft_player_profile" */
export type Espin_Draft_Player_Profile_Insert_Input = {
  bio?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['date']>;
  city?: InputMaybe<Scalars['String']>;
  college_coach_email?: InputMaybe<Scalars['String']>;
  college_coach_name?: InputMaybe<Scalars['String']>;
  college_name?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discord?: InputMaybe<Scalars['String']>;
  ethnicity?: InputMaybe<Espin_Ethnicity_Options_Enum>;
  facebook?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Espin_Gender_Options_Enum>;
  gender_not_listed_entry?: InputMaybe<Scalars['String']>;
  gpa?: InputMaybe<Scalars['numeric']>;
  graduating_class?: InputMaybe<Scalars['String']>;
  hs_coach_email?: InputMaybe<Scalars['String']>;
  hs_coach_name?: InputMaybe<Scalars['String']>;
  hs_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  in_game_username?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  /** Boolean switch for is high school or college (related to their data) */
  is_hs?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  moderation_status?: InputMaybe<Espin_Moderation_Status_Obj_Rel_Insert_Input>;
  preferred_schools?: InputMaybe<Scalars['jsonb']>;
  preferred_study_fields?: InputMaybe<Scalars['jsonb']>;
  primary_game?: InputMaybe<Scalars['uuid']>;
  primary_game_rank?: InputMaybe<Scalars['String']>;
  primary_game_role?: InputMaybe<Scalars['String']>;
  primary_game_tracker?: InputMaybe<Scalars['String']>;
  spin_username?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Espin_Moderation_Status_Enum>;
  tiktok?: InputMaybe<Scalars['String']>;
  twitch?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Draft_Player_Profile_Max_Fields = {
  __typename?: 'espin_draft_player_profile_max_fields';
  bio?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['date']>;
  city?: Maybe<Scalars['String']>;
  college_coach_email?: Maybe<Scalars['String']>;
  college_coach_name?: Maybe<Scalars['String']>;
  college_name?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discord?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  gender_not_listed_entry?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['numeric']>;
  graduating_class?: Maybe<Scalars['String']>;
  hs_coach_email?: Maybe<Scalars['String']>;
  hs_coach_name?: Maybe<Scalars['String']>;
  hs_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  in_game_username?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  primary_game?: Maybe<Scalars['uuid']>;
  primary_game_rank?: Maybe<Scalars['String']>;
  primary_game_role?: Maybe<Scalars['String']>;
  primary_game_tracker?: Maybe<Scalars['String']>;
  spin_username?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tiktok?: Maybe<Scalars['String']>;
  twitch?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Draft_Player_Profile_Min_Fields = {
  __typename?: 'espin_draft_player_profile_min_fields';
  bio?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['date']>;
  city?: Maybe<Scalars['String']>;
  college_coach_email?: Maybe<Scalars['String']>;
  college_coach_name?: Maybe<Scalars['String']>;
  college_name?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discord?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  gender_not_listed_entry?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['numeric']>;
  graduating_class?: Maybe<Scalars['String']>;
  hs_coach_email?: Maybe<Scalars['String']>;
  hs_coach_name?: Maybe<Scalars['String']>;
  hs_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  in_game_username?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  primary_game?: Maybe<Scalars['uuid']>;
  primary_game_rank?: Maybe<Scalars['String']>;
  primary_game_role?: Maybe<Scalars['String']>;
  primary_game_tracker?: Maybe<Scalars['String']>;
  spin_username?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tiktok?: Maybe<Scalars['String']>;
  twitch?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.draft_player_profile" */
export type Espin_Draft_Player_Profile_Mutation_Response = {
  __typename?: 'espin_draft_player_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Draft_Player_Profile>;
};

/** on_conflict condition type for table "espin.draft_player_profile" */
export type Espin_Draft_Player_Profile_On_Conflict = {
  constraint: Espin_Draft_Player_Profile_Constraint;
  update_columns?: Array<Espin_Draft_Player_Profile_Update_Column>;
  where?: InputMaybe<Espin_Draft_Player_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.draft_player_profile". */
export type Espin_Draft_Player_Profile_Order_By = {
  bio?: InputMaybe<Order_By>;
  birthdate?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  college_coach_email?: InputMaybe<Order_By>;
  college_coach_name?: InputMaybe<Order_By>;
  college_name?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discord?: InputMaybe<Order_By>;
  ethnicity?: InputMaybe<Order_By>;
  facebook?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  gender_not_listed_entry?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  graduating_class?: InputMaybe<Order_By>;
  hs_coach_email?: InputMaybe<Order_By>;
  hs_coach_name?: InputMaybe<Order_By>;
  hs_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_game_username?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  is_hs?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  moderation_status?: InputMaybe<Espin_Moderation_Status_Order_By>;
  preferred_schools?: InputMaybe<Order_By>;
  preferred_study_fields?: InputMaybe<Order_By>;
  primary_game?: InputMaybe<Order_By>;
  primary_game_rank?: InputMaybe<Order_By>;
  primary_game_role?: InputMaybe<Order_By>;
  primary_game_tracker?: InputMaybe<Order_By>;
  spin_username?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tiktok?: InputMaybe<Order_By>;
  twitch?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Espin_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  youtube?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.draft_player_profile */
export type Espin_Draft_Player_Profile_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Espin_Draft_Player_Profile_Prepend_Input = {
  preferred_schools?: InputMaybe<Scalars['jsonb']>;
  preferred_study_fields?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "espin.draft_player_profile" */
export enum Espin_Draft_Player_Profile_Select_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  Birthdate = 'birthdate',
  /** column name */
  City = 'city',
  /** column name */
  CollegeCoachEmail = 'college_coach_email',
  /** column name */
  CollegeCoachName = 'college_coach_name',
  /** column name */
  CollegeName = 'college_name',
  /** column name */
  Comments = 'comments',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Discord = 'discord',
  /** column name */
  Ethnicity = 'ethnicity',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  GenderNotListedEntry = 'gender_not_listed_entry',
  /** column name */
  Gpa = 'gpa',
  /** column name */
  GraduatingClass = 'graduating_class',
  /** column name */
  HsCoachEmail = 'hs_coach_email',
  /** column name */
  HsCoachName = 'hs_coach_name',
  /** column name */
  HsName = 'hs_name',
  /** column name */
  Id = 'id',
  /** column name */
  InGameUsername = 'in_game_username',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  IsHs = 'is_hs',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PreferredSchools = 'preferred_schools',
  /** column name */
  PreferredStudyFields = 'preferred_study_fields',
  /** column name */
  PrimaryGame = 'primary_game',
  /** column name */
  PrimaryGameRank = 'primary_game_rank',
  /** column name */
  PrimaryGameRole = 'primary_game_role',
  /** column name */
  PrimaryGameTracker = 'primary_game_tracker',
  /** column name */
  SpinUsername = 'spin_username',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  Tiktok = 'tiktok',
  /** column name */
  Twitch = 'twitch',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Youtube = 'youtube',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "espin.draft_player_profile" */
export type Espin_Draft_Player_Profile_Set_Input = {
  bio?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['date']>;
  city?: InputMaybe<Scalars['String']>;
  college_coach_email?: InputMaybe<Scalars['String']>;
  college_coach_name?: InputMaybe<Scalars['String']>;
  college_name?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discord?: InputMaybe<Scalars['String']>;
  ethnicity?: InputMaybe<Espin_Ethnicity_Options_Enum>;
  facebook?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Espin_Gender_Options_Enum>;
  gender_not_listed_entry?: InputMaybe<Scalars['String']>;
  gpa?: InputMaybe<Scalars['numeric']>;
  graduating_class?: InputMaybe<Scalars['String']>;
  hs_coach_email?: InputMaybe<Scalars['String']>;
  hs_coach_name?: InputMaybe<Scalars['String']>;
  hs_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  in_game_username?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  /** Boolean switch for is high school or college (related to their data) */
  is_hs?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  preferred_schools?: InputMaybe<Scalars['jsonb']>;
  preferred_study_fields?: InputMaybe<Scalars['jsonb']>;
  primary_game?: InputMaybe<Scalars['uuid']>;
  primary_game_rank?: InputMaybe<Scalars['String']>;
  primary_game_role?: InputMaybe<Scalars['String']>;
  primary_game_tracker?: InputMaybe<Scalars['String']>;
  spin_username?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Espin_Moderation_Status_Enum>;
  tiktok?: InputMaybe<Scalars['String']>;
  twitch?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Espin_Draft_Player_Profile_Stddev_Fields = {
  __typename?: 'espin_draft_player_profile_stddev_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_Draft_Player_Profile_Stddev_Pop_Fields = {
  __typename?: 'espin_draft_player_profile_stddev_pop_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_Draft_Player_Profile_Stddev_Samp_Fields = {
  __typename?: 'espin_draft_player_profile_stddev_samp_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_draft_player_profile" */
export type Espin_Draft_Player_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Draft_Player_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Draft_Player_Profile_Stream_Cursor_Value_Input = {
  bio?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['date']>;
  city?: InputMaybe<Scalars['String']>;
  college_coach_email?: InputMaybe<Scalars['String']>;
  college_coach_name?: InputMaybe<Scalars['String']>;
  college_name?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discord?: InputMaybe<Scalars['String']>;
  ethnicity?: InputMaybe<Espin_Ethnicity_Options_Enum>;
  facebook?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Espin_Gender_Options_Enum>;
  gender_not_listed_entry?: InputMaybe<Scalars['String']>;
  gpa?: InputMaybe<Scalars['numeric']>;
  graduating_class?: InputMaybe<Scalars['String']>;
  hs_coach_email?: InputMaybe<Scalars['String']>;
  hs_coach_name?: InputMaybe<Scalars['String']>;
  hs_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  in_game_username?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  /** Boolean switch for is high school or college (related to their data) */
  is_hs?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  preferred_schools?: InputMaybe<Scalars['jsonb']>;
  preferred_study_fields?: InputMaybe<Scalars['jsonb']>;
  primary_game?: InputMaybe<Scalars['uuid']>;
  primary_game_rank?: InputMaybe<Scalars['String']>;
  primary_game_role?: InputMaybe<Scalars['String']>;
  primary_game_tracker?: InputMaybe<Scalars['String']>;
  spin_username?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Espin_Moderation_Status_Enum>;
  tiktok?: InputMaybe<Scalars['String']>;
  twitch?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Espin_Draft_Player_Profile_Sum_Fields = {
  __typename?: 'espin_draft_player_profile_sum_fields';
  gpa?: Maybe<Scalars['numeric']>;
};

/** update columns of table "espin.draft_player_profile" */
export enum Espin_Draft_Player_Profile_Update_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  Birthdate = 'birthdate',
  /** column name */
  City = 'city',
  /** column name */
  CollegeCoachEmail = 'college_coach_email',
  /** column name */
  CollegeCoachName = 'college_coach_name',
  /** column name */
  CollegeName = 'college_name',
  /** column name */
  Comments = 'comments',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Discord = 'discord',
  /** column name */
  Ethnicity = 'ethnicity',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  GenderNotListedEntry = 'gender_not_listed_entry',
  /** column name */
  Gpa = 'gpa',
  /** column name */
  GraduatingClass = 'graduating_class',
  /** column name */
  HsCoachEmail = 'hs_coach_email',
  /** column name */
  HsCoachName = 'hs_coach_name',
  /** column name */
  HsName = 'hs_name',
  /** column name */
  Id = 'id',
  /** column name */
  InGameUsername = 'in_game_username',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  IsHs = 'is_hs',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PreferredSchools = 'preferred_schools',
  /** column name */
  PreferredStudyFields = 'preferred_study_fields',
  /** column name */
  PrimaryGame = 'primary_game',
  /** column name */
  PrimaryGameRank = 'primary_game_rank',
  /** column name */
  PrimaryGameRole = 'primary_game_role',
  /** column name */
  PrimaryGameTracker = 'primary_game_tracker',
  /** column name */
  SpinUsername = 'spin_username',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  Tiktok = 'tiktok',
  /** column name */
  Twitch = 'twitch',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Youtube = 'youtube',
  /** column name */
  Zip = 'zip'
}

export type Espin_Draft_Player_Profile_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Espin_Draft_Player_Profile_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Espin_Draft_Player_Profile_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Espin_Draft_Player_Profile_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Espin_Draft_Player_Profile_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Draft_Player_Profile_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Espin_Draft_Player_Profile_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Draft_Player_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Draft_Player_Profile_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Draft_Player_Profile_Var_Pop_Fields = {
  __typename?: 'espin_draft_player_profile_var_pop_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_Draft_Player_Profile_Var_Samp_Fields = {
  __typename?: 'espin_draft_player_profile_var_samp_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_Draft_Player_Profile_Variance_Fields = {
  __typename?: 'espin_draft_player_profile_variance_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** Enum listing the available terms for the espin site */
export type Espin_Editable_Site_Content = {
  __typename?: 'espin_editable_site_content';
  description: Scalars['String'];
  key: Scalars['String'];
};

/** aggregated selection of "espin.editable_site_content" */
export type Espin_Editable_Site_Content_Aggregate = {
  __typename?: 'espin_editable_site_content_aggregate';
  aggregate?: Maybe<Espin_Editable_Site_Content_Aggregate_Fields>;
  nodes: Array<Espin_Editable_Site_Content>;
};

/** aggregate fields of "espin.editable_site_content" */
export type Espin_Editable_Site_Content_Aggregate_Fields = {
  __typename?: 'espin_editable_site_content_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Editable_Site_Content_Max_Fields>;
  min?: Maybe<Espin_Editable_Site_Content_Min_Fields>;
};


/** aggregate fields of "espin.editable_site_content" */
export type Espin_Editable_Site_Content_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Editable_Site_Content_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.editable_site_content". All fields are combined with a logical 'AND'. */
export type Espin_Editable_Site_Content_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Editable_Site_Content_Bool_Exp>>;
  _not?: InputMaybe<Espin_Editable_Site_Content_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Editable_Site_Content_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.editable_site_content" */
export enum Espin_Editable_Site_Content_Constraint {
  /** unique or primary key constraint on columns "key" */
  EditableSiteContentPkey = 'editable_site_content_pkey'
}

export enum Espin_Editable_Site_Content_Enum {
  /** Content for the education page */
  EducationPageContent = 'education_page_content',
  /** Content for the sponsors page */
  SponsorsPageContent = 'sponsors_page_content'
}

/** Boolean expression to compare columns of type "espin_editable_site_content_enum". All fields are combined with logical 'AND'. */
export type Espin_Editable_Site_Content_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Editable_Site_Content_Enum>;
  _in?: InputMaybe<Array<Espin_Editable_Site_Content_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Editable_Site_Content_Enum>;
  _nin?: InputMaybe<Array<Espin_Editable_Site_Content_Enum>>;
};

/** input type for inserting data into table "espin.editable_site_content" */
export type Espin_Editable_Site_Content_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Editable_Site_Content_Max_Fields = {
  __typename?: 'espin_editable_site_content_max_fields';
  description?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Editable_Site_Content_Min_Fields = {
  __typename?: 'espin_editable_site_content_min_fields';
  description?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.editable_site_content" */
export type Espin_Editable_Site_Content_Mutation_Response = {
  __typename?: 'espin_editable_site_content_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Editable_Site_Content>;
};

/** on_conflict condition type for table "espin.editable_site_content" */
export type Espin_Editable_Site_Content_On_Conflict = {
  constraint: Espin_Editable_Site_Content_Constraint;
  update_columns?: Array<Espin_Editable_Site_Content_Update_Column>;
  where?: InputMaybe<Espin_Editable_Site_Content_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.editable_site_content". */
export type Espin_Editable_Site_Content_Order_By = {
  description?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.editable_site_content */
export type Espin_Editable_Site_Content_Pk_Columns_Input = {
  key: Scalars['String'];
};

/** select columns of table "espin.editable_site_content" */
export enum Espin_Editable_Site_Content_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Key = 'key'
}

/** input type for updating data in table "espin.editable_site_content" */
export type Espin_Editable_Site_Content_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_editable_site_content" */
export type Espin_Editable_Site_Content_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Editable_Site_Content_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Editable_Site_Content_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.editable_site_content" */
export enum Espin_Editable_Site_Content_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Key = 'key'
}

export type Espin_Editable_Site_Content_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Editable_Site_Content_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Editable_Site_Content_Bool_Exp;
};

/** Options for ethnicity */
export type Espin_Ethnicity_Options = {
  __typename?: 'espin_ethnicity_options';
  display_name: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.ethnicity_options" */
export type Espin_Ethnicity_Options_Aggregate = {
  __typename?: 'espin_ethnicity_options_aggregate';
  aggregate?: Maybe<Espin_Ethnicity_Options_Aggregate_Fields>;
  nodes: Array<Espin_Ethnicity_Options>;
};

/** aggregate fields of "espin.ethnicity_options" */
export type Espin_Ethnicity_Options_Aggregate_Fields = {
  __typename?: 'espin_ethnicity_options_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Ethnicity_Options_Max_Fields>;
  min?: Maybe<Espin_Ethnicity_Options_Min_Fields>;
};


/** aggregate fields of "espin.ethnicity_options" */
export type Espin_Ethnicity_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Ethnicity_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.ethnicity_options". All fields are combined with a logical 'AND'. */
export type Espin_Ethnicity_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Ethnicity_Options_Bool_Exp>>;
  _not?: InputMaybe<Espin_Ethnicity_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Ethnicity_Options_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.ethnicity_options" */
export enum Espin_Ethnicity_Options_Constraint {
  /** unique or primary key constraint on columns "name" */
  EthnicityOptionsPkey = 'ethnicity_options_pkey'
}

export enum Espin_Ethnicity_Options_Enum {
  /** Asian or Pacific Islander */
  AsianOrPacificIslander = 'asian_or_pacific_islander',
  /** Black or African American */
  BlackOrAfricanAmerican = 'black_or_african_american',
  /** Hispanic or Latino */
  HispanicOrLatino = 'hispanic_or_latino',
  /** Multiracial or Biracial */
  MultiracialOrBiracial = 'multiracial_or_biracial',
  /** Native American or Alaskan Native */
  NativeAmericanOrAlaskanNative = 'native_american_or_alaskan_native',
  /** A race/ethnicity not listed here */
  NotListed = 'not_listed',
  /** Prefer not to say */
  PreferNotToSay = 'prefer_not_to_say',
  /** White or Caucasian */
  WhiteOrCaucasian = 'white_or_caucasian'
}

/** Boolean expression to compare columns of type "espin_ethnicity_options_enum". All fields are combined with logical 'AND'. */
export type Espin_Ethnicity_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Ethnicity_Options_Enum>;
  _in?: InputMaybe<Array<Espin_Ethnicity_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Ethnicity_Options_Enum>;
  _nin?: InputMaybe<Array<Espin_Ethnicity_Options_Enum>>;
};

/** input type for inserting data into table "espin.ethnicity_options" */
export type Espin_Ethnicity_Options_Insert_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Ethnicity_Options_Max_Fields = {
  __typename?: 'espin_ethnicity_options_max_fields';
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Ethnicity_Options_Min_Fields = {
  __typename?: 'espin_ethnicity_options_min_fields';
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.ethnicity_options" */
export type Espin_Ethnicity_Options_Mutation_Response = {
  __typename?: 'espin_ethnicity_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Ethnicity_Options>;
};

/** on_conflict condition type for table "espin.ethnicity_options" */
export type Espin_Ethnicity_Options_On_Conflict = {
  constraint: Espin_Ethnicity_Options_Constraint;
  update_columns?: Array<Espin_Ethnicity_Options_Update_Column>;
  where?: InputMaybe<Espin_Ethnicity_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.ethnicity_options". */
export type Espin_Ethnicity_Options_Order_By = {
  display_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.ethnicity_options */
export type Espin_Ethnicity_Options_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.ethnicity_options" */
export enum Espin_Ethnicity_Options_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.ethnicity_options" */
export type Espin_Ethnicity_Options_Set_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_ethnicity_options" */
export type Espin_Ethnicity_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Ethnicity_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Ethnicity_Options_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.ethnicity_options" */
export enum Espin_Ethnicity_Options_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

export type Espin_Ethnicity_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Ethnicity_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Ethnicity_Options_Bool_Exp;
};

/** columns and relationships of "espin.event" */
export type Espin_Event = {
  __typename?: 'espin_event';
  admin_recommended: Scalars['Boolean'];
  body_content?: Maybe<Scalars['String']>;
  /** An array relationship */
  event_custom_fields: Array<Espin_Event_Custom_Field>;
  /** An aggregate relationship */
  event_custom_fields_aggregate: Espin_Event_Custom_Field_Aggregate;
  /** An array relationship */
  event_documents: Array<Espin_Event_Document>;
  /** An aggregate relationship */
  event_documents_aggregate: Espin_Event_Document_Aggregate;
  event_end_date: Scalars['timestamptz'];
  /** An array relationship */
  event_games: Array<Espin_Event_Game>;
  /** An aggregate relationship */
  event_games_aggregate: Espin_Event_Game_Aggregate;
  /** An array relationship */
  event_registrations: Array<Espin_Event_Registration>;
  /** An aggregate relationship */
  event_registrations_aggregate: Espin_Event_Registration_Aggregate;
  event_start_date: Scalars['timestamptz'];
  /** An object relationship */
  event_status: Content_Status;
  /** An array relationship */
  event_tickets: Array<Espin_Event_Ticket>;
  /** An aggregate relationship */
  event_tickets_aggregate: Espin_Event_Ticket_Aggregate;
  /** An object relationship */
  icon?: Maybe<Content_File>;
  icon_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  logo?: Maybe<Content_File>;
  logo_id?: Maybe<Scalars['uuid']>;
  migration_id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  prize: Scalars['numeric'];
  register_end_date: Scalars['timestamptz'];
  register_start_date: Scalars['timestamptz'];
  registration_disclaimer?: Maybe<Scalars['String']>;
  rules_content?: Maybe<Scalars['String']>;
  rules_link?: Maybe<Scalars['String']>;
  short_description?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  status: Content_Status_Enum;
  stickied?: Maybe<Scalars['Int']>;
  stream_url?: Maybe<Scalars['String']>;
  success_page?: Maybe<Scalars['String']>;
  type: Espin_Event_Type_Enum;
  url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "espin.event" */
export type Espin_EventEvent_Custom_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Custom_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Custom_Field_Order_By>>;
  where?: InputMaybe<Espin_Event_Custom_Field_Bool_Exp>;
};


/** columns and relationships of "espin.event" */
export type Espin_EventEvent_Custom_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Custom_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Custom_Field_Order_By>>;
  where?: InputMaybe<Espin_Event_Custom_Field_Bool_Exp>;
};


/** columns and relationships of "espin.event" */
export type Espin_EventEvent_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Document_Order_By>>;
  where?: InputMaybe<Espin_Event_Document_Bool_Exp>;
};


/** columns and relationships of "espin.event" */
export type Espin_EventEvent_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Document_Order_By>>;
  where?: InputMaybe<Espin_Event_Document_Bool_Exp>;
};


/** columns and relationships of "espin.event" */
export type Espin_EventEvent_GamesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Game_Order_By>>;
  where?: InputMaybe<Espin_Event_Game_Bool_Exp>;
};


/** columns and relationships of "espin.event" */
export type Espin_EventEvent_Games_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Game_Order_By>>;
  where?: InputMaybe<Espin_Event_Game_Bool_Exp>;
};


/** columns and relationships of "espin.event" */
export type Espin_EventEvent_RegistrationsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
};


/** columns and relationships of "espin.event" */
export type Espin_EventEvent_Registrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
};


/** columns and relationships of "espin.event" */
export type Espin_EventEvent_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Ticket_Order_By>>;
  where?: InputMaybe<Espin_Event_Ticket_Bool_Exp>;
};


/** columns and relationships of "espin.event" */
export type Espin_EventEvent_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Ticket_Order_By>>;
  where?: InputMaybe<Espin_Event_Ticket_Bool_Exp>;
};

/** aggregated selection of "espin.event" */
export type Espin_Event_Aggregate = {
  __typename?: 'espin_event_aggregate';
  aggregate?: Maybe<Espin_Event_Aggregate_Fields>;
  nodes: Array<Espin_Event>;
};

/** aggregate fields of "espin.event" */
export type Espin_Event_Aggregate_Fields = {
  __typename?: 'espin_event_aggregate_fields';
  avg?: Maybe<Espin_Event_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Event_Max_Fields>;
  min?: Maybe<Espin_Event_Min_Fields>;
  stddev?: Maybe<Espin_Event_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Event_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Event_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Event_Sum_Fields>;
  var_pop?: Maybe<Espin_Event_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Event_Var_Samp_Fields>;
  variance?: Maybe<Espin_Event_Variance_Fields>;
};


/** aggregate fields of "espin.event" */
export type Espin_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Espin_Event_Avg_Fields = {
  __typename?: 'espin_event_avg_fields';
  prize?: Maybe<Scalars['Float']>;
  stickied?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.event". All fields are combined with a logical 'AND'. */
export type Espin_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Event_Bool_Exp>>;
  _not?: InputMaybe<Espin_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Event_Bool_Exp>>;
  admin_recommended?: InputMaybe<Boolean_Comparison_Exp>;
  body_content?: InputMaybe<String_Comparison_Exp>;
  event_custom_fields?: InputMaybe<Espin_Event_Custom_Field_Bool_Exp>;
  event_custom_fields_aggregate?: InputMaybe<Espin_Event_Custom_Field_Aggregate_Bool_Exp>;
  event_documents?: InputMaybe<Espin_Event_Document_Bool_Exp>;
  event_documents_aggregate?: InputMaybe<Espin_Event_Document_Aggregate_Bool_Exp>;
  event_end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_games?: InputMaybe<Espin_Event_Game_Bool_Exp>;
  event_games_aggregate?: InputMaybe<Espin_Event_Game_Aggregate_Bool_Exp>;
  event_registrations?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
  event_registrations_aggregate?: InputMaybe<Espin_Event_Registration_Aggregate_Bool_Exp>;
  event_start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_status?: InputMaybe<Content_Status_Bool_Exp>;
  event_tickets?: InputMaybe<Espin_Event_Ticket_Bool_Exp>;
  event_tickets_aggregate?: InputMaybe<Espin_Event_Ticket_Aggregate_Bool_Exp>;
  icon?: InputMaybe<Content_File_Bool_Exp>;
  icon_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logo?: InputMaybe<Content_File_Bool_Exp>;
  logo_id?: InputMaybe<Uuid_Comparison_Exp>;
  migration_id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  prize?: InputMaybe<Numeric_Comparison_Exp>;
  register_end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  register_start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  registration_disclaimer?: InputMaybe<String_Comparison_Exp>;
  rules_content?: InputMaybe<String_Comparison_Exp>;
  rules_link?: InputMaybe<String_Comparison_Exp>;
  short_description?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Content_Status_Enum_Comparison_Exp>;
  stickied?: InputMaybe<Int_Comparison_Exp>;
  stream_url?: InputMaybe<String_Comparison_Exp>;
  success_page?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Espin_Event_Type_Enum_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.event" */
export enum Espin_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventPkey = 'event_pkey',
  /** unique or primary key constraint on columns "slug" */
  EventSlugKey = 'event_slug_key'
}

/** Custom fields in system */
export type Espin_Event_Custom_Field = {
  __typename?: 'espin_event_custom_field';
  created_at: Scalars['timestamptz'];
  default_value?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  event_id: Scalars['uuid'];
  field_type: Espin_Event_Custom_Field_Type_Enum;
  id: Scalars['uuid'];
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "espin.event_custom_field" */
export type Espin_Event_Custom_Field_Aggregate = {
  __typename?: 'espin_event_custom_field_aggregate';
  aggregate?: Maybe<Espin_Event_Custom_Field_Aggregate_Fields>;
  nodes: Array<Espin_Event_Custom_Field>;
};

export type Espin_Event_Custom_Field_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Event_Custom_Field_Aggregate_Bool_Exp_Count>;
};

export type Espin_Event_Custom_Field_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Event_Custom_Field_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Event_Custom_Field_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.event_custom_field" */
export type Espin_Event_Custom_Field_Aggregate_Fields = {
  __typename?: 'espin_event_custom_field_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Event_Custom_Field_Max_Fields>;
  min?: Maybe<Espin_Event_Custom_Field_Min_Fields>;
};


/** aggregate fields of "espin.event_custom_field" */
export type Espin_Event_Custom_Field_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Event_Custom_Field_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.event_custom_field" */
export type Espin_Event_Custom_Field_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Event_Custom_Field_Max_Order_By>;
  min?: InputMaybe<Espin_Event_Custom_Field_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.event_custom_field" */
export type Espin_Event_Custom_Field_Arr_Rel_Insert_Input = {
  data: Array<Espin_Event_Custom_Field_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Event_Custom_Field_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.event_custom_field". All fields are combined with a logical 'AND'. */
export type Espin_Event_Custom_Field_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Event_Custom_Field_Bool_Exp>>;
  _not?: InputMaybe<Espin_Event_Custom_Field_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Event_Custom_Field_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  default_value?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  field_type?: InputMaybe<Espin_Event_Custom_Field_Type_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.event_custom_field" */
export enum Espin_Event_Custom_Field_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomFieldPkey = 'custom_field_pkey'
}

/** input type for inserting data into table "espin.event_custom_field" */
export type Espin_Event_Custom_Field_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  default_value?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  field_type?: InputMaybe<Espin_Event_Custom_Field_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Espin_Event_Custom_Field_Max_Fields = {
  __typename?: 'espin_event_custom_field_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  default_value?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "espin.event_custom_field" */
export type Espin_Event_Custom_Field_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_value?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Event_Custom_Field_Min_Fields = {
  __typename?: 'espin_event_custom_field_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  default_value?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "espin.event_custom_field" */
export type Espin_Event_Custom_Field_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_value?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.event_custom_field" */
export type Espin_Event_Custom_Field_Mutation_Response = {
  __typename?: 'espin_event_custom_field_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Event_Custom_Field>;
};

/** input type for inserting object relation for remote table "espin.event_custom_field" */
export type Espin_Event_Custom_Field_Obj_Rel_Insert_Input = {
  data: Espin_Event_Custom_Field_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Event_Custom_Field_On_Conflict>;
};

/** on_conflict condition type for table "espin.event_custom_field" */
export type Espin_Event_Custom_Field_On_Conflict = {
  constraint: Espin_Event_Custom_Field_Constraint;
  update_columns?: Array<Espin_Event_Custom_Field_Update_Column>;
  where?: InputMaybe<Espin_Event_Custom_Field_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.event_custom_field". */
export type Espin_Event_Custom_Field_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_value?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.event_custom_field */
export type Espin_Event_Custom_Field_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.event_custom_field" */
export enum Espin_Event_Custom_Field_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultValue = 'default_value',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "espin.event_custom_field" */
export type Espin_Event_Custom_Field_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  default_value?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  field_type?: InputMaybe<Espin_Event_Custom_Field_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "espin_event_custom_field" */
export type Espin_Event_Custom_Field_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Event_Custom_Field_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Event_Custom_Field_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  default_value?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  field_type?: InputMaybe<Espin_Event_Custom_Field_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Enum for custom fields for forms in espin */
export type Espin_Event_Custom_Field_Type = {
  __typename?: 'espin_event_custom_field_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.event_custom_field_type" */
export type Espin_Event_Custom_Field_Type_Aggregate = {
  __typename?: 'espin_event_custom_field_type_aggregate';
  aggregate?: Maybe<Espin_Event_Custom_Field_Type_Aggregate_Fields>;
  nodes: Array<Espin_Event_Custom_Field_Type>;
};

/** aggregate fields of "espin.event_custom_field_type" */
export type Espin_Event_Custom_Field_Type_Aggregate_Fields = {
  __typename?: 'espin_event_custom_field_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Event_Custom_Field_Type_Max_Fields>;
  min?: Maybe<Espin_Event_Custom_Field_Type_Min_Fields>;
};


/** aggregate fields of "espin.event_custom_field_type" */
export type Espin_Event_Custom_Field_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Event_Custom_Field_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.event_custom_field_type". All fields are combined with a logical 'AND'. */
export type Espin_Event_Custom_Field_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Event_Custom_Field_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_Event_Custom_Field_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Event_Custom_Field_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.event_custom_field_type" */
export enum Espin_Event_Custom_Field_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  CustomFieldTypePkey = 'custom_field_type_pkey'
}

export enum Espin_Event_Custom_Field_Type_Enum {
  /** Input checkbox field */
  Checkbox = 'checkbox',
  /** Input text field */
  Text = 'text',
  /** Input textarea field */
  Textarea = 'textarea'
}

/** Boolean expression to compare columns of type "espin_event_custom_field_type_enum". All fields are combined with logical 'AND'. */
export type Espin_Event_Custom_Field_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Event_Custom_Field_Type_Enum>;
  _in?: InputMaybe<Array<Espin_Event_Custom_Field_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Event_Custom_Field_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_Event_Custom_Field_Type_Enum>>;
};

/** input type for inserting data into table "espin.event_custom_field_type" */
export type Espin_Event_Custom_Field_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Event_Custom_Field_Type_Max_Fields = {
  __typename?: 'espin_event_custom_field_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Event_Custom_Field_Type_Min_Fields = {
  __typename?: 'espin_event_custom_field_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.event_custom_field_type" */
export type Espin_Event_Custom_Field_Type_Mutation_Response = {
  __typename?: 'espin_event_custom_field_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Event_Custom_Field_Type>;
};

/** on_conflict condition type for table "espin.event_custom_field_type" */
export type Espin_Event_Custom_Field_Type_On_Conflict = {
  constraint: Espin_Event_Custom_Field_Type_Constraint;
  update_columns?: Array<Espin_Event_Custom_Field_Type_Update_Column>;
  where?: InputMaybe<Espin_Event_Custom_Field_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.event_custom_field_type". */
export type Espin_Event_Custom_Field_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.event_custom_field_type */
export type Espin_Event_Custom_Field_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.event_custom_field_type" */
export enum Espin_Event_Custom_Field_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.event_custom_field_type" */
export type Espin_Event_Custom_Field_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_event_custom_field_type" */
export type Espin_Event_Custom_Field_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Event_Custom_Field_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Event_Custom_Field_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.event_custom_field_type" */
export enum Espin_Event_Custom_Field_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Event_Custom_Field_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Event_Custom_Field_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Event_Custom_Field_Type_Bool_Exp;
};

/** update columns of table "espin.event_custom_field" */
export enum Espin_Event_Custom_Field_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultValue = 'default_value',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Espin_Event_Custom_Field_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Event_Custom_Field_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Event_Custom_Field_Bool_Exp;
};

/** columns and relationships of "espin.event_document" */
export type Espin_Event_Document = {
  __typename?: 'espin_event_document';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_on: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Espin_Event;
  event_id: Scalars['uuid'];
  /** An object relationship */
  file?: Maybe<Content_File>;
  file_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "espin.event_document" */
export type Espin_Event_Document_Aggregate = {
  __typename?: 'espin_event_document_aggregate';
  aggregate?: Maybe<Espin_Event_Document_Aggregate_Fields>;
  nodes: Array<Espin_Event_Document>;
};

export type Espin_Event_Document_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Event_Document_Aggregate_Bool_Exp_Count>;
};

export type Espin_Event_Document_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Event_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Event_Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.event_document" */
export type Espin_Event_Document_Aggregate_Fields = {
  __typename?: 'espin_event_document_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Event_Document_Max_Fields>;
  min?: Maybe<Espin_Event_Document_Min_Fields>;
};


/** aggregate fields of "espin.event_document" */
export type Espin_Event_Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Event_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.event_document" */
export type Espin_Event_Document_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Event_Document_Max_Order_By>;
  min?: InputMaybe<Espin_Event_Document_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.event_document" */
export type Espin_Event_Document_Arr_Rel_Insert_Input = {
  data: Array<Espin_Event_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Event_Document_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.event_document". All fields are combined with a logical 'AND'. */
export type Espin_Event_Document_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Event_Document_Bool_Exp>>;
  _not?: InputMaybe<Espin_Event_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Event_Document_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Espin_Event_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Content_File_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.event_document" */
export enum Espin_Event_Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventDocumentsPkey = 'event_documents_pkey'
}

/** input type for inserting data into table "espin.event_document" */
export type Espin_Event_Document_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_on?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<Espin_Event_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['uuid']>;
  file?: InputMaybe<Content_File_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Espin_Event_Document_Max_Fields = {
  __typename?: 'espin_event_document_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_on?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "espin.event_document" */
export type Espin_Event_Document_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_on?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Event_Document_Min_Fields = {
  __typename?: 'espin_event_document_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_on?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "espin.event_document" */
export type Espin_Event_Document_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_on?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.event_document" */
export type Espin_Event_Document_Mutation_Response = {
  __typename?: 'espin_event_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Event_Document>;
};

/** input type for inserting object relation for remote table "espin.event_document" */
export type Espin_Event_Document_Obj_Rel_Insert_Input = {
  data: Espin_Event_Document_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Event_Document_On_Conflict>;
};

/** on_conflict condition type for table "espin.event_document" */
export type Espin_Event_Document_On_Conflict = {
  constraint: Espin_Event_Document_Constraint;
  update_columns?: Array<Espin_Event_Document_Update_Column>;
  where?: InputMaybe<Espin_Event_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.event_document". */
export type Espin_Event_Document_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_on?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Espin_Event_Order_By>;
  event_id?: InputMaybe<Order_By>;
  file?: InputMaybe<Content_File_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.event_document */
export type Espin_Event_Document_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.event_document" */
export enum Espin_Event_Document_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "espin.event_document" */
export type Espin_Event_Document_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_on?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "espin_event_document" */
export type Espin_Event_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Event_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Event_Document_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_on?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "espin.event_document" */
export enum Espin_Event_Document_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Espin_Event_Document_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Event_Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Event_Document_Bool_Exp;
};

/** columns and relationships of "espin.event_game" */
export type Espin_Event_Game = {
  __typename?: 'espin_event_game';
  /** An object relationship */
  event: Espin_Event;
  event_id: Scalars['uuid'];
  /** An object relationship */
  game: Espin_Game;
  game_id: Scalars['String'];
  id: Scalars['uuid'];
};

/** aggregated selection of "espin.event_game" */
export type Espin_Event_Game_Aggregate = {
  __typename?: 'espin_event_game_aggregate';
  aggregate?: Maybe<Espin_Event_Game_Aggregate_Fields>;
  nodes: Array<Espin_Event_Game>;
};

export type Espin_Event_Game_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Event_Game_Aggregate_Bool_Exp_Count>;
};

export type Espin_Event_Game_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Event_Game_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Event_Game_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.event_game" */
export type Espin_Event_Game_Aggregate_Fields = {
  __typename?: 'espin_event_game_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Event_Game_Max_Fields>;
  min?: Maybe<Espin_Event_Game_Min_Fields>;
};


/** aggregate fields of "espin.event_game" */
export type Espin_Event_Game_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Event_Game_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.event_game" */
export type Espin_Event_Game_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Event_Game_Max_Order_By>;
  min?: InputMaybe<Espin_Event_Game_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.event_game" */
export type Espin_Event_Game_Arr_Rel_Insert_Input = {
  data: Array<Espin_Event_Game_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Event_Game_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.event_game". All fields are combined with a logical 'AND'. */
export type Espin_Event_Game_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Event_Game_Bool_Exp>>;
  _not?: InputMaybe<Espin_Event_Game_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Event_Game_Bool_Exp>>;
  event?: InputMaybe<Espin_Event_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  game?: InputMaybe<Espin_Game_Bool_Exp>;
  game_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.event_game" */
export enum Espin_Event_Game_Constraint {
  /** unique or primary key constraint on columns "game_id", "event_id" */
  EventGamesEventIdGameIdKey = 'event_games_event_id_game_id_key',
  /** unique or primary key constraint on columns "id" */
  EventGamesPkey = 'event_games_pkey'
}

/** input type for inserting data into table "espin.event_game" */
export type Espin_Event_Game_Insert_Input = {
  event?: InputMaybe<Espin_Event_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['uuid']>;
  game?: InputMaybe<Espin_Game_Obj_Rel_Insert_Input>;
  game_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Espin_Event_Game_Max_Fields = {
  __typename?: 'espin_event_game_max_fields';
  event_id?: Maybe<Scalars['uuid']>;
  game_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "espin.event_game" */
export type Espin_Event_Game_Max_Order_By = {
  event_id?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Event_Game_Min_Fields = {
  __typename?: 'espin_event_game_min_fields';
  event_id?: Maybe<Scalars['uuid']>;
  game_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "espin.event_game" */
export type Espin_Event_Game_Min_Order_By = {
  event_id?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.event_game" */
export type Espin_Event_Game_Mutation_Response = {
  __typename?: 'espin_event_game_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Event_Game>;
};

/** on_conflict condition type for table "espin.event_game" */
export type Espin_Event_Game_On_Conflict = {
  constraint: Espin_Event_Game_Constraint;
  update_columns?: Array<Espin_Event_Game_Update_Column>;
  where?: InputMaybe<Espin_Event_Game_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.event_game". */
export type Espin_Event_Game_Order_By = {
  event?: InputMaybe<Espin_Event_Order_By>;
  event_id?: InputMaybe<Order_By>;
  game?: InputMaybe<Espin_Game_Order_By>;
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.event_game */
export type Espin_Event_Game_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.event_game" */
export enum Espin_Event_Game_Select_Column {
  /** column name */
  EventId = 'event_id',
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "espin.event_game" */
export type Espin_Event_Game_Set_Input = {
  event_id?: InputMaybe<Scalars['uuid']>;
  game_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "espin_event_game" */
export type Espin_Event_Game_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Event_Game_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Event_Game_Stream_Cursor_Value_Input = {
  event_id?: InputMaybe<Scalars['uuid']>;
  game_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "espin.event_game" */
export enum Espin_Event_Game_Update_Column {
  /** column name */
  EventId = 'event_id',
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id'
}

export type Espin_Event_Game_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Event_Game_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Event_Game_Bool_Exp;
};

/** input type for incrementing numeric columns in table "espin.event" */
export type Espin_Event_Inc_Input = {
  prize?: InputMaybe<Scalars['numeric']>;
  stickied?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.event" */
export type Espin_Event_Insert_Input = {
  admin_recommended?: InputMaybe<Scalars['Boolean']>;
  body_content?: InputMaybe<Scalars['String']>;
  event_custom_fields?: InputMaybe<Espin_Event_Custom_Field_Arr_Rel_Insert_Input>;
  event_documents?: InputMaybe<Espin_Event_Document_Arr_Rel_Insert_Input>;
  event_end_date?: InputMaybe<Scalars['timestamptz']>;
  event_games?: InputMaybe<Espin_Event_Game_Arr_Rel_Insert_Input>;
  event_registrations?: InputMaybe<Espin_Event_Registration_Arr_Rel_Insert_Input>;
  event_start_date?: InputMaybe<Scalars['timestamptz']>;
  event_status?: InputMaybe<Content_Status_Obj_Rel_Insert_Input>;
  event_tickets?: InputMaybe<Espin_Event_Ticket_Arr_Rel_Insert_Input>;
  icon?: InputMaybe<Content_File_Obj_Rel_Insert_Input>;
  icon_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  logo?: InputMaybe<Content_File_Obj_Rel_Insert_Input>;
  logo_id?: InputMaybe<Scalars['uuid']>;
  migration_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  prize?: InputMaybe<Scalars['numeric']>;
  register_end_date?: InputMaybe<Scalars['timestamptz']>;
  register_start_date?: InputMaybe<Scalars['timestamptz']>;
  registration_disclaimer?: InputMaybe<Scalars['String']>;
  rules_content?: InputMaybe<Scalars['String']>;
  rules_link?: InputMaybe<Scalars['String']>;
  short_description?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Content_Status_Enum>;
  stickied?: InputMaybe<Scalars['Int']>;
  stream_url?: InputMaybe<Scalars['String']>;
  success_page?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Espin_Event_Type_Enum>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Event_Max_Fields = {
  __typename?: 'espin_event_max_fields';
  body_content?: Maybe<Scalars['String']>;
  event_end_date?: Maybe<Scalars['timestamptz']>;
  event_start_date?: Maybe<Scalars['timestamptz']>;
  icon_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  logo_id?: Maybe<Scalars['uuid']>;
  migration_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  prize?: Maybe<Scalars['numeric']>;
  register_end_date?: Maybe<Scalars['timestamptz']>;
  register_start_date?: Maybe<Scalars['timestamptz']>;
  registration_disclaimer?: Maybe<Scalars['String']>;
  rules_content?: Maybe<Scalars['String']>;
  rules_link?: Maybe<Scalars['String']>;
  short_description?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  stickied?: Maybe<Scalars['Int']>;
  stream_url?: Maybe<Scalars['String']>;
  success_page?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Event_Min_Fields = {
  __typename?: 'espin_event_min_fields';
  body_content?: Maybe<Scalars['String']>;
  event_end_date?: Maybe<Scalars['timestamptz']>;
  event_start_date?: Maybe<Scalars['timestamptz']>;
  icon_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  logo_id?: Maybe<Scalars['uuid']>;
  migration_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  prize?: Maybe<Scalars['numeric']>;
  register_end_date?: Maybe<Scalars['timestamptz']>;
  register_start_date?: Maybe<Scalars['timestamptz']>;
  registration_disclaimer?: Maybe<Scalars['String']>;
  rules_content?: Maybe<Scalars['String']>;
  rules_link?: Maybe<Scalars['String']>;
  short_description?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  stickied?: Maybe<Scalars['Int']>;
  stream_url?: Maybe<Scalars['String']>;
  success_page?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.event" */
export type Espin_Event_Mutation_Response = {
  __typename?: 'espin_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Event>;
};

/** input type for inserting object relation for remote table "espin.event" */
export type Espin_Event_Obj_Rel_Insert_Input = {
  data: Espin_Event_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Event_On_Conflict>;
};

/** on_conflict condition type for table "espin.event" */
export type Espin_Event_On_Conflict = {
  constraint: Espin_Event_Constraint;
  update_columns?: Array<Espin_Event_Update_Column>;
  where?: InputMaybe<Espin_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.event". */
export type Espin_Event_Order_By = {
  admin_recommended?: InputMaybe<Order_By>;
  body_content?: InputMaybe<Order_By>;
  event_custom_fields_aggregate?: InputMaybe<Espin_Event_Custom_Field_Aggregate_Order_By>;
  event_documents_aggregate?: InputMaybe<Espin_Event_Document_Aggregate_Order_By>;
  event_end_date?: InputMaybe<Order_By>;
  event_games_aggregate?: InputMaybe<Espin_Event_Game_Aggregate_Order_By>;
  event_registrations_aggregate?: InputMaybe<Espin_Event_Registration_Aggregate_Order_By>;
  event_start_date?: InputMaybe<Order_By>;
  event_status?: InputMaybe<Content_Status_Order_By>;
  event_tickets_aggregate?: InputMaybe<Espin_Event_Ticket_Aggregate_Order_By>;
  icon?: InputMaybe<Content_File_Order_By>;
  icon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Content_File_Order_By>;
  logo_id?: InputMaybe<Order_By>;
  migration_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  prize?: InputMaybe<Order_By>;
  register_end_date?: InputMaybe<Order_By>;
  register_start_date?: InputMaybe<Order_By>;
  registration_disclaimer?: InputMaybe<Order_By>;
  rules_content?: InputMaybe<Order_By>;
  rules_link?: InputMaybe<Order_By>;
  short_description?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stickied?: InputMaybe<Order_By>;
  stream_url?: InputMaybe<Order_By>;
  success_page?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.event */
export type Espin_Event_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "espin.event_registration" */
export type Espin_Event_Registration = {
  __typename?: 'espin_event_registration';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Espin_Event;
  event_id: Scalars['uuid'];
  /** An array relationship */
  event_registration_custom_field_entries: Array<Espin_Event_Registration_Custom_Field_Entry>;
  /** An aggregate relationship */
  event_registration_custom_field_entries_aggregate: Espin_Event_Registration_Custom_Field_Entry_Aggregate;
  /** An array relationship */
  event_registration_document_signoffs: Array<Espin_Event_Registration_Document_Signoff>;
  /** An aggregate relationship */
  event_registration_document_signoffs_aggregate: Espin_Event_Registration_Document_Signoff_Aggregate;
  /** An object relationship */
  event_ticket: Espin_Event_Ticket;
  id: Scalars['uuid'];
  payment_intent_id?: Maybe<Scalars['String']>;
  /** What they were referred by (YT, Twitch, etc) */
  referred_by?: Maybe<Scalars['String']>;
  /** Team / Individual and discord details */
  registration_details?: Maybe<Scalars['jsonb']>;
  status: Espin_Event_Registration_Status_Enum;
  /** An object relationship */
  team?: Maybe<Espin_Team>;
  team_id?: Maybe<Scalars['uuid']>;
  ticket_id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: Espin_User;
  user_id: Scalars['String'];
};


/** columns and relationships of "espin.event_registration" */
export type Espin_Event_RegistrationEvent_Registration_Custom_Field_EntriesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Bool_Exp>;
};


/** columns and relationships of "espin.event_registration" */
export type Espin_Event_RegistrationEvent_Registration_Custom_Field_Entries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Bool_Exp>;
};


/** columns and relationships of "espin.event_registration" */
export type Espin_Event_RegistrationEvent_Registration_Document_SignoffsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Document_Signoff_Bool_Exp>;
};


/** columns and relationships of "espin.event_registration" */
export type Espin_Event_RegistrationEvent_Registration_Document_Signoffs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Document_Signoff_Bool_Exp>;
};


/** columns and relationships of "espin.event_registration" */
export type Espin_Event_RegistrationRegistration_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "espin.event_registration" */
export type Espin_Event_Registration_Aggregate = {
  __typename?: 'espin_event_registration_aggregate';
  aggregate?: Maybe<Espin_Event_Registration_Aggregate_Fields>;
  nodes: Array<Espin_Event_Registration>;
};

export type Espin_Event_Registration_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Event_Registration_Aggregate_Bool_Exp_Count>;
};

export type Espin_Event_Registration_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Event_Registration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.event_registration" */
export type Espin_Event_Registration_Aggregate_Fields = {
  __typename?: 'espin_event_registration_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Event_Registration_Max_Fields>;
  min?: Maybe<Espin_Event_Registration_Min_Fields>;
};


/** aggregate fields of "espin.event_registration" */
export type Espin_Event_Registration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Event_Registration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.event_registration" */
export type Espin_Event_Registration_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Event_Registration_Max_Order_By>;
  min?: InputMaybe<Espin_Event_Registration_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Espin_Event_Registration_Append_Input = {
  /** Team / Individual and discord details */
  registration_details?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "espin.event_registration" */
export type Espin_Event_Registration_Arr_Rel_Insert_Input = {
  data: Array<Espin_Event_Registration_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Event_Registration_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.event_registration". All fields are combined with a logical 'AND'. */
export type Espin_Event_Registration_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Event_Registration_Bool_Exp>>;
  _not?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Event_Registration_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Espin_Event_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  event_registration_custom_field_entries?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Bool_Exp>;
  event_registration_custom_field_entries_aggregate?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Aggregate_Bool_Exp>;
  event_registration_document_signoffs?: InputMaybe<Espin_Event_Registration_Document_Signoff_Bool_Exp>;
  event_registration_document_signoffs_aggregate?: InputMaybe<Espin_Event_Registration_Document_Signoff_Aggregate_Bool_Exp>;
  event_ticket?: InputMaybe<Espin_Event_Ticket_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_intent_id?: InputMaybe<String_Comparison_Exp>;
  referred_by?: InputMaybe<String_Comparison_Exp>;
  registration_details?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<Espin_Event_Registration_Status_Enum_Comparison_Exp>;
  team?: InputMaybe<Espin_Team_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  ticket_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Espin_User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.event_registration" */
export enum Espin_Event_Registration_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventRegistrationPkey = 'event_registration_pkey'
}

/** Field to record event registration data from custom fields */
export type Espin_Event_Registration_Custom_Field_Entry = {
  __typename?: 'espin_event_registration_custom_field_entry';
  /** An object relationship */
  custom_field: Espin_Event_Custom_Field;
  custom_field_id: Scalars['uuid'];
  /** An object relationship */
  event_registration: Espin_Event_Registration;
  event_registration_id: Scalars['uuid'];
  id: Scalars['uuid'];
  value: Scalars['String'];
};

/** aggregated selection of "espin.event_registration_custom_field_entry" */
export type Espin_Event_Registration_Custom_Field_Entry_Aggregate = {
  __typename?: 'espin_event_registration_custom_field_entry_aggregate';
  aggregate?: Maybe<Espin_Event_Registration_Custom_Field_Entry_Aggregate_Fields>;
  nodes: Array<Espin_Event_Registration_Custom_Field_Entry>;
};

export type Espin_Event_Registration_Custom_Field_Entry_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Aggregate_Bool_Exp_Count>;
};

export type Espin_Event_Registration_Custom_Field_Entry_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.event_registration_custom_field_entry" */
export type Espin_Event_Registration_Custom_Field_Entry_Aggregate_Fields = {
  __typename?: 'espin_event_registration_custom_field_entry_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Event_Registration_Custom_Field_Entry_Max_Fields>;
  min?: Maybe<Espin_Event_Registration_Custom_Field_Entry_Min_Fields>;
};


/** aggregate fields of "espin.event_registration_custom_field_entry" */
export type Espin_Event_Registration_Custom_Field_Entry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.event_registration_custom_field_entry" */
export type Espin_Event_Registration_Custom_Field_Entry_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Max_Order_By>;
  min?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.event_registration_custom_field_entry" */
export type Espin_Event_Registration_Custom_Field_Entry_Arr_Rel_Insert_Input = {
  data: Array<Espin_Event_Registration_Custom_Field_Entry_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.event_registration_custom_field_entry". All fields are combined with a logical 'AND'. */
export type Espin_Event_Registration_Custom_Field_Entry_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Bool_Exp>>;
  _not?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Bool_Exp>>;
  custom_field?: InputMaybe<Espin_Event_Custom_Field_Bool_Exp>;
  custom_field_id?: InputMaybe<Uuid_Comparison_Exp>;
  event_registration?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
  event_registration_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.event_registration_custom_field_entry" */
export enum Espin_Event_Registration_Custom_Field_Entry_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventRegistrationCustomFieldEntryPkey = 'event_registration_custom_field_entry_pkey'
}

/** input type for inserting data into table "espin.event_registration_custom_field_entry" */
export type Espin_Event_Registration_Custom_Field_Entry_Insert_Input = {
  custom_field?: InputMaybe<Espin_Event_Custom_Field_Obj_Rel_Insert_Input>;
  custom_field_id?: InputMaybe<Scalars['uuid']>;
  event_registration?: InputMaybe<Espin_Event_Registration_Obj_Rel_Insert_Input>;
  event_registration_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Event_Registration_Custom_Field_Entry_Max_Fields = {
  __typename?: 'espin_event_registration_custom_field_entry_max_fields';
  custom_field_id?: Maybe<Scalars['uuid']>;
  event_registration_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.event_registration_custom_field_entry" */
export type Espin_Event_Registration_Custom_Field_Entry_Max_Order_By = {
  custom_field_id?: InputMaybe<Order_By>;
  event_registration_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Event_Registration_Custom_Field_Entry_Min_Fields = {
  __typename?: 'espin_event_registration_custom_field_entry_min_fields';
  custom_field_id?: Maybe<Scalars['uuid']>;
  event_registration_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.event_registration_custom_field_entry" */
export type Espin_Event_Registration_Custom_Field_Entry_Min_Order_By = {
  custom_field_id?: InputMaybe<Order_By>;
  event_registration_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.event_registration_custom_field_entry" */
export type Espin_Event_Registration_Custom_Field_Entry_Mutation_Response = {
  __typename?: 'espin_event_registration_custom_field_entry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Event_Registration_Custom_Field_Entry>;
};

/** on_conflict condition type for table "espin.event_registration_custom_field_entry" */
export type Espin_Event_Registration_Custom_Field_Entry_On_Conflict = {
  constraint: Espin_Event_Registration_Custom_Field_Entry_Constraint;
  update_columns?: Array<Espin_Event_Registration_Custom_Field_Entry_Update_Column>;
  where?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.event_registration_custom_field_entry". */
export type Espin_Event_Registration_Custom_Field_Entry_Order_By = {
  custom_field?: InputMaybe<Espin_Event_Custom_Field_Order_By>;
  custom_field_id?: InputMaybe<Order_By>;
  event_registration?: InputMaybe<Espin_Event_Registration_Order_By>;
  event_registration_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.event_registration_custom_field_entry */
export type Espin_Event_Registration_Custom_Field_Entry_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.event_registration_custom_field_entry" */
export enum Espin_Event_Registration_Custom_Field_Entry_Select_Column {
  /** column name */
  CustomFieldId = 'custom_field_id',
  /** column name */
  EventRegistrationId = 'event_registration_id',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "espin.event_registration_custom_field_entry" */
export type Espin_Event_Registration_Custom_Field_Entry_Set_Input = {
  custom_field_id?: InputMaybe<Scalars['uuid']>;
  event_registration_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_event_registration_custom_field_entry" */
export type Espin_Event_Registration_Custom_Field_Entry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Event_Registration_Custom_Field_Entry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Event_Registration_Custom_Field_Entry_Stream_Cursor_Value_Input = {
  custom_field_id?: InputMaybe<Scalars['uuid']>;
  event_registration_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.event_registration_custom_field_entry" */
export enum Espin_Event_Registration_Custom_Field_Entry_Update_Column {
  /** column name */
  CustomFieldId = 'custom_field_id',
  /** column name */
  EventRegistrationId = 'event_registration_id',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value'
}

export type Espin_Event_Registration_Custom_Field_Entry_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Event_Registration_Custom_Field_Entry_Bool_Exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Espin_Event_Registration_Delete_At_Path_Input = {
  /** Team / Individual and discord details */
  registration_details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Espin_Event_Registration_Delete_Elem_Input = {
  /** Team / Individual and discord details */
  registration_details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Espin_Event_Registration_Delete_Key_Input = {
  /** Team / Individual and discord details */
  registration_details?: InputMaybe<Scalars['String']>;
};

/** Listing of signed off documents on an event registration */
export type Espin_Event_Registration_Document_Signoff = {
  __typename?: 'espin_event_registration_document_signoff';
  /** An object relationship */
  event_document: Espin_Event_Document;
  event_document_id: Scalars['uuid'];
  /** An object relationship */
  event_registration: Espin_Event_Registration;
  event_registration_id: Scalars['uuid'];
  id: Scalars['uuid'];
  value: Scalars['Boolean'];
};

/** aggregated selection of "espin.event_registration_document_signoff" */
export type Espin_Event_Registration_Document_Signoff_Aggregate = {
  __typename?: 'espin_event_registration_document_signoff_aggregate';
  aggregate?: Maybe<Espin_Event_Registration_Document_Signoff_Aggregate_Fields>;
  nodes: Array<Espin_Event_Registration_Document_Signoff>;
};

export type Espin_Event_Registration_Document_Signoff_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Espin_Event_Registration_Document_Signoff_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Espin_Event_Registration_Document_Signoff_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Espin_Event_Registration_Document_Signoff_Aggregate_Bool_Exp_Count>;
};

export type Espin_Event_Registration_Document_Signoff_Aggregate_Bool_Exp_Bool_And = {
  arguments: Espin_Event_Registration_Document_Signoff_Select_Column_Espin_Event_Registration_Document_Signoff_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Event_Registration_Document_Signoff_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_Event_Registration_Document_Signoff_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Espin_Event_Registration_Document_Signoff_Select_Column_Espin_Event_Registration_Document_Signoff_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Event_Registration_Document_Signoff_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_Event_Registration_Document_Signoff_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Event_Registration_Document_Signoff_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.event_registration_document_signoff" */
export type Espin_Event_Registration_Document_Signoff_Aggregate_Fields = {
  __typename?: 'espin_event_registration_document_signoff_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Event_Registration_Document_Signoff_Max_Fields>;
  min?: Maybe<Espin_Event_Registration_Document_Signoff_Min_Fields>;
};


/** aggregate fields of "espin.event_registration_document_signoff" */
export type Espin_Event_Registration_Document_Signoff_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.event_registration_document_signoff" */
export type Espin_Event_Registration_Document_Signoff_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Event_Registration_Document_Signoff_Max_Order_By>;
  min?: InputMaybe<Espin_Event_Registration_Document_Signoff_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.event_registration_document_signoff" */
export type Espin_Event_Registration_Document_Signoff_Arr_Rel_Insert_Input = {
  data: Array<Espin_Event_Registration_Document_Signoff_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Event_Registration_Document_Signoff_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.event_registration_document_signoff". All fields are combined with a logical 'AND'. */
export type Espin_Event_Registration_Document_Signoff_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Bool_Exp>>;
  _not?: InputMaybe<Espin_Event_Registration_Document_Signoff_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Bool_Exp>>;
  event_document?: InputMaybe<Espin_Event_Document_Bool_Exp>;
  event_document_id?: InputMaybe<Uuid_Comparison_Exp>;
  event_registration?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
  event_registration_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.event_registration_document_signoff" */
export enum Espin_Event_Registration_Document_Signoff_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventRegistrationDocumentSignoffPkey = 'event_registration_document_signoff_pkey'
}

/** input type for inserting data into table "espin.event_registration_document_signoff" */
export type Espin_Event_Registration_Document_Signoff_Insert_Input = {
  event_document?: InputMaybe<Espin_Event_Document_Obj_Rel_Insert_Input>;
  event_document_id?: InputMaybe<Scalars['uuid']>;
  event_registration?: InputMaybe<Espin_Event_Registration_Obj_Rel_Insert_Input>;
  event_registration_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Espin_Event_Registration_Document_Signoff_Max_Fields = {
  __typename?: 'espin_event_registration_document_signoff_max_fields';
  event_document_id?: Maybe<Scalars['uuid']>;
  event_registration_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "espin.event_registration_document_signoff" */
export type Espin_Event_Registration_Document_Signoff_Max_Order_By = {
  event_document_id?: InputMaybe<Order_By>;
  event_registration_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Event_Registration_Document_Signoff_Min_Fields = {
  __typename?: 'espin_event_registration_document_signoff_min_fields';
  event_document_id?: Maybe<Scalars['uuid']>;
  event_registration_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "espin.event_registration_document_signoff" */
export type Espin_Event_Registration_Document_Signoff_Min_Order_By = {
  event_document_id?: InputMaybe<Order_By>;
  event_registration_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.event_registration_document_signoff" */
export type Espin_Event_Registration_Document_Signoff_Mutation_Response = {
  __typename?: 'espin_event_registration_document_signoff_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Event_Registration_Document_Signoff>;
};

/** on_conflict condition type for table "espin.event_registration_document_signoff" */
export type Espin_Event_Registration_Document_Signoff_On_Conflict = {
  constraint: Espin_Event_Registration_Document_Signoff_Constraint;
  update_columns?: Array<Espin_Event_Registration_Document_Signoff_Update_Column>;
  where?: InputMaybe<Espin_Event_Registration_Document_Signoff_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.event_registration_document_signoff". */
export type Espin_Event_Registration_Document_Signoff_Order_By = {
  event_document?: InputMaybe<Espin_Event_Document_Order_By>;
  event_document_id?: InputMaybe<Order_By>;
  event_registration?: InputMaybe<Espin_Event_Registration_Order_By>;
  event_registration_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.event_registration_document_signoff */
export type Espin_Event_Registration_Document_Signoff_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.event_registration_document_signoff" */
export enum Espin_Event_Registration_Document_Signoff_Select_Column {
  /** column name */
  EventDocumentId = 'event_document_id',
  /** column name */
  EventRegistrationId = 'event_registration_id',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value'
}

/** select "espin_event_registration_document_signoff_aggregate_bool_exp_bool_and_arguments_columns" columns of table "espin.event_registration_document_signoff" */
export enum Espin_Event_Registration_Document_Signoff_Select_Column_Espin_Event_Registration_Document_Signoff_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "espin_event_registration_document_signoff_aggregate_bool_exp_bool_or_arguments_columns" columns of table "espin.event_registration_document_signoff" */
export enum Espin_Event_Registration_Document_Signoff_Select_Column_Espin_Event_Registration_Document_Signoff_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "espin.event_registration_document_signoff" */
export type Espin_Event_Registration_Document_Signoff_Set_Input = {
  event_document_id?: InputMaybe<Scalars['uuid']>;
  event_registration_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "espin_event_registration_document_signoff" */
export type Espin_Event_Registration_Document_Signoff_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Event_Registration_Document_Signoff_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Event_Registration_Document_Signoff_Stream_Cursor_Value_Input = {
  event_document_id?: InputMaybe<Scalars['uuid']>;
  event_registration_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "espin.event_registration_document_signoff" */
export enum Espin_Event_Registration_Document_Signoff_Update_Column {
  /** column name */
  EventDocumentId = 'event_document_id',
  /** column name */
  EventRegistrationId = 'event_registration_id',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value'
}

export type Espin_Event_Registration_Document_Signoff_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Event_Registration_Document_Signoff_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Event_Registration_Document_Signoff_Bool_Exp;
};

/** input type for inserting data into table "espin.event_registration" */
export type Espin_Event_Registration_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<Espin_Event_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['uuid']>;
  event_registration_custom_field_entries?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Arr_Rel_Insert_Input>;
  event_registration_document_signoffs?: InputMaybe<Espin_Event_Registration_Document_Signoff_Arr_Rel_Insert_Input>;
  event_ticket?: InputMaybe<Espin_Event_Ticket_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  payment_intent_id?: InputMaybe<Scalars['String']>;
  /** What they were referred by (YT, Twitch, etc) */
  referred_by?: InputMaybe<Scalars['String']>;
  /** Team / Individual and discord details */
  registration_details?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Espin_Event_Registration_Status_Enum>;
  team?: InputMaybe<Espin_Team_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']>;
  ticket_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Event_Registration_Max_Fields = {
  __typename?: 'espin_event_registration_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  payment_intent_id?: Maybe<Scalars['String']>;
  /** What they were referred by (YT, Twitch, etc) */
  referred_by?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['uuid']>;
  ticket_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.event_registration" */
export type Espin_Event_Registration_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_intent_id?: InputMaybe<Order_By>;
  /** What they were referred by (YT, Twitch, etc) */
  referred_by?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Event_Registration_Min_Fields = {
  __typename?: 'espin_event_registration_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  payment_intent_id?: Maybe<Scalars['String']>;
  /** What they were referred by (YT, Twitch, etc) */
  referred_by?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['uuid']>;
  ticket_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.event_registration" */
export type Espin_Event_Registration_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_intent_id?: InputMaybe<Order_By>;
  /** What they were referred by (YT, Twitch, etc) */
  referred_by?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.event_registration" */
export type Espin_Event_Registration_Mutation_Response = {
  __typename?: 'espin_event_registration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Event_Registration>;
};

/** input type for inserting object relation for remote table "espin.event_registration" */
export type Espin_Event_Registration_Obj_Rel_Insert_Input = {
  data: Espin_Event_Registration_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Event_Registration_On_Conflict>;
};

/** on_conflict condition type for table "espin.event_registration" */
export type Espin_Event_Registration_On_Conflict = {
  constraint: Espin_Event_Registration_Constraint;
  update_columns?: Array<Espin_Event_Registration_Update_Column>;
  where?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.event_registration". */
export type Espin_Event_Registration_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Espin_Event_Order_By>;
  event_id?: InputMaybe<Order_By>;
  event_registration_custom_field_entries_aggregate?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Aggregate_Order_By>;
  event_registration_document_signoffs_aggregate?: InputMaybe<Espin_Event_Registration_Document_Signoff_Aggregate_Order_By>;
  event_ticket?: InputMaybe<Espin_Event_Ticket_Order_By>;
  id?: InputMaybe<Order_By>;
  payment_intent_id?: InputMaybe<Order_By>;
  referred_by?: InputMaybe<Order_By>;
  registration_details?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  team?: InputMaybe<Espin_Team_Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Espin_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.event_registration */
export type Espin_Event_Registration_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Espin_Event_Registration_Prepend_Input = {
  /** Team / Individual and discord details */
  registration_details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "espin.event_registration" */
export enum Espin_Event_Registration_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentIntentId = 'payment_intent_id',
  /** column name */
  ReferredBy = 'referred_by',
  /** column name */
  RegistrationDetails = 'registration_details',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TicketId = 'ticket_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "espin.event_registration" */
export type Espin_Event_Registration_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  payment_intent_id?: InputMaybe<Scalars['String']>;
  /** What they were referred by (YT, Twitch, etc) */
  referred_by?: InputMaybe<Scalars['String']>;
  /** Team / Individual and discord details */
  registration_details?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Espin_Event_Registration_Status_Enum>;
  team_id?: InputMaybe<Scalars['uuid']>;
  ticket_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** Event registration status enum */
export type Espin_Event_Registration_Status = {
  __typename?: 'espin_event_registration_status';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.event_registration_status" */
export type Espin_Event_Registration_Status_Aggregate = {
  __typename?: 'espin_event_registration_status_aggregate';
  aggregate?: Maybe<Espin_Event_Registration_Status_Aggregate_Fields>;
  nodes: Array<Espin_Event_Registration_Status>;
};

/** aggregate fields of "espin.event_registration_status" */
export type Espin_Event_Registration_Status_Aggregate_Fields = {
  __typename?: 'espin_event_registration_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Event_Registration_Status_Max_Fields>;
  min?: Maybe<Espin_Event_Registration_Status_Min_Fields>;
};


/** aggregate fields of "espin.event_registration_status" */
export type Espin_Event_Registration_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Event_Registration_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.event_registration_status". All fields are combined with a logical 'AND'. */
export type Espin_Event_Registration_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Event_Registration_Status_Bool_Exp>>;
  _not?: InputMaybe<Espin_Event_Registration_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Event_Registration_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.event_registration_status" */
export enum Espin_Event_Registration_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  EventRegistrationStatusPkey = 'event_registration_status_pkey'
}

export enum Espin_Event_Registration_Status_Enum {
  /** Payment received + reg done */
  Confirmed = 'confirmed',
  /** Created by player, needs payment (if there is payment required) */
  PendingPayment = 'pending_payment'
}

/** Boolean expression to compare columns of type "espin_event_registration_status_enum". All fields are combined with logical 'AND'. */
export type Espin_Event_Registration_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Event_Registration_Status_Enum>;
  _in?: InputMaybe<Array<Espin_Event_Registration_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Event_Registration_Status_Enum>;
  _nin?: InputMaybe<Array<Espin_Event_Registration_Status_Enum>>;
};

/** input type for inserting data into table "espin.event_registration_status" */
export type Espin_Event_Registration_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Event_Registration_Status_Max_Fields = {
  __typename?: 'espin_event_registration_status_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Event_Registration_Status_Min_Fields = {
  __typename?: 'espin_event_registration_status_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.event_registration_status" */
export type Espin_Event_Registration_Status_Mutation_Response = {
  __typename?: 'espin_event_registration_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Event_Registration_Status>;
};

/** on_conflict condition type for table "espin.event_registration_status" */
export type Espin_Event_Registration_Status_On_Conflict = {
  constraint: Espin_Event_Registration_Status_Constraint;
  update_columns?: Array<Espin_Event_Registration_Status_Update_Column>;
  where?: InputMaybe<Espin_Event_Registration_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.event_registration_status". */
export type Espin_Event_Registration_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.event_registration_status */
export type Espin_Event_Registration_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.event_registration_status" */
export enum Espin_Event_Registration_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.event_registration_status" */
export type Espin_Event_Registration_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_event_registration_status" */
export type Espin_Event_Registration_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Event_Registration_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Event_Registration_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.event_registration_status" */
export enum Espin_Event_Registration_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Event_Registration_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Event_Registration_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Event_Registration_Status_Bool_Exp;
};

/** Streaming cursor of the table "espin_event_registration" */
export type Espin_Event_Registration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Event_Registration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Event_Registration_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  payment_intent_id?: InputMaybe<Scalars['String']>;
  /** What they were referred by (YT, Twitch, etc) */
  referred_by?: InputMaybe<Scalars['String']>;
  /** Team / Individual and discord details */
  registration_details?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Espin_Event_Registration_Status_Enum>;
  team_id?: InputMaybe<Scalars['uuid']>;
  ticket_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.event_registration" */
export enum Espin_Event_Registration_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentIntentId = 'payment_intent_id',
  /** column name */
  ReferredBy = 'referred_by',
  /** column name */
  RegistrationDetails = 'registration_details',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TicketId = 'ticket_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Espin_Event_Registration_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Espin_Event_Registration_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Espin_Event_Registration_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Espin_Event_Registration_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Espin_Event_Registration_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Espin_Event_Registration_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Event_Registration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Event_Registration_Bool_Exp;
};

/** select columns of table "espin.event" */
export enum Espin_Event_Select_Column {
  /** column name */
  AdminRecommended = 'admin_recommended',
  /** column name */
  BodyContent = 'body_content',
  /** column name */
  EventEndDate = 'event_end_date',
  /** column name */
  EventStartDate = 'event_start_date',
  /** column name */
  IconId = 'icon_id',
  /** column name */
  Id = 'id',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  MigrationId = 'migration_id',
  /** column name */
  Name = 'name',
  /** column name */
  Prize = 'prize',
  /** column name */
  RegisterEndDate = 'register_end_date',
  /** column name */
  RegisterStartDate = 'register_start_date',
  /** column name */
  RegistrationDisclaimer = 'registration_disclaimer',
  /** column name */
  RulesContent = 'rules_content',
  /** column name */
  RulesLink = 'rules_link',
  /** column name */
  ShortDescription = 'short_description',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  Stickied = 'stickied',
  /** column name */
  StreamUrl = 'stream_url',
  /** column name */
  SuccessPage = 'success_page',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "espin.event" */
export type Espin_Event_Set_Input = {
  admin_recommended?: InputMaybe<Scalars['Boolean']>;
  body_content?: InputMaybe<Scalars['String']>;
  event_end_date?: InputMaybe<Scalars['timestamptz']>;
  event_start_date?: InputMaybe<Scalars['timestamptz']>;
  icon_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  logo_id?: InputMaybe<Scalars['uuid']>;
  migration_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  prize?: InputMaybe<Scalars['numeric']>;
  register_end_date?: InputMaybe<Scalars['timestamptz']>;
  register_start_date?: InputMaybe<Scalars['timestamptz']>;
  registration_disclaimer?: InputMaybe<Scalars['String']>;
  rules_content?: InputMaybe<Scalars['String']>;
  rules_link?: InputMaybe<Scalars['String']>;
  short_description?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Content_Status_Enum>;
  stickied?: InputMaybe<Scalars['Int']>;
  stream_url?: InputMaybe<Scalars['String']>;
  success_page?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Espin_Event_Type_Enum>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Espin_Event_Stddev_Fields = {
  __typename?: 'espin_event_stddev_fields';
  prize?: Maybe<Scalars['Float']>;
  stickied?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_Event_Stddev_Pop_Fields = {
  __typename?: 'espin_event_stddev_pop_fields';
  prize?: Maybe<Scalars['Float']>;
  stickied?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_Event_Stddev_Samp_Fields = {
  __typename?: 'espin_event_stddev_samp_fields';
  prize?: Maybe<Scalars['Float']>;
  stickied?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_event" */
export type Espin_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Event_Stream_Cursor_Value_Input = {
  admin_recommended?: InputMaybe<Scalars['Boolean']>;
  body_content?: InputMaybe<Scalars['String']>;
  event_end_date?: InputMaybe<Scalars['timestamptz']>;
  event_start_date?: InputMaybe<Scalars['timestamptz']>;
  icon_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  logo_id?: InputMaybe<Scalars['uuid']>;
  migration_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  prize?: InputMaybe<Scalars['numeric']>;
  register_end_date?: InputMaybe<Scalars['timestamptz']>;
  register_start_date?: InputMaybe<Scalars['timestamptz']>;
  registration_disclaimer?: InputMaybe<Scalars['String']>;
  rules_content?: InputMaybe<Scalars['String']>;
  rules_link?: InputMaybe<Scalars['String']>;
  short_description?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Content_Status_Enum>;
  stickied?: InputMaybe<Scalars['Int']>;
  stream_url?: InputMaybe<Scalars['String']>;
  success_page?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Espin_Event_Type_Enum>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Espin_Event_Sum_Fields = {
  __typename?: 'espin_event_sum_fields';
  prize?: Maybe<Scalars['numeric']>;
  stickied?: Maybe<Scalars['Int']>;
};

/** Tickets for an event used to register */
export type Espin_Event_Ticket = {
  __typename?: 'espin_event_ticket';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  event: Espin_Event;
  event_id: Scalars['uuid'];
  /** An array relationship */
  event_registrations: Array<Espin_Event_Registration>;
  /** An aggregate relationship */
  event_registrations_aggregate: Espin_Event_Registration_Aggregate;
  /** An object relationship */
  event_ticket_type: Espin_Event_Ticket_Type;
  /** An object relationship */
  game?: Maybe<Espin_Game>;
  game_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  price_id?: Maybe<Scalars['String']>;
  price_temp: Scalars['numeric'];
  ticket_type: Espin_Event_Ticket_Type_Enum;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** Tickets for an event used to register */
export type Espin_Event_TicketEvent_RegistrationsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
};


/** Tickets for an event used to register */
export type Espin_Event_TicketEvent_Registrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
};

/** aggregated selection of "espin.event_ticket" */
export type Espin_Event_Ticket_Aggregate = {
  __typename?: 'espin_event_ticket_aggregate';
  aggregate?: Maybe<Espin_Event_Ticket_Aggregate_Fields>;
  nodes: Array<Espin_Event_Ticket>;
};

export type Espin_Event_Ticket_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Event_Ticket_Aggregate_Bool_Exp_Count>;
};

export type Espin_Event_Ticket_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Event_Ticket_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Event_Ticket_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.event_ticket" */
export type Espin_Event_Ticket_Aggregate_Fields = {
  __typename?: 'espin_event_ticket_aggregate_fields';
  avg?: Maybe<Espin_Event_Ticket_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Event_Ticket_Max_Fields>;
  min?: Maybe<Espin_Event_Ticket_Min_Fields>;
  stddev?: Maybe<Espin_Event_Ticket_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Event_Ticket_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Event_Ticket_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Event_Ticket_Sum_Fields>;
  var_pop?: Maybe<Espin_Event_Ticket_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Event_Ticket_Var_Samp_Fields>;
  variance?: Maybe<Espin_Event_Ticket_Variance_Fields>;
};


/** aggregate fields of "espin.event_ticket" */
export type Espin_Event_Ticket_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Event_Ticket_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.event_ticket" */
export type Espin_Event_Ticket_Aggregate_Order_By = {
  avg?: InputMaybe<Espin_Event_Ticket_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Event_Ticket_Max_Order_By>;
  min?: InputMaybe<Espin_Event_Ticket_Min_Order_By>;
  stddev?: InputMaybe<Espin_Event_Ticket_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Espin_Event_Ticket_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Espin_Event_Ticket_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Espin_Event_Ticket_Sum_Order_By>;
  var_pop?: InputMaybe<Espin_Event_Ticket_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Espin_Event_Ticket_Var_Samp_Order_By>;
  variance?: InputMaybe<Espin_Event_Ticket_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "espin.event_ticket" */
export type Espin_Event_Ticket_Arr_Rel_Insert_Input = {
  data: Array<Espin_Event_Ticket_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Event_Ticket_On_Conflict>;
};

/** aggregate avg on columns */
export type Espin_Event_Ticket_Avg_Fields = {
  __typename?: 'espin_event_ticket_avg_fields';
  price_temp?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "espin.event_ticket" */
export type Espin_Event_Ticket_Avg_Order_By = {
  price_temp?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "espin.event_ticket". All fields are combined with a logical 'AND'. */
export type Espin_Event_Ticket_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Event_Ticket_Bool_Exp>>;
  _not?: InputMaybe<Espin_Event_Ticket_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Event_Ticket_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  event?: InputMaybe<Espin_Event_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  event_registrations?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
  event_registrations_aggregate?: InputMaybe<Espin_Event_Registration_Aggregate_Bool_Exp>;
  event_ticket_type?: InputMaybe<Espin_Event_Ticket_Type_Bool_Exp>;
  game?: InputMaybe<Espin_Game_Bool_Exp>;
  game_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  price_id?: InputMaybe<String_Comparison_Exp>;
  price_temp?: InputMaybe<Numeric_Comparison_Exp>;
  ticket_type?: InputMaybe<Espin_Event_Ticket_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.event_ticket" */
export enum Espin_Event_Ticket_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventTicketPkey = 'event_ticket_pkey'
}

/** input type for incrementing numeric columns in table "espin.event_ticket" */
export type Espin_Event_Ticket_Inc_Input = {
  price_temp?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "espin.event_ticket" */
export type Espin_Event_Ticket_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Espin_Event_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['uuid']>;
  event_registrations?: InputMaybe<Espin_Event_Registration_Arr_Rel_Insert_Input>;
  event_ticket_type?: InputMaybe<Espin_Event_Ticket_Type_Obj_Rel_Insert_Input>;
  game?: InputMaybe<Espin_Game_Obj_Rel_Insert_Input>;
  game_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  price_id?: InputMaybe<Scalars['String']>;
  price_temp?: InputMaybe<Scalars['numeric']>;
  ticket_type?: InputMaybe<Espin_Event_Ticket_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Espin_Event_Ticket_Max_Fields = {
  __typename?: 'espin_event_ticket_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['uuid']>;
  game_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  price_id?: Maybe<Scalars['String']>;
  price_temp?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "espin.event_ticket" */
export type Espin_Event_Ticket_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  price_temp?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Event_Ticket_Min_Fields = {
  __typename?: 'espin_event_ticket_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['uuid']>;
  game_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  price_id?: Maybe<Scalars['String']>;
  price_temp?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "espin.event_ticket" */
export type Espin_Event_Ticket_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  price_temp?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.event_ticket" */
export type Espin_Event_Ticket_Mutation_Response = {
  __typename?: 'espin_event_ticket_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Event_Ticket>;
};

/** input type for inserting object relation for remote table "espin.event_ticket" */
export type Espin_Event_Ticket_Obj_Rel_Insert_Input = {
  data: Espin_Event_Ticket_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Event_Ticket_On_Conflict>;
};

/** on_conflict condition type for table "espin.event_ticket" */
export type Espin_Event_Ticket_On_Conflict = {
  constraint: Espin_Event_Ticket_Constraint;
  update_columns?: Array<Espin_Event_Ticket_Update_Column>;
  where?: InputMaybe<Espin_Event_Ticket_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.event_ticket". */
export type Espin_Event_Ticket_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  event?: InputMaybe<Espin_Event_Order_By>;
  event_id?: InputMaybe<Order_By>;
  event_registrations_aggregate?: InputMaybe<Espin_Event_Registration_Aggregate_Order_By>;
  event_ticket_type?: InputMaybe<Espin_Event_Ticket_Type_Order_By>;
  game?: InputMaybe<Espin_Game_Order_By>;
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  price_temp?: InputMaybe<Order_By>;
  ticket_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.event_ticket */
export type Espin_Event_Ticket_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.event_ticket" */
export enum Espin_Event_Ticket_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  EventId = 'event_id',
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PriceId = 'price_id',
  /** column name */
  PriceTemp = 'price_temp',
  /** column name */
  TicketType = 'ticket_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "espin.event_ticket" */
export type Espin_Event_Ticket_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  game_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  price_id?: InputMaybe<Scalars['String']>;
  price_temp?: InputMaybe<Scalars['numeric']>;
  ticket_type?: InputMaybe<Espin_Event_Ticket_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Espin_Event_Ticket_Stddev_Fields = {
  __typename?: 'espin_event_ticket_stddev_fields';
  price_temp?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "espin.event_ticket" */
export type Espin_Event_Ticket_Stddev_Order_By = {
  price_temp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Espin_Event_Ticket_Stddev_Pop_Fields = {
  __typename?: 'espin_event_ticket_stddev_pop_fields';
  price_temp?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "espin.event_ticket" */
export type Espin_Event_Ticket_Stddev_Pop_Order_By = {
  price_temp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Espin_Event_Ticket_Stddev_Samp_Fields = {
  __typename?: 'espin_event_ticket_stddev_samp_fields';
  price_temp?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "espin.event_ticket" */
export type Espin_Event_Ticket_Stddev_Samp_Order_By = {
  price_temp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "espin_event_ticket" */
export type Espin_Event_Ticket_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Event_Ticket_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Event_Ticket_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  game_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  price_id?: InputMaybe<Scalars['String']>;
  price_temp?: InputMaybe<Scalars['numeric']>;
  ticket_type?: InputMaybe<Espin_Event_Ticket_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Espin_Event_Ticket_Sum_Fields = {
  __typename?: 'espin_event_ticket_sum_fields';
  price_temp?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "espin.event_ticket" */
export type Espin_Event_Ticket_Sum_Order_By = {
  price_temp?: InputMaybe<Order_By>;
};

/** Solo / Team type enum */
export type Espin_Event_Ticket_Type = {
  __typename?: 'espin_event_ticket_type';
  display_name: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.event_ticket_type" */
export type Espin_Event_Ticket_Type_Aggregate = {
  __typename?: 'espin_event_ticket_type_aggregate';
  aggregate?: Maybe<Espin_Event_Ticket_Type_Aggregate_Fields>;
  nodes: Array<Espin_Event_Ticket_Type>;
};

/** aggregate fields of "espin.event_ticket_type" */
export type Espin_Event_Ticket_Type_Aggregate_Fields = {
  __typename?: 'espin_event_ticket_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Event_Ticket_Type_Max_Fields>;
  min?: Maybe<Espin_Event_Ticket_Type_Min_Fields>;
};


/** aggregate fields of "espin.event_ticket_type" */
export type Espin_Event_Ticket_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Event_Ticket_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.event_ticket_type". All fields are combined with a logical 'AND'. */
export type Espin_Event_Ticket_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Event_Ticket_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_Event_Ticket_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Event_Ticket_Type_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.event_ticket_type" */
export enum Espin_Event_Ticket_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  EventTicketTypePkey = 'event_ticket_type_pkey'
}

export enum Espin_Event_Ticket_Type_Enum {
  /** Individual */
  Individual = 'individual',
  /** Team */
  Team = 'team'
}

/** Boolean expression to compare columns of type "espin_event_ticket_type_enum". All fields are combined with logical 'AND'. */
export type Espin_Event_Ticket_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Event_Ticket_Type_Enum>;
  _in?: InputMaybe<Array<Espin_Event_Ticket_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Event_Ticket_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_Event_Ticket_Type_Enum>>;
};

/** input type for inserting data into table "espin.event_ticket_type" */
export type Espin_Event_Ticket_Type_Insert_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Event_Ticket_Type_Max_Fields = {
  __typename?: 'espin_event_ticket_type_max_fields';
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Event_Ticket_Type_Min_Fields = {
  __typename?: 'espin_event_ticket_type_min_fields';
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.event_ticket_type" */
export type Espin_Event_Ticket_Type_Mutation_Response = {
  __typename?: 'espin_event_ticket_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Event_Ticket_Type>;
};

/** input type for inserting object relation for remote table "espin.event_ticket_type" */
export type Espin_Event_Ticket_Type_Obj_Rel_Insert_Input = {
  data: Espin_Event_Ticket_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Event_Ticket_Type_On_Conflict>;
};

/** on_conflict condition type for table "espin.event_ticket_type" */
export type Espin_Event_Ticket_Type_On_Conflict = {
  constraint: Espin_Event_Ticket_Type_Constraint;
  update_columns?: Array<Espin_Event_Ticket_Type_Update_Column>;
  where?: InputMaybe<Espin_Event_Ticket_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.event_ticket_type". */
export type Espin_Event_Ticket_Type_Order_By = {
  display_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.event_ticket_type */
export type Espin_Event_Ticket_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.event_ticket_type" */
export enum Espin_Event_Ticket_Type_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.event_ticket_type" */
export type Espin_Event_Ticket_Type_Set_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_event_ticket_type" */
export type Espin_Event_Ticket_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Event_Ticket_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Event_Ticket_Type_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.event_ticket_type" */
export enum Espin_Event_Ticket_Type_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

export type Espin_Event_Ticket_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Event_Ticket_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Event_Ticket_Type_Bool_Exp;
};

/** update columns of table "espin.event_ticket" */
export enum Espin_Event_Ticket_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  EventId = 'event_id',
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PriceId = 'price_id',
  /** column name */
  PriceTemp = 'price_temp',
  /** column name */
  TicketType = 'ticket_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Espin_Event_Ticket_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Event_Ticket_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Event_Ticket_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Event_Ticket_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Event_Ticket_Var_Pop_Fields = {
  __typename?: 'espin_event_ticket_var_pop_fields';
  price_temp?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "espin.event_ticket" */
export type Espin_Event_Ticket_Var_Pop_Order_By = {
  price_temp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Espin_Event_Ticket_Var_Samp_Fields = {
  __typename?: 'espin_event_ticket_var_samp_fields';
  price_temp?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "espin.event_ticket" */
export type Espin_Event_Ticket_Var_Samp_Order_By = {
  price_temp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Espin_Event_Ticket_Variance_Fields = {
  __typename?: 'espin_event_ticket_variance_fields';
  price_temp?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "espin.event_ticket" */
export type Espin_Event_Ticket_Variance_Order_By = {
  price_temp?: InputMaybe<Order_By>;
};

/** columns and relationships of "espin.event_type" */
export type Espin_Event_Type = {
  __typename?: 'espin_event_type';
  display_name: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.event_type" */
export type Espin_Event_Type_Aggregate = {
  __typename?: 'espin_event_type_aggregate';
  aggregate?: Maybe<Espin_Event_Type_Aggregate_Fields>;
  nodes: Array<Espin_Event_Type>;
};

/** aggregate fields of "espin.event_type" */
export type Espin_Event_Type_Aggregate_Fields = {
  __typename?: 'espin_event_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Event_Type_Max_Fields>;
  min?: Maybe<Espin_Event_Type_Min_Fields>;
};


/** aggregate fields of "espin.event_type" */
export type Espin_Event_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Event_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.event_type". All fields are combined with a logical 'AND'. */
export type Espin_Event_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Event_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_Event_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Event_Type_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.event_type" */
export enum Espin_Event_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  EventTypesPkey = 'event_types_pkey'
}

export enum Espin_Event_Type_Enum {
  /** LAN */
  Lan = 'lan',
  /** Online */
  Online = 'online'
}

/** Boolean expression to compare columns of type "espin_event_type_enum". All fields are combined with logical 'AND'. */
export type Espin_Event_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Event_Type_Enum>;
  _in?: InputMaybe<Array<Espin_Event_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Event_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_Event_Type_Enum>>;
};

/** input type for inserting data into table "espin.event_type" */
export type Espin_Event_Type_Insert_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Event_Type_Max_Fields = {
  __typename?: 'espin_event_type_max_fields';
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Event_Type_Min_Fields = {
  __typename?: 'espin_event_type_min_fields';
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.event_type" */
export type Espin_Event_Type_Mutation_Response = {
  __typename?: 'espin_event_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Event_Type>;
};

/** on_conflict condition type for table "espin.event_type" */
export type Espin_Event_Type_On_Conflict = {
  constraint: Espin_Event_Type_Constraint;
  update_columns?: Array<Espin_Event_Type_Update_Column>;
  where?: InputMaybe<Espin_Event_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.event_type". */
export type Espin_Event_Type_Order_By = {
  display_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.event_type */
export type Espin_Event_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.event_type" */
export enum Espin_Event_Type_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.event_type" */
export type Espin_Event_Type_Set_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_event_type" */
export type Espin_Event_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Event_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Event_Type_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.event_type" */
export enum Espin_Event_Type_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

export type Espin_Event_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Event_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Event_Type_Bool_Exp;
};

/** update columns of table "espin.event" */
export enum Espin_Event_Update_Column {
  /** column name */
  AdminRecommended = 'admin_recommended',
  /** column name */
  BodyContent = 'body_content',
  /** column name */
  EventEndDate = 'event_end_date',
  /** column name */
  EventStartDate = 'event_start_date',
  /** column name */
  IconId = 'icon_id',
  /** column name */
  Id = 'id',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  MigrationId = 'migration_id',
  /** column name */
  Name = 'name',
  /** column name */
  Prize = 'prize',
  /** column name */
  RegisterEndDate = 'register_end_date',
  /** column name */
  RegisterStartDate = 'register_start_date',
  /** column name */
  RegistrationDisclaimer = 'registration_disclaimer',
  /** column name */
  RulesContent = 'rules_content',
  /** column name */
  RulesLink = 'rules_link',
  /** column name */
  ShortDescription = 'short_description',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  Stickied = 'stickied',
  /** column name */
  StreamUrl = 'stream_url',
  /** column name */
  SuccessPage = 'success_page',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url'
}

export type Espin_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Event_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Event_Var_Pop_Fields = {
  __typename?: 'espin_event_var_pop_fields';
  prize?: Maybe<Scalars['Float']>;
  stickied?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_Event_Var_Samp_Fields = {
  __typename?: 'espin_event_var_samp_fields';
  prize?: Maybe<Scalars['Float']>;
  stickied?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_Event_Variance_Fields = {
  __typename?: 'espin_event_variance_fields';
  prize?: Maybe<Scalars['Float']>;
  stickied?: Maybe<Scalars['Float']>;
};

/** Enum table for external providers. Can have multiple, with diff link types */
export type Espin_External_Provider = {
  __typename?: 'espin_external_provider';
  description: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.external_provider" */
export type Espin_External_Provider_Aggregate = {
  __typename?: 'espin_external_provider_aggregate';
  aggregate?: Maybe<Espin_External_Provider_Aggregate_Fields>;
  nodes: Array<Espin_External_Provider>;
};

/** aggregate fields of "espin.external_provider" */
export type Espin_External_Provider_Aggregate_Fields = {
  __typename?: 'espin_external_provider_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_External_Provider_Max_Fields>;
  min?: Maybe<Espin_External_Provider_Min_Fields>;
};


/** aggregate fields of "espin.external_provider" */
export type Espin_External_Provider_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_External_Provider_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.external_provider". All fields are combined with a logical 'AND'. */
export type Espin_External_Provider_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_External_Provider_Bool_Exp>>;
  _not?: InputMaybe<Espin_External_Provider_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_External_Provider_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.external_provider" */
export enum Espin_External_Provider_Constraint {
  /** unique or primary key constraint on columns "name" */
  ExternalProviderPkey = 'external_provider_pkey'
}

export enum Espin_External_Provider_Enum {
  /** PlayVS connection by school id */
  Playvs = 'playvs'
}

/** Boolean expression to compare columns of type "espin_external_provider_enum". All fields are combined with logical 'AND'. */
export type Espin_External_Provider_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_External_Provider_Enum>;
  _in?: InputMaybe<Array<Espin_External_Provider_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_External_Provider_Enum>;
  _nin?: InputMaybe<Array<Espin_External_Provider_Enum>>;
};

/** input type for inserting data into table "espin.external_provider" */
export type Espin_External_Provider_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Link table for an external provider and it's ids + subscription times */
export type Espin_External_Provider_Link = {
  __typename?: 'espin_external_provider_link';
  external_id: Scalars['String'];
  id: Scalars['uuid'];
  provider: Espin_External_Provider_Enum;
  subscription_expiry: Scalars['bigint'];
};

/** aggregated selection of "espin.external_provider_link" */
export type Espin_External_Provider_Link_Aggregate = {
  __typename?: 'espin_external_provider_link_aggregate';
  aggregate?: Maybe<Espin_External_Provider_Link_Aggregate_Fields>;
  nodes: Array<Espin_External_Provider_Link>;
};

/** aggregate fields of "espin.external_provider_link" */
export type Espin_External_Provider_Link_Aggregate_Fields = {
  __typename?: 'espin_external_provider_link_aggregate_fields';
  avg?: Maybe<Espin_External_Provider_Link_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_External_Provider_Link_Max_Fields>;
  min?: Maybe<Espin_External_Provider_Link_Min_Fields>;
  stddev?: Maybe<Espin_External_Provider_Link_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_External_Provider_Link_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_External_Provider_Link_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_External_Provider_Link_Sum_Fields>;
  var_pop?: Maybe<Espin_External_Provider_Link_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_External_Provider_Link_Var_Samp_Fields>;
  variance?: Maybe<Espin_External_Provider_Link_Variance_Fields>;
};


/** aggregate fields of "espin.external_provider_link" */
export type Espin_External_Provider_Link_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_External_Provider_Link_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Espin_External_Provider_Link_Avg_Fields = {
  __typename?: 'espin_external_provider_link_avg_fields';
  subscription_expiry?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.external_provider_link". All fields are combined with a logical 'AND'. */
export type Espin_External_Provider_Link_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_External_Provider_Link_Bool_Exp>>;
  _not?: InputMaybe<Espin_External_Provider_Link_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_External_Provider_Link_Bool_Exp>>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Espin_External_Provider_Enum_Comparison_Exp>;
  subscription_expiry?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.external_provider_link" */
export enum Espin_External_Provider_Link_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExternalProviderLinkPkey = 'external_provider_link_pkey',
  /** unique or primary key constraint on columns "provider", "external_id" */
  UniqueProviderExternalLinkId = 'unique_provider_external_link_id'
}

/** input type for incrementing numeric columns in table "espin.external_provider_link" */
export type Espin_External_Provider_Link_Inc_Input = {
  subscription_expiry?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "espin.external_provider_link" */
export type Espin_External_Provider_Link_Insert_Input = {
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Espin_External_Provider_Enum>;
  subscription_expiry?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Espin_External_Provider_Link_Max_Fields = {
  __typename?: 'espin_external_provider_link_max_fields';
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  subscription_expiry?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Espin_External_Provider_Link_Min_Fields = {
  __typename?: 'espin_external_provider_link_min_fields';
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  subscription_expiry?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "espin.external_provider_link" */
export type Espin_External_Provider_Link_Mutation_Response = {
  __typename?: 'espin_external_provider_link_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_External_Provider_Link>;
};

/** input type for inserting object relation for remote table "espin.external_provider_link" */
export type Espin_External_Provider_Link_Obj_Rel_Insert_Input = {
  data: Espin_External_Provider_Link_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_External_Provider_Link_On_Conflict>;
};

/** on_conflict condition type for table "espin.external_provider_link" */
export type Espin_External_Provider_Link_On_Conflict = {
  constraint: Espin_External_Provider_Link_Constraint;
  update_columns?: Array<Espin_External_Provider_Link_Update_Column>;
  where?: InputMaybe<Espin_External_Provider_Link_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.external_provider_link". */
export type Espin_External_Provider_Link_Order_By = {
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  subscription_expiry?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.external_provider_link */
export type Espin_External_Provider_Link_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.external_provider_link" */
export enum Espin_External_Provider_Link_Select_Column {
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  SubscriptionExpiry = 'subscription_expiry'
}

/** input type for updating data in table "espin.external_provider_link" */
export type Espin_External_Provider_Link_Set_Input = {
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Espin_External_Provider_Enum>;
  subscription_expiry?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Espin_External_Provider_Link_Stddev_Fields = {
  __typename?: 'espin_external_provider_link_stddev_fields';
  subscription_expiry?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_External_Provider_Link_Stddev_Pop_Fields = {
  __typename?: 'espin_external_provider_link_stddev_pop_fields';
  subscription_expiry?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_External_Provider_Link_Stddev_Samp_Fields = {
  __typename?: 'espin_external_provider_link_stddev_samp_fields';
  subscription_expiry?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_external_provider_link" */
export type Espin_External_Provider_Link_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_External_Provider_Link_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_External_Provider_Link_Stream_Cursor_Value_Input = {
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Espin_External_Provider_Enum>;
  subscription_expiry?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Espin_External_Provider_Link_Sum_Fields = {
  __typename?: 'espin_external_provider_link_sum_fields';
  subscription_expiry?: Maybe<Scalars['bigint']>;
};

/** update columns of table "espin.external_provider_link" */
export enum Espin_External_Provider_Link_Update_Column {
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  SubscriptionExpiry = 'subscription_expiry'
}

export type Espin_External_Provider_Link_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_External_Provider_Link_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_External_Provider_Link_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_External_Provider_Link_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_External_Provider_Link_Var_Pop_Fields = {
  __typename?: 'espin_external_provider_link_var_pop_fields';
  subscription_expiry?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_External_Provider_Link_Var_Samp_Fields = {
  __typename?: 'espin_external_provider_link_var_samp_fields';
  subscription_expiry?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_External_Provider_Link_Variance_Fields = {
  __typename?: 'espin_external_provider_link_variance_fields';
  subscription_expiry?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Espin_External_Provider_Max_Fields = {
  __typename?: 'espin_external_provider_max_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_External_Provider_Min_Fields = {
  __typename?: 'espin_external_provider_min_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.external_provider" */
export type Espin_External_Provider_Mutation_Response = {
  __typename?: 'espin_external_provider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_External_Provider>;
};

/** on_conflict condition type for table "espin.external_provider" */
export type Espin_External_Provider_On_Conflict = {
  constraint: Espin_External_Provider_Constraint;
  update_columns?: Array<Espin_External_Provider_Update_Column>;
  where?: InputMaybe<Espin_External_Provider_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.external_provider". */
export type Espin_External_Provider_Order_By = {
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.external_provider */
export type Espin_External_Provider_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.external_provider" */
export enum Espin_External_Provider_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.external_provider" */
export type Espin_External_Provider_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_external_provider" */
export type Espin_External_Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_External_Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_External_Provider_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.external_provider" */
export enum Espin_External_Provider_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

export type Espin_External_Provider_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_External_Provider_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_External_Provider_Bool_Exp;
};

/** Tracking follows in system */
export type Espin_Follow = {
  __typename?: 'espin_follow';
  /** An object relationship */
  college: Espin_College;
  college_id: Scalars['uuid'];
  /** An object relationship */
  college_user?: Maybe<Espin_User>;
  college_user_id?: Maybe<Scalars['String']>;
  college_user_name?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  follow_type: Espin_Follow_Type_Enum;
  /** An object relationship */
  high_school?: Maybe<Espin_High_School>;
  high_school_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  high_school_user?: Maybe<Espin_User>;
  high_school_user_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  notification?: Maybe<Espin_Notification>;
  notification_id?: Maybe<Scalars['uuid']>;
  parent_user_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  player_user?: Maybe<Espin_User>;
  player_user_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "espin.follow" */
export type Espin_Follow_Aggregate = {
  __typename?: 'espin_follow_aggregate';
  aggregate?: Maybe<Espin_Follow_Aggregate_Fields>;
  nodes: Array<Espin_Follow>;
};

export type Espin_Follow_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Follow_Aggregate_Bool_Exp_Count>;
};

export type Espin_Follow_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Follow_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.follow" */
export type Espin_Follow_Aggregate_Fields = {
  __typename?: 'espin_follow_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Follow_Max_Fields>;
  min?: Maybe<Espin_Follow_Min_Fields>;
};


/** aggregate fields of "espin.follow" */
export type Espin_Follow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.follow" */
export type Espin_Follow_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Follow_Max_Order_By>;
  min?: InputMaybe<Espin_Follow_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.follow" */
export type Espin_Follow_Arr_Rel_Insert_Input = {
  data: Array<Espin_Follow_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Follow_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.follow". All fields are combined with a logical 'AND'. */
export type Espin_Follow_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Follow_Bool_Exp>>;
  _not?: InputMaybe<Espin_Follow_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Follow_Bool_Exp>>;
  college?: InputMaybe<Espin_College_Bool_Exp>;
  college_id?: InputMaybe<Uuid_Comparison_Exp>;
  college_user?: InputMaybe<Espin_User_Bool_Exp>;
  college_user_id?: InputMaybe<String_Comparison_Exp>;
  college_user_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  follow_type?: InputMaybe<Espin_Follow_Type_Enum_Comparison_Exp>;
  high_school?: InputMaybe<Espin_High_School_Bool_Exp>;
  high_school_id?: InputMaybe<Uuid_Comparison_Exp>;
  high_school_user?: InputMaybe<Espin_User_Bool_Exp>;
  high_school_user_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notification?: InputMaybe<Espin_Notification_Bool_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_user_id?: InputMaybe<String_Comparison_Exp>;
  player_user?: InputMaybe<Espin_User_Bool_Exp>;
  player_user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.follow" */
export enum Espin_Follow_Constraint {
  /** unique or primary key constraint on columns "id" */
  FollowPkey = 'follow_pkey'
}

/** input type for inserting data into table "espin.follow" */
export type Espin_Follow_Insert_Input = {
  college?: InputMaybe<Espin_College_Obj_Rel_Insert_Input>;
  college_id?: InputMaybe<Scalars['uuid']>;
  college_user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  college_user_id?: InputMaybe<Scalars['String']>;
  college_user_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  follow_type?: InputMaybe<Espin_Follow_Type_Enum>;
  high_school?: InputMaybe<Espin_High_School_Obj_Rel_Insert_Input>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  high_school_user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  high_school_user_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification?: InputMaybe<Espin_Notification_Obj_Rel_Insert_Input>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  parent_user_id?: InputMaybe<Scalars['String']>;
  player_user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  player_user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Follow_Max_Fields = {
  __typename?: 'espin_follow_max_fields';
  college_id?: Maybe<Scalars['uuid']>;
  college_user_id?: Maybe<Scalars['String']>;
  college_user_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  high_school_user_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notification_id?: Maybe<Scalars['uuid']>;
  parent_user_id?: Maybe<Scalars['String']>;
  player_user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.follow" */
export type Espin_Follow_Max_Order_By = {
  college_id?: InputMaybe<Order_By>;
  college_user_id?: InputMaybe<Order_By>;
  college_user_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  high_school_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  parent_user_id?: InputMaybe<Order_By>;
  player_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Follow_Min_Fields = {
  __typename?: 'espin_follow_min_fields';
  college_id?: Maybe<Scalars['uuid']>;
  college_user_id?: Maybe<Scalars['String']>;
  college_user_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  high_school_user_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notification_id?: Maybe<Scalars['uuid']>;
  parent_user_id?: Maybe<Scalars['String']>;
  player_user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.follow" */
export type Espin_Follow_Min_Order_By = {
  college_id?: InputMaybe<Order_By>;
  college_user_id?: InputMaybe<Order_By>;
  college_user_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  high_school_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  parent_user_id?: InputMaybe<Order_By>;
  player_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.follow" */
export type Espin_Follow_Mutation_Response = {
  __typename?: 'espin_follow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Follow>;
};

/** on_conflict condition type for table "espin.follow" */
export type Espin_Follow_On_Conflict = {
  constraint: Espin_Follow_Constraint;
  update_columns?: Array<Espin_Follow_Update_Column>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.follow". */
export type Espin_Follow_Order_By = {
  college?: InputMaybe<Espin_College_Order_By>;
  college_id?: InputMaybe<Order_By>;
  college_user?: InputMaybe<Espin_User_Order_By>;
  college_user_id?: InputMaybe<Order_By>;
  college_user_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  follow_type?: InputMaybe<Order_By>;
  high_school?: InputMaybe<Espin_High_School_Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  high_school_user?: InputMaybe<Espin_User_Order_By>;
  high_school_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification?: InputMaybe<Espin_Notification_Order_By>;
  notification_id?: InputMaybe<Order_By>;
  parent_user_id?: InputMaybe<Order_By>;
  player_user?: InputMaybe<Espin_User_Order_By>;
  player_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.follow */
export type Espin_Follow_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.follow" */
export enum Espin_Follow_Select_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CollegeUserId = 'college_user_id',
  /** column name */
  CollegeUserName = 'college_user_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FollowType = 'follow_type',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  HighSchoolUserId = 'high_school_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  ParentUserId = 'parent_user_id',
  /** column name */
  PlayerUserId = 'player_user_id'
}

/** input type for updating data in table "espin.follow" */
export type Espin_Follow_Set_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  college_user_id?: InputMaybe<Scalars['String']>;
  college_user_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  follow_type?: InputMaybe<Espin_Follow_Type_Enum>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  high_school_user_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  parent_user_id?: InputMaybe<Scalars['String']>;
  player_user_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_follow" */
export type Espin_Follow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Follow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Follow_Stream_Cursor_Value_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  college_user_id?: InputMaybe<Scalars['String']>;
  college_user_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  follow_type?: InputMaybe<Espin_Follow_Type_Enum>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  high_school_user_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  parent_user_id?: InputMaybe<Scalars['String']>;
  player_user_id?: InputMaybe<Scalars['String']>;
};

/** Follow type enum */
export type Espin_Follow_Type = {
  __typename?: 'espin_follow_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.follow_type" */
export type Espin_Follow_Type_Aggregate = {
  __typename?: 'espin_follow_type_aggregate';
  aggregate?: Maybe<Espin_Follow_Type_Aggregate_Fields>;
  nodes: Array<Espin_Follow_Type>;
};

/** aggregate fields of "espin.follow_type" */
export type Espin_Follow_Type_Aggregate_Fields = {
  __typename?: 'espin_follow_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Follow_Type_Max_Fields>;
  min?: Maybe<Espin_Follow_Type_Min_Fields>;
};


/** aggregate fields of "espin.follow_type" */
export type Espin_Follow_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Follow_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.follow_type". All fields are combined with a logical 'AND'. */
export type Espin_Follow_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Follow_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_Follow_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Follow_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.follow_type" */
export enum Espin_Follow_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  FollowTypePkey = 'follow_type_pkey'
}

export enum Espin_Follow_Type_Enum {
  /** A college follows a high school */
  CollegeFollowsHighSchool = 'college_follows_high_school',
  /** A college follows a player */
  CollegeFollowsPlayer = 'college_follows_player',
  /** High school follows a college */
  HighSchoolFollowsCollege = 'high_school_follows_college',
  /** A player follows a college */
  PlayerFollowsCollege = 'player_follows_college'
}

/** Boolean expression to compare columns of type "espin_follow_type_enum". All fields are combined with logical 'AND'. */
export type Espin_Follow_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Follow_Type_Enum>;
  _in?: InputMaybe<Array<Espin_Follow_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Follow_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_Follow_Type_Enum>>;
};

/** input type for inserting data into table "espin.follow_type" */
export type Espin_Follow_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Follow_Type_Max_Fields = {
  __typename?: 'espin_follow_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Follow_Type_Min_Fields = {
  __typename?: 'espin_follow_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.follow_type" */
export type Espin_Follow_Type_Mutation_Response = {
  __typename?: 'espin_follow_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Follow_Type>;
};

/** on_conflict condition type for table "espin.follow_type" */
export type Espin_Follow_Type_On_Conflict = {
  constraint: Espin_Follow_Type_Constraint;
  update_columns?: Array<Espin_Follow_Type_Update_Column>;
  where?: InputMaybe<Espin_Follow_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.follow_type". */
export type Espin_Follow_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.follow_type */
export type Espin_Follow_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.follow_type" */
export enum Espin_Follow_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.follow_type" */
export type Espin_Follow_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_follow_type" */
export type Espin_Follow_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Follow_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Follow_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.follow_type" */
export enum Espin_Follow_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Follow_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Follow_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Follow_Type_Bool_Exp;
};

/** update columns of table "espin.follow" */
export enum Espin_Follow_Update_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CollegeUserId = 'college_user_id',
  /** column name */
  CollegeUserName = 'college_user_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FollowType = 'follow_type',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  HighSchoolUserId = 'high_school_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  ParentUserId = 'parent_user_id',
  /** column name */
  PlayerUserId = 'player_user_id'
}

export type Espin_Follow_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Follow_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Follow_Bool_Exp;
};

/** Enum for follower email preferences */
export type Espin_Follower_Email_Notification_Type = {
  __typename?: 'espin_follower_email_notification_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.follower_email_notification_type" */
export type Espin_Follower_Email_Notification_Type_Aggregate = {
  __typename?: 'espin_follower_email_notification_type_aggregate';
  aggregate?: Maybe<Espin_Follower_Email_Notification_Type_Aggregate_Fields>;
  nodes: Array<Espin_Follower_Email_Notification_Type>;
};

/** aggregate fields of "espin.follower_email_notification_type" */
export type Espin_Follower_Email_Notification_Type_Aggregate_Fields = {
  __typename?: 'espin_follower_email_notification_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Follower_Email_Notification_Type_Max_Fields>;
  min?: Maybe<Espin_Follower_Email_Notification_Type_Min_Fields>;
};


/** aggregate fields of "espin.follower_email_notification_type" */
export type Espin_Follower_Email_Notification_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Follower_Email_Notification_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.follower_email_notification_type". All fields are combined with a logical 'AND'. */
export type Espin_Follower_Email_Notification_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Follower_Email_Notification_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_Follower_Email_Notification_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Follower_Email_Notification_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.follower_email_notification_type" */
export enum Espin_Follower_Email_Notification_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  FollowerEmailNotificationTypePkey = 'follower_email_notification_type_pkey'
}

export enum Espin_Follower_Email_Notification_Type_Enum {
  /** No email */
  None = 'none',
  /** One email per follow */
  OnePerFollow = 'one_per_follow',
  /** One email per month w/ followers listed */
  OnePerMonth = 'one_per_month',
  /** One email per week w/ followers listed */
  OnePerWeek = 'one_per_week'
}

/** Boolean expression to compare columns of type "espin_follower_email_notification_type_enum". All fields are combined with logical 'AND'. */
export type Espin_Follower_Email_Notification_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Follower_Email_Notification_Type_Enum>;
  _in?: InputMaybe<Array<Espin_Follower_Email_Notification_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Follower_Email_Notification_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_Follower_Email_Notification_Type_Enum>>;
};

/** input type for inserting data into table "espin.follower_email_notification_type" */
export type Espin_Follower_Email_Notification_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Follower_Email_Notification_Type_Max_Fields = {
  __typename?: 'espin_follower_email_notification_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Follower_Email_Notification_Type_Min_Fields = {
  __typename?: 'espin_follower_email_notification_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.follower_email_notification_type" */
export type Espin_Follower_Email_Notification_Type_Mutation_Response = {
  __typename?: 'espin_follower_email_notification_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Follower_Email_Notification_Type>;
};

/** on_conflict condition type for table "espin.follower_email_notification_type" */
export type Espin_Follower_Email_Notification_Type_On_Conflict = {
  constraint: Espin_Follower_Email_Notification_Type_Constraint;
  update_columns?: Array<Espin_Follower_Email_Notification_Type_Update_Column>;
  where?: InputMaybe<Espin_Follower_Email_Notification_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.follower_email_notification_type". */
export type Espin_Follower_Email_Notification_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.follower_email_notification_type */
export type Espin_Follower_Email_Notification_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.follower_email_notification_type" */
export enum Espin_Follower_Email_Notification_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.follower_email_notification_type" */
export type Espin_Follower_Email_Notification_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_follower_email_notification_type" */
export type Espin_Follower_Email_Notification_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Follower_Email_Notification_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Follower_Email_Notification_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.follower_email_notification_type" */
export enum Espin_Follower_Email_Notification_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Follower_Email_Notification_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Follower_Email_Notification_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Follower_Email_Notification_Type_Bool_Exp;
};

/** Simple table to force a cache refresh */
export type Espin_Force_Notification_Reload = {
  __typename?: 'espin_force_notification_reload';
  id: Scalars['Int'];
};

/** aggregated selection of "espin.force_notification_reload" */
export type Espin_Force_Notification_Reload_Aggregate = {
  __typename?: 'espin_force_notification_reload_aggregate';
  aggregate?: Maybe<Espin_Force_Notification_Reload_Aggregate_Fields>;
  nodes: Array<Espin_Force_Notification_Reload>;
};

/** aggregate fields of "espin.force_notification_reload" */
export type Espin_Force_Notification_Reload_Aggregate_Fields = {
  __typename?: 'espin_force_notification_reload_aggregate_fields';
  avg?: Maybe<Espin_Force_Notification_Reload_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Force_Notification_Reload_Max_Fields>;
  min?: Maybe<Espin_Force_Notification_Reload_Min_Fields>;
  stddev?: Maybe<Espin_Force_Notification_Reload_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Force_Notification_Reload_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Force_Notification_Reload_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Force_Notification_Reload_Sum_Fields>;
  var_pop?: Maybe<Espin_Force_Notification_Reload_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Force_Notification_Reload_Var_Samp_Fields>;
  variance?: Maybe<Espin_Force_Notification_Reload_Variance_Fields>;
};


/** aggregate fields of "espin.force_notification_reload" */
export type Espin_Force_Notification_Reload_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Force_Notification_Reload_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Espin_Force_Notification_Reload_Avg_Fields = {
  __typename?: 'espin_force_notification_reload_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.force_notification_reload". All fields are combined with a logical 'AND'. */
export type Espin_Force_Notification_Reload_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Force_Notification_Reload_Bool_Exp>>;
  _not?: InputMaybe<Espin_Force_Notification_Reload_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Force_Notification_Reload_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.force_notification_reload" */
export enum Espin_Force_Notification_Reload_Constraint {
  /** unique or primary key constraint on columns "id" */
  ForceNotificationReloadPkey = 'force_notification_reload_pkey'
}

/** input type for incrementing numeric columns in table "espin.force_notification_reload" */
export type Espin_Force_Notification_Reload_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.force_notification_reload" */
export type Espin_Force_Notification_Reload_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Espin_Force_Notification_Reload_Max_Fields = {
  __typename?: 'espin_force_notification_reload_max_fields';
  id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Espin_Force_Notification_Reload_Min_Fields = {
  __typename?: 'espin_force_notification_reload_min_fields';
  id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "espin.force_notification_reload" */
export type Espin_Force_Notification_Reload_Mutation_Response = {
  __typename?: 'espin_force_notification_reload_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Force_Notification_Reload>;
};

/** on_conflict condition type for table "espin.force_notification_reload" */
export type Espin_Force_Notification_Reload_On_Conflict = {
  constraint: Espin_Force_Notification_Reload_Constraint;
  update_columns?: Array<Espin_Force_Notification_Reload_Update_Column>;
  where?: InputMaybe<Espin_Force_Notification_Reload_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.force_notification_reload". */
export type Espin_Force_Notification_Reload_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.force_notification_reload */
export type Espin_Force_Notification_Reload_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "espin.force_notification_reload" */
export enum Espin_Force_Notification_Reload_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "espin.force_notification_reload" */
export type Espin_Force_Notification_Reload_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Espin_Force_Notification_Reload_Stddev_Fields = {
  __typename?: 'espin_force_notification_reload_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_Force_Notification_Reload_Stddev_Pop_Fields = {
  __typename?: 'espin_force_notification_reload_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_Force_Notification_Reload_Stddev_Samp_Fields = {
  __typename?: 'espin_force_notification_reload_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_force_notification_reload" */
export type Espin_Force_Notification_Reload_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Force_Notification_Reload_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Force_Notification_Reload_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Espin_Force_Notification_Reload_Sum_Fields = {
  __typename?: 'espin_force_notification_reload_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "espin.force_notification_reload" */
export enum Espin_Force_Notification_Reload_Update_Column {
  /** column name */
  Id = 'id'
}

export type Espin_Force_Notification_Reload_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Force_Notification_Reload_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Force_Notification_Reload_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Force_Notification_Reload_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Force_Notification_Reload_Var_Pop_Fields = {
  __typename?: 'espin_force_notification_reload_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_Force_Notification_Reload_Var_Samp_Fields = {
  __typename?: 'espin_force_notification_reload_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_Force_Notification_Reload_Variance_Fields = {
  __typename?: 'espin_force_notification_reload_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Games that we record in the system for players and colleges */
export type Espin_Game = {
  __typename?: 'espin_game';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Link to game enum */
  game_definition: Espin_Game_Definition_Enum;
  /** An object relationship */
  game_platform?: Maybe<Espin_Game_Platform>;
  image_url?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  platform: Scalars['String'];
  team_max_size: Scalars['Int'];
  website?: Maybe<Scalars['String']>;
};

/** aggregated selection of "espin.game" */
export type Espin_Game_Aggregate = {
  __typename?: 'espin_game_aggregate';
  aggregate?: Maybe<Espin_Game_Aggregate_Fields>;
  nodes: Array<Espin_Game>;
};

/** aggregate fields of "espin.game" */
export type Espin_Game_Aggregate_Fields = {
  __typename?: 'espin_game_aggregate_fields';
  avg?: Maybe<Espin_Game_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Game_Max_Fields>;
  min?: Maybe<Espin_Game_Min_Fields>;
  stddev?: Maybe<Espin_Game_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Game_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Game_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Game_Sum_Fields>;
  var_pop?: Maybe<Espin_Game_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Game_Var_Samp_Fields>;
  variance?: Maybe<Espin_Game_Variance_Fields>;
};


/** aggregate fields of "espin.game" */
export type Espin_Game_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Game_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Espin_Game_Avg_Fields = {
  __typename?: 'espin_game_avg_fields';
  team_max_size?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.game". All fields are combined with a logical 'AND'. */
export type Espin_Game_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Game_Bool_Exp>>;
  _not?: InputMaybe<Espin_Game_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Game_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  game_definition?: InputMaybe<Espin_Game_Definition_Enum_Comparison_Exp>;
  game_platform?: InputMaybe<Espin_Game_Platform_Bool_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  team_max_size?: InputMaybe<Int_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.game" */
export enum Espin_Game_Constraint {
  /** unique or primary key constraint on columns "name" */
  GameNameKey = 'game_name_key',
  /** unique or primary key constraint on columns "game_definition" */
  GamePkey = 'game_pkey'
}

/** Game enum to use in design and control of games */
export type Espin_Game_Definition = {
  __typename?: 'espin_game_definition';
  display_name: Scalars['String'];
  game_name: Scalars['String'];
};

/** aggregated selection of "espin.game_definition" */
export type Espin_Game_Definition_Aggregate = {
  __typename?: 'espin_game_definition_aggregate';
  aggregate?: Maybe<Espin_Game_Definition_Aggregate_Fields>;
  nodes: Array<Espin_Game_Definition>;
};

/** aggregate fields of "espin.game_definition" */
export type Espin_Game_Definition_Aggregate_Fields = {
  __typename?: 'espin_game_definition_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Game_Definition_Max_Fields>;
  min?: Maybe<Espin_Game_Definition_Min_Fields>;
};


/** aggregate fields of "espin.game_definition" */
export type Espin_Game_Definition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Game_Definition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.game_definition". All fields are combined with a logical 'AND'. */
export type Espin_Game_Definition_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Game_Definition_Bool_Exp>>;
  _not?: InputMaybe<Espin_Game_Definition_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Game_Definition_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  game_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.game_definition" */
export enum Espin_Game_Definition_Constraint {
  /** unique or primary key constraint on columns "game_name" */
  GameDefinitionPkey = 'game_definition_pkey'
}

export enum Espin_Game_Definition_Enum {
  /** Apex Legends */
  ApexLegends = 'apex_legends',
  /** Brawlhalla */
  Brawlhalla = 'brawlhalla',
  /** Call of Duty */
  CallOfDuty = 'call_of_duty',
  /** Chess */
  Chess = 'chess',
  /** Clash Royale */
  ClashRoyale = 'clash_royale',
  /** COD Warzone */
  CodWarzone = 'cod_warzone',
  /** CS:GO */
  Csgo = 'csgo',
  /** Dota 2 */
  Dota_2 = 'dota_2',
  /** EA FC 24 */
  EaFc_24 = 'ea_fc_24',
  /** FIFA 22 */
  Fifa_22 = 'fifa_22',
  /** Fortnite */
  Fortnite = 'fortnite',
  /** Forza */
  Forza = 'forza',
  /** Halo Infinite */
  HaloInfinite = 'halo_infinite',
  /** Hearthstone */
  Hearthstone = 'hearthstone',
  /** iRacing */
  Iracing = 'iracing',
  /** League of Legends */
  LeagueOfLegends = 'league_of_legends',
  /** League of Legends: Wild Rift */
  LeagueOfLegendsWildRift = 'league_of_legends_wild_rift',
  /** Legends of Runeterra */
  LegendsOfRuneterra = 'legends_of_runeterra',
  /** Madden 22 */
  Madden_22 = 'madden_22',
  /** Madden 24 */
  Madden_24 = 'madden_24',
  /** Magic the Gathering */
  MagicTheGathering = 'magic_the_gathering',
  /** Mario Kart 8 */
  MarioKartEight = 'mario_kart_eight',
  /** Marvel Rivals */
  MarvelRivals = 'marvel_rivals',
  /** NBA 2K22 */
  Nba_2k22 = 'nba_2k22',
  /** NHL 22 */
  Nhl_22 = 'nhl_22',
  /** Omega Strikers */
  OmegaStrikers = 'omega_strikers',
  /** Overwatch */
  Overwatch = 'overwatch',
  /** Pokémon Unite */
  PokemonUnite = 'pokemon_unite',
  /** Rainbow Six Siege */
  RainbowSixSiege = 'rainbow_six_siege',
  /** Rocket League */
  RocketLeague = 'rocket_league',
  /** Rogue Company */
  RogueCompany = 'rogue_company',
  /** Side Swipe */
  SideSwipe = 'side_swipe',
  /** Smite */
  Smite = 'smite',
  /** Splatoon 3 */
  Splatoon = 'splatoon',
  /** Street Fighter */
  StreetFighter = 'street_fighter',
  /** Super Smash Bros Melee */
  SuperSmashBrosMelee = 'super_smash_bros_melee',
  /** Super Smash Bros Ultimate */
  SuperSmashBrosUltimate = 'super_smash_bros_ultimate',
  /** Teamfight Tactics */
  TeamfightTactics = 'teamfight_tactics',
  /** Tekken */
  Tekken = 'tekken',
  /** Valorant */
  Valorant = 'valorant',
  /** World of Warcraft */
  WorldOfWarcraft = 'world_of_warcraft'
}

/** Boolean expression to compare columns of type "espin_game_definition_enum". All fields are combined with logical 'AND'. */
export type Espin_Game_Definition_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Game_Definition_Enum>;
  _in?: InputMaybe<Array<Espin_Game_Definition_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Game_Definition_Enum>;
  _nin?: InputMaybe<Array<Espin_Game_Definition_Enum>>;
};

/** input type for inserting data into table "espin.game_definition" */
export type Espin_Game_Definition_Insert_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  game_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Game_Definition_Max_Fields = {
  __typename?: 'espin_game_definition_max_fields';
  display_name?: Maybe<Scalars['String']>;
  game_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Game_Definition_Min_Fields = {
  __typename?: 'espin_game_definition_min_fields';
  display_name?: Maybe<Scalars['String']>;
  game_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.game_definition" */
export type Espin_Game_Definition_Mutation_Response = {
  __typename?: 'espin_game_definition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Game_Definition>;
};

/** input type for inserting object relation for remote table "espin.game_definition" */
export type Espin_Game_Definition_Obj_Rel_Insert_Input = {
  data: Espin_Game_Definition_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Game_Definition_On_Conflict>;
};

/** on_conflict condition type for table "espin.game_definition" */
export type Espin_Game_Definition_On_Conflict = {
  constraint: Espin_Game_Definition_Constraint;
  update_columns?: Array<Espin_Game_Definition_Update_Column>;
  where?: InputMaybe<Espin_Game_Definition_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.game_definition". */
export type Espin_Game_Definition_Order_By = {
  display_name?: InputMaybe<Order_By>;
  game_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.game_definition */
export type Espin_Game_Definition_Pk_Columns_Input = {
  game_name: Scalars['String'];
};

/** select columns of table "espin.game_definition" */
export enum Espin_Game_Definition_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  GameName = 'game_name'
}

/** input type for updating data in table "espin.game_definition" */
export type Espin_Game_Definition_Set_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  game_name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_game_definition" */
export type Espin_Game_Definition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Game_Definition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Game_Definition_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  game_name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.game_definition" */
export enum Espin_Game_Definition_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  GameName = 'game_name'
}

export type Espin_Game_Definition_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Game_Definition_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Game_Definition_Bool_Exp;
};

/** input type for incrementing numeric columns in table "espin.game" */
export type Espin_Game_Inc_Input = {
  team_max_size?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.game" */
export type Espin_Game_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** Link to game enum */
  game_definition?: InputMaybe<Espin_Game_Definition_Enum>;
  game_platform?: InputMaybe<Espin_Game_Platform_Obj_Rel_Insert_Input>;
  image_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  team_max_size?: InputMaybe<Scalars['Int']>;
  website?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Game_Max_Fields = {
  __typename?: 'espin_game_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  team_max_size?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Game_Min_Fields = {
  __typename?: 'espin_game_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  team_max_size?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.game" */
export type Espin_Game_Mutation_Response = {
  __typename?: 'espin_game_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Game>;
};

/** input type for inserting object relation for remote table "espin.game" */
export type Espin_Game_Obj_Rel_Insert_Input = {
  data: Espin_Game_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Game_On_Conflict>;
};

/** on_conflict condition type for table "espin.game" */
export type Espin_Game_On_Conflict = {
  constraint: Espin_Game_Constraint;
  update_columns?: Array<Espin_Game_Update_Column>;
  where?: InputMaybe<Espin_Game_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.game". */
export type Espin_Game_Order_By = {
  created_at?: InputMaybe<Order_By>;
  game_definition?: InputMaybe<Order_By>;
  game_platform?: InputMaybe<Espin_Game_Platform_Order_By>;
  image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  team_max_size?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.game */
export type Espin_Game_Pk_Columns_Input = {
  /** Link to game enum */
  game_definition: Espin_Game_Definition_Enum;
};

/** columns and relationships of "espin.game_platform" */
export type Espin_Game_Platform = {
  __typename?: 'espin_game_platform';
  display_name: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.game_platform" */
export type Espin_Game_Platform_Aggregate = {
  __typename?: 'espin_game_platform_aggregate';
  aggregate?: Maybe<Espin_Game_Platform_Aggregate_Fields>;
  nodes: Array<Espin_Game_Platform>;
};

/** aggregate fields of "espin.game_platform" */
export type Espin_Game_Platform_Aggregate_Fields = {
  __typename?: 'espin_game_platform_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Game_Platform_Max_Fields>;
  min?: Maybe<Espin_Game_Platform_Min_Fields>;
};


/** aggregate fields of "espin.game_platform" */
export type Espin_Game_Platform_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Game_Platform_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.game_platform". All fields are combined with a logical 'AND'. */
export type Espin_Game_Platform_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Game_Platform_Bool_Exp>>;
  _not?: InputMaybe<Espin_Game_Platform_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Game_Platform_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.game_platform" */
export enum Espin_Game_Platform_Constraint {
  /** unique or primary key constraint on columns "name" */
  GamePlatformsPkey = 'game_platforms_pkey'
}

/** input type for inserting data into table "espin.game_platform" */
export type Espin_Game_Platform_Insert_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Game_Platform_Max_Fields = {
  __typename?: 'espin_game_platform_max_fields';
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Game_Platform_Min_Fields = {
  __typename?: 'espin_game_platform_min_fields';
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.game_platform" */
export type Espin_Game_Platform_Mutation_Response = {
  __typename?: 'espin_game_platform_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Game_Platform>;
};

/** input type for inserting object relation for remote table "espin.game_platform" */
export type Espin_Game_Platform_Obj_Rel_Insert_Input = {
  data: Espin_Game_Platform_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Game_Platform_On_Conflict>;
};

/** on_conflict condition type for table "espin.game_platform" */
export type Espin_Game_Platform_On_Conflict = {
  constraint: Espin_Game_Platform_Constraint;
  update_columns?: Array<Espin_Game_Platform_Update_Column>;
  where?: InputMaybe<Espin_Game_Platform_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.game_platform". */
export type Espin_Game_Platform_Order_By = {
  display_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.game_platform */
export type Espin_Game_Platform_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.game_platform" */
export enum Espin_Game_Platform_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.game_platform" */
export type Espin_Game_Platform_Set_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_game_platform" */
export type Espin_Game_Platform_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Game_Platform_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Game_Platform_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.game_platform" */
export enum Espin_Game_Platform_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

export type Espin_Game_Platform_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Game_Platform_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Game_Platform_Bool_Exp;
};

/** select columns of table "espin.game" */
export enum Espin_Game_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GameDefinition = 'game_definition',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Name = 'name',
  /** column name */
  Platform = 'platform',
  /** column name */
  TeamMaxSize = 'team_max_size',
  /** column name */
  Website = 'website'
}

/** input type for updating data in table "espin.game" */
export type Espin_Game_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** Link to game enum */
  game_definition?: InputMaybe<Espin_Game_Definition_Enum>;
  image_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  team_max_size?: InputMaybe<Scalars['Int']>;
  website?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Espin_Game_Stddev_Fields = {
  __typename?: 'espin_game_stddev_fields';
  team_max_size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_Game_Stddev_Pop_Fields = {
  __typename?: 'espin_game_stddev_pop_fields';
  team_max_size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_Game_Stddev_Samp_Fields = {
  __typename?: 'espin_game_stddev_samp_fields';
  team_max_size?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_game" */
export type Espin_Game_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Game_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Game_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** Link to game enum */
  game_definition?: InputMaybe<Espin_Game_Definition_Enum>;
  image_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  team_max_size?: InputMaybe<Scalars['Int']>;
  website?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Espin_Game_Sum_Fields = {
  __typename?: 'espin_game_sum_fields';
  team_max_size?: Maybe<Scalars['Int']>;
};

/** update columns of table "espin.game" */
export enum Espin_Game_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GameDefinition = 'game_definition',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Name = 'name',
  /** column name */
  Platform = 'platform',
  /** column name */
  TeamMaxSize = 'team_max_size',
  /** column name */
  Website = 'website'
}

export type Espin_Game_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Game_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Game_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Game_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Game_Var_Pop_Fields = {
  __typename?: 'espin_game_var_pop_fields';
  team_max_size?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_Game_Var_Samp_Fields = {
  __typename?: 'espin_game_var_samp_fields';
  team_max_size?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_Game_Variance_Fields = {
  __typename?: 'espin_game_variance_fields';
  team_max_size?: Maybe<Scalars['Float']>;
};

/** Gender select option table */
export type Espin_Gender_Options = {
  __typename?: 'espin_gender_options';
  display_name: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.gender_options" */
export type Espin_Gender_Options_Aggregate = {
  __typename?: 'espin_gender_options_aggregate';
  aggregate?: Maybe<Espin_Gender_Options_Aggregate_Fields>;
  nodes: Array<Espin_Gender_Options>;
};

/** aggregate fields of "espin.gender_options" */
export type Espin_Gender_Options_Aggregate_Fields = {
  __typename?: 'espin_gender_options_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Gender_Options_Max_Fields>;
  min?: Maybe<Espin_Gender_Options_Min_Fields>;
};


/** aggregate fields of "espin.gender_options" */
export type Espin_Gender_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Gender_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.gender_options". All fields are combined with a logical 'AND'. */
export type Espin_Gender_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Gender_Options_Bool_Exp>>;
  _not?: InputMaybe<Espin_Gender_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Gender_Options_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.gender_options" */
export enum Espin_Gender_Options_Constraint {
  /** unique or primary key constraint on columns "name" */
  GenderOptionsPkey = 'gender_options_pkey'
}

export enum Espin_Gender_Options_Enum {
  /** Female */
  Female = 'female',
  /** Male */
  Male = 'male',
  /** Non-Conforming */
  Nonconforming = 'nonconforming',
  /** Not Listed */
  NotListed = 'not_listed',
  /** Prefer not to say */
  PreferNotToSay = 'prefer_not_to_say'
}

/** Boolean expression to compare columns of type "espin_gender_options_enum". All fields are combined with logical 'AND'. */
export type Espin_Gender_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Gender_Options_Enum>;
  _in?: InputMaybe<Array<Espin_Gender_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Gender_Options_Enum>;
  _nin?: InputMaybe<Array<Espin_Gender_Options_Enum>>;
};

/** input type for inserting data into table "espin.gender_options" */
export type Espin_Gender_Options_Insert_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Gender_Options_Max_Fields = {
  __typename?: 'espin_gender_options_max_fields';
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Gender_Options_Min_Fields = {
  __typename?: 'espin_gender_options_min_fields';
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.gender_options" */
export type Espin_Gender_Options_Mutation_Response = {
  __typename?: 'espin_gender_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Gender_Options>;
};

/** on_conflict condition type for table "espin.gender_options" */
export type Espin_Gender_Options_On_Conflict = {
  constraint: Espin_Gender_Options_Constraint;
  update_columns?: Array<Espin_Gender_Options_Update_Column>;
  where?: InputMaybe<Espin_Gender_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.gender_options". */
export type Espin_Gender_Options_Order_By = {
  display_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.gender_options */
export type Espin_Gender_Options_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.gender_options" */
export enum Espin_Gender_Options_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.gender_options" */
export type Espin_Gender_Options_Set_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_gender_options" */
export type Espin_Gender_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Gender_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Gender_Options_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.gender_options" */
export enum Espin_Gender_Options_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

export type Espin_Gender_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Gender_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Gender_Options_Bool_Exp;
};

/** columns and relationships of "espin.graduating_class" */
export type Espin_Graduating_Class = {
  __typename?: 'espin_graduating_class';
  grad_class_years: Scalars['String'];
};

/** aggregated selection of "espin.graduating_class" */
export type Espin_Graduating_Class_Aggregate = {
  __typename?: 'espin_graduating_class_aggregate';
  aggregate?: Maybe<Espin_Graduating_Class_Aggregate_Fields>;
  nodes: Array<Espin_Graduating_Class>;
};

/** aggregate fields of "espin.graduating_class" */
export type Espin_Graduating_Class_Aggregate_Fields = {
  __typename?: 'espin_graduating_class_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Graduating_Class_Max_Fields>;
  min?: Maybe<Espin_Graduating_Class_Min_Fields>;
};


/** aggregate fields of "espin.graduating_class" */
export type Espin_Graduating_Class_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Graduating_Class_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.graduating_class". All fields are combined with a logical 'AND'. */
export type Espin_Graduating_Class_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Graduating_Class_Bool_Exp>>;
  _not?: InputMaybe<Espin_Graduating_Class_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Graduating_Class_Bool_Exp>>;
  grad_class_years?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.graduating_class" */
export enum Espin_Graduating_Class_Constraint {
  /** unique or primary key constraint on columns "grad_class_years" */
  GraduatingClassPkey = 'graduating_class_pkey'
}

/** input type for inserting data into table "espin.graduating_class" */
export type Espin_Graduating_Class_Insert_Input = {
  grad_class_years?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Graduating_Class_Max_Fields = {
  __typename?: 'espin_graduating_class_max_fields';
  grad_class_years?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Graduating_Class_Min_Fields = {
  __typename?: 'espin_graduating_class_min_fields';
  grad_class_years?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.graduating_class" */
export type Espin_Graduating_Class_Mutation_Response = {
  __typename?: 'espin_graduating_class_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Graduating_Class>;
};

/** on_conflict condition type for table "espin.graduating_class" */
export type Espin_Graduating_Class_On_Conflict = {
  constraint: Espin_Graduating_Class_Constraint;
  update_columns?: Array<Espin_Graduating_Class_Update_Column>;
  where?: InputMaybe<Espin_Graduating_Class_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.graduating_class". */
export type Espin_Graduating_Class_Order_By = {
  grad_class_years?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.graduating_class */
export type Espin_Graduating_Class_Pk_Columns_Input = {
  grad_class_years: Scalars['String'];
};

/** select columns of table "espin.graduating_class" */
export enum Espin_Graduating_Class_Select_Column {
  /** column name */
  GradClassYears = 'grad_class_years'
}

/** input type for updating data in table "espin.graduating_class" */
export type Espin_Graduating_Class_Set_Input = {
  grad_class_years?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_graduating_class" */
export type Espin_Graduating_Class_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Graduating_Class_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Graduating_Class_Stream_Cursor_Value_Input = {
  grad_class_years?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.graduating_class" */
export enum Espin_Graduating_Class_Update_Column {
  /** column name */
  GradClassYears = 'grad_class_years'
}

export type Espin_Graduating_Class_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Graduating_Class_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Graduating_Class_Bool_Exp;
};

/** Entity representing a high school */
export type Espin_High_School = {
  __typename?: 'espin_high_school';
  /** An object relationship */
  address?: Maybe<Espin_Address>;
  address_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_name?: Maybe<Scalars['String']>;
  contact_phone?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  follows: Array<Espin_Follow>;
  /** An aggregate relationship */
  follows_aggregate: Espin_Follow_Aggregate;
  /** An object relationship */
  high_school_owner?: Maybe<Espin_High_School_Profile>;
  /** An array relationship */
  high_school_profiles: Array<Espin_High_School_Profile>;
  /** An aggregate relationship */
  high_school_profiles_aggregate: Espin_High_School_Profile_Aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  owner_profile_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  player_profile_linked_high_school: Array<Espin_Player_Profile>;
  /** An aggregate relationship */
  player_profile_linked_high_school_aggregate: Espin_Player_Profile_Aggregate;
  /** An object relationship */
  profile_pic_file?: Maybe<Content_File>;
  profile_pic_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  profile_views: Array<Espin_Profile_View>;
  /** An aggregate relationship */
  profile_views_aggregate: Espin_Profile_View_Aggregate;
  slug?: Maybe<Scalars['String']>;
  /** An object relationship */
  socials?: Maybe<Espin_Social>;
  socials_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  teams: Array<Espin_Team>;
  /** An aggregate relationship */
  teams_aggregate: Espin_Team_Aggregate;
  updated_at: Scalars['timestamptz'];
  verified: Scalars['Boolean'];
};


/** Entity representing a high school */
export type Espin_High_SchoolFollowsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Order_By>>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};


/** Entity representing a high school */
export type Espin_High_SchoolFollows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Order_By>>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};


/** Entity representing a high school */
export type Espin_High_SchoolHigh_School_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Profile_Order_By>>;
  where?: InputMaybe<Espin_High_School_Profile_Bool_Exp>;
};


/** Entity representing a high school */
export type Espin_High_SchoolHigh_School_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Profile_Order_By>>;
  where?: InputMaybe<Espin_High_School_Profile_Bool_Exp>;
};


/** Entity representing a high school */
export type Espin_High_SchoolPlayer_Profile_Linked_High_SchoolArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};


/** Entity representing a high school */
export type Espin_High_SchoolPlayer_Profile_Linked_High_School_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};


/** Entity representing a high school */
export type Espin_High_SchoolProfile_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};


/** Entity representing a high school */
export type Espin_High_SchoolProfile_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};


/** Entity representing a high school */
export type Espin_High_SchoolTeamsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Order_By>>;
  where?: InputMaybe<Espin_Team_Bool_Exp>;
};


/** Entity representing a high school */
export type Espin_High_SchoolTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Order_By>>;
  where?: InputMaybe<Espin_Team_Bool_Exp>;
};

/** aggregated selection of "espin.high_school" */
export type Espin_High_School_Aggregate = {
  __typename?: 'espin_high_school_aggregate';
  aggregate?: Maybe<Espin_High_School_Aggregate_Fields>;
  nodes: Array<Espin_High_School>;
};

export type Espin_High_School_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Espin_High_School_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Espin_High_School_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Espin_High_School_Aggregate_Bool_Exp_Count>;
};

export type Espin_High_School_Aggregate_Bool_Exp_Bool_And = {
  arguments: Espin_High_School_Select_Column_Espin_High_School_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_High_School_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_High_School_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Espin_High_School_Select_Column_Espin_High_School_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_High_School_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_High_School_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_High_School_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_High_School_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.high_school" */
export type Espin_High_School_Aggregate_Fields = {
  __typename?: 'espin_high_school_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_High_School_Max_Fields>;
  min?: Maybe<Espin_High_School_Min_Fields>;
};


/** aggregate fields of "espin.high_school" */
export type Espin_High_School_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_High_School_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.high_school" */
export type Espin_High_School_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_High_School_Max_Order_By>;
  min?: InputMaybe<Espin_High_School_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.high_school" */
export type Espin_High_School_Arr_Rel_Insert_Input = {
  data: Array<Espin_High_School_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_High_School_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.high_school". All fields are combined with a logical 'AND'. */
export type Espin_High_School_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_High_School_Bool_Exp>>;
  _not?: InputMaybe<Espin_High_School_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_High_School_Bool_Exp>>;
  address?: InputMaybe<Espin_Address_Bool_Exp>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  bio?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_name?: InputMaybe<String_Comparison_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  follows?: InputMaybe<Espin_Follow_Bool_Exp>;
  follows_aggregate?: InputMaybe<Espin_Follow_Aggregate_Bool_Exp>;
  high_school_owner?: InputMaybe<Espin_High_School_Profile_Bool_Exp>;
  high_school_profiles?: InputMaybe<Espin_High_School_Profile_Bool_Exp>;
  high_school_profiles_aggregate?: InputMaybe<Espin_High_School_Profile_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner_profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  player_profile_linked_high_school?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  player_profile_linked_high_school_aggregate?: InputMaybe<Espin_Player_Profile_Aggregate_Bool_Exp>;
  profile_pic_file?: InputMaybe<Content_File_Bool_Exp>;
  profile_pic_id?: InputMaybe<Uuid_Comparison_Exp>;
  profile_views?: InputMaybe<Espin_Profile_View_Bool_Exp>;
  profile_views_aggregate?: InputMaybe<Espin_Profile_View_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  socials?: InputMaybe<Espin_Social_Bool_Exp>;
  socials_id?: InputMaybe<Uuid_Comparison_Exp>;
  teams?: InputMaybe<Espin_Team_Bool_Exp>;
  teams_aggregate?: InputMaybe<Espin_Team_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.high_school" */
export enum Espin_High_School_Constraint {
  /** unique or primary key constraint on columns "id" */
  HighSchoolPkey = 'high_school_pkey',
  /** unique or primary key constraint on columns "slug" */
  HighSchoolSlugKey = 'high_school_slug_key'
}

/** input type for inserting data into table "espin.high_school" */
export type Espin_High_School_Insert_Input = {
  address?: InputMaybe<Espin_Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['uuid']>;
  bio?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_name?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  follows?: InputMaybe<Espin_Follow_Arr_Rel_Insert_Input>;
  high_school_owner?: InputMaybe<Espin_High_School_Profile_Obj_Rel_Insert_Input>;
  high_school_profiles?: InputMaybe<Espin_High_School_Profile_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  owner_profile_id?: InputMaybe<Scalars['uuid']>;
  player_profile_linked_high_school?: InputMaybe<Espin_Player_Profile_Arr_Rel_Insert_Input>;
  profile_pic_file?: InputMaybe<Content_File_Obj_Rel_Insert_Input>;
  profile_pic_id?: InputMaybe<Scalars['uuid']>;
  profile_views?: InputMaybe<Espin_Profile_View_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']>;
  socials?: InputMaybe<Espin_Social_Obj_Rel_Insert_Input>;
  socials_id?: InputMaybe<Scalars['uuid']>;
  teams?: InputMaybe<Espin_Team_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** Invite tracker for high schools */
export type Espin_High_School_Invite = {
  __typename?: 'espin_high_school_invite';
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  /** An object relationship */
  high_school: Espin_High_School;
  high_school_id: Scalars['uuid'];
  id: Scalars['uuid'];
  status: Espin_Invite_Status_Type_Enum;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "espin.high_school_invite" */
export type Espin_High_School_Invite_Aggregate = {
  __typename?: 'espin_high_school_invite_aggregate';
  aggregate?: Maybe<Espin_High_School_Invite_Aggregate_Fields>;
  nodes: Array<Espin_High_School_Invite>;
};

/** aggregate fields of "espin.high_school_invite" */
export type Espin_High_School_Invite_Aggregate_Fields = {
  __typename?: 'espin_high_school_invite_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_High_School_Invite_Max_Fields>;
  min?: Maybe<Espin_High_School_Invite_Min_Fields>;
};


/** aggregate fields of "espin.high_school_invite" */
export type Espin_High_School_Invite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_High_School_Invite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.high_school_invite". All fields are combined with a logical 'AND'. */
export type Espin_High_School_Invite_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_High_School_Invite_Bool_Exp>>;
  _not?: InputMaybe<Espin_High_School_Invite_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_High_School_Invite_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  high_school?: InputMaybe<Espin_High_School_Bool_Exp>;
  high_school_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.high_school_invite" */
export enum Espin_High_School_Invite_Constraint {
  /** unique or primary key constraint on columns "high_school_id", "email" */
  EspinHighSchoolInviteEmailHighSchoolIdKey = 'espin_high_school_invite_email_high_school_id_key',
  /** unique or primary key constraint on columns "email" */
  EspinHighSchoolInviteEmailKey = 'espin_high_school_invite_email_key',
  /** unique or primary key constraint on columns "id" */
  EspinHighSchoolInvitePkey = 'espin_high_school_invite_pkey'
}

/** input type for inserting data into table "espin.high_school_invite" */
export type Espin_High_School_Invite_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  high_school?: InputMaybe<Espin_High_School_Obj_Rel_Insert_Input>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Espin_High_School_Invite_Max_Fields = {
  __typename?: 'espin_high_school_invite_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Espin_High_School_Invite_Min_Fields = {
  __typename?: 'espin_high_school_invite_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "espin.high_school_invite" */
export type Espin_High_School_Invite_Mutation_Response = {
  __typename?: 'espin_high_school_invite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_High_School_Invite>;
};

/** on_conflict condition type for table "espin.high_school_invite" */
export type Espin_High_School_Invite_On_Conflict = {
  constraint: Espin_High_School_Invite_Constraint;
  update_columns?: Array<Espin_High_School_Invite_Update_Column>;
  where?: InputMaybe<Espin_High_School_Invite_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.high_school_invite". */
export type Espin_High_School_Invite_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  high_school?: InputMaybe<Espin_High_School_Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.high_school_invite */
export type Espin_High_School_Invite_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.high_school_invite" */
export enum Espin_High_School_Invite_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "espin.high_school_invite" */
export type Espin_High_School_Invite_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "espin_high_school_invite" */
export type Espin_High_School_Invite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_High_School_Invite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_High_School_Invite_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "espin.high_school_invite" */
export enum Espin_High_School_Invite_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Espin_High_School_Invite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_High_School_Invite_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_High_School_Invite_Bool_Exp;
};

/** aggregate max on columns */
export type Espin_High_School_Max_Fields = {
  __typename?: 'espin_high_school_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_name?: Maybe<Scalars['String']>;
  contact_phone?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  owner_profile_id?: Maybe<Scalars['uuid']>;
  profile_pic_id?: Maybe<Scalars['uuid']>;
  slug?: Maybe<Scalars['String']>;
  socials_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "espin.high_school" */
export type Espin_High_School_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  bio?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_name?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_profile_id?: InputMaybe<Order_By>;
  profile_pic_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  socials_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_High_School_Min_Fields = {
  __typename?: 'espin_high_school_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_name?: Maybe<Scalars['String']>;
  contact_phone?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  owner_profile_id?: Maybe<Scalars['uuid']>;
  profile_pic_id?: Maybe<Scalars['uuid']>;
  slug?: Maybe<Scalars['String']>;
  socials_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "espin.high_school" */
export type Espin_High_School_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  bio?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_name?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_profile_id?: InputMaybe<Order_By>;
  profile_pic_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  socials_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.high_school" */
export type Espin_High_School_Mutation_Response = {
  __typename?: 'espin_high_school_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_High_School>;
};

/** input type for inserting object relation for remote table "espin.high_school" */
export type Espin_High_School_Obj_Rel_Insert_Input = {
  data: Espin_High_School_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_High_School_On_Conflict>;
};

/** on_conflict condition type for table "espin.high_school" */
export type Espin_High_School_On_Conflict = {
  constraint: Espin_High_School_Constraint;
  update_columns?: Array<Espin_High_School_Update_Column>;
  where?: InputMaybe<Espin_High_School_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.high_school". */
export type Espin_High_School_Order_By = {
  address?: InputMaybe<Espin_Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  bio?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_name?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  follows_aggregate?: InputMaybe<Espin_Follow_Aggregate_Order_By>;
  high_school_owner?: InputMaybe<Espin_High_School_Profile_Order_By>;
  high_school_profiles_aggregate?: InputMaybe<Espin_High_School_Profile_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_profile_id?: InputMaybe<Order_By>;
  player_profile_linked_high_school_aggregate?: InputMaybe<Espin_Player_Profile_Aggregate_Order_By>;
  profile_pic_file?: InputMaybe<Content_File_Order_By>;
  profile_pic_id?: InputMaybe<Order_By>;
  profile_views_aggregate?: InputMaybe<Espin_Profile_View_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  socials?: InputMaybe<Espin_Social_Order_By>;
  socials_id?: InputMaybe<Order_By>;
  teams_aggregate?: InputMaybe<Espin_Team_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.high_school */
export type Espin_High_School_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** Profile link of a high school user */
export type Espin_High_School_Profile = {
  __typename?: 'espin_high_school_profile';
  created_at: Scalars['timestamptz'];
  first_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  high_school: Espin_High_School;
  high_school_id: Scalars['uuid'];
  id: Scalars['uuid'];
  last_name?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Espin_User;
  user_id: Scalars['String'];
};

/** aggregated selection of "espin.high_school_profile" */
export type Espin_High_School_Profile_Aggregate = {
  __typename?: 'espin_high_school_profile_aggregate';
  aggregate?: Maybe<Espin_High_School_Profile_Aggregate_Fields>;
  nodes: Array<Espin_High_School_Profile>;
};

export type Espin_High_School_Profile_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_High_School_Profile_Aggregate_Bool_Exp_Count>;
};

export type Espin_High_School_Profile_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_High_School_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_High_School_Profile_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.high_school_profile" */
export type Espin_High_School_Profile_Aggregate_Fields = {
  __typename?: 'espin_high_school_profile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_High_School_Profile_Max_Fields>;
  min?: Maybe<Espin_High_School_Profile_Min_Fields>;
};


/** aggregate fields of "espin.high_school_profile" */
export type Espin_High_School_Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_High_School_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.high_school_profile" */
export type Espin_High_School_Profile_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_High_School_Profile_Max_Order_By>;
  min?: InputMaybe<Espin_High_School_Profile_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.high_school_profile" */
export type Espin_High_School_Profile_Arr_Rel_Insert_Input = {
  data: Array<Espin_High_School_Profile_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_High_School_Profile_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.high_school_profile". All fields are combined with a logical 'AND'. */
export type Espin_High_School_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_High_School_Profile_Bool_Exp>>;
  _not?: InputMaybe<Espin_High_School_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_High_School_Profile_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  high_school?: InputMaybe<Espin_High_School_Bool_Exp>;
  high_school_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Espin_User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.high_school_profile" */
export enum Espin_High_School_Profile_Constraint {
  /** unique or primary key constraint on columns "id" */
  HighSchoolProfilePkey = 'high_school_profile_pkey',
  /** unique or primary key constraint on columns "user_id" */
  HighSchoolProfileUserIdKey = 'high_school_profile_user_id_key'
}

/** input type for inserting data into table "espin.high_school_profile" */
export type Espin_High_School_Profile_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  high_school?: InputMaybe<Espin_High_School_Obj_Rel_Insert_Input>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_High_School_Profile_Max_Fields = {
  __typename?: 'espin_high_school_profile_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.high_school_profile" */
export type Espin_High_School_Profile_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_High_School_Profile_Min_Fields = {
  __typename?: 'espin_high_school_profile_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.high_school_profile" */
export type Espin_High_School_Profile_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.high_school_profile" */
export type Espin_High_School_Profile_Mutation_Response = {
  __typename?: 'espin_high_school_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_High_School_Profile>;
};

/** input type for inserting object relation for remote table "espin.high_school_profile" */
export type Espin_High_School_Profile_Obj_Rel_Insert_Input = {
  data: Espin_High_School_Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_High_School_Profile_On_Conflict>;
};

/** on_conflict condition type for table "espin.high_school_profile" */
export type Espin_High_School_Profile_On_Conflict = {
  constraint: Espin_High_School_Profile_Constraint;
  update_columns?: Array<Espin_High_School_Profile_Update_Column>;
  where?: InputMaybe<Espin_High_School_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.high_school_profile". */
export type Espin_High_School_Profile_Order_By = {
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  high_school?: InputMaybe<Espin_High_School_Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Espin_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.high_school_profile */
export type Espin_High_School_Profile_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.high_school_profile" */
export enum Espin_High_School_Profile_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "espin.high_school_profile" */
export type Espin_High_School_Profile_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_high_school_profile" */
export type Espin_High_School_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_High_School_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_High_School_Profile_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.high_school_profile" */
export enum Espin_High_School_Profile_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Espin_High_School_Profile_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_High_School_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_High_School_Profile_Bool_Exp;
};

/** select columns of table "espin.high_school" */
export enum Espin_High_School_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Bio = 'bio',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerProfileId = 'owner_profile_id',
  /** column name */
  ProfilePicId = 'profile_pic_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  SocialsId = 'socials_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Verified = 'verified'
}

/** select "espin_high_school_aggregate_bool_exp_bool_and_arguments_columns" columns of table "espin.high_school" */
export enum Espin_High_School_Select_Column_Espin_High_School_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Verified = 'verified'
}

/** select "espin_high_school_aggregate_bool_exp_bool_or_arguments_columns" columns of table "espin.high_school" */
export enum Espin_High_School_Select_Column_Espin_High_School_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "espin.high_school" */
export type Espin_High_School_Set_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  bio?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_name?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  owner_profile_id?: InputMaybe<Scalars['uuid']>;
  profile_pic_id?: InputMaybe<Scalars['uuid']>;
  slug?: InputMaybe<Scalars['String']>;
  socials_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "espin_high_school" */
export type Espin_High_School_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_High_School_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_High_School_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  bio?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_name?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  owner_profile_id?: InputMaybe<Scalars['uuid']>;
  profile_pic_id?: InputMaybe<Scalars['uuid']>;
  slug?: InputMaybe<Scalars['String']>;
  socials_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "espin.high_school" */
export enum Espin_High_School_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Bio = 'bio',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerProfileId = 'owner_profile_id',
  /** column name */
  ProfilePicId = 'profile_pic_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  SocialsId = 'socials_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Verified = 'verified'
}

export type Espin_High_School_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_High_School_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_High_School_Bool_Exp;
};

/** Status enum table */
export type Espin_Invite_Status_Type = {
  __typename?: 'espin_invite_status_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.invite_status_type" */
export type Espin_Invite_Status_Type_Aggregate = {
  __typename?: 'espin_invite_status_type_aggregate';
  aggregate?: Maybe<Espin_Invite_Status_Type_Aggregate_Fields>;
  nodes: Array<Espin_Invite_Status_Type>;
};

/** aggregate fields of "espin.invite_status_type" */
export type Espin_Invite_Status_Type_Aggregate_Fields = {
  __typename?: 'espin_invite_status_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Invite_Status_Type_Max_Fields>;
  min?: Maybe<Espin_Invite_Status_Type_Min_Fields>;
};


/** aggregate fields of "espin.invite_status_type" */
export type Espin_Invite_Status_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Invite_Status_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.invite_status_type". All fields are combined with a logical 'AND'. */
export type Espin_Invite_Status_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Invite_Status_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_Invite_Status_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Invite_Status_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.invite_status_type" */
export enum Espin_Invite_Status_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  InviteStatusTypePkey = 'invite_status_type_pkey'
}

export enum Espin_Invite_Status_Type_Enum {
  /** Accepted by user */
  Accepted = 'accepted',
  /** Awaiting confirmation */
  Pending = 'pending'
}

/** Boolean expression to compare columns of type "espin_invite_status_type_enum". All fields are combined with logical 'AND'. */
export type Espin_Invite_Status_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Invite_Status_Type_Enum>;
  _in?: InputMaybe<Array<Espin_Invite_Status_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Invite_Status_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_Invite_Status_Type_Enum>>;
};

/** input type for inserting data into table "espin.invite_status_type" */
export type Espin_Invite_Status_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Invite_Status_Type_Max_Fields = {
  __typename?: 'espin_invite_status_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Invite_Status_Type_Min_Fields = {
  __typename?: 'espin_invite_status_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.invite_status_type" */
export type Espin_Invite_Status_Type_Mutation_Response = {
  __typename?: 'espin_invite_status_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Invite_Status_Type>;
};

/** on_conflict condition type for table "espin.invite_status_type" */
export type Espin_Invite_Status_Type_On_Conflict = {
  constraint: Espin_Invite_Status_Type_Constraint;
  update_columns?: Array<Espin_Invite_Status_Type_Update_Column>;
  where?: InputMaybe<Espin_Invite_Status_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.invite_status_type". */
export type Espin_Invite_Status_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.invite_status_type */
export type Espin_Invite_Status_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.invite_status_type" */
export enum Espin_Invite_Status_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.invite_status_type" */
export type Espin_Invite_Status_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_invite_status_type" */
export type Espin_Invite_Status_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Invite_Status_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Invite_Status_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.invite_status_type" */
export enum Espin_Invite_Status_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Invite_Status_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Invite_Status_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Invite_Status_Type_Bool_Exp;
};

/** columns and relationships of "espin.leaderboard" */
export type Espin_Leaderboard = {
  __typename?: 'espin_leaderboard';
  created_at: Scalars['timestamptz'];
  csv_file_id?: Maybe<Scalars['uuid']>;
  dropdown_label: Scalars['String'];
  /** An object relationship */
  file?: Maybe<Content_File>;
  id: Scalars['uuid'];
  info_contents?: Maybe<Scalars['String']>;
  info_title?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "espin.leaderboard" */
export type Espin_Leaderboard_Aggregate = {
  __typename?: 'espin_leaderboard_aggregate';
  aggregate?: Maybe<Espin_Leaderboard_Aggregate_Fields>;
  nodes: Array<Espin_Leaderboard>;
};

/** aggregate fields of "espin.leaderboard" */
export type Espin_Leaderboard_Aggregate_Fields = {
  __typename?: 'espin_leaderboard_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Leaderboard_Max_Fields>;
  min?: Maybe<Espin_Leaderboard_Min_Fields>;
};


/** aggregate fields of "espin.leaderboard" */
export type Espin_Leaderboard_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Leaderboard_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.leaderboard". All fields are combined with a logical 'AND'. */
export type Espin_Leaderboard_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Leaderboard_Bool_Exp>>;
  _not?: InputMaybe<Espin_Leaderboard_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Leaderboard_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  csv_file_id?: InputMaybe<Uuid_Comparison_Exp>;
  dropdown_label?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Content_File_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  info_contents?: InputMaybe<String_Comparison_Exp>;
  info_title?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.leaderboard" */
export enum Espin_Leaderboard_Constraint {
  /** unique or primary key constraint on columns "id" */
  LeaderboardPkey = 'leaderboard_pkey'
}

/** input type for inserting data into table "espin.leaderboard" */
export type Espin_Leaderboard_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  csv_file_id?: InputMaybe<Scalars['uuid']>;
  dropdown_label?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Content_File_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  info_contents?: InputMaybe<Scalars['String']>;
  info_title?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Espin_Leaderboard_Max_Fields = {
  __typename?: 'espin_leaderboard_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  csv_file_id?: Maybe<Scalars['uuid']>;
  dropdown_label?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  info_contents?: Maybe<Scalars['String']>;
  info_title?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Espin_Leaderboard_Min_Fields = {
  __typename?: 'espin_leaderboard_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  csv_file_id?: Maybe<Scalars['uuid']>;
  dropdown_label?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  info_contents?: Maybe<Scalars['String']>;
  info_title?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "espin.leaderboard" */
export type Espin_Leaderboard_Mutation_Response = {
  __typename?: 'espin_leaderboard_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Leaderboard>;
};

/** on_conflict condition type for table "espin.leaderboard" */
export type Espin_Leaderboard_On_Conflict = {
  constraint: Espin_Leaderboard_Constraint;
  update_columns?: Array<Espin_Leaderboard_Update_Column>;
  where?: InputMaybe<Espin_Leaderboard_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.leaderboard". */
export type Espin_Leaderboard_Order_By = {
  created_at?: InputMaybe<Order_By>;
  csv_file_id?: InputMaybe<Order_By>;
  dropdown_label?: InputMaybe<Order_By>;
  file?: InputMaybe<Content_File_Order_By>;
  id?: InputMaybe<Order_By>;
  info_contents?: InputMaybe<Order_By>;
  info_title?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.leaderboard */
export type Espin_Leaderboard_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.leaderboard" */
export enum Espin_Leaderboard_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CsvFileId = 'csv_file_id',
  /** column name */
  DropdownLabel = 'dropdown_label',
  /** column name */
  Id = 'id',
  /** column name */
  InfoContents = 'info_contents',
  /** column name */
  InfoTitle = 'info_title',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "espin.leaderboard" */
export type Espin_Leaderboard_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  csv_file_id?: InputMaybe<Scalars['uuid']>;
  dropdown_label?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  info_contents?: InputMaybe<Scalars['String']>;
  info_title?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "espin_leaderboard" */
export type Espin_Leaderboard_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Leaderboard_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Leaderboard_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  csv_file_id?: InputMaybe<Scalars['uuid']>;
  dropdown_label?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  info_contents?: InputMaybe<Scalars['String']>;
  info_title?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "espin.leaderboard" */
export enum Espin_Leaderboard_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CsvFileId = 'csv_file_id',
  /** column name */
  DropdownLabel = 'dropdown_label',
  /** column name */
  Id = 'id',
  /** column name */
  InfoContents = 'info_contents',
  /** column name */
  InfoTitle = 'info_title',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Espin_Leaderboard_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Leaderboard_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Leaderboard_Bool_Exp;
};

/** columns and relationships of "espin.membership" */
export type Espin_Membership = {
  __typename?: 'espin_membership';
  is_subscription: Scalars['Boolean'];
  membership: Scalars['String'];
  membership_id: Scalars['Int'];
  price: Scalars['float8'];
};

/** aggregated selection of "espin.membership" */
export type Espin_Membership_Aggregate = {
  __typename?: 'espin_membership_aggregate';
  aggregate?: Maybe<Espin_Membership_Aggregate_Fields>;
  nodes: Array<Espin_Membership>;
};

/** aggregate fields of "espin.membership" */
export type Espin_Membership_Aggregate_Fields = {
  __typename?: 'espin_membership_aggregate_fields';
  avg?: Maybe<Espin_Membership_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Membership_Max_Fields>;
  min?: Maybe<Espin_Membership_Min_Fields>;
  stddev?: Maybe<Espin_Membership_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Membership_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Membership_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Membership_Sum_Fields>;
  var_pop?: Maybe<Espin_Membership_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Membership_Var_Samp_Fields>;
  variance?: Maybe<Espin_Membership_Variance_Fields>;
};


/** aggregate fields of "espin.membership" */
export type Espin_Membership_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Membership_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Espin_Membership_Avg_Fields = {
  __typename?: 'espin_membership_avg_fields';
  membership_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.membership". All fields are combined with a logical 'AND'. */
export type Espin_Membership_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Membership_Bool_Exp>>;
  _not?: InputMaybe<Espin_Membership_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Membership_Bool_Exp>>;
  is_subscription?: InputMaybe<Boolean_Comparison_Exp>;
  membership?: InputMaybe<String_Comparison_Exp>;
  membership_id?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.membership" */
export enum Espin_Membership_Constraint {
  /** unique or primary key constraint on columns "membership_id" */
  MembershipsPkey = 'memberships_pkey'
}

/** input type for incrementing numeric columns in table "espin.membership" */
export type Espin_Membership_Inc_Input = {
  membership_id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "espin.membership" */
export type Espin_Membership_Insert_Input = {
  is_subscription?: InputMaybe<Scalars['Boolean']>;
  membership?: InputMaybe<Scalars['String']>;
  membership_id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Espin_Membership_Max_Fields = {
  __typename?: 'espin_membership_max_fields';
  membership?: Maybe<Scalars['String']>;
  membership_id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type Espin_Membership_Min_Fields = {
  __typename?: 'espin_membership_min_fields';
  membership?: Maybe<Scalars['String']>;
  membership_id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "espin.membership" */
export type Espin_Membership_Mutation_Response = {
  __typename?: 'espin_membership_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Membership>;
};

/** on_conflict condition type for table "espin.membership" */
export type Espin_Membership_On_Conflict = {
  constraint: Espin_Membership_Constraint;
  update_columns?: Array<Espin_Membership_Update_Column>;
  where?: InputMaybe<Espin_Membership_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.membership". */
export type Espin_Membership_Order_By = {
  is_subscription?: InputMaybe<Order_By>;
  membership?: InputMaybe<Order_By>;
  membership_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.membership */
export type Espin_Membership_Pk_Columns_Input = {
  membership_id: Scalars['Int'];
};

/** select columns of table "espin.membership" */
export enum Espin_Membership_Select_Column {
  /** column name */
  IsSubscription = 'is_subscription',
  /** column name */
  Membership = 'membership',
  /** column name */
  MembershipId = 'membership_id',
  /** column name */
  Price = 'price'
}

/** input type for updating data in table "espin.membership" */
export type Espin_Membership_Set_Input = {
  is_subscription?: InputMaybe<Scalars['Boolean']>;
  membership?: InputMaybe<Scalars['String']>;
  membership_id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Espin_Membership_Stddev_Fields = {
  __typename?: 'espin_membership_stddev_fields';
  membership_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_Membership_Stddev_Pop_Fields = {
  __typename?: 'espin_membership_stddev_pop_fields';
  membership_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_Membership_Stddev_Samp_Fields = {
  __typename?: 'espin_membership_stddev_samp_fields';
  membership_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_membership" */
export type Espin_Membership_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Membership_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Membership_Stream_Cursor_Value_Input = {
  is_subscription?: InputMaybe<Scalars['Boolean']>;
  membership?: InputMaybe<Scalars['String']>;
  membership_id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Espin_Membership_Sum_Fields = {
  __typename?: 'espin_membership_sum_fields';
  membership_id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['float8']>;
};

/** update columns of table "espin.membership" */
export enum Espin_Membership_Update_Column {
  /** column name */
  IsSubscription = 'is_subscription',
  /** column name */
  Membership = 'membership',
  /** column name */
  MembershipId = 'membership_id',
  /** column name */
  Price = 'price'
}

export type Espin_Membership_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Membership_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Membership_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Membership_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Membership_Var_Pop_Fields = {
  __typename?: 'espin_membership_var_pop_fields';
  membership_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_Membership_Var_Samp_Fields = {
  __typename?: 'espin_membership_var_samp_fields';
  membership_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_Membership_Variance_Fields = {
  __typename?: 'espin_membership_variance_fields';
  membership_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "espin.message" */
export type Espin_Message = {
  __typename?: 'espin_message';
  /** An object relationship */
  college?: Maybe<Espin_College>;
  college_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  college_user?: Maybe<Espin_User>;
  college_user_id?: Maybe<Scalars['String']>;
  contents: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  high_school?: Maybe<Espin_High_School>;
  high_school_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  high_school_user?: Maybe<Espin_User>;
  high_school_user_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  message_type: Espin_Message_Type_Enum;
  /** An object relationship */
  notification?: Maybe<Espin_Notification>;
  notification_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  parent_user?: Maybe<Espin_User>;
  parent_user_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  player_user?: Maybe<Espin_User>;
  player_user_id?: Maybe<Scalars['String']>;
  viewed_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "espin.message" */
export type Espin_Message_Aggregate = {
  __typename?: 'espin_message_aggregate';
  aggregate?: Maybe<Espin_Message_Aggregate_Fields>;
  nodes: Array<Espin_Message>;
};

export type Espin_Message_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Message_Aggregate_Bool_Exp_Count>;
};

export type Espin_Message_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Message_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.message" */
export type Espin_Message_Aggregate_Fields = {
  __typename?: 'espin_message_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Message_Max_Fields>;
  min?: Maybe<Espin_Message_Min_Fields>;
};


/** aggregate fields of "espin.message" */
export type Espin_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.message" */
export type Espin_Message_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Message_Max_Order_By>;
  min?: InputMaybe<Espin_Message_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.message" */
export type Espin_Message_Arr_Rel_Insert_Input = {
  data: Array<Espin_Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Message_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.message". All fields are combined with a logical 'AND'. */
export type Espin_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Message_Bool_Exp>>;
  _not?: InputMaybe<Espin_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Message_Bool_Exp>>;
  college?: InputMaybe<Espin_College_Bool_Exp>;
  college_id?: InputMaybe<Uuid_Comparison_Exp>;
  college_user?: InputMaybe<Espin_User_Bool_Exp>;
  college_user_id?: InputMaybe<String_Comparison_Exp>;
  contents?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  high_school?: InputMaybe<Espin_High_School_Bool_Exp>;
  high_school_id?: InputMaybe<Uuid_Comparison_Exp>;
  high_school_user?: InputMaybe<Espin_User_Bool_Exp>;
  high_school_user_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message_type?: InputMaybe<Espin_Message_Type_Enum_Comparison_Exp>;
  notification?: InputMaybe<Espin_Notification_Bool_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_user?: InputMaybe<Espin_User_Bool_Exp>;
  parent_user_id?: InputMaybe<String_Comparison_Exp>;
  player_user?: InputMaybe<Espin_User_Bool_Exp>;
  player_user_id?: InputMaybe<String_Comparison_Exp>;
  viewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.message" */
export enum Espin_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessagePkey = 'message_pkey'
}

/** Enum for messages email preference type */
export type Espin_Message_Email_Notification_Type = {
  __typename?: 'espin_message_email_notification_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.message_email_notification_type" */
export type Espin_Message_Email_Notification_Type_Aggregate = {
  __typename?: 'espin_message_email_notification_type_aggregate';
  aggregate?: Maybe<Espin_Message_Email_Notification_Type_Aggregate_Fields>;
  nodes: Array<Espin_Message_Email_Notification_Type>;
};

/** aggregate fields of "espin.message_email_notification_type" */
export type Espin_Message_Email_Notification_Type_Aggregate_Fields = {
  __typename?: 'espin_message_email_notification_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Message_Email_Notification_Type_Max_Fields>;
  min?: Maybe<Espin_Message_Email_Notification_Type_Min_Fields>;
};


/** aggregate fields of "espin.message_email_notification_type" */
export type Espin_Message_Email_Notification_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Message_Email_Notification_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.message_email_notification_type". All fields are combined with a logical 'AND'. */
export type Espin_Message_Email_Notification_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Message_Email_Notification_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_Message_Email_Notification_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Message_Email_Notification_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.message_email_notification_type" */
export enum Espin_Message_Email_Notification_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  MessageEmailNotificationTypePkey = 'message_email_notification_type_pkey'
}

export enum Espin_Message_Email_Notification_Type_Enum {
  /** No emails */
  None = 'none',
  /** One email per month with new conversations started */
  OnePerMonth = 'one_per_month',
  /** One email per new conversation started */
  OnePerNewConversation = 'one_per_new_conversation',
  /** One email per week with new conversations started */
  OnePerWeek = 'one_per_week'
}

/** Boolean expression to compare columns of type "espin_message_email_notification_type_enum". All fields are combined with logical 'AND'. */
export type Espin_Message_Email_Notification_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Message_Email_Notification_Type_Enum>;
  _in?: InputMaybe<Array<Espin_Message_Email_Notification_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Message_Email_Notification_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_Message_Email_Notification_Type_Enum>>;
};

/** input type for inserting data into table "espin.message_email_notification_type" */
export type Espin_Message_Email_Notification_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Message_Email_Notification_Type_Max_Fields = {
  __typename?: 'espin_message_email_notification_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Message_Email_Notification_Type_Min_Fields = {
  __typename?: 'espin_message_email_notification_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.message_email_notification_type" */
export type Espin_Message_Email_Notification_Type_Mutation_Response = {
  __typename?: 'espin_message_email_notification_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Message_Email_Notification_Type>;
};

/** on_conflict condition type for table "espin.message_email_notification_type" */
export type Espin_Message_Email_Notification_Type_On_Conflict = {
  constraint: Espin_Message_Email_Notification_Type_Constraint;
  update_columns?: Array<Espin_Message_Email_Notification_Type_Update_Column>;
  where?: InputMaybe<Espin_Message_Email_Notification_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.message_email_notification_type". */
export type Espin_Message_Email_Notification_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.message_email_notification_type */
export type Espin_Message_Email_Notification_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.message_email_notification_type" */
export enum Espin_Message_Email_Notification_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.message_email_notification_type" */
export type Espin_Message_Email_Notification_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_message_email_notification_type" */
export type Espin_Message_Email_Notification_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Message_Email_Notification_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Message_Email_Notification_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.message_email_notification_type" */
export enum Espin_Message_Email_Notification_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Message_Email_Notification_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Message_Email_Notification_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Message_Email_Notification_Type_Bool_Exp;
};

/** input type for inserting data into table "espin.message" */
export type Espin_Message_Insert_Input = {
  college?: InputMaybe<Espin_College_Obj_Rel_Insert_Input>;
  college_id?: InputMaybe<Scalars['uuid']>;
  college_user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  college_user_id?: InputMaybe<Scalars['String']>;
  contents?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  high_school?: InputMaybe<Espin_High_School_Obj_Rel_Insert_Input>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  high_school_user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  high_school_user_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_type?: InputMaybe<Espin_Message_Type_Enum>;
  notification?: InputMaybe<Espin_Notification_Obj_Rel_Insert_Input>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  parent_user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  parent_user_id?: InputMaybe<Scalars['String']>;
  player_user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  player_user_id?: InputMaybe<Scalars['String']>;
  viewed_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Espin_Message_Max_Fields = {
  __typename?: 'espin_message_max_fields';
  college_id?: Maybe<Scalars['uuid']>;
  college_user_id?: Maybe<Scalars['String']>;
  contents?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  high_school_user_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notification_id?: Maybe<Scalars['uuid']>;
  parent_user_id?: Maybe<Scalars['String']>;
  player_user_id?: Maybe<Scalars['String']>;
  viewed_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "espin.message" */
export type Espin_Message_Max_Order_By = {
  college_id?: InputMaybe<Order_By>;
  college_user_id?: InputMaybe<Order_By>;
  contents?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  high_school_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  parent_user_id?: InputMaybe<Order_By>;
  player_user_id?: InputMaybe<Order_By>;
  viewed_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Message_Min_Fields = {
  __typename?: 'espin_message_min_fields';
  college_id?: Maybe<Scalars['uuid']>;
  college_user_id?: Maybe<Scalars['String']>;
  contents?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  high_school_user_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notification_id?: Maybe<Scalars['uuid']>;
  parent_user_id?: Maybe<Scalars['String']>;
  player_user_id?: Maybe<Scalars['String']>;
  viewed_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "espin.message" */
export type Espin_Message_Min_Order_By = {
  college_id?: InputMaybe<Order_By>;
  college_user_id?: InputMaybe<Order_By>;
  contents?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  high_school_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  parent_user_id?: InputMaybe<Order_By>;
  player_user_id?: InputMaybe<Order_By>;
  viewed_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.message" */
export type Espin_Message_Mutation_Response = {
  __typename?: 'espin_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Message>;
};

/** on_conflict condition type for table "espin.message" */
export type Espin_Message_On_Conflict = {
  constraint: Espin_Message_Constraint;
  update_columns?: Array<Espin_Message_Update_Column>;
  where?: InputMaybe<Espin_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.message". */
export type Espin_Message_Order_By = {
  college?: InputMaybe<Espin_College_Order_By>;
  college_id?: InputMaybe<Order_By>;
  college_user?: InputMaybe<Espin_User_Order_By>;
  college_user_id?: InputMaybe<Order_By>;
  contents?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  high_school?: InputMaybe<Espin_High_School_Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  high_school_user?: InputMaybe<Espin_User_Order_By>;
  high_school_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_type?: InputMaybe<Order_By>;
  notification?: InputMaybe<Espin_Notification_Order_By>;
  notification_id?: InputMaybe<Order_By>;
  parent_user?: InputMaybe<Espin_User_Order_By>;
  parent_user_id?: InputMaybe<Order_By>;
  player_user?: InputMaybe<Espin_User_Order_By>;
  player_user_id?: InputMaybe<Order_By>;
  viewed_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.message */
export type Espin_Message_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.message" */
export enum Espin_Message_Select_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CollegeUserId = 'college_user_id',
  /** column name */
  Contents = 'contents',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  HighSchoolUserId = 'high_school_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  MessageType = 'message_type',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  ParentUserId = 'parent_user_id',
  /** column name */
  PlayerUserId = 'player_user_id',
  /** column name */
  ViewedAt = 'viewed_at'
}

/** input type for updating data in table "espin.message" */
export type Espin_Message_Set_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  college_user_id?: InputMaybe<Scalars['String']>;
  contents?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  high_school_user_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_type?: InputMaybe<Espin_Message_Type_Enum>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  parent_user_id?: InputMaybe<Scalars['String']>;
  player_user_id?: InputMaybe<Scalars['String']>;
  viewed_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "espin_message" */
export type Espin_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Message_Stream_Cursor_Value_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  college_user_id?: InputMaybe<Scalars['String']>;
  contents?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  high_school_user_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_type?: InputMaybe<Espin_Message_Type_Enum>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  parent_user_id?: InputMaybe<Scalars['String']>;
  player_user_id?: InputMaybe<Scalars['String']>;
  viewed_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "espin.message_type" */
export type Espin_Message_Type = {
  __typename?: 'espin_message_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.message_type" */
export type Espin_Message_Type_Aggregate = {
  __typename?: 'espin_message_type_aggregate';
  aggregate?: Maybe<Espin_Message_Type_Aggregate_Fields>;
  nodes: Array<Espin_Message_Type>;
};

/** aggregate fields of "espin.message_type" */
export type Espin_Message_Type_Aggregate_Fields = {
  __typename?: 'espin_message_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Message_Type_Max_Fields>;
  min?: Maybe<Espin_Message_Type_Min_Fields>;
};


/** aggregate fields of "espin.message_type" */
export type Espin_Message_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Message_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.message_type". All fields are combined with a logical 'AND'. */
export type Espin_Message_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Message_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_Message_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Message_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.message_type" */
export enum Espin_Message_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  MessageTypePkey = 'message_type_pkey'
}

export enum Espin_Message_Type_Enum {
  /** SPIN Admin messages a college */
  AdminMessagesCollege = 'admin_messages_college',
  /** SPIN Admin messages a player */
  AdminMessagesPlayer = 'admin_messages_player',
  /** College messages a high school. */
  CollegeMessagesHighSchool = 'college_messages_high_school',
  /** A college messages a player */
  CollegeMessagesPlayer = 'college_messages_player',
  /** High school messages a college . */
  HighSchoolMessagesCollege = 'high_school_messages_college',
  /** A player or parent of a player messages a college */
  PlayerMessagesCollege = 'player_messages_college'
}

/** Boolean expression to compare columns of type "espin_message_type_enum". All fields are combined with logical 'AND'. */
export type Espin_Message_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Message_Type_Enum>;
  _in?: InputMaybe<Array<Espin_Message_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Message_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_Message_Type_Enum>>;
};

/** input type for inserting data into table "espin.message_type" */
export type Espin_Message_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Message_Type_Max_Fields = {
  __typename?: 'espin_message_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Message_Type_Min_Fields = {
  __typename?: 'espin_message_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.message_type" */
export type Espin_Message_Type_Mutation_Response = {
  __typename?: 'espin_message_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Message_Type>;
};

/** on_conflict condition type for table "espin.message_type" */
export type Espin_Message_Type_On_Conflict = {
  constraint: Espin_Message_Type_Constraint;
  update_columns?: Array<Espin_Message_Type_Update_Column>;
  where?: InputMaybe<Espin_Message_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.message_type". */
export type Espin_Message_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.message_type */
export type Espin_Message_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.message_type" */
export enum Espin_Message_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.message_type" */
export type Espin_Message_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_message_type" */
export type Espin_Message_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Message_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Message_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.message_type" */
export enum Espin_Message_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Message_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Message_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Message_Type_Bool_Exp;
};

/** update columns of table "espin.message" */
export enum Espin_Message_Update_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CollegeUserId = 'college_user_id',
  /** column name */
  Contents = 'contents',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  HighSchoolUserId = 'high_school_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  MessageType = 'message_type',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  ParentUserId = 'parent_user_id',
  /** column name */
  PlayerUserId = 'player_user_id',
  /** column name */
  ViewedAt = 'viewed_at'
}

export type Espin_Message_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Message_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Message_Bool_Exp;
};

/** Enum for moderation status on items */
export type Espin_Moderation_Status = {
  __typename?: 'espin_moderation_status';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.moderation_status" */
export type Espin_Moderation_Status_Aggregate = {
  __typename?: 'espin_moderation_status_aggregate';
  aggregate?: Maybe<Espin_Moderation_Status_Aggregate_Fields>;
  nodes: Array<Espin_Moderation_Status>;
};

/** aggregate fields of "espin.moderation_status" */
export type Espin_Moderation_Status_Aggregate_Fields = {
  __typename?: 'espin_moderation_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Moderation_Status_Max_Fields>;
  min?: Maybe<Espin_Moderation_Status_Min_Fields>;
};


/** aggregate fields of "espin.moderation_status" */
export type Espin_Moderation_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Moderation_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.moderation_status". All fields are combined with a logical 'AND'. */
export type Espin_Moderation_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Moderation_Status_Bool_Exp>>;
  _not?: InputMaybe<Espin_Moderation_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Moderation_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.moderation_status" */
export enum Espin_Moderation_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  ModerationStatusPkey = 'moderation_status_pkey'
}

export enum Espin_Moderation_Status_Enum {
  /** Content approved and should be published */
  Approved = 'approved',
  /** Draft process */
  Draft = 'draft',
  /** Pending review by a human */
  PendingManualReview = 'pending_manual_review',
  /** Item is pending review (automatic or manual) */
  PendingReview = 'pending_review',
  /** Rejected for publishing */
  Rejected = 'rejected'
}

/** Boolean expression to compare columns of type "espin_moderation_status_enum". All fields are combined with logical 'AND'. */
export type Espin_Moderation_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Moderation_Status_Enum>;
  _in?: InputMaybe<Array<Espin_Moderation_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Moderation_Status_Enum>;
  _nin?: InputMaybe<Array<Espin_Moderation_Status_Enum>>;
};

/** input type for inserting data into table "espin.moderation_status" */
export type Espin_Moderation_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Moderation_Status_Max_Fields = {
  __typename?: 'espin_moderation_status_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Moderation_Status_Min_Fields = {
  __typename?: 'espin_moderation_status_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.moderation_status" */
export type Espin_Moderation_Status_Mutation_Response = {
  __typename?: 'espin_moderation_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Moderation_Status>;
};

/** input type for inserting object relation for remote table "espin.moderation_status" */
export type Espin_Moderation_Status_Obj_Rel_Insert_Input = {
  data: Espin_Moderation_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Moderation_Status_On_Conflict>;
};

/** on_conflict condition type for table "espin.moderation_status" */
export type Espin_Moderation_Status_On_Conflict = {
  constraint: Espin_Moderation_Status_Constraint;
  update_columns?: Array<Espin_Moderation_Status_Update_Column>;
  where?: InputMaybe<Espin_Moderation_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.moderation_status". */
export type Espin_Moderation_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.moderation_status */
export type Espin_Moderation_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.moderation_status" */
export enum Espin_Moderation_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.moderation_status" */
export type Espin_Moderation_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_moderation_status" */
export type Espin_Moderation_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Moderation_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Moderation_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.moderation_status" */
export enum Espin_Moderation_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Moderation_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Moderation_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Moderation_Status_Bool_Exp;
};

/** columns and relationships of "espin.newsletter_request" */
export type Espin_Newsletter_Request = {
  __typename?: 'espin_newsletter_request';
  email: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['uuid'];
  last_name: Scalars['String'];
};

/** aggregated selection of "espin.newsletter_request" */
export type Espin_Newsletter_Request_Aggregate = {
  __typename?: 'espin_newsletter_request_aggregate';
  aggregate?: Maybe<Espin_Newsletter_Request_Aggregate_Fields>;
  nodes: Array<Espin_Newsletter_Request>;
};

/** aggregate fields of "espin.newsletter_request" */
export type Espin_Newsletter_Request_Aggregate_Fields = {
  __typename?: 'espin_newsletter_request_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Newsletter_Request_Max_Fields>;
  min?: Maybe<Espin_Newsletter_Request_Min_Fields>;
};


/** aggregate fields of "espin.newsletter_request" */
export type Espin_Newsletter_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Newsletter_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.newsletter_request". All fields are combined with a logical 'AND'. */
export type Espin_Newsletter_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Newsletter_Request_Bool_Exp>>;
  _not?: InputMaybe<Espin_Newsletter_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Newsletter_Request_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.newsletter_request" */
export enum Espin_Newsletter_Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  EspinNewsletterRequestPkey = 'espin_newsletter_request_pkey',
  /** unique or primary key constraint on columns "email" */
  NewsletterRequestEmailKey = 'newsletter_request_email_key'
}

/** input type for inserting data into table "espin.newsletter_request" */
export type Espin_Newsletter_Request_Insert_Input = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Newsletter_Request_Max_Fields = {
  __typename?: 'espin_newsletter_request_max_fields';
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Newsletter_Request_Min_Fields = {
  __typename?: 'espin_newsletter_request_min_fields';
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.newsletter_request" */
export type Espin_Newsletter_Request_Mutation_Response = {
  __typename?: 'espin_newsletter_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Newsletter_Request>;
};

/** on_conflict condition type for table "espin.newsletter_request" */
export type Espin_Newsletter_Request_On_Conflict = {
  constraint: Espin_Newsletter_Request_Constraint;
  update_columns?: Array<Espin_Newsletter_Request_Update_Column>;
  where?: InputMaybe<Espin_Newsletter_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.newsletter_request". */
export type Espin_Newsletter_Request_Order_By = {
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.newsletter_request */
export type Espin_Newsletter_Request_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.newsletter_request" */
export enum Espin_Newsletter_Request_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name'
}

/** input type for updating data in table "espin.newsletter_request" */
export type Espin_Newsletter_Request_Set_Input = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_newsletter_request" */
export type Espin_Newsletter_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Newsletter_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Newsletter_Request_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.newsletter_request" */
export enum Espin_Newsletter_Request_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name'
}

export type Espin_Newsletter_Request_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Newsletter_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Newsletter_Request_Bool_Exp;
};

/** Notifications for users and colleges */
export type Espin_Notification = {
  __typename?: 'espin_notification';
  /** An object relationship */
  college?: Maybe<Espin_College>;
  college_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  follows: Array<Espin_Follow>;
  /** An aggregate relationship */
  follows_aggregate: Espin_Follow_Aggregate;
  /** An object relationship */
  high_school?: Maybe<Espin_High_School>;
  high_school_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An array relationship */
  messages: Array<Espin_Message>;
  /** An aggregate relationship */
  messages_aggregate: Espin_Message_Aggregate;
  notification_type: Espin_Notification_Type_Enum;
  /** An object relationship */
  player_user?: Maybe<Espin_User>;
  player_user_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  profile_views: Array<Espin_Profile_View>;
  /** An aggregate relationship */
  profile_views_aggregate: Espin_Profile_View_Aggregate;
  viewed_at?: Maybe<Scalars['timestamptz']>;
};


/** Notifications for users and colleges */
export type Espin_NotificationFollowsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Order_By>>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};


/** Notifications for users and colleges */
export type Espin_NotificationFollows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Order_By>>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};


/** Notifications for users and colleges */
export type Espin_NotificationMessagesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Order_By>>;
  where?: InputMaybe<Espin_Message_Bool_Exp>;
};


/** Notifications for users and colleges */
export type Espin_NotificationMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Order_By>>;
  where?: InputMaybe<Espin_Message_Bool_Exp>;
};


/** Notifications for users and colleges */
export type Espin_NotificationProfile_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};


/** Notifications for users and colleges */
export type Espin_NotificationProfile_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};

/** aggregated selection of "espin.notification" */
export type Espin_Notification_Aggregate = {
  __typename?: 'espin_notification_aggregate';
  aggregate?: Maybe<Espin_Notification_Aggregate_Fields>;
  nodes: Array<Espin_Notification>;
};

/** aggregate fields of "espin.notification" */
export type Espin_Notification_Aggregate_Fields = {
  __typename?: 'espin_notification_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Notification_Max_Fields>;
  min?: Maybe<Espin_Notification_Min_Fields>;
};


/** aggregate fields of "espin.notification" */
export type Espin_Notification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.notification". All fields are combined with a logical 'AND'. */
export type Espin_Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Notification_Bool_Exp>>;
  _not?: InputMaybe<Espin_Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Notification_Bool_Exp>>;
  college?: InputMaybe<Espin_College_Bool_Exp>;
  college_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  follows?: InputMaybe<Espin_Follow_Bool_Exp>;
  follows_aggregate?: InputMaybe<Espin_Follow_Aggregate_Bool_Exp>;
  high_school?: InputMaybe<Espin_High_School_Bool_Exp>;
  high_school_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  messages?: InputMaybe<Espin_Message_Bool_Exp>;
  messages_aggregate?: InputMaybe<Espin_Message_Aggregate_Bool_Exp>;
  notification_type?: InputMaybe<Espin_Notification_Type_Enum_Comparison_Exp>;
  player_user?: InputMaybe<Espin_User_Bool_Exp>;
  player_user_id?: InputMaybe<String_Comparison_Exp>;
  profile_views?: InputMaybe<Espin_Profile_View_Bool_Exp>;
  profile_views_aggregate?: InputMaybe<Espin_Profile_View_Aggregate_Bool_Exp>;
  viewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.notification" */
export enum Espin_Notification_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationPkey = 'notification_pkey'
}

/** input type for inserting data into table "espin.notification" */
export type Espin_Notification_Insert_Input = {
  college?: InputMaybe<Espin_College_Obj_Rel_Insert_Input>;
  college_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  follows?: InputMaybe<Espin_Follow_Arr_Rel_Insert_Input>;
  high_school?: InputMaybe<Espin_High_School_Obj_Rel_Insert_Input>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  messages?: InputMaybe<Espin_Message_Arr_Rel_Insert_Input>;
  notification_type?: InputMaybe<Espin_Notification_Type_Enum>;
  player_user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  player_user_id?: InputMaybe<Scalars['String']>;
  profile_views?: InputMaybe<Espin_Profile_View_Arr_Rel_Insert_Input>;
  viewed_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Espin_Notification_Max_Fields = {
  __typename?: 'espin_notification_max_fields';
  college_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  player_user_id?: Maybe<Scalars['String']>;
  viewed_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Espin_Notification_Min_Fields = {
  __typename?: 'espin_notification_min_fields';
  college_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  player_user_id?: Maybe<Scalars['String']>;
  viewed_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "espin.notification" */
export type Espin_Notification_Mutation_Response = {
  __typename?: 'espin_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Notification>;
};

/** input type for inserting object relation for remote table "espin.notification" */
export type Espin_Notification_Obj_Rel_Insert_Input = {
  data: Espin_Notification_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Notification_On_Conflict>;
};

/** on_conflict condition type for table "espin.notification" */
export type Espin_Notification_On_Conflict = {
  constraint: Espin_Notification_Constraint;
  update_columns?: Array<Espin_Notification_Update_Column>;
  where?: InputMaybe<Espin_Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.notification". */
export type Espin_Notification_Order_By = {
  college?: InputMaybe<Espin_College_Order_By>;
  college_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  follows_aggregate?: InputMaybe<Espin_Follow_Aggregate_Order_By>;
  high_school?: InputMaybe<Espin_High_School_Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Espin_Message_Aggregate_Order_By>;
  notification_type?: InputMaybe<Order_By>;
  player_user?: InputMaybe<Espin_User_Order_By>;
  player_user_id?: InputMaybe<Order_By>;
  profile_views_aggregate?: InputMaybe<Espin_Profile_View_Aggregate_Order_By>;
  viewed_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.notification */
export type Espin_Notification_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.notification" */
export enum Espin_Notification_Select_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationType = 'notification_type',
  /** column name */
  PlayerUserId = 'player_user_id',
  /** column name */
  ViewedAt = 'viewed_at'
}

/** input type for updating data in table "espin.notification" */
export type Espin_Notification_Set_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification_type?: InputMaybe<Espin_Notification_Type_Enum>;
  player_user_id?: InputMaybe<Scalars['String']>;
  viewed_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "espin_notification" */
export type Espin_Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Notification_Stream_Cursor_Value_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification_type?: InputMaybe<Espin_Notification_Type_Enum>;
  player_user_id?: InputMaybe<Scalars['String']>;
  viewed_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Notification type enum */
export type Espin_Notification_Type = {
  __typename?: 'espin_notification_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.notification_type" */
export type Espin_Notification_Type_Aggregate = {
  __typename?: 'espin_notification_type_aggregate';
  aggregate?: Maybe<Espin_Notification_Type_Aggregate_Fields>;
  nodes: Array<Espin_Notification_Type>;
};

/** aggregate fields of "espin.notification_type" */
export type Espin_Notification_Type_Aggregate_Fields = {
  __typename?: 'espin_notification_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Notification_Type_Max_Fields>;
  min?: Maybe<Espin_Notification_Type_Min_Fields>;
};


/** aggregate fields of "espin.notification_type" */
export type Espin_Notification_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Notification_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.notification_type". All fields are combined with a logical 'AND'. */
export type Espin_Notification_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Notification_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_Notification_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Notification_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.notification_type" */
export enum Espin_Notification_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  NotificationTypePkey = 'notification_type_pkey'
}

export enum Espin_Notification_Type_Enum {
  /** Conversation started between player and college. */
  ConversationStarted = 'conversation_started',
  /** User follows another */
  Follow = 'follow',
  /** A player signed up and indicated interest in a college */
  InterestedIn = 'interested_in',
  /** Message between users */
  Message = 'message',
  /** Profile view  */
  ProfileView = 'profile_view',
  /** A recruitment request */
  Recruitment = 'recruitment'
}

/** Boolean expression to compare columns of type "espin_notification_type_enum". All fields are combined with logical 'AND'. */
export type Espin_Notification_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Notification_Type_Enum>;
  _in?: InputMaybe<Array<Espin_Notification_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Notification_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_Notification_Type_Enum>>;
};

/** input type for inserting data into table "espin.notification_type" */
export type Espin_Notification_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Notification_Type_Max_Fields = {
  __typename?: 'espin_notification_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Notification_Type_Min_Fields = {
  __typename?: 'espin_notification_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.notification_type" */
export type Espin_Notification_Type_Mutation_Response = {
  __typename?: 'espin_notification_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Notification_Type>;
};

/** on_conflict condition type for table "espin.notification_type" */
export type Espin_Notification_Type_On_Conflict = {
  constraint: Espin_Notification_Type_Constraint;
  update_columns?: Array<Espin_Notification_Type_Update_Column>;
  where?: InputMaybe<Espin_Notification_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.notification_type". */
export type Espin_Notification_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.notification_type */
export type Espin_Notification_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.notification_type" */
export enum Espin_Notification_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.notification_type" */
export type Espin_Notification_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_notification_type" */
export type Espin_Notification_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Notification_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Notification_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.notification_type" */
export enum Espin_Notification_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Notification_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Notification_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Notification_Type_Bool_Exp;
};

/** update columns of table "espin.notification" */
export enum Espin_Notification_Update_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationType = 'notification_type',
  /** column name */
  PlayerUserId = 'player_user_id',
  /** column name */
  ViewedAt = 'viewed_at'
}

export type Espin_Notification_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Notification_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Notification_Bool_Exp;
};

/** columns and relationships of "espin.org" */
export type Espin_Org = {
  __typename?: 'espin_org';
  definition: Scalars['String'];
  display_name: Scalars['String'];
  id: Scalars['uuid'];
  /** An array relationship */
  org_players: Array<Espin_Org_Player>;
  /** An aggregate relationship */
  org_players_aggregate: Espin_Org_Player_Aggregate;
  /** An array relationship */
  org_schools: Array<Espin_Org_School>;
  /** An aggregate relationship */
  org_schools_aggregate: Espin_Org_School_Aggregate;
};


/** columns and relationships of "espin.org" */
export type Espin_OrgOrg_PlayersArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Player_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Player_Order_By>>;
  where?: InputMaybe<Espin_Org_Player_Bool_Exp>;
};


/** columns and relationships of "espin.org" */
export type Espin_OrgOrg_Players_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Player_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Player_Order_By>>;
  where?: InputMaybe<Espin_Org_Player_Bool_Exp>;
};


/** columns and relationships of "espin.org" */
export type Espin_OrgOrg_SchoolsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_School_Order_By>>;
  where?: InputMaybe<Espin_Org_School_Bool_Exp>;
};


/** columns and relationships of "espin.org" */
export type Espin_OrgOrg_Schools_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_School_Order_By>>;
  where?: InputMaybe<Espin_Org_School_Bool_Exp>;
};

/** aggregated selection of "espin.org" */
export type Espin_Org_Aggregate = {
  __typename?: 'espin_org_aggregate';
  aggregate?: Maybe<Espin_Org_Aggregate_Fields>;
  nodes: Array<Espin_Org>;
};

/** aggregate fields of "espin.org" */
export type Espin_Org_Aggregate_Fields = {
  __typename?: 'espin_org_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Org_Max_Fields>;
  min?: Maybe<Espin_Org_Min_Fields>;
};


/** aggregate fields of "espin.org" */
export type Espin_Org_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Org_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.org". All fields are combined with a logical 'AND'. */
export type Espin_Org_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Org_Bool_Exp>>;
  _not?: InputMaybe<Espin_Org_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Org_Bool_Exp>>;
  definition?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org_players?: InputMaybe<Espin_Org_Player_Bool_Exp>;
  org_players_aggregate?: InputMaybe<Espin_Org_Player_Aggregate_Bool_Exp>;
  org_schools?: InputMaybe<Espin_Org_School_Bool_Exp>;
  org_schools_aggregate?: InputMaybe<Espin_Org_School_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "espin.org" */
export enum Espin_Org_Constraint {
  /** unique or primary key constraint on columns "definition" */
  OrgDefinitionKey = 'org_definition_key',
  /** unique or primary key constraint on columns "id" */
  OrgPkey = 'org_pkey'
}

/** input type for inserting data into table "espin.org" */
export type Espin_Org_Insert_Input = {
  definition?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_players?: InputMaybe<Espin_Org_Player_Arr_Rel_Insert_Input>;
  org_schools?: InputMaybe<Espin_Org_School_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Espin_Org_Max_Fields = {
  __typename?: 'espin_org_max_fields';
  definition?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Espin_Org_Min_Fields = {
  __typename?: 'espin_org_min_fields';
  definition?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "espin.org_month" */
export type Espin_Org_Month = {
  __typename?: 'espin_org_month';
  /** An array relationship */
  days: Array<Espin_Org_Month_Day>;
  /** An aggregate relationship */
  days_aggregate: Espin_Org_Month_Day_Aggregate;
  id: Scalars['uuid'];
  month: Scalars['String'];
  month_of_year?: Maybe<Scalars['Int']>;
  /** An object relationship */
  org: Espin_Org;
  org_id: Scalars['uuid'];
  start_day: Scalars['Int'];
  total_days: Scalars['Int'];
};


/** columns and relationships of "espin.org_month" */
export type Espin_Org_MonthDaysArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Month_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Month_Day_Order_By>>;
  where?: InputMaybe<Espin_Org_Month_Day_Bool_Exp>;
};


/** columns and relationships of "espin.org_month" */
export type Espin_Org_MonthDays_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Month_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Month_Day_Order_By>>;
  where?: InputMaybe<Espin_Org_Month_Day_Bool_Exp>;
};

/** aggregated selection of "espin.org_month" */
export type Espin_Org_Month_Aggregate = {
  __typename?: 'espin_org_month_aggregate';
  aggregate?: Maybe<Espin_Org_Month_Aggregate_Fields>;
  nodes: Array<Espin_Org_Month>;
};

/** aggregate fields of "espin.org_month" */
export type Espin_Org_Month_Aggregate_Fields = {
  __typename?: 'espin_org_month_aggregate_fields';
  avg?: Maybe<Espin_Org_Month_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Org_Month_Max_Fields>;
  min?: Maybe<Espin_Org_Month_Min_Fields>;
  stddev?: Maybe<Espin_Org_Month_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Org_Month_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Org_Month_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Org_Month_Sum_Fields>;
  var_pop?: Maybe<Espin_Org_Month_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Org_Month_Var_Samp_Fields>;
  variance?: Maybe<Espin_Org_Month_Variance_Fields>;
};


/** aggregate fields of "espin.org_month" */
export type Espin_Org_Month_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Org_Month_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Espin_Org_Month_Avg_Fields = {
  __typename?: 'espin_org_month_avg_fields';
  month_of_year?: Maybe<Scalars['Float']>;
  start_day?: Maybe<Scalars['Float']>;
  total_days?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.org_month". All fields are combined with a logical 'AND'. */
export type Espin_Org_Month_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Org_Month_Bool_Exp>>;
  _not?: InputMaybe<Espin_Org_Month_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Org_Month_Bool_Exp>>;
  days?: InputMaybe<Espin_Org_Month_Day_Bool_Exp>;
  days_aggregate?: InputMaybe<Espin_Org_Month_Day_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  month?: InputMaybe<String_Comparison_Exp>;
  month_of_year?: InputMaybe<Int_Comparison_Exp>;
  org?: InputMaybe<Espin_Org_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_day?: InputMaybe<Int_Comparison_Exp>;
  total_days?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.org_month" */
export enum Espin_Org_Month_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrgMonthPkey = 'org_month_pkey'
}

/** columns and relationships of "espin.org_month_day" */
export type Espin_Org_Month_Day = {
  __typename?: 'espin_org_month_day';
  date: Scalars['Int'];
  /** An object relationship */
  game?: Maybe<Espin_Game>;
  game_def?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  month: Espin_Org_Month;
  org_month_id: Scalars['uuid'];
  time?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

/** aggregated selection of "espin.org_month_day" */
export type Espin_Org_Month_Day_Aggregate = {
  __typename?: 'espin_org_month_day_aggregate';
  aggregate?: Maybe<Espin_Org_Month_Day_Aggregate_Fields>;
  nodes: Array<Espin_Org_Month_Day>;
};

export type Espin_Org_Month_Day_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Org_Month_Day_Aggregate_Bool_Exp_Count>;
};

export type Espin_Org_Month_Day_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Org_Month_Day_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Org_Month_Day_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.org_month_day" */
export type Espin_Org_Month_Day_Aggregate_Fields = {
  __typename?: 'espin_org_month_day_aggregate_fields';
  avg?: Maybe<Espin_Org_Month_Day_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Org_Month_Day_Max_Fields>;
  min?: Maybe<Espin_Org_Month_Day_Min_Fields>;
  stddev?: Maybe<Espin_Org_Month_Day_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Org_Month_Day_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Org_Month_Day_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Org_Month_Day_Sum_Fields>;
  var_pop?: Maybe<Espin_Org_Month_Day_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Org_Month_Day_Var_Samp_Fields>;
  variance?: Maybe<Espin_Org_Month_Day_Variance_Fields>;
};


/** aggregate fields of "espin.org_month_day" */
export type Espin_Org_Month_Day_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Org_Month_Day_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.org_month_day" */
export type Espin_Org_Month_Day_Aggregate_Order_By = {
  avg?: InputMaybe<Espin_Org_Month_Day_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Org_Month_Day_Max_Order_By>;
  min?: InputMaybe<Espin_Org_Month_Day_Min_Order_By>;
  stddev?: InputMaybe<Espin_Org_Month_Day_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Espin_Org_Month_Day_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Espin_Org_Month_Day_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Espin_Org_Month_Day_Sum_Order_By>;
  var_pop?: InputMaybe<Espin_Org_Month_Day_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Espin_Org_Month_Day_Var_Samp_Order_By>;
  variance?: InputMaybe<Espin_Org_Month_Day_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "espin.org_month_day" */
export type Espin_Org_Month_Day_Arr_Rel_Insert_Input = {
  data: Array<Espin_Org_Month_Day_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Org_Month_Day_On_Conflict>;
};

/** aggregate avg on columns */
export type Espin_Org_Month_Day_Avg_Fields = {
  __typename?: 'espin_org_month_day_avg_fields';
  date?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "espin.org_month_day" */
export type Espin_Org_Month_Day_Avg_Order_By = {
  date?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "espin.org_month_day". All fields are combined with a logical 'AND'. */
export type Espin_Org_Month_Day_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Org_Month_Day_Bool_Exp>>;
  _not?: InputMaybe<Espin_Org_Month_Day_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Org_Month_Day_Bool_Exp>>;
  date?: InputMaybe<Int_Comparison_Exp>;
  game?: InputMaybe<Espin_Game_Bool_Exp>;
  game_def?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  month?: InputMaybe<Espin_Org_Month_Bool_Exp>;
  org_month_id?: InputMaybe<Uuid_Comparison_Exp>;
  time?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.org_month_day" */
export enum Espin_Org_Month_Day_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrgMonthDayPkey = 'org_month_day_pkey'
}

/** input type for incrementing numeric columns in table "espin.org_month_day" */
export type Espin_Org_Month_Day_Inc_Input = {
  date?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.org_month_day" */
export type Espin_Org_Month_Day_Insert_Input = {
  date?: InputMaybe<Scalars['Int']>;
  game?: InputMaybe<Espin_Game_Obj_Rel_Insert_Input>;
  game_def?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  month?: InputMaybe<Espin_Org_Month_Obj_Rel_Insert_Input>;
  org_month_id?: InputMaybe<Scalars['uuid']>;
  time?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Org_Month_Day_Max_Fields = {
  __typename?: 'espin_org_month_day_max_fields';
  date?: Maybe<Scalars['Int']>;
  game_def?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  org_month_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.org_month_day" */
export type Espin_Org_Month_Day_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  game_def?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_month_id?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Org_Month_Day_Min_Fields = {
  __typename?: 'espin_org_month_day_min_fields';
  date?: Maybe<Scalars['Int']>;
  game_def?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  org_month_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.org_month_day" */
export type Espin_Org_Month_Day_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  game_def?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_month_id?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.org_month_day" */
export type Espin_Org_Month_Day_Mutation_Response = {
  __typename?: 'espin_org_month_day_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Org_Month_Day>;
};

/** on_conflict condition type for table "espin.org_month_day" */
export type Espin_Org_Month_Day_On_Conflict = {
  constraint: Espin_Org_Month_Day_Constraint;
  update_columns?: Array<Espin_Org_Month_Day_Update_Column>;
  where?: InputMaybe<Espin_Org_Month_Day_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.org_month_day". */
export type Espin_Org_Month_Day_Order_By = {
  date?: InputMaybe<Order_By>;
  game?: InputMaybe<Espin_Game_Order_By>;
  game_def?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Espin_Org_Month_Order_By>;
  org_month_id?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.org_month_day */
export type Espin_Org_Month_Day_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.org_month_day" */
export enum Espin_Org_Month_Day_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  GameDef = 'game_def',
  /** column name */
  Id = 'id',
  /** column name */
  OrgMonthId = 'org_month_id',
  /** column name */
  Time = 'time',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "espin.org_month_day" */
export type Espin_Org_Month_Day_Set_Input = {
  date?: InputMaybe<Scalars['Int']>;
  game_def?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_month_id?: InputMaybe<Scalars['uuid']>;
  time?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Espin_Org_Month_Day_Stddev_Fields = {
  __typename?: 'espin_org_month_day_stddev_fields';
  date?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "espin.org_month_day" */
export type Espin_Org_Month_Day_Stddev_Order_By = {
  date?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Espin_Org_Month_Day_Stddev_Pop_Fields = {
  __typename?: 'espin_org_month_day_stddev_pop_fields';
  date?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "espin.org_month_day" */
export type Espin_Org_Month_Day_Stddev_Pop_Order_By = {
  date?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Espin_Org_Month_Day_Stddev_Samp_Fields = {
  __typename?: 'espin_org_month_day_stddev_samp_fields';
  date?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "espin.org_month_day" */
export type Espin_Org_Month_Day_Stddev_Samp_Order_By = {
  date?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "espin_org_month_day" */
export type Espin_Org_Month_Day_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Org_Month_Day_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Org_Month_Day_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['Int']>;
  game_def?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_month_id?: InputMaybe<Scalars['uuid']>;
  time?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Espin_Org_Month_Day_Sum_Fields = {
  __typename?: 'espin_org_month_day_sum_fields';
  date?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "espin.org_month_day" */
export type Espin_Org_Month_Day_Sum_Order_By = {
  date?: InputMaybe<Order_By>;
};

/** update columns of table "espin.org_month_day" */
export enum Espin_Org_Month_Day_Update_Column {
  /** column name */
  Date = 'date',
  /** column name */
  GameDef = 'game_def',
  /** column name */
  Id = 'id',
  /** column name */
  OrgMonthId = 'org_month_id',
  /** column name */
  Time = 'time',
  /** column name */
  Title = 'title'
}

export type Espin_Org_Month_Day_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Org_Month_Day_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Org_Month_Day_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Org_Month_Day_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Org_Month_Day_Var_Pop_Fields = {
  __typename?: 'espin_org_month_day_var_pop_fields';
  date?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "espin.org_month_day" */
export type Espin_Org_Month_Day_Var_Pop_Order_By = {
  date?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Espin_Org_Month_Day_Var_Samp_Fields = {
  __typename?: 'espin_org_month_day_var_samp_fields';
  date?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "espin.org_month_day" */
export type Espin_Org_Month_Day_Var_Samp_Order_By = {
  date?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Espin_Org_Month_Day_Variance_Fields = {
  __typename?: 'espin_org_month_day_variance_fields';
  date?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "espin.org_month_day" */
export type Espin_Org_Month_Day_Variance_Order_By = {
  date?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "espin.org_month" */
export type Espin_Org_Month_Inc_Input = {
  month_of_year?: InputMaybe<Scalars['Int']>;
  start_day?: InputMaybe<Scalars['Int']>;
  total_days?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.org_month" */
export type Espin_Org_Month_Insert_Input = {
  days?: InputMaybe<Espin_Org_Month_Day_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  month?: InputMaybe<Scalars['String']>;
  month_of_year?: InputMaybe<Scalars['Int']>;
  org?: InputMaybe<Espin_Org_Obj_Rel_Insert_Input>;
  org_id?: InputMaybe<Scalars['uuid']>;
  start_day?: InputMaybe<Scalars['Int']>;
  total_days?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Espin_Org_Month_Max_Fields = {
  __typename?: 'espin_org_month_max_fields';
  id?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['String']>;
  month_of_year?: Maybe<Scalars['Int']>;
  org_id?: Maybe<Scalars['uuid']>;
  start_day?: Maybe<Scalars['Int']>;
  total_days?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Espin_Org_Month_Min_Fields = {
  __typename?: 'espin_org_month_min_fields';
  id?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['String']>;
  month_of_year?: Maybe<Scalars['Int']>;
  org_id?: Maybe<Scalars['uuid']>;
  start_day?: Maybe<Scalars['Int']>;
  total_days?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "espin.org_month" */
export type Espin_Org_Month_Mutation_Response = {
  __typename?: 'espin_org_month_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Org_Month>;
};

/** input type for inserting object relation for remote table "espin.org_month" */
export type Espin_Org_Month_Obj_Rel_Insert_Input = {
  data: Espin_Org_Month_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Org_Month_On_Conflict>;
};

/** on_conflict condition type for table "espin.org_month" */
export type Espin_Org_Month_On_Conflict = {
  constraint: Espin_Org_Month_Constraint;
  update_columns?: Array<Espin_Org_Month_Update_Column>;
  where?: InputMaybe<Espin_Org_Month_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.org_month". */
export type Espin_Org_Month_Order_By = {
  days_aggregate?: InputMaybe<Espin_Org_Month_Day_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  month_of_year?: InputMaybe<Order_By>;
  org?: InputMaybe<Espin_Org_Order_By>;
  org_id?: InputMaybe<Order_By>;
  start_day?: InputMaybe<Order_By>;
  total_days?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.org_month */
export type Espin_Org_Month_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.org_month" */
export enum Espin_Org_Month_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  MonthOfYear = 'month_of_year',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  StartDay = 'start_day',
  /** column name */
  TotalDays = 'total_days'
}

/** input type for updating data in table "espin.org_month" */
export type Espin_Org_Month_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  month?: InputMaybe<Scalars['String']>;
  month_of_year?: InputMaybe<Scalars['Int']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  start_day?: InputMaybe<Scalars['Int']>;
  total_days?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Espin_Org_Month_Stddev_Fields = {
  __typename?: 'espin_org_month_stddev_fields';
  month_of_year?: Maybe<Scalars['Float']>;
  start_day?: Maybe<Scalars['Float']>;
  total_days?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_Org_Month_Stddev_Pop_Fields = {
  __typename?: 'espin_org_month_stddev_pop_fields';
  month_of_year?: Maybe<Scalars['Float']>;
  start_day?: Maybe<Scalars['Float']>;
  total_days?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_Org_Month_Stddev_Samp_Fields = {
  __typename?: 'espin_org_month_stddev_samp_fields';
  month_of_year?: Maybe<Scalars['Float']>;
  start_day?: Maybe<Scalars['Float']>;
  total_days?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_org_month" */
export type Espin_Org_Month_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Org_Month_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Org_Month_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  month?: InputMaybe<Scalars['String']>;
  month_of_year?: InputMaybe<Scalars['Int']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  start_day?: InputMaybe<Scalars['Int']>;
  total_days?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Espin_Org_Month_Sum_Fields = {
  __typename?: 'espin_org_month_sum_fields';
  month_of_year?: Maybe<Scalars['Int']>;
  start_day?: Maybe<Scalars['Int']>;
  total_days?: Maybe<Scalars['Int']>;
};

/** update columns of table "espin.org_month" */
export enum Espin_Org_Month_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  MonthOfYear = 'month_of_year',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  StartDay = 'start_day',
  /** column name */
  TotalDays = 'total_days'
}

export type Espin_Org_Month_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Org_Month_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Org_Month_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Org_Month_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Org_Month_Var_Pop_Fields = {
  __typename?: 'espin_org_month_var_pop_fields';
  month_of_year?: Maybe<Scalars['Float']>;
  start_day?: Maybe<Scalars['Float']>;
  total_days?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_Org_Month_Var_Samp_Fields = {
  __typename?: 'espin_org_month_var_samp_fields';
  month_of_year?: Maybe<Scalars['Float']>;
  start_day?: Maybe<Scalars['Float']>;
  total_days?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_Org_Month_Variance_Fields = {
  __typename?: 'espin_org_month_variance_fields';
  month_of_year?: Maybe<Scalars['Float']>;
  start_day?: Maybe<Scalars['Float']>;
  total_days?: Maybe<Scalars['Float']>;
};

/** response of any mutation on the table "espin.org" */
export type Espin_Org_Mutation_Response = {
  __typename?: 'espin_org_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Org>;
};

/** input type for inserting object relation for remote table "espin.org" */
export type Espin_Org_Obj_Rel_Insert_Input = {
  data: Espin_Org_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Org_On_Conflict>;
};

/** on_conflict condition type for table "espin.org" */
export type Espin_Org_On_Conflict = {
  constraint: Espin_Org_Constraint;
  update_columns?: Array<Espin_Org_Update_Column>;
  where?: InputMaybe<Espin_Org_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.org". */
export type Espin_Org_Order_By = {
  definition?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_players_aggregate?: InputMaybe<Espin_Org_Player_Aggregate_Order_By>;
  org_schools_aggregate?: InputMaybe<Espin_Org_School_Aggregate_Order_By>;
};

/** primary key columns input for table: espin.org */
export type Espin_Org_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "espin.org_player" */
export type Espin_Org_Player = {
  __typename?: 'espin_org_player';
  committed: Scalars['Boolean'];
  featured: Scalars['Boolean'];
  /** An object relationship */
  game?: Maybe<Espin_Game>;
  game_id?: Maybe<Scalars['String']>;
  game_rank?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['numeric']>;
  grad_class?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  /** An object relationship */
  org: Espin_Org;
  org_id: Scalars['uuid'];
  player_id?: Maybe<Scalars['uuid']>;
  player_review?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  /** An object relationship */
  school?: Maybe<Espin_Org_School>;
  school_id?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregated selection of "espin.org_player" */
export type Espin_Org_Player_Aggregate = {
  __typename?: 'espin_org_player_aggregate';
  aggregate?: Maybe<Espin_Org_Player_Aggregate_Fields>;
  nodes: Array<Espin_Org_Player>;
};

export type Espin_Org_Player_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Espin_Org_Player_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Espin_Org_Player_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Espin_Org_Player_Aggregate_Bool_Exp_Count>;
};

export type Espin_Org_Player_Aggregate_Bool_Exp_Bool_And = {
  arguments: Espin_Org_Player_Select_Column_Espin_Org_Player_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Org_Player_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_Org_Player_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Espin_Org_Player_Select_Column_Espin_Org_Player_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Org_Player_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_Org_Player_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Org_Player_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Org_Player_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.org_player" */
export type Espin_Org_Player_Aggregate_Fields = {
  __typename?: 'espin_org_player_aggregate_fields';
  avg?: Maybe<Espin_Org_Player_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Org_Player_Max_Fields>;
  min?: Maybe<Espin_Org_Player_Min_Fields>;
  stddev?: Maybe<Espin_Org_Player_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Org_Player_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Org_Player_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Org_Player_Sum_Fields>;
  var_pop?: Maybe<Espin_Org_Player_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Org_Player_Var_Samp_Fields>;
  variance?: Maybe<Espin_Org_Player_Variance_Fields>;
};


/** aggregate fields of "espin.org_player" */
export type Espin_Org_Player_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Org_Player_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.org_player" */
export type Espin_Org_Player_Aggregate_Order_By = {
  avg?: InputMaybe<Espin_Org_Player_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Org_Player_Max_Order_By>;
  min?: InputMaybe<Espin_Org_Player_Min_Order_By>;
  stddev?: InputMaybe<Espin_Org_Player_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Espin_Org_Player_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Espin_Org_Player_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Espin_Org_Player_Sum_Order_By>;
  var_pop?: InputMaybe<Espin_Org_Player_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Espin_Org_Player_Var_Samp_Order_By>;
  variance?: InputMaybe<Espin_Org_Player_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "espin.org_player" */
export type Espin_Org_Player_Arr_Rel_Insert_Input = {
  data: Array<Espin_Org_Player_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Org_Player_On_Conflict>;
};

/** aggregate avg on columns */
export type Espin_Org_Player_Avg_Fields = {
  __typename?: 'espin_org_player_avg_fields';
  gpa?: Maybe<Scalars['Float']>;
  grad_class?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "espin.org_player" */
export type Espin_Org_Player_Avg_Order_By = {
  gpa?: InputMaybe<Order_By>;
  grad_class?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "espin.org_player". All fields are combined with a logical 'AND'. */
export type Espin_Org_Player_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Org_Player_Bool_Exp>>;
  _not?: InputMaybe<Espin_Org_Player_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Org_Player_Bool_Exp>>;
  committed?: InputMaybe<Boolean_Comparison_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  game?: InputMaybe<Espin_Game_Bool_Exp>;
  game_id?: InputMaybe<String_Comparison_Exp>;
  game_rank?: InputMaybe<String_Comparison_Exp>;
  gpa?: InputMaybe<Numeric_Comparison_Exp>;
  grad_class?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org?: InputMaybe<Espin_Org_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  player_id?: InputMaybe<Uuid_Comparison_Exp>;
  player_review?: InputMaybe<String_Comparison_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  school?: InputMaybe<Espin_Org_School_Bool_Exp>;
  school_id?: InputMaybe<Uuid_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.org_player" */
export enum Espin_Org_Player_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrgPlayerPkey = 'org_player_pkey'
}

/** input type for incrementing numeric columns in table "espin.org_player" */
export type Espin_Org_Player_Inc_Input = {
  gpa?: InputMaybe<Scalars['numeric']>;
  grad_class?: InputMaybe<Scalars['Int']>;
  rank?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.org_player" */
export type Espin_Org_Player_Insert_Input = {
  committed?: InputMaybe<Scalars['Boolean']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  game?: InputMaybe<Espin_Game_Obj_Rel_Insert_Input>;
  game_id?: InputMaybe<Scalars['String']>;
  game_rank?: InputMaybe<Scalars['String']>;
  gpa?: InputMaybe<Scalars['numeric']>;
  grad_class?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  org?: InputMaybe<Espin_Org_Obj_Rel_Insert_Input>;
  org_id?: InputMaybe<Scalars['uuid']>;
  player_id?: InputMaybe<Scalars['uuid']>;
  player_review?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['Int']>;
  school?: InputMaybe<Espin_Org_School_Obj_Rel_Insert_Input>;
  school_id?: InputMaybe<Scalars['uuid']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Org_Player_Max_Fields = {
  __typename?: 'espin_org_player_max_fields';
  game_id?: Maybe<Scalars['String']>;
  game_rank?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['numeric']>;
  grad_class?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  player_id?: Maybe<Scalars['uuid']>;
  player_review?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  school_id?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.org_player" */
export type Espin_Org_Player_Max_Order_By = {
  game_id?: InputMaybe<Order_By>;
  game_rank?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  grad_class?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  player_id?: InputMaybe<Order_By>;
  player_review?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  school_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Org_Player_Min_Fields = {
  __typename?: 'espin_org_player_min_fields';
  game_id?: Maybe<Scalars['String']>;
  game_rank?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['numeric']>;
  grad_class?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  player_id?: Maybe<Scalars['uuid']>;
  player_review?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  school_id?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.org_player" */
export type Espin_Org_Player_Min_Order_By = {
  game_id?: InputMaybe<Order_By>;
  game_rank?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  grad_class?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  player_id?: InputMaybe<Order_By>;
  player_review?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  school_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.org_player" */
export type Espin_Org_Player_Mutation_Response = {
  __typename?: 'espin_org_player_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Org_Player>;
};

/** on_conflict condition type for table "espin.org_player" */
export type Espin_Org_Player_On_Conflict = {
  constraint: Espin_Org_Player_Constraint;
  update_columns?: Array<Espin_Org_Player_Update_Column>;
  where?: InputMaybe<Espin_Org_Player_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.org_player". */
export type Espin_Org_Player_Order_By = {
  committed?: InputMaybe<Order_By>;
  featured?: InputMaybe<Order_By>;
  game?: InputMaybe<Espin_Game_Order_By>;
  game_id?: InputMaybe<Order_By>;
  game_rank?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  grad_class?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org?: InputMaybe<Espin_Org_Order_By>;
  org_id?: InputMaybe<Order_By>;
  player_id?: InputMaybe<Order_By>;
  player_review?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  school?: InputMaybe<Espin_Org_School_Order_By>;
  school_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.org_player */
export type Espin_Org_Player_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.org_player" */
export enum Espin_Org_Player_Select_Column {
  /** column name */
  Committed = 'committed',
  /** column name */
  Featured = 'featured',
  /** column name */
  GameId = 'game_id',
  /** column name */
  GameRank = 'game_rank',
  /** column name */
  Gpa = 'gpa',
  /** column name */
  GradClass = 'grad_class',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  PlayerId = 'player_id',
  /** column name */
  PlayerReview = 'player_review',
  /** column name */
  Rank = 'rank',
  /** column name */
  SchoolId = 'school_id',
  /** column name */
  Username = 'username'
}

/** select "espin_org_player_aggregate_bool_exp_bool_and_arguments_columns" columns of table "espin.org_player" */
export enum Espin_Org_Player_Select_Column_Espin_Org_Player_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Committed = 'committed',
  /** column name */
  Featured = 'featured'
}

/** select "espin_org_player_aggregate_bool_exp_bool_or_arguments_columns" columns of table "espin.org_player" */
export enum Espin_Org_Player_Select_Column_Espin_Org_Player_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Committed = 'committed',
  /** column name */
  Featured = 'featured'
}

/** input type for updating data in table "espin.org_player" */
export type Espin_Org_Player_Set_Input = {
  committed?: InputMaybe<Scalars['Boolean']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  game_id?: InputMaybe<Scalars['String']>;
  game_rank?: InputMaybe<Scalars['String']>;
  gpa?: InputMaybe<Scalars['numeric']>;
  grad_class?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  player_id?: InputMaybe<Scalars['uuid']>;
  player_review?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['Int']>;
  school_id?: InputMaybe<Scalars['uuid']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Espin_Org_Player_Stddev_Fields = {
  __typename?: 'espin_org_player_stddev_fields';
  gpa?: Maybe<Scalars['Float']>;
  grad_class?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "espin.org_player" */
export type Espin_Org_Player_Stddev_Order_By = {
  gpa?: InputMaybe<Order_By>;
  grad_class?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Espin_Org_Player_Stddev_Pop_Fields = {
  __typename?: 'espin_org_player_stddev_pop_fields';
  gpa?: Maybe<Scalars['Float']>;
  grad_class?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "espin.org_player" */
export type Espin_Org_Player_Stddev_Pop_Order_By = {
  gpa?: InputMaybe<Order_By>;
  grad_class?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Espin_Org_Player_Stddev_Samp_Fields = {
  __typename?: 'espin_org_player_stddev_samp_fields';
  gpa?: Maybe<Scalars['Float']>;
  grad_class?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "espin.org_player" */
export type Espin_Org_Player_Stddev_Samp_Order_By = {
  gpa?: InputMaybe<Order_By>;
  grad_class?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "espin_org_player" */
export type Espin_Org_Player_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Org_Player_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Org_Player_Stream_Cursor_Value_Input = {
  committed?: InputMaybe<Scalars['Boolean']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  game_id?: InputMaybe<Scalars['String']>;
  game_rank?: InputMaybe<Scalars['String']>;
  gpa?: InputMaybe<Scalars['numeric']>;
  grad_class?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  player_id?: InputMaybe<Scalars['uuid']>;
  player_review?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['Int']>;
  school_id?: InputMaybe<Scalars['uuid']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Espin_Org_Player_Sum_Fields = {
  __typename?: 'espin_org_player_sum_fields';
  gpa?: Maybe<Scalars['numeric']>;
  grad_class?: Maybe<Scalars['Int']>;
  rank?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "espin.org_player" */
export type Espin_Org_Player_Sum_Order_By = {
  gpa?: InputMaybe<Order_By>;
  grad_class?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** update columns of table "espin.org_player" */
export enum Espin_Org_Player_Update_Column {
  /** column name */
  Committed = 'committed',
  /** column name */
  Featured = 'featured',
  /** column name */
  GameId = 'game_id',
  /** column name */
  GameRank = 'game_rank',
  /** column name */
  Gpa = 'gpa',
  /** column name */
  GradClass = 'grad_class',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  PlayerId = 'player_id',
  /** column name */
  PlayerReview = 'player_review',
  /** column name */
  Rank = 'rank',
  /** column name */
  SchoolId = 'school_id',
  /** column name */
  Username = 'username'
}

export type Espin_Org_Player_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Org_Player_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Org_Player_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Org_Player_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Org_Player_Var_Pop_Fields = {
  __typename?: 'espin_org_player_var_pop_fields';
  gpa?: Maybe<Scalars['Float']>;
  grad_class?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "espin.org_player" */
export type Espin_Org_Player_Var_Pop_Order_By = {
  gpa?: InputMaybe<Order_By>;
  grad_class?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Espin_Org_Player_Var_Samp_Fields = {
  __typename?: 'espin_org_player_var_samp_fields';
  gpa?: Maybe<Scalars['Float']>;
  grad_class?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "espin.org_player" */
export type Espin_Org_Player_Var_Samp_Order_By = {
  gpa?: InputMaybe<Order_By>;
  grad_class?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Espin_Org_Player_Variance_Fields = {
  __typename?: 'espin_org_player_variance_fields';
  gpa?: Maybe<Scalars['Float']>;
  grad_class?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "espin.org_player" */
export type Espin_Org_Player_Variance_Order_By = {
  gpa?: InputMaybe<Order_By>;
  grad_class?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** columns and relationships of "espin.org_school" */
export type Espin_Org_School = {
  __typename?: 'espin_org_school';
  bio?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  definition: Scalars['String'];
  display_name: Scalars['String'];
  featured: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  org: Espin_Org;
  org_id: Scalars['uuid'];
  rank?: Maybe<Scalars['Int']>;
  /** An array relationship */
  records: Array<Espin_Org_School_Record>;
  /** An aggregate relationship */
  records_aggregate: Espin_Org_School_Record_Aggregate;
  state?: Maybe<Scalars['String']>;
};


/** columns and relationships of "espin.org_school" */
export type Espin_Org_SchoolRecordsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_School_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_School_Record_Order_By>>;
  where?: InputMaybe<Espin_Org_School_Record_Bool_Exp>;
};


/** columns and relationships of "espin.org_school" */
export type Espin_Org_SchoolRecords_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_School_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_School_Record_Order_By>>;
  where?: InputMaybe<Espin_Org_School_Record_Bool_Exp>;
};

/** aggregated selection of "espin.org_school" */
export type Espin_Org_School_Aggregate = {
  __typename?: 'espin_org_school_aggregate';
  aggregate?: Maybe<Espin_Org_School_Aggregate_Fields>;
  nodes: Array<Espin_Org_School>;
};

export type Espin_Org_School_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Espin_Org_School_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Espin_Org_School_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Espin_Org_School_Aggregate_Bool_Exp_Count>;
};

export type Espin_Org_School_Aggregate_Bool_Exp_Bool_And = {
  arguments: Espin_Org_School_Select_Column_Espin_Org_School_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Org_School_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_Org_School_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Espin_Org_School_Select_Column_Espin_Org_School_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Org_School_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_Org_School_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Org_School_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Org_School_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.org_school" */
export type Espin_Org_School_Aggregate_Fields = {
  __typename?: 'espin_org_school_aggregate_fields';
  avg?: Maybe<Espin_Org_School_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Org_School_Max_Fields>;
  min?: Maybe<Espin_Org_School_Min_Fields>;
  stddev?: Maybe<Espin_Org_School_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Org_School_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Org_School_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Org_School_Sum_Fields>;
  var_pop?: Maybe<Espin_Org_School_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Org_School_Var_Samp_Fields>;
  variance?: Maybe<Espin_Org_School_Variance_Fields>;
};


/** aggregate fields of "espin.org_school" */
export type Espin_Org_School_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Org_School_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.org_school" */
export type Espin_Org_School_Aggregate_Order_By = {
  avg?: InputMaybe<Espin_Org_School_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Org_School_Max_Order_By>;
  min?: InputMaybe<Espin_Org_School_Min_Order_By>;
  stddev?: InputMaybe<Espin_Org_School_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Espin_Org_School_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Espin_Org_School_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Espin_Org_School_Sum_Order_By>;
  var_pop?: InputMaybe<Espin_Org_School_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Espin_Org_School_Var_Samp_Order_By>;
  variance?: InputMaybe<Espin_Org_School_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "espin.org_school" */
export type Espin_Org_School_Arr_Rel_Insert_Input = {
  data: Array<Espin_Org_School_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Org_School_On_Conflict>;
};

/** aggregate avg on columns */
export type Espin_Org_School_Avg_Fields = {
  __typename?: 'espin_org_school_avg_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "espin.org_school" */
export type Espin_Org_School_Avg_Order_By = {
  rank?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "espin.org_school". All fields are combined with a logical 'AND'. */
export type Espin_Org_School_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Org_School_Bool_Exp>>;
  _not?: InputMaybe<Espin_Org_School_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Org_School_Bool_Exp>>;
  bio?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  definition?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org?: InputMaybe<Espin_Org_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  records?: InputMaybe<Espin_Org_School_Record_Bool_Exp>;
  records_aggregate?: InputMaybe<Espin_Org_School_Record_Aggregate_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.org_school" */
export enum Espin_Org_School_Constraint {
  /** unique or primary key constraint on columns "definition" */
  OrgSchoolDefinitionKey = 'org_school_definition_key',
  /** unique or primary key constraint on columns "id" */
  OrgSchoolPkey = 'org_school_pkey'
}

/** input type for incrementing numeric columns in table "espin.org_school" */
export type Espin_Org_School_Inc_Input = {
  rank?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.org_school" */
export type Espin_Org_School_Insert_Input = {
  bio?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  definition?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  org?: InputMaybe<Espin_Org_Obj_Rel_Insert_Input>;
  org_id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Int']>;
  records?: InputMaybe<Espin_Org_School_Record_Arr_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Org_School_Max_Fields = {
  __typename?: 'espin_org_school_max_fields';
  bio?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  definition?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  rank?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.org_school" */
export type Espin_Org_School_Max_Order_By = {
  bio?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  definition?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Org_School_Min_Fields = {
  __typename?: 'espin_org_school_min_fields';
  bio?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  definition?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  rank?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.org_school" */
export type Espin_Org_School_Min_Order_By = {
  bio?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  definition?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.org_school" */
export type Espin_Org_School_Mutation_Response = {
  __typename?: 'espin_org_school_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Org_School>;
};

/** input type for inserting object relation for remote table "espin.org_school" */
export type Espin_Org_School_Obj_Rel_Insert_Input = {
  data: Espin_Org_School_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Org_School_On_Conflict>;
};

/** on_conflict condition type for table "espin.org_school" */
export type Espin_Org_School_On_Conflict = {
  constraint: Espin_Org_School_Constraint;
  update_columns?: Array<Espin_Org_School_Update_Column>;
  where?: InputMaybe<Espin_Org_School_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.org_school". */
export type Espin_Org_School_Order_By = {
  bio?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  definition?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  featured?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org?: InputMaybe<Espin_Org_Order_By>;
  org_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  records_aggregate?: InputMaybe<Espin_Org_School_Record_Aggregate_Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.org_school */
export type Espin_Org_School_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "espin.org_school_record" */
export type Espin_Org_School_Record = {
  __typename?: 'espin_org_school_record';
  /** An object relationship */
  game: Espin_Game;
  game_def: Scalars['String'];
  id: Scalars['uuid'];
  losses: Scalars['Int'];
  org_school_id: Scalars['uuid'];
  /** An object relationship */
  school: Espin_Org_School;
  wins: Scalars['Int'];
};

/** aggregated selection of "espin.org_school_record" */
export type Espin_Org_School_Record_Aggregate = {
  __typename?: 'espin_org_school_record_aggregate';
  aggregate?: Maybe<Espin_Org_School_Record_Aggregate_Fields>;
  nodes: Array<Espin_Org_School_Record>;
};

export type Espin_Org_School_Record_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Org_School_Record_Aggregate_Bool_Exp_Count>;
};

export type Espin_Org_School_Record_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Org_School_Record_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Org_School_Record_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.org_school_record" */
export type Espin_Org_School_Record_Aggregate_Fields = {
  __typename?: 'espin_org_school_record_aggregate_fields';
  avg?: Maybe<Espin_Org_School_Record_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Org_School_Record_Max_Fields>;
  min?: Maybe<Espin_Org_School_Record_Min_Fields>;
  stddev?: Maybe<Espin_Org_School_Record_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Org_School_Record_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Org_School_Record_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Org_School_Record_Sum_Fields>;
  var_pop?: Maybe<Espin_Org_School_Record_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Org_School_Record_Var_Samp_Fields>;
  variance?: Maybe<Espin_Org_School_Record_Variance_Fields>;
};


/** aggregate fields of "espin.org_school_record" */
export type Espin_Org_School_Record_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Org_School_Record_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.org_school_record" */
export type Espin_Org_School_Record_Aggregate_Order_By = {
  avg?: InputMaybe<Espin_Org_School_Record_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Org_School_Record_Max_Order_By>;
  min?: InputMaybe<Espin_Org_School_Record_Min_Order_By>;
  stddev?: InputMaybe<Espin_Org_School_Record_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Espin_Org_School_Record_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Espin_Org_School_Record_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Espin_Org_School_Record_Sum_Order_By>;
  var_pop?: InputMaybe<Espin_Org_School_Record_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Espin_Org_School_Record_Var_Samp_Order_By>;
  variance?: InputMaybe<Espin_Org_School_Record_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "espin.org_school_record" */
export type Espin_Org_School_Record_Arr_Rel_Insert_Input = {
  data: Array<Espin_Org_School_Record_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Org_School_Record_On_Conflict>;
};

/** aggregate avg on columns */
export type Espin_Org_School_Record_Avg_Fields = {
  __typename?: 'espin_org_school_record_avg_fields';
  losses?: Maybe<Scalars['Float']>;
  wins?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "espin.org_school_record" */
export type Espin_Org_School_Record_Avg_Order_By = {
  losses?: InputMaybe<Order_By>;
  wins?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "espin.org_school_record". All fields are combined with a logical 'AND'. */
export type Espin_Org_School_Record_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Org_School_Record_Bool_Exp>>;
  _not?: InputMaybe<Espin_Org_School_Record_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Org_School_Record_Bool_Exp>>;
  game?: InputMaybe<Espin_Game_Bool_Exp>;
  game_def?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  losses?: InputMaybe<Int_Comparison_Exp>;
  org_school_id?: InputMaybe<Uuid_Comparison_Exp>;
  school?: InputMaybe<Espin_Org_School_Bool_Exp>;
  wins?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.org_school_record" */
export enum Espin_Org_School_Record_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrgSchoolRecordPkey = 'org_school_record_pkey'
}

/** input type for incrementing numeric columns in table "espin.org_school_record" */
export type Espin_Org_School_Record_Inc_Input = {
  losses?: InputMaybe<Scalars['Int']>;
  wins?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.org_school_record" */
export type Espin_Org_School_Record_Insert_Input = {
  game?: InputMaybe<Espin_Game_Obj_Rel_Insert_Input>;
  game_def?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  losses?: InputMaybe<Scalars['Int']>;
  org_school_id?: InputMaybe<Scalars['uuid']>;
  school?: InputMaybe<Espin_Org_School_Obj_Rel_Insert_Input>;
  wins?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Espin_Org_School_Record_Max_Fields = {
  __typename?: 'espin_org_school_record_max_fields';
  game_def?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  losses?: Maybe<Scalars['Int']>;
  org_school_id?: Maybe<Scalars['uuid']>;
  wins?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "espin.org_school_record" */
export type Espin_Org_School_Record_Max_Order_By = {
  game_def?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  losses?: InputMaybe<Order_By>;
  org_school_id?: InputMaybe<Order_By>;
  wins?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Org_School_Record_Min_Fields = {
  __typename?: 'espin_org_school_record_min_fields';
  game_def?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  losses?: Maybe<Scalars['Int']>;
  org_school_id?: Maybe<Scalars['uuid']>;
  wins?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "espin.org_school_record" */
export type Espin_Org_School_Record_Min_Order_By = {
  game_def?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  losses?: InputMaybe<Order_By>;
  org_school_id?: InputMaybe<Order_By>;
  wins?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.org_school_record" */
export type Espin_Org_School_Record_Mutation_Response = {
  __typename?: 'espin_org_school_record_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Org_School_Record>;
};

/** on_conflict condition type for table "espin.org_school_record" */
export type Espin_Org_School_Record_On_Conflict = {
  constraint: Espin_Org_School_Record_Constraint;
  update_columns?: Array<Espin_Org_School_Record_Update_Column>;
  where?: InputMaybe<Espin_Org_School_Record_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.org_school_record". */
export type Espin_Org_School_Record_Order_By = {
  game?: InputMaybe<Espin_Game_Order_By>;
  game_def?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  losses?: InputMaybe<Order_By>;
  org_school_id?: InputMaybe<Order_By>;
  school?: InputMaybe<Espin_Org_School_Order_By>;
  wins?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.org_school_record */
export type Espin_Org_School_Record_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.org_school_record" */
export enum Espin_Org_School_Record_Select_Column {
  /** column name */
  GameDef = 'game_def',
  /** column name */
  Id = 'id',
  /** column name */
  Losses = 'losses',
  /** column name */
  OrgSchoolId = 'org_school_id',
  /** column name */
  Wins = 'wins'
}

/** input type for updating data in table "espin.org_school_record" */
export type Espin_Org_School_Record_Set_Input = {
  game_def?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  losses?: InputMaybe<Scalars['Int']>;
  org_school_id?: InputMaybe<Scalars['uuid']>;
  wins?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Espin_Org_School_Record_Stddev_Fields = {
  __typename?: 'espin_org_school_record_stddev_fields';
  losses?: Maybe<Scalars['Float']>;
  wins?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "espin.org_school_record" */
export type Espin_Org_School_Record_Stddev_Order_By = {
  losses?: InputMaybe<Order_By>;
  wins?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Espin_Org_School_Record_Stddev_Pop_Fields = {
  __typename?: 'espin_org_school_record_stddev_pop_fields';
  losses?: Maybe<Scalars['Float']>;
  wins?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "espin.org_school_record" */
export type Espin_Org_School_Record_Stddev_Pop_Order_By = {
  losses?: InputMaybe<Order_By>;
  wins?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Espin_Org_School_Record_Stddev_Samp_Fields = {
  __typename?: 'espin_org_school_record_stddev_samp_fields';
  losses?: Maybe<Scalars['Float']>;
  wins?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "espin.org_school_record" */
export type Espin_Org_School_Record_Stddev_Samp_Order_By = {
  losses?: InputMaybe<Order_By>;
  wins?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "espin_org_school_record" */
export type Espin_Org_School_Record_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Org_School_Record_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Org_School_Record_Stream_Cursor_Value_Input = {
  game_def?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  losses?: InputMaybe<Scalars['Int']>;
  org_school_id?: InputMaybe<Scalars['uuid']>;
  wins?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Espin_Org_School_Record_Sum_Fields = {
  __typename?: 'espin_org_school_record_sum_fields';
  losses?: Maybe<Scalars['Int']>;
  wins?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "espin.org_school_record" */
export type Espin_Org_School_Record_Sum_Order_By = {
  losses?: InputMaybe<Order_By>;
  wins?: InputMaybe<Order_By>;
};

/** update columns of table "espin.org_school_record" */
export enum Espin_Org_School_Record_Update_Column {
  /** column name */
  GameDef = 'game_def',
  /** column name */
  Id = 'id',
  /** column name */
  Losses = 'losses',
  /** column name */
  OrgSchoolId = 'org_school_id',
  /** column name */
  Wins = 'wins'
}

export type Espin_Org_School_Record_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Org_School_Record_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Org_School_Record_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Org_School_Record_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Org_School_Record_Var_Pop_Fields = {
  __typename?: 'espin_org_school_record_var_pop_fields';
  losses?: Maybe<Scalars['Float']>;
  wins?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "espin.org_school_record" */
export type Espin_Org_School_Record_Var_Pop_Order_By = {
  losses?: InputMaybe<Order_By>;
  wins?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Espin_Org_School_Record_Var_Samp_Fields = {
  __typename?: 'espin_org_school_record_var_samp_fields';
  losses?: Maybe<Scalars['Float']>;
  wins?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "espin.org_school_record" */
export type Espin_Org_School_Record_Var_Samp_Order_By = {
  losses?: InputMaybe<Order_By>;
  wins?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Espin_Org_School_Record_Variance_Fields = {
  __typename?: 'espin_org_school_record_variance_fields';
  losses?: Maybe<Scalars['Float']>;
  wins?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "espin.org_school_record" */
export type Espin_Org_School_Record_Variance_Order_By = {
  losses?: InputMaybe<Order_By>;
  wins?: InputMaybe<Order_By>;
};

/** select columns of table "espin.org_school" */
export enum Espin_Org_School_Select_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  City = 'city',
  /** column name */
  Definition = 'definition',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Featured = 'featured',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  State = 'state'
}

/** select "espin_org_school_aggregate_bool_exp_bool_and_arguments_columns" columns of table "espin.org_school" */
export enum Espin_Org_School_Select_Column_Espin_Org_School_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Featured = 'featured'
}

/** select "espin_org_school_aggregate_bool_exp_bool_or_arguments_columns" columns of table "espin.org_school" */
export enum Espin_Org_School_Select_Column_Espin_Org_School_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Featured = 'featured'
}

/** input type for updating data in table "espin.org_school" */
export type Espin_Org_School_Set_Input = {
  bio?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  definition?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Espin_Org_School_Stddev_Fields = {
  __typename?: 'espin_org_school_stddev_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "espin.org_school" */
export type Espin_Org_School_Stddev_Order_By = {
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Espin_Org_School_Stddev_Pop_Fields = {
  __typename?: 'espin_org_school_stddev_pop_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "espin.org_school" */
export type Espin_Org_School_Stddev_Pop_Order_By = {
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Espin_Org_School_Stddev_Samp_Fields = {
  __typename?: 'espin_org_school_stddev_samp_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "espin.org_school" */
export type Espin_Org_School_Stddev_Samp_Order_By = {
  rank?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "espin_org_school" */
export type Espin_Org_School_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Org_School_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Org_School_Stream_Cursor_Value_Input = {
  bio?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  definition?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Espin_Org_School_Sum_Fields = {
  __typename?: 'espin_org_school_sum_fields';
  rank?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "espin.org_school" */
export type Espin_Org_School_Sum_Order_By = {
  rank?: InputMaybe<Order_By>;
};

/** update columns of table "espin.org_school" */
export enum Espin_Org_School_Update_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  City = 'city',
  /** column name */
  Definition = 'definition',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Featured = 'featured',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  State = 'state'
}

export type Espin_Org_School_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Org_School_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Org_School_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Org_School_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Org_School_Var_Pop_Fields = {
  __typename?: 'espin_org_school_var_pop_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "espin.org_school" */
export type Espin_Org_School_Var_Pop_Order_By = {
  rank?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Espin_Org_School_Var_Samp_Fields = {
  __typename?: 'espin_org_school_var_samp_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "espin.org_school" */
export type Espin_Org_School_Var_Samp_Order_By = {
  rank?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Espin_Org_School_Variance_Fields = {
  __typename?: 'espin_org_school_variance_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "espin.org_school" */
export type Espin_Org_School_Variance_Order_By = {
  rank?: InputMaybe<Order_By>;
};

/** select columns of table "espin.org" */
export enum Espin_Org_Select_Column {
  /** column name */
  Definition = 'definition',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "espin.org" */
export type Espin_Org_Set_Input = {
  definition?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "espin_org" */
export type Espin_Org_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Org_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Org_Stream_Cursor_Value_Input = {
  definition?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "espin.org" */
export enum Espin_Org_Update_Column {
  /** column name */
  Definition = 'definition',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id'
}

export type Espin_Org_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Org_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Org_Bool_Exp;
};

/** Product table */
export type Espin_Paid_Product = {
  __typename?: 'espin_paid_product';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.paid_product" */
export type Espin_Paid_Product_Aggregate = {
  __typename?: 'espin_paid_product_aggregate';
  aggregate?: Maybe<Espin_Paid_Product_Aggregate_Fields>;
  nodes: Array<Espin_Paid_Product>;
};

/** aggregate fields of "espin.paid_product" */
export type Espin_Paid_Product_Aggregate_Fields = {
  __typename?: 'espin_paid_product_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Paid_Product_Max_Fields>;
  min?: Maybe<Espin_Paid_Product_Min_Fields>;
};


/** aggregate fields of "espin.paid_product" */
export type Espin_Paid_Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Paid_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.paid_product". All fields are combined with a logical 'AND'. */
export type Espin_Paid_Product_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Paid_Product_Bool_Exp>>;
  _not?: InputMaybe<Espin_Paid_Product_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Paid_Product_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.paid_product" */
export enum Espin_Paid_Product_Constraint {
  /** unique or primary key constraint on columns "name" */
  PaidProductPkey = 'paid_product_pkey'
}

export enum Espin_Paid_Product_Enum {
  /** College yearly premium subscription */
  CollegePremiumYearly = 'college_premium_yearly',
  /** Player premium monthly plan */
  PlayerPremiumMonthly = 'player_premium_monthly',
  /** Player premium yearly plan */
  PlayerPremiumYearly = 'player_premium_yearly',
  /** Gold College Yearly Plan */
  TierOneCollegeYearlyPlan = 'tier_one_college_yearly_plan',
  /** Diamond College Yearly Plan */
  TierThreeCollegeYearlyPlan = 'tier_three_college_yearly_plan',
  /** Platinum College Yearly Plan */
  TierTwoCollegeYearlyPlan = 'tier_two_college_yearly_plan'
}

/** Boolean expression to compare columns of type "espin_paid_product_enum". All fields are combined with logical 'AND'. */
export type Espin_Paid_Product_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Paid_Product_Enum>;
  _in?: InputMaybe<Array<Espin_Paid_Product_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Paid_Product_Enum>;
  _nin?: InputMaybe<Array<Espin_Paid_Product_Enum>>;
};

/** input type for inserting data into table "espin.paid_product" */
export type Espin_Paid_Product_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Paid_Product_Max_Fields = {
  __typename?: 'espin_paid_product_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Paid_Product_Min_Fields = {
  __typename?: 'espin_paid_product_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.paid_product" */
export type Espin_Paid_Product_Mutation_Response = {
  __typename?: 'espin_paid_product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Paid_Product>;
};

/** on_conflict condition type for table "espin.paid_product" */
export type Espin_Paid_Product_On_Conflict = {
  constraint: Espin_Paid_Product_Constraint;
  update_columns?: Array<Espin_Paid_Product_Update_Column>;
  where?: InputMaybe<Espin_Paid_Product_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.paid_product". */
export type Espin_Paid_Product_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.paid_product */
export type Espin_Paid_Product_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.paid_product" */
export enum Espin_Paid_Product_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.paid_product" */
export type Espin_Paid_Product_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_paid_product" */
export type Espin_Paid_Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Paid_Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Paid_Product_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.paid_product" */
export enum Espin_Paid_Product_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Paid_Product_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Paid_Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Paid_Product_Bool_Exp;
};

/** Holds parent invites */
export type Espin_Parent_Invite = {
  __typename?: 'espin_parent_invite';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  parent_email: Scalars['String'];
  /** An object relationship */
  player_profile: Espin_Player_Profile;
  player_profile_id: Scalars['uuid'];
  status: Espin_Invite_Status_Type_Enum;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "espin.parent_invite" */
export type Espin_Parent_Invite_Aggregate = {
  __typename?: 'espin_parent_invite_aggregate';
  aggregate?: Maybe<Espin_Parent_Invite_Aggregate_Fields>;
  nodes: Array<Espin_Parent_Invite>;
};

/** aggregate fields of "espin.parent_invite" */
export type Espin_Parent_Invite_Aggregate_Fields = {
  __typename?: 'espin_parent_invite_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Parent_Invite_Max_Fields>;
  min?: Maybe<Espin_Parent_Invite_Min_Fields>;
};


/** aggregate fields of "espin.parent_invite" */
export type Espin_Parent_Invite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Parent_Invite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.parent_invite". All fields are combined with a logical 'AND'. */
export type Espin_Parent_Invite_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Parent_Invite_Bool_Exp>>;
  _not?: InputMaybe<Espin_Parent_Invite_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Parent_Invite_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_email?: InputMaybe<String_Comparison_Exp>;
  player_profile?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  player_profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.parent_invite" */
export enum Espin_Parent_Invite_Constraint {
  /** unique or primary key constraint on columns "id" */
  ParentInvitePkey = 'parent_invite_pkey'
}

/** input type for inserting data into table "espin.parent_invite" */
export type Espin_Parent_Invite_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parent_email?: InputMaybe<Scalars['String']>;
  player_profile?: InputMaybe<Espin_Player_Profile_Obj_Rel_Insert_Input>;
  player_profile_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Espin_Parent_Invite_Max_Fields = {
  __typename?: 'espin_parent_invite_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_email?: Maybe<Scalars['String']>;
  player_profile_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Espin_Parent_Invite_Min_Fields = {
  __typename?: 'espin_parent_invite_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_email?: Maybe<Scalars['String']>;
  player_profile_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "espin.parent_invite" */
export type Espin_Parent_Invite_Mutation_Response = {
  __typename?: 'espin_parent_invite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Parent_Invite>;
};

/** on_conflict condition type for table "espin.parent_invite" */
export type Espin_Parent_Invite_On_Conflict = {
  constraint: Espin_Parent_Invite_Constraint;
  update_columns?: Array<Espin_Parent_Invite_Update_Column>;
  where?: InputMaybe<Espin_Parent_Invite_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.parent_invite". */
export type Espin_Parent_Invite_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_email?: InputMaybe<Order_By>;
  player_profile?: InputMaybe<Espin_Player_Profile_Order_By>;
  player_profile_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.parent_invite */
export type Espin_Parent_Invite_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.parent_invite" */
export enum Espin_Parent_Invite_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentEmail = 'parent_email',
  /** column name */
  PlayerProfileId = 'player_profile_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "espin.parent_invite" */
export type Espin_Parent_Invite_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parent_email?: InputMaybe<Scalars['String']>;
  player_profile_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "espin_parent_invite" */
export type Espin_Parent_Invite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Parent_Invite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Parent_Invite_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parent_email?: InputMaybe<Scalars['String']>;
  player_profile_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "espin.parent_invite" */
export enum Espin_Parent_Invite_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentEmail = 'parent_email',
  /** column name */
  PlayerProfileId = 'player_profile_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Espin_Parent_Invite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Parent_Invite_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Parent_Invite_Bool_Exp;
};

/** Profile info for a parent */
export type Espin_Parent_Profile = {
  __typename?: 'espin_parent_profile';
  /** An object relationship */
  address?: Maybe<Espin_Address>;
  address_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  child_profiles: Array<Espin_Player_Profile>;
  /** An aggregate relationship */
  child_profiles_aggregate: Espin_Player_Profile_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user?: Maybe<Espin_User>;
  user_id?: Maybe<Scalars['String']>;
};


/** Profile info for a parent */
export type Espin_Parent_ProfileChild_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};


/** Profile info for a parent */
export type Espin_Parent_ProfileChild_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};

/** aggregated selection of "espin.parent_profile" */
export type Espin_Parent_Profile_Aggregate = {
  __typename?: 'espin_parent_profile_aggregate';
  aggregate?: Maybe<Espin_Parent_Profile_Aggregate_Fields>;
  nodes: Array<Espin_Parent_Profile>;
};

export type Espin_Parent_Profile_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Parent_Profile_Aggregate_Bool_Exp_Count>;
};

export type Espin_Parent_Profile_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Parent_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Parent_Profile_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.parent_profile" */
export type Espin_Parent_Profile_Aggregate_Fields = {
  __typename?: 'espin_parent_profile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Parent_Profile_Max_Fields>;
  min?: Maybe<Espin_Parent_Profile_Min_Fields>;
};


/** aggregate fields of "espin.parent_profile" */
export type Espin_Parent_Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Parent_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.parent_profile" */
export type Espin_Parent_Profile_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Parent_Profile_Max_Order_By>;
  min?: InputMaybe<Espin_Parent_Profile_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.parent_profile" */
export type Espin_Parent_Profile_Arr_Rel_Insert_Input = {
  data: Array<Espin_Parent_Profile_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Parent_Profile_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.parent_profile". All fields are combined with a logical 'AND'. */
export type Espin_Parent_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Parent_Profile_Bool_Exp>>;
  _not?: InputMaybe<Espin_Parent_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Parent_Profile_Bool_Exp>>;
  address?: InputMaybe<Espin_Address_Bool_Exp>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  child_profiles?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  child_profiles_aggregate?: InputMaybe<Espin_Player_Profile_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Espin_User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.parent_profile" */
export enum Espin_Parent_Profile_Constraint {
  /** unique or primary key constraint on columns "address_id" */
  ParentProfileAddressIdKey = 'parent_profile_address_id_key',
  /** unique or primary key constraint on columns "id" */
  ParentProfilePkey = 'parent_profile_pkey',
  /** unique or primary key constraint on columns "user_id" */
  ParentProfileUserIdKey = 'parent_profile_user_id_key'
}

/** input type for inserting data into table "espin.parent_profile" */
export type Espin_Parent_Profile_Insert_Input = {
  address?: InputMaybe<Espin_Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['uuid']>;
  child_profiles?: InputMaybe<Espin_Player_Profile_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Parent_Profile_Max_Fields = {
  __typename?: 'espin_parent_profile_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.parent_profile" */
export type Espin_Parent_Profile_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Parent_Profile_Min_Fields = {
  __typename?: 'espin_parent_profile_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.parent_profile" */
export type Espin_Parent_Profile_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.parent_profile" */
export type Espin_Parent_Profile_Mutation_Response = {
  __typename?: 'espin_parent_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Parent_Profile>;
};

/** input type for inserting object relation for remote table "espin.parent_profile" */
export type Espin_Parent_Profile_Obj_Rel_Insert_Input = {
  data: Espin_Parent_Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Parent_Profile_On_Conflict>;
};

/** on_conflict condition type for table "espin.parent_profile" */
export type Espin_Parent_Profile_On_Conflict = {
  constraint: Espin_Parent_Profile_Constraint;
  update_columns?: Array<Espin_Parent_Profile_Update_Column>;
  where?: InputMaybe<Espin_Parent_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.parent_profile". */
export type Espin_Parent_Profile_Order_By = {
  address?: InputMaybe<Espin_Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  child_profiles_aggregate?: InputMaybe<Espin_Player_Profile_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Espin_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.parent_profile */
export type Espin_Parent_Profile_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.parent_profile" */
export enum Espin_Parent_Profile_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "espin.parent_profile" */
export type Espin_Parent_Profile_Set_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_parent_profile" */
export type Espin_Parent_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Parent_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Parent_Profile_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.parent_profile" */
export enum Espin_Parent_Profile_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Espin_Parent_Profile_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Parent_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Parent_Profile_Bool_Exp;
};

/** columns and relationships of "espin.player_game" */
export type Espin_Player_Game = {
  __typename?: 'espin_player_game';
  /** An object relationship */
  game: Espin_Game;
  game_id: Scalars['String'];
  id: Scalars['uuid'];
  in_game_username?: Maybe<Scalars['String']>;
  /** An object relationship */
  player_profile: Espin_Player_Profile;
  primary: Scalars['Boolean'];
  profile_id: Scalars['uuid'];
  rank?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  tracker?: Maybe<Scalars['String']>;
};

/** aggregated selection of "espin.player_game" */
export type Espin_Player_Game_Aggregate = {
  __typename?: 'espin_player_game_aggregate';
  aggregate?: Maybe<Espin_Player_Game_Aggregate_Fields>;
  nodes: Array<Espin_Player_Game>;
};

export type Espin_Player_Game_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Espin_Player_Game_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Espin_Player_Game_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Espin_Player_Game_Aggregate_Bool_Exp_Count>;
};

export type Espin_Player_Game_Aggregate_Bool_Exp_Bool_And = {
  arguments: Espin_Player_Game_Select_Column_Espin_Player_Game_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Player_Game_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_Player_Game_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Espin_Player_Game_Select_Column_Espin_Player_Game_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Player_Game_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_Player_Game_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Player_Game_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Player_Game_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.player_game" */
export type Espin_Player_Game_Aggregate_Fields = {
  __typename?: 'espin_player_game_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Player_Game_Max_Fields>;
  min?: Maybe<Espin_Player_Game_Min_Fields>;
};


/** aggregate fields of "espin.player_game" */
export type Espin_Player_Game_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Player_Game_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.player_game" */
export type Espin_Player_Game_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Player_Game_Max_Order_By>;
  min?: InputMaybe<Espin_Player_Game_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.player_game" */
export type Espin_Player_Game_Arr_Rel_Insert_Input = {
  data: Array<Espin_Player_Game_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Player_Game_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.player_game". All fields are combined with a logical 'AND'. */
export type Espin_Player_Game_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Player_Game_Bool_Exp>>;
  _not?: InputMaybe<Espin_Player_Game_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Player_Game_Bool_Exp>>;
  game?: InputMaybe<Espin_Game_Bool_Exp>;
  game_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_game_username?: InputMaybe<String_Comparison_Exp>;
  player_profile?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  primary?: InputMaybe<Boolean_Comparison_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  rank?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  tracker?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.player_game" */
export enum Espin_Player_Game_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlayerGamesPkey = 'player_games_pkey'
}

/** input type for inserting data into table "espin.player_game" */
export type Espin_Player_Game_Insert_Input = {
  game?: InputMaybe<Espin_Game_Obj_Rel_Insert_Input>;
  game_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  in_game_username?: InputMaybe<Scalars['String']>;
  player_profile?: InputMaybe<Espin_Player_Profile_Obj_Rel_Insert_Input>;
  primary?: InputMaybe<Scalars['Boolean']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  tracker?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Player_Game_Max_Fields = {
  __typename?: 'espin_player_game_max_fields';
  game_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  in_game_username?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['uuid']>;
  rank?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  tracker?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.player_game" */
export type Espin_Player_Game_Max_Order_By = {
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_game_username?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tracker?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Player_Game_Min_Fields = {
  __typename?: 'espin_player_game_min_fields';
  game_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  in_game_username?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['uuid']>;
  rank?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  tracker?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.player_game" */
export type Espin_Player_Game_Min_Order_By = {
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_game_username?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tracker?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.player_game" */
export type Espin_Player_Game_Mutation_Response = {
  __typename?: 'espin_player_game_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Player_Game>;
};

/** on_conflict condition type for table "espin.player_game" */
export type Espin_Player_Game_On_Conflict = {
  constraint: Espin_Player_Game_Constraint;
  update_columns?: Array<Espin_Player_Game_Update_Column>;
  where?: InputMaybe<Espin_Player_Game_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.player_game". */
export type Espin_Player_Game_Order_By = {
  game?: InputMaybe<Espin_Game_Order_By>;
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_game_username?: InputMaybe<Order_By>;
  player_profile?: InputMaybe<Espin_Player_Profile_Order_By>;
  primary?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tracker?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.player_game */
export type Espin_Player_Game_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.player_game" */
export enum Espin_Player_Game_Select_Column {
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id',
  /** column name */
  InGameUsername = 'in_game_username',
  /** column name */
  Primary = 'primary',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  Role = 'role',
  /** column name */
  Tracker = 'tracker'
}

/** select "espin_player_game_aggregate_bool_exp_bool_and_arguments_columns" columns of table "espin.player_game" */
export enum Espin_Player_Game_Select_Column_Espin_Player_Game_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Primary = 'primary'
}

/** select "espin_player_game_aggregate_bool_exp_bool_or_arguments_columns" columns of table "espin.player_game" */
export enum Espin_Player_Game_Select_Column_Espin_Player_Game_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Primary = 'primary'
}

/** input type for updating data in table "espin.player_game" */
export type Espin_Player_Game_Set_Input = {
  game_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  in_game_username?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  tracker?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_player_game" */
export type Espin_Player_Game_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Player_Game_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Player_Game_Stream_Cursor_Value_Input = {
  game_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  in_game_username?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  tracker?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.player_game" */
export enum Espin_Player_Game_Update_Column {
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id',
  /** column name */
  InGameUsername = 'in_game_username',
  /** column name */
  Primary = 'primary',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  Role = 'role',
  /** column name */
  Tracker = 'tracker'
}

export type Espin_Player_Game_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Player_Game_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Player_Game_Bool_Exp;
};

/** columns and relationships of "espin.player_journey" */
export type Espin_Player_Journey = {
  __typename?: 'espin_player_journey';
  city?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name: Scalars['String'];
  draft: Scalars['Boolean'];
  game?: Maybe<Espin_Game_Definition_Enum>;
  /** An object relationship */
  game_definition?: Maybe<Espin_Game_Definition>;
  grad_class?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  /** An array relationship */
  player_journey_stages: Array<Espin_Player_Journey_Stage>;
  /** An aggregate relationship */
  player_journey_stages_aggregate: Espin_Player_Journey_Stage_Aggregate;
  profile_image_url?: Maybe<Scalars['String']>;
  profile_slug?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  viewable: Scalars['Boolean'];
};


/** columns and relationships of "espin.player_journey" */
export type Espin_Player_JourneyPlayer_Journey_StagesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
};


/** columns and relationships of "espin.player_journey" */
export type Espin_Player_JourneyPlayer_Journey_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
};

/** aggregated selection of "espin.player_journey" */
export type Espin_Player_Journey_Aggregate = {
  __typename?: 'espin_player_journey_aggregate';
  aggregate?: Maybe<Espin_Player_Journey_Aggregate_Fields>;
  nodes: Array<Espin_Player_Journey>;
};

/** aggregate fields of "espin.player_journey" */
export type Espin_Player_Journey_Aggregate_Fields = {
  __typename?: 'espin_player_journey_aggregate_fields';
  avg?: Maybe<Espin_Player_Journey_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Player_Journey_Max_Fields>;
  min?: Maybe<Espin_Player_Journey_Min_Fields>;
  stddev?: Maybe<Espin_Player_Journey_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Player_Journey_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Player_Journey_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Player_Journey_Sum_Fields>;
  var_pop?: Maybe<Espin_Player_Journey_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Player_Journey_Var_Samp_Fields>;
  variance?: Maybe<Espin_Player_Journey_Variance_Fields>;
};


/** aggregate fields of "espin.player_journey" */
export type Espin_Player_Journey_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Player_Journey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Espin_Player_Journey_Avg_Fields = {
  __typename?: 'espin_player_journey_avg_fields';
  grad_class?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.player_journey". All fields are combined with a logical 'AND'. */
export type Espin_Player_Journey_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Player_Journey_Bool_Exp>>;
  _not?: InputMaybe<Espin_Player_Journey_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Player_Journey_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  draft?: InputMaybe<Boolean_Comparison_Exp>;
  game?: InputMaybe<Espin_Game_Definition_Enum_Comparison_Exp>;
  game_definition?: InputMaybe<Espin_Game_Definition_Bool_Exp>;
  grad_class?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  player_journey_stages?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
  player_journey_stages_aggregate?: InputMaybe<Espin_Player_Journey_Stage_Aggregate_Bool_Exp>;
  profile_image_url?: InputMaybe<String_Comparison_Exp>;
  profile_slug?: InputMaybe<String_Comparison_Exp>;
  rank?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  viewable?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.player_journey" */
export enum Espin_Player_Journey_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlayerJourneyPkey = 'player_journey_pkey'
}

/** input type for incrementing numeric columns in table "espin.player_journey" */
export type Espin_Player_Journey_Inc_Input = {
  grad_class?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.player_journey" */
export type Espin_Player_Journey_Insert_Input = {
  city?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  game?: InputMaybe<Espin_Game_Definition_Enum>;
  game_definition?: InputMaybe<Espin_Game_Definition_Obj_Rel_Insert_Input>;
  grad_class?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  player_journey_stages?: InputMaybe<Espin_Player_Journey_Stage_Arr_Rel_Insert_Input>;
  profile_image_url?: InputMaybe<Scalars['String']>;
  profile_slug?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  viewable?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Espin_Player_Journey_Max_Fields = {
  __typename?: 'espin_player_journey_max_fields';
  city?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  grad_class?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  profile_image_url?: Maybe<Scalars['String']>;
  profile_slug?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Player_Journey_Min_Fields = {
  __typename?: 'espin_player_journey_min_fields';
  city?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  grad_class?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  profile_image_url?: Maybe<Scalars['String']>;
  profile_slug?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.player_journey" */
export type Espin_Player_Journey_Mutation_Response = {
  __typename?: 'espin_player_journey_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Player_Journey>;
};

/** input type for inserting object relation for remote table "espin.player_journey" */
export type Espin_Player_Journey_Obj_Rel_Insert_Input = {
  data: Espin_Player_Journey_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Player_Journey_On_Conflict>;
};

/** on_conflict condition type for table "espin.player_journey" */
export type Espin_Player_Journey_On_Conflict = {
  constraint: Espin_Player_Journey_Constraint;
  update_columns?: Array<Espin_Player_Journey_Update_Column>;
  where?: InputMaybe<Espin_Player_Journey_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.player_journey". */
export type Espin_Player_Journey_Order_By = {
  city?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  game?: InputMaybe<Order_By>;
  game_definition?: InputMaybe<Espin_Game_Definition_Order_By>;
  grad_class?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  player_journey_stages_aggregate?: InputMaybe<Espin_Player_Journey_Stage_Aggregate_Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  profile_slug?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  viewable?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.player_journey */
export type Espin_Player_Journey_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.player_journey" */
export enum Espin_Player_Journey_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Draft = 'draft',
  /** column name */
  Game = 'game',
  /** column name */
  GradClass = 'grad_class',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  ProfileSlug = 'profile_slug',
  /** column name */
  Rank = 'rank',
  /** column name */
  Slug = 'slug',
  /** column name */
  State = 'state',
  /** column name */
  Viewable = 'viewable'
}

/** input type for updating data in table "espin.player_journey" */
export type Espin_Player_Journey_Set_Input = {
  city?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  game?: InputMaybe<Espin_Game_Definition_Enum>;
  grad_class?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_image_url?: InputMaybe<Scalars['String']>;
  profile_slug?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  viewable?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage = {
  __typename?: 'espin_player_journey_stage';
  /** An array relationship */
  colleges: Array<Espin_Player_Journey_Stage_College>;
  /** An aggregate relationship */
  colleges_aggregate: Espin_Player_Journey_Stage_College_Aggregate;
  def: Espin_Player_Journey_Stage_Def_Enum;
  id: Scalars['uuid'];
  /** An array relationship */
  images: Array<Espin_Player_Journey_Stage_Image>;
  /** An aggregate relationship */
  images_aggregate: Espin_Player_Journey_Stage_Image_Aggregate;
  order: Scalars['Int'];
  /** An object relationship */
  player_journey: Espin_Player_Journey;
  player_journey_id: Scalars['uuid'];
  /** An object relationship */
  player_journey_stage_def: Espin_Player_Journey_Stage_Def;
  /** An array relationship */
  quotes: Array<Espin_Player_Journey_Stage_Quote>;
  /** An aggregate relationship */
  quotes_aggregate: Espin_Player_Journey_Stage_Quote_Aggregate;
  title: Scalars['String'];
};


/** columns and relationships of "espin.player_journey_stage" */
export type Espin_Player_Journey_StageCollegesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_College_Bool_Exp>;
};


/** columns and relationships of "espin.player_journey_stage" */
export type Espin_Player_Journey_StageColleges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_College_Bool_Exp>;
};


/** columns and relationships of "espin.player_journey_stage" */
export type Espin_Player_Journey_StageImagesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Image_Bool_Exp>;
};


/** columns and relationships of "espin.player_journey_stage" */
export type Espin_Player_Journey_StageImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Image_Bool_Exp>;
};


/** columns and relationships of "espin.player_journey_stage" */
export type Espin_Player_Journey_StageQuotesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Quote_Bool_Exp>;
};


/** columns and relationships of "espin.player_journey_stage" */
export type Espin_Player_Journey_StageQuotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Quote_Bool_Exp>;
};

/** aggregated selection of "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Aggregate = {
  __typename?: 'espin_player_journey_stage_aggregate';
  aggregate?: Maybe<Espin_Player_Journey_Stage_Aggregate_Fields>;
  nodes: Array<Espin_Player_Journey_Stage>;
};

export type Espin_Player_Journey_Stage_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Player_Journey_Stage_Aggregate_Bool_Exp_Count>;
};

export type Espin_Player_Journey_Stage_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Player_Journey_Stage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Aggregate_Fields = {
  __typename?: 'espin_player_journey_stage_aggregate_fields';
  avg?: Maybe<Espin_Player_Journey_Stage_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Player_Journey_Stage_Max_Fields>;
  min?: Maybe<Espin_Player_Journey_Stage_Min_Fields>;
  stddev?: Maybe<Espin_Player_Journey_Stage_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Player_Journey_Stage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Player_Journey_Stage_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Player_Journey_Stage_Sum_Fields>;
  var_pop?: Maybe<Espin_Player_Journey_Stage_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Player_Journey_Stage_Var_Samp_Fields>;
  variance?: Maybe<Espin_Player_Journey_Stage_Variance_Fields>;
};


/** aggregate fields of "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Player_Journey_Stage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Aggregate_Order_By = {
  avg?: InputMaybe<Espin_Player_Journey_Stage_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Player_Journey_Stage_Max_Order_By>;
  min?: InputMaybe<Espin_Player_Journey_Stage_Min_Order_By>;
  stddev?: InputMaybe<Espin_Player_Journey_Stage_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Espin_Player_Journey_Stage_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Espin_Player_Journey_Stage_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Espin_Player_Journey_Stage_Sum_Order_By>;
  var_pop?: InputMaybe<Espin_Player_Journey_Stage_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Espin_Player_Journey_Stage_Var_Samp_Order_By>;
  variance?: InputMaybe<Espin_Player_Journey_Stage_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Arr_Rel_Insert_Input = {
  data: Array<Espin_Player_Journey_Stage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_On_Conflict>;
};

/** aggregate avg on columns */
export type Espin_Player_Journey_Stage_Avg_Fields = {
  __typename?: 'espin_player_journey_stage_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "espin.player_journey_stage". All fields are combined with a logical 'AND'. */
export type Espin_Player_Journey_Stage_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Player_Journey_Stage_Bool_Exp>>;
  _not?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Player_Journey_Stage_Bool_Exp>>;
  colleges?: InputMaybe<Espin_Player_Journey_Stage_College_Bool_Exp>;
  colleges_aggregate?: InputMaybe<Espin_Player_Journey_Stage_College_Aggregate_Bool_Exp>;
  def?: InputMaybe<Espin_Player_Journey_Stage_Def_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  images?: InputMaybe<Espin_Player_Journey_Stage_Image_Bool_Exp>;
  images_aggregate?: InputMaybe<Espin_Player_Journey_Stage_Image_Aggregate_Bool_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  player_journey?: InputMaybe<Espin_Player_Journey_Bool_Exp>;
  player_journey_id?: InputMaybe<Uuid_Comparison_Exp>;
  player_journey_stage_def?: InputMaybe<Espin_Player_Journey_Stage_Def_Bool_Exp>;
  quotes?: InputMaybe<Espin_Player_Journey_Stage_Quote_Bool_Exp>;
  quotes_aggregate?: InputMaybe<Espin_Player_Journey_Stage_Quote_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "espin.player_journey_stage_college" */
export type Espin_Player_Journey_Stage_College = {
  __typename?: 'espin_player_journey_stage_college';
  /** An object relationship */
  college: Espin_College;
  college_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  player_journey_stage: Espin_Player_Journey_Stage;
  stage_id: Scalars['uuid'];
};

/** aggregated selection of "espin.player_journey_stage_college" */
export type Espin_Player_Journey_Stage_College_Aggregate = {
  __typename?: 'espin_player_journey_stage_college_aggregate';
  aggregate?: Maybe<Espin_Player_Journey_Stage_College_Aggregate_Fields>;
  nodes: Array<Espin_Player_Journey_Stage_College>;
};

export type Espin_Player_Journey_Stage_College_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Player_Journey_Stage_College_Aggregate_Bool_Exp_Count>;
};

export type Espin_Player_Journey_Stage_College_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Player_Journey_Stage_College_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.player_journey_stage_college" */
export type Espin_Player_Journey_Stage_College_Aggregate_Fields = {
  __typename?: 'espin_player_journey_stage_college_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Player_Journey_Stage_College_Max_Fields>;
  min?: Maybe<Espin_Player_Journey_Stage_College_Min_Fields>;
};


/** aggregate fields of "espin.player_journey_stage_college" */
export type Espin_Player_Journey_Stage_College_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.player_journey_stage_college" */
export type Espin_Player_Journey_Stage_College_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Player_Journey_Stage_College_Max_Order_By>;
  min?: InputMaybe<Espin_Player_Journey_Stage_College_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.player_journey_stage_college" */
export type Espin_Player_Journey_Stage_College_Arr_Rel_Insert_Input = {
  data: Array<Espin_Player_Journey_Stage_College_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_College_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.player_journey_stage_college". All fields are combined with a logical 'AND'. */
export type Espin_Player_Journey_Stage_College_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Bool_Exp>>;
  _not?: InputMaybe<Espin_Player_Journey_Stage_College_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Bool_Exp>>;
  college?: InputMaybe<Espin_College_Bool_Exp>;
  college_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  player_journey_stage?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
  stage_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.player_journey_stage_college" */
export enum Espin_Player_Journey_Stage_College_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlayerJourneyStageCollegePkey = 'player_journey_stage_college_pkey'
}

/** input type for inserting data into table "espin.player_journey_stage_college" */
export type Espin_Player_Journey_Stage_College_Insert_Input = {
  college?: InputMaybe<Espin_College_Obj_Rel_Insert_Input>;
  college_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  player_journey_stage?: InputMaybe<Espin_Player_Journey_Stage_Obj_Rel_Insert_Input>;
  stage_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Espin_Player_Journey_Stage_College_Max_Fields = {
  __typename?: 'espin_player_journey_stage_college_max_fields';
  college_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  stage_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "espin.player_journey_stage_college" */
export type Espin_Player_Journey_Stage_College_Max_Order_By = {
  college_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Player_Journey_Stage_College_Min_Fields = {
  __typename?: 'espin_player_journey_stage_college_min_fields';
  college_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  stage_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "espin.player_journey_stage_college" */
export type Espin_Player_Journey_Stage_College_Min_Order_By = {
  college_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.player_journey_stage_college" */
export type Espin_Player_Journey_Stage_College_Mutation_Response = {
  __typename?: 'espin_player_journey_stage_college_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Player_Journey_Stage_College>;
};

/** on_conflict condition type for table "espin.player_journey_stage_college" */
export type Espin_Player_Journey_Stage_College_On_Conflict = {
  constraint: Espin_Player_Journey_Stage_College_Constraint;
  update_columns?: Array<Espin_Player_Journey_Stage_College_Update_Column>;
  where?: InputMaybe<Espin_Player_Journey_Stage_College_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.player_journey_stage_college". */
export type Espin_Player_Journey_Stage_College_Order_By = {
  college?: InputMaybe<Espin_College_Order_By>;
  college_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  player_journey_stage?: InputMaybe<Espin_Player_Journey_Stage_Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.player_journey_stage_college */
export type Espin_Player_Journey_Stage_College_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.player_journey_stage_college" */
export enum Espin_Player_Journey_Stage_College_Select_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  Id = 'id',
  /** column name */
  StageId = 'stage_id'
}

/** input type for updating data in table "espin.player_journey_stage_college" */
export type Espin_Player_Journey_Stage_College_Set_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  stage_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "espin_player_journey_stage_college" */
export type Espin_Player_Journey_Stage_College_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Player_Journey_Stage_College_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Player_Journey_Stage_College_Stream_Cursor_Value_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  stage_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "espin.player_journey_stage_college" */
export enum Espin_Player_Journey_Stage_College_Update_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  Id = 'id',
  /** column name */
  StageId = 'stage_id'
}

export type Espin_Player_Journey_Stage_College_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Player_Journey_Stage_College_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Player_Journey_Stage_College_Bool_Exp;
};

/** unique or primary key constraints on table "espin.player_journey_stage" */
export enum Espin_Player_Journey_Stage_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlayerJourneyStagePkey = 'player_journey_stage_pkey'
}

/** defs for player journey stages */
export type Espin_Player_Journey_Stage_Def = {
  __typename?: 'espin_player_journey_stage_def';
  display_name: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.player_journey_stage_def" */
export type Espin_Player_Journey_Stage_Def_Aggregate = {
  __typename?: 'espin_player_journey_stage_def_aggregate';
  aggregate?: Maybe<Espin_Player_Journey_Stage_Def_Aggregate_Fields>;
  nodes: Array<Espin_Player_Journey_Stage_Def>;
};

/** aggregate fields of "espin.player_journey_stage_def" */
export type Espin_Player_Journey_Stage_Def_Aggregate_Fields = {
  __typename?: 'espin_player_journey_stage_def_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Player_Journey_Stage_Def_Max_Fields>;
  min?: Maybe<Espin_Player_Journey_Stage_Def_Min_Fields>;
};


/** aggregate fields of "espin.player_journey_stage_def" */
export type Espin_Player_Journey_Stage_Def_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Player_Journey_Stage_Def_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.player_journey_stage_def". All fields are combined with a logical 'AND'. */
export type Espin_Player_Journey_Stage_Def_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Player_Journey_Stage_Def_Bool_Exp>>;
  _not?: InputMaybe<Espin_Player_Journey_Stage_Def_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Player_Journey_Stage_Def_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.player_journey_stage_def" */
export enum Espin_Player_Journey_Stage_Def_Constraint {
  /** unique or primary key constraint on columns "name" */
  PlayerJourneyStageDefPkey = 'player_journey_stage_def_pkey'
}

export enum Espin_Player_Journey_Stage_Def_Enum {
  /** Collegiate Connections #1 */
  CollegiateConnectionsOne = 'collegiate_connections_one',
  /** Player Profile */
  PlayerProfile = 'player_profile',
  /** Video Stage */
  Video = 'video'
}

/** Boolean expression to compare columns of type "espin_player_journey_stage_def_enum". All fields are combined with logical 'AND'. */
export type Espin_Player_Journey_Stage_Def_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Player_Journey_Stage_Def_Enum>;
  _in?: InputMaybe<Array<Espin_Player_Journey_Stage_Def_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Player_Journey_Stage_Def_Enum>;
  _nin?: InputMaybe<Array<Espin_Player_Journey_Stage_Def_Enum>>;
};

/** input type for inserting data into table "espin.player_journey_stage_def" */
export type Espin_Player_Journey_Stage_Def_Insert_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Player_Journey_Stage_Def_Max_Fields = {
  __typename?: 'espin_player_journey_stage_def_max_fields';
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Player_Journey_Stage_Def_Min_Fields = {
  __typename?: 'espin_player_journey_stage_def_min_fields';
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.player_journey_stage_def" */
export type Espin_Player_Journey_Stage_Def_Mutation_Response = {
  __typename?: 'espin_player_journey_stage_def_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Player_Journey_Stage_Def>;
};

/** input type for inserting object relation for remote table "espin.player_journey_stage_def" */
export type Espin_Player_Journey_Stage_Def_Obj_Rel_Insert_Input = {
  data: Espin_Player_Journey_Stage_Def_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_Def_On_Conflict>;
};

/** on_conflict condition type for table "espin.player_journey_stage_def" */
export type Espin_Player_Journey_Stage_Def_On_Conflict = {
  constraint: Espin_Player_Journey_Stage_Def_Constraint;
  update_columns?: Array<Espin_Player_Journey_Stage_Def_Update_Column>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Def_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.player_journey_stage_def". */
export type Espin_Player_Journey_Stage_Def_Order_By = {
  display_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.player_journey_stage_def */
export type Espin_Player_Journey_Stage_Def_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.player_journey_stage_def" */
export enum Espin_Player_Journey_Stage_Def_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.player_journey_stage_def" */
export type Espin_Player_Journey_Stage_Def_Set_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_player_journey_stage_def" */
export type Espin_Player_Journey_Stage_Def_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Player_Journey_Stage_Def_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Player_Journey_Stage_Def_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.player_journey_stage_def" */
export enum Espin_Player_Journey_Stage_Def_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

export type Espin_Player_Journey_Stage_Def_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Player_Journey_Stage_Def_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Player_Journey_Stage_Def_Bool_Exp;
};

/** columns and relationships of "espin.player_journey_stage_image" */
export type Espin_Player_Journey_Stage_Image = {
  __typename?: 'espin_player_journey_stage_image';
  caption?: Maybe<Scalars['String']>;
  /** An object relationship */
  file: Content_File;
  file_id: Scalars['uuid'];
  id: Scalars['uuid'];
  label?: Maybe<Scalars['String']>;
  /** An object relationship */
  player_journey_stage: Espin_Player_Journey_Stage;
  stage_id: Scalars['uuid'];
};

/** aggregated selection of "espin.player_journey_stage_image" */
export type Espin_Player_Journey_Stage_Image_Aggregate = {
  __typename?: 'espin_player_journey_stage_image_aggregate';
  aggregate?: Maybe<Espin_Player_Journey_Stage_Image_Aggregate_Fields>;
  nodes: Array<Espin_Player_Journey_Stage_Image>;
};

export type Espin_Player_Journey_Stage_Image_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Player_Journey_Stage_Image_Aggregate_Bool_Exp_Count>;
};

export type Espin_Player_Journey_Stage_Image_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Player_Journey_Stage_Image_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.player_journey_stage_image" */
export type Espin_Player_Journey_Stage_Image_Aggregate_Fields = {
  __typename?: 'espin_player_journey_stage_image_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Player_Journey_Stage_Image_Max_Fields>;
  min?: Maybe<Espin_Player_Journey_Stage_Image_Min_Fields>;
};


/** aggregate fields of "espin.player_journey_stage_image" */
export type Espin_Player_Journey_Stage_Image_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.player_journey_stage_image" */
export type Espin_Player_Journey_Stage_Image_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Player_Journey_Stage_Image_Max_Order_By>;
  min?: InputMaybe<Espin_Player_Journey_Stage_Image_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.player_journey_stage_image" */
export type Espin_Player_Journey_Stage_Image_Arr_Rel_Insert_Input = {
  data: Array<Espin_Player_Journey_Stage_Image_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_Image_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.player_journey_stage_image". All fields are combined with a logical 'AND'. */
export type Espin_Player_Journey_Stage_Image_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Bool_Exp>>;
  _not?: InputMaybe<Espin_Player_Journey_Stage_Image_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Bool_Exp>>;
  caption?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Content_File_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  player_journey_stage?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
  stage_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.player_journey_stage_image" */
export enum Espin_Player_Journey_Stage_Image_Constraint {
  /** unique or primary key constraint on columns "file_id" */
  PlayerJourneyStageImageFileIdKey = 'player_journey_stage_image_file_id_key',
  /** unique or primary key constraint on columns "id" */
  PlayerJourneyStageImagePkey = 'player_journey_stage_image_pkey'
}

/** input type for inserting data into table "espin.player_journey_stage_image" */
export type Espin_Player_Journey_Stage_Image_Insert_Input = {
  caption?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Content_File_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  player_journey_stage?: InputMaybe<Espin_Player_Journey_Stage_Obj_Rel_Insert_Input>;
  stage_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Espin_Player_Journey_Stage_Image_Max_Fields = {
  __typename?: 'espin_player_journey_stage_image_max_fields';
  caption?: Maybe<Scalars['String']>;
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  stage_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "espin.player_journey_stage_image" */
export type Espin_Player_Journey_Stage_Image_Max_Order_By = {
  caption?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Player_Journey_Stage_Image_Min_Fields = {
  __typename?: 'espin_player_journey_stage_image_min_fields';
  caption?: Maybe<Scalars['String']>;
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  stage_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "espin.player_journey_stage_image" */
export type Espin_Player_Journey_Stage_Image_Min_Order_By = {
  caption?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.player_journey_stage_image" */
export type Espin_Player_Journey_Stage_Image_Mutation_Response = {
  __typename?: 'espin_player_journey_stage_image_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Player_Journey_Stage_Image>;
};

/** on_conflict condition type for table "espin.player_journey_stage_image" */
export type Espin_Player_Journey_Stage_Image_On_Conflict = {
  constraint: Espin_Player_Journey_Stage_Image_Constraint;
  update_columns?: Array<Espin_Player_Journey_Stage_Image_Update_Column>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Image_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.player_journey_stage_image". */
export type Espin_Player_Journey_Stage_Image_Order_By = {
  caption?: InputMaybe<Order_By>;
  file?: InputMaybe<Content_File_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  player_journey_stage?: InputMaybe<Espin_Player_Journey_Stage_Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.player_journey_stage_image */
export type Espin_Player_Journey_Stage_Image_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.player_journey_stage_image" */
export enum Espin_Player_Journey_Stage_Image_Select_Column {
  /** column name */
  Caption = 'caption',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  StageId = 'stage_id'
}

/** input type for updating data in table "espin.player_journey_stage_image" */
export type Espin_Player_Journey_Stage_Image_Set_Input = {
  caption?: InputMaybe<Scalars['String']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  stage_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "espin_player_journey_stage_image" */
export type Espin_Player_Journey_Stage_Image_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Player_Journey_Stage_Image_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Player_Journey_Stage_Image_Stream_Cursor_Value_Input = {
  caption?: InputMaybe<Scalars['String']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  stage_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "espin.player_journey_stage_image" */
export enum Espin_Player_Journey_Stage_Image_Update_Column {
  /** column name */
  Caption = 'caption',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  StageId = 'stage_id'
}

export type Espin_Player_Journey_Stage_Image_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Player_Journey_Stage_Image_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Player_Journey_Stage_Image_Bool_Exp;
};

/** input type for incrementing numeric columns in table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Insert_Input = {
  colleges?: InputMaybe<Espin_Player_Journey_Stage_College_Arr_Rel_Insert_Input>;
  def?: InputMaybe<Espin_Player_Journey_Stage_Def_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  images?: InputMaybe<Espin_Player_Journey_Stage_Image_Arr_Rel_Insert_Input>;
  order?: InputMaybe<Scalars['Int']>;
  player_journey?: InputMaybe<Espin_Player_Journey_Obj_Rel_Insert_Input>;
  player_journey_id?: InputMaybe<Scalars['uuid']>;
  player_journey_stage_def?: InputMaybe<Espin_Player_Journey_Stage_Def_Obj_Rel_Insert_Input>;
  quotes?: InputMaybe<Espin_Player_Journey_Stage_Quote_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Player_Journey_Stage_Max_Fields = {
  __typename?: 'espin_player_journey_stage_max_fields';
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  player_journey_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  player_journey_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Player_Journey_Stage_Min_Fields = {
  __typename?: 'espin_player_journey_stage_min_fields';
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  player_journey_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  player_journey_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Mutation_Response = {
  __typename?: 'espin_player_journey_stage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Player_Journey_Stage>;
};

/** input type for inserting object relation for remote table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Obj_Rel_Insert_Input = {
  data: Espin_Player_Journey_Stage_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_On_Conflict>;
};

/** on_conflict condition type for table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_On_Conflict = {
  constraint: Espin_Player_Journey_Stage_Constraint;
  update_columns?: Array<Espin_Player_Journey_Stage_Update_Column>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.player_journey_stage". */
export type Espin_Player_Journey_Stage_Order_By = {
  colleges_aggregate?: InputMaybe<Espin_Player_Journey_Stage_College_Aggregate_Order_By>;
  def?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Espin_Player_Journey_Stage_Image_Aggregate_Order_By>;
  order?: InputMaybe<Order_By>;
  player_journey?: InputMaybe<Espin_Player_Journey_Order_By>;
  player_journey_id?: InputMaybe<Order_By>;
  player_journey_stage_def?: InputMaybe<Espin_Player_Journey_Stage_Def_Order_By>;
  quotes_aggregate?: InputMaybe<Espin_Player_Journey_Stage_Quote_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.player_journey_stage */
export type Espin_Player_Journey_Stage_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** for quotes for various stages */
export type Espin_Player_Journey_Stage_Quote = {
  __typename?: 'espin_player_journey_stage_quote';
  content: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  player_journey_stage: Espin_Player_Journey_Stage;
  stage_id: Scalars['uuid'];
  title: Scalars['String'];
  twitter: Scalars['String'];
};

/** aggregated selection of "espin.player_journey_stage_quote" */
export type Espin_Player_Journey_Stage_Quote_Aggregate = {
  __typename?: 'espin_player_journey_stage_quote_aggregate';
  aggregate?: Maybe<Espin_Player_Journey_Stage_Quote_Aggregate_Fields>;
  nodes: Array<Espin_Player_Journey_Stage_Quote>;
};

export type Espin_Player_Journey_Stage_Quote_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Player_Journey_Stage_Quote_Aggregate_Bool_Exp_Count>;
};

export type Espin_Player_Journey_Stage_Quote_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Player_Journey_Stage_Quote_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.player_journey_stage_quote" */
export type Espin_Player_Journey_Stage_Quote_Aggregate_Fields = {
  __typename?: 'espin_player_journey_stage_quote_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Player_Journey_Stage_Quote_Max_Fields>;
  min?: Maybe<Espin_Player_Journey_Stage_Quote_Min_Fields>;
};


/** aggregate fields of "espin.player_journey_stage_quote" */
export type Espin_Player_Journey_Stage_Quote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.player_journey_stage_quote" */
export type Espin_Player_Journey_Stage_Quote_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Player_Journey_Stage_Quote_Max_Order_By>;
  min?: InputMaybe<Espin_Player_Journey_Stage_Quote_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.player_journey_stage_quote" */
export type Espin_Player_Journey_Stage_Quote_Arr_Rel_Insert_Input = {
  data: Array<Espin_Player_Journey_Stage_Quote_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_Quote_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.player_journey_stage_quote". All fields are combined with a logical 'AND'. */
export type Espin_Player_Journey_Stage_Quote_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Bool_Exp>>;
  _not?: InputMaybe<Espin_Player_Journey_Stage_Quote_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  player_journey_stage?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
  stage_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  twitter?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.player_journey_stage_quote" */
export enum Espin_Player_Journey_Stage_Quote_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlayerJourneyStageQuotePkey = 'player_journey_stage_quote_pkey'
}

/** input type for inserting data into table "espin.player_journey_stage_quote" */
export type Espin_Player_Journey_Stage_Quote_Insert_Input = {
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  player_journey_stage?: InputMaybe<Espin_Player_Journey_Stage_Obj_Rel_Insert_Input>;
  stage_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Player_Journey_Stage_Quote_Max_Fields = {
  __typename?: 'espin_player_journey_stage_quote_max_fields';
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  stage_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.player_journey_stage_quote" */
export type Espin_Player_Journey_Stage_Quote_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Player_Journey_Stage_Quote_Min_Fields = {
  __typename?: 'espin_player_journey_stage_quote_min_fields';
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  stage_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.player_journey_stage_quote" */
export type Espin_Player_Journey_Stage_Quote_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.player_journey_stage_quote" */
export type Espin_Player_Journey_Stage_Quote_Mutation_Response = {
  __typename?: 'espin_player_journey_stage_quote_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Player_Journey_Stage_Quote>;
};

/** on_conflict condition type for table "espin.player_journey_stage_quote" */
export type Espin_Player_Journey_Stage_Quote_On_Conflict = {
  constraint: Espin_Player_Journey_Stage_Quote_Constraint;
  update_columns?: Array<Espin_Player_Journey_Stage_Quote_Update_Column>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Quote_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.player_journey_stage_quote". */
export type Espin_Player_Journey_Stage_Quote_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  player_journey_stage?: InputMaybe<Espin_Player_Journey_Stage_Order_By>;
  stage_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.player_journey_stage_quote */
export type Espin_Player_Journey_Stage_Quote_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.player_journey_stage_quote" */
export enum Espin_Player_Journey_Stage_Quote_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  Title = 'title',
  /** column name */
  Twitter = 'twitter'
}

/** input type for updating data in table "espin.player_journey_stage_quote" */
export type Espin_Player_Journey_Stage_Quote_Set_Input = {
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  stage_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_player_journey_stage_quote" */
export type Espin_Player_Journey_Stage_Quote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Player_Journey_Stage_Quote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Player_Journey_Stage_Quote_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  stage_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.player_journey_stage_quote" */
export enum Espin_Player_Journey_Stage_Quote_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  Title = 'title',
  /** column name */
  Twitter = 'twitter'
}

export type Espin_Player_Journey_Stage_Quote_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Player_Journey_Stage_Quote_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Player_Journey_Stage_Quote_Bool_Exp;
};

/** select columns of table "espin.player_journey_stage" */
export enum Espin_Player_Journey_Stage_Select_Column {
  /** column name */
  Def = 'def',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PlayerJourneyId = 'player_journey_id',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Set_Input = {
  def?: InputMaybe<Espin_Player_Journey_Stage_Def_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  player_journey_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Espin_Player_Journey_Stage_Stddev_Fields = {
  __typename?: 'espin_player_journey_stage_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Espin_Player_Journey_Stage_Stddev_Pop_Fields = {
  __typename?: 'espin_player_journey_stage_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Espin_Player_Journey_Stage_Stddev_Samp_Fields = {
  __typename?: 'espin_player_journey_stage_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "espin_player_journey_stage" */
export type Espin_Player_Journey_Stage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Player_Journey_Stage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Player_Journey_Stage_Stream_Cursor_Value_Input = {
  def?: InputMaybe<Espin_Player_Journey_Stage_Def_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  player_journey_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Espin_Player_Journey_Stage_Sum_Fields = {
  __typename?: 'espin_player_journey_stage_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "espin.player_journey_stage" */
export enum Espin_Player_Journey_Stage_Update_Column {
  /** column name */
  Def = 'def',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PlayerJourneyId = 'player_journey_id',
  /** column name */
  Title = 'title'
}

export type Espin_Player_Journey_Stage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Player_Journey_Stage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Player_Journey_Stage_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Player_Journey_Stage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Player_Journey_Stage_Var_Pop_Fields = {
  __typename?: 'espin_player_journey_stage_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Espin_Player_Journey_Stage_Var_Samp_Fields = {
  __typename?: 'espin_player_journey_stage_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Espin_Player_Journey_Stage_Variance_Fields = {
  __typename?: 'espin_player_journey_stage_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "espin.player_journey_stage" */
export type Espin_Player_Journey_Stage_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "espin.player_journey_stage_video" */
export type Espin_Player_Journey_Stage_Video = {
  __typename?: 'espin_player_journey_stage_video';
  caption?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  label?: Maybe<Scalars['String']>;
  /** An object relationship */
  media_link: Content_Media_Link;
  media_link_id: Scalars['uuid'];
  stage_id: Scalars['uuid'];
};

/** aggregated selection of "espin.player_journey_stage_video" */
export type Espin_Player_Journey_Stage_Video_Aggregate = {
  __typename?: 'espin_player_journey_stage_video_aggregate';
  aggregate?: Maybe<Espin_Player_Journey_Stage_Video_Aggregate_Fields>;
  nodes: Array<Espin_Player_Journey_Stage_Video>;
};

/** aggregate fields of "espin.player_journey_stage_video" */
export type Espin_Player_Journey_Stage_Video_Aggregate_Fields = {
  __typename?: 'espin_player_journey_stage_video_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Player_Journey_Stage_Video_Max_Fields>;
  min?: Maybe<Espin_Player_Journey_Stage_Video_Min_Fields>;
};


/** aggregate fields of "espin.player_journey_stage_video" */
export type Espin_Player_Journey_Stage_Video_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Player_Journey_Stage_Video_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.player_journey_stage_video". All fields are combined with a logical 'AND'. */
export type Espin_Player_Journey_Stage_Video_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Player_Journey_Stage_Video_Bool_Exp>>;
  _not?: InputMaybe<Espin_Player_Journey_Stage_Video_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Player_Journey_Stage_Video_Bool_Exp>>;
  caption?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  media_link?: InputMaybe<Content_Media_Link_Bool_Exp>;
  media_link_id?: InputMaybe<Uuid_Comparison_Exp>;
  stage_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.player_journey_stage_video" */
export enum Espin_Player_Journey_Stage_Video_Constraint {
  /** unique or primary key constraint on columns "media_link_id" */
  PlayerJourneyStageVideoMediaLinkIdKey = 'player_journey_stage_video_media_link_id_key',
  /** unique or primary key constraint on columns "id" */
  PlayerJourneyStageVideoPkey = 'player_journey_stage_video_pkey'
}

/** input type for inserting data into table "espin.player_journey_stage_video" */
export type Espin_Player_Journey_Stage_Video_Insert_Input = {
  caption?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  media_link?: InputMaybe<Content_Media_Link_Obj_Rel_Insert_Input>;
  media_link_id?: InputMaybe<Scalars['uuid']>;
  stage_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Espin_Player_Journey_Stage_Video_Max_Fields = {
  __typename?: 'espin_player_journey_stage_video_max_fields';
  caption?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  media_link_id?: Maybe<Scalars['uuid']>;
  stage_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Espin_Player_Journey_Stage_Video_Min_Fields = {
  __typename?: 'espin_player_journey_stage_video_min_fields';
  caption?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  media_link_id?: Maybe<Scalars['uuid']>;
  stage_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "espin.player_journey_stage_video" */
export type Espin_Player_Journey_Stage_Video_Mutation_Response = {
  __typename?: 'espin_player_journey_stage_video_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Player_Journey_Stage_Video>;
};

/** on_conflict condition type for table "espin.player_journey_stage_video" */
export type Espin_Player_Journey_Stage_Video_On_Conflict = {
  constraint: Espin_Player_Journey_Stage_Video_Constraint;
  update_columns?: Array<Espin_Player_Journey_Stage_Video_Update_Column>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Video_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.player_journey_stage_video". */
export type Espin_Player_Journey_Stage_Video_Order_By = {
  caption?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  media_link?: InputMaybe<Content_Media_Link_Order_By>;
  media_link_id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.player_journey_stage_video */
export type Espin_Player_Journey_Stage_Video_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.player_journey_stage_video" */
export enum Espin_Player_Journey_Stage_Video_Select_Column {
  /** column name */
  Caption = 'caption',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  MediaLinkId = 'media_link_id',
  /** column name */
  StageId = 'stage_id'
}

/** input type for updating data in table "espin.player_journey_stage_video" */
export type Espin_Player_Journey_Stage_Video_Set_Input = {
  caption?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  media_link_id?: InputMaybe<Scalars['uuid']>;
  stage_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "espin_player_journey_stage_video" */
export type Espin_Player_Journey_Stage_Video_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Player_Journey_Stage_Video_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Player_Journey_Stage_Video_Stream_Cursor_Value_Input = {
  caption?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  media_link_id?: InputMaybe<Scalars['uuid']>;
  stage_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "espin.player_journey_stage_video" */
export enum Espin_Player_Journey_Stage_Video_Update_Column {
  /** column name */
  Caption = 'caption',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  MediaLinkId = 'media_link_id',
  /** column name */
  StageId = 'stage_id'
}

export type Espin_Player_Journey_Stage_Video_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Player_Journey_Stage_Video_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Player_Journey_Stage_Video_Bool_Exp;
};

/** aggregate stddev on columns */
export type Espin_Player_Journey_Stddev_Fields = {
  __typename?: 'espin_player_journey_stddev_fields';
  grad_class?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_Player_Journey_Stddev_Pop_Fields = {
  __typename?: 'espin_player_journey_stddev_pop_fields';
  grad_class?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_Player_Journey_Stddev_Samp_Fields = {
  __typename?: 'espin_player_journey_stddev_samp_fields';
  grad_class?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_player_journey" */
export type Espin_Player_Journey_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Player_Journey_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Player_Journey_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  game?: InputMaybe<Espin_Game_Definition_Enum>;
  grad_class?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_image_url?: InputMaybe<Scalars['String']>;
  profile_slug?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  viewable?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Espin_Player_Journey_Sum_Fields = {
  __typename?: 'espin_player_journey_sum_fields';
  grad_class?: Maybe<Scalars['Int']>;
};

/** update columns of table "espin.player_journey" */
export enum Espin_Player_Journey_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Draft = 'draft',
  /** column name */
  Game = 'game',
  /** column name */
  GradClass = 'grad_class',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  ProfileSlug = 'profile_slug',
  /** column name */
  Rank = 'rank',
  /** column name */
  Slug = 'slug',
  /** column name */
  State = 'state',
  /** column name */
  Viewable = 'viewable'
}

export type Espin_Player_Journey_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Player_Journey_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Player_Journey_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Player_Journey_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Player_Journey_Var_Pop_Fields = {
  __typename?: 'espin_player_journey_var_pop_fields';
  grad_class?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_Player_Journey_Var_Samp_Fields = {
  __typename?: 'espin_player_journey_var_samp_fields';
  grad_class?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_Player_Journey_Variance_Fields = {
  __typename?: 'espin_player_journey_variance_fields';
  grad_class?: Maybe<Scalars['Float']>;
};

/** Profile for a player in the system */
export type Espin_Player_Profile = {
  __typename?: 'espin_player_profile';
  /** Display profile to premium members acknowledgement */
  ack_displayed: Scalars['Boolean'];
  ack_terms: Scalars['Boolean'];
  ack_waiver: Scalars['Boolean'];
  /** An object relationship */
  address?: Maybe<Espin_Address>;
  address_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['date']>;
  college_coach_email?: Maybe<Scalars['String']>;
  college_coach_name?: Maybe<Scalars['String']>;
  college_name?: Maybe<Scalars['String']>;
  committed_to_college?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ethnicity?: Maybe<Espin_Ethnicity_Options_Enum>;
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Espin_Gender_Options_Enum>;
  gender_not_listed_entry?: Maybe<Scalars['String']>;
  /** A computed field, executes function "espin.general_study_field" */
  general_study_field?: Maybe<Array<Espin_Study_Field>>;
  gpa: Scalars['numeric'];
  graduating_class?: Maybe<Scalars['String']>;
  hs_coach_email?: Maybe<Scalars['String']>;
  hs_coach_name?: Maybe<Scalars['String']>;
  hs_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_hs: Scalars['Boolean'];
  last_name?: Maybe<Scalars['String']>;
  linked_high_school?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  linked_high_school_details?: Maybe<Espin_High_School>;
  parent_email?: Maybe<Scalars['String']>;
  /** An object relationship */
  parent_profile?: Maybe<Espin_Parent_Profile>;
  parent_profile_id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  /** An array relationship */
  player_games: Array<Espin_Player_Game>;
  /** An aggregate relationship */
  player_games_aggregate: Espin_Player_Game_Aggregate;
  player_subscription_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  player_teams: Array<Espin_Team_Members>;
  /** An aggregate relationship */
  player_teams_aggregate: Espin_Team_Members_Aggregate;
  /** An array relationship */
  player_vods: Array<Espin_Player_Vod>;
  /** An aggregate relationship */
  player_vods_aggregate: Espin_Player_Vod_Aggregate;
  preferred_schools?: Maybe<Scalars['jsonb']>;
  preferred_study_fields?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  profile_image?: Maybe<Content_File>;
  profile_image_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  referral_option?: Maybe<Espin_Referral_Option>;
  referral_option_id?: Maybe<Scalars['uuid']>;
  slug: Scalars['String'];
  /** An object relationship */
  social?: Maybe<Espin_Social>;
  socials_id?: Maybe<Scalars['uuid']>;
  spin_username: Scalars['String'];
  /** An array relationship */
  stickied_players: Array<Espin_Stickied_Player>;
  /** An aggregate relationship */
  stickied_players_aggregate: Espin_Stickied_Player_Aggregate;
  sub_connected_colleges?: Maybe<Scalars['jsonb']>;
  sub_last_meeting?: Maybe<Scalars['timestamptz']>;
  sub_sales_notes?: Maybe<Scalars['String']>;
  /** A computed field, executes function "espin.subject_study_field" */
  subject_study_field?: Maybe<Array<Espin_Study_Subject>>;
  subscribed_override: Scalars['Boolean'];
  /** An object relationship */
  subscription?: Maybe<Espin_Player_Subscription>;
  trial_end_date?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Espin_User;
  user_id: Scalars['String'];
  user_source?: Maybe<Scalars['String']>;
};


/** Profile for a player in the system */
export type Espin_Player_ProfileGeneral_Study_FieldArgs = {
  distinct_on?: InputMaybe<Array<Espin_Study_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Study_Field_Order_By>>;
  where?: InputMaybe<Espin_Study_Field_Bool_Exp>;
};


/** Profile for a player in the system */
export type Espin_Player_ProfilePlayer_GamesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Game_Order_By>>;
  where?: InputMaybe<Espin_Player_Game_Bool_Exp>;
};


/** Profile for a player in the system */
export type Espin_Player_ProfilePlayer_Games_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Game_Order_By>>;
  where?: InputMaybe<Espin_Player_Game_Bool_Exp>;
};


/** Profile for a player in the system */
export type Espin_Player_ProfilePlayer_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Members_Order_By>>;
  where?: InputMaybe<Espin_Team_Members_Bool_Exp>;
};


/** Profile for a player in the system */
export type Espin_Player_ProfilePlayer_Teams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Members_Order_By>>;
  where?: InputMaybe<Espin_Team_Members_Bool_Exp>;
};


/** Profile for a player in the system */
export type Espin_Player_ProfilePlayer_VodsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Vod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Vod_Order_By>>;
  where?: InputMaybe<Espin_Player_Vod_Bool_Exp>;
};


/** Profile for a player in the system */
export type Espin_Player_ProfilePlayer_Vods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Vod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Vod_Order_By>>;
  where?: InputMaybe<Espin_Player_Vod_Bool_Exp>;
};


/** Profile for a player in the system */
export type Espin_Player_ProfilePreferred_SchoolsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Profile for a player in the system */
export type Espin_Player_ProfilePreferred_Study_FieldsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Profile for a player in the system */
export type Espin_Player_ProfileStickied_PlayersArgs = {
  distinct_on?: InputMaybe<Array<Espin_Stickied_Player_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Stickied_Player_Order_By>>;
  where?: InputMaybe<Espin_Stickied_Player_Bool_Exp>;
};


/** Profile for a player in the system */
export type Espin_Player_ProfileStickied_Players_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Stickied_Player_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Stickied_Player_Order_By>>;
  where?: InputMaybe<Espin_Stickied_Player_Bool_Exp>;
};


/** Profile for a player in the system */
export type Espin_Player_ProfileSub_Connected_CollegesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Profile for a player in the system */
export type Espin_Player_ProfileSubject_Study_FieldArgs = {
  distinct_on?: InputMaybe<Array<Espin_Study_Subject_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Study_Subject_Order_By>>;
  where?: InputMaybe<Espin_Study_Subject_Bool_Exp>;
};

/** aggregated selection of "espin.player_profile" */
export type Espin_Player_Profile_Aggregate = {
  __typename?: 'espin_player_profile_aggregate';
  aggregate?: Maybe<Espin_Player_Profile_Aggregate_Fields>;
  nodes: Array<Espin_Player_Profile>;
};

export type Espin_Player_Profile_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Espin_Player_Profile_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Espin_Player_Profile_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Espin_Player_Profile_Aggregate_Bool_Exp_Count>;
};

export type Espin_Player_Profile_Aggregate_Bool_Exp_Bool_And = {
  arguments: Espin_Player_Profile_Select_Column_Espin_Player_Profile_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_Player_Profile_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Espin_Player_Profile_Select_Column_Espin_Player_Profile_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Espin_Player_Profile_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.player_profile" */
export type Espin_Player_Profile_Aggregate_Fields = {
  __typename?: 'espin_player_profile_aggregate_fields';
  avg?: Maybe<Espin_Player_Profile_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Player_Profile_Max_Fields>;
  min?: Maybe<Espin_Player_Profile_Min_Fields>;
  stddev?: Maybe<Espin_Player_Profile_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Player_Profile_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Player_Profile_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Player_Profile_Sum_Fields>;
  var_pop?: Maybe<Espin_Player_Profile_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Player_Profile_Var_Samp_Fields>;
  variance?: Maybe<Espin_Player_Profile_Variance_Fields>;
};


/** aggregate fields of "espin.player_profile" */
export type Espin_Player_Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.player_profile" */
export type Espin_Player_Profile_Aggregate_Order_By = {
  avg?: InputMaybe<Espin_Player_Profile_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Player_Profile_Max_Order_By>;
  min?: InputMaybe<Espin_Player_Profile_Min_Order_By>;
  stddev?: InputMaybe<Espin_Player_Profile_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Espin_Player_Profile_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Espin_Player_Profile_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Espin_Player_Profile_Sum_Order_By>;
  var_pop?: InputMaybe<Espin_Player_Profile_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Espin_Player_Profile_Var_Samp_Order_By>;
  variance?: InputMaybe<Espin_Player_Profile_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Espin_Player_Profile_Append_Input = {
  preferred_schools?: InputMaybe<Scalars['jsonb']>;
  preferred_study_fields?: InputMaybe<Scalars['jsonb']>;
  sub_connected_colleges?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "espin.player_profile" */
export type Espin_Player_Profile_Arr_Rel_Insert_Input = {
  data: Array<Espin_Player_Profile_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Player_Profile_On_Conflict>;
};

/** aggregate avg on columns */
export type Espin_Player_Profile_Avg_Fields = {
  __typename?: 'espin_player_profile_avg_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "espin.player_profile" */
export type Espin_Player_Profile_Avg_Order_By = {
  gpa?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "espin.player_profile". All fields are combined with a logical 'AND'. */
export type Espin_Player_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Player_Profile_Bool_Exp>>;
  _not?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Player_Profile_Bool_Exp>>;
  ack_displayed?: InputMaybe<Boolean_Comparison_Exp>;
  ack_terms?: InputMaybe<Boolean_Comparison_Exp>;
  ack_waiver?: InputMaybe<Boolean_Comparison_Exp>;
  address?: InputMaybe<Espin_Address_Bool_Exp>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  bio?: InputMaybe<String_Comparison_Exp>;
  birthdate?: InputMaybe<Date_Comparison_Exp>;
  college_coach_email?: InputMaybe<String_Comparison_Exp>;
  college_coach_name?: InputMaybe<String_Comparison_Exp>;
  college_name?: InputMaybe<String_Comparison_Exp>;
  committed_to_college?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ethnicity?: InputMaybe<Espin_Ethnicity_Options_Enum_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<Espin_Gender_Options_Enum_Comparison_Exp>;
  gender_not_listed_entry?: InputMaybe<String_Comparison_Exp>;
  general_study_field?: InputMaybe<Espin_Study_Field_Bool_Exp>;
  gpa?: InputMaybe<Numeric_Comparison_Exp>;
  graduating_class?: InputMaybe<String_Comparison_Exp>;
  hs_coach_email?: InputMaybe<String_Comparison_Exp>;
  hs_coach_name?: InputMaybe<String_Comparison_Exp>;
  hs_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_hs?: InputMaybe<Boolean_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  linked_high_school?: InputMaybe<Uuid_Comparison_Exp>;
  linked_high_school_details?: InputMaybe<Espin_High_School_Bool_Exp>;
  parent_email?: InputMaybe<String_Comparison_Exp>;
  parent_profile?: InputMaybe<Espin_Parent_Profile_Bool_Exp>;
  parent_profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  player_games?: InputMaybe<Espin_Player_Game_Bool_Exp>;
  player_games_aggregate?: InputMaybe<Espin_Player_Game_Aggregate_Bool_Exp>;
  player_subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  player_teams?: InputMaybe<Espin_Team_Members_Bool_Exp>;
  player_teams_aggregate?: InputMaybe<Espin_Team_Members_Aggregate_Bool_Exp>;
  player_vods?: InputMaybe<Espin_Player_Vod_Bool_Exp>;
  player_vods_aggregate?: InputMaybe<Espin_Player_Vod_Aggregate_Bool_Exp>;
  preferred_schools?: InputMaybe<Jsonb_Comparison_Exp>;
  preferred_study_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  profile_image?: InputMaybe<Content_File_Bool_Exp>;
  profile_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  referral_option?: InputMaybe<Espin_Referral_Option_Bool_Exp>;
  referral_option_id?: InputMaybe<Uuid_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  social?: InputMaybe<Espin_Social_Bool_Exp>;
  socials_id?: InputMaybe<Uuid_Comparison_Exp>;
  spin_username?: InputMaybe<String_Comparison_Exp>;
  stickied_players?: InputMaybe<Espin_Stickied_Player_Bool_Exp>;
  stickied_players_aggregate?: InputMaybe<Espin_Stickied_Player_Aggregate_Bool_Exp>;
  sub_connected_colleges?: InputMaybe<Jsonb_Comparison_Exp>;
  sub_last_meeting?: InputMaybe<Timestamptz_Comparison_Exp>;
  sub_sales_notes?: InputMaybe<String_Comparison_Exp>;
  subject_study_field?: InputMaybe<Espin_Study_Subject_Bool_Exp>;
  subscribed_override?: InputMaybe<Boolean_Comparison_Exp>;
  subscription?: InputMaybe<Espin_Player_Subscription_Bool_Exp>;
  trial_end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Espin_User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_source?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.player_profile" */
export enum Espin_Player_Profile_Constraint {
  /** unique or primary key constraint on columns "spin_username" */
  PlayerProfileGamerTagKey = 'player_profile_gamer_tag_key',
  /** unique or primary key constraint on columns "id" */
  PlayerProfilePkey = 'player_profile_pkey',
  /** unique or primary key constraint on columns "slug" */
  PlayerProfileSlugKey = 'player_profile_slug_key',
  /** unique or primary key constraint on columns "user_id" */
  PlayerProfileUserIdKey = 'player_profile_user_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Espin_Player_Profile_Delete_At_Path_Input = {
  preferred_schools?: InputMaybe<Array<Scalars['String']>>;
  preferred_study_fields?: InputMaybe<Array<Scalars['String']>>;
  sub_connected_colleges?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Espin_Player_Profile_Delete_Elem_Input = {
  preferred_schools?: InputMaybe<Scalars['Int']>;
  preferred_study_fields?: InputMaybe<Scalars['Int']>;
  sub_connected_colleges?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Espin_Player_Profile_Delete_Key_Input = {
  preferred_schools?: InputMaybe<Scalars['String']>;
  preferred_study_fields?: InputMaybe<Scalars['String']>;
  sub_connected_colleges?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "espin.player_profile" */
export type Espin_Player_Profile_Inc_Input = {
  gpa?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "espin.player_profile" */
export type Espin_Player_Profile_Insert_Input = {
  /** Display profile to premium members acknowledgement */
  ack_displayed?: InputMaybe<Scalars['Boolean']>;
  ack_terms?: InputMaybe<Scalars['Boolean']>;
  ack_waiver?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Espin_Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['uuid']>;
  bio?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['date']>;
  college_coach_email?: InputMaybe<Scalars['String']>;
  college_coach_name?: InputMaybe<Scalars['String']>;
  college_name?: InputMaybe<Scalars['String']>;
  committed_to_college?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  ethnicity?: InputMaybe<Espin_Ethnicity_Options_Enum>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Espin_Gender_Options_Enum>;
  gender_not_listed_entry?: InputMaybe<Scalars['String']>;
  gpa?: InputMaybe<Scalars['numeric']>;
  graduating_class?: InputMaybe<Scalars['String']>;
  hs_coach_email?: InputMaybe<Scalars['String']>;
  hs_coach_name?: InputMaybe<Scalars['String']>;
  hs_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_hs?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  linked_high_school?: InputMaybe<Scalars['uuid']>;
  linked_high_school_details?: InputMaybe<Espin_High_School_Obj_Rel_Insert_Input>;
  parent_email?: InputMaybe<Scalars['String']>;
  parent_profile?: InputMaybe<Espin_Parent_Profile_Obj_Rel_Insert_Input>;
  parent_profile_id?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  player_games?: InputMaybe<Espin_Player_Game_Arr_Rel_Insert_Input>;
  player_subscription_id?: InputMaybe<Scalars['uuid']>;
  player_teams?: InputMaybe<Espin_Team_Members_Arr_Rel_Insert_Input>;
  player_vods?: InputMaybe<Espin_Player_Vod_Arr_Rel_Insert_Input>;
  preferred_schools?: InputMaybe<Scalars['jsonb']>;
  preferred_study_fields?: InputMaybe<Scalars['jsonb']>;
  profile_image?: InputMaybe<Content_File_Obj_Rel_Insert_Input>;
  profile_image_id?: InputMaybe<Scalars['uuid']>;
  referral_option?: InputMaybe<Espin_Referral_Option_Obj_Rel_Insert_Input>;
  referral_option_id?: InputMaybe<Scalars['uuid']>;
  slug?: InputMaybe<Scalars['String']>;
  social?: InputMaybe<Espin_Social_Obj_Rel_Insert_Input>;
  socials_id?: InputMaybe<Scalars['uuid']>;
  spin_username?: InputMaybe<Scalars['String']>;
  stickied_players?: InputMaybe<Espin_Stickied_Player_Arr_Rel_Insert_Input>;
  sub_connected_colleges?: InputMaybe<Scalars['jsonb']>;
  sub_last_meeting?: InputMaybe<Scalars['timestamptz']>;
  sub_sales_notes?: InputMaybe<Scalars['String']>;
  subscribed_override?: InputMaybe<Scalars['Boolean']>;
  subscription?: InputMaybe<Espin_Player_Subscription_Obj_Rel_Insert_Input>;
  trial_end_date?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']>;
  user_source?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Player_Profile_Max_Fields = {
  __typename?: 'espin_player_profile_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['date']>;
  college_coach_email?: Maybe<Scalars['String']>;
  college_coach_name?: Maybe<Scalars['String']>;
  college_name?: Maybe<Scalars['String']>;
  committed_to_college?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  gender_not_listed_entry?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['numeric']>;
  graduating_class?: Maybe<Scalars['String']>;
  hs_coach_email?: Maybe<Scalars['String']>;
  hs_coach_name?: Maybe<Scalars['String']>;
  hs_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  linked_high_school?: Maybe<Scalars['uuid']>;
  parent_email?: Maybe<Scalars['String']>;
  parent_profile_id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  player_subscription_id?: Maybe<Scalars['uuid']>;
  profile_image_id?: Maybe<Scalars['uuid']>;
  referral_option_id?: Maybe<Scalars['uuid']>;
  slug?: Maybe<Scalars['String']>;
  socials_id?: Maybe<Scalars['uuid']>;
  spin_username?: Maybe<Scalars['String']>;
  sub_last_meeting?: Maybe<Scalars['timestamptz']>;
  sub_sales_notes?: Maybe<Scalars['String']>;
  trial_end_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
  user_source?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.player_profile" */
export type Espin_Player_Profile_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  bio?: InputMaybe<Order_By>;
  birthdate?: InputMaybe<Order_By>;
  college_coach_email?: InputMaybe<Order_By>;
  college_coach_name?: InputMaybe<Order_By>;
  college_name?: InputMaybe<Order_By>;
  committed_to_college?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender_not_listed_entry?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  graduating_class?: InputMaybe<Order_By>;
  hs_coach_email?: InputMaybe<Order_By>;
  hs_coach_name?: InputMaybe<Order_By>;
  hs_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  linked_high_school?: InputMaybe<Order_By>;
  parent_email?: InputMaybe<Order_By>;
  parent_profile_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  player_subscription_id?: InputMaybe<Order_By>;
  profile_image_id?: InputMaybe<Order_By>;
  referral_option_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  socials_id?: InputMaybe<Order_By>;
  spin_username?: InputMaybe<Order_By>;
  sub_last_meeting?: InputMaybe<Order_By>;
  sub_sales_notes?: InputMaybe<Order_By>;
  trial_end_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_source?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Player_Profile_Min_Fields = {
  __typename?: 'espin_player_profile_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['date']>;
  college_coach_email?: Maybe<Scalars['String']>;
  college_coach_name?: Maybe<Scalars['String']>;
  college_name?: Maybe<Scalars['String']>;
  committed_to_college?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  gender_not_listed_entry?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['numeric']>;
  graduating_class?: Maybe<Scalars['String']>;
  hs_coach_email?: Maybe<Scalars['String']>;
  hs_coach_name?: Maybe<Scalars['String']>;
  hs_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  linked_high_school?: Maybe<Scalars['uuid']>;
  parent_email?: Maybe<Scalars['String']>;
  parent_profile_id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  player_subscription_id?: Maybe<Scalars['uuid']>;
  profile_image_id?: Maybe<Scalars['uuid']>;
  referral_option_id?: Maybe<Scalars['uuid']>;
  slug?: Maybe<Scalars['String']>;
  socials_id?: Maybe<Scalars['uuid']>;
  spin_username?: Maybe<Scalars['String']>;
  sub_last_meeting?: Maybe<Scalars['timestamptz']>;
  sub_sales_notes?: Maybe<Scalars['String']>;
  trial_end_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
  user_source?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.player_profile" */
export type Espin_Player_Profile_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  bio?: InputMaybe<Order_By>;
  birthdate?: InputMaybe<Order_By>;
  college_coach_email?: InputMaybe<Order_By>;
  college_coach_name?: InputMaybe<Order_By>;
  college_name?: InputMaybe<Order_By>;
  committed_to_college?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender_not_listed_entry?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  graduating_class?: InputMaybe<Order_By>;
  hs_coach_email?: InputMaybe<Order_By>;
  hs_coach_name?: InputMaybe<Order_By>;
  hs_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  linked_high_school?: InputMaybe<Order_By>;
  parent_email?: InputMaybe<Order_By>;
  parent_profile_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  player_subscription_id?: InputMaybe<Order_By>;
  profile_image_id?: InputMaybe<Order_By>;
  referral_option_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  socials_id?: InputMaybe<Order_By>;
  spin_username?: InputMaybe<Order_By>;
  sub_last_meeting?: InputMaybe<Order_By>;
  sub_sales_notes?: InputMaybe<Order_By>;
  trial_end_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_source?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.player_profile" */
export type Espin_Player_Profile_Mutation_Response = {
  __typename?: 'espin_player_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Player_Profile>;
};

/** input type for inserting object relation for remote table "espin.player_profile" */
export type Espin_Player_Profile_Obj_Rel_Insert_Input = {
  data: Espin_Player_Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Player_Profile_On_Conflict>;
};

/** on_conflict condition type for table "espin.player_profile" */
export type Espin_Player_Profile_On_Conflict = {
  constraint: Espin_Player_Profile_Constraint;
  update_columns?: Array<Espin_Player_Profile_Update_Column>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.player_profile". */
export type Espin_Player_Profile_Order_By = {
  ack_displayed?: InputMaybe<Order_By>;
  ack_terms?: InputMaybe<Order_By>;
  ack_waiver?: InputMaybe<Order_By>;
  address?: InputMaybe<Espin_Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  bio?: InputMaybe<Order_By>;
  birthdate?: InputMaybe<Order_By>;
  college_coach_email?: InputMaybe<Order_By>;
  college_coach_name?: InputMaybe<Order_By>;
  college_name?: InputMaybe<Order_By>;
  committed_to_college?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ethnicity?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  gender_not_listed_entry?: InputMaybe<Order_By>;
  general_study_field_aggregate?: InputMaybe<Espin_Study_Field_Aggregate_Order_By>;
  gpa?: InputMaybe<Order_By>;
  graduating_class?: InputMaybe<Order_By>;
  hs_coach_email?: InputMaybe<Order_By>;
  hs_coach_name?: InputMaybe<Order_By>;
  hs_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_hs?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  linked_high_school?: InputMaybe<Order_By>;
  linked_high_school_details?: InputMaybe<Espin_High_School_Order_By>;
  parent_email?: InputMaybe<Order_By>;
  parent_profile?: InputMaybe<Espin_Parent_Profile_Order_By>;
  parent_profile_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  player_games_aggregate?: InputMaybe<Espin_Player_Game_Aggregate_Order_By>;
  player_subscription_id?: InputMaybe<Order_By>;
  player_teams_aggregate?: InputMaybe<Espin_Team_Members_Aggregate_Order_By>;
  player_vods_aggregate?: InputMaybe<Espin_Player_Vod_Aggregate_Order_By>;
  preferred_schools?: InputMaybe<Order_By>;
  preferred_study_fields?: InputMaybe<Order_By>;
  profile_image?: InputMaybe<Content_File_Order_By>;
  profile_image_id?: InputMaybe<Order_By>;
  referral_option?: InputMaybe<Espin_Referral_Option_Order_By>;
  referral_option_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  social?: InputMaybe<Espin_Social_Order_By>;
  socials_id?: InputMaybe<Order_By>;
  spin_username?: InputMaybe<Order_By>;
  stickied_players_aggregate?: InputMaybe<Espin_Stickied_Player_Aggregate_Order_By>;
  sub_connected_colleges?: InputMaybe<Order_By>;
  sub_last_meeting?: InputMaybe<Order_By>;
  sub_sales_notes?: InputMaybe<Order_By>;
  subject_study_field_aggregate?: InputMaybe<Espin_Study_Subject_Aggregate_Order_By>;
  subscribed_override?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Espin_Player_Subscription_Order_By>;
  trial_end_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Espin_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.player_profile */
export type Espin_Player_Profile_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Espin_Player_Profile_Prepend_Input = {
  preferred_schools?: InputMaybe<Scalars['jsonb']>;
  preferred_study_fields?: InputMaybe<Scalars['jsonb']>;
  sub_connected_colleges?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "espin.player_profile" */
export enum Espin_Player_Profile_Select_Column {
  /** column name */
  AckDisplayed = 'ack_displayed',
  /** column name */
  AckTerms = 'ack_terms',
  /** column name */
  AckWaiver = 'ack_waiver',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Bio = 'bio',
  /** column name */
  Birthdate = 'birthdate',
  /** column name */
  CollegeCoachEmail = 'college_coach_email',
  /** column name */
  CollegeCoachName = 'college_coach_name',
  /** column name */
  CollegeName = 'college_name',
  /** column name */
  CommittedToCollege = 'committed_to_college',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Ethnicity = 'ethnicity',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  GenderNotListedEntry = 'gender_not_listed_entry',
  /** column name */
  Gpa = 'gpa',
  /** column name */
  GraduatingClass = 'graduating_class',
  /** column name */
  HsCoachEmail = 'hs_coach_email',
  /** column name */
  HsCoachName = 'hs_coach_name',
  /** column name */
  HsName = 'hs_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsHs = 'is_hs',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LinkedHighSchool = 'linked_high_school',
  /** column name */
  ParentEmail = 'parent_email',
  /** column name */
  ParentProfileId = 'parent_profile_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  PlayerSubscriptionId = 'player_subscription_id',
  /** column name */
  PreferredSchools = 'preferred_schools',
  /** column name */
  PreferredStudyFields = 'preferred_study_fields',
  /** column name */
  ProfileImageId = 'profile_image_id',
  /** column name */
  ReferralOptionId = 'referral_option_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  SocialsId = 'socials_id',
  /** column name */
  SpinUsername = 'spin_username',
  /** column name */
  SubConnectedColleges = 'sub_connected_colleges',
  /** column name */
  SubLastMeeting = 'sub_last_meeting',
  /** column name */
  SubSalesNotes = 'sub_sales_notes',
  /** column name */
  SubscribedOverride = 'subscribed_override',
  /** column name */
  TrialEndDate = 'trial_end_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserSource = 'user_source'
}

/** select "espin_player_profile_aggregate_bool_exp_bool_and_arguments_columns" columns of table "espin.player_profile" */
export enum Espin_Player_Profile_Select_Column_Espin_Player_Profile_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AckDisplayed = 'ack_displayed',
  /** column name */
  AckTerms = 'ack_terms',
  /** column name */
  AckWaiver = 'ack_waiver',
  /** column name */
  IsHs = 'is_hs',
  /** column name */
  SubscribedOverride = 'subscribed_override'
}

/** select "espin_player_profile_aggregate_bool_exp_bool_or_arguments_columns" columns of table "espin.player_profile" */
export enum Espin_Player_Profile_Select_Column_Espin_Player_Profile_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AckDisplayed = 'ack_displayed',
  /** column name */
  AckTerms = 'ack_terms',
  /** column name */
  AckWaiver = 'ack_waiver',
  /** column name */
  IsHs = 'is_hs',
  /** column name */
  SubscribedOverride = 'subscribed_override'
}

/** input type for updating data in table "espin.player_profile" */
export type Espin_Player_Profile_Set_Input = {
  /** Display profile to premium members acknowledgement */
  ack_displayed?: InputMaybe<Scalars['Boolean']>;
  ack_terms?: InputMaybe<Scalars['Boolean']>;
  ack_waiver?: InputMaybe<Scalars['Boolean']>;
  address_id?: InputMaybe<Scalars['uuid']>;
  bio?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['date']>;
  college_coach_email?: InputMaybe<Scalars['String']>;
  college_coach_name?: InputMaybe<Scalars['String']>;
  college_name?: InputMaybe<Scalars['String']>;
  committed_to_college?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  ethnicity?: InputMaybe<Espin_Ethnicity_Options_Enum>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Espin_Gender_Options_Enum>;
  gender_not_listed_entry?: InputMaybe<Scalars['String']>;
  gpa?: InputMaybe<Scalars['numeric']>;
  graduating_class?: InputMaybe<Scalars['String']>;
  hs_coach_email?: InputMaybe<Scalars['String']>;
  hs_coach_name?: InputMaybe<Scalars['String']>;
  hs_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_hs?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  linked_high_school?: InputMaybe<Scalars['uuid']>;
  parent_email?: InputMaybe<Scalars['String']>;
  parent_profile_id?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  player_subscription_id?: InputMaybe<Scalars['uuid']>;
  preferred_schools?: InputMaybe<Scalars['jsonb']>;
  preferred_study_fields?: InputMaybe<Scalars['jsonb']>;
  profile_image_id?: InputMaybe<Scalars['uuid']>;
  referral_option_id?: InputMaybe<Scalars['uuid']>;
  slug?: InputMaybe<Scalars['String']>;
  socials_id?: InputMaybe<Scalars['uuid']>;
  spin_username?: InputMaybe<Scalars['String']>;
  sub_connected_colleges?: InputMaybe<Scalars['jsonb']>;
  sub_last_meeting?: InputMaybe<Scalars['timestamptz']>;
  sub_sales_notes?: InputMaybe<Scalars['String']>;
  subscribed_override?: InputMaybe<Scalars['Boolean']>;
  trial_end_date?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  user_source?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Espin_Player_Profile_Stddev_Fields = {
  __typename?: 'espin_player_profile_stddev_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "espin.player_profile" */
export type Espin_Player_Profile_Stddev_Order_By = {
  gpa?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Espin_Player_Profile_Stddev_Pop_Fields = {
  __typename?: 'espin_player_profile_stddev_pop_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "espin.player_profile" */
export type Espin_Player_Profile_Stddev_Pop_Order_By = {
  gpa?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Espin_Player_Profile_Stddev_Samp_Fields = {
  __typename?: 'espin_player_profile_stddev_samp_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "espin.player_profile" */
export type Espin_Player_Profile_Stddev_Samp_Order_By = {
  gpa?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "espin_player_profile" */
export type Espin_Player_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Player_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Player_Profile_Stream_Cursor_Value_Input = {
  /** Display profile to premium members acknowledgement */
  ack_displayed?: InputMaybe<Scalars['Boolean']>;
  ack_terms?: InputMaybe<Scalars['Boolean']>;
  ack_waiver?: InputMaybe<Scalars['Boolean']>;
  address_id?: InputMaybe<Scalars['uuid']>;
  bio?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['date']>;
  college_coach_email?: InputMaybe<Scalars['String']>;
  college_coach_name?: InputMaybe<Scalars['String']>;
  college_name?: InputMaybe<Scalars['String']>;
  committed_to_college?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  ethnicity?: InputMaybe<Espin_Ethnicity_Options_Enum>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Espin_Gender_Options_Enum>;
  gender_not_listed_entry?: InputMaybe<Scalars['String']>;
  gpa?: InputMaybe<Scalars['numeric']>;
  graduating_class?: InputMaybe<Scalars['String']>;
  hs_coach_email?: InputMaybe<Scalars['String']>;
  hs_coach_name?: InputMaybe<Scalars['String']>;
  hs_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_hs?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  linked_high_school?: InputMaybe<Scalars['uuid']>;
  parent_email?: InputMaybe<Scalars['String']>;
  parent_profile_id?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  player_subscription_id?: InputMaybe<Scalars['uuid']>;
  preferred_schools?: InputMaybe<Scalars['jsonb']>;
  preferred_study_fields?: InputMaybe<Scalars['jsonb']>;
  profile_image_id?: InputMaybe<Scalars['uuid']>;
  referral_option_id?: InputMaybe<Scalars['uuid']>;
  slug?: InputMaybe<Scalars['String']>;
  socials_id?: InputMaybe<Scalars['uuid']>;
  spin_username?: InputMaybe<Scalars['String']>;
  sub_connected_colleges?: InputMaybe<Scalars['jsonb']>;
  sub_last_meeting?: InputMaybe<Scalars['timestamptz']>;
  sub_sales_notes?: InputMaybe<Scalars['String']>;
  subscribed_override?: InputMaybe<Scalars['Boolean']>;
  trial_end_date?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  user_source?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Espin_Player_Profile_Sum_Fields = {
  __typename?: 'espin_player_profile_sum_fields';
  gpa?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "espin.player_profile" */
export type Espin_Player_Profile_Sum_Order_By = {
  gpa?: InputMaybe<Order_By>;
};

/** update columns of table "espin.player_profile" */
export enum Espin_Player_Profile_Update_Column {
  /** column name */
  AckDisplayed = 'ack_displayed',
  /** column name */
  AckTerms = 'ack_terms',
  /** column name */
  AckWaiver = 'ack_waiver',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Bio = 'bio',
  /** column name */
  Birthdate = 'birthdate',
  /** column name */
  CollegeCoachEmail = 'college_coach_email',
  /** column name */
  CollegeCoachName = 'college_coach_name',
  /** column name */
  CollegeName = 'college_name',
  /** column name */
  CommittedToCollege = 'committed_to_college',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Ethnicity = 'ethnicity',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  GenderNotListedEntry = 'gender_not_listed_entry',
  /** column name */
  Gpa = 'gpa',
  /** column name */
  GraduatingClass = 'graduating_class',
  /** column name */
  HsCoachEmail = 'hs_coach_email',
  /** column name */
  HsCoachName = 'hs_coach_name',
  /** column name */
  HsName = 'hs_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsHs = 'is_hs',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LinkedHighSchool = 'linked_high_school',
  /** column name */
  ParentEmail = 'parent_email',
  /** column name */
  ParentProfileId = 'parent_profile_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  PlayerSubscriptionId = 'player_subscription_id',
  /** column name */
  PreferredSchools = 'preferred_schools',
  /** column name */
  PreferredStudyFields = 'preferred_study_fields',
  /** column name */
  ProfileImageId = 'profile_image_id',
  /** column name */
  ReferralOptionId = 'referral_option_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  SocialsId = 'socials_id',
  /** column name */
  SpinUsername = 'spin_username',
  /** column name */
  SubConnectedColleges = 'sub_connected_colleges',
  /** column name */
  SubLastMeeting = 'sub_last_meeting',
  /** column name */
  SubSalesNotes = 'sub_sales_notes',
  /** column name */
  SubscribedOverride = 'subscribed_override',
  /** column name */
  TrialEndDate = 'trial_end_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserSource = 'user_source'
}

export type Espin_Player_Profile_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Espin_Player_Profile_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Espin_Player_Profile_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Espin_Player_Profile_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Espin_Player_Profile_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Player_Profile_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Espin_Player_Profile_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Player_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Player_Profile_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Player_Profile_Var_Pop_Fields = {
  __typename?: 'espin_player_profile_var_pop_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "espin.player_profile" */
export type Espin_Player_Profile_Var_Pop_Order_By = {
  gpa?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Espin_Player_Profile_Var_Samp_Fields = {
  __typename?: 'espin_player_profile_var_samp_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "espin.player_profile" */
export type Espin_Player_Profile_Var_Samp_Order_By = {
  gpa?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Espin_Player_Profile_Variance_Fields = {
  __typename?: 'espin_player_profile_variance_fields';
  gpa?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "espin.player_profile" */
export type Espin_Player_Profile_Variance_Order_By = {
  gpa?: InputMaybe<Order_By>;
};

/** Player subscription information */
export type Espin_Player_Subscription = {
  __typename?: 'espin_player_subscription';
  expires: Scalars['bigint'];
  id: Scalars['uuid'];
  plan: Espin_Paid_Product_Enum;
  /** An array relationship */
  player_profile: Array<Espin_Player_Profile>;
  /** An aggregate relationship */
  player_profile_aggregate: Espin_Player_Profile_Aggregate;
  /** An object relationship */
  referral_code_redemption?: Maybe<Espin_Referral_Code_Redemption>;
  referral_code_redemption_id?: Maybe<Scalars['uuid']>;
  status: Espin_Subscription_Status_Enum;
};


/** Player subscription information */
export type Espin_Player_SubscriptionPlayer_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};


/** Player subscription information */
export type Espin_Player_SubscriptionPlayer_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};

/** aggregated selection of "espin.player_subscription" */
export type Espin_Player_Subscription_Aggregate = {
  __typename?: 'espin_player_subscription_aggregate';
  aggregate?: Maybe<Espin_Player_Subscription_Aggregate_Fields>;
  nodes: Array<Espin_Player_Subscription>;
};

/** aggregate fields of "espin.player_subscription" */
export type Espin_Player_Subscription_Aggregate_Fields = {
  __typename?: 'espin_player_subscription_aggregate_fields';
  avg?: Maybe<Espin_Player_Subscription_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Player_Subscription_Max_Fields>;
  min?: Maybe<Espin_Player_Subscription_Min_Fields>;
  stddev?: Maybe<Espin_Player_Subscription_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Player_Subscription_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Player_Subscription_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Player_Subscription_Sum_Fields>;
  var_pop?: Maybe<Espin_Player_Subscription_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Player_Subscription_Var_Samp_Fields>;
  variance?: Maybe<Espin_Player_Subscription_Variance_Fields>;
};


/** aggregate fields of "espin.player_subscription" */
export type Espin_Player_Subscription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Player_Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Espin_Player_Subscription_Avg_Fields = {
  __typename?: 'espin_player_subscription_avg_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.player_subscription". All fields are combined with a logical 'AND'. */
export type Espin_Player_Subscription_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Player_Subscription_Bool_Exp>>;
  _not?: InputMaybe<Espin_Player_Subscription_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Player_Subscription_Bool_Exp>>;
  expires?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  plan?: InputMaybe<Espin_Paid_Product_Enum_Comparison_Exp>;
  player_profile?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  player_profile_aggregate?: InputMaybe<Espin_Player_Profile_Aggregate_Bool_Exp>;
  referral_code_redemption?: InputMaybe<Espin_Referral_Code_Redemption_Bool_Exp>;
  referral_code_redemption_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Espin_Subscription_Status_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.player_subscription" */
export enum Espin_Player_Subscription_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlayerSubscriptionsPkey = 'player_subscriptions_pkey'
}

/** input type for incrementing numeric columns in table "espin.player_subscription" */
export type Espin_Player_Subscription_Inc_Input = {
  expires?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "espin.player_subscription" */
export type Espin_Player_Subscription_Insert_Input = {
  expires?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  plan?: InputMaybe<Espin_Paid_Product_Enum>;
  player_profile?: InputMaybe<Espin_Player_Profile_Arr_Rel_Insert_Input>;
  referral_code_redemption?: InputMaybe<Espin_Referral_Code_Redemption_Obj_Rel_Insert_Input>;
  referral_code_redemption_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Subscription_Status_Enum>;
};

/** aggregate max on columns */
export type Espin_Player_Subscription_Max_Fields = {
  __typename?: 'espin_player_subscription_max_fields';
  expires?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  referral_code_redemption_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Espin_Player_Subscription_Min_Fields = {
  __typename?: 'espin_player_subscription_min_fields';
  expires?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  referral_code_redemption_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "espin.player_subscription" */
export type Espin_Player_Subscription_Mutation_Response = {
  __typename?: 'espin_player_subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Player_Subscription>;
};

/** input type for inserting object relation for remote table "espin.player_subscription" */
export type Espin_Player_Subscription_Obj_Rel_Insert_Input = {
  data: Espin_Player_Subscription_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Player_Subscription_On_Conflict>;
};

/** on_conflict condition type for table "espin.player_subscription" */
export type Espin_Player_Subscription_On_Conflict = {
  constraint: Espin_Player_Subscription_Constraint;
  update_columns?: Array<Espin_Player_Subscription_Update_Column>;
  where?: InputMaybe<Espin_Player_Subscription_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.player_subscription". */
export type Espin_Player_Subscription_Order_By = {
  expires?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  player_profile_aggregate?: InputMaybe<Espin_Player_Profile_Aggregate_Order_By>;
  referral_code_redemption?: InputMaybe<Espin_Referral_Code_Redemption_Order_By>;
  referral_code_redemption_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.player_subscription */
export type Espin_Player_Subscription_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.player_subscription" */
export enum Espin_Player_Subscription_Select_Column {
  /** column name */
  Expires = 'expires',
  /** column name */
  Id = 'id',
  /** column name */
  Plan = 'plan',
  /** column name */
  ReferralCodeRedemptionId = 'referral_code_redemption_id',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "espin.player_subscription" */
export type Espin_Player_Subscription_Set_Input = {
  expires?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  plan?: InputMaybe<Espin_Paid_Product_Enum>;
  referral_code_redemption_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Subscription_Status_Enum>;
};

/** aggregate stddev on columns */
export type Espin_Player_Subscription_Stddev_Fields = {
  __typename?: 'espin_player_subscription_stddev_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_Player_Subscription_Stddev_Pop_Fields = {
  __typename?: 'espin_player_subscription_stddev_pop_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_Player_Subscription_Stddev_Samp_Fields = {
  __typename?: 'espin_player_subscription_stddev_samp_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_player_subscription" */
export type Espin_Player_Subscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Player_Subscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Player_Subscription_Stream_Cursor_Value_Input = {
  expires?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  plan?: InputMaybe<Espin_Paid_Product_Enum>;
  referral_code_redemption_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Subscription_Status_Enum>;
};

/** aggregate sum on columns */
export type Espin_Player_Subscription_Sum_Fields = {
  __typename?: 'espin_player_subscription_sum_fields';
  expires?: Maybe<Scalars['bigint']>;
};

/** update columns of table "espin.player_subscription" */
export enum Espin_Player_Subscription_Update_Column {
  /** column name */
  Expires = 'expires',
  /** column name */
  Id = 'id',
  /** column name */
  Plan = 'plan',
  /** column name */
  ReferralCodeRedemptionId = 'referral_code_redemption_id',
  /** column name */
  Status = 'status'
}

export type Espin_Player_Subscription_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Player_Subscription_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Player_Subscription_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Player_Subscription_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Player_Subscription_Var_Pop_Fields = {
  __typename?: 'espin_player_subscription_var_pop_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_Player_Subscription_Var_Samp_Fields = {
  __typename?: 'espin_player_subscription_var_samp_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_Player_Subscription_Variance_Fields = {
  __typename?: 'espin_player_subscription_variance_fields';
  expires?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "espin.player_vod" */
export type Espin_Player_Vod = {
  __typename?: 'espin_player_vod';
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  label?: Maybe<Scalars['String']>;
  /** An object relationship */
  media_link: Content_Media_Link;
  media_link_id: Scalars['uuid'];
  player_id: Scalars['uuid'];
  /** An object relationship */
  player_profile: Espin_Player_Profile;
};

/** aggregated selection of "espin.player_vod" */
export type Espin_Player_Vod_Aggregate = {
  __typename?: 'espin_player_vod_aggregate';
  aggregate?: Maybe<Espin_Player_Vod_Aggregate_Fields>;
  nodes: Array<Espin_Player_Vod>;
};

export type Espin_Player_Vod_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Player_Vod_Aggregate_Bool_Exp_Count>;
};

export type Espin_Player_Vod_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Player_Vod_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Player_Vod_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.player_vod" */
export type Espin_Player_Vod_Aggregate_Fields = {
  __typename?: 'espin_player_vod_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Player_Vod_Max_Fields>;
  min?: Maybe<Espin_Player_Vod_Min_Fields>;
};


/** aggregate fields of "espin.player_vod" */
export type Espin_Player_Vod_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Player_Vod_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.player_vod" */
export type Espin_Player_Vod_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Player_Vod_Max_Order_By>;
  min?: InputMaybe<Espin_Player_Vod_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.player_vod" */
export type Espin_Player_Vod_Arr_Rel_Insert_Input = {
  data: Array<Espin_Player_Vod_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Player_Vod_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.player_vod". All fields are combined with a logical 'AND'. */
export type Espin_Player_Vod_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Player_Vod_Bool_Exp>>;
  _not?: InputMaybe<Espin_Player_Vod_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Player_Vod_Bool_Exp>>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  media_link?: InputMaybe<Content_Media_Link_Bool_Exp>;
  media_link_id?: InputMaybe<Uuid_Comparison_Exp>;
  player_id?: InputMaybe<Uuid_Comparison_Exp>;
  player_profile?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};

/** unique or primary key constraints on table "espin.player_vod" */
export enum Espin_Player_Vod_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlayerVodsPkey = 'player_vods_pkey'
}

/** input type for inserting data into table "espin.player_vod" */
export type Espin_Player_Vod_Insert_Input = {
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  media_link?: InputMaybe<Content_Media_Link_Obj_Rel_Insert_Input>;
  media_link_id?: InputMaybe<Scalars['uuid']>;
  player_id?: InputMaybe<Scalars['uuid']>;
  player_profile?: InputMaybe<Espin_Player_Profile_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Espin_Player_Vod_Max_Fields = {
  __typename?: 'espin_player_vod_max_fields';
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  media_link_id?: Maybe<Scalars['uuid']>;
  player_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "espin.player_vod" */
export type Espin_Player_Vod_Max_Order_By = {
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  media_link_id?: InputMaybe<Order_By>;
  player_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Player_Vod_Min_Fields = {
  __typename?: 'espin_player_vod_min_fields';
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  media_link_id?: Maybe<Scalars['uuid']>;
  player_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "espin.player_vod" */
export type Espin_Player_Vod_Min_Order_By = {
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  media_link_id?: InputMaybe<Order_By>;
  player_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.player_vod" */
export type Espin_Player_Vod_Mutation_Response = {
  __typename?: 'espin_player_vod_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Player_Vod>;
};

/** on_conflict condition type for table "espin.player_vod" */
export type Espin_Player_Vod_On_Conflict = {
  constraint: Espin_Player_Vod_Constraint;
  update_columns?: Array<Espin_Player_Vod_Update_Column>;
  where?: InputMaybe<Espin_Player_Vod_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.player_vod". */
export type Espin_Player_Vod_Order_By = {
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  media_link?: InputMaybe<Content_Media_Link_Order_By>;
  media_link_id?: InputMaybe<Order_By>;
  player_id?: InputMaybe<Order_By>;
  player_profile?: InputMaybe<Espin_Player_Profile_Order_By>;
};

/** primary key columns input for table: espin.player_vod */
export type Espin_Player_Vod_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.player_vod" */
export enum Espin_Player_Vod_Select_Column {
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  MediaLinkId = 'media_link_id',
  /** column name */
  PlayerId = 'player_id'
}

/** input type for updating data in table "espin.player_vod" */
export type Espin_Player_Vod_Set_Input = {
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  media_link_id?: InputMaybe<Scalars['uuid']>;
  player_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "espin_player_vod" */
export type Espin_Player_Vod_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Player_Vod_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Player_Vod_Stream_Cursor_Value_Input = {
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  media_link_id?: InputMaybe<Scalars['uuid']>;
  player_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "espin.player_vod" */
export enum Espin_Player_Vod_Update_Column {
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  MediaLinkId = 'media_link_id',
  /** column name */
  PlayerId = 'player_id'
}

export type Espin_Player_Vod_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Player_Vod_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Player_Vod_Bool_Exp;
};

/** Records profile views */
export type Espin_Profile_View = {
  __typename?: 'espin_profile_view';
  /** An object relationship */
  college: Espin_College;
  college_id: Scalars['uuid'];
  /** An object relationship */
  college_user?: Maybe<Espin_User>;
  college_user_full_name?: Maybe<Scalars['String']>;
  college_user_id?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  high_school?: Maybe<Espin_High_School>;
  high_school_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  high_school_user?: Maybe<Espin_User>;
  high_school_user_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  notification?: Maybe<Espin_Notification>;
  notification_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  parent_user?: Maybe<Espin_User>;
  parent_user_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  player_user?: Maybe<Espin_User>;
  player_user_id?: Maybe<Scalars['String']>;
  profile_view_type: Espin_Profile_View_Type_Enum;
};

/** aggregated selection of "espin.profile_view" */
export type Espin_Profile_View_Aggregate = {
  __typename?: 'espin_profile_view_aggregate';
  aggregate?: Maybe<Espin_Profile_View_Aggregate_Fields>;
  nodes: Array<Espin_Profile_View>;
};

export type Espin_Profile_View_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Profile_View_Aggregate_Bool_Exp_Count>;
};

export type Espin_Profile_View_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Profile_View_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.profile_view" */
export type Espin_Profile_View_Aggregate_Fields = {
  __typename?: 'espin_profile_view_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Profile_View_Max_Fields>;
  min?: Maybe<Espin_Profile_View_Min_Fields>;
};


/** aggregate fields of "espin.profile_view" */
export type Espin_Profile_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.profile_view" */
export type Espin_Profile_View_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Profile_View_Max_Order_By>;
  min?: InputMaybe<Espin_Profile_View_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.profile_view" */
export type Espin_Profile_View_Arr_Rel_Insert_Input = {
  data: Array<Espin_Profile_View_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Profile_View_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.profile_view". All fields are combined with a logical 'AND'. */
export type Espin_Profile_View_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Profile_View_Bool_Exp>>;
  _not?: InputMaybe<Espin_Profile_View_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Profile_View_Bool_Exp>>;
  college?: InputMaybe<Espin_College_Bool_Exp>;
  college_id?: InputMaybe<Uuid_Comparison_Exp>;
  college_user?: InputMaybe<Espin_User_Bool_Exp>;
  college_user_full_name?: InputMaybe<String_Comparison_Exp>;
  college_user_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  high_school?: InputMaybe<Espin_High_School_Bool_Exp>;
  high_school_id?: InputMaybe<Uuid_Comparison_Exp>;
  high_school_user?: InputMaybe<Espin_User_Bool_Exp>;
  high_school_user_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notification?: InputMaybe<Espin_Notification_Bool_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_user?: InputMaybe<Espin_User_Bool_Exp>;
  parent_user_id?: InputMaybe<String_Comparison_Exp>;
  player_user?: InputMaybe<Espin_User_Bool_Exp>;
  player_user_id?: InputMaybe<String_Comparison_Exp>;
  profile_view_type?: InputMaybe<Espin_Profile_View_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.profile_view" */
export enum Espin_Profile_View_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProfileViewPkey = 'profile_view_pkey'
}

/** Enum for email preference options for profile views */
export type Espin_Profile_View_Email_Notification_Type = {
  __typename?: 'espin_profile_view_email_notification_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.profile_view_email_notification_type" */
export type Espin_Profile_View_Email_Notification_Type_Aggregate = {
  __typename?: 'espin_profile_view_email_notification_type_aggregate';
  aggregate?: Maybe<Espin_Profile_View_Email_Notification_Type_Aggregate_Fields>;
  nodes: Array<Espin_Profile_View_Email_Notification_Type>;
};

/** aggregate fields of "espin.profile_view_email_notification_type" */
export type Espin_Profile_View_Email_Notification_Type_Aggregate_Fields = {
  __typename?: 'espin_profile_view_email_notification_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Profile_View_Email_Notification_Type_Max_Fields>;
  min?: Maybe<Espin_Profile_View_Email_Notification_Type_Min_Fields>;
};


/** aggregate fields of "espin.profile_view_email_notification_type" */
export type Espin_Profile_View_Email_Notification_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Profile_View_Email_Notification_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.profile_view_email_notification_type". All fields are combined with a logical 'AND'. */
export type Espin_Profile_View_Email_Notification_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Profile_View_Email_Notification_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Profile_View_Email_Notification_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.profile_view_email_notification_type" */
export enum Espin_Profile_View_Email_Notification_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  ProfileViewEmailNotificationTypePkey = 'profile_view_email_notification_type_pkey'
}

export enum Espin_Profile_View_Email_Notification_Type_Enum {
  /** A monthly email detailing number of new profile views */
  MonthlyReport = 'monthly_report',
  /** No email */
  None = 'none',
  /** A weekly email detailing number of new profile views */
  WeeklyReport = 'weekly_report'
}

/** Boolean expression to compare columns of type "espin_profile_view_email_notification_type_enum". All fields are combined with logical 'AND'. */
export type Espin_Profile_View_Email_Notification_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Enum>;
  _in?: InputMaybe<Array<Espin_Profile_View_Email_Notification_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_Profile_View_Email_Notification_Type_Enum>>;
};

/** input type for inserting data into table "espin.profile_view_email_notification_type" */
export type Espin_Profile_View_Email_Notification_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Profile_View_Email_Notification_Type_Max_Fields = {
  __typename?: 'espin_profile_view_email_notification_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Profile_View_Email_Notification_Type_Min_Fields = {
  __typename?: 'espin_profile_view_email_notification_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.profile_view_email_notification_type" */
export type Espin_Profile_View_Email_Notification_Type_Mutation_Response = {
  __typename?: 'espin_profile_view_email_notification_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Profile_View_Email_Notification_Type>;
};

/** on_conflict condition type for table "espin.profile_view_email_notification_type" */
export type Espin_Profile_View_Email_Notification_Type_On_Conflict = {
  constraint: Espin_Profile_View_Email_Notification_Type_Constraint;
  update_columns?: Array<Espin_Profile_View_Email_Notification_Type_Update_Column>;
  where?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.profile_view_email_notification_type". */
export type Espin_Profile_View_Email_Notification_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.profile_view_email_notification_type */
export type Espin_Profile_View_Email_Notification_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.profile_view_email_notification_type" */
export enum Espin_Profile_View_Email_Notification_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.profile_view_email_notification_type" */
export type Espin_Profile_View_Email_Notification_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_profile_view_email_notification_type" */
export type Espin_Profile_View_Email_Notification_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Profile_View_Email_Notification_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Profile_View_Email_Notification_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.profile_view_email_notification_type" */
export enum Espin_Profile_View_Email_Notification_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Profile_View_Email_Notification_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Profile_View_Email_Notification_Type_Bool_Exp;
};

/** input type for inserting data into table "espin.profile_view" */
export type Espin_Profile_View_Insert_Input = {
  college?: InputMaybe<Espin_College_Obj_Rel_Insert_Input>;
  college_id?: InputMaybe<Scalars['uuid']>;
  college_user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  college_user_full_name?: InputMaybe<Scalars['String']>;
  college_user_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  high_school?: InputMaybe<Espin_High_School_Obj_Rel_Insert_Input>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  high_school_user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  high_school_user_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification?: InputMaybe<Espin_Notification_Obj_Rel_Insert_Input>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  parent_user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  parent_user_id?: InputMaybe<Scalars['String']>;
  player_user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  player_user_id?: InputMaybe<Scalars['String']>;
  profile_view_type?: InputMaybe<Espin_Profile_View_Type_Enum>;
};

/** aggregate max on columns */
export type Espin_Profile_View_Max_Fields = {
  __typename?: 'espin_profile_view_max_fields';
  college_id?: Maybe<Scalars['uuid']>;
  college_user_full_name?: Maybe<Scalars['String']>;
  college_user_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  high_school_user_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notification_id?: Maybe<Scalars['uuid']>;
  parent_user_id?: Maybe<Scalars['String']>;
  player_user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.profile_view" */
export type Espin_Profile_View_Max_Order_By = {
  college_id?: InputMaybe<Order_By>;
  college_user_full_name?: InputMaybe<Order_By>;
  college_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  high_school_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  parent_user_id?: InputMaybe<Order_By>;
  player_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Profile_View_Min_Fields = {
  __typename?: 'espin_profile_view_min_fields';
  college_id?: Maybe<Scalars['uuid']>;
  college_user_full_name?: Maybe<Scalars['String']>;
  college_user_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  high_school_user_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notification_id?: Maybe<Scalars['uuid']>;
  parent_user_id?: Maybe<Scalars['String']>;
  player_user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.profile_view" */
export type Espin_Profile_View_Min_Order_By = {
  college_id?: InputMaybe<Order_By>;
  college_user_full_name?: InputMaybe<Order_By>;
  college_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  high_school_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  parent_user_id?: InputMaybe<Order_By>;
  player_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.profile_view" */
export type Espin_Profile_View_Mutation_Response = {
  __typename?: 'espin_profile_view_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Profile_View>;
};

/** on_conflict condition type for table "espin.profile_view" */
export type Espin_Profile_View_On_Conflict = {
  constraint: Espin_Profile_View_Constraint;
  update_columns?: Array<Espin_Profile_View_Update_Column>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.profile_view". */
export type Espin_Profile_View_Order_By = {
  college?: InputMaybe<Espin_College_Order_By>;
  college_id?: InputMaybe<Order_By>;
  college_user?: InputMaybe<Espin_User_Order_By>;
  college_user_full_name?: InputMaybe<Order_By>;
  college_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  high_school?: InputMaybe<Espin_High_School_Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  high_school_user?: InputMaybe<Espin_User_Order_By>;
  high_school_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification?: InputMaybe<Espin_Notification_Order_By>;
  notification_id?: InputMaybe<Order_By>;
  parent_user?: InputMaybe<Espin_User_Order_By>;
  parent_user_id?: InputMaybe<Order_By>;
  player_user?: InputMaybe<Espin_User_Order_By>;
  player_user_id?: InputMaybe<Order_By>;
  profile_view_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.profile_view */
export type Espin_Profile_View_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.profile_view" */
export enum Espin_Profile_View_Select_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CollegeUserFullName = 'college_user_full_name',
  /** column name */
  CollegeUserId = 'college_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  HighSchoolUserId = 'high_school_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  ParentUserId = 'parent_user_id',
  /** column name */
  PlayerUserId = 'player_user_id',
  /** column name */
  ProfileViewType = 'profile_view_type'
}

/** input type for updating data in table "espin.profile_view" */
export type Espin_Profile_View_Set_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  college_user_full_name?: InputMaybe<Scalars['String']>;
  college_user_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  high_school_user_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  parent_user_id?: InputMaybe<Scalars['String']>;
  player_user_id?: InputMaybe<Scalars['String']>;
  profile_view_type?: InputMaybe<Espin_Profile_View_Type_Enum>;
};

/** Streaming cursor of the table "espin_profile_view" */
export type Espin_Profile_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Profile_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Profile_View_Stream_Cursor_Value_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  college_user_full_name?: InputMaybe<Scalars['String']>;
  college_user_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  high_school_user_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  parent_user_id?: InputMaybe<Scalars['String']>;
  player_user_id?: InputMaybe<Scalars['String']>;
  profile_view_type?: InputMaybe<Espin_Profile_View_Type_Enum>;
};

/** Profile view type enum */
export type Espin_Profile_View_Type = {
  __typename?: 'espin_profile_view_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.profile_view_type" */
export type Espin_Profile_View_Type_Aggregate = {
  __typename?: 'espin_profile_view_type_aggregate';
  aggregate?: Maybe<Espin_Profile_View_Type_Aggregate_Fields>;
  nodes: Array<Espin_Profile_View_Type>;
};

/** aggregate fields of "espin.profile_view_type" */
export type Espin_Profile_View_Type_Aggregate_Fields = {
  __typename?: 'espin_profile_view_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Profile_View_Type_Max_Fields>;
  min?: Maybe<Espin_Profile_View_Type_Min_Fields>;
};


/** aggregate fields of "espin.profile_view_type" */
export type Espin_Profile_View_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Profile_View_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.profile_view_type". All fields are combined with a logical 'AND'. */
export type Espin_Profile_View_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Profile_View_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_Profile_View_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Profile_View_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.profile_view_type" */
export enum Espin_Profile_View_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  ProfileViewTypePkey = 'profile_view_type_pkey'
}

export enum Espin_Profile_View_Type_Enum {
  /** College views a high school */
  CollegeViewsHighSchool = 'college_views_high_school',
  /** College user views a player */
  CollegeViewsPlayer = 'college_views_player',
  /** High school views a college */
  HighSchoolViewsCollege = 'high_school_views_college',
  /** Parent views a college */
  ParentViewsCollege = 'parent_views_college',
  /** Player views a college */
  PlayerViewsCollege = 'player_views_college'
}

/** Boolean expression to compare columns of type "espin_profile_view_type_enum". All fields are combined with logical 'AND'. */
export type Espin_Profile_View_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Profile_View_Type_Enum>;
  _in?: InputMaybe<Array<Espin_Profile_View_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Profile_View_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_Profile_View_Type_Enum>>;
};

/** input type for inserting data into table "espin.profile_view_type" */
export type Espin_Profile_View_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Profile_View_Type_Max_Fields = {
  __typename?: 'espin_profile_view_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Profile_View_Type_Min_Fields = {
  __typename?: 'espin_profile_view_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.profile_view_type" */
export type Espin_Profile_View_Type_Mutation_Response = {
  __typename?: 'espin_profile_view_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Profile_View_Type>;
};

/** on_conflict condition type for table "espin.profile_view_type" */
export type Espin_Profile_View_Type_On_Conflict = {
  constraint: Espin_Profile_View_Type_Constraint;
  update_columns?: Array<Espin_Profile_View_Type_Update_Column>;
  where?: InputMaybe<Espin_Profile_View_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.profile_view_type". */
export type Espin_Profile_View_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.profile_view_type */
export type Espin_Profile_View_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.profile_view_type" */
export enum Espin_Profile_View_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.profile_view_type" */
export type Espin_Profile_View_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_profile_view_type" */
export type Espin_Profile_View_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Profile_View_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Profile_View_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.profile_view_type" */
export enum Espin_Profile_View_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Profile_View_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Profile_View_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Profile_View_Type_Bool_Exp;
};

/** update columns of table "espin.profile_view" */
export enum Espin_Profile_View_Update_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CollegeUserFullName = 'college_user_full_name',
  /** column name */
  CollegeUserId = 'college_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  HighSchoolUserId = 'high_school_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  ParentUserId = 'parent_user_id',
  /** column name */
  PlayerUserId = 'player_user_id',
  /** column name */
  ProfileViewType = 'profile_view_type'
}

export type Espin_Profile_View_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Profile_View_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Profile_View_Bool_Exp;
};

/** columns and relationships of "espin.referral_code" */
export type Espin_Referral_Code = {
  __typename?: 'espin_referral_code';
  code_active_end_date?: Maybe<Scalars['timestamptz']>;
  code_active_start_date?: Maybe<Scalars['timestamptz']>;
  code_key: Scalars['String'];
  id: Scalars['uuid'];
  /** An array relationship */
  referral_code_redemptions: Array<Espin_Referral_Code_Redemption>;
  /** An aggregate relationship */
  referral_code_redemptions_aggregate: Espin_Referral_Code_Redemption_Aggregate;
  subscription_duration: Scalars['Int'];
};


/** columns and relationships of "espin.referral_code" */
export type Espin_Referral_CodeReferral_Code_RedemptionsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Code_Redemption_Order_By>>;
  where?: InputMaybe<Espin_Referral_Code_Redemption_Bool_Exp>;
};


/** columns and relationships of "espin.referral_code" */
export type Espin_Referral_CodeReferral_Code_Redemptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Code_Redemption_Order_By>>;
  where?: InputMaybe<Espin_Referral_Code_Redemption_Bool_Exp>;
};

/** aggregated selection of "espin.referral_code" */
export type Espin_Referral_Code_Aggregate = {
  __typename?: 'espin_referral_code_aggregate';
  aggregate?: Maybe<Espin_Referral_Code_Aggregate_Fields>;
  nodes: Array<Espin_Referral_Code>;
};

/** aggregate fields of "espin.referral_code" */
export type Espin_Referral_Code_Aggregate_Fields = {
  __typename?: 'espin_referral_code_aggregate_fields';
  avg?: Maybe<Espin_Referral_Code_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Referral_Code_Max_Fields>;
  min?: Maybe<Espin_Referral_Code_Min_Fields>;
  stddev?: Maybe<Espin_Referral_Code_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Referral_Code_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Referral_Code_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Referral_Code_Sum_Fields>;
  var_pop?: Maybe<Espin_Referral_Code_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Referral_Code_Var_Samp_Fields>;
  variance?: Maybe<Espin_Referral_Code_Variance_Fields>;
};


/** aggregate fields of "espin.referral_code" */
export type Espin_Referral_Code_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Referral_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Espin_Referral_Code_Avg_Fields = {
  __typename?: 'espin_referral_code_avg_fields';
  subscription_duration?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.referral_code". All fields are combined with a logical 'AND'. */
export type Espin_Referral_Code_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Referral_Code_Bool_Exp>>;
  _not?: InputMaybe<Espin_Referral_Code_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Referral_Code_Bool_Exp>>;
  code_active_end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  code_active_start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  code_key?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  referral_code_redemptions?: InputMaybe<Espin_Referral_Code_Redemption_Bool_Exp>;
  referral_code_redemptions_aggregate?: InputMaybe<Espin_Referral_Code_Redemption_Aggregate_Bool_Exp>;
  subscription_duration?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.referral_code" */
export enum Espin_Referral_Code_Constraint {
  /** unique or primary key constraint on columns "code_key" */
  ReferralCodeCodeKeyKey = 'referral_code_code_key_key',
  /** unique or primary key constraint on columns "id" */
  ReferralCodePkey = 'referral_code_pkey'
}

/** input type for incrementing numeric columns in table "espin.referral_code" */
export type Espin_Referral_Code_Inc_Input = {
  subscription_duration?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.referral_code" */
export type Espin_Referral_Code_Insert_Input = {
  code_active_end_date?: InputMaybe<Scalars['timestamptz']>;
  code_active_start_date?: InputMaybe<Scalars['timestamptz']>;
  code_key?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  referral_code_redemptions?: InputMaybe<Espin_Referral_Code_Redemption_Arr_Rel_Insert_Input>;
  subscription_duration?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Espin_Referral_Code_Max_Fields = {
  __typename?: 'espin_referral_code_max_fields';
  code_active_end_date?: Maybe<Scalars['timestamptz']>;
  code_active_start_date?: Maybe<Scalars['timestamptz']>;
  code_key?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  subscription_duration?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Espin_Referral_Code_Min_Fields = {
  __typename?: 'espin_referral_code_min_fields';
  code_active_end_date?: Maybe<Scalars['timestamptz']>;
  code_active_start_date?: Maybe<Scalars['timestamptz']>;
  code_key?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  subscription_duration?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "espin.referral_code" */
export type Espin_Referral_Code_Mutation_Response = {
  __typename?: 'espin_referral_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Referral_Code>;
};

/** input type for inserting object relation for remote table "espin.referral_code" */
export type Espin_Referral_Code_Obj_Rel_Insert_Input = {
  data: Espin_Referral_Code_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Referral_Code_On_Conflict>;
};

/** on_conflict condition type for table "espin.referral_code" */
export type Espin_Referral_Code_On_Conflict = {
  constraint: Espin_Referral_Code_Constraint;
  update_columns?: Array<Espin_Referral_Code_Update_Column>;
  where?: InputMaybe<Espin_Referral_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.referral_code". */
export type Espin_Referral_Code_Order_By = {
  code_active_end_date?: InputMaybe<Order_By>;
  code_active_start_date?: InputMaybe<Order_By>;
  code_key?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  referral_code_redemptions_aggregate?: InputMaybe<Espin_Referral_Code_Redemption_Aggregate_Order_By>;
  subscription_duration?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.referral_code */
export type Espin_Referral_Code_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "espin.referral_code_redemption" */
export type Espin_Referral_Code_Redemption = {
  __typename?: 'espin_referral_code_redemption';
  code_id: Scalars['uuid'];
  /** An object relationship */
  college?: Maybe<Espin_College>;
  id: Scalars['uuid'];
  /** An object relationship */
  player_profile?: Maybe<Espin_Player_Profile>;
  redeemed_at: Scalars['timestamptz'];
  redeemed_by_college?: Maybe<Scalars['uuid']>;
  redeemed_by_player?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  referral_code: Espin_Referral_Code;
};

/** aggregated selection of "espin.referral_code_redemption" */
export type Espin_Referral_Code_Redemption_Aggregate = {
  __typename?: 'espin_referral_code_redemption_aggregate';
  aggregate?: Maybe<Espin_Referral_Code_Redemption_Aggregate_Fields>;
  nodes: Array<Espin_Referral_Code_Redemption>;
};

export type Espin_Referral_Code_Redemption_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Referral_Code_Redemption_Aggregate_Bool_Exp_Count>;
};

export type Espin_Referral_Code_Redemption_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Referral_Code_Redemption_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Referral_Code_Redemption_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.referral_code_redemption" */
export type Espin_Referral_Code_Redemption_Aggregate_Fields = {
  __typename?: 'espin_referral_code_redemption_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Referral_Code_Redemption_Max_Fields>;
  min?: Maybe<Espin_Referral_Code_Redemption_Min_Fields>;
};


/** aggregate fields of "espin.referral_code_redemption" */
export type Espin_Referral_Code_Redemption_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Referral_Code_Redemption_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.referral_code_redemption" */
export type Espin_Referral_Code_Redemption_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Referral_Code_Redemption_Max_Order_By>;
  min?: InputMaybe<Espin_Referral_Code_Redemption_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.referral_code_redemption" */
export type Espin_Referral_Code_Redemption_Arr_Rel_Insert_Input = {
  data: Array<Espin_Referral_Code_Redemption_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Referral_Code_Redemption_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.referral_code_redemption". All fields are combined with a logical 'AND'. */
export type Espin_Referral_Code_Redemption_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Referral_Code_Redemption_Bool_Exp>>;
  _not?: InputMaybe<Espin_Referral_Code_Redemption_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Referral_Code_Redemption_Bool_Exp>>;
  code_id?: InputMaybe<Uuid_Comparison_Exp>;
  college?: InputMaybe<Espin_College_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  player_profile?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  redeemed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  redeemed_by_college?: InputMaybe<Uuid_Comparison_Exp>;
  redeemed_by_player?: InputMaybe<Uuid_Comparison_Exp>;
  referral_code?: InputMaybe<Espin_Referral_Code_Bool_Exp>;
};

/** unique or primary key constraints on table "espin.referral_code_redemption" */
export enum Espin_Referral_Code_Redemption_Constraint {
  /** unique or primary key constraint on columns "redeemed_by_player", "code_id" */
  ReferralCodeRedemptionCodeIdRedeemedByPlayerKey = 'referral_code_redemption_code_id_redeemed_by_player_key',
  /** unique or primary key constraint on columns "id" */
  ReferralCodeRedemptionPkey = 'referral_code_redemption_pkey',
  /** unique or primary key constraint on columns "code_id", "redeemed_by_college" */
  ReferralCodeRedemptionRedeemedByCollegeCodeIdKey = 'referral_code_redemption_redeemed_by_college_code_id_key'
}

/** input type for inserting data into table "espin.referral_code_redemption" */
export type Espin_Referral_Code_Redemption_Insert_Input = {
  code_id?: InputMaybe<Scalars['uuid']>;
  college?: InputMaybe<Espin_College_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  player_profile?: InputMaybe<Espin_Player_Profile_Obj_Rel_Insert_Input>;
  redeemed_at?: InputMaybe<Scalars['timestamptz']>;
  redeemed_by_college?: InputMaybe<Scalars['uuid']>;
  redeemed_by_player?: InputMaybe<Scalars['uuid']>;
  referral_code?: InputMaybe<Espin_Referral_Code_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Espin_Referral_Code_Redemption_Max_Fields = {
  __typename?: 'espin_referral_code_redemption_max_fields';
  code_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  redeemed_at?: Maybe<Scalars['timestamptz']>;
  redeemed_by_college?: Maybe<Scalars['uuid']>;
  redeemed_by_player?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "espin.referral_code_redemption" */
export type Espin_Referral_Code_Redemption_Max_Order_By = {
  code_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  redeemed_at?: InputMaybe<Order_By>;
  redeemed_by_college?: InputMaybe<Order_By>;
  redeemed_by_player?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Referral_Code_Redemption_Min_Fields = {
  __typename?: 'espin_referral_code_redemption_min_fields';
  code_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  redeemed_at?: Maybe<Scalars['timestamptz']>;
  redeemed_by_college?: Maybe<Scalars['uuid']>;
  redeemed_by_player?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "espin.referral_code_redemption" */
export type Espin_Referral_Code_Redemption_Min_Order_By = {
  code_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  redeemed_at?: InputMaybe<Order_By>;
  redeemed_by_college?: InputMaybe<Order_By>;
  redeemed_by_player?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.referral_code_redemption" */
export type Espin_Referral_Code_Redemption_Mutation_Response = {
  __typename?: 'espin_referral_code_redemption_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Referral_Code_Redemption>;
};

/** input type for inserting object relation for remote table "espin.referral_code_redemption" */
export type Espin_Referral_Code_Redemption_Obj_Rel_Insert_Input = {
  data: Espin_Referral_Code_Redemption_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Referral_Code_Redemption_On_Conflict>;
};

/** on_conflict condition type for table "espin.referral_code_redemption" */
export type Espin_Referral_Code_Redemption_On_Conflict = {
  constraint: Espin_Referral_Code_Redemption_Constraint;
  update_columns?: Array<Espin_Referral_Code_Redemption_Update_Column>;
  where?: InputMaybe<Espin_Referral_Code_Redemption_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.referral_code_redemption". */
export type Espin_Referral_Code_Redemption_Order_By = {
  code_id?: InputMaybe<Order_By>;
  college?: InputMaybe<Espin_College_Order_By>;
  id?: InputMaybe<Order_By>;
  player_profile?: InputMaybe<Espin_Player_Profile_Order_By>;
  redeemed_at?: InputMaybe<Order_By>;
  redeemed_by_college?: InputMaybe<Order_By>;
  redeemed_by_player?: InputMaybe<Order_By>;
  referral_code?: InputMaybe<Espin_Referral_Code_Order_By>;
};

/** primary key columns input for table: espin.referral_code_redemption */
export type Espin_Referral_Code_Redemption_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.referral_code_redemption" */
export enum Espin_Referral_Code_Redemption_Select_Column {
  /** column name */
  CodeId = 'code_id',
  /** column name */
  Id = 'id',
  /** column name */
  RedeemedAt = 'redeemed_at',
  /** column name */
  RedeemedByCollege = 'redeemed_by_college',
  /** column name */
  RedeemedByPlayer = 'redeemed_by_player'
}

/** input type for updating data in table "espin.referral_code_redemption" */
export type Espin_Referral_Code_Redemption_Set_Input = {
  code_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  redeemed_at?: InputMaybe<Scalars['timestamptz']>;
  redeemed_by_college?: InputMaybe<Scalars['uuid']>;
  redeemed_by_player?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "espin_referral_code_redemption" */
export type Espin_Referral_Code_Redemption_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Referral_Code_Redemption_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Referral_Code_Redemption_Stream_Cursor_Value_Input = {
  code_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  redeemed_at?: InputMaybe<Scalars['timestamptz']>;
  redeemed_by_college?: InputMaybe<Scalars['uuid']>;
  redeemed_by_player?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "espin.referral_code_redemption" */
export enum Espin_Referral_Code_Redemption_Update_Column {
  /** column name */
  CodeId = 'code_id',
  /** column name */
  Id = 'id',
  /** column name */
  RedeemedAt = 'redeemed_at',
  /** column name */
  RedeemedByCollege = 'redeemed_by_college',
  /** column name */
  RedeemedByPlayer = 'redeemed_by_player'
}

export type Espin_Referral_Code_Redemption_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Referral_Code_Redemption_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Referral_Code_Redemption_Bool_Exp;
};

/** select columns of table "espin.referral_code" */
export enum Espin_Referral_Code_Select_Column {
  /** column name */
  CodeActiveEndDate = 'code_active_end_date',
  /** column name */
  CodeActiveStartDate = 'code_active_start_date',
  /** column name */
  CodeKey = 'code_key',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriptionDuration = 'subscription_duration'
}

/** input type for updating data in table "espin.referral_code" */
export type Espin_Referral_Code_Set_Input = {
  code_active_end_date?: InputMaybe<Scalars['timestamptz']>;
  code_active_start_date?: InputMaybe<Scalars['timestamptz']>;
  code_key?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  subscription_duration?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Espin_Referral_Code_Stddev_Fields = {
  __typename?: 'espin_referral_code_stddev_fields';
  subscription_duration?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_Referral_Code_Stddev_Pop_Fields = {
  __typename?: 'espin_referral_code_stddev_pop_fields';
  subscription_duration?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_Referral_Code_Stddev_Samp_Fields = {
  __typename?: 'espin_referral_code_stddev_samp_fields';
  subscription_duration?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_referral_code" */
export type Espin_Referral_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Referral_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Referral_Code_Stream_Cursor_Value_Input = {
  code_active_end_date?: InputMaybe<Scalars['timestamptz']>;
  code_active_start_date?: InputMaybe<Scalars['timestamptz']>;
  code_key?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  subscription_duration?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Espin_Referral_Code_Sum_Fields = {
  __typename?: 'espin_referral_code_sum_fields';
  subscription_duration?: Maybe<Scalars['Int']>;
};

/** update columns of table "espin.referral_code" */
export enum Espin_Referral_Code_Update_Column {
  /** column name */
  CodeActiveEndDate = 'code_active_end_date',
  /** column name */
  CodeActiveStartDate = 'code_active_start_date',
  /** column name */
  CodeKey = 'code_key',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriptionDuration = 'subscription_duration'
}

export type Espin_Referral_Code_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Referral_Code_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Referral_Code_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Referral_Code_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Referral_Code_Var_Pop_Fields = {
  __typename?: 'espin_referral_code_var_pop_fields';
  subscription_duration?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_Referral_Code_Var_Samp_Fields = {
  __typename?: 'espin_referral_code_var_samp_fields';
  subscription_duration?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_Referral_Code_Variance_Fields = {
  __typename?: 'espin_referral_code_variance_fields';
  subscription_duration?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "espin.referral_option" */
export type Espin_Referral_Option = {
  __typename?: 'espin_referral_option';
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  sort_order?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "espin.referral_option" */
export type Espin_Referral_Option_Aggregate = {
  __typename?: 'espin_referral_option_aggregate';
  aggregate?: Maybe<Espin_Referral_Option_Aggregate_Fields>;
  nodes: Array<Espin_Referral_Option>;
};

/** aggregate fields of "espin.referral_option" */
export type Espin_Referral_Option_Aggregate_Fields = {
  __typename?: 'espin_referral_option_aggregate_fields';
  avg?: Maybe<Espin_Referral_Option_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Referral_Option_Max_Fields>;
  min?: Maybe<Espin_Referral_Option_Min_Fields>;
  stddev?: Maybe<Espin_Referral_Option_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Referral_Option_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Referral_Option_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Referral_Option_Sum_Fields>;
  var_pop?: Maybe<Espin_Referral_Option_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Referral_Option_Var_Samp_Fields>;
  variance?: Maybe<Espin_Referral_Option_Variance_Fields>;
};


/** aggregate fields of "espin.referral_option" */
export type Espin_Referral_Option_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Referral_Option_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Espin_Referral_Option_Avg_Fields = {
  __typename?: 'espin_referral_option_avg_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.referral_option". All fields are combined with a logical 'AND'. */
export type Espin_Referral_Option_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Referral_Option_Bool_Exp>>;
  _not?: InputMaybe<Espin_Referral_Option_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Referral_Option_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.referral_option" */
export enum Espin_Referral_Option_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReferralOptionPkey = 'referral_option_pkey'
}

/** input type for incrementing numeric columns in table "espin.referral_option" */
export type Espin_Referral_Option_Inc_Input = {
  sort_order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.referral_option" */
export type Espin_Referral_Option_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Espin_Referral_Option_Max_Fields = {
  __typename?: 'espin_referral_option_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  sort_order?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Espin_Referral_Option_Min_Fields = {
  __typename?: 'espin_referral_option_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  sort_order?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "espin.referral_option" */
export type Espin_Referral_Option_Mutation_Response = {
  __typename?: 'espin_referral_option_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Referral_Option>;
};

/** input type for inserting object relation for remote table "espin.referral_option" */
export type Espin_Referral_Option_Obj_Rel_Insert_Input = {
  data: Espin_Referral_Option_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Referral_Option_On_Conflict>;
};

/** on_conflict condition type for table "espin.referral_option" */
export type Espin_Referral_Option_On_Conflict = {
  constraint: Espin_Referral_Option_Constraint;
  update_columns?: Array<Espin_Referral_Option_Update_Column>;
  where?: InputMaybe<Espin_Referral_Option_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.referral_option". */
export type Espin_Referral_Option_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.referral_option */
export type Espin_Referral_Option_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.referral_option" */
export enum Espin_Referral_Option_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SortOrder = 'sort_order'
}

/** input type for updating data in table "espin.referral_option" */
export type Espin_Referral_Option_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Espin_Referral_Option_Stddev_Fields = {
  __typename?: 'espin_referral_option_stddev_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_Referral_Option_Stddev_Pop_Fields = {
  __typename?: 'espin_referral_option_stddev_pop_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_Referral_Option_Stddev_Samp_Fields = {
  __typename?: 'espin_referral_option_stddev_samp_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_referral_option" */
export type Espin_Referral_Option_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Referral_Option_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Referral_Option_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Espin_Referral_Option_Sum_Fields = {
  __typename?: 'espin_referral_option_sum_fields';
  sort_order?: Maybe<Scalars['Int']>;
};

/** update columns of table "espin.referral_option" */
export enum Espin_Referral_Option_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SortOrder = 'sort_order'
}

export type Espin_Referral_Option_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Referral_Option_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Referral_Option_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Referral_Option_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Referral_Option_Var_Pop_Fields = {
  __typename?: 'espin_referral_option_var_pop_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_Referral_Option_Var_Samp_Fields = {
  __typename?: 'espin_referral_option_var_samp_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_Referral_Option_Variance_Fields = {
  __typename?: 'espin_referral_option_variance_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** Roles within espin (top level roles) */
export type Espin_Role = {
  __typename?: 'espin_role';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.role" */
export type Espin_Role_Aggregate = {
  __typename?: 'espin_role_aggregate';
  aggregate?: Maybe<Espin_Role_Aggregate_Fields>;
  nodes: Array<Espin_Role>;
};

/** aggregate fields of "espin.role" */
export type Espin_Role_Aggregate_Fields = {
  __typename?: 'espin_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Role_Max_Fields>;
  min?: Maybe<Espin_Role_Min_Fields>;
};


/** aggregate fields of "espin.role" */
export type Espin_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.role". All fields are combined with a logical 'AND'. */
export type Espin_Role_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Role_Bool_Exp>>;
  _not?: InputMaybe<Espin_Role_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Role_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.role" */
export enum Espin_Role_Constraint {
  /** unique or primary key constraint on columns "name" */
  RolePkey = 'role_pkey'
}

export enum Espin_Role_Enum {
  /** Spin College user */
  EspinCollegeUser = 'espin_college_user',
  /** User role for a highschool user */
  EspinHighschoolUser = 'espin_highschool_user',
  /** parent users */
  EspinParentUser = 'espin_parent_user',
  /** Spin Player */
  EspinPlayerUser = 'espin_player_user',
  /** SPIN Operator */
  SpinOps = 'spin_ops',
  /** SPIN Sales user */
  SpinSales = 'spin_sales'
}

/** Boolean expression to compare columns of type "espin_role_enum". All fields are combined with logical 'AND'. */
export type Espin_Role_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Role_Enum>;
  _in?: InputMaybe<Array<Espin_Role_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Role_Enum>;
  _nin?: InputMaybe<Array<Espin_Role_Enum>>;
};

/** input type for inserting data into table "espin.role" */
export type Espin_Role_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Role_Max_Fields = {
  __typename?: 'espin_role_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Role_Min_Fields = {
  __typename?: 'espin_role_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.role" */
export type Espin_Role_Mutation_Response = {
  __typename?: 'espin_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Role>;
};

/** input type for inserting object relation for remote table "espin.role" */
export type Espin_Role_Obj_Rel_Insert_Input = {
  data: Espin_Role_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Role_On_Conflict>;
};

/** on_conflict condition type for table "espin.role" */
export type Espin_Role_On_Conflict = {
  constraint: Espin_Role_Constraint;
  update_columns?: Array<Espin_Role_Update_Column>;
  where?: InputMaybe<Espin_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.role". */
export type Espin_Role_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.role */
export type Espin_Role_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.role" */
export enum Espin_Role_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.role" */
export type Espin_Role_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_role" */
export type Espin_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Role_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.role" */
export enum Espin_Role_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Role_Bool_Exp;
};

/** Admin controlled site content for espin */
export type Espin_Site_Content = {
  __typename?: 'espin_site_content';
  key: Espin_Editable_Site_Content_Enum;
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "espin.site_content" */
export type Espin_Site_Content_Aggregate = {
  __typename?: 'espin_site_content_aggregate';
  aggregate?: Maybe<Espin_Site_Content_Aggregate_Fields>;
  nodes: Array<Espin_Site_Content>;
};

/** aggregate fields of "espin.site_content" */
export type Espin_Site_Content_Aggregate_Fields = {
  __typename?: 'espin_site_content_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Site_Content_Max_Fields>;
  min?: Maybe<Espin_Site_Content_Min_Fields>;
};


/** aggregate fields of "espin.site_content" */
export type Espin_Site_Content_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Site_Content_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.site_content". All fields are combined with a logical 'AND'. */
export type Espin_Site_Content_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Site_Content_Bool_Exp>>;
  _not?: InputMaybe<Espin_Site_Content_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Site_Content_Bool_Exp>>;
  key?: InputMaybe<Espin_Editable_Site_Content_Enum_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.site_content" */
export enum Espin_Site_Content_Constraint {
  /** unique or primary key constraint on columns "key" */
  SiteContentPkey = 'site_content_pkey'
}

/** input type for inserting data into table "espin.site_content" */
export type Espin_Site_Content_Insert_Input = {
  key?: InputMaybe<Espin_Editable_Site_Content_Enum>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Site_Content_Max_Fields = {
  __typename?: 'espin_site_content_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Site_Content_Min_Fields = {
  __typename?: 'espin_site_content_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.site_content" */
export type Espin_Site_Content_Mutation_Response = {
  __typename?: 'espin_site_content_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Site_Content>;
};

/** on_conflict condition type for table "espin.site_content" */
export type Espin_Site_Content_On_Conflict = {
  constraint: Espin_Site_Content_Constraint;
  update_columns?: Array<Espin_Site_Content_Update_Column>;
  where?: InputMaybe<Espin_Site_Content_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.site_content". */
export type Espin_Site_Content_Order_By = {
  key?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.site_content */
export type Espin_Site_Content_Pk_Columns_Input = {
  key: Espin_Editable_Site_Content_Enum;
};

/** select columns of table "espin.site_content" */
export enum Espin_Site_Content_Select_Column {
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "espin.site_content" */
export type Espin_Site_Content_Set_Input = {
  key?: InputMaybe<Espin_Editable_Site_Content_Enum>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_site_content" */
export type Espin_Site_Content_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Site_Content_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Site_Content_Stream_Cursor_Value_Input = {
  key?: InputMaybe<Espin_Editable_Site_Content_Enum>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.site_content" */
export enum Espin_Site_Content_Update_Column {
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

export type Espin_Site_Content_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Site_Content_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Site_Content_Bool_Exp;
};

/** Social information for colleges OR players */
export type Espin_Social = {
  __typename?: 'espin_social';
  created_at: Scalars['timestamptz'];
  discord?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  instagram?: Maybe<Scalars['String']>;
  tiktok?: Maybe<Scalars['String']>;
  twitch?: Maybe<Scalars['String']>;
  /** An object relationship */
  twitch_channel?: Maybe<Content_Media_Link>;
  twitch_channel_id?: Maybe<Scalars['uuid']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  website?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  /** An object relationship */
  youtube_channel?: Maybe<Content_Media_Link>;
  youtube_channel_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "espin.social" */
export type Espin_Social_Aggregate = {
  __typename?: 'espin_social_aggregate';
  aggregate?: Maybe<Espin_Social_Aggregate_Fields>;
  nodes: Array<Espin_Social>;
};

/** aggregate fields of "espin.social" */
export type Espin_Social_Aggregate_Fields = {
  __typename?: 'espin_social_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Social_Max_Fields>;
  min?: Maybe<Espin_Social_Min_Fields>;
};


/** aggregate fields of "espin.social" */
export type Espin_Social_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Social_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.social". All fields are combined with a logical 'AND'. */
export type Espin_Social_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Social_Bool_Exp>>;
  _not?: InputMaybe<Espin_Social_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Social_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  discord?: InputMaybe<String_Comparison_Exp>;
  facebook?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  instagram?: InputMaybe<String_Comparison_Exp>;
  tiktok?: InputMaybe<String_Comparison_Exp>;
  twitch?: InputMaybe<String_Comparison_Exp>;
  twitch_channel?: InputMaybe<Content_Media_Link_Bool_Exp>;
  twitch_channel_id?: InputMaybe<Uuid_Comparison_Exp>;
  twitter?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
  youtube?: InputMaybe<String_Comparison_Exp>;
  youtube_channel?: InputMaybe<Content_Media_Link_Bool_Exp>;
  youtube_channel_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.social" */
export enum Espin_Social_Constraint {
  /** unique or primary key constraint on columns "id" */
  SocialsPkey = 'socials_pkey'
}

/** input type for inserting data into table "espin.social" */
export type Espin_Social_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discord?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagram?: InputMaybe<Scalars['String']>;
  tiktok?: InputMaybe<Scalars['String']>;
  twitch?: InputMaybe<Scalars['String']>;
  twitch_channel?: InputMaybe<Content_Media_Link_Obj_Rel_Insert_Input>;
  twitch_channel_id?: InputMaybe<Scalars['uuid']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  website?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  youtube_channel?: InputMaybe<Content_Media_Link_Obj_Rel_Insert_Input>;
  youtube_channel_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Espin_Social_Max_Fields = {
  __typename?: 'espin_social_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  discord?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  tiktok?: Maybe<Scalars['String']>;
  twitch?: Maybe<Scalars['String']>;
  twitch_channel_id?: Maybe<Scalars['uuid']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  website?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  youtube_channel_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Espin_Social_Min_Fields = {
  __typename?: 'espin_social_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  discord?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  tiktok?: Maybe<Scalars['String']>;
  twitch?: Maybe<Scalars['String']>;
  twitch_channel_id?: Maybe<Scalars['uuid']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  website?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  youtube_channel_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "espin.social" */
export type Espin_Social_Mutation_Response = {
  __typename?: 'espin_social_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Social>;
};

/** input type for inserting object relation for remote table "espin.social" */
export type Espin_Social_Obj_Rel_Insert_Input = {
  data: Espin_Social_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Social_On_Conflict>;
};

/** on_conflict condition type for table "espin.social" */
export type Espin_Social_On_Conflict = {
  constraint: Espin_Social_Constraint;
  update_columns?: Array<Espin_Social_Update_Column>;
  where?: InputMaybe<Espin_Social_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.social". */
export type Espin_Social_Order_By = {
  created_at?: InputMaybe<Order_By>;
  discord?: InputMaybe<Order_By>;
  facebook?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  tiktok?: InputMaybe<Order_By>;
  twitch?: InputMaybe<Order_By>;
  twitch_channel?: InputMaybe<Content_Media_Link_Order_By>;
  twitch_channel_id?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
  youtube?: InputMaybe<Order_By>;
  youtube_channel?: InputMaybe<Content_Media_Link_Order_By>;
  youtube_channel_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.social */
export type Espin_Social_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.social" */
export enum Espin_Social_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Discord = 'discord',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  Tiktok = 'tiktok',
  /** column name */
  Twitch = 'twitch',
  /** column name */
  TwitchChannelId = 'twitch_channel_id',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website',
  /** column name */
  Youtube = 'youtube',
  /** column name */
  YoutubeChannelId = 'youtube_channel_id'
}

/** input type for updating data in table "espin.social" */
export type Espin_Social_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discord?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagram?: InputMaybe<Scalars['String']>;
  tiktok?: InputMaybe<Scalars['String']>;
  twitch?: InputMaybe<Scalars['String']>;
  twitch_channel_id?: InputMaybe<Scalars['uuid']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  website?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  youtube_channel_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "espin_social" */
export type Espin_Social_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Social_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Social_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discord?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagram?: InputMaybe<Scalars['String']>;
  tiktok?: InputMaybe<Scalars['String']>;
  twitch?: InputMaybe<Scalars['String']>;
  twitch_channel_id?: InputMaybe<Scalars['uuid']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  website?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  youtube_channel_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "espin.social" */
export enum Espin_Social_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Discord = 'discord',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  Tiktok = 'tiktok',
  /** column name */
  Twitch = 'twitch',
  /** column name */
  TwitchChannelId = 'twitch_channel_id',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website',
  /** column name */
  Youtube = 'youtube',
  /** column name */
  YoutubeChannelId = 'youtube_channel_id'
}

export type Espin_Social_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Social_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Social_Bool_Exp;
};

/** columns and relationships of "espin.stickied_college" */
export type Espin_Stickied_College = {
  __typename?: 'espin_stickied_college';
  /** An object relationship */
  college: Espin_College;
  college_id: Scalars['uuid'];
  id: Scalars['uuid'];
  order: Scalars['numeric'];
};

/** aggregated selection of "espin.stickied_college" */
export type Espin_Stickied_College_Aggregate = {
  __typename?: 'espin_stickied_college_aggregate';
  aggregate?: Maybe<Espin_Stickied_College_Aggregate_Fields>;
  nodes: Array<Espin_Stickied_College>;
};

export type Espin_Stickied_College_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Stickied_College_Aggregate_Bool_Exp_Count>;
};

export type Espin_Stickied_College_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Stickied_College_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Stickied_College_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.stickied_college" */
export type Espin_Stickied_College_Aggregate_Fields = {
  __typename?: 'espin_stickied_college_aggregate_fields';
  avg?: Maybe<Espin_Stickied_College_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Stickied_College_Max_Fields>;
  min?: Maybe<Espin_Stickied_College_Min_Fields>;
  stddev?: Maybe<Espin_Stickied_College_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Stickied_College_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Stickied_College_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Stickied_College_Sum_Fields>;
  var_pop?: Maybe<Espin_Stickied_College_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Stickied_College_Var_Samp_Fields>;
  variance?: Maybe<Espin_Stickied_College_Variance_Fields>;
};


/** aggregate fields of "espin.stickied_college" */
export type Espin_Stickied_College_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Stickied_College_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.stickied_college" */
export type Espin_Stickied_College_Aggregate_Order_By = {
  avg?: InputMaybe<Espin_Stickied_College_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Stickied_College_Max_Order_By>;
  min?: InputMaybe<Espin_Stickied_College_Min_Order_By>;
  stddev?: InputMaybe<Espin_Stickied_College_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Espin_Stickied_College_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Espin_Stickied_College_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Espin_Stickied_College_Sum_Order_By>;
  var_pop?: InputMaybe<Espin_Stickied_College_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Espin_Stickied_College_Var_Samp_Order_By>;
  variance?: InputMaybe<Espin_Stickied_College_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "espin.stickied_college" */
export type Espin_Stickied_College_Arr_Rel_Insert_Input = {
  data: Array<Espin_Stickied_College_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Stickied_College_On_Conflict>;
};

/** aggregate avg on columns */
export type Espin_Stickied_College_Avg_Fields = {
  __typename?: 'espin_stickied_college_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "espin.stickied_college" */
export type Espin_Stickied_College_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "espin.stickied_college". All fields are combined with a logical 'AND'. */
export type Espin_Stickied_College_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Stickied_College_Bool_Exp>>;
  _not?: InputMaybe<Espin_Stickied_College_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Stickied_College_Bool_Exp>>;
  college?: InputMaybe<Espin_College_Bool_Exp>;
  college_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.stickied_college" */
export enum Espin_Stickied_College_Constraint {
  /** unique or primary key constraint on columns "college_id" */
  StickiedCollegesCollegeIdKey = 'stickied_colleges_college_id_key',
  /** unique or primary key constraint on columns "id" */
  StickiedCollegesPkey = 'stickied_colleges_pkey'
}

/** input type for incrementing numeric columns in table "espin.stickied_college" */
export type Espin_Stickied_College_Inc_Input = {
  order?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "espin.stickied_college" */
export type Espin_Stickied_College_Insert_Input = {
  college?: InputMaybe<Espin_College_Obj_Rel_Insert_Input>;
  college_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Espin_Stickied_College_Max_Fields = {
  __typename?: 'espin_stickied_college_max_fields';
  college_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "espin.stickied_college" */
export type Espin_Stickied_College_Max_Order_By = {
  college_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Stickied_College_Min_Fields = {
  __typename?: 'espin_stickied_college_min_fields';
  college_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "espin.stickied_college" */
export type Espin_Stickied_College_Min_Order_By = {
  college_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.stickied_college" */
export type Espin_Stickied_College_Mutation_Response = {
  __typename?: 'espin_stickied_college_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Stickied_College>;
};

/** on_conflict condition type for table "espin.stickied_college" */
export type Espin_Stickied_College_On_Conflict = {
  constraint: Espin_Stickied_College_Constraint;
  update_columns?: Array<Espin_Stickied_College_Update_Column>;
  where?: InputMaybe<Espin_Stickied_College_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.stickied_college". */
export type Espin_Stickied_College_Order_By = {
  college?: InputMaybe<Espin_College_Order_By>;
  college_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.stickied_college */
export type Espin_Stickied_College_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.stickied_college" */
export enum Espin_Stickied_College_Select_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "espin.stickied_college" */
export type Espin_Stickied_College_Set_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Espin_Stickied_College_Stddev_Fields = {
  __typename?: 'espin_stickied_college_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "espin.stickied_college" */
export type Espin_Stickied_College_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Espin_Stickied_College_Stddev_Pop_Fields = {
  __typename?: 'espin_stickied_college_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "espin.stickied_college" */
export type Espin_Stickied_College_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Espin_Stickied_College_Stddev_Samp_Fields = {
  __typename?: 'espin_stickied_college_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "espin.stickied_college" */
export type Espin_Stickied_College_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "espin_stickied_college" */
export type Espin_Stickied_College_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Stickied_College_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Stickied_College_Stream_Cursor_Value_Input = {
  college_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Espin_Stickied_College_Sum_Fields = {
  __typename?: 'espin_stickied_college_sum_fields';
  order?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "espin.stickied_college" */
export type Espin_Stickied_College_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "espin.stickied_college" */
export enum Espin_Stickied_College_Update_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order'
}

export type Espin_Stickied_College_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Stickied_College_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Stickied_College_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Stickied_College_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Stickied_College_Var_Pop_Fields = {
  __typename?: 'espin_stickied_college_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "espin.stickied_college" */
export type Espin_Stickied_College_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Espin_Stickied_College_Var_Samp_Fields = {
  __typename?: 'espin_stickied_college_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "espin.stickied_college" */
export type Espin_Stickied_College_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Espin_Stickied_College_Variance_Fields = {
  __typename?: 'espin_stickied_college_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "espin.stickied_college" */
export type Espin_Stickied_College_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "espin.stickied_player" */
export type Espin_Stickied_Player = {
  __typename?: 'espin_stickied_player';
  id: Scalars['uuid'];
  order: Scalars['numeric'];
  /** An object relationship */
  player_profile: Espin_Player_Profile;
  player_profile_id: Scalars['uuid'];
};

/** aggregated selection of "espin.stickied_player" */
export type Espin_Stickied_Player_Aggregate = {
  __typename?: 'espin_stickied_player_aggregate';
  aggregate?: Maybe<Espin_Stickied_Player_Aggregate_Fields>;
  nodes: Array<Espin_Stickied_Player>;
};

export type Espin_Stickied_Player_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Stickied_Player_Aggregate_Bool_Exp_Count>;
};

export type Espin_Stickied_Player_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Stickied_Player_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Stickied_Player_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.stickied_player" */
export type Espin_Stickied_Player_Aggregate_Fields = {
  __typename?: 'espin_stickied_player_aggregate_fields';
  avg?: Maybe<Espin_Stickied_Player_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_Stickied_Player_Max_Fields>;
  min?: Maybe<Espin_Stickied_Player_Min_Fields>;
  stddev?: Maybe<Espin_Stickied_Player_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_Stickied_Player_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_Stickied_Player_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_Stickied_Player_Sum_Fields>;
  var_pop?: Maybe<Espin_Stickied_Player_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_Stickied_Player_Var_Samp_Fields>;
  variance?: Maybe<Espin_Stickied_Player_Variance_Fields>;
};


/** aggregate fields of "espin.stickied_player" */
export type Espin_Stickied_Player_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Stickied_Player_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.stickied_player" */
export type Espin_Stickied_Player_Aggregate_Order_By = {
  avg?: InputMaybe<Espin_Stickied_Player_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Stickied_Player_Max_Order_By>;
  min?: InputMaybe<Espin_Stickied_Player_Min_Order_By>;
  stddev?: InputMaybe<Espin_Stickied_Player_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Espin_Stickied_Player_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Espin_Stickied_Player_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Espin_Stickied_Player_Sum_Order_By>;
  var_pop?: InputMaybe<Espin_Stickied_Player_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Espin_Stickied_Player_Var_Samp_Order_By>;
  variance?: InputMaybe<Espin_Stickied_Player_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "espin.stickied_player" */
export type Espin_Stickied_Player_Arr_Rel_Insert_Input = {
  data: Array<Espin_Stickied_Player_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Stickied_Player_On_Conflict>;
};

/** aggregate avg on columns */
export type Espin_Stickied_Player_Avg_Fields = {
  __typename?: 'espin_stickied_player_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "espin.stickied_player" */
export type Espin_Stickied_Player_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "espin.stickied_player". All fields are combined with a logical 'AND'. */
export type Espin_Stickied_Player_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Stickied_Player_Bool_Exp>>;
  _not?: InputMaybe<Espin_Stickied_Player_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Stickied_Player_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Numeric_Comparison_Exp>;
  player_profile?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  player_profile_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.stickied_player" */
export enum Espin_Stickied_Player_Constraint {
  /** unique or primary key constraint on columns "id" */
  StickiedPlayersPkey = 'stickied_players_pkey',
  /** unique or primary key constraint on columns "player_profile_id" */
  StickiedPlayersPlayerProfileIdKey = 'stickied_players_player_profile_id_key'
}

/** input type for incrementing numeric columns in table "espin.stickied_player" */
export type Espin_Stickied_Player_Inc_Input = {
  order?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "espin.stickied_player" */
export type Espin_Stickied_Player_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['numeric']>;
  player_profile?: InputMaybe<Espin_Player_Profile_Obj_Rel_Insert_Input>;
  player_profile_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Espin_Stickied_Player_Max_Fields = {
  __typename?: 'espin_stickied_player_max_fields';
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['numeric']>;
  player_profile_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "espin.stickied_player" */
export type Espin_Stickied_Player_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  player_profile_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Stickied_Player_Min_Fields = {
  __typename?: 'espin_stickied_player_min_fields';
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['numeric']>;
  player_profile_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "espin.stickied_player" */
export type Espin_Stickied_Player_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  player_profile_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.stickied_player" */
export type Espin_Stickied_Player_Mutation_Response = {
  __typename?: 'espin_stickied_player_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Stickied_Player>;
};

/** on_conflict condition type for table "espin.stickied_player" */
export type Espin_Stickied_Player_On_Conflict = {
  constraint: Espin_Stickied_Player_Constraint;
  update_columns?: Array<Espin_Stickied_Player_Update_Column>;
  where?: InputMaybe<Espin_Stickied_Player_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.stickied_player". */
export type Espin_Stickied_Player_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  player_profile?: InputMaybe<Espin_Player_Profile_Order_By>;
  player_profile_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.stickied_player */
export type Espin_Stickied_Player_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.stickied_player" */
export enum Espin_Stickied_Player_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PlayerProfileId = 'player_profile_id'
}

/** input type for updating data in table "espin.stickied_player" */
export type Espin_Stickied_Player_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['numeric']>;
  player_profile_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Espin_Stickied_Player_Stddev_Fields = {
  __typename?: 'espin_stickied_player_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "espin.stickied_player" */
export type Espin_Stickied_Player_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Espin_Stickied_Player_Stddev_Pop_Fields = {
  __typename?: 'espin_stickied_player_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "espin.stickied_player" */
export type Espin_Stickied_Player_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Espin_Stickied_Player_Stddev_Samp_Fields = {
  __typename?: 'espin_stickied_player_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "espin.stickied_player" */
export type Espin_Stickied_Player_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "espin_stickied_player" */
export type Espin_Stickied_Player_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Stickied_Player_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Stickied_Player_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['numeric']>;
  player_profile_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Espin_Stickied_Player_Sum_Fields = {
  __typename?: 'espin_stickied_player_sum_fields';
  order?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "espin.stickied_player" */
export type Espin_Stickied_Player_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "espin.stickied_player" */
export enum Espin_Stickied_Player_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PlayerProfileId = 'player_profile_id'
}

export type Espin_Stickied_Player_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_Stickied_Player_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Stickied_Player_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Stickied_Player_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_Stickied_Player_Var_Pop_Fields = {
  __typename?: 'espin_stickied_player_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "espin.stickied_player" */
export type Espin_Stickied_Player_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Espin_Stickied_Player_Var_Samp_Fields = {
  __typename?: 'espin_stickied_player_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "espin.stickied_player" */
export type Espin_Stickied_Player_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Espin_Stickied_Player_Variance_Fields = {
  __typename?: 'espin_stickied_player_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "espin.stickied_player" */
export type Espin_Stickied_Player_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "espin.study_field" */
export type Espin_Study_Field = {
  __typename?: 'espin_study_field';
  id: Scalars['uuid'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.study_field" */
export type Espin_Study_Field_Aggregate = {
  __typename?: 'espin_study_field_aggregate';
  aggregate?: Maybe<Espin_Study_Field_Aggregate_Fields>;
  nodes: Array<Espin_Study_Field>;
};

/** aggregate fields of "espin.study_field" */
export type Espin_Study_Field_Aggregate_Fields = {
  __typename?: 'espin_study_field_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Study_Field_Max_Fields>;
  min?: Maybe<Espin_Study_Field_Min_Fields>;
};


/** aggregate fields of "espin.study_field" */
export type Espin_Study_Field_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Study_Field_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.study_field" */
export type Espin_Study_Field_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Study_Field_Max_Order_By>;
  min?: InputMaybe<Espin_Study_Field_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "espin.study_field". All fields are combined with a logical 'AND'. */
export type Espin_Study_Field_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Study_Field_Bool_Exp>>;
  _not?: InputMaybe<Espin_Study_Field_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Study_Field_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.study_field" */
export enum Espin_Study_Field_Constraint {
  /** unique or primary key constraint on columns "id" */
  StudyFieldPkey = 'study_field_pkey'
}

/** input type for inserting data into table "espin.study_field" */
export type Espin_Study_Field_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Study_Field_Max_Fields = {
  __typename?: 'espin_study_field_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.study_field" */
export type Espin_Study_Field_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Study_Field_Min_Fields = {
  __typename?: 'espin_study_field_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.study_field" */
export type Espin_Study_Field_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.study_field" */
export type Espin_Study_Field_Mutation_Response = {
  __typename?: 'espin_study_field_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Study_Field>;
};

/** input type for inserting object relation for remote table "espin.study_field" */
export type Espin_Study_Field_Obj_Rel_Insert_Input = {
  data: Espin_Study_Field_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Study_Field_On_Conflict>;
};

/** on_conflict condition type for table "espin.study_field" */
export type Espin_Study_Field_On_Conflict = {
  constraint: Espin_Study_Field_Constraint;
  update_columns?: Array<Espin_Study_Field_Update_Column>;
  where?: InputMaybe<Espin_Study_Field_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.study_field". */
export type Espin_Study_Field_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.study_field */
export type Espin_Study_Field_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.study_field" */
export enum Espin_Study_Field_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.study_field" */
export type Espin_Study_Field_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_study_field" */
export type Espin_Study_Field_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Study_Field_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Study_Field_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.study_field" */
export enum Espin_Study_Field_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Espin_Study_Field_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Study_Field_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Study_Field_Bool_Exp;
};

/** columns and relationships of "espin.study_subject" */
export type Espin_Study_Subject = {
  __typename?: 'espin_study_subject';
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  study_field: Espin_Study_Field;
  study_field_id: Scalars['uuid'];
};

/** aggregated selection of "espin.study_subject" */
export type Espin_Study_Subject_Aggregate = {
  __typename?: 'espin_study_subject_aggregate';
  aggregate?: Maybe<Espin_Study_Subject_Aggregate_Fields>;
  nodes: Array<Espin_Study_Subject>;
};

/** aggregate fields of "espin.study_subject" */
export type Espin_Study_Subject_Aggregate_Fields = {
  __typename?: 'espin_study_subject_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Study_Subject_Max_Fields>;
  min?: Maybe<Espin_Study_Subject_Min_Fields>;
};


/** aggregate fields of "espin.study_subject" */
export type Espin_Study_Subject_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Study_Subject_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.study_subject" */
export type Espin_Study_Subject_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Study_Subject_Max_Order_By>;
  min?: InputMaybe<Espin_Study_Subject_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "espin.study_subject". All fields are combined with a logical 'AND'. */
export type Espin_Study_Subject_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Study_Subject_Bool_Exp>>;
  _not?: InputMaybe<Espin_Study_Subject_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Study_Subject_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  study_field?: InputMaybe<Espin_Study_Field_Bool_Exp>;
  study_field_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.study_subject" */
export enum Espin_Study_Subject_Constraint {
  /** unique or primary key constraint on columns "id" */
  StudySubjectPkey = 'study_subject_pkey'
}

/** input type for inserting data into table "espin.study_subject" */
export type Espin_Study_Subject_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  study_field?: InputMaybe<Espin_Study_Field_Obj_Rel_Insert_Input>;
  study_field_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Espin_Study_Subject_Max_Fields = {
  __typename?: 'espin_study_subject_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  study_field_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "espin.study_subject" */
export type Espin_Study_Subject_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  study_field_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Study_Subject_Min_Fields = {
  __typename?: 'espin_study_subject_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  study_field_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "espin.study_subject" */
export type Espin_Study_Subject_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  study_field_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.study_subject" */
export type Espin_Study_Subject_Mutation_Response = {
  __typename?: 'espin_study_subject_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Study_Subject>;
};

/** on_conflict condition type for table "espin.study_subject" */
export type Espin_Study_Subject_On_Conflict = {
  constraint: Espin_Study_Subject_Constraint;
  update_columns?: Array<Espin_Study_Subject_Update_Column>;
  where?: InputMaybe<Espin_Study_Subject_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.study_subject". */
export type Espin_Study_Subject_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  study_field?: InputMaybe<Espin_Study_Field_Order_By>;
  study_field_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.study_subject */
export type Espin_Study_Subject_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.study_subject" */
export enum Espin_Study_Subject_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StudyFieldId = 'study_field_id'
}

/** input type for updating data in table "espin.study_subject" */
export type Espin_Study_Subject_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  study_field_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "espin_study_subject" */
export type Espin_Study_Subject_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Study_Subject_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Study_Subject_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  study_field_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "espin.study_subject" */
export enum Espin_Study_Subject_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StudyFieldId = 'study_field_id'
}

export type Espin_Study_Subject_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Study_Subject_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Study_Subject_Bool_Exp;
};

/** Enum for sub statuses */
export type Espin_Subscription_Status = {
  __typename?: 'espin_subscription_status';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.subscription_status" */
export type Espin_Subscription_Status_Aggregate = {
  __typename?: 'espin_subscription_status_aggregate';
  aggregate?: Maybe<Espin_Subscription_Status_Aggregate_Fields>;
  nodes: Array<Espin_Subscription_Status>;
};

/** aggregate fields of "espin.subscription_status" */
export type Espin_Subscription_Status_Aggregate_Fields = {
  __typename?: 'espin_subscription_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Subscription_Status_Max_Fields>;
  min?: Maybe<Espin_Subscription_Status_Min_Fields>;
};


/** aggregate fields of "espin.subscription_status" */
export type Espin_Subscription_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Subscription_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.subscription_status". All fields are combined with a logical 'AND'. */
export type Espin_Subscription_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Subscription_Status_Bool_Exp>>;
  _not?: InputMaybe<Espin_Subscription_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Subscription_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.subscription_status" */
export enum Espin_Subscription_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  SubscriptionStatusPkey = 'subscription_status_pkey'
}

export enum Espin_Subscription_Status_Enum {
  /** Active sub */
  Active = 'active',
  /** Subscription expired and no new payments */
  Lapsed = 'lapsed'
}

/** Boolean expression to compare columns of type "espin_subscription_status_enum". All fields are combined with logical 'AND'. */
export type Espin_Subscription_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Subscription_Status_Enum>;
  _in?: InputMaybe<Array<Espin_Subscription_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Subscription_Status_Enum>;
  _nin?: InputMaybe<Array<Espin_Subscription_Status_Enum>>;
};

/** input type for inserting data into table "espin.subscription_status" */
export type Espin_Subscription_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Subscription_Status_Max_Fields = {
  __typename?: 'espin_subscription_status_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Subscription_Status_Min_Fields = {
  __typename?: 'espin_subscription_status_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.subscription_status" */
export type Espin_Subscription_Status_Mutation_Response = {
  __typename?: 'espin_subscription_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Subscription_Status>;
};

/** on_conflict condition type for table "espin.subscription_status" */
export type Espin_Subscription_Status_On_Conflict = {
  constraint: Espin_Subscription_Status_Constraint;
  update_columns?: Array<Espin_Subscription_Status_Update_Column>;
  where?: InputMaybe<Espin_Subscription_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.subscription_status". */
export type Espin_Subscription_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.subscription_status */
export type Espin_Subscription_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.subscription_status" */
export enum Espin_Subscription_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.subscription_status" */
export type Espin_Subscription_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_subscription_status" */
export type Espin_Subscription_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Subscription_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Subscription_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.subscription_status" */
export enum Espin_Subscription_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Espin_Subscription_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Subscription_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Subscription_Status_Bool_Exp;
};

/** Tiers of subs */
export type Espin_Subscription_Tier_Type = {
  __typename?: 'espin_subscription_tier_type';
  description: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.subscription_tier_type" */
export type Espin_Subscription_Tier_Type_Aggregate = {
  __typename?: 'espin_subscription_tier_type_aggregate';
  aggregate?: Maybe<Espin_Subscription_Tier_Type_Aggregate_Fields>;
  nodes: Array<Espin_Subscription_Tier_Type>;
};

/** aggregate fields of "espin.subscription_tier_type" */
export type Espin_Subscription_Tier_Type_Aggregate_Fields = {
  __typename?: 'espin_subscription_tier_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Subscription_Tier_Type_Max_Fields>;
  min?: Maybe<Espin_Subscription_Tier_Type_Min_Fields>;
};


/** aggregate fields of "espin.subscription_tier_type" */
export type Espin_Subscription_Tier_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Subscription_Tier_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.subscription_tier_type". All fields are combined with a logical 'AND'. */
export type Espin_Subscription_Tier_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Subscription_Tier_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_Subscription_Tier_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Subscription_Tier_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.subscription_tier_type" */
export enum Espin_Subscription_Tier_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  SubscriptionTierTypePkey = 'subscription_tier_type_pkey'
}

export enum Espin_Subscription_Tier_Type_Enum {
  /** Tier one sub */
  TierOne = 'tier_one',
  /** Tier three sub */
  TierThree = 'tier_three',
  /** Tier two sub */
  TierTwo = 'tier_two'
}

/** Boolean expression to compare columns of type "espin_subscription_tier_type_enum". All fields are combined with logical 'AND'. */
export type Espin_Subscription_Tier_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Subscription_Tier_Type_Enum>;
  _in?: InputMaybe<Array<Espin_Subscription_Tier_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Subscription_Tier_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_Subscription_Tier_Type_Enum>>;
};

/** input type for inserting data into table "espin.subscription_tier_type" */
export type Espin_Subscription_Tier_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Subscription_Tier_Type_Max_Fields = {
  __typename?: 'espin_subscription_tier_type_max_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Subscription_Tier_Type_Min_Fields = {
  __typename?: 'espin_subscription_tier_type_min_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.subscription_tier_type" */
export type Espin_Subscription_Tier_Type_Mutation_Response = {
  __typename?: 'espin_subscription_tier_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Subscription_Tier_Type>;
};

/** on_conflict condition type for table "espin.subscription_tier_type" */
export type Espin_Subscription_Tier_Type_On_Conflict = {
  constraint: Espin_Subscription_Tier_Type_Constraint;
  update_columns?: Array<Espin_Subscription_Tier_Type_Update_Column>;
  where?: InputMaybe<Espin_Subscription_Tier_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.subscription_tier_type". */
export type Espin_Subscription_Tier_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.subscription_tier_type */
export type Espin_Subscription_Tier_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.subscription_tier_type" */
export enum Espin_Subscription_Tier_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.subscription_tier_type" */
export type Espin_Subscription_Tier_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_subscription_tier_type" */
export type Espin_Subscription_Tier_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Subscription_Tier_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Subscription_Tier_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.subscription_tier_type" */
export enum Espin_Subscription_Tier_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

export type Espin_Subscription_Tier_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Subscription_Tier_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Subscription_Tier_Type_Bool_Exp;
};

/** Team object  */
export type Espin_Team = {
  __typename?: 'espin_team';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  display_name: Scalars['String'];
  /** An array relationship */
  event_registrations: Array<Espin_Event_Registration>;
  /** An aggregate relationship */
  event_registrations_aggregate: Espin_Event_Registration_Aggregate;
  /** An object relationship */
  game: Espin_Game;
  /** An object relationship */
  high_school?: Maybe<Espin_High_School>;
  high_school_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An array relationship */
  members: Array<Espin_Team_Members>;
  /** An aggregate relationship */
  members_aggregate: Espin_Team_Members_Aggregate;
  primary_game: Scalars['String'];
  /** An array relationship */
  team_invites: Array<Espin_Team_Invite>;
  /** An aggregate relationship */
  team_invites_aggregate: Espin_Team_Invite_Aggregate;
  team_type: Espin_Team_Type_Enum;
  updated_at: Scalars['timestamptz'];
};


/** Team object  */
export type Espin_TeamEvent_RegistrationsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
};


/** Team object  */
export type Espin_TeamEvent_Registrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
};


/** Team object  */
export type Espin_TeamMembersArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Members_Order_By>>;
  where?: InputMaybe<Espin_Team_Members_Bool_Exp>;
};


/** Team object  */
export type Espin_TeamMembers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Members_Order_By>>;
  where?: InputMaybe<Espin_Team_Members_Bool_Exp>;
};


/** Team object  */
export type Espin_TeamTeam_InvitesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Invite_Order_By>>;
  where?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
};


/** Team object  */
export type Espin_TeamTeam_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Invite_Order_By>>;
  where?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
};

/** aggregated selection of "espin.team" */
export type Espin_Team_Aggregate = {
  __typename?: 'espin_team_aggregate';
  aggregate?: Maybe<Espin_Team_Aggregate_Fields>;
  nodes: Array<Espin_Team>;
};

export type Espin_Team_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Team_Aggregate_Bool_Exp_Count>;
};

export type Espin_Team_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Team_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Team_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.team" */
export type Espin_Team_Aggregate_Fields = {
  __typename?: 'espin_team_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Team_Max_Fields>;
  min?: Maybe<Espin_Team_Min_Fields>;
};


/** aggregate fields of "espin.team" */
export type Espin_Team_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Team_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.team" */
export type Espin_Team_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Team_Max_Order_By>;
  min?: InputMaybe<Espin_Team_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.team" */
export type Espin_Team_Arr_Rel_Insert_Input = {
  data: Array<Espin_Team_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Team_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.team". All fields are combined with a logical 'AND'. */
export type Espin_Team_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Team_Bool_Exp>>;
  _not?: InputMaybe<Espin_Team_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Team_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  event_registrations?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
  event_registrations_aggregate?: InputMaybe<Espin_Event_Registration_Aggregate_Bool_Exp>;
  game?: InputMaybe<Espin_Game_Bool_Exp>;
  high_school?: InputMaybe<Espin_High_School_Bool_Exp>;
  high_school_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  members?: InputMaybe<Espin_Team_Members_Bool_Exp>;
  members_aggregate?: InputMaybe<Espin_Team_Members_Aggregate_Bool_Exp>;
  primary_game?: InputMaybe<String_Comparison_Exp>;
  team_invites?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
  team_invites_aggregate?: InputMaybe<Espin_Team_Invite_Aggregate_Bool_Exp>;
  team_type?: InputMaybe<Espin_Team_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.team" */
export enum Espin_Team_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamPkey = 'team_pkey'
}

/** input type for inserting data into table "espin.team" */
export type Espin_Team_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  event_registrations?: InputMaybe<Espin_Event_Registration_Arr_Rel_Insert_Input>;
  game?: InputMaybe<Espin_Game_Obj_Rel_Insert_Input>;
  high_school?: InputMaybe<Espin_High_School_Obj_Rel_Insert_Input>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  members?: InputMaybe<Espin_Team_Members_Arr_Rel_Insert_Input>;
  primary_game?: InputMaybe<Scalars['String']>;
  team_invites?: InputMaybe<Espin_Team_Invite_Arr_Rel_Insert_Input>;
  team_type?: InputMaybe<Espin_Team_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Invite tracking for teams */
export type Espin_Team_Invite = {
  __typename?: 'espin_team_invite';
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  player_profile?: Maybe<Espin_Player_Profile>;
  status: Espin_Invite_Status_Type_Enum;
  /** An object relationship */
  team: Espin_Team;
  team_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Espin_User>;
  user_id: Scalars['String'];
};

/** aggregated selection of "espin.team_invite" */
export type Espin_Team_Invite_Aggregate = {
  __typename?: 'espin_team_invite_aggregate';
  aggregate?: Maybe<Espin_Team_Invite_Aggregate_Fields>;
  nodes: Array<Espin_Team_Invite>;
};

export type Espin_Team_Invite_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Team_Invite_Aggregate_Bool_Exp_Count>;
};

export type Espin_Team_Invite_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Team_Invite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.team_invite" */
export type Espin_Team_Invite_Aggregate_Fields = {
  __typename?: 'espin_team_invite_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Team_Invite_Max_Fields>;
  min?: Maybe<Espin_Team_Invite_Min_Fields>;
};


/** aggregate fields of "espin.team_invite" */
export type Espin_Team_Invite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Team_Invite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.team_invite" */
export type Espin_Team_Invite_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Team_Invite_Max_Order_By>;
  min?: InputMaybe<Espin_Team_Invite_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.team_invite" */
export type Espin_Team_Invite_Arr_Rel_Insert_Input = {
  data: Array<Espin_Team_Invite_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Team_Invite_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.team_invite". All fields are combined with a logical 'AND'. */
export type Espin_Team_Invite_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Team_Invite_Bool_Exp>>;
  _not?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Team_Invite_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  player_profile?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum_Comparison_Exp>;
  team?: InputMaybe<Espin_Team_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Espin_User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.team_invite" */
export enum Espin_Team_Invite_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamInvitePkey = 'team_invite_pkey',
  /** unique or primary key constraint on columns "user_id", "team_id" */
  TeamInviteTeamIdUserIdKey = 'team_invite_team_id_user_id_key'
}

/** input type for inserting data into table "espin.team_invite" */
export type Espin_Team_Invite_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  player_profile?: InputMaybe<Espin_Player_Profile_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum>;
  team?: InputMaybe<Espin_Team_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Team_Invite_Max_Fields = {
  __typename?: 'espin_team_invite_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "espin.team_invite" */
export type Espin_Team_Invite_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Team_Invite_Min_Fields = {
  __typename?: 'espin_team_invite_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "espin.team_invite" */
export type Espin_Team_Invite_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.team_invite" */
export type Espin_Team_Invite_Mutation_Response = {
  __typename?: 'espin_team_invite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Team_Invite>;
};

/** on_conflict condition type for table "espin.team_invite" */
export type Espin_Team_Invite_On_Conflict = {
  constraint: Espin_Team_Invite_Constraint;
  update_columns?: Array<Espin_Team_Invite_Update_Column>;
  where?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.team_invite". */
export type Espin_Team_Invite_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  player_profile?: InputMaybe<Espin_Player_Profile_Order_By>;
  status?: InputMaybe<Order_By>;
  team?: InputMaybe<Espin_Team_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Espin_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.team_invite */
export type Espin_Team_Invite_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.team_invite" */
export enum Espin_Team_Invite_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "espin.team_invite" */
export type Espin_Team_Invite_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum>;
  team_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_team_invite" */
export type Espin_Team_Invite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Team_Invite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Team_Invite_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Espin_Invite_Status_Type_Enum>;
  team_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.team_invite" */
export enum Espin_Team_Invite_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Espin_Team_Invite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Team_Invite_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Team_Invite_Bool_Exp;
};

/** aggregate max on columns */
export type Espin_Team_Max_Fields = {
  __typename?: 'espin_team_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  display_name?: Maybe<Scalars['String']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  primary_game?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "espin.team" */
export type Espin_Team_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  primary_game?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Many to many join table between players + teanms */
export type Espin_Team_Members = {
  __typename?: 'espin_team_members';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  player_profile?: Maybe<Espin_Player_Profile>;
  player_profile_id: Scalars['uuid'];
  /** An object relationship */
  team?: Maybe<Espin_Team>;
  team_id: Scalars['uuid'];
  team_role: Espin_Team_Role_Enum;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "espin.team_members" */
export type Espin_Team_Members_Aggregate = {
  __typename?: 'espin_team_members_aggregate';
  aggregate?: Maybe<Espin_Team_Members_Aggregate_Fields>;
  nodes: Array<Espin_Team_Members>;
};

export type Espin_Team_Members_Aggregate_Bool_Exp = {
  count?: InputMaybe<Espin_Team_Members_Aggregate_Bool_Exp_Count>;
};

export type Espin_Team_Members_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Espin_Team_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Espin_Team_Members_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "espin.team_members" */
export type Espin_Team_Members_Aggregate_Fields = {
  __typename?: 'espin_team_members_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Team_Members_Max_Fields>;
  min?: Maybe<Espin_Team_Members_Min_Fields>;
};


/** aggregate fields of "espin.team_members" */
export type Espin_Team_Members_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Team_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "espin.team_members" */
export type Espin_Team_Members_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Espin_Team_Members_Max_Order_By>;
  min?: InputMaybe<Espin_Team_Members_Min_Order_By>;
};

/** input type for inserting array relation for remote table "espin.team_members" */
export type Espin_Team_Members_Arr_Rel_Insert_Input = {
  data: Array<Espin_Team_Members_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Team_Members_On_Conflict>;
};

/** Boolean expression to filter rows from the table "espin.team_members". All fields are combined with a logical 'AND'. */
export type Espin_Team_Members_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Team_Members_Bool_Exp>>;
  _not?: InputMaybe<Espin_Team_Members_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Team_Members_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  player_profile?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  player_profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Espin_Team_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  team_role?: InputMaybe<Espin_Team_Role_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.team_members" */
export enum Espin_Team_Members_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamMembersPkey = 'team_members_pkey',
  /** unique or primary key constraint on columns "player_profile_id", "team_id" */
  TeamMembersTeamIdPlayerProfileIdKey = 'team_members_team_id_player_profile_id_key'
}

/** input type for inserting data into table "espin.team_members" */
export type Espin_Team_Members_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  player_profile?: InputMaybe<Espin_Player_Profile_Obj_Rel_Insert_Input>;
  player_profile_id?: InputMaybe<Scalars['uuid']>;
  team?: InputMaybe<Espin_Team_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']>;
  team_role?: InputMaybe<Espin_Team_Role_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Espin_Team_Members_Max_Fields = {
  __typename?: 'espin_team_members_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  player_profile_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "espin.team_members" */
export type Espin_Team_Members_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  player_profile_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Espin_Team_Members_Min_Fields = {
  __typename?: 'espin_team_members_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  player_profile_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "espin.team_members" */
export type Espin_Team_Members_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  player_profile_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.team_members" */
export type Espin_Team_Members_Mutation_Response = {
  __typename?: 'espin_team_members_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Team_Members>;
};

/** on_conflict condition type for table "espin.team_members" */
export type Espin_Team_Members_On_Conflict = {
  constraint: Espin_Team_Members_Constraint;
  update_columns?: Array<Espin_Team_Members_Update_Column>;
  where?: InputMaybe<Espin_Team_Members_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.team_members". */
export type Espin_Team_Members_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  player_profile?: InputMaybe<Espin_Player_Profile_Order_By>;
  player_profile_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Espin_Team_Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.team_members */
export type Espin_Team_Members_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.team_members" */
export enum Espin_Team_Members_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PlayerProfileId = 'player_profile_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TeamRole = 'team_role',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "espin.team_members" */
export type Espin_Team_Members_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  player_profile_id?: InputMaybe<Scalars['uuid']>;
  team_id?: InputMaybe<Scalars['uuid']>;
  team_role?: InputMaybe<Espin_Team_Role_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "espin_team_members" */
export type Espin_Team_Members_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Team_Members_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Team_Members_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  player_profile_id?: InputMaybe<Scalars['uuid']>;
  team_id?: InputMaybe<Scalars['uuid']>;
  team_role?: InputMaybe<Espin_Team_Role_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "espin.team_members" */
export enum Espin_Team_Members_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PlayerProfileId = 'player_profile_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TeamRole = 'team_role',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Espin_Team_Members_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Team_Members_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Team_Members_Bool_Exp;
};

/** aggregate min on columns */
export type Espin_Team_Min_Fields = {
  __typename?: 'espin_team_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  display_name?: Maybe<Scalars['String']>;
  high_school_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  primary_game?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "espin.team" */
export type Espin_Team_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  primary_game?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "espin.team" */
export type Espin_Team_Mutation_Response = {
  __typename?: 'espin_team_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Team>;
};

/** input type for inserting object relation for remote table "espin.team" */
export type Espin_Team_Obj_Rel_Insert_Input = {
  data: Espin_Team_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_Team_On_Conflict>;
};

/** on_conflict condition type for table "espin.team" */
export type Espin_Team_On_Conflict = {
  constraint: Espin_Team_Constraint;
  update_columns?: Array<Espin_Team_Update_Column>;
  where?: InputMaybe<Espin_Team_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.team". */
export type Espin_Team_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  event_registrations_aggregate?: InputMaybe<Espin_Event_Registration_Aggregate_Order_By>;
  game?: InputMaybe<Espin_Game_Order_By>;
  high_school?: InputMaybe<Espin_High_School_Order_By>;
  high_school_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  members_aggregate?: InputMaybe<Espin_Team_Members_Aggregate_Order_By>;
  primary_game?: InputMaybe<Order_By>;
  team_invites_aggregate?: InputMaybe<Espin_Team_Invite_Aggregate_Order_By>;
  team_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.team */
export type Espin_Team_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** Enum describing a player's role on a team */
export type Espin_Team_Role = {
  __typename?: 'espin_team_role';
  description: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.team_role" */
export type Espin_Team_Role_Aggregate = {
  __typename?: 'espin_team_role_aggregate';
  aggregate?: Maybe<Espin_Team_Role_Aggregate_Fields>;
  nodes: Array<Espin_Team_Role>;
};

/** aggregate fields of "espin.team_role" */
export type Espin_Team_Role_Aggregate_Fields = {
  __typename?: 'espin_team_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Team_Role_Max_Fields>;
  min?: Maybe<Espin_Team_Role_Min_Fields>;
};


/** aggregate fields of "espin.team_role" */
export type Espin_Team_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Team_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.team_role". All fields are combined with a logical 'AND'. */
export type Espin_Team_Role_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Team_Role_Bool_Exp>>;
  _not?: InputMaybe<Espin_Team_Role_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Team_Role_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.team_role" */
export enum Espin_Team_Role_Constraint {
  /** unique or primary key constraint on columns "name" */
  TeamRolePkey = 'team_role_pkey'
}

export enum Espin_Team_Role_Enum {
  /** Team captain */
  Captain = 'captain',
  /** Team member (default) */
  Member = 'member'
}

/** Boolean expression to compare columns of type "espin_team_role_enum". All fields are combined with logical 'AND'. */
export type Espin_Team_Role_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Team_Role_Enum>;
  _in?: InputMaybe<Array<Espin_Team_Role_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Team_Role_Enum>;
  _nin?: InputMaybe<Array<Espin_Team_Role_Enum>>;
};

/** input type for inserting data into table "espin.team_role" */
export type Espin_Team_Role_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Team_Role_Max_Fields = {
  __typename?: 'espin_team_role_max_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Team_Role_Min_Fields = {
  __typename?: 'espin_team_role_min_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.team_role" */
export type Espin_Team_Role_Mutation_Response = {
  __typename?: 'espin_team_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Team_Role>;
};

/** on_conflict condition type for table "espin.team_role" */
export type Espin_Team_Role_On_Conflict = {
  constraint: Espin_Team_Role_Constraint;
  update_columns?: Array<Espin_Team_Role_Update_Column>;
  where?: InputMaybe<Espin_Team_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.team_role". */
export type Espin_Team_Role_Order_By = {
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.team_role */
export type Espin_Team_Role_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.team_role" */
export enum Espin_Team_Role_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.team_role" */
export type Espin_Team_Role_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_team_role" */
export type Espin_Team_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Team_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Team_Role_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.team_role" */
export enum Espin_Team_Role_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

export type Espin_Team_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Team_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Team_Role_Bool_Exp;
};

/** select columns of table "espin.team" */
export enum Espin_Team_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  Id = 'id',
  /** column name */
  PrimaryGame = 'primary_game',
  /** column name */
  TeamType = 'team_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "espin.team" */
export type Espin_Team_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  primary_game?: InputMaybe<Scalars['String']>;
  team_type?: InputMaybe<Espin_Team_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "espin_team" */
export type Espin_Team_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Team_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Team_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  high_school_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  primary_game?: InputMaybe<Scalars['String']>;
  team_type?: InputMaybe<Espin_Team_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Enum indicating the type of team */
export type Espin_Team_Type = {
  __typename?: 'espin_team_type';
  description: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.team_type" */
export type Espin_Team_Type_Aggregate = {
  __typename?: 'espin_team_type_aggregate';
  aggregate?: Maybe<Espin_Team_Type_Aggregate_Fields>;
  nodes: Array<Espin_Team_Type>;
};

/** aggregate fields of "espin.team_type" */
export type Espin_Team_Type_Aggregate_Fields = {
  __typename?: 'espin_team_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Team_Type_Max_Fields>;
  min?: Maybe<Espin_Team_Type_Min_Fields>;
};


/** aggregate fields of "espin.team_type" */
export type Espin_Team_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Team_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.team_type". All fields are combined with a logical 'AND'. */
export type Espin_Team_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Team_Type_Bool_Exp>>;
  _not?: InputMaybe<Espin_Team_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Team_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.team_type" */
export enum Espin_Team_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  TeamTypePkey = 'team_type_pkey'
}

export enum Espin_Team_Type_Enum {
  /** Free agent team (admin) */
  FreeAgent = 'free_agent',
  /** Pick up team (player) */
  PickUp = 'pick_up',
  /** High School Team */
  School = 'school'
}

/** Boolean expression to compare columns of type "espin_team_type_enum". All fields are combined with logical 'AND'. */
export type Espin_Team_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Espin_Team_Type_Enum>;
  _in?: InputMaybe<Array<Espin_Team_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Espin_Team_Type_Enum>;
  _nin?: InputMaybe<Array<Espin_Team_Type_Enum>>;
};

/** input type for inserting data into table "espin.team_type" */
export type Espin_Team_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Team_Type_Max_Fields = {
  __typename?: 'espin_team_type_max_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Team_Type_Min_Fields = {
  __typename?: 'espin_team_type_min_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.team_type" */
export type Espin_Team_Type_Mutation_Response = {
  __typename?: 'espin_team_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Team_Type>;
};

/** on_conflict condition type for table "espin.team_type" */
export type Espin_Team_Type_On_Conflict = {
  constraint: Espin_Team_Type_Constraint;
  update_columns?: Array<Espin_Team_Type_Update_Column>;
  where?: InputMaybe<Espin_Team_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.team_type". */
export type Espin_Team_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.team_type */
export type Espin_Team_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "espin.team_type" */
export enum Espin_Team_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.team_type" */
export type Espin_Team_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_team_type" */
export type Espin_Team_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Team_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Team_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.team_type" */
export enum Espin_Team_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

export type Espin_Team_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Team_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Team_Type_Bool_Exp;
};

/** update columns of table "espin.team" */
export enum Espin_Team_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  HighSchoolId = 'high_school_id',
  /** column name */
  Id = 'id',
  /** column name */
  PrimaryGame = 'primary_game',
  /** column name */
  TeamType = 'team_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Espin_Team_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Team_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Team_Bool_Exp;
};

/** Simple table to track "unregistered colleges" */
export type Espin_Unregistered_College = {
  __typename?: 'espin_unregistered_college';
  id: Scalars['uuid'];
  program_name: Scalars['String'];
};

/** aggregated selection of "espin.unregistered_college" */
export type Espin_Unregistered_College_Aggregate = {
  __typename?: 'espin_unregistered_college_aggregate';
  aggregate?: Maybe<Espin_Unregistered_College_Aggregate_Fields>;
  nodes: Array<Espin_Unregistered_College>;
};

/** aggregate fields of "espin.unregistered_college" */
export type Espin_Unregistered_College_Aggregate_Fields = {
  __typename?: 'espin_unregistered_college_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_Unregistered_College_Max_Fields>;
  min?: Maybe<Espin_Unregistered_College_Min_Fields>;
};


/** aggregate fields of "espin.unregistered_college" */
export type Espin_Unregistered_College_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_Unregistered_College_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.unregistered_college". All fields are combined with a logical 'AND'. */
export type Espin_Unregistered_College_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_Unregistered_College_Bool_Exp>>;
  _not?: InputMaybe<Espin_Unregistered_College_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_Unregistered_College_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  program_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.unregistered_college" */
export enum Espin_Unregistered_College_Constraint {
  /** unique or primary key constraint on columns "id" */
  UnregisteredCollegesPkey = 'unregistered_colleges_pkey',
  /** unique or primary key constraint on columns "program_name" */
  UnregisteredCollegesProgramNameKey = 'unregistered_colleges_program_name_key'
}

/** input type for inserting data into table "espin.unregistered_college" */
export type Espin_Unregistered_College_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  program_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_Unregistered_College_Max_Fields = {
  __typename?: 'espin_unregistered_college_max_fields';
  id?: Maybe<Scalars['uuid']>;
  program_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_Unregistered_College_Min_Fields = {
  __typename?: 'espin_unregistered_college_min_fields';
  id?: Maybe<Scalars['uuid']>;
  program_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.unregistered_college" */
export type Espin_Unregistered_College_Mutation_Response = {
  __typename?: 'espin_unregistered_college_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_Unregistered_College>;
};

/** on_conflict condition type for table "espin.unregistered_college" */
export type Espin_Unregistered_College_On_Conflict = {
  constraint: Espin_Unregistered_College_Constraint;
  update_columns?: Array<Espin_Unregistered_College_Update_Column>;
  where?: InputMaybe<Espin_Unregistered_College_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.unregistered_college". */
export type Espin_Unregistered_College_Order_By = {
  id?: InputMaybe<Order_By>;
  program_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.unregistered_college */
export type Espin_Unregistered_College_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.unregistered_college" */
export enum Espin_Unregistered_College_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProgramName = 'program_name'
}

/** input type for updating data in table "espin.unregistered_college" */
export type Espin_Unregistered_College_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  program_name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_unregistered_college" */
export type Espin_Unregistered_College_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_Unregistered_College_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_Unregistered_College_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  program_name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.unregistered_college" */
export enum Espin_Unregistered_College_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProgramName = 'program_name'
}

export type Espin_Unregistered_College_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_Unregistered_College_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_Unregistered_College_Bool_Exp;
};

/** eSpin User - sub links back to a0 info */
export type Espin_User = {
  __typename?: 'espin_user';
  client_login: Scalars['timestamptz'];
  /** An object relationship */
  college_profile?: Maybe<Espin_College_Profile>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  email_follow_preference: Espin_Follower_Email_Notification_Type_Enum;
  email_message_preference?: Maybe<Espin_Message_Email_Notification_Type_Enum>;
  email_profile_view_preference?: Maybe<Espin_Profile_View_Email_Notification_Type_Enum>;
  /** An object relationship */
  high_school_profile?: Maybe<Espin_High_School_Profile>;
  id: Scalars['String'];
  last_login?: Maybe<Scalars['timestamptz']>;
  migration_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  parent_profile?: Maybe<Espin_Parent_Profile>;
  /** An object relationship */
  player_profile?: Maybe<Espin_Player_Profile>;
  /** An array relationship */
  player_user_follows: Array<Espin_Follow>;
  /** An aggregate relationship */
  player_user_follows_aggregate: Espin_Follow_Aggregate;
  /** An array relationship */
  player_user_messages: Array<Espin_Message>;
  /** An aggregate relationship */
  player_user_messages_aggregate: Espin_Message_Aggregate;
  /** An array relationship */
  player_user_profile_views: Array<Espin_Profile_View>;
  /** An aggregate relationship */
  player_user_profile_views_aggregate: Espin_Profile_View_Aggregate;
  role: Espin_Role_Enum;
  /** An object relationship */
  role_name: Espin_Role;
  /** An object relationship */
  subscription_status?: Maybe<Espin_User_Subscription_Status>;
  /** An array relationship */
  team_invites: Array<Espin_Team_Invite>;
  /** An aggregate relationship */
  team_invites_aggregate: Espin_Team_Invite_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** eSpin User - sub links back to a0 info */
export type Espin_UserPlayer_User_FollowsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Order_By>>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};


/** eSpin User - sub links back to a0 info */
export type Espin_UserPlayer_User_Follows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Order_By>>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};


/** eSpin User - sub links back to a0 info */
export type Espin_UserPlayer_User_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Order_By>>;
  where?: InputMaybe<Espin_Message_Bool_Exp>;
};


/** eSpin User - sub links back to a0 info */
export type Espin_UserPlayer_User_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Order_By>>;
  where?: InputMaybe<Espin_Message_Bool_Exp>;
};


/** eSpin User - sub links back to a0 info */
export type Espin_UserPlayer_User_Profile_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};


/** eSpin User - sub links back to a0 info */
export type Espin_UserPlayer_User_Profile_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};


/** eSpin User - sub links back to a0 info */
export type Espin_UserTeam_InvitesArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Invite_Order_By>>;
  where?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
};


/** eSpin User - sub links back to a0 info */
export type Espin_UserTeam_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Invite_Order_By>>;
  where?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
};

/** aggregated selection of "espin.user" */
export type Espin_User_Aggregate = {
  __typename?: 'espin_user_aggregate';
  aggregate?: Maybe<Espin_User_Aggregate_Fields>;
  nodes: Array<Espin_User>;
};

/** aggregate fields of "espin.user" */
export type Espin_User_Aggregate_Fields = {
  __typename?: 'espin_user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_User_Max_Fields>;
  min?: Maybe<Espin_User_Min_Fields>;
};


/** aggregate fields of "espin.user" */
export type Espin_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.user". All fields are combined with a logical 'AND'. */
export type Espin_User_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_User_Bool_Exp>>;
  _not?: InputMaybe<Espin_User_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_User_Bool_Exp>>;
  client_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  college_profile?: InputMaybe<Espin_College_Profile_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  email_follow_preference?: InputMaybe<Espin_Follower_Email_Notification_Type_Enum_Comparison_Exp>;
  email_message_preference?: InputMaybe<Espin_Message_Email_Notification_Type_Enum_Comparison_Exp>;
  email_profile_view_preference?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Enum_Comparison_Exp>;
  high_school_profile?: InputMaybe<Espin_High_School_Profile_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  migration_id?: InputMaybe<String_Comparison_Exp>;
  parent_profile?: InputMaybe<Espin_Parent_Profile_Bool_Exp>;
  player_profile?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
  player_user_follows?: InputMaybe<Espin_Follow_Bool_Exp>;
  player_user_follows_aggregate?: InputMaybe<Espin_Follow_Aggregate_Bool_Exp>;
  player_user_messages?: InputMaybe<Espin_Message_Bool_Exp>;
  player_user_messages_aggregate?: InputMaybe<Espin_Message_Aggregate_Bool_Exp>;
  player_user_profile_views?: InputMaybe<Espin_Profile_View_Bool_Exp>;
  player_user_profile_views_aggregate?: InputMaybe<Espin_Profile_View_Aggregate_Bool_Exp>;
  role?: InputMaybe<Espin_Role_Enum_Comparison_Exp>;
  role_name?: InputMaybe<Espin_Role_Bool_Exp>;
  subscription_status?: InputMaybe<Espin_User_Subscription_Status_Bool_Exp>;
  team_invites?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
  team_invites_aggregate?: InputMaybe<Espin_Team_Invite_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.user" */
export enum Espin_User_Constraint {
  /** unique or primary key constraint on columns "email" */
  UserEmailKey = 'user_email_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

/** input type for inserting data into table "espin.user" */
export type Espin_User_Insert_Input = {
  client_login?: InputMaybe<Scalars['timestamptz']>;
  college_profile?: InputMaybe<Espin_College_Profile_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  email_follow_preference?: InputMaybe<Espin_Follower_Email_Notification_Type_Enum>;
  email_message_preference?: InputMaybe<Espin_Message_Email_Notification_Type_Enum>;
  email_profile_view_preference?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Enum>;
  high_school_profile?: InputMaybe<Espin_High_School_Profile_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  migration_id?: InputMaybe<Scalars['String']>;
  parent_profile?: InputMaybe<Espin_Parent_Profile_Obj_Rel_Insert_Input>;
  player_profile?: InputMaybe<Espin_Player_Profile_Obj_Rel_Insert_Input>;
  player_user_follows?: InputMaybe<Espin_Follow_Arr_Rel_Insert_Input>;
  player_user_messages?: InputMaybe<Espin_Message_Arr_Rel_Insert_Input>;
  player_user_profile_views?: InputMaybe<Espin_Profile_View_Arr_Rel_Insert_Input>;
  role?: InputMaybe<Espin_Role_Enum>;
  role_name?: InputMaybe<Espin_Role_Obj_Rel_Insert_Input>;
  subscription_status?: InputMaybe<Espin_User_Subscription_Status_Obj_Rel_Insert_Input>;
  team_invites?: InputMaybe<Espin_Team_Invite_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** A link from a user in system to an external provider link (id / sub pair) */
export type Espin_User_Linked_External_Provider = {
  __typename?: 'espin_user_linked_external_provider';
  id: Scalars['uuid'];
  /** An object relationship */
  link: Espin_External_Provider_Link;
  link_id: Scalars['uuid'];
  user_id: Scalars['String'];
};

/** aggregated selection of "espin.user_linked_external_provider" */
export type Espin_User_Linked_External_Provider_Aggregate = {
  __typename?: 'espin_user_linked_external_provider_aggregate';
  aggregate?: Maybe<Espin_User_Linked_External_Provider_Aggregate_Fields>;
  nodes: Array<Espin_User_Linked_External_Provider>;
};

/** aggregate fields of "espin.user_linked_external_provider" */
export type Espin_User_Linked_External_Provider_Aggregate_Fields = {
  __typename?: 'espin_user_linked_external_provider_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_User_Linked_External_Provider_Max_Fields>;
  min?: Maybe<Espin_User_Linked_External_Provider_Min_Fields>;
};


/** aggregate fields of "espin.user_linked_external_provider" */
export type Espin_User_Linked_External_Provider_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_User_Linked_External_Provider_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.user_linked_external_provider". All fields are combined with a logical 'AND'. */
export type Espin_User_Linked_External_Provider_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_User_Linked_External_Provider_Bool_Exp>>;
  _not?: InputMaybe<Espin_User_Linked_External_Provider_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_User_Linked_External_Provider_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  link?: InputMaybe<Espin_External_Provider_Link_Bool_Exp>;
  link_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.user_linked_external_provider" */
export enum Espin_User_Linked_External_Provider_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserLinkedExternalProviderPkey = 'user_linked_external_provider_pkey'
}

/** input type for inserting data into table "espin.user_linked_external_provider" */
export type Espin_User_Linked_External_Provider_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  link?: InputMaybe<Espin_External_Provider_Link_Obj_Rel_Insert_Input>;
  link_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_User_Linked_External_Provider_Max_Fields = {
  __typename?: 'espin_user_linked_external_provider_max_fields';
  id?: Maybe<Scalars['uuid']>;
  link_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_User_Linked_External_Provider_Min_Fields = {
  __typename?: 'espin_user_linked_external_provider_min_fields';
  id?: Maybe<Scalars['uuid']>;
  link_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.user_linked_external_provider" */
export type Espin_User_Linked_External_Provider_Mutation_Response = {
  __typename?: 'espin_user_linked_external_provider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_User_Linked_External_Provider>;
};

/** on_conflict condition type for table "espin.user_linked_external_provider" */
export type Espin_User_Linked_External_Provider_On_Conflict = {
  constraint: Espin_User_Linked_External_Provider_Constraint;
  update_columns?: Array<Espin_User_Linked_External_Provider_Update_Column>;
  where?: InputMaybe<Espin_User_Linked_External_Provider_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.user_linked_external_provider". */
export type Espin_User_Linked_External_Provider_Order_By = {
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Espin_External_Provider_Link_Order_By>;
  link_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.user_linked_external_provider */
export type Espin_User_Linked_External_Provider_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.user_linked_external_provider" */
export enum Espin_User_Linked_External_Provider_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LinkId = 'link_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "espin.user_linked_external_provider" */
export type Espin_User_Linked_External_Provider_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  link_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_user_linked_external_provider" */
export type Espin_User_Linked_External_Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_User_Linked_External_Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_User_Linked_External_Provider_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  link_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.user_linked_external_provider" */
export enum Espin_User_Linked_External_Provider_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LinkId = 'link_id',
  /** column name */
  UserId = 'user_id'
}

export type Espin_User_Linked_External_Provider_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_User_Linked_External_Provider_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_User_Linked_External_Provider_Bool_Exp;
};

/** aggregate max on columns */
export type Espin_User_Max_Fields = {
  __typename?: 'espin_user_max_fields';
  client_login?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  migration_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "espin.user_membership" */
export type Espin_User_Membership = {
  __typename?: 'espin_user_membership';
  account_type: Scalars['String'];
  created_at: Scalars['timestamptz'];
  customer_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expiry_date: Scalars['date'];
  id: Scalars['String'];
  membership_id: Scalars['Int'];
  payment_failed: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "espin.user_membership" */
export type Espin_User_Membership_Aggregate = {
  __typename?: 'espin_user_membership_aggregate';
  aggregate?: Maybe<Espin_User_Membership_Aggregate_Fields>;
  nodes: Array<Espin_User_Membership>;
};

/** aggregate fields of "espin.user_membership" */
export type Espin_User_Membership_Aggregate_Fields = {
  __typename?: 'espin_user_membership_aggregate_fields';
  avg?: Maybe<Espin_User_Membership_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_User_Membership_Max_Fields>;
  min?: Maybe<Espin_User_Membership_Min_Fields>;
  stddev?: Maybe<Espin_User_Membership_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_User_Membership_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_User_Membership_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_User_Membership_Sum_Fields>;
  var_pop?: Maybe<Espin_User_Membership_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_User_Membership_Var_Samp_Fields>;
  variance?: Maybe<Espin_User_Membership_Variance_Fields>;
};


/** aggregate fields of "espin.user_membership" */
export type Espin_User_Membership_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_User_Membership_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Espin_User_Membership_Avg_Fields = {
  __typename?: 'espin_user_membership_avg_fields';
  membership_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.user_membership". All fields are combined with a logical 'AND'. */
export type Espin_User_Membership_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_User_Membership_Bool_Exp>>;
  _not?: InputMaybe<Espin_User_Membership_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_User_Membership_Bool_Exp>>;
  account_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_id?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  expiry_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  membership_id?: InputMaybe<Int_Comparison_Exp>;
  payment_failed?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.user_membership" */
export enum Espin_User_Membership_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserMembershipsPkey = 'user_memberships_pkey'
}

/** input type for incrementing numeric columns in table "espin.user_membership" */
export type Espin_User_Membership_Inc_Input = {
  membership_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "espin.user_membership" */
export type Espin_User_Membership_Insert_Input = {
  account_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  customer_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expiry_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['String']>;
  membership_id?: InputMaybe<Scalars['Int']>;
  payment_failed?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Espin_User_Membership_Max_Fields = {
  __typename?: 'espin_user_membership_max_fields';
  account_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  customer_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expiry_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['String']>;
  membership_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Espin_User_Membership_Min_Fields = {
  __typename?: 'espin_user_membership_min_fields';
  account_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  customer_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expiry_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['String']>;
  membership_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "espin.user_membership" */
export type Espin_User_Membership_Mutation_Response = {
  __typename?: 'espin_user_membership_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_User_Membership>;
};

/** on_conflict condition type for table "espin.user_membership" */
export type Espin_User_Membership_On_Conflict = {
  constraint: Espin_User_Membership_Constraint;
  update_columns?: Array<Espin_User_Membership_Update_Column>;
  where?: InputMaybe<Espin_User_Membership_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.user_membership". */
export type Espin_User_Membership_Order_By = {
  account_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  membership_id?: InputMaybe<Order_By>;
  payment_failed?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.user_membership */
export type Espin_User_Membership_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "espin.user_membership" */
export enum Espin_User_Membership_Select_Column {
  /** column name */
  AccountType = 'account_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  Email = 'email',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  MembershipId = 'membership_id',
  /** column name */
  PaymentFailed = 'payment_failed',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "espin.user_membership" */
export type Espin_User_Membership_Set_Input = {
  account_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  customer_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expiry_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['String']>;
  membership_id?: InputMaybe<Scalars['Int']>;
  payment_failed?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Espin_User_Membership_Stddev_Fields = {
  __typename?: 'espin_user_membership_stddev_fields';
  membership_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_User_Membership_Stddev_Pop_Fields = {
  __typename?: 'espin_user_membership_stddev_pop_fields';
  membership_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_User_Membership_Stddev_Samp_Fields = {
  __typename?: 'espin_user_membership_stddev_samp_fields';
  membership_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_user_membership" */
export type Espin_User_Membership_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_User_Membership_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_User_Membership_Stream_Cursor_Value_Input = {
  account_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  customer_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expiry_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['String']>;
  membership_id?: InputMaybe<Scalars['Int']>;
  payment_failed?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Espin_User_Membership_Sum_Fields = {
  __typename?: 'espin_user_membership_sum_fields';
  membership_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "espin.user_membership" */
export enum Espin_User_Membership_Update_Column {
  /** column name */
  AccountType = 'account_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  Email = 'email',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  MembershipId = 'membership_id',
  /** column name */
  PaymentFailed = 'payment_failed',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Espin_User_Membership_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Espin_User_Membership_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_User_Membership_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_User_Membership_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Espin_User_Membership_Var_Pop_Fields = {
  __typename?: 'espin_user_membership_var_pop_fields';
  membership_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_User_Membership_Var_Samp_Fields = {
  __typename?: 'espin_user_membership_var_samp_fields';
  membership_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_User_Membership_Variance_Fields = {
  __typename?: 'espin_user_membership_variance_fields';
  membership_id?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Espin_User_Min_Fields = {
  __typename?: 'espin_user_min_fields';
  client_login?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  migration_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "espin.user" */
export type Espin_User_Mutation_Response = {
  __typename?: 'espin_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_User>;
};

/** input type for inserting object relation for remote table "espin.user" */
export type Espin_User_Obj_Rel_Insert_Input = {
  data: Espin_User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Espin_User_On_Conflict>;
};

/** on_conflict condition type for table "espin.user" */
export type Espin_User_On_Conflict = {
  constraint: Espin_User_Constraint;
  update_columns?: Array<Espin_User_Update_Column>;
  where?: InputMaybe<Espin_User_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.user". */
export type Espin_User_Order_By = {
  client_login?: InputMaybe<Order_By>;
  college_profile?: InputMaybe<Espin_College_Profile_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  email_follow_preference?: InputMaybe<Order_By>;
  email_message_preference?: InputMaybe<Order_By>;
  email_profile_view_preference?: InputMaybe<Order_By>;
  high_school_profile?: InputMaybe<Espin_High_School_Profile_Order_By>;
  id?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  migration_id?: InputMaybe<Order_By>;
  parent_profile?: InputMaybe<Espin_Parent_Profile_Order_By>;
  player_profile?: InputMaybe<Espin_Player_Profile_Order_By>;
  player_user_follows_aggregate?: InputMaybe<Espin_Follow_Aggregate_Order_By>;
  player_user_messages_aggregate?: InputMaybe<Espin_Message_Aggregate_Order_By>;
  player_user_profile_views_aggregate?: InputMaybe<Espin_Profile_View_Aggregate_Order_By>;
  role?: InputMaybe<Order_By>;
  role_name?: InputMaybe<Espin_Role_Order_By>;
  subscription_status?: InputMaybe<Espin_User_Subscription_Status_Order_By>;
  team_invites_aggregate?: InputMaybe<Espin_Team_Invite_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.user */
export type Espin_User_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "espin.user" */
export enum Espin_User_Select_Column {
  /** column name */
  ClientLogin = 'client_login',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailFollowPreference = 'email_follow_preference',
  /** column name */
  EmailMessagePreference = 'email_message_preference',
  /** column name */
  EmailProfileViewPreference = 'email_profile_view_preference',
  /** column name */
  Id = 'id',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  MigrationId = 'migration_id',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "espin.user" */
export type Espin_User_Set_Input = {
  client_login?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  email_follow_preference?: InputMaybe<Espin_Follower_Email_Notification_Type_Enum>;
  email_message_preference?: InputMaybe<Espin_Message_Email_Notification_Type_Enum>;
  email_profile_view_preference?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Enum>;
  id?: InputMaybe<Scalars['String']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  migration_id?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Espin_Role_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "espin.user_source" */
export type Espin_User_Source = {
  __typename?: 'espin_user_source';
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
};

/** aggregated selection of "espin.user_source" */
export type Espin_User_Source_Aggregate = {
  __typename?: 'espin_user_source_aggregate';
  aggregate?: Maybe<Espin_User_Source_Aggregate_Fields>;
  nodes: Array<Espin_User_Source>;
};

/** aggregate fields of "espin.user_source" */
export type Espin_User_Source_Aggregate_Fields = {
  __typename?: 'espin_user_source_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Espin_User_Source_Max_Fields>;
  min?: Maybe<Espin_User_Source_Min_Fields>;
};


/** aggregate fields of "espin.user_source" */
export type Espin_User_Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_User_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "espin.user_source". All fields are combined with a logical 'AND'. */
export type Espin_User_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_User_Source_Bool_Exp>>;
  _not?: InputMaybe<Espin_User_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_User_Source_Bool_Exp>>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "espin.user_source" */
export enum Espin_User_Source_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSourcePkey = 'user_source_pkey'
}

/** input type for inserting data into table "espin.user_source" */
export type Espin_User_Source_Insert_Input = {
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Espin_User_Source_Max_Fields = {
  __typename?: 'espin_user_source_max_fields';
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Espin_User_Source_Min_Fields = {
  __typename?: 'espin_user_source_min_fields';
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "espin.user_source" */
export type Espin_User_Source_Mutation_Response = {
  __typename?: 'espin_user_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Espin_User_Source>;
};

/** on_conflict condition type for table "espin.user_source" */
export type Espin_User_Source_On_Conflict = {
  constraint: Espin_User_Source_Constraint;
  update_columns?: Array<Espin_User_Source_Update_Column>;
  where?: InputMaybe<Espin_User_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "espin.user_source". */
export type Espin_User_Source_Order_By = {
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: espin.user_source */
export type Espin_User_Source_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "espin.user_source" */
export enum Espin_User_Source_Select_Column {
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "espin.user_source" */
export type Espin_User_Source_Set_Input = {
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "espin_user_source" */
export type Espin_User_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_User_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_User_Source_Stream_Cursor_Value_Input = {
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "espin.user_source" */
export enum Espin_User_Source_Update_Column {
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Espin_User_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_User_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_User_Source_Bool_Exp;
};

/** Streaming cursor of the table "espin_user" */
export type Espin_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_User_Stream_Cursor_Value_Input = {
  client_login?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  email_follow_preference?: InputMaybe<Espin_Follower_Email_Notification_Type_Enum>;
  email_message_preference?: InputMaybe<Espin_Message_Email_Notification_Type_Enum>;
  email_profile_view_preference?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Enum>;
  id?: InputMaybe<Scalars['String']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  migration_id?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Espin_Role_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "espin.user_subscription_status" */
export type Espin_User_Subscription_Status = {
  __typename?: 'espin_user_subscription_status';
  id?: Maybe<Scalars['String']>;
  is_subscribed?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['String']>;
  tierlookup?: Maybe<Scalars['Int']>;
  /** An object relationship */
  user?: Maybe<Espin_User>;
};

/** aggregated selection of "espin.user_subscription_status" */
export type Espin_User_Subscription_Status_Aggregate = {
  __typename?: 'espin_user_subscription_status_aggregate';
  aggregate?: Maybe<Espin_User_Subscription_Status_Aggregate_Fields>;
  nodes: Array<Espin_User_Subscription_Status>;
};

/** aggregate fields of "espin.user_subscription_status" */
export type Espin_User_Subscription_Status_Aggregate_Fields = {
  __typename?: 'espin_user_subscription_status_aggregate_fields';
  avg?: Maybe<Espin_User_Subscription_Status_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Espin_User_Subscription_Status_Max_Fields>;
  min?: Maybe<Espin_User_Subscription_Status_Min_Fields>;
  stddev?: Maybe<Espin_User_Subscription_Status_Stddev_Fields>;
  stddev_pop?: Maybe<Espin_User_Subscription_Status_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Espin_User_Subscription_Status_Stddev_Samp_Fields>;
  sum?: Maybe<Espin_User_Subscription_Status_Sum_Fields>;
  var_pop?: Maybe<Espin_User_Subscription_Status_Var_Pop_Fields>;
  var_samp?: Maybe<Espin_User_Subscription_Status_Var_Samp_Fields>;
  variance?: Maybe<Espin_User_Subscription_Status_Variance_Fields>;
};


/** aggregate fields of "espin.user_subscription_status" */
export type Espin_User_Subscription_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Espin_User_Subscription_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Espin_User_Subscription_Status_Avg_Fields = {
  __typename?: 'espin_user_subscription_status_avg_fields';
  tierlookup?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "espin.user_subscription_status". All fields are combined with a logical 'AND'. */
export type Espin_User_Subscription_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Espin_User_Subscription_Status_Bool_Exp>>;
  _not?: InputMaybe<Espin_User_Subscription_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Espin_User_Subscription_Status_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_subscribed?: InputMaybe<Boolean_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  tier?: InputMaybe<String_Comparison_Exp>;
  tierlookup?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Espin_User_Bool_Exp>;
};

/** input type for inserting data into table "espin.user_subscription_status" */
export type Espin_User_Subscription_Status_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  is_subscribed?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<Scalars['String']>;
  tierlookup?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Espin_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Espin_User_Subscription_Status_Max_Fields = {
  __typename?: 'espin_user_subscription_status_max_fields';
  id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['String']>;
  tierlookup?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Espin_User_Subscription_Status_Min_Fields = {
  __typename?: 'espin_user_subscription_status_min_fields';
  id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['String']>;
  tierlookup?: Maybe<Scalars['Int']>;
};

/** input type for inserting object relation for remote table "espin.user_subscription_status" */
export type Espin_User_Subscription_Status_Obj_Rel_Insert_Input = {
  data: Espin_User_Subscription_Status_Insert_Input;
};

/** Ordering options when selecting data from "espin.user_subscription_status". */
export type Espin_User_Subscription_Status_Order_By = {
  id?: InputMaybe<Order_By>;
  is_subscribed?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tier?: InputMaybe<Order_By>;
  tierlookup?: InputMaybe<Order_By>;
  user?: InputMaybe<Espin_User_Order_By>;
};

/** select columns of table "espin.user_subscription_status" */
export enum Espin_User_Subscription_Status_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsSubscribed = 'is_subscribed',
  /** column name */
  Role = 'role',
  /** column name */
  Tier = 'tier',
  /** column name */
  Tierlookup = 'tierlookup'
}

/** aggregate stddev on columns */
export type Espin_User_Subscription_Status_Stddev_Fields = {
  __typename?: 'espin_user_subscription_status_stddev_fields';
  tierlookup?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Espin_User_Subscription_Status_Stddev_Pop_Fields = {
  __typename?: 'espin_user_subscription_status_stddev_pop_fields';
  tierlookup?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Espin_User_Subscription_Status_Stddev_Samp_Fields = {
  __typename?: 'espin_user_subscription_status_stddev_samp_fields';
  tierlookup?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "espin_user_subscription_status" */
export type Espin_User_Subscription_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Espin_User_Subscription_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Espin_User_Subscription_Status_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  is_subscribed?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<Scalars['String']>;
  tierlookup?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Espin_User_Subscription_Status_Sum_Fields = {
  __typename?: 'espin_user_subscription_status_sum_fields';
  tierlookup?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Espin_User_Subscription_Status_Var_Pop_Fields = {
  __typename?: 'espin_user_subscription_status_var_pop_fields';
  tierlookup?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Espin_User_Subscription_Status_Var_Samp_Fields = {
  __typename?: 'espin_user_subscription_status_var_samp_fields';
  tierlookup?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Espin_User_Subscription_Status_Variance_Fields = {
  __typename?: 'espin_user_subscription_status_variance_fields';
  tierlookup?: Maybe<Scalars['Float']>;
};

/** update columns of table "espin.user" */
export enum Espin_User_Update_Column {
  /** column name */
  ClientLogin = 'client_login',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailFollowPreference = 'email_follow_preference',
  /** column name */
  EmailMessagePreference = 'email_message_preference',
  /** column name */
  EmailProfileViewPreference = 'email_profile_view_preference',
  /** column name */
  Id = 'id',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  MigrationId = 'migration_id',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Espin_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Espin_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Espin_User_Bool_Exp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']>;
  _gt?: InputMaybe<Scalars['geography']>;
  _gte?: InputMaybe<Scalars['geography']>;
  _in?: InputMaybe<Array<Scalars['geography']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geography']>;
  _lte?: InputMaybe<Scalars['geography']>;
  _neq?: InputMaybe<Scalars['geography']>;
  _nin?: InputMaybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']>;
  _gt?: InputMaybe<Scalars['geometry']>;
  _gte?: InputMaybe<Scalars['geometry']>;
  _in?: InputMaybe<Array<Scalars['geometry']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geometry']>;
  _lte?: InputMaybe<Scalars['geometry']>;
  _neq?: InputMaybe<Scalars['geometry']>;
  _nin?: InputMaybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  SubmitPlayerProfileUpdate?: Maybe<SubmitPlayerProfileUpdateOutput>;
  acceptCollegeInvite?: Maybe<AcceptCollegeInviteOutput>;
  createEventTicketPaymentIntent?: Maybe<EventTicketPaymentIntentOutput>;
  createFileUploadUrl?: Maybe<FileUploadUrlRequestOutput>;
  /** Action for a HS to create a team (since it can be usernames OR emails) */
  createHighSchoolTeam?: Maybe<CreateHighSchoolTeamOutput>;
  /** Action for a player to create a team (since it can be usernames OR emails) */
  createPlayerTeam?: Maybe<CreatePlayerTeamOutput>;
  /** delete data from the table: "cehsite.ms_available_site_terms" */
  delete_cehsite_ms_available_site_terms?: Maybe<Cehsite_Ms_Available_Site_Terms_Mutation_Response>;
  /** delete single row from the table: "cehsite.ms_available_site_terms" */
  delete_cehsite_ms_available_site_terms_by_pk?: Maybe<Cehsite_Ms_Available_Site_Terms>;
  /** delete data from the table: "cehsite.ms_contact_form_entry" */
  delete_cehsite_ms_contact_form_entry?: Maybe<Cehsite_Ms_Contact_Form_Entry_Mutation_Response>;
  /** delete single row from the table: "cehsite.ms_contact_form_entry" */
  delete_cehsite_ms_contact_form_entry_by_pk?: Maybe<Cehsite_Ms_Contact_Form_Entry>;
  /** delete data from the table: "cehsite.ms_newsletter_signup" */
  delete_cehsite_ms_newsletter_signup?: Maybe<Cehsite_Ms_Newsletter_Signup_Mutation_Response>;
  /** delete single row from the table: "cehsite.ms_newsletter_signup" */
  delete_cehsite_ms_newsletter_signup_by_pk?: Maybe<Cehsite_Ms_Newsletter_Signup>;
  /** delete data from the table: "cehsite.ms_site_content" */
  delete_cehsite_ms_site_content?: Maybe<Cehsite_Ms_Site_Content_Mutation_Response>;
  /** delete single row from the table: "cehsite.ms_site_content" */
  delete_cehsite_ms_site_content_by_pk?: Maybe<Cehsite_Ms_Site_Content>;
  /** delete data from the table: "content.file" */
  delete_content_file?: Maybe<Content_File_Mutation_Response>;
  /** delete single row from the table: "content.file" */
  delete_content_file_by_pk?: Maybe<Content_File>;
  /** delete data from the table: "content.file_metadata" */
  delete_content_file_metadata?: Maybe<Content_File_Metadata_Mutation_Response>;
  /** delete single row from the table: "content.file_metadata" */
  delete_content_file_metadata_by_pk?: Maybe<Content_File_Metadata>;
  /** delete data from the table: "content.file_status" */
  delete_content_file_status?: Maybe<Content_File_Status_Mutation_Response>;
  /** delete single row from the table: "content.file_status" */
  delete_content_file_status_by_pk?: Maybe<Content_File_Status>;
  /** delete data from the table: "content.media_link" */
  delete_content_media_link?: Maybe<Content_Media_Link_Mutation_Response>;
  /** delete single row from the table: "content.media_link" */
  delete_content_media_link_by_pk?: Maybe<Content_Media_Link>;
  /** delete data from the table: "content.media_link_type" */
  delete_content_media_link_type?: Maybe<Content_Media_Link_Type_Mutation_Response>;
  /** delete single row from the table: "content.media_link_type" */
  delete_content_media_link_type_by_pk?: Maybe<Content_Media_Link_Type>;
  /** delete data from the table: "content.project_name" */
  delete_content_project_name?: Maybe<Content_Project_Name_Mutation_Response>;
  /** delete single row from the table: "content.project_name" */
  delete_content_project_name_by_pk?: Maybe<Content_Project_Name>;
  /** delete data from the table: "content.status" */
  delete_content_status?: Maybe<Content_Status_Mutation_Response>;
  /** delete single row from the table: "content.status" */
  delete_content_status_by_pk?: Maybe<Content_Status>;
  /** delete data from the table: "espin.address" */
  delete_espin_address?: Maybe<Espin_Address_Mutation_Response>;
  /** delete single row from the table: "espin.address" */
  delete_espin_address_by_pk?: Maybe<Espin_Address>;
  /** delete data from the table: "espin.boolean_feature_flag" */
  delete_espin_boolean_feature_flag?: Maybe<Espin_Boolean_Feature_Flag_Mutation_Response>;
  /** delete single row from the table: "espin.boolean_feature_flag" */
  delete_espin_boolean_feature_flag_by_pk?: Maybe<Espin_Boolean_Feature_Flag>;
  /** delete data from the table: "espin.coach_profile" */
  delete_espin_coach_profile?: Maybe<Espin_Coach_Profile_Mutation_Response>;
  /** delete single row from the table: "espin.coach_profile" */
  delete_espin_coach_profile_by_pk?: Maybe<Espin_Coach_Profile>;
  /** delete data from the table: "espin.college" */
  delete_espin_college?: Maybe<Espin_College_Mutation_Response>;
  /** delete data from the table: "espin.college_automatic_message_response_type" */
  delete_espin_college_automatic_message_response_type?: Maybe<Espin_College_Automatic_Message_Response_Type_Mutation_Response>;
  /** delete single row from the table: "espin.college_automatic_message_response_type" */
  delete_espin_college_automatic_message_response_type_by_pk?: Maybe<Espin_College_Automatic_Message_Response_Type>;
  /** delete single row from the table: "espin.college" */
  delete_espin_college_by_pk?: Maybe<Espin_College>;
  /** delete data from the table: "espin.college_game" */
  delete_espin_college_game?: Maybe<Espin_College_Game_Mutation_Response>;
  /** delete single row from the table: "espin.college_game" */
  delete_espin_college_game_by_pk?: Maybe<Espin_College_Game>;
  /** delete data from the table: "espin.college_image" */
  delete_espin_college_image?: Maybe<Espin_College_Image_Mutation_Response>;
  /** delete single row from the table: "espin.college_image" */
  delete_espin_college_image_by_pk?: Maybe<Espin_College_Image>;
  /** delete data from the table: "espin.college_invite" */
  delete_espin_college_invite?: Maybe<Espin_College_Invite_Mutation_Response>;
  /** delete single row from the table: "espin.college_invite" */
  delete_espin_college_invite_by_pk?: Maybe<Espin_College_Invite>;
  /** delete data from the table: "espin.college_preferences" */
  delete_espin_college_preferences?: Maybe<Espin_College_Preferences_Mutation_Response>;
  /** delete single row from the table: "espin.college_preferences" */
  delete_espin_college_preferences_by_pk?: Maybe<Espin_College_Preferences>;
  /** delete data from the table: "espin.college_profile" */
  delete_espin_college_profile?: Maybe<Espin_College_Profile_Mutation_Response>;
  /** delete single row from the table: "espin.college_profile" */
  delete_espin_college_profile_by_pk?: Maybe<Espin_College_Profile>;
  /** delete data from the table: "espin.college_roster" */
  delete_espin_college_roster?: Maybe<Espin_College_Roster_Mutation_Response>;
  /** delete single row from the table: "espin.college_roster" */
  delete_espin_college_roster_by_pk?: Maybe<Espin_College_Roster>;
  /** delete data from the table: "espin.college_staff_member" */
  delete_espin_college_staff_member?: Maybe<Espin_College_Staff_Member_Mutation_Response>;
  /** delete single row from the table: "espin.college_staff_member" */
  delete_espin_college_staff_member_by_pk?: Maybe<Espin_College_Staff_Member>;
  /** delete data from the table: "espin.college_subscription" */
  delete_espin_college_subscription?: Maybe<Espin_College_Subscription_Mutation_Response>;
  /** delete single row from the table: "espin.college_subscription" */
  delete_espin_college_subscription_by_pk?: Maybe<Espin_College_Subscription>;
  /** delete data from the table: "espin.college_verification_status_type" */
  delete_espin_college_verification_status_type?: Maybe<Espin_College_Verification_Status_Type_Mutation_Response>;
  /** delete single row from the table: "espin.college_verification_status_type" */
  delete_espin_college_verification_status_type_by_pk?: Maybe<Espin_College_Verification_Status_Type>;
  /** delete data from the table: "espin.draft_player_profile" */
  delete_espin_draft_player_profile?: Maybe<Espin_Draft_Player_Profile_Mutation_Response>;
  /** delete single row from the table: "espin.draft_player_profile" */
  delete_espin_draft_player_profile_by_pk?: Maybe<Espin_Draft_Player_Profile>;
  /** delete data from the table: "espin.editable_site_content" */
  delete_espin_editable_site_content?: Maybe<Espin_Editable_Site_Content_Mutation_Response>;
  /** delete single row from the table: "espin.editable_site_content" */
  delete_espin_editable_site_content_by_pk?: Maybe<Espin_Editable_Site_Content>;
  /** delete data from the table: "espin.ethnicity_options" */
  delete_espin_ethnicity_options?: Maybe<Espin_Ethnicity_Options_Mutation_Response>;
  /** delete single row from the table: "espin.ethnicity_options" */
  delete_espin_ethnicity_options_by_pk?: Maybe<Espin_Ethnicity_Options>;
  /** delete data from the table: "espin.event" */
  delete_espin_event?: Maybe<Espin_Event_Mutation_Response>;
  /** delete single row from the table: "espin.event" */
  delete_espin_event_by_pk?: Maybe<Espin_Event>;
  /** delete data from the table: "espin.event_custom_field" */
  delete_espin_event_custom_field?: Maybe<Espin_Event_Custom_Field_Mutation_Response>;
  /** delete single row from the table: "espin.event_custom_field" */
  delete_espin_event_custom_field_by_pk?: Maybe<Espin_Event_Custom_Field>;
  /** delete data from the table: "espin.event_custom_field_type" */
  delete_espin_event_custom_field_type?: Maybe<Espin_Event_Custom_Field_Type_Mutation_Response>;
  /** delete single row from the table: "espin.event_custom_field_type" */
  delete_espin_event_custom_field_type_by_pk?: Maybe<Espin_Event_Custom_Field_Type>;
  /** delete data from the table: "espin.event_document" */
  delete_espin_event_document?: Maybe<Espin_Event_Document_Mutation_Response>;
  /** delete single row from the table: "espin.event_document" */
  delete_espin_event_document_by_pk?: Maybe<Espin_Event_Document>;
  /** delete data from the table: "espin.event_game" */
  delete_espin_event_game?: Maybe<Espin_Event_Game_Mutation_Response>;
  /** delete single row from the table: "espin.event_game" */
  delete_espin_event_game_by_pk?: Maybe<Espin_Event_Game>;
  /** delete data from the table: "espin.event_registration" */
  delete_espin_event_registration?: Maybe<Espin_Event_Registration_Mutation_Response>;
  /** delete single row from the table: "espin.event_registration" */
  delete_espin_event_registration_by_pk?: Maybe<Espin_Event_Registration>;
  /** delete data from the table: "espin.event_registration_custom_field_entry" */
  delete_espin_event_registration_custom_field_entry?: Maybe<Espin_Event_Registration_Custom_Field_Entry_Mutation_Response>;
  /** delete single row from the table: "espin.event_registration_custom_field_entry" */
  delete_espin_event_registration_custom_field_entry_by_pk?: Maybe<Espin_Event_Registration_Custom_Field_Entry>;
  /** delete data from the table: "espin.event_registration_document_signoff" */
  delete_espin_event_registration_document_signoff?: Maybe<Espin_Event_Registration_Document_Signoff_Mutation_Response>;
  /** delete single row from the table: "espin.event_registration_document_signoff" */
  delete_espin_event_registration_document_signoff_by_pk?: Maybe<Espin_Event_Registration_Document_Signoff>;
  /** delete data from the table: "espin.event_registration_status" */
  delete_espin_event_registration_status?: Maybe<Espin_Event_Registration_Status_Mutation_Response>;
  /** delete single row from the table: "espin.event_registration_status" */
  delete_espin_event_registration_status_by_pk?: Maybe<Espin_Event_Registration_Status>;
  /** delete data from the table: "espin.event_ticket" */
  delete_espin_event_ticket?: Maybe<Espin_Event_Ticket_Mutation_Response>;
  /** delete single row from the table: "espin.event_ticket" */
  delete_espin_event_ticket_by_pk?: Maybe<Espin_Event_Ticket>;
  /** delete data from the table: "espin.event_ticket_type" */
  delete_espin_event_ticket_type?: Maybe<Espin_Event_Ticket_Type_Mutation_Response>;
  /** delete single row from the table: "espin.event_ticket_type" */
  delete_espin_event_ticket_type_by_pk?: Maybe<Espin_Event_Ticket_Type>;
  /** delete data from the table: "espin.event_type" */
  delete_espin_event_type?: Maybe<Espin_Event_Type_Mutation_Response>;
  /** delete single row from the table: "espin.event_type" */
  delete_espin_event_type_by_pk?: Maybe<Espin_Event_Type>;
  /** delete data from the table: "espin.external_provider" */
  delete_espin_external_provider?: Maybe<Espin_External_Provider_Mutation_Response>;
  /** delete single row from the table: "espin.external_provider" */
  delete_espin_external_provider_by_pk?: Maybe<Espin_External_Provider>;
  /** delete data from the table: "espin.external_provider_link" */
  delete_espin_external_provider_link?: Maybe<Espin_External_Provider_Link_Mutation_Response>;
  /** delete single row from the table: "espin.external_provider_link" */
  delete_espin_external_provider_link_by_pk?: Maybe<Espin_External_Provider_Link>;
  /** delete data from the table: "espin.follow" */
  delete_espin_follow?: Maybe<Espin_Follow_Mutation_Response>;
  /** delete single row from the table: "espin.follow" */
  delete_espin_follow_by_pk?: Maybe<Espin_Follow>;
  /** delete data from the table: "espin.follow_type" */
  delete_espin_follow_type?: Maybe<Espin_Follow_Type_Mutation_Response>;
  /** delete single row from the table: "espin.follow_type" */
  delete_espin_follow_type_by_pk?: Maybe<Espin_Follow_Type>;
  /** delete data from the table: "espin.follower_email_notification_type" */
  delete_espin_follower_email_notification_type?: Maybe<Espin_Follower_Email_Notification_Type_Mutation_Response>;
  /** delete single row from the table: "espin.follower_email_notification_type" */
  delete_espin_follower_email_notification_type_by_pk?: Maybe<Espin_Follower_Email_Notification_Type>;
  /** delete data from the table: "espin.force_notification_reload" */
  delete_espin_force_notification_reload?: Maybe<Espin_Force_Notification_Reload_Mutation_Response>;
  /** delete single row from the table: "espin.force_notification_reload" */
  delete_espin_force_notification_reload_by_pk?: Maybe<Espin_Force_Notification_Reload>;
  /** delete data from the table: "espin.game" */
  delete_espin_game?: Maybe<Espin_Game_Mutation_Response>;
  /** delete single row from the table: "espin.game" */
  delete_espin_game_by_pk?: Maybe<Espin_Game>;
  /** delete data from the table: "espin.game_definition" */
  delete_espin_game_definition?: Maybe<Espin_Game_Definition_Mutation_Response>;
  /** delete single row from the table: "espin.game_definition" */
  delete_espin_game_definition_by_pk?: Maybe<Espin_Game_Definition>;
  /** delete data from the table: "espin.game_platform" */
  delete_espin_game_platform?: Maybe<Espin_Game_Platform_Mutation_Response>;
  /** delete single row from the table: "espin.game_platform" */
  delete_espin_game_platform_by_pk?: Maybe<Espin_Game_Platform>;
  /** delete data from the table: "espin.gender_options" */
  delete_espin_gender_options?: Maybe<Espin_Gender_Options_Mutation_Response>;
  /** delete single row from the table: "espin.gender_options" */
  delete_espin_gender_options_by_pk?: Maybe<Espin_Gender_Options>;
  /** delete data from the table: "espin.graduating_class" */
  delete_espin_graduating_class?: Maybe<Espin_Graduating_Class_Mutation_Response>;
  /** delete single row from the table: "espin.graduating_class" */
  delete_espin_graduating_class_by_pk?: Maybe<Espin_Graduating_Class>;
  /** delete data from the table: "espin.high_school" */
  delete_espin_high_school?: Maybe<Espin_High_School_Mutation_Response>;
  /** delete single row from the table: "espin.high_school" */
  delete_espin_high_school_by_pk?: Maybe<Espin_High_School>;
  /** delete data from the table: "espin.high_school_invite" */
  delete_espin_high_school_invite?: Maybe<Espin_High_School_Invite_Mutation_Response>;
  /** delete single row from the table: "espin.high_school_invite" */
  delete_espin_high_school_invite_by_pk?: Maybe<Espin_High_School_Invite>;
  /** delete data from the table: "espin.high_school_profile" */
  delete_espin_high_school_profile?: Maybe<Espin_High_School_Profile_Mutation_Response>;
  /** delete single row from the table: "espin.high_school_profile" */
  delete_espin_high_school_profile_by_pk?: Maybe<Espin_High_School_Profile>;
  /** delete data from the table: "espin.invite_status_type" */
  delete_espin_invite_status_type?: Maybe<Espin_Invite_Status_Type_Mutation_Response>;
  /** delete single row from the table: "espin.invite_status_type" */
  delete_espin_invite_status_type_by_pk?: Maybe<Espin_Invite_Status_Type>;
  /** delete data from the table: "espin.leaderboard" */
  delete_espin_leaderboard?: Maybe<Espin_Leaderboard_Mutation_Response>;
  /** delete single row from the table: "espin.leaderboard" */
  delete_espin_leaderboard_by_pk?: Maybe<Espin_Leaderboard>;
  /** delete data from the table: "espin.membership" */
  delete_espin_membership?: Maybe<Espin_Membership_Mutation_Response>;
  /** delete single row from the table: "espin.membership" */
  delete_espin_membership_by_pk?: Maybe<Espin_Membership>;
  /** delete data from the table: "espin.message" */
  delete_espin_message?: Maybe<Espin_Message_Mutation_Response>;
  /** delete single row from the table: "espin.message" */
  delete_espin_message_by_pk?: Maybe<Espin_Message>;
  /** delete data from the table: "espin.message_email_notification_type" */
  delete_espin_message_email_notification_type?: Maybe<Espin_Message_Email_Notification_Type_Mutation_Response>;
  /** delete single row from the table: "espin.message_email_notification_type" */
  delete_espin_message_email_notification_type_by_pk?: Maybe<Espin_Message_Email_Notification_Type>;
  /** delete data from the table: "espin.message_type" */
  delete_espin_message_type?: Maybe<Espin_Message_Type_Mutation_Response>;
  /** delete single row from the table: "espin.message_type" */
  delete_espin_message_type_by_pk?: Maybe<Espin_Message_Type>;
  /** delete data from the table: "espin.moderation_status" */
  delete_espin_moderation_status?: Maybe<Espin_Moderation_Status_Mutation_Response>;
  /** delete single row from the table: "espin.moderation_status" */
  delete_espin_moderation_status_by_pk?: Maybe<Espin_Moderation_Status>;
  /** delete data from the table: "espin.newsletter_request" */
  delete_espin_newsletter_request?: Maybe<Espin_Newsletter_Request_Mutation_Response>;
  /** delete single row from the table: "espin.newsletter_request" */
  delete_espin_newsletter_request_by_pk?: Maybe<Espin_Newsletter_Request>;
  /** delete data from the table: "espin.notification" */
  delete_espin_notification?: Maybe<Espin_Notification_Mutation_Response>;
  /** delete single row from the table: "espin.notification" */
  delete_espin_notification_by_pk?: Maybe<Espin_Notification>;
  /** delete data from the table: "espin.notification_type" */
  delete_espin_notification_type?: Maybe<Espin_Notification_Type_Mutation_Response>;
  /** delete single row from the table: "espin.notification_type" */
  delete_espin_notification_type_by_pk?: Maybe<Espin_Notification_Type>;
  /** delete data from the table: "espin.org" */
  delete_espin_org?: Maybe<Espin_Org_Mutation_Response>;
  /** delete single row from the table: "espin.org" */
  delete_espin_org_by_pk?: Maybe<Espin_Org>;
  /** delete data from the table: "espin.org_month" */
  delete_espin_org_month?: Maybe<Espin_Org_Month_Mutation_Response>;
  /** delete single row from the table: "espin.org_month" */
  delete_espin_org_month_by_pk?: Maybe<Espin_Org_Month>;
  /** delete data from the table: "espin.org_month_day" */
  delete_espin_org_month_day?: Maybe<Espin_Org_Month_Day_Mutation_Response>;
  /** delete single row from the table: "espin.org_month_day" */
  delete_espin_org_month_day_by_pk?: Maybe<Espin_Org_Month_Day>;
  /** delete data from the table: "espin.org_player" */
  delete_espin_org_player?: Maybe<Espin_Org_Player_Mutation_Response>;
  /** delete single row from the table: "espin.org_player" */
  delete_espin_org_player_by_pk?: Maybe<Espin_Org_Player>;
  /** delete data from the table: "espin.org_school" */
  delete_espin_org_school?: Maybe<Espin_Org_School_Mutation_Response>;
  /** delete single row from the table: "espin.org_school" */
  delete_espin_org_school_by_pk?: Maybe<Espin_Org_School>;
  /** delete data from the table: "espin.org_school_record" */
  delete_espin_org_school_record?: Maybe<Espin_Org_School_Record_Mutation_Response>;
  /** delete single row from the table: "espin.org_school_record" */
  delete_espin_org_school_record_by_pk?: Maybe<Espin_Org_School_Record>;
  /** delete data from the table: "espin.paid_product" */
  delete_espin_paid_product?: Maybe<Espin_Paid_Product_Mutation_Response>;
  /** delete single row from the table: "espin.paid_product" */
  delete_espin_paid_product_by_pk?: Maybe<Espin_Paid_Product>;
  /** delete data from the table: "espin.parent_invite" */
  delete_espin_parent_invite?: Maybe<Espin_Parent_Invite_Mutation_Response>;
  /** delete single row from the table: "espin.parent_invite" */
  delete_espin_parent_invite_by_pk?: Maybe<Espin_Parent_Invite>;
  /** delete data from the table: "espin.parent_profile" */
  delete_espin_parent_profile?: Maybe<Espin_Parent_Profile_Mutation_Response>;
  /** delete single row from the table: "espin.parent_profile" */
  delete_espin_parent_profile_by_pk?: Maybe<Espin_Parent_Profile>;
  /** delete data from the table: "espin.player_game" */
  delete_espin_player_game?: Maybe<Espin_Player_Game_Mutation_Response>;
  /** delete single row from the table: "espin.player_game" */
  delete_espin_player_game_by_pk?: Maybe<Espin_Player_Game>;
  /** delete data from the table: "espin.player_journey" */
  delete_espin_player_journey?: Maybe<Espin_Player_Journey_Mutation_Response>;
  /** delete single row from the table: "espin.player_journey" */
  delete_espin_player_journey_by_pk?: Maybe<Espin_Player_Journey>;
  /** delete data from the table: "espin.player_journey_stage" */
  delete_espin_player_journey_stage?: Maybe<Espin_Player_Journey_Stage_Mutation_Response>;
  /** delete single row from the table: "espin.player_journey_stage" */
  delete_espin_player_journey_stage_by_pk?: Maybe<Espin_Player_Journey_Stage>;
  /** delete data from the table: "espin.player_journey_stage_college" */
  delete_espin_player_journey_stage_college?: Maybe<Espin_Player_Journey_Stage_College_Mutation_Response>;
  /** delete single row from the table: "espin.player_journey_stage_college" */
  delete_espin_player_journey_stage_college_by_pk?: Maybe<Espin_Player_Journey_Stage_College>;
  /** delete data from the table: "espin.player_journey_stage_def" */
  delete_espin_player_journey_stage_def?: Maybe<Espin_Player_Journey_Stage_Def_Mutation_Response>;
  /** delete single row from the table: "espin.player_journey_stage_def" */
  delete_espin_player_journey_stage_def_by_pk?: Maybe<Espin_Player_Journey_Stage_Def>;
  /** delete data from the table: "espin.player_journey_stage_image" */
  delete_espin_player_journey_stage_image?: Maybe<Espin_Player_Journey_Stage_Image_Mutation_Response>;
  /** delete single row from the table: "espin.player_journey_stage_image" */
  delete_espin_player_journey_stage_image_by_pk?: Maybe<Espin_Player_Journey_Stage_Image>;
  /** delete data from the table: "espin.player_journey_stage_quote" */
  delete_espin_player_journey_stage_quote?: Maybe<Espin_Player_Journey_Stage_Quote_Mutation_Response>;
  /** delete single row from the table: "espin.player_journey_stage_quote" */
  delete_espin_player_journey_stage_quote_by_pk?: Maybe<Espin_Player_Journey_Stage_Quote>;
  /** delete data from the table: "espin.player_journey_stage_video" */
  delete_espin_player_journey_stage_video?: Maybe<Espin_Player_Journey_Stage_Video_Mutation_Response>;
  /** delete single row from the table: "espin.player_journey_stage_video" */
  delete_espin_player_journey_stage_video_by_pk?: Maybe<Espin_Player_Journey_Stage_Video>;
  /** delete data from the table: "espin.player_profile" */
  delete_espin_player_profile?: Maybe<Espin_Player_Profile_Mutation_Response>;
  /** delete single row from the table: "espin.player_profile" */
  delete_espin_player_profile_by_pk?: Maybe<Espin_Player_Profile>;
  /** delete data from the table: "espin.player_subscription" */
  delete_espin_player_subscription?: Maybe<Espin_Player_Subscription_Mutation_Response>;
  /** delete single row from the table: "espin.player_subscription" */
  delete_espin_player_subscription_by_pk?: Maybe<Espin_Player_Subscription>;
  /** delete data from the table: "espin.player_vod" */
  delete_espin_player_vod?: Maybe<Espin_Player_Vod_Mutation_Response>;
  /** delete single row from the table: "espin.player_vod" */
  delete_espin_player_vod_by_pk?: Maybe<Espin_Player_Vod>;
  /** delete data from the table: "espin.profile_view" */
  delete_espin_profile_view?: Maybe<Espin_Profile_View_Mutation_Response>;
  /** delete single row from the table: "espin.profile_view" */
  delete_espin_profile_view_by_pk?: Maybe<Espin_Profile_View>;
  /** delete data from the table: "espin.profile_view_email_notification_type" */
  delete_espin_profile_view_email_notification_type?: Maybe<Espin_Profile_View_Email_Notification_Type_Mutation_Response>;
  /** delete single row from the table: "espin.profile_view_email_notification_type" */
  delete_espin_profile_view_email_notification_type_by_pk?: Maybe<Espin_Profile_View_Email_Notification_Type>;
  /** delete data from the table: "espin.profile_view_type" */
  delete_espin_profile_view_type?: Maybe<Espin_Profile_View_Type_Mutation_Response>;
  /** delete single row from the table: "espin.profile_view_type" */
  delete_espin_profile_view_type_by_pk?: Maybe<Espin_Profile_View_Type>;
  /** delete data from the table: "espin.referral_code" */
  delete_espin_referral_code?: Maybe<Espin_Referral_Code_Mutation_Response>;
  /** delete single row from the table: "espin.referral_code" */
  delete_espin_referral_code_by_pk?: Maybe<Espin_Referral_Code>;
  /** delete data from the table: "espin.referral_code_redemption" */
  delete_espin_referral_code_redemption?: Maybe<Espin_Referral_Code_Redemption_Mutation_Response>;
  /** delete single row from the table: "espin.referral_code_redemption" */
  delete_espin_referral_code_redemption_by_pk?: Maybe<Espin_Referral_Code_Redemption>;
  /** delete data from the table: "espin.referral_option" */
  delete_espin_referral_option?: Maybe<Espin_Referral_Option_Mutation_Response>;
  /** delete single row from the table: "espin.referral_option" */
  delete_espin_referral_option_by_pk?: Maybe<Espin_Referral_Option>;
  /** delete data from the table: "espin.role" */
  delete_espin_role?: Maybe<Espin_Role_Mutation_Response>;
  /** delete single row from the table: "espin.role" */
  delete_espin_role_by_pk?: Maybe<Espin_Role>;
  /** delete data from the table: "espin.site_content" */
  delete_espin_site_content?: Maybe<Espin_Site_Content_Mutation_Response>;
  /** delete single row from the table: "espin.site_content" */
  delete_espin_site_content_by_pk?: Maybe<Espin_Site_Content>;
  /** delete data from the table: "espin.social" */
  delete_espin_social?: Maybe<Espin_Social_Mutation_Response>;
  /** delete single row from the table: "espin.social" */
  delete_espin_social_by_pk?: Maybe<Espin_Social>;
  /** delete data from the table: "espin.stickied_college" */
  delete_espin_stickied_college?: Maybe<Espin_Stickied_College_Mutation_Response>;
  /** delete single row from the table: "espin.stickied_college" */
  delete_espin_stickied_college_by_pk?: Maybe<Espin_Stickied_College>;
  /** delete data from the table: "espin.stickied_player" */
  delete_espin_stickied_player?: Maybe<Espin_Stickied_Player_Mutation_Response>;
  /** delete single row from the table: "espin.stickied_player" */
  delete_espin_stickied_player_by_pk?: Maybe<Espin_Stickied_Player>;
  /** delete data from the table: "espin.study_field" */
  delete_espin_study_field?: Maybe<Espin_Study_Field_Mutation_Response>;
  /** delete single row from the table: "espin.study_field" */
  delete_espin_study_field_by_pk?: Maybe<Espin_Study_Field>;
  /** delete data from the table: "espin.study_subject" */
  delete_espin_study_subject?: Maybe<Espin_Study_Subject_Mutation_Response>;
  /** delete single row from the table: "espin.study_subject" */
  delete_espin_study_subject_by_pk?: Maybe<Espin_Study_Subject>;
  /** delete data from the table: "espin.subscription_status" */
  delete_espin_subscription_status?: Maybe<Espin_Subscription_Status_Mutation_Response>;
  /** delete single row from the table: "espin.subscription_status" */
  delete_espin_subscription_status_by_pk?: Maybe<Espin_Subscription_Status>;
  /** delete data from the table: "espin.subscription_tier_type" */
  delete_espin_subscription_tier_type?: Maybe<Espin_Subscription_Tier_Type_Mutation_Response>;
  /** delete single row from the table: "espin.subscription_tier_type" */
  delete_espin_subscription_tier_type_by_pk?: Maybe<Espin_Subscription_Tier_Type>;
  /** delete data from the table: "espin.team" */
  delete_espin_team?: Maybe<Espin_Team_Mutation_Response>;
  /** delete single row from the table: "espin.team" */
  delete_espin_team_by_pk?: Maybe<Espin_Team>;
  /** delete data from the table: "espin.team_invite" */
  delete_espin_team_invite?: Maybe<Espin_Team_Invite_Mutation_Response>;
  /** delete single row from the table: "espin.team_invite" */
  delete_espin_team_invite_by_pk?: Maybe<Espin_Team_Invite>;
  /** delete data from the table: "espin.team_members" */
  delete_espin_team_members?: Maybe<Espin_Team_Members_Mutation_Response>;
  /** delete single row from the table: "espin.team_members" */
  delete_espin_team_members_by_pk?: Maybe<Espin_Team_Members>;
  /** delete data from the table: "espin.team_role" */
  delete_espin_team_role?: Maybe<Espin_Team_Role_Mutation_Response>;
  /** delete single row from the table: "espin.team_role" */
  delete_espin_team_role_by_pk?: Maybe<Espin_Team_Role>;
  /** delete data from the table: "espin.team_type" */
  delete_espin_team_type?: Maybe<Espin_Team_Type_Mutation_Response>;
  /** delete single row from the table: "espin.team_type" */
  delete_espin_team_type_by_pk?: Maybe<Espin_Team_Type>;
  /** delete data from the table: "espin.unregistered_college" */
  delete_espin_unregistered_college?: Maybe<Espin_Unregistered_College_Mutation_Response>;
  /** delete single row from the table: "espin.unregistered_college" */
  delete_espin_unregistered_college_by_pk?: Maybe<Espin_Unregistered_College>;
  /** delete data from the table: "espin.user" */
  delete_espin_user?: Maybe<Espin_User_Mutation_Response>;
  /** delete single row from the table: "espin.user" */
  delete_espin_user_by_pk?: Maybe<Espin_User>;
  /** delete data from the table: "espin.user_linked_external_provider" */
  delete_espin_user_linked_external_provider?: Maybe<Espin_User_Linked_External_Provider_Mutation_Response>;
  /** delete single row from the table: "espin.user_linked_external_provider" */
  delete_espin_user_linked_external_provider_by_pk?: Maybe<Espin_User_Linked_External_Provider>;
  /** delete data from the table: "espin.user_membership" */
  delete_espin_user_membership?: Maybe<Espin_User_Membership_Mutation_Response>;
  /** delete single row from the table: "espin.user_membership" */
  delete_espin_user_membership_by_pk?: Maybe<Espin_User_Membership>;
  /** delete data from the table: "espin.user_source" */
  delete_espin_user_source?: Maybe<Espin_User_Source_Mutation_Response>;
  /** delete single row from the table: "espin.user_source" */
  delete_espin_user_source_by_pk?: Maybe<Espin_User_Source>;
  /** delete data from the table: "queue.job" */
  delete_queue_job?: Maybe<Queue_Job_Mutation_Response>;
  /** delete single row from the table: "queue.job" */
  delete_queue_job_by_pk?: Maybe<Queue_Job>;
  /** delete data from the table: "queue.job_status_type" */
  delete_queue_job_status_type?: Maybe<Queue_Job_Status_Type_Mutation_Response>;
  /** delete single row from the table: "queue.job_status_type" */
  delete_queue_job_status_type_by_pk?: Maybe<Queue_Job_Status_Type>;
  /** delete data from the table: "queue.job_type" */
  delete_queue_job_type?: Maybe<Queue_Job_Type_Mutation_Response>;
  /** delete single row from the table: "queue.job_type" */
  delete_queue_job_type_by_pk?: Maybe<Queue_Job_Type>;
  /** delete data from the table: "stripe.customer_data" */
  delete_stripe_customer_data?: Maybe<Stripe_Customer_Data_Mutation_Response>;
  /** delete single row from the table: "stripe.customer_data" */
  delete_stripe_customer_data_by_pk?: Maybe<Stripe_Customer_Data>;
  /** delete data from the table: "stripe.invoice_data" */
  delete_stripe_invoice_data?: Maybe<Stripe_Invoice_Data_Mutation_Response>;
  /** delete single row from the table: "stripe.invoice_data" */
  delete_stripe_invoice_data_by_pk?: Maybe<Stripe_Invoice_Data>;
  /** delete data from the table: "stripe.stripe_payment_data" */
  delete_stripe_stripe_payment_data?: Maybe<Stripe_Stripe_Payment_Data_Mutation_Response>;
  /** delete single row from the table: "stripe.stripe_payment_data" */
  delete_stripe_stripe_payment_data_by_pk?: Maybe<Stripe_Stripe_Payment_Data>;
  /** delete data from the table: "stripe.stripe_subscription_data" */
  delete_stripe_stripe_subscription_data?: Maybe<Stripe_Stripe_Subscription_Data_Mutation_Response>;
  /** delete single row from the table: "stripe.stripe_subscription_data" */
  delete_stripe_stripe_subscription_data_by_pk?: Maybe<Stripe_Stripe_Subscription_Data>;
  /** delete data from the table: "tempstorage.keyvalue" */
  delete_tempstorage_keyvalue?: Maybe<Tempstorage_Keyvalue_Mutation_Response>;
  /** delete single row from the table: "tempstorage.keyvalue" */
  delete_tempstorage_keyvalue_by_pk?: Maybe<Tempstorage_Keyvalue>;
  /** Action for a HS to edit a team (since it can be usernames OR emails) */
  editHighSchoolTeam?: Maybe<EditHighSchoolTeamOutput>;
  /** editPlayerTeam */
  editPlayerTeam?: Maybe<EditPlayerTeamOutput>;
  generatePasswordResetEmail?: Maybe<PasswordResetOutput>;
  /** insert data into the table: "cehsite.ms_available_site_terms" */
  insert_cehsite_ms_available_site_terms?: Maybe<Cehsite_Ms_Available_Site_Terms_Mutation_Response>;
  /** insert a single row into the table: "cehsite.ms_available_site_terms" */
  insert_cehsite_ms_available_site_terms_one?: Maybe<Cehsite_Ms_Available_Site_Terms>;
  /** insert data into the table: "cehsite.ms_contact_form_entry" */
  insert_cehsite_ms_contact_form_entry?: Maybe<Cehsite_Ms_Contact_Form_Entry_Mutation_Response>;
  /** insert a single row into the table: "cehsite.ms_contact_form_entry" */
  insert_cehsite_ms_contact_form_entry_one?: Maybe<Cehsite_Ms_Contact_Form_Entry>;
  /** insert data into the table: "cehsite.ms_newsletter_signup" */
  insert_cehsite_ms_newsletter_signup?: Maybe<Cehsite_Ms_Newsletter_Signup_Mutation_Response>;
  /** insert a single row into the table: "cehsite.ms_newsletter_signup" */
  insert_cehsite_ms_newsletter_signup_one?: Maybe<Cehsite_Ms_Newsletter_Signup>;
  /** insert data into the table: "cehsite.ms_site_content" */
  insert_cehsite_ms_site_content?: Maybe<Cehsite_Ms_Site_Content_Mutation_Response>;
  /** insert a single row into the table: "cehsite.ms_site_content" */
  insert_cehsite_ms_site_content_one?: Maybe<Cehsite_Ms_Site_Content>;
  /** insert data into the table: "content.file" */
  insert_content_file?: Maybe<Content_File_Mutation_Response>;
  /** insert data into the table: "content.file_metadata" */
  insert_content_file_metadata?: Maybe<Content_File_Metadata_Mutation_Response>;
  /** insert a single row into the table: "content.file_metadata" */
  insert_content_file_metadata_one?: Maybe<Content_File_Metadata>;
  /** insert a single row into the table: "content.file" */
  insert_content_file_one?: Maybe<Content_File>;
  /** insert data into the table: "content.file_status" */
  insert_content_file_status?: Maybe<Content_File_Status_Mutation_Response>;
  /** insert a single row into the table: "content.file_status" */
  insert_content_file_status_one?: Maybe<Content_File_Status>;
  /** insert data into the table: "content.media_link" */
  insert_content_media_link?: Maybe<Content_Media_Link_Mutation_Response>;
  /** insert a single row into the table: "content.media_link" */
  insert_content_media_link_one?: Maybe<Content_Media_Link>;
  /** insert data into the table: "content.media_link_type" */
  insert_content_media_link_type?: Maybe<Content_Media_Link_Type_Mutation_Response>;
  /** insert a single row into the table: "content.media_link_type" */
  insert_content_media_link_type_one?: Maybe<Content_Media_Link_Type>;
  /** insert data into the table: "content.project_name" */
  insert_content_project_name?: Maybe<Content_Project_Name_Mutation_Response>;
  /** insert a single row into the table: "content.project_name" */
  insert_content_project_name_one?: Maybe<Content_Project_Name>;
  /** insert data into the table: "content.status" */
  insert_content_status?: Maybe<Content_Status_Mutation_Response>;
  /** insert a single row into the table: "content.status" */
  insert_content_status_one?: Maybe<Content_Status>;
  /** insert data into the table: "espin.address" */
  insert_espin_address?: Maybe<Espin_Address_Mutation_Response>;
  /** insert a single row into the table: "espin.address" */
  insert_espin_address_one?: Maybe<Espin_Address>;
  /** insert data into the table: "espin.boolean_feature_flag" */
  insert_espin_boolean_feature_flag?: Maybe<Espin_Boolean_Feature_Flag_Mutation_Response>;
  /** insert a single row into the table: "espin.boolean_feature_flag" */
  insert_espin_boolean_feature_flag_one?: Maybe<Espin_Boolean_Feature_Flag>;
  /** insert data into the table: "espin.coach_profile" */
  insert_espin_coach_profile?: Maybe<Espin_Coach_Profile_Mutation_Response>;
  /** insert a single row into the table: "espin.coach_profile" */
  insert_espin_coach_profile_one?: Maybe<Espin_Coach_Profile>;
  /** insert data into the table: "espin.college" */
  insert_espin_college?: Maybe<Espin_College_Mutation_Response>;
  /** insert data into the table: "espin.college_automatic_message_response_type" */
  insert_espin_college_automatic_message_response_type?: Maybe<Espin_College_Automatic_Message_Response_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.college_automatic_message_response_type" */
  insert_espin_college_automatic_message_response_type_one?: Maybe<Espin_College_Automatic_Message_Response_Type>;
  /** insert data into the table: "espin.college_game" */
  insert_espin_college_game?: Maybe<Espin_College_Game_Mutation_Response>;
  /** insert a single row into the table: "espin.college_game" */
  insert_espin_college_game_one?: Maybe<Espin_College_Game>;
  /** insert data into the table: "espin.college_image" */
  insert_espin_college_image?: Maybe<Espin_College_Image_Mutation_Response>;
  /** insert a single row into the table: "espin.college_image" */
  insert_espin_college_image_one?: Maybe<Espin_College_Image>;
  /** insert data into the table: "espin.college_invite" */
  insert_espin_college_invite?: Maybe<Espin_College_Invite_Mutation_Response>;
  /** insert a single row into the table: "espin.college_invite" */
  insert_espin_college_invite_one?: Maybe<Espin_College_Invite>;
  /** insert a single row into the table: "espin.college" */
  insert_espin_college_one?: Maybe<Espin_College>;
  /** insert data into the table: "espin.college_preferences" */
  insert_espin_college_preferences?: Maybe<Espin_College_Preferences_Mutation_Response>;
  /** insert a single row into the table: "espin.college_preferences" */
  insert_espin_college_preferences_one?: Maybe<Espin_College_Preferences>;
  /** insert data into the table: "espin.college_profile" */
  insert_espin_college_profile?: Maybe<Espin_College_Profile_Mutation_Response>;
  /** insert a single row into the table: "espin.college_profile" */
  insert_espin_college_profile_one?: Maybe<Espin_College_Profile>;
  /** insert data into the table: "espin.college_roster" */
  insert_espin_college_roster?: Maybe<Espin_College_Roster_Mutation_Response>;
  /** insert a single row into the table: "espin.college_roster" */
  insert_espin_college_roster_one?: Maybe<Espin_College_Roster>;
  /** insert data into the table: "espin.college_staff_member" */
  insert_espin_college_staff_member?: Maybe<Espin_College_Staff_Member_Mutation_Response>;
  /** insert a single row into the table: "espin.college_staff_member" */
  insert_espin_college_staff_member_one?: Maybe<Espin_College_Staff_Member>;
  /** insert data into the table: "espin.college_subscription" */
  insert_espin_college_subscription?: Maybe<Espin_College_Subscription_Mutation_Response>;
  /** insert a single row into the table: "espin.college_subscription" */
  insert_espin_college_subscription_one?: Maybe<Espin_College_Subscription>;
  /** insert data into the table: "espin.college_verification_status_type" */
  insert_espin_college_verification_status_type?: Maybe<Espin_College_Verification_Status_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.college_verification_status_type" */
  insert_espin_college_verification_status_type_one?: Maybe<Espin_College_Verification_Status_Type>;
  /** insert data into the table: "espin.draft_player_profile" */
  insert_espin_draft_player_profile?: Maybe<Espin_Draft_Player_Profile_Mutation_Response>;
  /** insert a single row into the table: "espin.draft_player_profile" */
  insert_espin_draft_player_profile_one?: Maybe<Espin_Draft_Player_Profile>;
  /** insert data into the table: "espin.editable_site_content" */
  insert_espin_editable_site_content?: Maybe<Espin_Editable_Site_Content_Mutation_Response>;
  /** insert a single row into the table: "espin.editable_site_content" */
  insert_espin_editable_site_content_one?: Maybe<Espin_Editable_Site_Content>;
  /** insert data into the table: "espin.ethnicity_options" */
  insert_espin_ethnicity_options?: Maybe<Espin_Ethnicity_Options_Mutation_Response>;
  /** insert a single row into the table: "espin.ethnicity_options" */
  insert_espin_ethnicity_options_one?: Maybe<Espin_Ethnicity_Options>;
  /** insert data into the table: "espin.event" */
  insert_espin_event?: Maybe<Espin_Event_Mutation_Response>;
  /** insert data into the table: "espin.event_custom_field" */
  insert_espin_event_custom_field?: Maybe<Espin_Event_Custom_Field_Mutation_Response>;
  /** insert a single row into the table: "espin.event_custom_field" */
  insert_espin_event_custom_field_one?: Maybe<Espin_Event_Custom_Field>;
  /** insert data into the table: "espin.event_custom_field_type" */
  insert_espin_event_custom_field_type?: Maybe<Espin_Event_Custom_Field_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.event_custom_field_type" */
  insert_espin_event_custom_field_type_one?: Maybe<Espin_Event_Custom_Field_Type>;
  /** insert data into the table: "espin.event_document" */
  insert_espin_event_document?: Maybe<Espin_Event_Document_Mutation_Response>;
  /** insert a single row into the table: "espin.event_document" */
  insert_espin_event_document_one?: Maybe<Espin_Event_Document>;
  /** insert data into the table: "espin.event_game" */
  insert_espin_event_game?: Maybe<Espin_Event_Game_Mutation_Response>;
  /** insert a single row into the table: "espin.event_game" */
  insert_espin_event_game_one?: Maybe<Espin_Event_Game>;
  /** insert a single row into the table: "espin.event" */
  insert_espin_event_one?: Maybe<Espin_Event>;
  /** insert data into the table: "espin.event_registration" */
  insert_espin_event_registration?: Maybe<Espin_Event_Registration_Mutation_Response>;
  /** insert data into the table: "espin.event_registration_custom_field_entry" */
  insert_espin_event_registration_custom_field_entry?: Maybe<Espin_Event_Registration_Custom_Field_Entry_Mutation_Response>;
  /** insert a single row into the table: "espin.event_registration_custom_field_entry" */
  insert_espin_event_registration_custom_field_entry_one?: Maybe<Espin_Event_Registration_Custom_Field_Entry>;
  /** insert data into the table: "espin.event_registration_document_signoff" */
  insert_espin_event_registration_document_signoff?: Maybe<Espin_Event_Registration_Document_Signoff_Mutation_Response>;
  /** insert a single row into the table: "espin.event_registration_document_signoff" */
  insert_espin_event_registration_document_signoff_one?: Maybe<Espin_Event_Registration_Document_Signoff>;
  /** insert a single row into the table: "espin.event_registration" */
  insert_espin_event_registration_one?: Maybe<Espin_Event_Registration>;
  /** insert data into the table: "espin.event_registration_status" */
  insert_espin_event_registration_status?: Maybe<Espin_Event_Registration_Status_Mutation_Response>;
  /** insert a single row into the table: "espin.event_registration_status" */
  insert_espin_event_registration_status_one?: Maybe<Espin_Event_Registration_Status>;
  /** insert data into the table: "espin.event_ticket" */
  insert_espin_event_ticket?: Maybe<Espin_Event_Ticket_Mutation_Response>;
  /** insert a single row into the table: "espin.event_ticket" */
  insert_espin_event_ticket_one?: Maybe<Espin_Event_Ticket>;
  /** insert data into the table: "espin.event_ticket_type" */
  insert_espin_event_ticket_type?: Maybe<Espin_Event_Ticket_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.event_ticket_type" */
  insert_espin_event_ticket_type_one?: Maybe<Espin_Event_Ticket_Type>;
  /** insert data into the table: "espin.event_type" */
  insert_espin_event_type?: Maybe<Espin_Event_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.event_type" */
  insert_espin_event_type_one?: Maybe<Espin_Event_Type>;
  /** insert data into the table: "espin.external_provider" */
  insert_espin_external_provider?: Maybe<Espin_External_Provider_Mutation_Response>;
  /** insert data into the table: "espin.external_provider_link" */
  insert_espin_external_provider_link?: Maybe<Espin_External_Provider_Link_Mutation_Response>;
  /** insert a single row into the table: "espin.external_provider_link" */
  insert_espin_external_provider_link_one?: Maybe<Espin_External_Provider_Link>;
  /** insert a single row into the table: "espin.external_provider" */
  insert_espin_external_provider_one?: Maybe<Espin_External_Provider>;
  /** insert data into the table: "espin.follow" */
  insert_espin_follow?: Maybe<Espin_Follow_Mutation_Response>;
  /** insert a single row into the table: "espin.follow" */
  insert_espin_follow_one?: Maybe<Espin_Follow>;
  /** insert data into the table: "espin.follow_type" */
  insert_espin_follow_type?: Maybe<Espin_Follow_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.follow_type" */
  insert_espin_follow_type_one?: Maybe<Espin_Follow_Type>;
  /** insert data into the table: "espin.follower_email_notification_type" */
  insert_espin_follower_email_notification_type?: Maybe<Espin_Follower_Email_Notification_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.follower_email_notification_type" */
  insert_espin_follower_email_notification_type_one?: Maybe<Espin_Follower_Email_Notification_Type>;
  /** insert data into the table: "espin.force_notification_reload" */
  insert_espin_force_notification_reload?: Maybe<Espin_Force_Notification_Reload_Mutation_Response>;
  /** insert a single row into the table: "espin.force_notification_reload" */
  insert_espin_force_notification_reload_one?: Maybe<Espin_Force_Notification_Reload>;
  /** insert data into the table: "espin.game" */
  insert_espin_game?: Maybe<Espin_Game_Mutation_Response>;
  /** insert data into the table: "espin.game_definition" */
  insert_espin_game_definition?: Maybe<Espin_Game_Definition_Mutation_Response>;
  /** insert a single row into the table: "espin.game_definition" */
  insert_espin_game_definition_one?: Maybe<Espin_Game_Definition>;
  /** insert a single row into the table: "espin.game" */
  insert_espin_game_one?: Maybe<Espin_Game>;
  /** insert data into the table: "espin.game_platform" */
  insert_espin_game_platform?: Maybe<Espin_Game_Platform_Mutation_Response>;
  /** insert a single row into the table: "espin.game_platform" */
  insert_espin_game_platform_one?: Maybe<Espin_Game_Platform>;
  /** insert data into the table: "espin.gender_options" */
  insert_espin_gender_options?: Maybe<Espin_Gender_Options_Mutation_Response>;
  /** insert a single row into the table: "espin.gender_options" */
  insert_espin_gender_options_one?: Maybe<Espin_Gender_Options>;
  /** insert data into the table: "espin.graduating_class" */
  insert_espin_graduating_class?: Maybe<Espin_Graduating_Class_Mutation_Response>;
  /** insert a single row into the table: "espin.graduating_class" */
  insert_espin_graduating_class_one?: Maybe<Espin_Graduating_Class>;
  /** insert data into the table: "espin.high_school" */
  insert_espin_high_school?: Maybe<Espin_High_School_Mutation_Response>;
  /** insert data into the table: "espin.high_school_invite" */
  insert_espin_high_school_invite?: Maybe<Espin_High_School_Invite_Mutation_Response>;
  /** insert a single row into the table: "espin.high_school_invite" */
  insert_espin_high_school_invite_one?: Maybe<Espin_High_School_Invite>;
  /** insert a single row into the table: "espin.high_school" */
  insert_espin_high_school_one?: Maybe<Espin_High_School>;
  /** insert data into the table: "espin.high_school_profile" */
  insert_espin_high_school_profile?: Maybe<Espin_High_School_Profile_Mutation_Response>;
  /** insert a single row into the table: "espin.high_school_profile" */
  insert_espin_high_school_profile_one?: Maybe<Espin_High_School_Profile>;
  /** insert data into the table: "espin.invite_status_type" */
  insert_espin_invite_status_type?: Maybe<Espin_Invite_Status_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.invite_status_type" */
  insert_espin_invite_status_type_one?: Maybe<Espin_Invite_Status_Type>;
  /** insert data into the table: "espin.leaderboard" */
  insert_espin_leaderboard?: Maybe<Espin_Leaderboard_Mutation_Response>;
  /** insert a single row into the table: "espin.leaderboard" */
  insert_espin_leaderboard_one?: Maybe<Espin_Leaderboard>;
  /** insert data into the table: "espin.membership" */
  insert_espin_membership?: Maybe<Espin_Membership_Mutation_Response>;
  /** insert a single row into the table: "espin.membership" */
  insert_espin_membership_one?: Maybe<Espin_Membership>;
  /** insert data into the table: "espin.message" */
  insert_espin_message?: Maybe<Espin_Message_Mutation_Response>;
  /** insert data into the table: "espin.message_email_notification_type" */
  insert_espin_message_email_notification_type?: Maybe<Espin_Message_Email_Notification_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.message_email_notification_type" */
  insert_espin_message_email_notification_type_one?: Maybe<Espin_Message_Email_Notification_Type>;
  /** insert a single row into the table: "espin.message" */
  insert_espin_message_one?: Maybe<Espin_Message>;
  /** insert data into the table: "espin.message_type" */
  insert_espin_message_type?: Maybe<Espin_Message_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.message_type" */
  insert_espin_message_type_one?: Maybe<Espin_Message_Type>;
  /** insert data into the table: "espin.moderation_status" */
  insert_espin_moderation_status?: Maybe<Espin_Moderation_Status_Mutation_Response>;
  /** insert a single row into the table: "espin.moderation_status" */
  insert_espin_moderation_status_one?: Maybe<Espin_Moderation_Status>;
  /** insert data into the table: "espin.newsletter_request" */
  insert_espin_newsletter_request?: Maybe<Espin_Newsletter_Request_Mutation_Response>;
  /** insert a single row into the table: "espin.newsletter_request" */
  insert_espin_newsletter_request_one?: Maybe<Espin_Newsletter_Request>;
  /** insert data into the table: "espin.notification" */
  insert_espin_notification?: Maybe<Espin_Notification_Mutation_Response>;
  /** insert a single row into the table: "espin.notification" */
  insert_espin_notification_one?: Maybe<Espin_Notification>;
  /** insert data into the table: "espin.notification_type" */
  insert_espin_notification_type?: Maybe<Espin_Notification_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.notification_type" */
  insert_espin_notification_type_one?: Maybe<Espin_Notification_Type>;
  /** insert data into the table: "espin.org" */
  insert_espin_org?: Maybe<Espin_Org_Mutation_Response>;
  /** insert data into the table: "espin.org_month" */
  insert_espin_org_month?: Maybe<Espin_Org_Month_Mutation_Response>;
  /** insert data into the table: "espin.org_month_day" */
  insert_espin_org_month_day?: Maybe<Espin_Org_Month_Day_Mutation_Response>;
  /** insert a single row into the table: "espin.org_month_day" */
  insert_espin_org_month_day_one?: Maybe<Espin_Org_Month_Day>;
  /** insert a single row into the table: "espin.org_month" */
  insert_espin_org_month_one?: Maybe<Espin_Org_Month>;
  /** insert a single row into the table: "espin.org" */
  insert_espin_org_one?: Maybe<Espin_Org>;
  /** insert data into the table: "espin.org_player" */
  insert_espin_org_player?: Maybe<Espin_Org_Player_Mutation_Response>;
  /** insert a single row into the table: "espin.org_player" */
  insert_espin_org_player_one?: Maybe<Espin_Org_Player>;
  /** insert data into the table: "espin.org_school" */
  insert_espin_org_school?: Maybe<Espin_Org_School_Mutation_Response>;
  /** insert a single row into the table: "espin.org_school" */
  insert_espin_org_school_one?: Maybe<Espin_Org_School>;
  /** insert data into the table: "espin.org_school_record" */
  insert_espin_org_school_record?: Maybe<Espin_Org_School_Record_Mutation_Response>;
  /** insert a single row into the table: "espin.org_school_record" */
  insert_espin_org_school_record_one?: Maybe<Espin_Org_School_Record>;
  /** insert data into the table: "espin.paid_product" */
  insert_espin_paid_product?: Maybe<Espin_Paid_Product_Mutation_Response>;
  /** insert a single row into the table: "espin.paid_product" */
  insert_espin_paid_product_one?: Maybe<Espin_Paid_Product>;
  /** insert data into the table: "espin.parent_invite" */
  insert_espin_parent_invite?: Maybe<Espin_Parent_Invite_Mutation_Response>;
  /** insert a single row into the table: "espin.parent_invite" */
  insert_espin_parent_invite_one?: Maybe<Espin_Parent_Invite>;
  /** insert data into the table: "espin.parent_profile" */
  insert_espin_parent_profile?: Maybe<Espin_Parent_Profile_Mutation_Response>;
  /** insert a single row into the table: "espin.parent_profile" */
  insert_espin_parent_profile_one?: Maybe<Espin_Parent_Profile>;
  /** insert data into the table: "espin.player_game" */
  insert_espin_player_game?: Maybe<Espin_Player_Game_Mutation_Response>;
  /** insert a single row into the table: "espin.player_game" */
  insert_espin_player_game_one?: Maybe<Espin_Player_Game>;
  /** insert data into the table: "espin.player_journey" */
  insert_espin_player_journey?: Maybe<Espin_Player_Journey_Mutation_Response>;
  /** insert a single row into the table: "espin.player_journey" */
  insert_espin_player_journey_one?: Maybe<Espin_Player_Journey>;
  /** insert data into the table: "espin.player_journey_stage" */
  insert_espin_player_journey_stage?: Maybe<Espin_Player_Journey_Stage_Mutation_Response>;
  /** insert data into the table: "espin.player_journey_stage_college" */
  insert_espin_player_journey_stage_college?: Maybe<Espin_Player_Journey_Stage_College_Mutation_Response>;
  /** insert a single row into the table: "espin.player_journey_stage_college" */
  insert_espin_player_journey_stage_college_one?: Maybe<Espin_Player_Journey_Stage_College>;
  /** insert data into the table: "espin.player_journey_stage_def" */
  insert_espin_player_journey_stage_def?: Maybe<Espin_Player_Journey_Stage_Def_Mutation_Response>;
  /** insert a single row into the table: "espin.player_journey_stage_def" */
  insert_espin_player_journey_stage_def_one?: Maybe<Espin_Player_Journey_Stage_Def>;
  /** insert data into the table: "espin.player_journey_stage_image" */
  insert_espin_player_journey_stage_image?: Maybe<Espin_Player_Journey_Stage_Image_Mutation_Response>;
  /** insert a single row into the table: "espin.player_journey_stage_image" */
  insert_espin_player_journey_stage_image_one?: Maybe<Espin_Player_Journey_Stage_Image>;
  /** insert a single row into the table: "espin.player_journey_stage" */
  insert_espin_player_journey_stage_one?: Maybe<Espin_Player_Journey_Stage>;
  /** insert data into the table: "espin.player_journey_stage_quote" */
  insert_espin_player_journey_stage_quote?: Maybe<Espin_Player_Journey_Stage_Quote_Mutation_Response>;
  /** insert a single row into the table: "espin.player_journey_stage_quote" */
  insert_espin_player_journey_stage_quote_one?: Maybe<Espin_Player_Journey_Stage_Quote>;
  /** insert data into the table: "espin.player_journey_stage_video" */
  insert_espin_player_journey_stage_video?: Maybe<Espin_Player_Journey_Stage_Video_Mutation_Response>;
  /** insert a single row into the table: "espin.player_journey_stage_video" */
  insert_espin_player_journey_stage_video_one?: Maybe<Espin_Player_Journey_Stage_Video>;
  /** insert data into the table: "espin.player_profile" */
  insert_espin_player_profile?: Maybe<Espin_Player_Profile_Mutation_Response>;
  /** insert a single row into the table: "espin.player_profile" */
  insert_espin_player_profile_one?: Maybe<Espin_Player_Profile>;
  /** insert data into the table: "espin.player_subscription" */
  insert_espin_player_subscription?: Maybe<Espin_Player_Subscription_Mutation_Response>;
  /** insert a single row into the table: "espin.player_subscription" */
  insert_espin_player_subscription_one?: Maybe<Espin_Player_Subscription>;
  /** insert data into the table: "espin.player_vod" */
  insert_espin_player_vod?: Maybe<Espin_Player_Vod_Mutation_Response>;
  /** insert a single row into the table: "espin.player_vod" */
  insert_espin_player_vod_one?: Maybe<Espin_Player_Vod>;
  /** insert data into the table: "espin.profile_view" */
  insert_espin_profile_view?: Maybe<Espin_Profile_View_Mutation_Response>;
  /** insert data into the table: "espin.profile_view_email_notification_type" */
  insert_espin_profile_view_email_notification_type?: Maybe<Espin_Profile_View_Email_Notification_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.profile_view_email_notification_type" */
  insert_espin_profile_view_email_notification_type_one?: Maybe<Espin_Profile_View_Email_Notification_Type>;
  /** insert a single row into the table: "espin.profile_view" */
  insert_espin_profile_view_one?: Maybe<Espin_Profile_View>;
  /** insert data into the table: "espin.profile_view_type" */
  insert_espin_profile_view_type?: Maybe<Espin_Profile_View_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.profile_view_type" */
  insert_espin_profile_view_type_one?: Maybe<Espin_Profile_View_Type>;
  /** insert data into the table: "espin.referral_code" */
  insert_espin_referral_code?: Maybe<Espin_Referral_Code_Mutation_Response>;
  /** insert a single row into the table: "espin.referral_code" */
  insert_espin_referral_code_one?: Maybe<Espin_Referral_Code>;
  /** insert data into the table: "espin.referral_code_redemption" */
  insert_espin_referral_code_redemption?: Maybe<Espin_Referral_Code_Redemption_Mutation_Response>;
  /** insert a single row into the table: "espin.referral_code_redemption" */
  insert_espin_referral_code_redemption_one?: Maybe<Espin_Referral_Code_Redemption>;
  /** insert data into the table: "espin.referral_option" */
  insert_espin_referral_option?: Maybe<Espin_Referral_Option_Mutation_Response>;
  /** insert a single row into the table: "espin.referral_option" */
  insert_espin_referral_option_one?: Maybe<Espin_Referral_Option>;
  /** insert data into the table: "espin.role" */
  insert_espin_role?: Maybe<Espin_Role_Mutation_Response>;
  /** insert a single row into the table: "espin.role" */
  insert_espin_role_one?: Maybe<Espin_Role>;
  /** insert data into the table: "espin.site_content" */
  insert_espin_site_content?: Maybe<Espin_Site_Content_Mutation_Response>;
  /** insert a single row into the table: "espin.site_content" */
  insert_espin_site_content_one?: Maybe<Espin_Site_Content>;
  /** insert data into the table: "espin.social" */
  insert_espin_social?: Maybe<Espin_Social_Mutation_Response>;
  /** insert a single row into the table: "espin.social" */
  insert_espin_social_one?: Maybe<Espin_Social>;
  /** insert data into the table: "espin.stickied_college" */
  insert_espin_stickied_college?: Maybe<Espin_Stickied_College_Mutation_Response>;
  /** insert a single row into the table: "espin.stickied_college" */
  insert_espin_stickied_college_one?: Maybe<Espin_Stickied_College>;
  /** insert data into the table: "espin.stickied_player" */
  insert_espin_stickied_player?: Maybe<Espin_Stickied_Player_Mutation_Response>;
  /** insert a single row into the table: "espin.stickied_player" */
  insert_espin_stickied_player_one?: Maybe<Espin_Stickied_Player>;
  /** insert data into the table: "espin.study_field" */
  insert_espin_study_field?: Maybe<Espin_Study_Field_Mutation_Response>;
  /** insert a single row into the table: "espin.study_field" */
  insert_espin_study_field_one?: Maybe<Espin_Study_Field>;
  /** insert data into the table: "espin.study_subject" */
  insert_espin_study_subject?: Maybe<Espin_Study_Subject_Mutation_Response>;
  /** insert a single row into the table: "espin.study_subject" */
  insert_espin_study_subject_one?: Maybe<Espin_Study_Subject>;
  /** insert data into the table: "espin.subscription_status" */
  insert_espin_subscription_status?: Maybe<Espin_Subscription_Status_Mutation_Response>;
  /** insert a single row into the table: "espin.subscription_status" */
  insert_espin_subscription_status_one?: Maybe<Espin_Subscription_Status>;
  /** insert data into the table: "espin.subscription_tier_type" */
  insert_espin_subscription_tier_type?: Maybe<Espin_Subscription_Tier_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.subscription_tier_type" */
  insert_espin_subscription_tier_type_one?: Maybe<Espin_Subscription_Tier_Type>;
  /** insert data into the table: "espin.team" */
  insert_espin_team?: Maybe<Espin_Team_Mutation_Response>;
  /** insert data into the table: "espin.team_invite" */
  insert_espin_team_invite?: Maybe<Espin_Team_Invite_Mutation_Response>;
  /** insert a single row into the table: "espin.team_invite" */
  insert_espin_team_invite_one?: Maybe<Espin_Team_Invite>;
  /** insert data into the table: "espin.team_members" */
  insert_espin_team_members?: Maybe<Espin_Team_Members_Mutation_Response>;
  /** insert a single row into the table: "espin.team_members" */
  insert_espin_team_members_one?: Maybe<Espin_Team_Members>;
  /** insert a single row into the table: "espin.team" */
  insert_espin_team_one?: Maybe<Espin_Team>;
  /** insert data into the table: "espin.team_role" */
  insert_espin_team_role?: Maybe<Espin_Team_Role_Mutation_Response>;
  /** insert a single row into the table: "espin.team_role" */
  insert_espin_team_role_one?: Maybe<Espin_Team_Role>;
  /** insert data into the table: "espin.team_type" */
  insert_espin_team_type?: Maybe<Espin_Team_Type_Mutation_Response>;
  /** insert a single row into the table: "espin.team_type" */
  insert_espin_team_type_one?: Maybe<Espin_Team_Type>;
  /** insert data into the table: "espin.unregistered_college" */
  insert_espin_unregistered_college?: Maybe<Espin_Unregistered_College_Mutation_Response>;
  /** insert a single row into the table: "espin.unregistered_college" */
  insert_espin_unregistered_college_one?: Maybe<Espin_Unregistered_College>;
  /** insert data into the table: "espin.user" */
  insert_espin_user?: Maybe<Espin_User_Mutation_Response>;
  /** insert data into the table: "espin.user_linked_external_provider" */
  insert_espin_user_linked_external_provider?: Maybe<Espin_User_Linked_External_Provider_Mutation_Response>;
  /** insert a single row into the table: "espin.user_linked_external_provider" */
  insert_espin_user_linked_external_provider_one?: Maybe<Espin_User_Linked_External_Provider>;
  /** insert data into the table: "espin.user_membership" */
  insert_espin_user_membership?: Maybe<Espin_User_Membership_Mutation_Response>;
  /** insert a single row into the table: "espin.user_membership" */
  insert_espin_user_membership_one?: Maybe<Espin_User_Membership>;
  /** insert a single row into the table: "espin.user" */
  insert_espin_user_one?: Maybe<Espin_User>;
  /** insert data into the table: "espin.user_source" */
  insert_espin_user_source?: Maybe<Espin_User_Source_Mutation_Response>;
  /** insert a single row into the table: "espin.user_source" */
  insert_espin_user_source_one?: Maybe<Espin_User_Source>;
  /** insert data into the table: "queue.job" */
  insert_queue_job?: Maybe<Queue_Job_Mutation_Response>;
  /** insert a single row into the table: "queue.job" */
  insert_queue_job_one?: Maybe<Queue_Job>;
  /** insert data into the table: "queue.job_status_type" */
  insert_queue_job_status_type?: Maybe<Queue_Job_Status_Type_Mutation_Response>;
  /** insert a single row into the table: "queue.job_status_type" */
  insert_queue_job_status_type_one?: Maybe<Queue_Job_Status_Type>;
  /** insert data into the table: "queue.job_type" */
  insert_queue_job_type?: Maybe<Queue_Job_Type_Mutation_Response>;
  /** insert a single row into the table: "queue.job_type" */
  insert_queue_job_type_one?: Maybe<Queue_Job_Type>;
  /** insert data into the table: "stripe.customer_data" */
  insert_stripe_customer_data?: Maybe<Stripe_Customer_Data_Mutation_Response>;
  /** insert a single row into the table: "stripe.customer_data" */
  insert_stripe_customer_data_one?: Maybe<Stripe_Customer_Data>;
  /** insert data into the table: "stripe.invoice_data" */
  insert_stripe_invoice_data?: Maybe<Stripe_Invoice_Data_Mutation_Response>;
  /** insert a single row into the table: "stripe.invoice_data" */
  insert_stripe_invoice_data_one?: Maybe<Stripe_Invoice_Data>;
  /** insert data into the table: "stripe.stripe_payment_data" */
  insert_stripe_stripe_payment_data?: Maybe<Stripe_Stripe_Payment_Data_Mutation_Response>;
  /** insert a single row into the table: "stripe.stripe_payment_data" */
  insert_stripe_stripe_payment_data_one?: Maybe<Stripe_Stripe_Payment_Data>;
  /** insert data into the table: "stripe.stripe_subscription_data" */
  insert_stripe_stripe_subscription_data?: Maybe<Stripe_Stripe_Subscription_Data_Mutation_Response>;
  /** insert a single row into the table: "stripe.stripe_subscription_data" */
  insert_stripe_stripe_subscription_data_one?: Maybe<Stripe_Stripe_Subscription_Data>;
  /** insert data into the table: "tempstorage.keyvalue" */
  insert_tempstorage_keyvalue?: Maybe<Tempstorage_Keyvalue_Mutation_Response>;
  /** insert a single row into the table: "tempstorage.keyvalue" */
  insert_tempstorage_keyvalue_one?: Maybe<Tempstorage_Keyvalue>;
  inviteHighSchoolColleague?: Maybe<InviteHighSchoolColleagueActionOutput>;
  /** Add players to a team */
  invitePlayersToTeamAction?: Maybe<InvitePlayersToTeamActionOutput>;
  redeemCollegeReferralCode?: Maybe<RedeemCollegeReferralCodeInsertOutput>;
  redeemPlayerReferralCode?: Maybe<RedeemPlayerReferralCodeInsertOutput>;
  removeChildPlayer?: Maybe<RemoveChildPlayerOutput>;
  sendMassPlayerMessage?: Maybe<SendMassPlayerMessageOutput>;
  /** update data of the table: "cehsite.ms_available_site_terms" */
  update_cehsite_ms_available_site_terms?: Maybe<Cehsite_Ms_Available_Site_Terms_Mutation_Response>;
  /** update single row of the table: "cehsite.ms_available_site_terms" */
  update_cehsite_ms_available_site_terms_by_pk?: Maybe<Cehsite_Ms_Available_Site_Terms>;
  /** update multiples rows of table: "cehsite.ms_available_site_terms" */
  update_cehsite_ms_available_site_terms_many?: Maybe<Array<Maybe<Cehsite_Ms_Available_Site_Terms_Mutation_Response>>>;
  /** update data of the table: "cehsite.ms_contact_form_entry" */
  update_cehsite_ms_contact_form_entry?: Maybe<Cehsite_Ms_Contact_Form_Entry_Mutation_Response>;
  /** update single row of the table: "cehsite.ms_contact_form_entry" */
  update_cehsite_ms_contact_form_entry_by_pk?: Maybe<Cehsite_Ms_Contact_Form_Entry>;
  /** update multiples rows of table: "cehsite.ms_contact_form_entry" */
  update_cehsite_ms_contact_form_entry_many?: Maybe<Array<Maybe<Cehsite_Ms_Contact_Form_Entry_Mutation_Response>>>;
  /** update data of the table: "cehsite.ms_newsletter_signup" */
  update_cehsite_ms_newsletter_signup?: Maybe<Cehsite_Ms_Newsletter_Signup_Mutation_Response>;
  /** update single row of the table: "cehsite.ms_newsletter_signup" */
  update_cehsite_ms_newsletter_signup_by_pk?: Maybe<Cehsite_Ms_Newsletter_Signup>;
  /** update multiples rows of table: "cehsite.ms_newsletter_signup" */
  update_cehsite_ms_newsletter_signup_many?: Maybe<Array<Maybe<Cehsite_Ms_Newsletter_Signup_Mutation_Response>>>;
  /** update data of the table: "cehsite.ms_site_content" */
  update_cehsite_ms_site_content?: Maybe<Cehsite_Ms_Site_Content_Mutation_Response>;
  /** update single row of the table: "cehsite.ms_site_content" */
  update_cehsite_ms_site_content_by_pk?: Maybe<Cehsite_Ms_Site_Content>;
  /** update multiples rows of table: "cehsite.ms_site_content" */
  update_cehsite_ms_site_content_many?: Maybe<Array<Maybe<Cehsite_Ms_Site_Content_Mutation_Response>>>;
  /** update data of the table: "content.file" */
  update_content_file?: Maybe<Content_File_Mutation_Response>;
  /** update single row of the table: "content.file" */
  update_content_file_by_pk?: Maybe<Content_File>;
  /** update multiples rows of table: "content.file" */
  update_content_file_many?: Maybe<Array<Maybe<Content_File_Mutation_Response>>>;
  /** update data of the table: "content.file_metadata" */
  update_content_file_metadata?: Maybe<Content_File_Metadata_Mutation_Response>;
  /** update single row of the table: "content.file_metadata" */
  update_content_file_metadata_by_pk?: Maybe<Content_File_Metadata>;
  /** update multiples rows of table: "content.file_metadata" */
  update_content_file_metadata_many?: Maybe<Array<Maybe<Content_File_Metadata_Mutation_Response>>>;
  /** update data of the table: "content.file_status" */
  update_content_file_status?: Maybe<Content_File_Status_Mutation_Response>;
  /** update single row of the table: "content.file_status" */
  update_content_file_status_by_pk?: Maybe<Content_File_Status>;
  /** update multiples rows of table: "content.file_status" */
  update_content_file_status_many?: Maybe<Array<Maybe<Content_File_Status_Mutation_Response>>>;
  /** update data of the table: "content.media_link" */
  update_content_media_link?: Maybe<Content_Media_Link_Mutation_Response>;
  /** update single row of the table: "content.media_link" */
  update_content_media_link_by_pk?: Maybe<Content_Media_Link>;
  /** update multiples rows of table: "content.media_link" */
  update_content_media_link_many?: Maybe<Array<Maybe<Content_Media_Link_Mutation_Response>>>;
  /** update data of the table: "content.media_link_type" */
  update_content_media_link_type?: Maybe<Content_Media_Link_Type_Mutation_Response>;
  /** update single row of the table: "content.media_link_type" */
  update_content_media_link_type_by_pk?: Maybe<Content_Media_Link_Type>;
  /** update multiples rows of table: "content.media_link_type" */
  update_content_media_link_type_many?: Maybe<Array<Maybe<Content_Media_Link_Type_Mutation_Response>>>;
  /** update data of the table: "content.project_name" */
  update_content_project_name?: Maybe<Content_Project_Name_Mutation_Response>;
  /** update single row of the table: "content.project_name" */
  update_content_project_name_by_pk?: Maybe<Content_Project_Name>;
  /** update multiples rows of table: "content.project_name" */
  update_content_project_name_many?: Maybe<Array<Maybe<Content_Project_Name_Mutation_Response>>>;
  /** update data of the table: "content.status" */
  update_content_status?: Maybe<Content_Status_Mutation_Response>;
  /** update single row of the table: "content.status" */
  update_content_status_by_pk?: Maybe<Content_Status>;
  /** update multiples rows of table: "content.status" */
  update_content_status_many?: Maybe<Array<Maybe<Content_Status_Mutation_Response>>>;
  /** update data of the table: "espin.address" */
  update_espin_address?: Maybe<Espin_Address_Mutation_Response>;
  /** update single row of the table: "espin.address" */
  update_espin_address_by_pk?: Maybe<Espin_Address>;
  /** update multiples rows of table: "espin.address" */
  update_espin_address_many?: Maybe<Array<Maybe<Espin_Address_Mutation_Response>>>;
  /** update data of the table: "espin.boolean_feature_flag" */
  update_espin_boolean_feature_flag?: Maybe<Espin_Boolean_Feature_Flag_Mutation_Response>;
  /** update single row of the table: "espin.boolean_feature_flag" */
  update_espin_boolean_feature_flag_by_pk?: Maybe<Espin_Boolean_Feature_Flag>;
  /** update multiples rows of table: "espin.boolean_feature_flag" */
  update_espin_boolean_feature_flag_many?: Maybe<Array<Maybe<Espin_Boolean_Feature_Flag_Mutation_Response>>>;
  /** update data of the table: "espin.coach_profile" */
  update_espin_coach_profile?: Maybe<Espin_Coach_Profile_Mutation_Response>;
  /** update single row of the table: "espin.coach_profile" */
  update_espin_coach_profile_by_pk?: Maybe<Espin_Coach_Profile>;
  /** update multiples rows of table: "espin.coach_profile" */
  update_espin_coach_profile_many?: Maybe<Array<Maybe<Espin_Coach_Profile_Mutation_Response>>>;
  /** update data of the table: "espin.college" */
  update_espin_college?: Maybe<Espin_College_Mutation_Response>;
  /** update data of the table: "espin.college_automatic_message_response_type" */
  update_espin_college_automatic_message_response_type?: Maybe<Espin_College_Automatic_Message_Response_Type_Mutation_Response>;
  /** update single row of the table: "espin.college_automatic_message_response_type" */
  update_espin_college_automatic_message_response_type_by_pk?: Maybe<Espin_College_Automatic_Message_Response_Type>;
  /** update multiples rows of table: "espin.college_automatic_message_response_type" */
  update_espin_college_automatic_message_response_type_many?: Maybe<Array<Maybe<Espin_College_Automatic_Message_Response_Type_Mutation_Response>>>;
  /** update single row of the table: "espin.college" */
  update_espin_college_by_pk?: Maybe<Espin_College>;
  /** update data of the table: "espin.college_game" */
  update_espin_college_game?: Maybe<Espin_College_Game_Mutation_Response>;
  /** update single row of the table: "espin.college_game" */
  update_espin_college_game_by_pk?: Maybe<Espin_College_Game>;
  /** update multiples rows of table: "espin.college_game" */
  update_espin_college_game_many?: Maybe<Array<Maybe<Espin_College_Game_Mutation_Response>>>;
  /** update data of the table: "espin.college_image" */
  update_espin_college_image?: Maybe<Espin_College_Image_Mutation_Response>;
  /** update single row of the table: "espin.college_image" */
  update_espin_college_image_by_pk?: Maybe<Espin_College_Image>;
  /** update multiples rows of table: "espin.college_image" */
  update_espin_college_image_many?: Maybe<Array<Maybe<Espin_College_Image_Mutation_Response>>>;
  /** update data of the table: "espin.college_invite" */
  update_espin_college_invite?: Maybe<Espin_College_Invite_Mutation_Response>;
  /** update single row of the table: "espin.college_invite" */
  update_espin_college_invite_by_pk?: Maybe<Espin_College_Invite>;
  /** update multiples rows of table: "espin.college_invite" */
  update_espin_college_invite_many?: Maybe<Array<Maybe<Espin_College_Invite_Mutation_Response>>>;
  /** update multiples rows of table: "espin.college" */
  update_espin_college_many?: Maybe<Array<Maybe<Espin_College_Mutation_Response>>>;
  /** update data of the table: "espin.college_preferences" */
  update_espin_college_preferences?: Maybe<Espin_College_Preferences_Mutation_Response>;
  /** update single row of the table: "espin.college_preferences" */
  update_espin_college_preferences_by_pk?: Maybe<Espin_College_Preferences>;
  /** update multiples rows of table: "espin.college_preferences" */
  update_espin_college_preferences_many?: Maybe<Array<Maybe<Espin_College_Preferences_Mutation_Response>>>;
  /** update data of the table: "espin.college_profile" */
  update_espin_college_profile?: Maybe<Espin_College_Profile_Mutation_Response>;
  /** update single row of the table: "espin.college_profile" */
  update_espin_college_profile_by_pk?: Maybe<Espin_College_Profile>;
  /** update multiples rows of table: "espin.college_profile" */
  update_espin_college_profile_many?: Maybe<Array<Maybe<Espin_College_Profile_Mutation_Response>>>;
  /** update data of the table: "espin.college_roster" */
  update_espin_college_roster?: Maybe<Espin_College_Roster_Mutation_Response>;
  /** update single row of the table: "espin.college_roster" */
  update_espin_college_roster_by_pk?: Maybe<Espin_College_Roster>;
  /** update multiples rows of table: "espin.college_roster" */
  update_espin_college_roster_many?: Maybe<Array<Maybe<Espin_College_Roster_Mutation_Response>>>;
  /** update data of the table: "espin.college_staff_member" */
  update_espin_college_staff_member?: Maybe<Espin_College_Staff_Member_Mutation_Response>;
  /** update single row of the table: "espin.college_staff_member" */
  update_espin_college_staff_member_by_pk?: Maybe<Espin_College_Staff_Member>;
  /** update multiples rows of table: "espin.college_staff_member" */
  update_espin_college_staff_member_many?: Maybe<Array<Maybe<Espin_College_Staff_Member_Mutation_Response>>>;
  /** update data of the table: "espin.college_subscription" */
  update_espin_college_subscription?: Maybe<Espin_College_Subscription_Mutation_Response>;
  /** update single row of the table: "espin.college_subscription" */
  update_espin_college_subscription_by_pk?: Maybe<Espin_College_Subscription>;
  /** update multiples rows of table: "espin.college_subscription" */
  update_espin_college_subscription_many?: Maybe<Array<Maybe<Espin_College_Subscription_Mutation_Response>>>;
  /** update data of the table: "espin.college_verification_status_type" */
  update_espin_college_verification_status_type?: Maybe<Espin_College_Verification_Status_Type_Mutation_Response>;
  /** update single row of the table: "espin.college_verification_status_type" */
  update_espin_college_verification_status_type_by_pk?: Maybe<Espin_College_Verification_Status_Type>;
  /** update multiples rows of table: "espin.college_verification_status_type" */
  update_espin_college_verification_status_type_many?: Maybe<Array<Maybe<Espin_College_Verification_Status_Type_Mutation_Response>>>;
  /** update data of the table: "espin.draft_player_profile" */
  update_espin_draft_player_profile?: Maybe<Espin_Draft_Player_Profile_Mutation_Response>;
  /** update single row of the table: "espin.draft_player_profile" */
  update_espin_draft_player_profile_by_pk?: Maybe<Espin_Draft_Player_Profile>;
  /** update multiples rows of table: "espin.draft_player_profile" */
  update_espin_draft_player_profile_many?: Maybe<Array<Maybe<Espin_Draft_Player_Profile_Mutation_Response>>>;
  /** update data of the table: "espin.editable_site_content" */
  update_espin_editable_site_content?: Maybe<Espin_Editable_Site_Content_Mutation_Response>;
  /** update single row of the table: "espin.editable_site_content" */
  update_espin_editable_site_content_by_pk?: Maybe<Espin_Editable_Site_Content>;
  /** update multiples rows of table: "espin.editable_site_content" */
  update_espin_editable_site_content_many?: Maybe<Array<Maybe<Espin_Editable_Site_Content_Mutation_Response>>>;
  /** update data of the table: "espin.ethnicity_options" */
  update_espin_ethnicity_options?: Maybe<Espin_Ethnicity_Options_Mutation_Response>;
  /** update single row of the table: "espin.ethnicity_options" */
  update_espin_ethnicity_options_by_pk?: Maybe<Espin_Ethnicity_Options>;
  /** update multiples rows of table: "espin.ethnicity_options" */
  update_espin_ethnicity_options_many?: Maybe<Array<Maybe<Espin_Ethnicity_Options_Mutation_Response>>>;
  /** update data of the table: "espin.event" */
  update_espin_event?: Maybe<Espin_Event_Mutation_Response>;
  /** update single row of the table: "espin.event" */
  update_espin_event_by_pk?: Maybe<Espin_Event>;
  /** update data of the table: "espin.event_custom_field" */
  update_espin_event_custom_field?: Maybe<Espin_Event_Custom_Field_Mutation_Response>;
  /** update single row of the table: "espin.event_custom_field" */
  update_espin_event_custom_field_by_pk?: Maybe<Espin_Event_Custom_Field>;
  /** update multiples rows of table: "espin.event_custom_field" */
  update_espin_event_custom_field_many?: Maybe<Array<Maybe<Espin_Event_Custom_Field_Mutation_Response>>>;
  /** update data of the table: "espin.event_custom_field_type" */
  update_espin_event_custom_field_type?: Maybe<Espin_Event_Custom_Field_Type_Mutation_Response>;
  /** update single row of the table: "espin.event_custom_field_type" */
  update_espin_event_custom_field_type_by_pk?: Maybe<Espin_Event_Custom_Field_Type>;
  /** update multiples rows of table: "espin.event_custom_field_type" */
  update_espin_event_custom_field_type_many?: Maybe<Array<Maybe<Espin_Event_Custom_Field_Type_Mutation_Response>>>;
  /** update data of the table: "espin.event_document" */
  update_espin_event_document?: Maybe<Espin_Event_Document_Mutation_Response>;
  /** update single row of the table: "espin.event_document" */
  update_espin_event_document_by_pk?: Maybe<Espin_Event_Document>;
  /** update multiples rows of table: "espin.event_document" */
  update_espin_event_document_many?: Maybe<Array<Maybe<Espin_Event_Document_Mutation_Response>>>;
  /** update data of the table: "espin.event_game" */
  update_espin_event_game?: Maybe<Espin_Event_Game_Mutation_Response>;
  /** update single row of the table: "espin.event_game" */
  update_espin_event_game_by_pk?: Maybe<Espin_Event_Game>;
  /** update multiples rows of table: "espin.event_game" */
  update_espin_event_game_many?: Maybe<Array<Maybe<Espin_Event_Game_Mutation_Response>>>;
  /** update multiples rows of table: "espin.event" */
  update_espin_event_many?: Maybe<Array<Maybe<Espin_Event_Mutation_Response>>>;
  /** update data of the table: "espin.event_registration" */
  update_espin_event_registration?: Maybe<Espin_Event_Registration_Mutation_Response>;
  /** update single row of the table: "espin.event_registration" */
  update_espin_event_registration_by_pk?: Maybe<Espin_Event_Registration>;
  /** update data of the table: "espin.event_registration_custom_field_entry" */
  update_espin_event_registration_custom_field_entry?: Maybe<Espin_Event_Registration_Custom_Field_Entry_Mutation_Response>;
  /** update single row of the table: "espin.event_registration_custom_field_entry" */
  update_espin_event_registration_custom_field_entry_by_pk?: Maybe<Espin_Event_Registration_Custom_Field_Entry>;
  /** update multiples rows of table: "espin.event_registration_custom_field_entry" */
  update_espin_event_registration_custom_field_entry_many?: Maybe<Array<Maybe<Espin_Event_Registration_Custom_Field_Entry_Mutation_Response>>>;
  /** update data of the table: "espin.event_registration_document_signoff" */
  update_espin_event_registration_document_signoff?: Maybe<Espin_Event_Registration_Document_Signoff_Mutation_Response>;
  /** update single row of the table: "espin.event_registration_document_signoff" */
  update_espin_event_registration_document_signoff_by_pk?: Maybe<Espin_Event_Registration_Document_Signoff>;
  /** update multiples rows of table: "espin.event_registration_document_signoff" */
  update_espin_event_registration_document_signoff_many?: Maybe<Array<Maybe<Espin_Event_Registration_Document_Signoff_Mutation_Response>>>;
  /** update multiples rows of table: "espin.event_registration" */
  update_espin_event_registration_many?: Maybe<Array<Maybe<Espin_Event_Registration_Mutation_Response>>>;
  /** update data of the table: "espin.event_registration_status" */
  update_espin_event_registration_status?: Maybe<Espin_Event_Registration_Status_Mutation_Response>;
  /** update single row of the table: "espin.event_registration_status" */
  update_espin_event_registration_status_by_pk?: Maybe<Espin_Event_Registration_Status>;
  /** update multiples rows of table: "espin.event_registration_status" */
  update_espin_event_registration_status_many?: Maybe<Array<Maybe<Espin_Event_Registration_Status_Mutation_Response>>>;
  /** update data of the table: "espin.event_ticket" */
  update_espin_event_ticket?: Maybe<Espin_Event_Ticket_Mutation_Response>;
  /** update single row of the table: "espin.event_ticket" */
  update_espin_event_ticket_by_pk?: Maybe<Espin_Event_Ticket>;
  /** update multiples rows of table: "espin.event_ticket" */
  update_espin_event_ticket_many?: Maybe<Array<Maybe<Espin_Event_Ticket_Mutation_Response>>>;
  /** update data of the table: "espin.event_ticket_type" */
  update_espin_event_ticket_type?: Maybe<Espin_Event_Ticket_Type_Mutation_Response>;
  /** update single row of the table: "espin.event_ticket_type" */
  update_espin_event_ticket_type_by_pk?: Maybe<Espin_Event_Ticket_Type>;
  /** update multiples rows of table: "espin.event_ticket_type" */
  update_espin_event_ticket_type_many?: Maybe<Array<Maybe<Espin_Event_Ticket_Type_Mutation_Response>>>;
  /** update data of the table: "espin.event_type" */
  update_espin_event_type?: Maybe<Espin_Event_Type_Mutation_Response>;
  /** update single row of the table: "espin.event_type" */
  update_espin_event_type_by_pk?: Maybe<Espin_Event_Type>;
  /** update multiples rows of table: "espin.event_type" */
  update_espin_event_type_many?: Maybe<Array<Maybe<Espin_Event_Type_Mutation_Response>>>;
  /** update data of the table: "espin.external_provider" */
  update_espin_external_provider?: Maybe<Espin_External_Provider_Mutation_Response>;
  /** update single row of the table: "espin.external_provider" */
  update_espin_external_provider_by_pk?: Maybe<Espin_External_Provider>;
  /** update data of the table: "espin.external_provider_link" */
  update_espin_external_provider_link?: Maybe<Espin_External_Provider_Link_Mutation_Response>;
  /** update single row of the table: "espin.external_provider_link" */
  update_espin_external_provider_link_by_pk?: Maybe<Espin_External_Provider_Link>;
  /** update multiples rows of table: "espin.external_provider_link" */
  update_espin_external_provider_link_many?: Maybe<Array<Maybe<Espin_External_Provider_Link_Mutation_Response>>>;
  /** update multiples rows of table: "espin.external_provider" */
  update_espin_external_provider_many?: Maybe<Array<Maybe<Espin_External_Provider_Mutation_Response>>>;
  /** update data of the table: "espin.follow" */
  update_espin_follow?: Maybe<Espin_Follow_Mutation_Response>;
  /** update single row of the table: "espin.follow" */
  update_espin_follow_by_pk?: Maybe<Espin_Follow>;
  /** update multiples rows of table: "espin.follow" */
  update_espin_follow_many?: Maybe<Array<Maybe<Espin_Follow_Mutation_Response>>>;
  /** update data of the table: "espin.follow_type" */
  update_espin_follow_type?: Maybe<Espin_Follow_Type_Mutation_Response>;
  /** update single row of the table: "espin.follow_type" */
  update_espin_follow_type_by_pk?: Maybe<Espin_Follow_Type>;
  /** update multiples rows of table: "espin.follow_type" */
  update_espin_follow_type_many?: Maybe<Array<Maybe<Espin_Follow_Type_Mutation_Response>>>;
  /** update data of the table: "espin.follower_email_notification_type" */
  update_espin_follower_email_notification_type?: Maybe<Espin_Follower_Email_Notification_Type_Mutation_Response>;
  /** update single row of the table: "espin.follower_email_notification_type" */
  update_espin_follower_email_notification_type_by_pk?: Maybe<Espin_Follower_Email_Notification_Type>;
  /** update multiples rows of table: "espin.follower_email_notification_type" */
  update_espin_follower_email_notification_type_many?: Maybe<Array<Maybe<Espin_Follower_Email_Notification_Type_Mutation_Response>>>;
  /** update data of the table: "espin.force_notification_reload" */
  update_espin_force_notification_reload?: Maybe<Espin_Force_Notification_Reload_Mutation_Response>;
  /** update single row of the table: "espin.force_notification_reload" */
  update_espin_force_notification_reload_by_pk?: Maybe<Espin_Force_Notification_Reload>;
  /** update multiples rows of table: "espin.force_notification_reload" */
  update_espin_force_notification_reload_many?: Maybe<Array<Maybe<Espin_Force_Notification_Reload_Mutation_Response>>>;
  /** update data of the table: "espin.game" */
  update_espin_game?: Maybe<Espin_Game_Mutation_Response>;
  /** update single row of the table: "espin.game" */
  update_espin_game_by_pk?: Maybe<Espin_Game>;
  /** update data of the table: "espin.game_definition" */
  update_espin_game_definition?: Maybe<Espin_Game_Definition_Mutation_Response>;
  /** update single row of the table: "espin.game_definition" */
  update_espin_game_definition_by_pk?: Maybe<Espin_Game_Definition>;
  /** update multiples rows of table: "espin.game_definition" */
  update_espin_game_definition_many?: Maybe<Array<Maybe<Espin_Game_Definition_Mutation_Response>>>;
  /** update multiples rows of table: "espin.game" */
  update_espin_game_many?: Maybe<Array<Maybe<Espin_Game_Mutation_Response>>>;
  /** update data of the table: "espin.game_platform" */
  update_espin_game_platform?: Maybe<Espin_Game_Platform_Mutation_Response>;
  /** update single row of the table: "espin.game_platform" */
  update_espin_game_platform_by_pk?: Maybe<Espin_Game_Platform>;
  /** update multiples rows of table: "espin.game_platform" */
  update_espin_game_platform_many?: Maybe<Array<Maybe<Espin_Game_Platform_Mutation_Response>>>;
  /** update data of the table: "espin.gender_options" */
  update_espin_gender_options?: Maybe<Espin_Gender_Options_Mutation_Response>;
  /** update single row of the table: "espin.gender_options" */
  update_espin_gender_options_by_pk?: Maybe<Espin_Gender_Options>;
  /** update multiples rows of table: "espin.gender_options" */
  update_espin_gender_options_many?: Maybe<Array<Maybe<Espin_Gender_Options_Mutation_Response>>>;
  /** update data of the table: "espin.graduating_class" */
  update_espin_graduating_class?: Maybe<Espin_Graduating_Class_Mutation_Response>;
  /** update single row of the table: "espin.graduating_class" */
  update_espin_graduating_class_by_pk?: Maybe<Espin_Graduating_Class>;
  /** update multiples rows of table: "espin.graduating_class" */
  update_espin_graduating_class_many?: Maybe<Array<Maybe<Espin_Graduating_Class_Mutation_Response>>>;
  /** update data of the table: "espin.high_school" */
  update_espin_high_school?: Maybe<Espin_High_School_Mutation_Response>;
  /** update single row of the table: "espin.high_school" */
  update_espin_high_school_by_pk?: Maybe<Espin_High_School>;
  /** update data of the table: "espin.high_school_invite" */
  update_espin_high_school_invite?: Maybe<Espin_High_School_Invite_Mutation_Response>;
  /** update single row of the table: "espin.high_school_invite" */
  update_espin_high_school_invite_by_pk?: Maybe<Espin_High_School_Invite>;
  /** update multiples rows of table: "espin.high_school_invite" */
  update_espin_high_school_invite_many?: Maybe<Array<Maybe<Espin_High_School_Invite_Mutation_Response>>>;
  /** update multiples rows of table: "espin.high_school" */
  update_espin_high_school_many?: Maybe<Array<Maybe<Espin_High_School_Mutation_Response>>>;
  /** update data of the table: "espin.high_school_profile" */
  update_espin_high_school_profile?: Maybe<Espin_High_School_Profile_Mutation_Response>;
  /** update single row of the table: "espin.high_school_profile" */
  update_espin_high_school_profile_by_pk?: Maybe<Espin_High_School_Profile>;
  /** update multiples rows of table: "espin.high_school_profile" */
  update_espin_high_school_profile_many?: Maybe<Array<Maybe<Espin_High_School_Profile_Mutation_Response>>>;
  /** update data of the table: "espin.invite_status_type" */
  update_espin_invite_status_type?: Maybe<Espin_Invite_Status_Type_Mutation_Response>;
  /** update single row of the table: "espin.invite_status_type" */
  update_espin_invite_status_type_by_pk?: Maybe<Espin_Invite_Status_Type>;
  /** update multiples rows of table: "espin.invite_status_type" */
  update_espin_invite_status_type_many?: Maybe<Array<Maybe<Espin_Invite_Status_Type_Mutation_Response>>>;
  /** update data of the table: "espin.leaderboard" */
  update_espin_leaderboard?: Maybe<Espin_Leaderboard_Mutation_Response>;
  /** update single row of the table: "espin.leaderboard" */
  update_espin_leaderboard_by_pk?: Maybe<Espin_Leaderboard>;
  /** update multiples rows of table: "espin.leaderboard" */
  update_espin_leaderboard_many?: Maybe<Array<Maybe<Espin_Leaderboard_Mutation_Response>>>;
  /** update data of the table: "espin.membership" */
  update_espin_membership?: Maybe<Espin_Membership_Mutation_Response>;
  /** update single row of the table: "espin.membership" */
  update_espin_membership_by_pk?: Maybe<Espin_Membership>;
  /** update multiples rows of table: "espin.membership" */
  update_espin_membership_many?: Maybe<Array<Maybe<Espin_Membership_Mutation_Response>>>;
  /** update data of the table: "espin.message" */
  update_espin_message?: Maybe<Espin_Message_Mutation_Response>;
  /** update single row of the table: "espin.message" */
  update_espin_message_by_pk?: Maybe<Espin_Message>;
  /** update data of the table: "espin.message_email_notification_type" */
  update_espin_message_email_notification_type?: Maybe<Espin_Message_Email_Notification_Type_Mutation_Response>;
  /** update single row of the table: "espin.message_email_notification_type" */
  update_espin_message_email_notification_type_by_pk?: Maybe<Espin_Message_Email_Notification_Type>;
  /** update multiples rows of table: "espin.message_email_notification_type" */
  update_espin_message_email_notification_type_many?: Maybe<Array<Maybe<Espin_Message_Email_Notification_Type_Mutation_Response>>>;
  /** update multiples rows of table: "espin.message" */
  update_espin_message_many?: Maybe<Array<Maybe<Espin_Message_Mutation_Response>>>;
  /** update data of the table: "espin.message_type" */
  update_espin_message_type?: Maybe<Espin_Message_Type_Mutation_Response>;
  /** update single row of the table: "espin.message_type" */
  update_espin_message_type_by_pk?: Maybe<Espin_Message_Type>;
  /** update multiples rows of table: "espin.message_type" */
  update_espin_message_type_many?: Maybe<Array<Maybe<Espin_Message_Type_Mutation_Response>>>;
  /** update data of the table: "espin.moderation_status" */
  update_espin_moderation_status?: Maybe<Espin_Moderation_Status_Mutation_Response>;
  /** update single row of the table: "espin.moderation_status" */
  update_espin_moderation_status_by_pk?: Maybe<Espin_Moderation_Status>;
  /** update multiples rows of table: "espin.moderation_status" */
  update_espin_moderation_status_many?: Maybe<Array<Maybe<Espin_Moderation_Status_Mutation_Response>>>;
  /** update data of the table: "espin.newsletter_request" */
  update_espin_newsletter_request?: Maybe<Espin_Newsletter_Request_Mutation_Response>;
  /** update single row of the table: "espin.newsletter_request" */
  update_espin_newsletter_request_by_pk?: Maybe<Espin_Newsletter_Request>;
  /** update multiples rows of table: "espin.newsletter_request" */
  update_espin_newsletter_request_many?: Maybe<Array<Maybe<Espin_Newsletter_Request_Mutation_Response>>>;
  /** update data of the table: "espin.notification" */
  update_espin_notification?: Maybe<Espin_Notification_Mutation_Response>;
  /** update single row of the table: "espin.notification" */
  update_espin_notification_by_pk?: Maybe<Espin_Notification>;
  /** update multiples rows of table: "espin.notification" */
  update_espin_notification_many?: Maybe<Array<Maybe<Espin_Notification_Mutation_Response>>>;
  /** update data of the table: "espin.notification_type" */
  update_espin_notification_type?: Maybe<Espin_Notification_Type_Mutation_Response>;
  /** update single row of the table: "espin.notification_type" */
  update_espin_notification_type_by_pk?: Maybe<Espin_Notification_Type>;
  /** update multiples rows of table: "espin.notification_type" */
  update_espin_notification_type_many?: Maybe<Array<Maybe<Espin_Notification_Type_Mutation_Response>>>;
  /** update data of the table: "espin.org" */
  update_espin_org?: Maybe<Espin_Org_Mutation_Response>;
  /** update single row of the table: "espin.org" */
  update_espin_org_by_pk?: Maybe<Espin_Org>;
  /** update multiples rows of table: "espin.org" */
  update_espin_org_many?: Maybe<Array<Maybe<Espin_Org_Mutation_Response>>>;
  /** update data of the table: "espin.org_month" */
  update_espin_org_month?: Maybe<Espin_Org_Month_Mutation_Response>;
  /** update single row of the table: "espin.org_month" */
  update_espin_org_month_by_pk?: Maybe<Espin_Org_Month>;
  /** update data of the table: "espin.org_month_day" */
  update_espin_org_month_day?: Maybe<Espin_Org_Month_Day_Mutation_Response>;
  /** update single row of the table: "espin.org_month_day" */
  update_espin_org_month_day_by_pk?: Maybe<Espin_Org_Month_Day>;
  /** update multiples rows of table: "espin.org_month_day" */
  update_espin_org_month_day_many?: Maybe<Array<Maybe<Espin_Org_Month_Day_Mutation_Response>>>;
  /** update multiples rows of table: "espin.org_month" */
  update_espin_org_month_many?: Maybe<Array<Maybe<Espin_Org_Month_Mutation_Response>>>;
  /** update data of the table: "espin.org_player" */
  update_espin_org_player?: Maybe<Espin_Org_Player_Mutation_Response>;
  /** update single row of the table: "espin.org_player" */
  update_espin_org_player_by_pk?: Maybe<Espin_Org_Player>;
  /** update multiples rows of table: "espin.org_player" */
  update_espin_org_player_many?: Maybe<Array<Maybe<Espin_Org_Player_Mutation_Response>>>;
  /** update data of the table: "espin.org_school" */
  update_espin_org_school?: Maybe<Espin_Org_School_Mutation_Response>;
  /** update single row of the table: "espin.org_school" */
  update_espin_org_school_by_pk?: Maybe<Espin_Org_School>;
  /** update multiples rows of table: "espin.org_school" */
  update_espin_org_school_many?: Maybe<Array<Maybe<Espin_Org_School_Mutation_Response>>>;
  /** update data of the table: "espin.org_school_record" */
  update_espin_org_school_record?: Maybe<Espin_Org_School_Record_Mutation_Response>;
  /** update single row of the table: "espin.org_school_record" */
  update_espin_org_school_record_by_pk?: Maybe<Espin_Org_School_Record>;
  /** update multiples rows of table: "espin.org_school_record" */
  update_espin_org_school_record_many?: Maybe<Array<Maybe<Espin_Org_School_Record_Mutation_Response>>>;
  /** update data of the table: "espin.paid_product" */
  update_espin_paid_product?: Maybe<Espin_Paid_Product_Mutation_Response>;
  /** update single row of the table: "espin.paid_product" */
  update_espin_paid_product_by_pk?: Maybe<Espin_Paid_Product>;
  /** update multiples rows of table: "espin.paid_product" */
  update_espin_paid_product_many?: Maybe<Array<Maybe<Espin_Paid_Product_Mutation_Response>>>;
  /** update data of the table: "espin.parent_invite" */
  update_espin_parent_invite?: Maybe<Espin_Parent_Invite_Mutation_Response>;
  /** update single row of the table: "espin.parent_invite" */
  update_espin_parent_invite_by_pk?: Maybe<Espin_Parent_Invite>;
  /** update multiples rows of table: "espin.parent_invite" */
  update_espin_parent_invite_many?: Maybe<Array<Maybe<Espin_Parent_Invite_Mutation_Response>>>;
  /** update data of the table: "espin.parent_profile" */
  update_espin_parent_profile?: Maybe<Espin_Parent_Profile_Mutation_Response>;
  /** update single row of the table: "espin.parent_profile" */
  update_espin_parent_profile_by_pk?: Maybe<Espin_Parent_Profile>;
  /** update multiples rows of table: "espin.parent_profile" */
  update_espin_parent_profile_many?: Maybe<Array<Maybe<Espin_Parent_Profile_Mutation_Response>>>;
  /** update data of the table: "espin.player_game" */
  update_espin_player_game?: Maybe<Espin_Player_Game_Mutation_Response>;
  /** update single row of the table: "espin.player_game" */
  update_espin_player_game_by_pk?: Maybe<Espin_Player_Game>;
  /** update multiples rows of table: "espin.player_game" */
  update_espin_player_game_many?: Maybe<Array<Maybe<Espin_Player_Game_Mutation_Response>>>;
  /** update data of the table: "espin.player_journey" */
  update_espin_player_journey?: Maybe<Espin_Player_Journey_Mutation_Response>;
  /** update single row of the table: "espin.player_journey" */
  update_espin_player_journey_by_pk?: Maybe<Espin_Player_Journey>;
  /** update multiples rows of table: "espin.player_journey" */
  update_espin_player_journey_many?: Maybe<Array<Maybe<Espin_Player_Journey_Mutation_Response>>>;
  /** update data of the table: "espin.player_journey_stage" */
  update_espin_player_journey_stage?: Maybe<Espin_Player_Journey_Stage_Mutation_Response>;
  /** update single row of the table: "espin.player_journey_stage" */
  update_espin_player_journey_stage_by_pk?: Maybe<Espin_Player_Journey_Stage>;
  /** update data of the table: "espin.player_journey_stage_college" */
  update_espin_player_journey_stage_college?: Maybe<Espin_Player_Journey_Stage_College_Mutation_Response>;
  /** update single row of the table: "espin.player_journey_stage_college" */
  update_espin_player_journey_stage_college_by_pk?: Maybe<Espin_Player_Journey_Stage_College>;
  /** update multiples rows of table: "espin.player_journey_stage_college" */
  update_espin_player_journey_stage_college_many?: Maybe<Array<Maybe<Espin_Player_Journey_Stage_College_Mutation_Response>>>;
  /** update data of the table: "espin.player_journey_stage_def" */
  update_espin_player_journey_stage_def?: Maybe<Espin_Player_Journey_Stage_Def_Mutation_Response>;
  /** update single row of the table: "espin.player_journey_stage_def" */
  update_espin_player_journey_stage_def_by_pk?: Maybe<Espin_Player_Journey_Stage_Def>;
  /** update multiples rows of table: "espin.player_journey_stage_def" */
  update_espin_player_journey_stage_def_many?: Maybe<Array<Maybe<Espin_Player_Journey_Stage_Def_Mutation_Response>>>;
  /** update data of the table: "espin.player_journey_stage_image" */
  update_espin_player_journey_stage_image?: Maybe<Espin_Player_Journey_Stage_Image_Mutation_Response>;
  /** update single row of the table: "espin.player_journey_stage_image" */
  update_espin_player_journey_stage_image_by_pk?: Maybe<Espin_Player_Journey_Stage_Image>;
  /** update multiples rows of table: "espin.player_journey_stage_image" */
  update_espin_player_journey_stage_image_many?: Maybe<Array<Maybe<Espin_Player_Journey_Stage_Image_Mutation_Response>>>;
  /** update multiples rows of table: "espin.player_journey_stage" */
  update_espin_player_journey_stage_many?: Maybe<Array<Maybe<Espin_Player_Journey_Stage_Mutation_Response>>>;
  /** update data of the table: "espin.player_journey_stage_quote" */
  update_espin_player_journey_stage_quote?: Maybe<Espin_Player_Journey_Stage_Quote_Mutation_Response>;
  /** update single row of the table: "espin.player_journey_stage_quote" */
  update_espin_player_journey_stage_quote_by_pk?: Maybe<Espin_Player_Journey_Stage_Quote>;
  /** update multiples rows of table: "espin.player_journey_stage_quote" */
  update_espin_player_journey_stage_quote_many?: Maybe<Array<Maybe<Espin_Player_Journey_Stage_Quote_Mutation_Response>>>;
  /** update data of the table: "espin.player_journey_stage_video" */
  update_espin_player_journey_stage_video?: Maybe<Espin_Player_Journey_Stage_Video_Mutation_Response>;
  /** update single row of the table: "espin.player_journey_stage_video" */
  update_espin_player_journey_stage_video_by_pk?: Maybe<Espin_Player_Journey_Stage_Video>;
  /** update multiples rows of table: "espin.player_journey_stage_video" */
  update_espin_player_journey_stage_video_many?: Maybe<Array<Maybe<Espin_Player_Journey_Stage_Video_Mutation_Response>>>;
  /** update data of the table: "espin.player_profile" */
  update_espin_player_profile?: Maybe<Espin_Player_Profile_Mutation_Response>;
  /** update single row of the table: "espin.player_profile" */
  update_espin_player_profile_by_pk?: Maybe<Espin_Player_Profile>;
  /** update multiples rows of table: "espin.player_profile" */
  update_espin_player_profile_many?: Maybe<Array<Maybe<Espin_Player_Profile_Mutation_Response>>>;
  /** update data of the table: "espin.player_subscription" */
  update_espin_player_subscription?: Maybe<Espin_Player_Subscription_Mutation_Response>;
  /** update single row of the table: "espin.player_subscription" */
  update_espin_player_subscription_by_pk?: Maybe<Espin_Player_Subscription>;
  /** update multiples rows of table: "espin.player_subscription" */
  update_espin_player_subscription_many?: Maybe<Array<Maybe<Espin_Player_Subscription_Mutation_Response>>>;
  /** update data of the table: "espin.player_vod" */
  update_espin_player_vod?: Maybe<Espin_Player_Vod_Mutation_Response>;
  /** update single row of the table: "espin.player_vod" */
  update_espin_player_vod_by_pk?: Maybe<Espin_Player_Vod>;
  /** update multiples rows of table: "espin.player_vod" */
  update_espin_player_vod_many?: Maybe<Array<Maybe<Espin_Player_Vod_Mutation_Response>>>;
  /** update data of the table: "espin.profile_view" */
  update_espin_profile_view?: Maybe<Espin_Profile_View_Mutation_Response>;
  /** update single row of the table: "espin.profile_view" */
  update_espin_profile_view_by_pk?: Maybe<Espin_Profile_View>;
  /** update data of the table: "espin.profile_view_email_notification_type" */
  update_espin_profile_view_email_notification_type?: Maybe<Espin_Profile_View_Email_Notification_Type_Mutation_Response>;
  /** update single row of the table: "espin.profile_view_email_notification_type" */
  update_espin_profile_view_email_notification_type_by_pk?: Maybe<Espin_Profile_View_Email_Notification_Type>;
  /** update multiples rows of table: "espin.profile_view_email_notification_type" */
  update_espin_profile_view_email_notification_type_many?: Maybe<Array<Maybe<Espin_Profile_View_Email_Notification_Type_Mutation_Response>>>;
  /** update multiples rows of table: "espin.profile_view" */
  update_espin_profile_view_many?: Maybe<Array<Maybe<Espin_Profile_View_Mutation_Response>>>;
  /** update data of the table: "espin.profile_view_type" */
  update_espin_profile_view_type?: Maybe<Espin_Profile_View_Type_Mutation_Response>;
  /** update single row of the table: "espin.profile_view_type" */
  update_espin_profile_view_type_by_pk?: Maybe<Espin_Profile_View_Type>;
  /** update multiples rows of table: "espin.profile_view_type" */
  update_espin_profile_view_type_many?: Maybe<Array<Maybe<Espin_Profile_View_Type_Mutation_Response>>>;
  /** update data of the table: "espin.referral_code" */
  update_espin_referral_code?: Maybe<Espin_Referral_Code_Mutation_Response>;
  /** update single row of the table: "espin.referral_code" */
  update_espin_referral_code_by_pk?: Maybe<Espin_Referral_Code>;
  /** update multiples rows of table: "espin.referral_code" */
  update_espin_referral_code_many?: Maybe<Array<Maybe<Espin_Referral_Code_Mutation_Response>>>;
  /** update data of the table: "espin.referral_code_redemption" */
  update_espin_referral_code_redemption?: Maybe<Espin_Referral_Code_Redemption_Mutation_Response>;
  /** update single row of the table: "espin.referral_code_redemption" */
  update_espin_referral_code_redemption_by_pk?: Maybe<Espin_Referral_Code_Redemption>;
  /** update multiples rows of table: "espin.referral_code_redemption" */
  update_espin_referral_code_redemption_many?: Maybe<Array<Maybe<Espin_Referral_Code_Redemption_Mutation_Response>>>;
  /** update data of the table: "espin.referral_option" */
  update_espin_referral_option?: Maybe<Espin_Referral_Option_Mutation_Response>;
  /** update single row of the table: "espin.referral_option" */
  update_espin_referral_option_by_pk?: Maybe<Espin_Referral_Option>;
  /** update multiples rows of table: "espin.referral_option" */
  update_espin_referral_option_many?: Maybe<Array<Maybe<Espin_Referral_Option_Mutation_Response>>>;
  /** update data of the table: "espin.role" */
  update_espin_role?: Maybe<Espin_Role_Mutation_Response>;
  /** update single row of the table: "espin.role" */
  update_espin_role_by_pk?: Maybe<Espin_Role>;
  /** update multiples rows of table: "espin.role" */
  update_espin_role_many?: Maybe<Array<Maybe<Espin_Role_Mutation_Response>>>;
  /** update data of the table: "espin.site_content" */
  update_espin_site_content?: Maybe<Espin_Site_Content_Mutation_Response>;
  /** update single row of the table: "espin.site_content" */
  update_espin_site_content_by_pk?: Maybe<Espin_Site_Content>;
  /** update multiples rows of table: "espin.site_content" */
  update_espin_site_content_many?: Maybe<Array<Maybe<Espin_Site_Content_Mutation_Response>>>;
  /** update data of the table: "espin.social" */
  update_espin_social?: Maybe<Espin_Social_Mutation_Response>;
  /** update single row of the table: "espin.social" */
  update_espin_social_by_pk?: Maybe<Espin_Social>;
  /** update multiples rows of table: "espin.social" */
  update_espin_social_many?: Maybe<Array<Maybe<Espin_Social_Mutation_Response>>>;
  /** update data of the table: "espin.stickied_college" */
  update_espin_stickied_college?: Maybe<Espin_Stickied_College_Mutation_Response>;
  /** update single row of the table: "espin.stickied_college" */
  update_espin_stickied_college_by_pk?: Maybe<Espin_Stickied_College>;
  /** update multiples rows of table: "espin.stickied_college" */
  update_espin_stickied_college_many?: Maybe<Array<Maybe<Espin_Stickied_College_Mutation_Response>>>;
  /** update data of the table: "espin.stickied_player" */
  update_espin_stickied_player?: Maybe<Espin_Stickied_Player_Mutation_Response>;
  /** update single row of the table: "espin.stickied_player" */
  update_espin_stickied_player_by_pk?: Maybe<Espin_Stickied_Player>;
  /** update multiples rows of table: "espin.stickied_player" */
  update_espin_stickied_player_many?: Maybe<Array<Maybe<Espin_Stickied_Player_Mutation_Response>>>;
  /** update data of the table: "espin.study_field" */
  update_espin_study_field?: Maybe<Espin_Study_Field_Mutation_Response>;
  /** update single row of the table: "espin.study_field" */
  update_espin_study_field_by_pk?: Maybe<Espin_Study_Field>;
  /** update multiples rows of table: "espin.study_field" */
  update_espin_study_field_many?: Maybe<Array<Maybe<Espin_Study_Field_Mutation_Response>>>;
  /** update data of the table: "espin.study_subject" */
  update_espin_study_subject?: Maybe<Espin_Study_Subject_Mutation_Response>;
  /** update single row of the table: "espin.study_subject" */
  update_espin_study_subject_by_pk?: Maybe<Espin_Study_Subject>;
  /** update multiples rows of table: "espin.study_subject" */
  update_espin_study_subject_many?: Maybe<Array<Maybe<Espin_Study_Subject_Mutation_Response>>>;
  /** update data of the table: "espin.subscription_status" */
  update_espin_subscription_status?: Maybe<Espin_Subscription_Status_Mutation_Response>;
  /** update single row of the table: "espin.subscription_status" */
  update_espin_subscription_status_by_pk?: Maybe<Espin_Subscription_Status>;
  /** update multiples rows of table: "espin.subscription_status" */
  update_espin_subscription_status_many?: Maybe<Array<Maybe<Espin_Subscription_Status_Mutation_Response>>>;
  /** update data of the table: "espin.subscription_tier_type" */
  update_espin_subscription_tier_type?: Maybe<Espin_Subscription_Tier_Type_Mutation_Response>;
  /** update single row of the table: "espin.subscription_tier_type" */
  update_espin_subscription_tier_type_by_pk?: Maybe<Espin_Subscription_Tier_Type>;
  /** update multiples rows of table: "espin.subscription_tier_type" */
  update_espin_subscription_tier_type_many?: Maybe<Array<Maybe<Espin_Subscription_Tier_Type_Mutation_Response>>>;
  /** update data of the table: "espin.team" */
  update_espin_team?: Maybe<Espin_Team_Mutation_Response>;
  /** update single row of the table: "espin.team" */
  update_espin_team_by_pk?: Maybe<Espin_Team>;
  /** update data of the table: "espin.team_invite" */
  update_espin_team_invite?: Maybe<Espin_Team_Invite_Mutation_Response>;
  /** update single row of the table: "espin.team_invite" */
  update_espin_team_invite_by_pk?: Maybe<Espin_Team_Invite>;
  /** update multiples rows of table: "espin.team_invite" */
  update_espin_team_invite_many?: Maybe<Array<Maybe<Espin_Team_Invite_Mutation_Response>>>;
  /** update multiples rows of table: "espin.team" */
  update_espin_team_many?: Maybe<Array<Maybe<Espin_Team_Mutation_Response>>>;
  /** update data of the table: "espin.team_members" */
  update_espin_team_members?: Maybe<Espin_Team_Members_Mutation_Response>;
  /** update single row of the table: "espin.team_members" */
  update_espin_team_members_by_pk?: Maybe<Espin_Team_Members>;
  /** update multiples rows of table: "espin.team_members" */
  update_espin_team_members_many?: Maybe<Array<Maybe<Espin_Team_Members_Mutation_Response>>>;
  /** update data of the table: "espin.team_role" */
  update_espin_team_role?: Maybe<Espin_Team_Role_Mutation_Response>;
  /** update single row of the table: "espin.team_role" */
  update_espin_team_role_by_pk?: Maybe<Espin_Team_Role>;
  /** update multiples rows of table: "espin.team_role" */
  update_espin_team_role_many?: Maybe<Array<Maybe<Espin_Team_Role_Mutation_Response>>>;
  /** update data of the table: "espin.team_type" */
  update_espin_team_type?: Maybe<Espin_Team_Type_Mutation_Response>;
  /** update single row of the table: "espin.team_type" */
  update_espin_team_type_by_pk?: Maybe<Espin_Team_Type>;
  /** update multiples rows of table: "espin.team_type" */
  update_espin_team_type_many?: Maybe<Array<Maybe<Espin_Team_Type_Mutation_Response>>>;
  /** update data of the table: "espin.unregistered_college" */
  update_espin_unregistered_college?: Maybe<Espin_Unregistered_College_Mutation_Response>;
  /** update single row of the table: "espin.unregistered_college" */
  update_espin_unregistered_college_by_pk?: Maybe<Espin_Unregistered_College>;
  /** update multiples rows of table: "espin.unregistered_college" */
  update_espin_unregistered_college_many?: Maybe<Array<Maybe<Espin_Unregistered_College_Mutation_Response>>>;
  /** update data of the table: "espin.user" */
  update_espin_user?: Maybe<Espin_User_Mutation_Response>;
  /** update single row of the table: "espin.user" */
  update_espin_user_by_pk?: Maybe<Espin_User>;
  /** update data of the table: "espin.user_linked_external_provider" */
  update_espin_user_linked_external_provider?: Maybe<Espin_User_Linked_External_Provider_Mutation_Response>;
  /** update single row of the table: "espin.user_linked_external_provider" */
  update_espin_user_linked_external_provider_by_pk?: Maybe<Espin_User_Linked_External_Provider>;
  /** update multiples rows of table: "espin.user_linked_external_provider" */
  update_espin_user_linked_external_provider_many?: Maybe<Array<Maybe<Espin_User_Linked_External_Provider_Mutation_Response>>>;
  /** update multiples rows of table: "espin.user" */
  update_espin_user_many?: Maybe<Array<Maybe<Espin_User_Mutation_Response>>>;
  /** update data of the table: "espin.user_membership" */
  update_espin_user_membership?: Maybe<Espin_User_Membership_Mutation_Response>;
  /** update single row of the table: "espin.user_membership" */
  update_espin_user_membership_by_pk?: Maybe<Espin_User_Membership>;
  /** update multiples rows of table: "espin.user_membership" */
  update_espin_user_membership_many?: Maybe<Array<Maybe<Espin_User_Membership_Mutation_Response>>>;
  /** update data of the table: "espin.user_source" */
  update_espin_user_source?: Maybe<Espin_User_Source_Mutation_Response>;
  /** update single row of the table: "espin.user_source" */
  update_espin_user_source_by_pk?: Maybe<Espin_User_Source>;
  /** update multiples rows of table: "espin.user_source" */
  update_espin_user_source_many?: Maybe<Array<Maybe<Espin_User_Source_Mutation_Response>>>;
  /** update data of the table: "queue.job" */
  update_queue_job?: Maybe<Queue_Job_Mutation_Response>;
  /** update single row of the table: "queue.job" */
  update_queue_job_by_pk?: Maybe<Queue_Job>;
  /** update multiples rows of table: "queue.job" */
  update_queue_job_many?: Maybe<Array<Maybe<Queue_Job_Mutation_Response>>>;
  /** update data of the table: "queue.job_status_type" */
  update_queue_job_status_type?: Maybe<Queue_Job_Status_Type_Mutation_Response>;
  /** update single row of the table: "queue.job_status_type" */
  update_queue_job_status_type_by_pk?: Maybe<Queue_Job_Status_Type>;
  /** update multiples rows of table: "queue.job_status_type" */
  update_queue_job_status_type_many?: Maybe<Array<Maybe<Queue_Job_Status_Type_Mutation_Response>>>;
  /** update data of the table: "queue.job_type" */
  update_queue_job_type?: Maybe<Queue_Job_Type_Mutation_Response>;
  /** update single row of the table: "queue.job_type" */
  update_queue_job_type_by_pk?: Maybe<Queue_Job_Type>;
  /** update multiples rows of table: "queue.job_type" */
  update_queue_job_type_many?: Maybe<Array<Maybe<Queue_Job_Type_Mutation_Response>>>;
  /** update data of the table: "stripe.customer_data" */
  update_stripe_customer_data?: Maybe<Stripe_Customer_Data_Mutation_Response>;
  /** update single row of the table: "stripe.customer_data" */
  update_stripe_customer_data_by_pk?: Maybe<Stripe_Customer_Data>;
  /** update multiples rows of table: "stripe.customer_data" */
  update_stripe_customer_data_many?: Maybe<Array<Maybe<Stripe_Customer_Data_Mutation_Response>>>;
  /** update data of the table: "stripe.invoice_data" */
  update_stripe_invoice_data?: Maybe<Stripe_Invoice_Data_Mutation_Response>;
  /** update single row of the table: "stripe.invoice_data" */
  update_stripe_invoice_data_by_pk?: Maybe<Stripe_Invoice_Data>;
  /** update multiples rows of table: "stripe.invoice_data" */
  update_stripe_invoice_data_many?: Maybe<Array<Maybe<Stripe_Invoice_Data_Mutation_Response>>>;
  /** update data of the table: "stripe.stripe_payment_data" */
  update_stripe_stripe_payment_data?: Maybe<Stripe_Stripe_Payment_Data_Mutation_Response>;
  /** update single row of the table: "stripe.stripe_payment_data" */
  update_stripe_stripe_payment_data_by_pk?: Maybe<Stripe_Stripe_Payment_Data>;
  /** update multiples rows of table: "stripe.stripe_payment_data" */
  update_stripe_stripe_payment_data_many?: Maybe<Array<Maybe<Stripe_Stripe_Payment_Data_Mutation_Response>>>;
  /** update data of the table: "stripe.stripe_subscription_data" */
  update_stripe_stripe_subscription_data?: Maybe<Stripe_Stripe_Subscription_Data_Mutation_Response>;
  /** update single row of the table: "stripe.stripe_subscription_data" */
  update_stripe_stripe_subscription_data_by_pk?: Maybe<Stripe_Stripe_Subscription_Data>;
  /** update multiples rows of table: "stripe.stripe_subscription_data" */
  update_stripe_stripe_subscription_data_many?: Maybe<Array<Maybe<Stripe_Stripe_Subscription_Data_Mutation_Response>>>;
  /** update data of the table: "tempstorage.keyvalue" */
  update_tempstorage_keyvalue?: Maybe<Tempstorage_Keyvalue_Mutation_Response>;
  /** update single row of the table: "tempstorage.keyvalue" */
  update_tempstorage_keyvalue_by_pk?: Maybe<Tempstorage_Keyvalue>;
  /** update multiples rows of table: "tempstorage.keyvalue" */
  update_tempstorage_keyvalue_many?: Maybe<Array<Maybe<Tempstorage_Keyvalue_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootSubmitPlayerProfileUpdateArgs = {
  input: SubmitPlayerProfileUpdateEspinDraftPlayerProfileInsertInput;
};


/** mutation root */
export type Mutation_RootAcceptCollegeInviteArgs = {
  input: AcceptCollegeInviteInput;
};


/** mutation root */
export type Mutation_RootCreateEventTicketPaymentIntentArgs = {
  input: EventTicketPaymentIntent;
};


/** mutation root */
export type Mutation_RootCreateFileUploadUrlArgs = {
  input: FileUploadUrlRequestInput;
};


/** mutation root */
export type Mutation_RootCreateHighSchoolTeamArgs = {
  input: CreateHighSchoolTeamInput;
};


/** mutation root */
export type Mutation_RootCreatePlayerTeamArgs = {
  input: CreatePlayerTeamInput;
};


/** mutation root */
export type Mutation_RootDelete_Cehsite_Ms_Available_Site_TermsArgs = {
  where: Cehsite_Ms_Available_Site_Terms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cehsite_Ms_Available_Site_Terms_By_PkArgs = {
  key: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Cehsite_Ms_Contact_Form_EntryArgs = {
  where: Cehsite_Ms_Contact_Form_Entry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cehsite_Ms_Contact_Form_Entry_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Cehsite_Ms_Newsletter_SignupArgs = {
  where: Cehsite_Ms_Newsletter_Signup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cehsite_Ms_Newsletter_Signup_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Cehsite_Ms_Site_ContentArgs = {
  where: Cehsite_Ms_Site_Content_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cehsite_Ms_Site_Content_By_PkArgs = {
  key: Cehsite_Ms_Available_Site_Terms_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Content_FileArgs = {
  where: Content_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Content_File_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Content_File_MetadataArgs = {
  where: Content_File_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Content_File_Metadata_By_PkArgs = {
  file_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Content_File_StatusArgs = {
  where: Content_File_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Content_File_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Content_Media_LinkArgs = {
  where: Content_Media_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Content_Media_Link_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Content_Media_Link_TypeArgs = {
  where: Content_Media_Link_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Content_Media_Link_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Content_Project_NameArgs = {
  where: Content_Project_Name_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Content_Project_Name_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Content_StatusArgs = {
  where: Content_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Content_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_AddressArgs = {
  where: Espin_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Address_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Boolean_Feature_FlagArgs = {
  where: Espin_Boolean_Feature_Flag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Boolean_Feature_Flag_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Coach_ProfileArgs = {
  where: Espin_Coach_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Coach_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_CollegeArgs = {
  where: Espin_College_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_Automatic_Message_Response_TypeArgs = {
  where: Espin_College_Automatic_Message_Response_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_Automatic_Message_Response_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_GameArgs = {
  where: Espin_College_Game_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_Game_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_ImageArgs = {
  where: Espin_College_Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_Image_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_InviteArgs = {
  where: Espin_College_Invite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_PreferencesArgs = {
  where: Espin_College_Preferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_Preferences_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_ProfileArgs = {
  where: Espin_College_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_RosterArgs = {
  where: Espin_College_Roster_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_Roster_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_Staff_MemberArgs = {
  where: Espin_College_Staff_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_Staff_Member_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_SubscriptionArgs = {
  where: Espin_College_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_Subscription_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_Verification_Status_TypeArgs = {
  where: Espin_College_Verification_Status_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_College_Verification_Status_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Draft_Player_ProfileArgs = {
  where: Espin_Draft_Player_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Draft_Player_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Editable_Site_ContentArgs = {
  where: Espin_Editable_Site_Content_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Editable_Site_Content_By_PkArgs = {
  key: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Ethnicity_OptionsArgs = {
  where: Espin_Ethnicity_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Ethnicity_Options_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_EventArgs = {
  where: Espin_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Custom_FieldArgs = {
  where: Espin_Event_Custom_Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Custom_Field_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Custom_Field_TypeArgs = {
  where: Espin_Event_Custom_Field_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Custom_Field_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_DocumentArgs = {
  where: Espin_Event_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Document_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_GameArgs = {
  where: Espin_Event_Game_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Game_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_RegistrationArgs = {
  where: Espin_Event_Registration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Registration_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Registration_Custom_Field_EntryArgs = {
  where: Espin_Event_Registration_Custom_Field_Entry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Registration_Custom_Field_Entry_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Registration_Document_SignoffArgs = {
  where: Espin_Event_Registration_Document_Signoff_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Registration_Document_Signoff_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Registration_StatusArgs = {
  where: Espin_Event_Registration_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Registration_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_TicketArgs = {
  where: Espin_Event_Ticket_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Ticket_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Ticket_TypeArgs = {
  where: Espin_Event_Ticket_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Ticket_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_TypeArgs = {
  where: Espin_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Event_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_External_ProviderArgs = {
  where: Espin_External_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_External_Provider_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_External_Provider_LinkArgs = {
  where: Espin_External_Provider_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_External_Provider_Link_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_FollowArgs = {
  where: Espin_Follow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Follow_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Follow_TypeArgs = {
  where: Espin_Follow_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Follow_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Follower_Email_Notification_TypeArgs = {
  where: Espin_Follower_Email_Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Follower_Email_Notification_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Force_Notification_ReloadArgs = {
  where: Espin_Force_Notification_Reload_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Force_Notification_Reload_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_GameArgs = {
  where: Espin_Game_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Game_By_PkArgs = {
  game_definition: Espin_Game_Definition_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Game_DefinitionArgs = {
  where: Espin_Game_Definition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Game_Definition_By_PkArgs = {
  game_name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Game_PlatformArgs = {
  where: Espin_Game_Platform_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Game_Platform_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Gender_OptionsArgs = {
  where: Espin_Gender_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Gender_Options_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Graduating_ClassArgs = {
  where: Espin_Graduating_Class_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Graduating_Class_By_PkArgs = {
  grad_class_years: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_High_SchoolArgs = {
  where: Espin_High_School_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_High_School_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_High_School_InviteArgs = {
  where: Espin_High_School_Invite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_High_School_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_High_School_ProfileArgs = {
  where: Espin_High_School_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_High_School_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Invite_Status_TypeArgs = {
  where: Espin_Invite_Status_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Invite_Status_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_LeaderboardArgs = {
  where: Espin_Leaderboard_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Leaderboard_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_MembershipArgs = {
  where: Espin_Membership_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Membership_By_PkArgs = {
  membership_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_MessageArgs = {
  where: Espin_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Message_Email_Notification_TypeArgs = {
  where: Espin_Message_Email_Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Message_Email_Notification_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Message_TypeArgs = {
  where: Espin_Message_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Message_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Moderation_StatusArgs = {
  where: Espin_Moderation_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Moderation_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Newsletter_RequestArgs = {
  where: Espin_Newsletter_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Newsletter_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_NotificationArgs = {
  where: Espin_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Notification_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Notification_TypeArgs = {
  where: Espin_Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Notification_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_OrgArgs = {
  where: Espin_Org_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Org_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Org_MonthArgs = {
  where: Espin_Org_Month_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Org_Month_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Org_Month_DayArgs = {
  where: Espin_Org_Month_Day_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Org_Month_Day_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Org_PlayerArgs = {
  where: Espin_Org_Player_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Org_Player_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Org_SchoolArgs = {
  where: Espin_Org_School_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Org_School_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Org_School_RecordArgs = {
  where: Espin_Org_School_Record_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Org_School_Record_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Paid_ProductArgs = {
  where: Espin_Paid_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Paid_Product_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Parent_InviteArgs = {
  where: Espin_Parent_Invite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Parent_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Parent_ProfileArgs = {
  where: Espin_Parent_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Parent_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_GameArgs = {
  where: Espin_Player_Game_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Game_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_JourneyArgs = {
  where: Espin_Player_Journey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Journey_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Journey_StageArgs = {
  where: Espin_Player_Journey_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Journey_Stage_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Journey_Stage_CollegeArgs = {
  where: Espin_Player_Journey_Stage_College_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Journey_Stage_College_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Journey_Stage_DefArgs = {
  where: Espin_Player_Journey_Stage_Def_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Journey_Stage_Def_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Journey_Stage_ImageArgs = {
  where: Espin_Player_Journey_Stage_Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Journey_Stage_Image_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Journey_Stage_QuoteArgs = {
  where: Espin_Player_Journey_Stage_Quote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Journey_Stage_Quote_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Journey_Stage_VideoArgs = {
  where: Espin_Player_Journey_Stage_Video_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Journey_Stage_Video_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_ProfileArgs = {
  where: Espin_Player_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_SubscriptionArgs = {
  where: Espin_Player_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Subscription_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_VodArgs = {
  where: Espin_Player_Vod_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Player_Vod_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Profile_ViewArgs = {
  where: Espin_Profile_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Profile_View_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Profile_View_Email_Notification_TypeArgs = {
  where: Espin_Profile_View_Email_Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Profile_View_Email_Notification_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Profile_View_TypeArgs = {
  where: Espin_Profile_View_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Profile_View_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Referral_CodeArgs = {
  where: Espin_Referral_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Referral_Code_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Referral_Code_RedemptionArgs = {
  where: Espin_Referral_Code_Redemption_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Referral_Code_Redemption_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Referral_OptionArgs = {
  where: Espin_Referral_Option_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Referral_Option_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_RoleArgs = {
  where: Espin_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Role_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Site_ContentArgs = {
  where: Espin_Site_Content_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Site_Content_By_PkArgs = {
  key: Espin_Editable_Site_Content_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Espin_SocialArgs = {
  where: Espin_Social_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Social_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Stickied_CollegeArgs = {
  where: Espin_Stickied_College_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Stickied_College_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Stickied_PlayerArgs = {
  where: Espin_Stickied_Player_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Stickied_Player_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Study_FieldArgs = {
  where: Espin_Study_Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Study_Field_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Study_SubjectArgs = {
  where: Espin_Study_Subject_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Study_Subject_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Subscription_StatusArgs = {
  where: Espin_Subscription_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Subscription_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Subscription_Tier_TypeArgs = {
  where: Espin_Subscription_Tier_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Subscription_Tier_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_TeamArgs = {
  where: Espin_Team_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Team_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Team_InviteArgs = {
  where: Espin_Team_Invite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Team_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Team_MembersArgs = {
  where: Espin_Team_Members_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Team_Members_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Team_RoleArgs = {
  where: Espin_Team_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Team_Role_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Team_TypeArgs = {
  where: Espin_Team_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Team_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_Unregistered_CollegeArgs = {
  where: Espin_Unregistered_College_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_Unregistered_College_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_UserArgs = {
  where: Espin_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_User_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_User_Linked_External_ProviderArgs = {
  where: Espin_User_Linked_External_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_User_Linked_External_Provider_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_User_MembershipArgs = {
  where: Espin_User_Membership_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_User_Membership_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Espin_User_SourceArgs = {
  where: Espin_User_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Espin_User_Source_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Queue_JobArgs = {
  where: Queue_Job_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Queue_Job_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Queue_Job_Status_TypeArgs = {
  where: Queue_Job_Status_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Queue_Job_Status_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Queue_Job_TypeArgs = {
  where: Queue_Job_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Queue_Job_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Customer_DataArgs = {
  where: Stripe_Customer_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Customer_Data_By_PkArgs = {
  customer_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Invoice_DataArgs = {
  where: Stripe_Invoice_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Invoice_Data_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Stripe_Payment_DataArgs = {
  where: Stripe_Stripe_Payment_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Stripe_Payment_Data_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Stripe_Subscription_DataArgs = {
  where: Stripe_Stripe_Subscription_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Stripe_Subscription_Data_By_PkArgs = {
  customer: Scalars['String'];
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Tempstorage_KeyvalueArgs = {
  where: Tempstorage_Keyvalue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tempstorage_Keyvalue_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootEditHighSchoolTeamArgs = {
  input: EditHighSchoolTeamInput;
};


/** mutation root */
export type Mutation_RootEditPlayerTeamArgs = {
  input: EditPlayerTeamInput;
};


/** mutation root */
export type Mutation_RootInsert_Cehsite_Ms_Available_Site_TermsArgs = {
  objects: Array<Cehsite_Ms_Available_Site_Terms_Insert_Input>;
  on_conflict?: InputMaybe<Cehsite_Ms_Available_Site_Terms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cehsite_Ms_Available_Site_Terms_OneArgs = {
  object: Cehsite_Ms_Available_Site_Terms_Insert_Input;
  on_conflict?: InputMaybe<Cehsite_Ms_Available_Site_Terms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cehsite_Ms_Contact_Form_EntryArgs = {
  objects: Array<Cehsite_Ms_Contact_Form_Entry_Insert_Input>;
  on_conflict?: InputMaybe<Cehsite_Ms_Contact_Form_Entry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cehsite_Ms_Contact_Form_Entry_OneArgs = {
  object: Cehsite_Ms_Contact_Form_Entry_Insert_Input;
  on_conflict?: InputMaybe<Cehsite_Ms_Contact_Form_Entry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cehsite_Ms_Newsletter_SignupArgs = {
  objects: Array<Cehsite_Ms_Newsletter_Signup_Insert_Input>;
  on_conflict?: InputMaybe<Cehsite_Ms_Newsletter_Signup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cehsite_Ms_Newsletter_Signup_OneArgs = {
  object: Cehsite_Ms_Newsletter_Signup_Insert_Input;
  on_conflict?: InputMaybe<Cehsite_Ms_Newsletter_Signup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cehsite_Ms_Site_ContentArgs = {
  objects: Array<Cehsite_Ms_Site_Content_Insert_Input>;
  on_conflict?: InputMaybe<Cehsite_Ms_Site_Content_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cehsite_Ms_Site_Content_OneArgs = {
  object: Cehsite_Ms_Site_Content_Insert_Input;
  on_conflict?: InputMaybe<Cehsite_Ms_Site_Content_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_FileArgs = {
  objects: Array<Content_File_Insert_Input>;
  on_conflict?: InputMaybe<Content_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_File_MetadataArgs = {
  objects: Array<Content_File_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Content_File_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_File_Metadata_OneArgs = {
  object: Content_File_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Content_File_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_File_OneArgs = {
  object: Content_File_Insert_Input;
  on_conflict?: InputMaybe<Content_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_File_StatusArgs = {
  objects: Array<Content_File_Status_Insert_Input>;
  on_conflict?: InputMaybe<Content_File_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_File_Status_OneArgs = {
  object: Content_File_Status_Insert_Input;
  on_conflict?: InputMaybe<Content_File_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_Media_LinkArgs = {
  objects: Array<Content_Media_Link_Insert_Input>;
  on_conflict?: InputMaybe<Content_Media_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_Media_Link_OneArgs = {
  object: Content_Media_Link_Insert_Input;
  on_conflict?: InputMaybe<Content_Media_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_Media_Link_TypeArgs = {
  objects: Array<Content_Media_Link_Type_Insert_Input>;
  on_conflict?: InputMaybe<Content_Media_Link_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_Media_Link_Type_OneArgs = {
  object: Content_Media_Link_Type_Insert_Input;
  on_conflict?: InputMaybe<Content_Media_Link_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_Project_NameArgs = {
  objects: Array<Content_Project_Name_Insert_Input>;
  on_conflict?: InputMaybe<Content_Project_Name_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_Project_Name_OneArgs = {
  object: Content_Project_Name_Insert_Input;
  on_conflict?: InputMaybe<Content_Project_Name_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_StatusArgs = {
  objects: Array<Content_Status_Insert_Input>;
  on_conflict?: InputMaybe<Content_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_Status_OneArgs = {
  object: Content_Status_Insert_Input;
  on_conflict?: InputMaybe<Content_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_AddressArgs = {
  objects: Array<Espin_Address_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Address_OneArgs = {
  object: Espin_Address_Insert_Input;
  on_conflict?: InputMaybe<Espin_Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Boolean_Feature_FlagArgs = {
  objects: Array<Espin_Boolean_Feature_Flag_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Boolean_Feature_Flag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Boolean_Feature_Flag_OneArgs = {
  object: Espin_Boolean_Feature_Flag_Insert_Input;
  on_conflict?: InputMaybe<Espin_Boolean_Feature_Flag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Coach_ProfileArgs = {
  objects: Array<Espin_Coach_Profile_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Coach_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Coach_Profile_OneArgs = {
  object: Espin_Coach_Profile_Insert_Input;
  on_conflict?: InputMaybe<Espin_Coach_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_CollegeArgs = {
  objects: Array<Espin_College_Insert_Input>;
  on_conflict?: InputMaybe<Espin_College_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_Automatic_Message_Response_TypeArgs = {
  objects: Array<Espin_College_Automatic_Message_Response_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_College_Automatic_Message_Response_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_Automatic_Message_Response_Type_OneArgs = {
  object: Espin_College_Automatic_Message_Response_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_College_Automatic_Message_Response_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_GameArgs = {
  objects: Array<Espin_College_Game_Insert_Input>;
  on_conflict?: InputMaybe<Espin_College_Game_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_Game_OneArgs = {
  object: Espin_College_Game_Insert_Input;
  on_conflict?: InputMaybe<Espin_College_Game_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_ImageArgs = {
  objects: Array<Espin_College_Image_Insert_Input>;
  on_conflict?: InputMaybe<Espin_College_Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_Image_OneArgs = {
  object: Espin_College_Image_Insert_Input;
  on_conflict?: InputMaybe<Espin_College_Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_InviteArgs = {
  objects: Array<Espin_College_Invite_Insert_Input>;
  on_conflict?: InputMaybe<Espin_College_Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_Invite_OneArgs = {
  object: Espin_College_Invite_Insert_Input;
  on_conflict?: InputMaybe<Espin_College_Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_OneArgs = {
  object: Espin_College_Insert_Input;
  on_conflict?: InputMaybe<Espin_College_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_PreferencesArgs = {
  objects: Array<Espin_College_Preferences_Insert_Input>;
  on_conflict?: InputMaybe<Espin_College_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_Preferences_OneArgs = {
  object: Espin_College_Preferences_Insert_Input;
  on_conflict?: InputMaybe<Espin_College_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_ProfileArgs = {
  objects: Array<Espin_College_Profile_Insert_Input>;
  on_conflict?: InputMaybe<Espin_College_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_Profile_OneArgs = {
  object: Espin_College_Profile_Insert_Input;
  on_conflict?: InputMaybe<Espin_College_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_RosterArgs = {
  objects: Array<Espin_College_Roster_Insert_Input>;
  on_conflict?: InputMaybe<Espin_College_Roster_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_Roster_OneArgs = {
  object: Espin_College_Roster_Insert_Input;
  on_conflict?: InputMaybe<Espin_College_Roster_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_Staff_MemberArgs = {
  objects: Array<Espin_College_Staff_Member_Insert_Input>;
  on_conflict?: InputMaybe<Espin_College_Staff_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_Staff_Member_OneArgs = {
  object: Espin_College_Staff_Member_Insert_Input;
  on_conflict?: InputMaybe<Espin_College_Staff_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_SubscriptionArgs = {
  objects: Array<Espin_College_Subscription_Insert_Input>;
  on_conflict?: InputMaybe<Espin_College_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_Subscription_OneArgs = {
  object: Espin_College_Subscription_Insert_Input;
  on_conflict?: InputMaybe<Espin_College_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_Verification_Status_TypeArgs = {
  objects: Array<Espin_College_Verification_Status_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_College_Verification_Status_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_College_Verification_Status_Type_OneArgs = {
  object: Espin_College_Verification_Status_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_College_Verification_Status_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Draft_Player_ProfileArgs = {
  objects: Array<Espin_Draft_Player_Profile_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Draft_Player_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Draft_Player_Profile_OneArgs = {
  object: Espin_Draft_Player_Profile_Insert_Input;
  on_conflict?: InputMaybe<Espin_Draft_Player_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Editable_Site_ContentArgs = {
  objects: Array<Espin_Editable_Site_Content_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Editable_Site_Content_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Editable_Site_Content_OneArgs = {
  object: Espin_Editable_Site_Content_Insert_Input;
  on_conflict?: InputMaybe<Espin_Editable_Site_Content_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Ethnicity_OptionsArgs = {
  objects: Array<Espin_Ethnicity_Options_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Ethnicity_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Ethnicity_Options_OneArgs = {
  object: Espin_Ethnicity_Options_Insert_Input;
  on_conflict?: InputMaybe<Espin_Ethnicity_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_EventArgs = {
  objects: Array<Espin_Event_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Custom_FieldArgs = {
  objects: Array<Espin_Event_Custom_Field_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Event_Custom_Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Custom_Field_OneArgs = {
  object: Espin_Event_Custom_Field_Insert_Input;
  on_conflict?: InputMaybe<Espin_Event_Custom_Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Custom_Field_TypeArgs = {
  objects: Array<Espin_Event_Custom_Field_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Event_Custom_Field_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Custom_Field_Type_OneArgs = {
  object: Espin_Event_Custom_Field_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_Event_Custom_Field_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_DocumentArgs = {
  objects: Array<Espin_Event_Document_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Event_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Document_OneArgs = {
  object: Espin_Event_Document_Insert_Input;
  on_conflict?: InputMaybe<Espin_Event_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_GameArgs = {
  objects: Array<Espin_Event_Game_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Event_Game_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Game_OneArgs = {
  object: Espin_Event_Game_Insert_Input;
  on_conflict?: InputMaybe<Espin_Event_Game_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_OneArgs = {
  object: Espin_Event_Insert_Input;
  on_conflict?: InputMaybe<Espin_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_RegistrationArgs = {
  objects: Array<Espin_Event_Registration_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Event_Registration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Registration_Custom_Field_EntryArgs = {
  objects: Array<Espin_Event_Registration_Custom_Field_Entry_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Registration_Custom_Field_Entry_OneArgs = {
  object: Espin_Event_Registration_Custom_Field_Entry_Insert_Input;
  on_conflict?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Registration_Document_SignoffArgs = {
  objects: Array<Espin_Event_Registration_Document_Signoff_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Event_Registration_Document_Signoff_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Registration_Document_Signoff_OneArgs = {
  object: Espin_Event_Registration_Document_Signoff_Insert_Input;
  on_conflict?: InputMaybe<Espin_Event_Registration_Document_Signoff_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Registration_OneArgs = {
  object: Espin_Event_Registration_Insert_Input;
  on_conflict?: InputMaybe<Espin_Event_Registration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Registration_StatusArgs = {
  objects: Array<Espin_Event_Registration_Status_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Event_Registration_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Registration_Status_OneArgs = {
  object: Espin_Event_Registration_Status_Insert_Input;
  on_conflict?: InputMaybe<Espin_Event_Registration_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_TicketArgs = {
  objects: Array<Espin_Event_Ticket_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Event_Ticket_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Ticket_OneArgs = {
  object: Espin_Event_Ticket_Insert_Input;
  on_conflict?: InputMaybe<Espin_Event_Ticket_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Ticket_TypeArgs = {
  objects: Array<Espin_Event_Ticket_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Event_Ticket_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Ticket_Type_OneArgs = {
  object: Espin_Event_Ticket_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_Event_Ticket_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_TypeArgs = {
  objects: Array<Espin_Event_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Event_Type_OneArgs = {
  object: Espin_Event_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_External_ProviderArgs = {
  objects: Array<Espin_External_Provider_Insert_Input>;
  on_conflict?: InputMaybe<Espin_External_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_External_Provider_LinkArgs = {
  objects: Array<Espin_External_Provider_Link_Insert_Input>;
  on_conflict?: InputMaybe<Espin_External_Provider_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_External_Provider_Link_OneArgs = {
  object: Espin_External_Provider_Link_Insert_Input;
  on_conflict?: InputMaybe<Espin_External_Provider_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_External_Provider_OneArgs = {
  object: Espin_External_Provider_Insert_Input;
  on_conflict?: InputMaybe<Espin_External_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_FollowArgs = {
  objects: Array<Espin_Follow_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Follow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Follow_OneArgs = {
  object: Espin_Follow_Insert_Input;
  on_conflict?: InputMaybe<Espin_Follow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Follow_TypeArgs = {
  objects: Array<Espin_Follow_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Follow_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Follow_Type_OneArgs = {
  object: Espin_Follow_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_Follow_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Follower_Email_Notification_TypeArgs = {
  objects: Array<Espin_Follower_Email_Notification_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Follower_Email_Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Follower_Email_Notification_Type_OneArgs = {
  object: Espin_Follower_Email_Notification_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_Follower_Email_Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Force_Notification_ReloadArgs = {
  objects: Array<Espin_Force_Notification_Reload_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Force_Notification_Reload_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Force_Notification_Reload_OneArgs = {
  object: Espin_Force_Notification_Reload_Insert_Input;
  on_conflict?: InputMaybe<Espin_Force_Notification_Reload_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_GameArgs = {
  objects: Array<Espin_Game_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Game_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Game_DefinitionArgs = {
  objects: Array<Espin_Game_Definition_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Game_Definition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Game_Definition_OneArgs = {
  object: Espin_Game_Definition_Insert_Input;
  on_conflict?: InputMaybe<Espin_Game_Definition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Game_OneArgs = {
  object: Espin_Game_Insert_Input;
  on_conflict?: InputMaybe<Espin_Game_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Game_PlatformArgs = {
  objects: Array<Espin_Game_Platform_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Game_Platform_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Game_Platform_OneArgs = {
  object: Espin_Game_Platform_Insert_Input;
  on_conflict?: InputMaybe<Espin_Game_Platform_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Gender_OptionsArgs = {
  objects: Array<Espin_Gender_Options_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Gender_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Gender_Options_OneArgs = {
  object: Espin_Gender_Options_Insert_Input;
  on_conflict?: InputMaybe<Espin_Gender_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Graduating_ClassArgs = {
  objects: Array<Espin_Graduating_Class_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Graduating_Class_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Graduating_Class_OneArgs = {
  object: Espin_Graduating_Class_Insert_Input;
  on_conflict?: InputMaybe<Espin_Graduating_Class_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_High_SchoolArgs = {
  objects: Array<Espin_High_School_Insert_Input>;
  on_conflict?: InputMaybe<Espin_High_School_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_High_School_InviteArgs = {
  objects: Array<Espin_High_School_Invite_Insert_Input>;
  on_conflict?: InputMaybe<Espin_High_School_Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_High_School_Invite_OneArgs = {
  object: Espin_High_School_Invite_Insert_Input;
  on_conflict?: InputMaybe<Espin_High_School_Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_High_School_OneArgs = {
  object: Espin_High_School_Insert_Input;
  on_conflict?: InputMaybe<Espin_High_School_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_High_School_ProfileArgs = {
  objects: Array<Espin_High_School_Profile_Insert_Input>;
  on_conflict?: InputMaybe<Espin_High_School_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_High_School_Profile_OneArgs = {
  object: Espin_High_School_Profile_Insert_Input;
  on_conflict?: InputMaybe<Espin_High_School_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Invite_Status_TypeArgs = {
  objects: Array<Espin_Invite_Status_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Invite_Status_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Invite_Status_Type_OneArgs = {
  object: Espin_Invite_Status_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_Invite_Status_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_LeaderboardArgs = {
  objects: Array<Espin_Leaderboard_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Leaderboard_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Leaderboard_OneArgs = {
  object: Espin_Leaderboard_Insert_Input;
  on_conflict?: InputMaybe<Espin_Leaderboard_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_MembershipArgs = {
  objects: Array<Espin_Membership_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Membership_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Membership_OneArgs = {
  object: Espin_Membership_Insert_Input;
  on_conflict?: InputMaybe<Espin_Membership_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_MessageArgs = {
  objects: Array<Espin_Message_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Message_Email_Notification_TypeArgs = {
  objects: Array<Espin_Message_Email_Notification_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Message_Email_Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Message_Email_Notification_Type_OneArgs = {
  object: Espin_Message_Email_Notification_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_Message_Email_Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Message_OneArgs = {
  object: Espin_Message_Insert_Input;
  on_conflict?: InputMaybe<Espin_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Message_TypeArgs = {
  objects: Array<Espin_Message_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Message_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Message_Type_OneArgs = {
  object: Espin_Message_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_Message_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Moderation_StatusArgs = {
  objects: Array<Espin_Moderation_Status_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Moderation_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Moderation_Status_OneArgs = {
  object: Espin_Moderation_Status_Insert_Input;
  on_conflict?: InputMaybe<Espin_Moderation_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Newsletter_RequestArgs = {
  objects: Array<Espin_Newsletter_Request_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Newsletter_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Newsletter_Request_OneArgs = {
  object: Espin_Newsletter_Request_Insert_Input;
  on_conflict?: InputMaybe<Espin_Newsletter_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_NotificationArgs = {
  objects: Array<Espin_Notification_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Notification_OneArgs = {
  object: Espin_Notification_Insert_Input;
  on_conflict?: InputMaybe<Espin_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Notification_TypeArgs = {
  objects: Array<Espin_Notification_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Notification_Type_OneArgs = {
  object: Espin_Notification_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_OrgArgs = {
  objects: Array<Espin_Org_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Org_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Org_MonthArgs = {
  objects: Array<Espin_Org_Month_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Org_Month_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Org_Month_DayArgs = {
  objects: Array<Espin_Org_Month_Day_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Org_Month_Day_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Org_Month_Day_OneArgs = {
  object: Espin_Org_Month_Day_Insert_Input;
  on_conflict?: InputMaybe<Espin_Org_Month_Day_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Org_Month_OneArgs = {
  object: Espin_Org_Month_Insert_Input;
  on_conflict?: InputMaybe<Espin_Org_Month_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Org_OneArgs = {
  object: Espin_Org_Insert_Input;
  on_conflict?: InputMaybe<Espin_Org_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Org_PlayerArgs = {
  objects: Array<Espin_Org_Player_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Org_Player_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Org_Player_OneArgs = {
  object: Espin_Org_Player_Insert_Input;
  on_conflict?: InputMaybe<Espin_Org_Player_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Org_SchoolArgs = {
  objects: Array<Espin_Org_School_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Org_School_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Org_School_OneArgs = {
  object: Espin_Org_School_Insert_Input;
  on_conflict?: InputMaybe<Espin_Org_School_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Org_School_RecordArgs = {
  objects: Array<Espin_Org_School_Record_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Org_School_Record_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Org_School_Record_OneArgs = {
  object: Espin_Org_School_Record_Insert_Input;
  on_conflict?: InputMaybe<Espin_Org_School_Record_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Paid_ProductArgs = {
  objects: Array<Espin_Paid_Product_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Paid_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Paid_Product_OneArgs = {
  object: Espin_Paid_Product_Insert_Input;
  on_conflict?: InputMaybe<Espin_Paid_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Parent_InviteArgs = {
  objects: Array<Espin_Parent_Invite_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Parent_Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Parent_Invite_OneArgs = {
  object: Espin_Parent_Invite_Insert_Input;
  on_conflict?: InputMaybe<Espin_Parent_Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Parent_ProfileArgs = {
  objects: Array<Espin_Parent_Profile_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Parent_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Parent_Profile_OneArgs = {
  object: Espin_Parent_Profile_Insert_Input;
  on_conflict?: InputMaybe<Espin_Parent_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_GameArgs = {
  objects: Array<Espin_Player_Game_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Player_Game_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Game_OneArgs = {
  object: Espin_Player_Game_Insert_Input;
  on_conflict?: InputMaybe<Espin_Player_Game_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_JourneyArgs = {
  objects: Array<Espin_Player_Journey_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Player_Journey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Journey_OneArgs = {
  object: Espin_Player_Journey_Insert_Input;
  on_conflict?: InputMaybe<Espin_Player_Journey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Journey_StageArgs = {
  objects: Array<Espin_Player_Journey_Stage_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Journey_Stage_CollegeArgs = {
  objects: Array<Espin_Player_Journey_Stage_College_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_College_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Journey_Stage_College_OneArgs = {
  object: Espin_Player_Journey_Stage_College_Insert_Input;
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_College_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Journey_Stage_DefArgs = {
  objects: Array<Espin_Player_Journey_Stage_Def_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_Def_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Journey_Stage_Def_OneArgs = {
  object: Espin_Player_Journey_Stage_Def_Insert_Input;
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_Def_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Journey_Stage_ImageArgs = {
  objects: Array<Espin_Player_Journey_Stage_Image_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Journey_Stage_Image_OneArgs = {
  object: Espin_Player_Journey_Stage_Image_Insert_Input;
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Journey_Stage_OneArgs = {
  object: Espin_Player_Journey_Stage_Insert_Input;
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Journey_Stage_QuoteArgs = {
  objects: Array<Espin_Player_Journey_Stage_Quote_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_Quote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Journey_Stage_Quote_OneArgs = {
  object: Espin_Player_Journey_Stage_Quote_Insert_Input;
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_Quote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Journey_Stage_VideoArgs = {
  objects: Array<Espin_Player_Journey_Stage_Video_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_Video_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Journey_Stage_Video_OneArgs = {
  object: Espin_Player_Journey_Stage_Video_Insert_Input;
  on_conflict?: InputMaybe<Espin_Player_Journey_Stage_Video_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_ProfileArgs = {
  objects: Array<Espin_Player_Profile_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Player_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Profile_OneArgs = {
  object: Espin_Player_Profile_Insert_Input;
  on_conflict?: InputMaybe<Espin_Player_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_SubscriptionArgs = {
  objects: Array<Espin_Player_Subscription_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Player_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Subscription_OneArgs = {
  object: Espin_Player_Subscription_Insert_Input;
  on_conflict?: InputMaybe<Espin_Player_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_VodArgs = {
  objects: Array<Espin_Player_Vod_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Player_Vod_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Player_Vod_OneArgs = {
  object: Espin_Player_Vod_Insert_Input;
  on_conflict?: InputMaybe<Espin_Player_Vod_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Profile_ViewArgs = {
  objects: Array<Espin_Profile_View_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Profile_View_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Profile_View_Email_Notification_TypeArgs = {
  objects: Array<Espin_Profile_View_Email_Notification_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Profile_View_Email_Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Profile_View_Email_Notification_Type_OneArgs = {
  object: Espin_Profile_View_Email_Notification_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_Profile_View_Email_Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Profile_View_OneArgs = {
  object: Espin_Profile_View_Insert_Input;
  on_conflict?: InputMaybe<Espin_Profile_View_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Profile_View_TypeArgs = {
  objects: Array<Espin_Profile_View_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Profile_View_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Profile_View_Type_OneArgs = {
  object: Espin_Profile_View_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_Profile_View_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Referral_CodeArgs = {
  objects: Array<Espin_Referral_Code_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Referral_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Referral_Code_OneArgs = {
  object: Espin_Referral_Code_Insert_Input;
  on_conflict?: InputMaybe<Espin_Referral_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Referral_Code_RedemptionArgs = {
  objects: Array<Espin_Referral_Code_Redemption_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Referral_Code_Redemption_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Referral_Code_Redemption_OneArgs = {
  object: Espin_Referral_Code_Redemption_Insert_Input;
  on_conflict?: InputMaybe<Espin_Referral_Code_Redemption_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Referral_OptionArgs = {
  objects: Array<Espin_Referral_Option_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Referral_Option_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Referral_Option_OneArgs = {
  object: Espin_Referral_Option_Insert_Input;
  on_conflict?: InputMaybe<Espin_Referral_Option_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_RoleArgs = {
  objects: Array<Espin_Role_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Role_OneArgs = {
  object: Espin_Role_Insert_Input;
  on_conflict?: InputMaybe<Espin_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Site_ContentArgs = {
  objects: Array<Espin_Site_Content_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Site_Content_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Site_Content_OneArgs = {
  object: Espin_Site_Content_Insert_Input;
  on_conflict?: InputMaybe<Espin_Site_Content_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_SocialArgs = {
  objects: Array<Espin_Social_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Social_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Social_OneArgs = {
  object: Espin_Social_Insert_Input;
  on_conflict?: InputMaybe<Espin_Social_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Stickied_CollegeArgs = {
  objects: Array<Espin_Stickied_College_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Stickied_College_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Stickied_College_OneArgs = {
  object: Espin_Stickied_College_Insert_Input;
  on_conflict?: InputMaybe<Espin_Stickied_College_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Stickied_PlayerArgs = {
  objects: Array<Espin_Stickied_Player_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Stickied_Player_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Stickied_Player_OneArgs = {
  object: Espin_Stickied_Player_Insert_Input;
  on_conflict?: InputMaybe<Espin_Stickied_Player_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Study_FieldArgs = {
  objects: Array<Espin_Study_Field_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Study_Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Study_Field_OneArgs = {
  object: Espin_Study_Field_Insert_Input;
  on_conflict?: InputMaybe<Espin_Study_Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Study_SubjectArgs = {
  objects: Array<Espin_Study_Subject_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Study_Subject_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Study_Subject_OneArgs = {
  object: Espin_Study_Subject_Insert_Input;
  on_conflict?: InputMaybe<Espin_Study_Subject_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Subscription_StatusArgs = {
  objects: Array<Espin_Subscription_Status_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Subscription_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Subscription_Status_OneArgs = {
  object: Espin_Subscription_Status_Insert_Input;
  on_conflict?: InputMaybe<Espin_Subscription_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Subscription_Tier_TypeArgs = {
  objects: Array<Espin_Subscription_Tier_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Subscription_Tier_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Subscription_Tier_Type_OneArgs = {
  object: Espin_Subscription_Tier_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_Subscription_Tier_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_TeamArgs = {
  objects: Array<Espin_Team_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Team_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Team_InviteArgs = {
  objects: Array<Espin_Team_Invite_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Team_Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Team_Invite_OneArgs = {
  object: Espin_Team_Invite_Insert_Input;
  on_conflict?: InputMaybe<Espin_Team_Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Team_MembersArgs = {
  objects: Array<Espin_Team_Members_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Team_Members_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Team_Members_OneArgs = {
  object: Espin_Team_Members_Insert_Input;
  on_conflict?: InputMaybe<Espin_Team_Members_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Team_OneArgs = {
  object: Espin_Team_Insert_Input;
  on_conflict?: InputMaybe<Espin_Team_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Team_RoleArgs = {
  objects: Array<Espin_Team_Role_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Team_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Team_Role_OneArgs = {
  object: Espin_Team_Role_Insert_Input;
  on_conflict?: InputMaybe<Espin_Team_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Team_TypeArgs = {
  objects: Array<Espin_Team_Type_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Team_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Team_Type_OneArgs = {
  object: Espin_Team_Type_Insert_Input;
  on_conflict?: InputMaybe<Espin_Team_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Unregistered_CollegeArgs = {
  objects: Array<Espin_Unregistered_College_Insert_Input>;
  on_conflict?: InputMaybe<Espin_Unregistered_College_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_Unregistered_College_OneArgs = {
  object: Espin_Unregistered_College_Insert_Input;
  on_conflict?: InputMaybe<Espin_Unregistered_College_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_UserArgs = {
  objects: Array<Espin_User_Insert_Input>;
  on_conflict?: InputMaybe<Espin_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_User_Linked_External_ProviderArgs = {
  objects: Array<Espin_User_Linked_External_Provider_Insert_Input>;
  on_conflict?: InputMaybe<Espin_User_Linked_External_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_User_Linked_External_Provider_OneArgs = {
  object: Espin_User_Linked_External_Provider_Insert_Input;
  on_conflict?: InputMaybe<Espin_User_Linked_External_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_User_MembershipArgs = {
  objects: Array<Espin_User_Membership_Insert_Input>;
  on_conflict?: InputMaybe<Espin_User_Membership_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_User_Membership_OneArgs = {
  object: Espin_User_Membership_Insert_Input;
  on_conflict?: InputMaybe<Espin_User_Membership_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_User_OneArgs = {
  object: Espin_User_Insert_Input;
  on_conflict?: InputMaybe<Espin_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_User_SourceArgs = {
  objects: Array<Espin_User_Source_Insert_Input>;
  on_conflict?: InputMaybe<Espin_User_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Espin_User_Source_OneArgs = {
  object: Espin_User_Source_Insert_Input;
  on_conflict?: InputMaybe<Espin_User_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_JobArgs = {
  objects: Array<Queue_Job_Insert_Input>;
  on_conflict?: InputMaybe<Queue_Job_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Job_OneArgs = {
  object: Queue_Job_Insert_Input;
  on_conflict?: InputMaybe<Queue_Job_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Job_Status_TypeArgs = {
  objects: Array<Queue_Job_Status_Type_Insert_Input>;
  on_conflict?: InputMaybe<Queue_Job_Status_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Job_Status_Type_OneArgs = {
  object: Queue_Job_Status_Type_Insert_Input;
  on_conflict?: InputMaybe<Queue_Job_Status_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Job_TypeArgs = {
  objects: Array<Queue_Job_Type_Insert_Input>;
  on_conflict?: InputMaybe<Queue_Job_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Job_Type_OneArgs = {
  object: Queue_Job_Type_Insert_Input;
  on_conflict?: InputMaybe<Queue_Job_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Customer_DataArgs = {
  objects: Array<Stripe_Customer_Data_Insert_Input>;
  on_conflict?: InputMaybe<Stripe_Customer_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Customer_Data_OneArgs = {
  object: Stripe_Customer_Data_Insert_Input;
  on_conflict?: InputMaybe<Stripe_Customer_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Invoice_DataArgs = {
  objects: Array<Stripe_Invoice_Data_Insert_Input>;
  on_conflict?: InputMaybe<Stripe_Invoice_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Invoice_Data_OneArgs = {
  object: Stripe_Invoice_Data_Insert_Input;
  on_conflict?: InputMaybe<Stripe_Invoice_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Stripe_Payment_DataArgs = {
  objects: Array<Stripe_Stripe_Payment_Data_Insert_Input>;
  on_conflict?: InputMaybe<Stripe_Stripe_Payment_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Stripe_Payment_Data_OneArgs = {
  object: Stripe_Stripe_Payment_Data_Insert_Input;
  on_conflict?: InputMaybe<Stripe_Stripe_Payment_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Stripe_Subscription_DataArgs = {
  objects: Array<Stripe_Stripe_Subscription_Data_Insert_Input>;
  on_conflict?: InputMaybe<Stripe_Stripe_Subscription_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Stripe_Subscription_Data_OneArgs = {
  object: Stripe_Stripe_Subscription_Data_Insert_Input;
  on_conflict?: InputMaybe<Stripe_Stripe_Subscription_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tempstorage_KeyvalueArgs = {
  objects: Array<Tempstorage_Keyvalue_Insert_Input>;
  on_conflict?: InputMaybe<Tempstorage_Keyvalue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tempstorage_Keyvalue_OneArgs = {
  object: Tempstorage_Keyvalue_Insert_Input;
  on_conflict?: InputMaybe<Tempstorage_Keyvalue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInviteHighSchoolColleagueArgs = {
  input: InviteHighSchoolColleagueActionInput;
};


/** mutation root */
export type Mutation_RootInvitePlayersToTeamActionArgs = {
  input: InvitePlayersToTeamActionInput;
};


/** mutation root */
export type Mutation_RootRedeemCollegeReferralCodeArgs = {
  input: RedeemCollegeReferralCodeInsertInput;
};


/** mutation root */
export type Mutation_RootRedeemPlayerReferralCodeArgs = {
  input: RedeemPlayerReferralCodeInsertInput;
};


/** mutation root */
export type Mutation_RootRemoveChildPlayerArgs = {
  playerProfileId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootSendMassPlayerMessageArgs = {
  input: SendMassPlayerMessageInput;
};


/** mutation root */
export type Mutation_RootUpdate_Cehsite_Ms_Available_Site_TermsArgs = {
  _set?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Set_Input>;
  where: Cehsite_Ms_Available_Site_Terms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cehsite_Ms_Available_Site_Terms_By_PkArgs = {
  _set?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Set_Input>;
  pk_columns: Cehsite_Ms_Available_Site_Terms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cehsite_Ms_Available_Site_Terms_ManyArgs = {
  updates: Array<Cehsite_Ms_Available_Site_Terms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cehsite_Ms_Contact_Form_EntryArgs = {
  _set?: InputMaybe<Cehsite_Ms_Contact_Form_Entry_Set_Input>;
  where: Cehsite_Ms_Contact_Form_Entry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cehsite_Ms_Contact_Form_Entry_By_PkArgs = {
  _set?: InputMaybe<Cehsite_Ms_Contact_Form_Entry_Set_Input>;
  pk_columns: Cehsite_Ms_Contact_Form_Entry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cehsite_Ms_Contact_Form_Entry_ManyArgs = {
  updates: Array<Cehsite_Ms_Contact_Form_Entry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cehsite_Ms_Newsletter_SignupArgs = {
  _set?: InputMaybe<Cehsite_Ms_Newsletter_Signup_Set_Input>;
  where: Cehsite_Ms_Newsletter_Signup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cehsite_Ms_Newsletter_Signup_By_PkArgs = {
  _set?: InputMaybe<Cehsite_Ms_Newsletter_Signup_Set_Input>;
  pk_columns: Cehsite_Ms_Newsletter_Signup_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cehsite_Ms_Newsletter_Signup_ManyArgs = {
  updates: Array<Cehsite_Ms_Newsletter_Signup_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cehsite_Ms_Site_ContentArgs = {
  _set?: InputMaybe<Cehsite_Ms_Site_Content_Set_Input>;
  where: Cehsite_Ms_Site_Content_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cehsite_Ms_Site_Content_By_PkArgs = {
  _set?: InputMaybe<Cehsite_Ms_Site_Content_Set_Input>;
  pk_columns: Cehsite_Ms_Site_Content_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cehsite_Ms_Site_Content_ManyArgs = {
  updates: Array<Cehsite_Ms_Site_Content_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Content_FileArgs = {
  _set?: InputMaybe<Content_File_Set_Input>;
  where: Content_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Content_File_By_PkArgs = {
  _set?: InputMaybe<Content_File_Set_Input>;
  pk_columns: Content_File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Content_File_ManyArgs = {
  updates: Array<Content_File_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Content_File_MetadataArgs = {
  _set?: InputMaybe<Content_File_Metadata_Set_Input>;
  where: Content_File_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Content_File_Metadata_By_PkArgs = {
  _set?: InputMaybe<Content_File_Metadata_Set_Input>;
  pk_columns: Content_File_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Content_File_Metadata_ManyArgs = {
  updates: Array<Content_File_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Content_File_StatusArgs = {
  _set?: InputMaybe<Content_File_Status_Set_Input>;
  where: Content_File_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Content_File_Status_By_PkArgs = {
  _set?: InputMaybe<Content_File_Status_Set_Input>;
  pk_columns: Content_File_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Content_File_Status_ManyArgs = {
  updates: Array<Content_File_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Content_Media_LinkArgs = {
  _set?: InputMaybe<Content_Media_Link_Set_Input>;
  where: Content_Media_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Content_Media_Link_By_PkArgs = {
  _set?: InputMaybe<Content_Media_Link_Set_Input>;
  pk_columns: Content_Media_Link_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Content_Media_Link_ManyArgs = {
  updates: Array<Content_Media_Link_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Content_Media_Link_TypeArgs = {
  _set?: InputMaybe<Content_Media_Link_Type_Set_Input>;
  where: Content_Media_Link_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Content_Media_Link_Type_By_PkArgs = {
  _set?: InputMaybe<Content_Media_Link_Type_Set_Input>;
  pk_columns: Content_Media_Link_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Content_Media_Link_Type_ManyArgs = {
  updates: Array<Content_Media_Link_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Content_Project_NameArgs = {
  _set?: InputMaybe<Content_Project_Name_Set_Input>;
  where: Content_Project_Name_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Content_Project_Name_By_PkArgs = {
  _set?: InputMaybe<Content_Project_Name_Set_Input>;
  pk_columns: Content_Project_Name_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Content_Project_Name_ManyArgs = {
  updates: Array<Content_Project_Name_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Content_StatusArgs = {
  _set?: InputMaybe<Content_Status_Set_Input>;
  where: Content_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Content_Status_By_PkArgs = {
  _set?: InputMaybe<Content_Status_Set_Input>;
  pk_columns: Content_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Content_Status_ManyArgs = {
  updates: Array<Content_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_AddressArgs = {
  _set?: InputMaybe<Espin_Address_Set_Input>;
  where: Espin_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Address_By_PkArgs = {
  _set?: InputMaybe<Espin_Address_Set_Input>;
  pk_columns: Espin_Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Address_ManyArgs = {
  updates: Array<Espin_Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Boolean_Feature_FlagArgs = {
  _set?: InputMaybe<Espin_Boolean_Feature_Flag_Set_Input>;
  where: Espin_Boolean_Feature_Flag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Boolean_Feature_Flag_By_PkArgs = {
  _set?: InputMaybe<Espin_Boolean_Feature_Flag_Set_Input>;
  pk_columns: Espin_Boolean_Feature_Flag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Boolean_Feature_Flag_ManyArgs = {
  updates: Array<Espin_Boolean_Feature_Flag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Coach_ProfileArgs = {
  _set?: InputMaybe<Espin_Coach_Profile_Set_Input>;
  where: Espin_Coach_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Coach_Profile_By_PkArgs = {
  _set?: InputMaybe<Espin_Coach_Profile_Set_Input>;
  pk_columns: Espin_Coach_Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Coach_Profile_ManyArgs = {
  updates: Array<Espin_Coach_Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_CollegeArgs = {
  _inc?: InputMaybe<Espin_College_Inc_Input>;
  _set?: InputMaybe<Espin_College_Set_Input>;
  where: Espin_College_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Automatic_Message_Response_TypeArgs = {
  _set?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Set_Input>;
  where: Espin_College_Automatic_Message_Response_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Automatic_Message_Response_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Set_Input>;
  pk_columns: Espin_College_Automatic_Message_Response_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Automatic_Message_Response_Type_ManyArgs = {
  updates: Array<Espin_College_Automatic_Message_Response_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_By_PkArgs = {
  _inc?: InputMaybe<Espin_College_Inc_Input>;
  _set?: InputMaybe<Espin_College_Set_Input>;
  pk_columns: Espin_College_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_GameArgs = {
  _set?: InputMaybe<Espin_College_Game_Set_Input>;
  where: Espin_College_Game_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Game_By_PkArgs = {
  _set?: InputMaybe<Espin_College_Game_Set_Input>;
  pk_columns: Espin_College_Game_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Game_ManyArgs = {
  updates: Array<Espin_College_Game_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_ImageArgs = {
  _inc?: InputMaybe<Espin_College_Image_Inc_Input>;
  _set?: InputMaybe<Espin_College_Image_Set_Input>;
  where: Espin_College_Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Image_By_PkArgs = {
  _inc?: InputMaybe<Espin_College_Image_Inc_Input>;
  _set?: InputMaybe<Espin_College_Image_Set_Input>;
  pk_columns: Espin_College_Image_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Image_ManyArgs = {
  updates: Array<Espin_College_Image_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_InviteArgs = {
  _set?: InputMaybe<Espin_College_Invite_Set_Input>;
  where: Espin_College_Invite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Invite_By_PkArgs = {
  _set?: InputMaybe<Espin_College_Invite_Set_Input>;
  pk_columns: Espin_College_Invite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Invite_ManyArgs = {
  updates: Array<Espin_College_Invite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_ManyArgs = {
  updates: Array<Espin_College_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_PreferencesArgs = {
  _set?: InputMaybe<Espin_College_Preferences_Set_Input>;
  where: Espin_College_Preferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Preferences_By_PkArgs = {
  _set?: InputMaybe<Espin_College_Preferences_Set_Input>;
  pk_columns: Espin_College_Preferences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Preferences_ManyArgs = {
  updates: Array<Espin_College_Preferences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_ProfileArgs = {
  _set?: InputMaybe<Espin_College_Profile_Set_Input>;
  where: Espin_College_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Profile_By_PkArgs = {
  _set?: InputMaybe<Espin_College_Profile_Set_Input>;
  pk_columns: Espin_College_Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Profile_ManyArgs = {
  updates: Array<Espin_College_Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_RosterArgs = {
  _set?: InputMaybe<Espin_College_Roster_Set_Input>;
  where: Espin_College_Roster_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Roster_By_PkArgs = {
  _set?: InputMaybe<Espin_College_Roster_Set_Input>;
  pk_columns: Espin_College_Roster_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Roster_ManyArgs = {
  updates: Array<Espin_College_Roster_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Staff_MemberArgs = {
  _set?: InputMaybe<Espin_College_Staff_Member_Set_Input>;
  where: Espin_College_Staff_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Staff_Member_By_PkArgs = {
  _set?: InputMaybe<Espin_College_Staff_Member_Set_Input>;
  pk_columns: Espin_College_Staff_Member_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Staff_Member_ManyArgs = {
  updates: Array<Espin_College_Staff_Member_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_SubscriptionArgs = {
  _inc?: InputMaybe<Espin_College_Subscription_Inc_Input>;
  _set?: InputMaybe<Espin_College_Subscription_Set_Input>;
  where: Espin_College_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Subscription_By_PkArgs = {
  _inc?: InputMaybe<Espin_College_Subscription_Inc_Input>;
  _set?: InputMaybe<Espin_College_Subscription_Set_Input>;
  pk_columns: Espin_College_Subscription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Subscription_ManyArgs = {
  updates: Array<Espin_College_Subscription_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Verification_Status_TypeArgs = {
  _set?: InputMaybe<Espin_College_Verification_Status_Type_Set_Input>;
  where: Espin_College_Verification_Status_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Verification_Status_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_College_Verification_Status_Type_Set_Input>;
  pk_columns: Espin_College_Verification_Status_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_College_Verification_Status_Type_ManyArgs = {
  updates: Array<Espin_College_Verification_Status_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Draft_Player_ProfileArgs = {
  _append?: InputMaybe<Espin_Draft_Player_Profile_Append_Input>;
  _delete_at_path?: InputMaybe<Espin_Draft_Player_Profile_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Espin_Draft_Player_Profile_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Espin_Draft_Player_Profile_Delete_Key_Input>;
  _inc?: InputMaybe<Espin_Draft_Player_Profile_Inc_Input>;
  _prepend?: InputMaybe<Espin_Draft_Player_Profile_Prepend_Input>;
  _set?: InputMaybe<Espin_Draft_Player_Profile_Set_Input>;
  where: Espin_Draft_Player_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Draft_Player_Profile_By_PkArgs = {
  _append?: InputMaybe<Espin_Draft_Player_Profile_Append_Input>;
  _delete_at_path?: InputMaybe<Espin_Draft_Player_Profile_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Espin_Draft_Player_Profile_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Espin_Draft_Player_Profile_Delete_Key_Input>;
  _inc?: InputMaybe<Espin_Draft_Player_Profile_Inc_Input>;
  _prepend?: InputMaybe<Espin_Draft_Player_Profile_Prepend_Input>;
  _set?: InputMaybe<Espin_Draft_Player_Profile_Set_Input>;
  pk_columns: Espin_Draft_Player_Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Draft_Player_Profile_ManyArgs = {
  updates: Array<Espin_Draft_Player_Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Editable_Site_ContentArgs = {
  _set?: InputMaybe<Espin_Editable_Site_Content_Set_Input>;
  where: Espin_Editable_Site_Content_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Editable_Site_Content_By_PkArgs = {
  _set?: InputMaybe<Espin_Editable_Site_Content_Set_Input>;
  pk_columns: Espin_Editable_Site_Content_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Editable_Site_Content_ManyArgs = {
  updates: Array<Espin_Editable_Site_Content_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Ethnicity_OptionsArgs = {
  _set?: InputMaybe<Espin_Ethnicity_Options_Set_Input>;
  where: Espin_Ethnicity_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Ethnicity_Options_By_PkArgs = {
  _set?: InputMaybe<Espin_Ethnicity_Options_Set_Input>;
  pk_columns: Espin_Ethnicity_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Ethnicity_Options_ManyArgs = {
  updates: Array<Espin_Ethnicity_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_EventArgs = {
  _inc?: InputMaybe<Espin_Event_Inc_Input>;
  _set?: InputMaybe<Espin_Event_Set_Input>;
  where: Espin_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_By_PkArgs = {
  _inc?: InputMaybe<Espin_Event_Inc_Input>;
  _set?: InputMaybe<Espin_Event_Set_Input>;
  pk_columns: Espin_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Custom_FieldArgs = {
  _set?: InputMaybe<Espin_Event_Custom_Field_Set_Input>;
  where: Espin_Event_Custom_Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Custom_Field_By_PkArgs = {
  _set?: InputMaybe<Espin_Event_Custom_Field_Set_Input>;
  pk_columns: Espin_Event_Custom_Field_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Custom_Field_ManyArgs = {
  updates: Array<Espin_Event_Custom_Field_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Custom_Field_TypeArgs = {
  _set?: InputMaybe<Espin_Event_Custom_Field_Type_Set_Input>;
  where: Espin_Event_Custom_Field_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Custom_Field_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_Event_Custom_Field_Type_Set_Input>;
  pk_columns: Espin_Event_Custom_Field_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Custom_Field_Type_ManyArgs = {
  updates: Array<Espin_Event_Custom_Field_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_DocumentArgs = {
  _set?: InputMaybe<Espin_Event_Document_Set_Input>;
  where: Espin_Event_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Document_By_PkArgs = {
  _set?: InputMaybe<Espin_Event_Document_Set_Input>;
  pk_columns: Espin_Event_Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Document_ManyArgs = {
  updates: Array<Espin_Event_Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_GameArgs = {
  _set?: InputMaybe<Espin_Event_Game_Set_Input>;
  where: Espin_Event_Game_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Game_By_PkArgs = {
  _set?: InputMaybe<Espin_Event_Game_Set_Input>;
  pk_columns: Espin_Event_Game_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Game_ManyArgs = {
  updates: Array<Espin_Event_Game_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_ManyArgs = {
  updates: Array<Espin_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_RegistrationArgs = {
  _append?: InputMaybe<Espin_Event_Registration_Append_Input>;
  _delete_at_path?: InputMaybe<Espin_Event_Registration_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Espin_Event_Registration_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Espin_Event_Registration_Delete_Key_Input>;
  _prepend?: InputMaybe<Espin_Event_Registration_Prepend_Input>;
  _set?: InputMaybe<Espin_Event_Registration_Set_Input>;
  where: Espin_Event_Registration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Registration_By_PkArgs = {
  _append?: InputMaybe<Espin_Event_Registration_Append_Input>;
  _delete_at_path?: InputMaybe<Espin_Event_Registration_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Espin_Event_Registration_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Espin_Event_Registration_Delete_Key_Input>;
  _prepend?: InputMaybe<Espin_Event_Registration_Prepend_Input>;
  _set?: InputMaybe<Espin_Event_Registration_Set_Input>;
  pk_columns: Espin_Event_Registration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Registration_Custom_Field_EntryArgs = {
  _set?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Set_Input>;
  where: Espin_Event_Registration_Custom_Field_Entry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Registration_Custom_Field_Entry_By_PkArgs = {
  _set?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Set_Input>;
  pk_columns: Espin_Event_Registration_Custom_Field_Entry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Registration_Custom_Field_Entry_ManyArgs = {
  updates: Array<Espin_Event_Registration_Custom_Field_Entry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Registration_Document_SignoffArgs = {
  _set?: InputMaybe<Espin_Event_Registration_Document_Signoff_Set_Input>;
  where: Espin_Event_Registration_Document_Signoff_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Registration_Document_Signoff_By_PkArgs = {
  _set?: InputMaybe<Espin_Event_Registration_Document_Signoff_Set_Input>;
  pk_columns: Espin_Event_Registration_Document_Signoff_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Registration_Document_Signoff_ManyArgs = {
  updates: Array<Espin_Event_Registration_Document_Signoff_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Registration_ManyArgs = {
  updates: Array<Espin_Event_Registration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Registration_StatusArgs = {
  _set?: InputMaybe<Espin_Event_Registration_Status_Set_Input>;
  where: Espin_Event_Registration_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Registration_Status_By_PkArgs = {
  _set?: InputMaybe<Espin_Event_Registration_Status_Set_Input>;
  pk_columns: Espin_Event_Registration_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Registration_Status_ManyArgs = {
  updates: Array<Espin_Event_Registration_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_TicketArgs = {
  _inc?: InputMaybe<Espin_Event_Ticket_Inc_Input>;
  _set?: InputMaybe<Espin_Event_Ticket_Set_Input>;
  where: Espin_Event_Ticket_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Ticket_By_PkArgs = {
  _inc?: InputMaybe<Espin_Event_Ticket_Inc_Input>;
  _set?: InputMaybe<Espin_Event_Ticket_Set_Input>;
  pk_columns: Espin_Event_Ticket_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Ticket_ManyArgs = {
  updates: Array<Espin_Event_Ticket_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Ticket_TypeArgs = {
  _set?: InputMaybe<Espin_Event_Ticket_Type_Set_Input>;
  where: Espin_Event_Ticket_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Ticket_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_Event_Ticket_Type_Set_Input>;
  pk_columns: Espin_Event_Ticket_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Ticket_Type_ManyArgs = {
  updates: Array<Espin_Event_Ticket_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_TypeArgs = {
  _set?: InputMaybe<Espin_Event_Type_Set_Input>;
  where: Espin_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_Event_Type_Set_Input>;
  pk_columns: Espin_Event_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Event_Type_ManyArgs = {
  updates: Array<Espin_Event_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_External_ProviderArgs = {
  _set?: InputMaybe<Espin_External_Provider_Set_Input>;
  where: Espin_External_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_External_Provider_By_PkArgs = {
  _set?: InputMaybe<Espin_External_Provider_Set_Input>;
  pk_columns: Espin_External_Provider_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_External_Provider_LinkArgs = {
  _inc?: InputMaybe<Espin_External_Provider_Link_Inc_Input>;
  _set?: InputMaybe<Espin_External_Provider_Link_Set_Input>;
  where: Espin_External_Provider_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_External_Provider_Link_By_PkArgs = {
  _inc?: InputMaybe<Espin_External_Provider_Link_Inc_Input>;
  _set?: InputMaybe<Espin_External_Provider_Link_Set_Input>;
  pk_columns: Espin_External_Provider_Link_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_External_Provider_Link_ManyArgs = {
  updates: Array<Espin_External_Provider_Link_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_External_Provider_ManyArgs = {
  updates: Array<Espin_External_Provider_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_FollowArgs = {
  _set?: InputMaybe<Espin_Follow_Set_Input>;
  where: Espin_Follow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Follow_By_PkArgs = {
  _set?: InputMaybe<Espin_Follow_Set_Input>;
  pk_columns: Espin_Follow_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Follow_ManyArgs = {
  updates: Array<Espin_Follow_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Follow_TypeArgs = {
  _set?: InputMaybe<Espin_Follow_Type_Set_Input>;
  where: Espin_Follow_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Follow_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_Follow_Type_Set_Input>;
  pk_columns: Espin_Follow_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Follow_Type_ManyArgs = {
  updates: Array<Espin_Follow_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Follower_Email_Notification_TypeArgs = {
  _set?: InputMaybe<Espin_Follower_Email_Notification_Type_Set_Input>;
  where: Espin_Follower_Email_Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Follower_Email_Notification_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_Follower_Email_Notification_Type_Set_Input>;
  pk_columns: Espin_Follower_Email_Notification_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Follower_Email_Notification_Type_ManyArgs = {
  updates: Array<Espin_Follower_Email_Notification_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Force_Notification_ReloadArgs = {
  _inc?: InputMaybe<Espin_Force_Notification_Reload_Inc_Input>;
  _set?: InputMaybe<Espin_Force_Notification_Reload_Set_Input>;
  where: Espin_Force_Notification_Reload_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Force_Notification_Reload_By_PkArgs = {
  _inc?: InputMaybe<Espin_Force_Notification_Reload_Inc_Input>;
  _set?: InputMaybe<Espin_Force_Notification_Reload_Set_Input>;
  pk_columns: Espin_Force_Notification_Reload_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Force_Notification_Reload_ManyArgs = {
  updates: Array<Espin_Force_Notification_Reload_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_GameArgs = {
  _inc?: InputMaybe<Espin_Game_Inc_Input>;
  _set?: InputMaybe<Espin_Game_Set_Input>;
  where: Espin_Game_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Game_By_PkArgs = {
  _inc?: InputMaybe<Espin_Game_Inc_Input>;
  _set?: InputMaybe<Espin_Game_Set_Input>;
  pk_columns: Espin_Game_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Game_DefinitionArgs = {
  _set?: InputMaybe<Espin_Game_Definition_Set_Input>;
  where: Espin_Game_Definition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Game_Definition_By_PkArgs = {
  _set?: InputMaybe<Espin_Game_Definition_Set_Input>;
  pk_columns: Espin_Game_Definition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Game_Definition_ManyArgs = {
  updates: Array<Espin_Game_Definition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Game_ManyArgs = {
  updates: Array<Espin_Game_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Game_PlatformArgs = {
  _set?: InputMaybe<Espin_Game_Platform_Set_Input>;
  where: Espin_Game_Platform_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Game_Platform_By_PkArgs = {
  _set?: InputMaybe<Espin_Game_Platform_Set_Input>;
  pk_columns: Espin_Game_Platform_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Game_Platform_ManyArgs = {
  updates: Array<Espin_Game_Platform_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Gender_OptionsArgs = {
  _set?: InputMaybe<Espin_Gender_Options_Set_Input>;
  where: Espin_Gender_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Gender_Options_By_PkArgs = {
  _set?: InputMaybe<Espin_Gender_Options_Set_Input>;
  pk_columns: Espin_Gender_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Gender_Options_ManyArgs = {
  updates: Array<Espin_Gender_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Graduating_ClassArgs = {
  _set?: InputMaybe<Espin_Graduating_Class_Set_Input>;
  where: Espin_Graduating_Class_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Graduating_Class_By_PkArgs = {
  _set?: InputMaybe<Espin_Graduating_Class_Set_Input>;
  pk_columns: Espin_Graduating_Class_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Graduating_Class_ManyArgs = {
  updates: Array<Espin_Graduating_Class_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_High_SchoolArgs = {
  _set?: InputMaybe<Espin_High_School_Set_Input>;
  where: Espin_High_School_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_High_School_By_PkArgs = {
  _set?: InputMaybe<Espin_High_School_Set_Input>;
  pk_columns: Espin_High_School_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_High_School_InviteArgs = {
  _set?: InputMaybe<Espin_High_School_Invite_Set_Input>;
  where: Espin_High_School_Invite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_High_School_Invite_By_PkArgs = {
  _set?: InputMaybe<Espin_High_School_Invite_Set_Input>;
  pk_columns: Espin_High_School_Invite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_High_School_Invite_ManyArgs = {
  updates: Array<Espin_High_School_Invite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_High_School_ManyArgs = {
  updates: Array<Espin_High_School_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_High_School_ProfileArgs = {
  _set?: InputMaybe<Espin_High_School_Profile_Set_Input>;
  where: Espin_High_School_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_High_School_Profile_By_PkArgs = {
  _set?: InputMaybe<Espin_High_School_Profile_Set_Input>;
  pk_columns: Espin_High_School_Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_High_School_Profile_ManyArgs = {
  updates: Array<Espin_High_School_Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Invite_Status_TypeArgs = {
  _set?: InputMaybe<Espin_Invite_Status_Type_Set_Input>;
  where: Espin_Invite_Status_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Invite_Status_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_Invite_Status_Type_Set_Input>;
  pk_columns: Espin_Invite_Status_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Invite_Status_Type_ManyArgs = {
  updates: Array<Espin_Invite_Status_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_LeaderboardArgs = {
  _set?: InputMaybe<Espin_Leaderboard_Set_Input>;
  where: Espin_Leaderboard_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Leaderboard_By_PkArgs = {
  _set?: InputMaybe<Espin_Leaderboard_Set_Input>;
  pk_columns: Espin_Leaderboard_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Leaderboard_ManyArgs = {
  updates: Array<Espin_Leaderboard_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_MembershipArgs = {
  _inc?: InputMaybe<Espin_Membership_Inc_Input>;
  _set?: InputMaybe<Espin_Membership_Set_Input>;
  where: Espin_Membership_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Membership_By_PkArgs = {
  _inc?: InputMaybe<Espin_Membership_Inc_Input>;
  _set?: InputMaybe<Espin_Membership_Set_Input>;
  pk_columns: Espin_Membership_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Membership_ManyArgs = {
  updates: Array<Espin_Membership_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_MessageArgs = {
  _set?: InputMaybe<Espin_Message_Set_Input>;
  where: Espin_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Message_By_PkArgs = {
  _set?: InputMaybe<Espin_Message_Set_Input>;
  pk_columns: Espin_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Message_Email_Notification_TypeArgs = {
  _set?: InputMaybe<Espin_Message_Email_Notification_Type_Set_Input>;
  where: Espin_Message_Email_Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Message_Email_Notification_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_Message_Email_Notification_Type_Set_Input>;
  pk_columns: Espin_Message_Email_Notification_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Message_Email_Notification_Type_ManyArgs = {
  updates: Array<Espin_Message_Email_Notification_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Message_ManyArgs = {
  updates: Array<Espin_Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Message_TypeArgs = {
  _set?: InputMaybe<Espin_Message_Type_Set_Input>;
  where: Espin_Message_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Message_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_Message_Type_Set_Input>;
  pk_columns: Espin_Message_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Message_Type_ManyArgs = {
  updates: Array<Espin_Message_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Moderation_StatusArgs = {
  _set?: InputMaybe<Espin_Moderation_Status_Set_Input>;
  where: Espin_Moderation_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Moderation_Status_By_PkArgs = {
  _set?: InputMaybe<Espin_Moderation_Status_Set_Input>;
  pk_columns: Espin_Moderation_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Moderation_Status_ManyArgs = {
  updates: Array<Espin_Moderation_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Newsletter_RequestArgs = {
  _set?: InputMaybe<Espin_Newsletter_Request_Set_Input>;
  where: Espin_Newsletter_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Newsletter_Request_By_PkArgs = {
  _set?: InputMaybe<Espin_Newsletter_Request_Set_Input>;
  pk_columns: Espin_Newsletter_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Newsletter_Request_ManyArgs = {
  updates: Array<Espin_Newsletter_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_NotificationArgs = {
  _set?: InputMaybe<Espin_Notification_Set_Input>;
  where: Espin_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Notification_By_PkArgs = {
  _set?: InputMaybe<Espin_Notification_Set_Input>;
  pk_columns: Espin_Notification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Notification_ManyArgs = {
  updates: Array<Espin_Notification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Notification_TypeArgs = {
  _set?: InputMaybe<Espin_Notification_Type_Set_Input>;
  where: Espin_Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Notification_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_Notification_Type_Set_Input>;
  pk_columns: Espin_Notification_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Notification_Type_ManyArgs = {
  updates: Array<Espin_Notification_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_OrgArgs = {
  _set?: InputMaybe<Espin_Org_Set_Input>;
  where: Espin_Org_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_By_PkArgs = {
  _set?: InputMaybe<Espin_Org_Set_Input>;
  pk_columns: Espin_Org_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_ManyArgs = {
  updates: Array<Espin_Org_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_MonthArgs = {
  _inc?: InputMaybe<Espin_Org_Month_Inc_Input>;
  _set?: InputMaybe<Espin_Org_Month_Set_Input>;
  where: Espin_Org_Month_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_Month_By_PkArgs = {
  _inc?: InputMaybe<Espin_Org_Month_Inc_Input>;
  _set?: InputMaybe<Espin_Org_Month_Set_Input>;
  pk_columns: Espin_Org_Month_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_Month_DayArgs = {
  _inc?: InputMaybe<Espin_Org_Month_Day_Inc_Input>;
  _set?: InputMaybe<Espin_Org_Month_Day_Set_Input>;
  where: Espin_Org_Month_Day_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_Month_Day_By_PkArgs = {
  _inc?: InputMaybe<Espin_Org_Month_Day_Inc_Input>;
  _set?: InputMaybe<Espin_Org_Month_Day_Set_Input>;
  pk_columns: Espin_Org_Month_Day_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_Month_Day_ManyArgs = {
  updates: Array<Espin_Org_Month_Day_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_Month_ManyArgs = {
  updates: Array<Espin_Org_Month_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_PlayerArgs = {
  _inc?: InputMaybe<Espin_Org_Player_Inc_Input>;
  _set?: InputMaybe<Espin_Org_Player_Set_Input>;
  where: Espin_Org_Player_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_Player_By_PkArgs = {
  _inc?: InputMaybe<Espin_Org_Player_Inc_Input>;
  _set?: InputMaybe<Espin_Org_Player_Set_Input>;
  pk_columns: Espin_Org_Player_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_Player_ManyArgs = {
  updates: Array<Espin_Org_Player_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_SchoolArgs = {
  _inc?: InputMaybe<Espin_Org_School_Inc_Input>;
  _set?: InputMaybe<Espin_Org_School_Set_Input>;
  where: Espin_Org_School_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_School_By_PkArgs = {
  _inc?: InputMaybe<Espin_Org_School_Inc_Input>;
  _set?: InputMaybe<Espin_Org_School_Set_Input>;
  pk_columns: Espin_Org_School_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_School_ManyArgs = {
  updates: Array<Espin_Org_School_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_School_RecordArgs = {
  _inc?: InputMaybe<Espin_Org_School_Record_Inc_Input>;
  _set?: InputMaybe<Espin_Org_School_Record_Set_Input>;
  where: Espin_Org_School_Record_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_School_Record_By_PkArgs = {
  _inc?: InputMaybe<Espin_Org_School_Record_Inc_Input>;
  _set?: InputMaybe<Espin_Org_School_Record_Set_Input>;
  pk_columns: Espin_Org_School_Record_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Org_School_Record_ManyArgs = {
  updates: Array<Espin_Org_School_Record_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Paid_ProductArgs = {
  _set?: InputMaybe<Espin_Paid_Product_Set_Input>;
  where: Espin_Paid_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Paid_Product_By_PkArgs = {
  _set?: InputMaybe<Espin_Paid_Product_Set_Input>;
  pk_columns: Espin_Paid_Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Paid_Product_ManyArgs = {
  updates: Array<Espin_Paid_Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Parent_InviteArgs = {
  _set?: InputMaybe<Espin_Parent_Invite_Set_Input>;
  where: Espin_Parent_Invite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Parent_Invite_By_PkArgs = {
  _set?: InputMaybe<Espin_Parent_Invite_Set_Input>;
  pk_columns: Espin_Parent_Invite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Parent_Invite_ManyArgs = {
  updates: Array<Espin_Parent_Invite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Parent_ProfileArgs = {
  _set?: InputMaybe<Espin_Parent_Profile_Set_Input>;
  where: Espin_Parent_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Parent_Profile_By_PkArgs = {
  _set?: InputMaybe<Espin_Parent_Profile_Set_Input>;
  pk_columns: Espin_Parent_Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Parent_Profile_ManyArgs = {
  updates: Array<Espin_Parent_Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_GameArgs = {
  _set?: InputMaybe<Espin_Player_Game_Set_Input>;
  where: Espin_Player_Game_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Game_By_PkArgs = {
  _set?: InputMaybe<Espin_Player_Game_Set_Input>;
  pk_columns: Espin_Player_Game_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Game_ManyArgs = {
  updates: Array<Espin_Player_Game_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_JourneyArgs = {
  _inc?: InputMaybe<Espin_Player_Journey_Inc_Input>;
  _set?: InputMaybe<Espin_Player_Journey_Set_Input>;
  where: Espin_Player_Journey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_By_PkArgs = {
  _inc?: InputMaybe<Espin_Player_Journey_Inc_Input>;
  _set?: InputMaybe<Espin_Player_Journey_Set_Input>;
  pk_columns: Espin_Player_Journey_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_ManyArgs = {
  updates: Array<Espin_Player_Journey_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_StageArgs = {
  _inc?: InputMaybe<Espin_Player_Journey_Stage_Inc_Input>;
  _set?: InputMaybe<Espin_Player_Journey_Stage_Set_Input>;
  where: Espin_Player_Journey_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_By_PkArgs = {
  _inc?: InputMaybe<Espin_Player_Journey_Stage_Inc_Input>;
  _set?: InputMaybe<Espin_Player_Journey_Stage_Set_Input>;
  pk_columns: Espin_Player_Journey_Stage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_CollegeArgs = {
  _set?: InputMaybe<Espin_Player_Journey_Stage_College_Set_Input>;
  where: Espin_Player_Journey_Stage_College_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_College_By_PkArgs = {
  _set?: InputMaybe<Espin_Player_Journey_Stage_College_Set_Input>;
  pk_columns: Espin_Player_Journey_Stage_College_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_College_ManyArgs = {
  updates: Array<Espin_Player_Journey_Stage_College_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_DefArgs = {
  _set?: InputMaybe<Espin_Player_Journey_Stage_Def_Set_Input>;
  where: Espin_Player_Journey_Stage_Def_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_Def_By_PkArgs = {
  _set?: InputMaybe<Espin_Player_Journey_Stage_Def_Set_Input>;
  pk_columns: Espin_Player_Journey_Stage_Def_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_Def_ManyArgs = {
  updates: Array<Espin_Player_Journey_Stage_Def_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_ImageArgs = {
  _set?: InputMaybe<Espin_Player_Journey_Stage_Image_Set_Input>;
  where: Espin_Player_Journey_Stage_Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_Image_By_PkArgs = {
  _set?: InputMaybe<Espin_Player_Journey_Stage_Image_Set_Input>;
  pk_columns: Espin_Player_Journey_Stage_Image_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_Image_ManyArgs = {
  updates: Array<Espin_Player_Journey_Stage_Image_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_ManyArgs = {
  updates: Array<Espin_Player_Journey_Stage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_QuoteArgs = {
  _set?: InputMaybe<Espin_Player_Journey_Stage_Quote_Set_Input>;
  where: Espin_Player_Journey_Stage_Quote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_Quote_By_PkArgs = {
  _set?: InputMaybe<Espin_Player_Journey_Stage_Quote_Set_Input>;
  pk_columns: Espin_Player_Journey_Stage_Quote_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_Quote_ManyArgs = {
  updates: Array<Espin_Player_Journey_Stage_Quote_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_VideoArgs = {
  _set?: InputMaybe<Espin_Player_Journey_Stage_Video_Set_Input>;
  where: Espin_Player_Journey_Stage_Video_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_Video_By_PkArgs = {
  _set?: InputMaybe<Espin_Player_Journey_Stage_Video_Set_Input>;
  pk_columns: Espin_Player_Journey_Stage_Video_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Journey_Stage_Video_ManyArgs = {
  updates: Array<Espin_Player_Journey_Stage_Video_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_ProfileArgs = {
  _append?: InputMaybe<Espin_Player_Profile_Append_Input>;
  _delete_at_path?: InputMaybe<Espin_Player_Profile_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Espin_Player_Profile_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Espin_Player_Profile_Delete_Key_Input>;
  _inc?: InputMaybe<Espin_Player_Profile_Inc_Input>;
  _prepend?: InputMaybe<Espin_Player_Profile_Prepend_Input>;
  _set?: InputMaybe<Espin_Player_Profile_Set_Input>;
  where: Espin_Player_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Profile_By_PkArgs = {
  _append?: InputMaybe<Espin_Player_Profile_Append_Input>;
  _delete_at_path?: InputMaybe<Espin_Player_Profile_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Espin_Player_Profile_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Espin_Player_Profile_Delete_Key_Input>;
  _inc?: InputMaybe<Espin_Player_Profile_Inc_Input>;
  _prepend?: InputMaybe<Espin_Player_Profile_Prepend_Input>;
  _set?: InputMaybe<Espin_Player_Profile_Set_Input>;
  pk_columns: Espin_Player_Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Profile_ManyArgs = {
  updates: Array<Espin_Player_Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_SubscriptionArgs = {
  _inc?: InputMaybe<Espin_Player_Subscription_Inc_Input>;
  _set?: InputMaybe<Espin_Player_Subscription_Set_Input>;
  where: Espin_Player_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Subscription_By_PkArgs = {
  _inc?: InputMaybe<Espin_Player_Subscription_Inc_Input>;
  _set?: InputMaybe<Espin_Player_Subscription_Set_Input>;
  pk_columns: Espin_Player_Subscription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Subscription_ManyArgs = {
  updates: Array<Espin_Player_Subscription_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_VodArgs = {
  _set?: InputMaybe<Espin_Player_Vod_Set_Input>;
  where: Espin_Player_Vod_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Vod_By_PkArgs = {
  _set?: InputMaybe<Espin_Player_Vod_Set_Input>;
  pk_columns: Espin_Player_Vod_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Player_Vod_ManyArgs = {
  updates: Array<Espin_Player_Vod_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Profile_ViewArgs = {
  _set?: InputMaybe<Espin_Profile_View_Set_Input>;
  where: Espin_Profile_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Profile_View_By_PkArgs = {
  _set?: InputMaybe<Espin_Profile_View_Set_Input>;
  pk_columns: Espin_Profile_View_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Profile_View_Email_Notification_TypeArgs = {
  _set?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Set_Input>;
  where: Espin_Profile_View_Email_Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Profile_View_Email_Notification_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Set_Input>;
  pk_columns: Espin_Profile_View_Email_Notification_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Profile_View_Email_Notification_Type_ManyArgs = {
  updates: Array<Espin_Profile_View_Email_Notification_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Profile_View_ManyArgs = {
  updates: Array<Espin_Profile_View_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Profile_View_TypeArgs = {
  _set?: InputMaybe<Espin_Profile_View_Type_Set_Input>;
  where: Espin_Profile_View_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Profile_View_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_Profile_View_Type_Set_Input>;
  pk_columns: Espin_Profile_View_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Profile_View_Type_ManyArgs = {
  updates: Array<Espin_Profile_View_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Referral_CodeArgs = {
  _inc?: InputMaybe<Espin_Referral_Code_Inc_Input>;
  _set?: InputMaybe<Espin_Referral_Code_Set_Input>;
  where: Espin_Referral_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Referral_Code_By_PkArgs = {
  _inc?: InputMaybe<Espin_Referral_Code_Inc_Input>;
  _set?: InputMaybe<Espin_Referral_Code_Set_Input>;
  pk_columns: Espin_Referral_Code_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Referral_Code_ManyArgs = {
  updates: Array<Espin_Referral_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Referral_Code_RedemptionArgs = {
  _set?: InputMaybe<Espin_Referral_Code_Redemption_Set_Input>;
  where: Espin_Referral_Code_Redemption_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Referral_Code_Redemption_By_PkArgs = {
  _set?: InputMaybe<Espin_Referral_Code_Redemption_Set_Input>;
  pk_columns: Espin_Referral_Code_Redemption_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Referral_Code_Redemption_ManyArgs = {
  updates: Array<Espin_Referral_Code_Redemption_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Referral_OptionArgs = {
  _inc?: InputMaybe<Espin_Referral_Option_Inc_Input>;
  _set?: InputMaybe<Espin_Referral_Option_Set_Input>;
  where: Espin_Referral_Option_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Referral_Option_By_PkArgs = {
  _inc?: InputMaybe<Espin_Referral_Option_Inc_Input>;
  _set?: InputMaybe<Espin_Referral_Option_Set_Input>;
  pk_columns: Espin_Referral_Option_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Referral_Option_ManyArgs = {
  updates: Array<Espin_Referral_Option_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_RoleArgs = {
  _set?: InputMaybe<Espin_Role_Set_Input>;
  where: Espin_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Role_By_PkArgs = {
  _set?: InputMaybe<Espin_Role_Set_Input>;
  pk_columns: Espin_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Role_ManyArgs = {
  updates: Array<Espin_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Site_ContentArgs = {
  _set?: InputMaybe<Espin_Site_Content_Set_Input>;
  where: Espin_Site_Content_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Site_Content_By_PkArgs = {
  _set?: InputMaybe<Espin_Site_Content_Set_Input>;
  pk_columns: Espin_Site_Content_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Site_Content_ManyArgs = {
  updates: Array<Espin_Site_Content_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_SocialArgs = {
  _set?: InputMaybe<Espin_Social_Set_Input>;
  where: Espin_Social_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Social_By_PkArgs = {
  _set?: InputMaybe<Espin_Social_Set_Input>;
  pk_columns: Espin_Social_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Social_ManyArgs = {
  updates: Array<Espin_Social_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Stickied_CollegeArgs = {
  _inc?: InputMaybe<Espin_Stickied_College_Inc_Input>;
  _set?: InputMaybe<Espin_Stickied_College_Set_Input>;
  where: Espin_Stickied_College_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Stickied_College_By_PkArgs = {
  _inc?: InputMaybe<Espin_Stickied_College_Inc_Input>;
  _set?: InputMaybe<Espin_Stickied_College_Set_Input>;
  pk_columns: Espin_Stickied_College_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Stickied_College_ManyArgs = {
  updates: Array<Espin_Stickied_College_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Stickied_PlayerArgs = {
  _inc?: InputMaybe<Espin_Stickied_Player_Inc_Input>;
  _set?: InputMaybe<Espin_Stickied_Player_Set_Input>;
  where: Espin_Stickied_Player_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Stickied_Player_By_PkArgs = {
  _inc?: InputMaybe<Espin_Stickied_Player_Inc_Input>;
  _set?: InputMaybe<Espin_Stickied_Player_Set_Input>;
  pk_columns: Espin_Stickied_Player_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Stickied_Player_ManyArgs = {
  updates: Array<Espin_Stickied_Player_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Study_FieldArgs = {
  _set?: InputMaybe<Espin_Study_Field_Set_Input>;
  where: Espin_Study_Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Study_Field_By_PkArgs = {
  _set?: InputMaybe<Espin_Study_Field_Set_Input>;
  pk_columns: Espin_Study_Field_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Study_Field_ManyArgs = {
  updates: Array<Espin_Study_Field_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Study_SubjectArgs = {
  _set?: InputMaybe<Espin_Study_Subject_Set_Input>;
  where: Espin_Study_Subject_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Study_Subject_By_PkArgs = {
  _set?: InputMaybe<Espin_Study_Subject_Set_Input>;
  pk_columns: Espin_Study_Subject_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Study_Subject_ManyArgs = {
  updates: Array<Espin_Study_Subject_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Subscription_StatusArgs = {
  _set?: InputMaybe<Espin_Subscription_Status_Set_Input>;
  where: Espin_Subscription_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Subscription_Status_By_PkArgs = {
  _set?: InputMaybe<Espin_Subscription_Status_Set_Input>;
  pk_columns: Espin_Subscription_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Subscription_Status_ManyArgs = {
  updates: Array<Espin_Subscription_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Subscription_Tier_TypeArgs = {
  _set?: InputMaybe<Espin_Subscription_Tier_Type_Set_Input>;
  where: Espin_Subscription_Tier_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Subscription_Tier_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_Subscription_Tier_Type_Set_Input>;
  pk_columns: Espin_Subscription_Tier_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Subscription_Tier_Type_ManyArgs = {
  updates: Array<Espin_Subscription_Tier_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_TeamArgs = {
  _set?: InputMaybe<Espin_Team_Set_Input>;
  where: Espin_Team_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_By_PkArgs = {
  _set?: InputMaybe<Espin_Team_Set_Input>;
  pk_columns: Espin_Team_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_InviteArgs = {
  _set?: InputMaybe<Espin_Team_Invite_Set_Input>;
  where: Espin_Team_Invite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_Invite_By_PkArgs = {
  _set?: InputMaybe<Espin_Team_Invite_Set_Input>;
  pk_columns: Espin_Team_Invite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_Invite_ManyArgs = {
  updates: Array<Espin_Team_Invite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_ManyArgs = {
  updates: Array<Espin_Team_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_MembersArgs = {
  _set?: InputMaybe<Espin_Team_Members_Set_Input>;
  where: Espin_Team_Members_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_Members_By_PkArgs = {
  _set?: InputMaybe<Espin_Team_Members_Set_Input>;
  pk_columns: Espin_Team_Members_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_Members_ManyArgs = {
  updates: Array<Espin_Team_Members_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_RoleArgs = {
  _set?: InputMaybe<Espin_Team_Role_Set_Input>;
  where: Espin_Team_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_Role_By_PkArgs = {
  _set?: InputMaybe<Espin_Team_Role_Set_Input>;
  pk_columns: Espin_Team_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_Role_ManyArgs = {
  updates: Array<Espin_Team_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_TypeArgs = {
  _set?: InputMaybe<Espin_Team_Type_Set_Input>;
  where: Espin_Team_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_Type_By_PkArgs = {
  _set?: InputMaybe<Espin_Team_Type_Set_Input>;
  pk_columns: Espin_Team_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Team_Type_ManyArgs = {
  updates: Array<Espin_Team_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Unregistered_CollegeArgs = {
  _set?: InputMaybe<Espin_Unregistered_College_Set_Input>;
  where: Espin_Unregistered_College_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Unregistered_College_By_PkArgs = {
  _set?: InputMaybe<Espin_Unregistered_College_Set_Input>;
  pk_columns: Espin_Unregistered_College_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_Unregistered_College_ManyArgs = {
  updates: Array<Espin_Unregistered_College_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_UserArgs = {
  _set?: InputMaybe<Espin_User_Set_Input>;
  where: Espin_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_User_By_PkArgs = {
  _set?: InputMaybe<Espin_User_Set_Input>;
  pk_columns: Espin_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_User_Linked_External_ProviderArgs = {
  _set?: InputMaybe<Espin_User_Linked_External_Provider_Set_Input>;
  where: Espin_User_Linked_External_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_User_Linked_External_Provider_By_PkArgs = {
  _set?: InputMaybe<Espin_User_Linked_External_Provider_Set_Input>;
  pk_columns: Espin_User_Linked_External_Provider_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_User_Linked_External_Provider_ManyArgs = {
  updates: Array<Espin_User_Linked_External_Provider_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_User_ManyArgs = {
  updates: Array<Espin_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_User_MembershipArgs = {
  _inc?: InputMaybe<Espin_User_Membership_Inc_Input>;
  _set?: InputMaybe<Espin_User_Membership_Set_Input>;
  where: Espin_User_Membership_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_User_Membership_By_PkArgs = {
  _inc?: InputMaybe<Espin_User_Membership_Inc_Input>;
  _set?: InputMaybe<Espin_User_Membership_Set_Input>;
  pk_columns: Espin_User_Membership_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_User_Membership_ManyArgs = {
  updates: Array<Espin_User_Membership_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_User_SourceArgs = {
  _set?: InputMaybe<Espin_User_Source_Set_Input>;
  where: Espin_User_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_User_Source_By_PkArgs = {
  _set?: InputMaybe<Espin_User_Source_Set_Input>;
  pk_columns: Espin_User_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Espin_User_Source_ManyArgs = {
  updates: Array<Espin_User_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_JobArgs = {
  _append?: InputMaybe<Queue_Job_Append_Input>;
  _delete_at_path?: InputMaybe<Queue_Job_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Queue_Job_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Queue_Job_Delete_Key_Input>;
  _prepend?: InputMaybe<Queue_Job_Prepend_Input>;
  _set?: InputMaybe<Queue_Job_Set_Input>;
  where: Queue_Job_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Job_By_PkArgs = {
  _append?: InputMaybe<Queue_Job_Append_Input>;
  _delete_at_path?: InputMaybe<Queue_Job_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Queue_Job_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Queue_Job_Delete_Key_Input>;
  _prepend?: InputMaybe<Queue_Job_Prepend_Input>;
  _set?: InputMaybe<Queue_Job_Set_Input>;
  pk_columns: Queue_Job_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Job_ManyArgs = {
  updates: Array<Queue_Job_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Job_Status_TypeArgs = {
  _set?: InputMaybe<Queue_Job_Status_Type_Set_Input>;
  where: Queue_Job_Status_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Job_Status_Type_By_PkArgs = {
  _set?: InputMaybe<Queue_Job_Status_Type_Set_Input>;
  pk_columns: Queue_Job_Status_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Job_Status_Type_ManyArgs = {
  updates: Array<Queue_Job_Status_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Job_TypeArgs = {
  _set?: InputMaybe<Queue_Job_Type_Set_Input>;
  where: Queue_Job_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Job_Type_By_PkArgs = {
  _set?: InputMaybe<Queue_Job_Type_Set_Input>;
  pk_columns: Queue_Job_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Job_Type_ManyArgs = {
  updates: Array<Queue_Job_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Customer_DataArgs = {
  _set?: InputMaybe<Stripe_Customer_Data_Set_Input>;
  where: Stripe_Customer_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Customer_Data_By_PkArgs = {
  _set?: InputMaybe<Stripe_Customer_Data_Set_Input>;
  pk_columns: Stripe_Customer_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Customer_Data_ManyArgs = {
  updates: Array<Stripe_Customer_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Invoice_DataArgs = {
  _inc?: InputMaybe<Stripe_Invoice_Data_Inc_Input>;
  _set?: InputMaybe<Stripe_Invoice_Data_Set_Input>;
  where: Stripe_Invoice_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Invoice_Data_By_PkArgs = {
  _inc?: InputMaybe<Stripe_Invoice_Data_Inc_Input>;
  _set?: InputMaybe<Stripe_Invoice_Data_Set_Input>;
  pk_columns: Stripe_Invoice_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Invoice_Data_ManyArgs = {
  updates: Array<Stripe_Invoice_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Stripe_Payment_DataArgs = {
  _inc?: InputMaybe<Stripe_Stripe_Payment_Data_Inc_Input>;
  _set?: InputMaybe<Stripe_Stripe_Payment_Data_Set_Input>;
  where: Stripe_Stripe_Payment_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Stripe_Payment_Data_By_PkArgs = {
  _inc?: InputMaybe<Stripe_Stripe_Payment_Data_Inc_Input>;
  _set?: InputMaybe<Stripe_Stripe_Payment_Data_Set_Input>;
  pk_columns: Stripe_Stripe_Payment_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Stripe_Payment_Data_ManyArgs = {
  updates: Array<Stripe_Stripe_Payment_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Stripe_Subscription_DataArgs = {
  _inc?: InputMaybe<Stripe_Stripe_Subscription_Data_Inc_Input>;
  _set?: InputMaybe<Stripe_Stripe_Subscription_Data_Set_Input>;
  where: Stripe_Stripe_Subscription_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Stripe_Subscription_Data_By_PkArgs = {
  _inc?: InputMaybe<Stripe_Stripe_Subscription_Data_Inc_Input>;
  _set?: InputMaybe<Stripe_Stripe_Subscription_Data_Set_Input>;
  pk_columns: Stripe_Stripe_Subscription_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Stripe_Subscription_Data_ManyArgs = {
  updates: Array<Stripe_Stripe_Subscription_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tempstorage_KeyvalueArgs = {
  _append?: InputMaybe<Tempstorage_Keyvalue_Append_Input>;
  _delete_at_path?: InputMaybe<Tempstorage_Keyvalue_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tempstorage_Keyvalue_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tempstorage_Keyvalue_Delete_Key_Input>;
  _prepend?: InputMaybe<Tempstorage_Keyvalue_Prepend_Input>;
  _set?: InputMaybe<Tempstorage_Keyvalue_Set_Input>;
  where: Tempstorage_Keyvalue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tempstorage_Keyvalue_By_PkArgs = {
  _append?: InputMaybe<Tempstorage_Keyvalue_Append_Input>;
  _delete_at_path?: InputMaybe<Tempstorage_Keyvalue_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tempstorage_Keyvalue_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tempstorage_Keyvalue_Delete_Key_Input>;
  _prepend?: InputMaybe<Tempstorage_Keyvalue_Prepend_Input>;
  _set?: InputMaybe<Tempstorage_Keyvalue_Set_Input>;
  pk_columns: Tempstorage_Keyvalue_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tempstorage_Keyvalue_ManyArgs = {
  updates: Array<Tempstorage_Keyvalue_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  GetAllVerifiedHighSchoolNames?: Maybe<GetAllVerifiedHighSchoolNamesOutput>;
  /** fetch data from the table: "cehsite.ms_available_site_terms" */
  cehsite_ms_available_site_terms: Array<Cehsite_Ms_Available_Site_Terms>;
  /** fetch aggregated fields from the table: "cehsite.ms_available_site_terms" */
  cehsite_ms_available_site_terms_aggregate: Cehsite_Ms_Available_Site_Terms_Aggregate;
  /** fetch data from the table: "cehsite.ms_available_site_terms" using primary key columns */
  cehsite_ms_available_site_terms_by_pk?: Maybe<Cehsite_Ms_Available_Site_Terms>;
  /** fetch data from the table: "cehsite.ms_contact_form_entry" */
  cehsite_ms_contact_form_entry: Array<Cehsite_Ms_Contact_Form_Entry>;
  /** fetch aggregated fields from the table: "cehsite.ms_contact_form_entry" */
  cehsite_ms_contact_form_entry_aggregate: Cehsite_Ms_Contact_Form_Entry_Aggregate;
  /** fetch data from the table: "cehsite.ms_contact_form_entry" using primary key columns */
  cehsite_ms_contact_form_entry_by_pk?: Maybe<Cehsite_Ms_Contact_Form_Entry>;
  /** fetch data from the table: "cehsite.ms_newsletter_signup" */
  cehsite_ms_newsletter_signup: Array<Cehsite_Ms_Newsletter_Signup>;
  /** fetch aggregated fields from the table: "cehsite.ms_newsletter_signup" */
  cehsite_ms_newsletter_signup_aggregate: Cehsite_Ms_Newsletter_Signup_Aggregate;
  /** fetch data from the table: "cehsite.ms_newsletter_signup" using primary key columns */
  cehsite_ms_newsletter_signup_by_pk?: Maybe<Cehsite_Ms_Newsletter_Signup>;
  /** fetch data from the table: "cehsite.ms_site_content" */
  cehsite_ms_site_content: Array<Cehsite_Ms_Site_Content>;
  /** fetch aggregated fields from the table: "cehsite.ms_site_content" */
  cehsite_ms_site_content_aggregate: Cehsite_Ms_Site_Content_Aggregate;
  /** fetch data from the table: "cehsite.ms_site_content" using primary key columns */
  cehsite_ms_site_content_by_pk?: Maybe<Cehsite_Ms_Site_Content>;
  /** fetch data from the table: "content.file" */
  content_file: Array<Content_File>;
  /** fetch aggregated fields from the table: "content.file" */
  content_file_aggregate: Content_File_Aggregate;
  /** fetch data from the table: "content.file" using primary key columns */
  content_file_by_pk?: Maybe<Content_File>;
  /** fetch data from the table: "content.file_metadata" */
  content_file_metadata: Array<Content_File_Metadata>;
  /** fetch aggregated fields from the table: "content.file_metadata" */
  content_file_metadata_aggregate: Content_File_Metadata_Aggregate;
  /** fetch data from the table: "content.file_metadata" using primary key columns */
  content_file_metadata_by_pk?: Maybe<Content_File_Metadata>;
  /** fetch data from the table: "content.file_status" */
  content_file_status: Array<Content_File_Status>;
  /** fetch aggregated fields from the table: "content.file_status" */
  content_file_status_aggregate: Content_File_Status_Aggregate;
  /** fetch data from the table: "content.file_status" using primary key columns */
  content_file_status_by_pk?: Maybe<Content_File_Status>;
  /** fetch data from the table: "content.media_link" */
  content_media_link: Array<Content_Media_Link>;
  /** fetch aggregated fields from the table: "content.media_link" */
  content_media_link_aggregate: Content_Media_Link_Aggregate;
  /** fetch data from the table: "content.media_link" using primary key columns */
  content_media_link_by_pk?: Maybe<Content_Media_Link>;
  /** fetch data from the table: "content.media_link_type" */
  content_media_link_type: Array<Content_Media_Link_Type>;
  /** fetch aggregated fields from the table: "content.media_link_type" */
  content_media_link_type_aggregate: Content_Media_Link_Type_Aggregate;
  /** fetch data from the table: "content.media_link_type" using primary key columns */
  content_media_link_type_by_pk?: Maybe<Content_Media_Link_Type>;
  /** fetch data from the table: "content.project_name" */
  content_project_name: Array<Content_Project_Name>;
  /** fetch aggregated fields from the table: "content.project_name" */
  content_project_name_aggregate: Content_Project_Name_Aggregate;
  /** fetch data from the table: "content.project_name" using primary key columns */
  content_project_name_by_pk?: Maybe<Content_Project_Name>;
  /** fetch data from the table: "content.status" */
  content_status: Array<Content_Status>;
  /** fetch aggregated fields from the table: "content.status" */
  content_status_aggregate: Content_Status_Aggregate;
  /** fetch data from the table: "content.status" using primary key columns */
  content_status_by_pk?: Maybe<Content_Status>;
  /** fetch data from the table: "espin.address" */
  espin_address: Array<Espin_Address>;
  /** fetch aggregated fields from the table: "espin.address" */
  espin_address_aggregate: Espin_Address_Aggregate;
  /** fetch data from the table: "espin.address" using primary key columns */
  espin_address_by_pk?: Maybe<Espin_Address>;
  /** fetch data from the table: "espin.boolean_feature_flag" */
  espin_boolean_feature_flag: Array<Espin_Boolean_Feature_Flag>;
  /** fetch aggregated fields from the table: "espin.boolean_feature_flag" */
  espin_boolean_feature_flag_aggregate: Espin_Boolean_Feature_Flag_Aggregate;
  /** fetch data from the table: "espin.boolean_feature_flag" using primary key columns */
  espin_boolean_feature_flag_by_pk?: Maybe<Espin_Boolean_Feature_Flag>;
  /** fetch data from the table: "espin.coach_profile" */
  espin_coach_profile: Array<Espin_Coach_Profile>;
  /** fetch aggregated fields from the table: "espin.coach_profile" */
  espin_coach_profile_aggregate: Espin_Coach_Profile_Aggregate;
  /** fetch data from the table: "espin.coach_profile" using primary key columns */
  espin_coach_profile_by_pk?: Maybe<Espin_Coach_Profile>;
  /** fetch data from the table: "espin.college" */
  espin_college: Array<Espin_College>;
  /** fetch aggregated fields from the table: "espin.college" */
  espin_college_aggregate: Espin_College_Aggregate;
  /** fetch data from the table: "espin.college_automatic_message_response_type" */
  espin_college_automatic_message_response_type: Array<Espin_College_Automatic_Message_Response_Type>;
  /** fetch aggregated fields from the table: "espin.college_automatic_message_response_type" */
  espin_college_automatic_message_response_type_aggregate: Espin_College_Automatic_Message_Response_Type_Aggregate;
  /** fetch data from the table: "espin.college_automatic_message_response_type" using primary key columns */
  espin_college_automatic_message_response_type_by_pk?: Maybe<Espin_College_Automatic_Message_Response_Type>;
  /** fetch data from the table: "espin.college" using primary key columns */
  espin_college_by_pk?: Maybe<Espin_College>;
  /** fetch data from the table: "espin.college_game" */
  espin_college_game: Array<Espin_College_Game>;
  /** fetch aggregated fields from the table: "espin.college_game" */
  espin_college_game_aggregate: Espin_College_Game_Aggregate;
  /** fetch data from the table: "espin.college_game" using primary key columns */
  espin_college_game_by_pk?: Maybe<Espin_College_Game>;
  /** fetch data from the table: "espin.college_image" */
  espin_college_image: Array<Espin_College_Image>;
  /** fetch aggregated fields from the table: "espin.college_image" */
  espin_college_image_aggregate: Espin_College_Image_Aggregate;
  /** fetch data from the table: "espin.college_image" using primary key columns */
  espin_college_image_by_pk?: Maybe<Espin_College_Image>;
  /** fetch data from the table: "espin.college_invite" */
  espin_college_invite: Array<Espin_College_Invite>;
  /** fetch aggregated fields from the table: "espin.college_invite" */
  espin_college_invite_aggregate: Espin_College_Invite_Aggregate;
  /** fetch data from the table: "espin.college_invite" using primary key columns */
  espin_college_invite_by_pk?: Maybe<Espin_College_Invite>;
  /** fetch data from the table: "espin.college_preferences" */
  espin_college_preferences: Array<Espin_College_Preferences>;
  /** fetch aggregated fields from the table: "espin.college_preferences" */
  espin_college_preferences_aggregate: Espin_College_Preferences_Aggregate;
  /** fetch data from the table: "espin.college_preferences" using primary key columns */
  espin_college_preferences_by_pk?: Maybe<Espin_College_Preferences>;
  /** fetch data from the table: "espin.college_profile" */
  espin_college_profile: Array<Espin_College_Profile>;
  /** fetch aggregated fields from the table: "espin.college_profile" */
  espin_college_profile_aggregate: Espin_College_Profile_Aggregate;
  /** fetch data from the table: "espin.college_profile" using primary key columns */
  espin_college_profile_by_pk?: Maybe<Espin_College_Profile>;
  /** fetch data from the table: "espin.college_roster" */
  espin_college_roster: Array<Espin_College_Roster>;
  /** fetch aggregated fields from the table: "espin.college_roster" */
  espin_college_roster_aggregate: Espin_College_Roster_Aggregate;
  /** fetch data from the table: "espin.college_roster" using primary key columns */
  espin_college_roster_by_pk?: Maybe<Espin_College_Roster>;
  /** fetch data from the table: "espin.college_staff_member" */
  espin_college_staff_member: Array<Espin_College_Staff_Member>;
  /** fetch aggregated fields from the table: "espin.college_staff_member" */
  espin_college_staff_member_aggregate: Espin_College_Staff_Member_Aggregate;
  /** fetch data from the table: "espin.college_staff_member" using primary key columns */
  espin_college_staff_member_by_pk?: Maybe<Espin_College_Staff_Member>;
  /** fetch data from the table: "espin.college_subscription" */
  espin_college_subscription: Array<Espin_College_Subscription>;
  /** fetch aggregated fields from the table: "espin.college_subscription" */
  espin_college_subscription_aggregate: Espin_College_Subscription_Aggregate;
  /** fetch data from the table: "espin.college_subscription" using primary key columns */
  espin_college_subscription_by_pk?: Maybe<Espin_College_Subscription>;
  /** fetch data from the table: "espin.college_verification_status_type" */
  espin_college_verification_status_type: Array<Espin_College_Verification_Status_Type>;
  /** fetch aggregated fields from the table: "espin.college_verification_status_type" */
  espin_college_verification_status_type_aggregate: Espin_College_Verification_Status_Type_Aggregate;
  /** fetch data from the table: "espin.college_verification_status_type" using primary key columns */
  espin_college_verification_status_type_by_pk?: Maybe<Espin_College_Verification_Status_Type>;
  /** fetch data from the table: "espin.draft_player_profile" */
  espin_draft_player_profile: Array<Espin_Draft_Player_Profile>;
  /** fetch aggregated fields from the table: "espin.draft_player_profile" */
  espin_draft_player_profile_aggregate: Espin_Draft_Player_Profile_Aggregate;
  /** fetch data from the table: "espin.draft_player_profile" using primary key columns */
  espin_draft_player_profile_by_pk?: Maybe<Espin_Draft_Player_Profile>;
  /** fetch data from the table: "espin.editable_site_content" */
  espin_editable_site_content: Array<Espin_Editable_Site_Content>;
  /** fetch aggregated fields from the table: "espin.editable_site_content" */
  espin_editable_site_content_aggregate: Espin_Editable_Site_Content_Aggregate;
  /** fetch data from the table: "espin.editable_site_content" using primary key columns */
  espin_editable_site_content_by_pk?: Maybe<Espin_Editable_Site_Content>;
  /** fetch data from the table: "espin.ethnicity_options" */
  espin_ethnicity_options: Array<Espin_Ethnicity_Options>;
  /** fetch aggregated fields from the table: "espin.ethnicity_options" */
  espin_ethnicity_options_aggregate: Espin_Ethnicity_Options_Aggregate;
  /** fetch data from the table: "espin.ethnicity_options" using primary key columns */
  espin_ethnicity_options_by_pk?: Maybe<Espin_Ethnicity_Options>;
  /** fetch data from the table: "espin.event" */
  espin_event: Array<Espin_Event>;
  /** fetch aggregated fields from the table: "espin.event" */
  espin_event_aggregate: Espin_Event_Aggregate;
  /** fetch data from the table: "espin.event" using primary key columns */
  espin_event_by_pk?: Maybe<Espin_Event>;
  /** fetch data from the table: "espin.event_custom_field" */
  espin_event_custom_field: Array<Espin_Event_Custom_Field>;
  /** fetch aggregated fields from the table: "espin.event_custom_field" */
  espin_event_custom_field_aggregate: Espin_Event_Custom_Field_Aggregate;
  /** fetch data from the table: "espin.event_custom_field" using primary key columns */
  espin_event_custom_field_by_pk?: Maybe<Espin_Event_Custom_Field>;
  /** fetch data from the table: "espin.event_custom_field_type" */
  espin_event_custom_field_type: Array<Espin_Event_Custom_Field_Type>;
  /** fetch aggregated fields from the table: "espin.event_custom_field_type" */
  espin_event_custom_field_type_aggregate: Espin_Event_Custom_Field_Type_Aggregate;
  /** fetch data from the table: "espin.event_custom_field_type" using primary key columns */
  espin_event_custom_field_type_by_pk?: Maybe<Espin_Event_Custom_Field_Type>;
  /** fetch data from the table: "espin.event_document" */
  espin_event_document: Array<Espin_Event_Document>;
  /** fetch aggregated fields from the table: "espin.event_document" */
  espin_event_document_aggregate: Espin_Event_Document_Aggregate;
  /** fetch data from the table: "espin.event_document" using primary key columns */
  espin_event_document_by_pk?: Maybe<Espin_Event_Document>;
  /** fetch data from the table: "espin.event_game" */
  espin_event_game: Array<Espin_Event_Game>;
  /** fetch aggregated fields from the table: "espin.event_game" */
  espin_event_game_aggregate: Espin_Event_Game_Aggregate;
  /** fetch data from the table: "espin.event_game" using primary key columns */
  espin_event_game_by_pk?: Maybe<Espin_Event_Game>;
  /** fetch data from the table: "espin.event_registration" */
  espin_event_registration: Array<Espin_Event_Registration>;
  /** fetch aggregated fields from the table: "espin.event_registration" */
  espin_event_registration_aggregate: Espin_Event_Registration_Aggregate;
  /** fetch data from the table: "espin.event_registration" using primary key columns */
  espin_event_registration_by_pk?: Maybe<Espin_Event_Registration>;
  /** fetch data from the table: "espin.event_registration_custom_field_entry" */
  espin_event_registration_custom_field_entry: Array<Espin_Event_Registration_Custom_Field_Entry>;
  /** fetch aggregated fields from the table: "espin.event_registration_custom_field_entry" */
  espin_event_registration_custom_field_entry_aggregate: Espin_Event_Registration_Custom_Field_Entry_Aggregate;
  /** fetch data from the table: "espin.event_registration_custom_field_entry" using primary key columns */
  espin_event_registration_custom_field_entry_by_pk?: Maybe<Espin_Event_Registration_Custom_Field_Entry>;
  /** fetch data from the table: "espin.event_registration_document_signoff" */
  espin_event_registration_document_signoff: Array<Espin_Event_Registration_Document_Signoff>;
  /** fetch aggregated fields from the table: "espin.event_registration_document_signoff" */
  espin_event_registration_document_signoff_aggregate: Espin_Event_Registration_Document_Signoff_Aggregate;
  /** fetch data from the table: "espin.event_registration_document_signoff" using primary key columns */
  espin_event_registration_document_signoff_by_pk?: Maybe<Espin_Event_Registration_Document_Signoff>;
  /** fetch data from the table: "espin.event_registration_status" */
  espin_event_registration_status: Array<Espin_Event_Registration_Status>;
  /** fetch aggregated fields from the table: "espin.event_registration_status" */
  espin_event_registration_status_aggregate: Espin_Event_Registration_Status_Aggregate;
  /** fetch data from the table: "espin.event_registration_status" using primary key columns */
  espin_event_registration_status_by_pk?: Maybe<Espin_Event_Registration_Status>;
  /** fetch data from the table: "espin.event_ticket" */
  espin_event_ticket: Array<Espin_Event_Ticket>;
  /** fetch aggregated fields from the table: "espin.event_ticket" */
  espin_event_ticket_aggregate: Espin_Event_Ticket_Aggregate;
  /** fetch data from the table: "espin.event_ticket" using primary key columns */
  espin_event_ticket_by_pk?: Maybe<Espin_Event_Ticket>;
  /** fetch data from the table: "espin.event_ticket_type" */
  espin_event_ticket_type: Array<Espin_Event_Ticket_Type>;
  /** fetch aggregated fields from the table: "espin.event_ticket_type" */
  espin_event_ticket_type_aggregate: Espin_Event_Ticket_Type_Aggregate;
  /** fetch data from the table: "espin.event_ticket_type" using primary key columns */
  espin_event_ticket_type_by_pk?: Maybe<Espin_Event_Ticket_Type>;
  /** fetch data from the table: "espin.event_type" */
  espin_event_type: Array<Espin_Event_Type>;
  /** fetch aggregated fields from the table: "espin.event_type" */
  espin_event_type_aggregate: Espin_Event_Type_Aggregate;
  /** fetch data from the table: "espin.event_type" using primary key columns */
  espin_event_type_by_pk?: Maybe<Espin_Event_Type>;
  /** fetch data from the table: "espin.external_provider" */
  espin_external_provider: Array<Espin_External_Provider>;
  /** fetch aggregated fields from the table: "espin.external_provider" */
  espin_external_provider_aggregate: Espin_External_Provider_Aggregate;
  /** fetch data from the table: "espin.external_provider" using primary key columns */
  espin_external_provider_by_pk?: Maybe<Espin_External_Provider>;
  /** fetch data from the table: "espin.external_provider_link" */
  espin_external_provider_link: Array<Espin_External_Provider_Link>;
  /** fetch aggregated fields from the table: "espin.external_provider_link" */
  espin_external_provider_link_aggregate: Espin_External_Provider_Link_Aggregate;
  /** fetch data from the table: "espin.external_provider_link" using primary key columns */
  espin_external_provider_link_by_pk?: Maybe<Espin_External_Provider_Link>;
  /** fetch data from the table: "espin.follow" */
  espin_follow: Array<Espin_Follow>;
  /** fetch aggregated fields from the table: "espin.follow" */
  espin_follow_aggregate: Espin_Follow_Aggregate;
  /** fetch data from the table: "espin.follow" using primary key columns */
  espin_follow_by_pk?: Maybe<Espin_Follow>;
  /** fetch data from the table: "espin.follow_type" */
  espin_follow_type: Array<Espin_Follow_Type>;
  /** fetch aggregated fields from the table: "espin.follow_type" */
  espin_follow_type_aggregate: Espin_Follow_Type_Aggregate;
  /** fetch data from the table: "espin.follow_type" using primary key columns */
  espin_follow_type_by_pk?: Maybe<Espin_Follow_Type>;
  /** fetch data from the table: "espin.follower_email_notification_type" */
  espin_follower_email_notification_type: Array<Espin_Follower_Email_Notification_Type>;
  /** fetch aggregated fields from the table: "espin.follower_email_notification_type" */
  espin_follower_email_notification_type_aggregate: Espin_Follower_Email_Notification_Type_Aggregate;
  /** fetch data from the table: "espin.follower_email_notification_type" using primary key columns */
  espin_follower_email_notification_type_by_pk?: Maybe<Espin_Follower_Email_Notification_Type>;
  /** fetch data from the table: "espin.force_notification_reload" */
  espin_force_notification_reload: Array<Espin_Force_Notification_Reload>;
  /** fetch aggregated fields from the table: "espin.force_notification_reload" */
  espin_force_notification_reload_aggregate: Espin_Force_Notification_Reload_Aggregate;
  /** fetch data from the table: "espin.force_notification_reload" using primary key columns */
  espin_force_notification_reload_by_pk?: Maybe<Espin_Force_Notification_Reload>;
  /** fetch data from the table: "espin.game" */
  espin_game: Array<Espin_Game>;
  /** fetch aggregated fields from the table: "espin.game" */
  espin_game_aggregate: Espin_Game_Aggregate;
  /** fetch data from the table: "espin.game" using primary key columns */
  espin_game_by_pk?: Maybe<Espin_Game>;
  /** fetch data from the table: "espin.game_definition" */
  espin_game_definition: Array<Espin_Game_Definition>;
  /** fetch aggregated fields from the table: "espin.game_definition" */
  espin_game_definition_aggregate: Espin_Game_Definition_Aggregate;
  /** fetch data from the table: "espin.game_definition" using primary key columns */
  espin_game_definition_by_pk?: Maybe<Espin_Game_Definition>;
  /** fetch data from the table: "espin.game_platform" */
  espin_game_platform: Array<Espin_Game_Platform>;
  /** fetch aggregated fields from the table: "espin.game_platform" */
  espin_game_platform_aggregate: Espin_Game_Platform_Aggregate;
  /** fetch data from the table: "espin.game_platform" using primary key columns */
  espin_game_platform_by_pk?: Maybe<Espin_Game_Platform>;
  /** fetch data from the table: "espin.gender_options" */
  espin_gender_options: Array<Espin_Gender_Options>;
  /** fetch aggregated fields from the table: "espin.gender_options" */
  espin_gender_options_aggregate: Espin_Gender_Options_Aggregate;
  /** fetch data from the table: "espin.gender_options" using primary key columns */
  espin_gender_options_by_pk?: Maybe<Espin_Gender_Options>;
  /** fetch data from the table: "espin.graduating_class" */
  espin_graduating_class: Array<Espin_Graduating_Class>;
  /** fetch aggregated fields from the table: "espin.graduating_class" */
  espin_graduating_class_aggregate: Espin_Graduating_Class_Aggregate;
  /** fetch data from the table: "espin.graduating_class" using primary key columns */
  espin_graduating_class_by_pk?: Maybe<Espin_Graduating_Class>;
  /** fetch data from the table: "espin.high_school" */
  espin_high_school: Array<Espin_High_School>;
  /** fetch aggregated fields from the table: "espin.high_school" */
  espin_high_school_aggregate: Espin_High_School_Aggregate;
  /** fetch data from the table: "espin.high_school" using primary key columns */
  espin_high_school_by_pk?: Maybe<Espin_High_School>;
  /** fetch data from the table: "espin.high_school_invite" */
  espin_high_school_invite: Array<Espin_High_School_Invite>;
  /** fetch aggregated fields from the table: "espin.high_school_invite" */
  espin_high_school_invite_aggregate: Espin_High_School_Invite_Aggregate;
  /** fetch data from the table: "espin.high_school_invite" using primary key columns */
  espin_high_school_invite_by_pk?: Maybe<Espin_High_School_Invite>;
  /** fetch data from the table: "espin.high_school_profile" */
  espin_high_school_profile: Array<Espin_High_School_Profile>;
  /** fetch aggregated fields from the table: "espin.high_school_profile" */
  espin_high_school_profile_aggregate: Espin_High_School_Profile_Aggregate;
  /** fetch data from the table: "espin.high_school_profile" using primary key columns */
  espin_high_school_profile_by_pk?: Maybe<Espin_High_School_Profile>;
  /** fetch data from the table: "espin.invite_status_type" */
  espin_invite_status_type: Array<Espin_Invite_Status_Type>;
  /** fetch aggregated fields from the table: "espin.invite_status_type" */
  espin_invite_status_type_aggregate: Espin_Invite_Status_Type_Aggregate;
  /** fetch data from the table: "espin.invite_status_type" using primary key columns */
  espin_invite_status_type_by_pk?: Maybe<Espin_Invite_Status_Type>;
  /** fetch data from the table: "espin.leaderboard" */
  espin_leaderboard: Array<Espin_Leaderboard>;
  /** fetch aggregated fields from the table: "espin.leaderboard" */
  espin_leaderboard_aggregate: Espin_Leaderboard_Aggregate;
  /** fetch data from the table: "espin.leaderboard" using primary key columns */
  espin_leaderboard_by_pk?: Maybe<Espin_Leaderboard>;
  /** fetch data from the table: "espin.membership" */
  espin_membership: Array<Espin_Membership>;
  /** fetch aggregated fields from the table: "espin.membership" */
  espin_membership_aggregate: Espin_Membership_Aggregate;
  /** fetch data from the table: "espin.membership" using primary key columns */
  espin_membership_by_pk?: Maybe<Espin_Membership>;
  /** fetch data from the table: "espin.message" */
  espin_message: Array<Espin_Message>;
  /** fetch aggregated fields from the table: "espin.message" */
  espin_message_aggregate: Espin_Message_Aggregate;
  /** fetch data from the table: "espin.message" using primary key columns */
  espin_message_by_pk?: Maybe<Espin_Message>;
  /** fetch data from the table: "espin.message_email_notification_type" */
  espin_message_email_notification_type: Array<Espin_Message_Email_Notification_Type>;
  /** fetch aggregated fields from the table: "espin.message_email_notification_type" */
  espin_message_email_notification_type_aggregate: Espin_Message_Email_Notification_Type_Aggregate;
  /** fetch data from the table: "espin.message_email_notification_type" using primary key columns */
  espin_message_email_notification_type_by_pk?: Maybe<Espin_Message_Email_Notification_Type>;
  /** fetch data from the table: "espin.message_type" */
  espin_message_type: Array<Espin_Message_Type>;
  /** fetch aggregated fields from the table: "espin.message_type" */
  espin_message_type_aggregate: Espin_Message_Type_Aggregate;
  /** fetch data from the table: "espin.message_type" using primary key columns */
  espin_message_type_by_pk?: Maybe<Espin_Message_Type>;
  /** fetch data from the table: "espin.moderation_status" */
  espin_moderation_status: Array<Espin_Moderation_Status>;
  /** fetch aggregated fields from the table: "espin.moderation_status" */
  espin_moderation_status_aggregate: Espin_Moderation_Status_Aggregate;
  /** fetch data from the table: "espin.moderation_status" using primary key columns */
  espin_moderation_status_by_pk?: Maybe<Espin_Moderation_Status>;
  /** fetch data from the table: "espin.newsletter_request" */
  espin_newsletter_request: Array<Espin_Newsletter_Request>;
  /** fetch aggregated fields from the table: "espin.newsletter_request" */
  espin_newsletter_request_aggregate: Espin_Newsletter_Request_Aggregate;
  /** fetch data from the table: "espin.newsletter_request" using primary key columns */
  espin_newsletter_request_by_pk?: Maybe<Espin_Newsletter_Request>;
  /** fetch data from the table: "espin.notification" */
  espin_notification: Array<Espin_Notification>;
  /** fetch aggregated fields from the table: "espin.notification" */
  espin_notification_aggregate: Espin_Notification_Aggregate;
  /** fetch data from the table: "espin.notification" using primary key columns */
  espin_notification_by_pk?: Maybe<Espin_Notification>;
  /** fetch data from the table: "espin.notification_type" */
  espin_notification_type: Array<Espin_Notification_Type>;
  /** fetch aggregated fields from the table: "espin.notification_type" */
  espin_notification_type_aggregate: Espin_Notification_Type_Aggregate;
  /** fetch data from the table: "espin.notification_type" using primary key columns */
  espin_notification_type_by_pk?: Maybe<Espin_Notification_Type>;
  /** fetch data from the table: "espin.org" */
  espin_org: Array<Espin_Org>;
  /** fetch aggregated fields from the table: "espin.org" */
  espin_org_aggregate: Espin_Org_Aggregate;
  /** fetch data from the table: "espin.org" using primary key columns */
  espin_org_by_pk?: Maybe<Espin_Org>;
  /** fetch data from the table: "espin.org_month" */
  espin_org_month: Array<Espin_Org_Month>;
  /** fetch aggregated fields from the table: "espin.org_month" */
  espin_org_month_aggregate: Espin_Org_Month_Aggregate;
  /** fetch data from the table: "espin.org_month" using primary key columns */
  espin_org_month_by_pk?: Maybe<Espin_Org_Month>;
  /** fetch data from the table: "espin.org_month_day" */
  espin_org_month_day: Array<Espin_Org_Month_Day>;
  /** fetch aggregated fields from the table: "espin.org_month_day" */
  espin_org_month_day_aggregate: Espin_Org_Month_Day_Aggregate;
  /** fetch data from the table: "espin.org_month_day" using primary key columns */
  espin_org_month_day_by_pk?: Maybe<Espin_Org_Month_Day>;
  /** fetch data from the table: "espin.org_player" */
  espin_org_player: Array<Espin_Org_Player>;
  /** fetch aggregated fields from the table: "espin.org_player" */
  espin_org_player_aggregate: Espin_Org_Player_Aggregate;
  /** fetch data from the table: "espin.org_player" using primary key columns */
  espin_org_player_by_pk?: Maybe<Espin_Org_Player>;
  /** fetch data from the table: "espin.org_school" */
  espin_org_school: Array<Espin_Org_School>;
  /** fetch aggregated fields from the table: "espin.org_school" */
  espin_org_school_aggregate: Espin_Org_School_Aggregate;
  /** fetch data from the table: "espin.org_school" using primary key columns */
  espin_org_school_by_pk?: Maybe<Espin_Org_School>;
  /** fetch data from the table: "espin.org_school_record" */
  espin_org_school_record: Array<Espin_Org_School_Record>;
  /** fetch aggregated fields from the table: "espin.org_school_record" */
  espin_org_school_record_aggregate: Espin_Org_School_Record_Aggregate;
  /** fetch data from the table: "espin.org_school_record" using primary key columns */
  espin_org_school_record_by_pk?: Maybe<Espin_Org_School_Record>;
  /** fetch data from the table: "espin.paid_product" */
  espin_paid_product: Array<Espin_Paid_Product>;
  /** fetch aggregated fields from the table: "espin.paid_product" */
  espin_paid_product_aggregate: Espin_Paid_Product_Aggregate;
  /** fetch data from the table: "espin.paid_product" using primary key columns */
  espin_paid_product_by_pk?: Maybe<Espin_Paid_Product>;
  /** fetch data from the table: "espin.parent_invite" */
  espin_parent_invite: Array<Espin_Parent_Invite>;
  /** fetch aggregated fields from the table: "espin.parent_invite" */
  espin_parent_invite_aggregate: Espin_Parent_Invite_Aggregate;
  /** fetch data from the table: "espin.parent_invite" using primary key columns */
  espin_parent_invite_by_pk?: Maybe<Espin_Parent_Invite>;
  /** fetch data from the table: "espin.parent_profile" */
  espin_parent_profile: Array<Espin_Parent_Profile>;
  /** fetch aggregated fields from the table: "espin.parent_profile" */
  espin_parent_profile_aggregate: Espin_Parent_Profile_Aggregate;
  /** fetch data from the table: "espin.parent_profile" using primary key columns */
  espin_parent_profile_by_pk?: Maybe<Espin_Parent_Profile>;
  /** fetch data from the table: "espin.player_game" */
  espin_player_game: Array<Espin_Player_Game>;
  /** fetch aggregated fields from the table: "espin.player_game" */
  espin_player_game_aggregate: Espin_Player_Game_Aggregate;
  /** fetch data from the table: "espin.player_game" using primary key columns */
  espin_player_game_by_pk?: Maybe<Espin_Player_Game>;
  /** fetch data from the table: "espin.player_journey" */
  espin_player_journey: Array<Espin_Player_Journey>;
  /** fetch aggregated fields from the table: "espin.player_journey" */
  espin_player_journey_aggregate: Espin_Player_Journey_Aggregate;
  /** fetch data from the table: "espin.player_journey" using primary key columns */
  espin_player_journey_by_pk?: Maybe<Espin_Player_Journey>;
  /** fetch data from the table: "espin.player_journey_stage" */
  espin_player_journey_stage: Array<Espin_Player_Journey_Stage>;
  /** fetch aggregated fields from the table: "espin.player_journey_stage" */
  espin_player_journey_stage_aggregate: Espin_Player_Journey_Stage_Aggregate;
  /** fetch data from the table: "espin.player_journey_stage" using primary key columns */
  espin_player_journey_stage_by_pk?: Maybe<Espin_Player_Journey_Stage>;
  /** fetch data from the table: "espin.player_journey_stage_college" */
  espin_player_journey_stage_college: Array<Espin_Player_Journey_Stage_College>;
  /** fetch aggregated fields from the table: "espin.player_journey_stage_college" */
  espin_player_journey_stage_college_aggregate: Espin_Player_Journey_Stage_College_Aggregate;
  /** fetch data from the table: "espin.player_journey_stage_college" using primary key columns */
  espin_player_journey_stage_college_by_pk?: Maybe<Espin_Player_Journey_Stage_College>;
  /** fetch data from the table: "espin.player_journey_stage_def" */
  espin_player_journey_stage_def: Array<Espin_Player_Journey_Stage_Def>;
  /** fetch aggregated fields from the table: "espin.player_journey_stage_def" */
  espin_player_journey_stage_def_aggregate: Espin_Player_Journey_Stage_Def_Aggregate;
  /** fetch data from the table: "espin.player_journey_stage_def" using primary key columns */
  espin_player_journey_stage_def_by_pk?: Maybe<Espin_Player_Journey_Stage_Def>;
  /** fetch data from the table: "espin.player_journey_stage_image" */
  espin_player_journey_stage_image: Array<Espin_Player_Journey_Stage_Image>;
  /** fetch aggregated fields from the table: "espin.player_journey_stage_image" */
  espin_player_journey_stage_image_aggregate: Espin_Player_Journey_Stage_Image_Aggregate;
  /** fetch data from the table: "espin.player_journey_stage_image" using primary key columns */
  espin_player_journey_stage_image_by_pk?: Maybe<Espin_Player_Journey_Stage_Image>;
  /** fetch data from the table: "espin.player_journey_stage_quote" */
  espin_player_journey_stage_quote: Array<Espin_Player_Journey_Stage_Quote>;
  /** fetch aggregated fields from the table: "espin.player_journey_stage_quote" */
  espin_player_journey_stage_quote_aggregate: Espin_Player_Journey_Stage_Quote_Aggregate;
  /** fetch data from the table: "espin.player_journey_stage_quote" using primary key columns */
  espin_player_journey_stage_quote_by_pk?: Maybe<Espin_Player_Journey_Stage_Quote>;
  /** fetch data from the table: "espin.player_journey_stage_video" */
  espin_player_journey_stage_video: Array<Espin_Player_Journey_Stage_Video>;
  /** fetch aggregated fields from the table: "espin.player_journey_stage_video" */
  espin_player_journey_stage_video_aggregate: Espin_Player_Journey_Stage_Video_Aggregate;
  /** fetch data from the table: "espin.player_journey_stage_video" using primary key columns */
  espin_player_journey_stage_video_by_pk?: Maybe<Espin_Player_Journey_Stage_Video>;
  /** fetch data from the table: "espin.player_profile" */
  espin_player_profile: Array<Espin_Player_Profile>;
  /** fetch aggregated fields from the table: "espin.player_profile" */
  espin_player_profile_aggregate: Espin_Player_Profile_Aggregate;
  /** fetch data from the table: "espin.player_profile" using primary key columns */
  espin_player_profile_by_pk?: Maybe<Espin_Player_Profile>;
  /** fetch data from the table: "espin.player_subscription" */
  espin_player_subscription: Array<Espin_Player_Subscription>;
  /** fetch aggregated fields from the table: "espin.player_subscription" */
  espin_player_subscription_aggregate: Espin_Player_Subscription_Aggregate;
  /** fetch data from the table: "espin.player_subscription" using primary key columns */
  espin_player_subscription_by_pk?: Maybe<Espin_Player_Subscription>;
  /** fetch data from the table: "espin.player_vod" */
  espin_player_vod: Array<Espin_Player_Vod>;
  /** fetch aggregated fields from the table: "espin.player_vod" */
  espin_player_vod_aggregate: Espin_Player_Vod_Aggregate;
  /** fetch data from the table: "espin.player_vod" using primary key columns */
  espin_player_vod_by_pk?: Maybe<Espin_Player_Vod>;
  /** fetch data from the table: "espin.profile_view" */
  espin_profile_view: Array<Espin_Profile_View>;
  /** fetch aggregated fields from the table: "espin.profile_view" */
  espin_profile_view_aggregate: Espin_Profile_View_Aggregate;
  /** fetch data from the table: "espin.profile_view" using primary key columns */
  espin_profile_view_by_pk?: Maybe<Espin_Profile_View>;
  /** fetch data from the table: "espin.profile_view_email_notification_type" */
  espin_profile_view_email_notification_type: Array<Espin_Profile_View_Email_Notification_Type>;
  /** fetch aggregated fields from the table: "espin.profile_view_email_notification_type" */
  espin_profile_view_email_notification_type_aggregate: Espin_Profile_View_Email_Notification_Type_Aggregate;
  /** fetch data from the table: "espin.profile_view_email_notification_type" using primary key columns */
  espin_profile_view_email_notification_type_by_pk?: Maybe<Espin_Profile_View_Email_Notification_Type>;
  /** fetch data from the table: "espin.profile_view_type" */
  espin_profile_view_type: Array<Espin_Profile_View_Type>;
  /** fetch aggregated fields from the table: "espin.profile_view_type" */
  espin_profile_view_type_aggregate: Espin_Profile_View_Type_Aggregate;
  /** fetch data from the table: "espin.profile_view_type" using primary key columns */
  espin_profile_view_type_by_pk?: Maybe<Espin_Profile_View_Type>;
  /** fetch data from the table: "espin.referral_code" */
  espin_referral_code: Array<Espin_Referral_Code>;
  /** fetch aggregated fields from the table: "espin.referral_code" */
  espin_referral_code_aggregate: Espin_Referral_Code_Aggregate;
  /** fetch data from the table: "espin.referral_code" using primary key columns */
  espin_referral_code_by_pk?: Maybe<Espin_Referral_Code>;
  /** fetch data from the table: "espin.referral_code_redemption" */
  espin_referral_code_redemption: Array<Espin_Referral_Code_Redemption>;
  /** fetch aggregated fields from the table: "espin.referral_code_redemption" */
  espin_referral_code_redemption_aggregate: Espin_Referral_Code_Redemption_Aggregate;
  /** fetch data from the table: "espin.referral_code_redemption" using primary key columns */
  espin_referral_code_redemption_by_pk?: Maybe<Espin_Referral_Code_Redemption>;
  /** fetch data from the table: "espin.referral_option" */
  espin_referral_option: Array<Espin_Referral_Option>;
  /** fetch aggregated fields from the table: "espin.referral_option" */
  espin_referral_option_aggregate: Espin_Referral_Option_Aggregate;
  /** fetch data from the table: "espin.referral_option" using primary key columns */
  espin_referral_option_by_pk?: Maybe<Espin_Referral_Option>;
  /** fetch data from the table: "espin.role" */
  espin_role: Array<Espin_Role>;
  /** fetch aggregated fields from the table: "espin.role" */
  espin_role_aggregate: Espin_Role_Aggregate;
  /** fetch data from the table: "espin.role" using primary key columns */
  espin_role_by_pk?: Maybe<Espin_Role>;
  /** fetch data from the table: "espin.site_content" */
  espin_site_content: Array<Espin_Site_Content>;
  /** fetch aggregated fields from the table: "espin.site_content" */
  espin_site_content_aggregate: Espin_Site_Content_Aggregate;
  /** fetch data from the table: "espin.site_content" using primary key columns */
  espin_site_content_by_pk?: Maybe<Espin_Site_Content>;
  /** fetch data from the table: "espin.social" */
  espin_social: Array<Espin_Social>;
  /** fetch aggregated fields from the table: "espin.social" */
  espin_social_aggregate: Espin_Social_Aggregate;
  /** fetch data from the table: "espin.social" using primary key columns */
  espin_social_by_pk?: Maybe<Espin_Social>;
  /** fetch data from the table: "espin.stickied_college" */
  espin_stickied_college: Array<Espin_Stickied_College>;
  /** fetch aggregated fields from the table: "espin.stickied_college" */
  espin_stickied_college_aggregate: Espin_Stickied_College_Aggregate;
  /** fetch data from the table: "espin.stickied_college" using primary key columns */
  espin_stickied_college_by_pk?: Maybe<Espin_Stickied_College>;
  /** fetch data from the table: "espin.stickied_player" */
  espin_stickied_player: Array<Espin_Stickied_Player>;
  /** fetch aggregated fields from the table: "espin.stickied_player" */
  espin_stickied_player_aggregate: Espin_Stickied_Player_Aggregate;
  /** fetch data from the table: "espin.stickied_player" using primary key columns */
  espin_stickied_player_by_pk?: Maybe<Espin_Stickied_Player>;
  /** fetch data from the table: "espin.study_field" */
  espin_study_field: Array<Espin_Study_Field>;
  /** fetch aggregated fields from the table: "espin.study_field" */
  espin_study_field_aggregate: Espin_Study_Field_Aggregate;
  /** fetch data from the table: "espin.study_field" using primary key columns */
  espin_study_field_by_pk?: Maybe<Espin_Study_Field>;
  /** fetch data from the table: "espin.study_subject" */
  espin_study_subject: Array<Espin_Study_Subject>;
  /** fetch aggregated fields from the table: "espin.study_subject" */
  espin_study_subject_aggregate: Espin_Study_Subject_Aggregate;
  /** fetch data from the table: "espin.study_subject" using primary key columns */
  espin_study_subject_by_pk?: Maybe<Espin_Study_Subject>;
  /** fetch data from the table: "espin.subscription_status" */
  espin_subscription_status: Array<Espin_Subscription_Status>;
  /** fetch aggregated fields from the table: "espin.subscription_status" */
  espin_subscription_status_aggregate: Espin_Subscription_Status_Aggregate;
  /** fetch data from the table: "espin.subscription_status" using primary key columns */
  espin_subscription_status_by_pk?: Maybe<Espin_Subscription_Status>;
  /** fetch data from the table: "espin.subscription_tier_type" */
  espin_subscription_tier_type: Array<Espin_Subscription_Tier_Type>;
  /** fetch aggregated fields from the table: "espin.subscription_tier_type" */
  espin_subscription_tier_type_aggregate: Espin_Subscription_Tier_Type_Aggregate;
  /** fetch data from the table: "espin.subscription_tier_type" using primary key columns */
  espin_subscription_tier_type_by_pk?: Maybe<Espin_Subscription_Tier_Type>;
  /** fetch data from the table: "espin.team" */
  espin_team: Array<Espin_Team>;
  /** fetch aggregated fields from the table: "espin.team" */
  espin_team_aggregate: Espin_Team_Aggregate;
  /** fetch data from the table: "espin.team" using primary key columns */
  espin_team_by_pk?: Maybe<Espin_Team>;
  /** fetch data from the table: "espin.team_invite" */
  espin_team_invite: Array<Espin_Team_Invite>;
  /** fetch aggregated fields from the table: "espin.team_invite" */
  espin_team_invite_aggregate: Espin_Team_Invite_Aggregate;
  /** fetch data from the table: "espin.team_invite" using primary key columns */
  espin_team_invite_by_pk?: Maybe<Espin_Team_Invite>;
  /** fetch data from the table: "espin.team_members" */
  espin_team_members: Array<Espin_Team_Members>;
  /** fetch aggregated fields from the table: "espin.team_members" */
  espin_team_members_aggregate: Espin_Team_Members_Aggregate;
  /** fetch data from the table: "espin.team_members" using primary key columns */
  espin_team_members_by_pk?: Maybe<Espin_Team_Members>;
  /** fetch data from the table: "espin.team_role" */
  espin_team_role: Array<Espin_Team_Role>;
  /** fetch aggregated fields from the table: "espin.team_role" */
  espin_team_role_aggregate: Espin_Team_Role_Aggregate;
  /** fetch data from the table: "espin.team_role" using primary key columns */
  espin_team_role_by_pk?: Maybe<Espin_Team_Role>;
  /** fetch data from the table: "espin.team_type" */
  espin_team_type: Array<Espin_Team_Type>;
  /** fetch aggregated fields from the table: "espin.team_type" */
  espin_team_type_aggregate: Espin_Team_Type_Aggregate;
  /** fetch data from the table: "espin.team_type" using primary key columns */
  espin_team_type_by_pk?: Maybe<Espin_Team_Type>;
  /** fetch data from the table: "espin.unregistered_college" */
  espin_unregistered_college: Array<Espin_Unregistered_College>;
  /** fetch aggregated fields from the table: "espin.unregistered_college" */
  espin_unregistered_college_aggregate: Espin_Unregistered_College_Aggregate;
  /** fetch data from the table: "espin.unregistered_college" using primary key columns */
  espin_unregistered_college_by_pk?: Maybe<Espin_Unregistered_College>;
  /** fetch data from the table: "espin.user" */
  espin_user: Array<Espin_User>;
  /** fetch aggregated fields from the table: "espin.user" */
  espin_user_aggregate: Espin_User_Aggregate;
  /** fetch data from the table: "espin.user" using primary key columns */
  espin_user_by_pk?: Maybe<Espin_User>;
  /** fetch data from the table: "espin.user_linked_external_provider" */
  espin_user_linked_external_provider: Array<Espin_User_Linked_External_Provider>;
  /** fetch aggregated fields from the table: "espin.user_linked_external_provider" */
  espin_user_linked_external_provider_aggregate: Espin_User_Linked_External_Provider_Aggregate;
  /** fetch data from the table: "espin.user_linked_external_provider" using primary key columns */
  espin_user_linked_external_provider_by_pk?: Maybe<Espin_User_Linked_External_Provider>;
  /** fetch data from the table: "espin.user_membership" */
  espin_user_membership: Array<Espin_User_Membership>;
  /** fetch aggregated fields from the table: "espin.user_membership" */
  espin_user_membership_aggregate: Espin_User_Membership_Aggregate;
  /** fetch data from the table: "espin.user_membership" using primary key columns */
  espin_user_membership_by_pk?: Maybe<Espin_User_Membership>;
  /** fetch data from the table: "espin.user_source" */
  espin_user_source: Array<Espin_User_Source>;
  /** fetch aggregated fields from the table: "espin.user_source" */
  espin_user_source_aggregate: Espin_User_Source_Aggregate;
  /** fetch data from the table: "espin.user_source" using primary key columns */
  espin_user_source_by_pk?: Maybe<Espin_User_Source>;
  /** fetch data from the table: "espin.user_subscription_status" */
  espin_user_subscription_status: Array<Espin_User_Subscription_Status>;
  /** fetch aggregated fields from the table: "espin.user_subscription_status" */
  espin_user_subscription_status_aggregate: Espin_User_Subscription_Status_Aggregate;
  /** fetch data from the table: "queue.job" */
  queue_job: Array<Queue_Job>;
  /** fetch aggregated fields from the table: "queue.job" */
  queue_job_aggregate: Queue_Job_Aggregate;
  /** fetch data from the table: "queue.job" using primary key columns */
  queue_job_by_pk?: Maybe<Queue_Job>;
  /** fetch data from the table: "queue.job_status_type" */
  queue_job_status_type: Array<Queue_Job_Status_Type>;
  /** fetch aggregated fields from the table: "queue.job_status_type" */
  queue_job_status_type_aggregate: Queue_Job_Status_Type_Aggregate;
  /** fetch data from the table: "queue.job_status_type" using primary key columns */
  queue_job_status_type_by_pk?: Maybe<Queue_Job_Status_Type>;
  /** fetch data from the table: "queue.job_type" */
  queue_job_type: Array<Queue_Job_Type>;
  /** fetch aggregated fields from the table: "queue.job_type" */
  queue_job_type_aggregate: Queue_Job_Type_Aggregate;
  /** fetch data from the table: "queue.job_type" using primary key columns */
  queue_job_type_by_pk?: Maybe<Queue_Job_Type>;
  /** fetch data from the table: "stripe.customer_data" */
  stripe_customer_data: Array<Stripe_Customer_Data>;
  /** fetch aggregated fields from the table: "stripe.customer_data" */
  stripe_customer_data_aggregate: Stripe_Customer_Data_Aggregate;
  /** fetch data from the table: "stripe.customer_data" using primary key columns */
  stripe_customer_data_by_pk?: Maybe<Stripe_Customer_Data>;
  /** fetch data from the table: "stripe.invoice_data" */
  stripe_invoice_data: Array<Stripe_Invoice_Data>;
  /** fetch aggregated fields from the table: "stripe.invoice_data" */
  stripe_invoice_data_aggregate: Stripe_Invoice_Data_Aggregate;
  /** fetch data from the table: "stripe.invoice_data" using primary key columns */
  stripe_invoice_data_by_pk?: Maybe<Stripe_Invoice_Data>;
  /** fetch data from the table: "stripe.stripe_payment_data" */
  stripe_stripe_payment_data: Array<Stripe_Stripe_Payment_Data>;
  /** fetch aggregated fields from the table: "stripe.stripe_payment_data" */
  stripe_stripe_payment_data_aggregate: Stripe_Stripe_Payment_Data_Aggregate;
  /** fetch data from the table: "stripe.stripe_payment_data" using primary key columns */
  stripe_stripe_payment_data_by_pk?: Maybe<Stripe_Stripe_Payment_Data>;
  /** fetch data from the table: "stripe.stripe_subscription_data" */
  stripe_stripe_subscription_data: Array<Stripe_Stripe_Subscription_Data>;
  /** fetch aggregated fields from the table: "stripe.stripe_subscription_data" */
  stripe_stripe_subscription_data_aggregate: Stripe_Stripe_Subscription_Data_Aggregate;
  /** fetch data from the table: "stripe.stripe_subscription_data" using primary key columns */
  stripe_stripe_subscription_data_by_pk?: Maybe<Stripe_Stripe_Subscription_Data>;
  /** fetch data from the table: "tempstorage.keyvalue" */
  tempstorage_keyvalue: Array<Tempstorage_Keyvalue>;
  /** fetch aggregated fields from the table: "tempstorage.keyvalue" */
  tempstorage_keyvalue_aggregate: Tempstorage_Keyvalue_Aggregate;
  /** fetch data from the table: "tempstorage.keyvalue" using primary key columns */
  tempstorage_keyvalue_by_pk?: Maybe<Tempstorage_Keyvalue>;
};


export type Query_RootCehsite_Ms_Available_Site_TermsArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Available_Site_Terms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Available_Site_Terms_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Bool_Exp>;
};


export type Query_RootCehsite_Ms_Available_Site_Terms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Available_Site_Terms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Available_Site_Terms_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Bool_Exp>;
};


export type Query_RootCehsite_Ms_Available_Site_Terms_By_PkArgs = {
  key: Scalars['String'];
};


export type Query_RootCehsite_Ms_Contact_Form_EntryArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Contact_Form_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Contact_Form_Entry_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Contact_Form_Entry_Bool_Exp>;
};


export type Query_RootCehsite_Ms_Contact_Form_Entry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Contact_Form_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Contact_Form_Entry_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Contact_Form_Entry_Bool_Exp>;
};


export type Query_RootCehsite_Ms_Contact_Form_Entry_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCehsite_Ms_Newsletter_SignupArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Newsletter_Signup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Newsletter_Signup_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Newsletter_Signup_Bool_Exp>;
};


export type Query_RootCehsite_Ms_Newsletter_Signup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Newsletter_Signup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Newsletter_Signup_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Newsletter_Signup_Bool_Exp>;
};


export type Query_RootCehsite_Ms_Newsletter_Signup_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCehsite_Ms_Site_ContentArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Site_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Site_Content_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Site_Content_Bool_Exp>;
};


export type Query_RootCehsite_Ms_Site_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Site_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Site_Content_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Site_Content_Bool_Exp>;
};


export type Query_RootCehsite_Ms_Site_Content_By_PkArgs = {
  key: Cehsite_Ms_Available_Site_Terms_Enum;
};


export type Query_RootContent_FileArgs = {
  distinct_on?: InputMaybe<Array<Content_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_File_Order_By>>;
  where?: InputMaybe<Content_File_Bool_Exp>;
};


export type Query_RootContent_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_File_Order_By>>;
  where?: InputMaybe<Content_File_Bool_Exp>;
};


export type Query_RootContent_File_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootContent_File_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Content_File_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_File_Metadata_Order_By>>;
  where?: InputMaybe<Content_File_Metadata_Bool_Exp>;
};


export type Query_RootContent_File_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_File_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_File_Metadata_Order_By>>;
  where?: InputMaybe<Content_File_Metadata_Bool_Exp>;
};


export type Query_RootContent_File_Metadata_By_PkArgs = {
  file_id: Scalars['uuid'];
};


export type Query_RootContent_File_StatusArgs = {
  distinct_on?: InputMaybe<Array<Content_File_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_File_Status_Order_By>>;
  where?: InputMaybe<Content_File_Status_Bool_Exp>;
};


export type Query_RootContent_File_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_File_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_File_Status_Order_By>>;
  where?: InputMaybe<Content_File_Status_Bool_Exp>;
};


export type Query_RootContent_File_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootContent_Media_LinkArgs = {
  distinct_on?: InputMaybe<Array<Content_Media_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Media_Link_Order_By>>;
  where?: InputMaybe<Content_Media_Link_Bool_Exp>;
};


export type Query_RootContent_Media_Link_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_Media_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Media_Link_Order_By>>;
  where?: InputMaybe<Content_Media_Link_Bool_Exp>;
};


export type Query_RootContent_Media_Link_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootContent_Media_Link_TypeArgs = {
  distinct_on?: InputMaybe<Array<Content_Media_Link_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Media_Link_Type_Order_By>>;
  where?: InputMaybe<Content_Media_Link_Type_Bool_Exp>;
};


export type Query_RootContent_Media_Link_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_Media_Link_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Media_Link_Type_Order_By>>;
  where?: InputMaybe<Content_Media_Link_Type_Bool_Exp>;
};


export type Query_RootContent_Media_Link_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootContent_Project_NameArgs = {
  distinct_on?: InputMaybe<Array<Content_Project_Name_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Project_Name_Order_By>>;
  where?: InputMaybe<Content_Project_Name_Bool_Exp>;
};


export type Query_RootContent_Project_Name_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_Project_Name_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Project_Name_Order_By>>;
  where?: InputMaybe<Content_Project_Name_Bool_Exp>;
};


export type Query_RootContent_Project_Name_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootContent_StatusArgs = {
  distinct_on?: InputMaybe<Array<Content_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Status_Order_By>>;
  where?: InputMaybe<Content_Status_Bool_Exp>;
};


export type Query_RootContent_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Status_Order_By>>;
  where?: InputMaybe<Content_Status_Bool_Exp>;
};


export type Query_RootContent_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_AddressArgs = {
  distinct_on?: InputMaybe<Array<Espin_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Address_Order_By>>;
  where?: InputMaybe<Espin_Address_Bool_Exp>;
};


export type Query_RootEspin_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Address_Order_By>>;
  where?: InputMaybe<Espin_Address_Bool_Exp>;
};


export type Query_RootEspin_Address_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Boolean_Feature_FlagArgs = {
  distinct_on?: InputMaybe<Array<Espin_Boolean_Feature_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Boolean_Feature_Flag_Order_By>>;
  where?: InputMaybe<Espin_Boolean_Feature_Flag_Bool_Exp>;
};


export type Query_RootEspin_Boolean_Feature_Flag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Boolean_Feature_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Boolean_Feature_Flag_Order_By>>;
  where?: InputMaybe<Espin_Boolean_Feature_Flag_Bool_Exp>;
};


export type Query_RootEspin_Boolean_Feature_Flag_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Coach_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Espin_Coach_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Coach_Profile_Order_By>>;
  where?: InputMaybe<Espin_Coach_Profile_Bool_Exp>;
};


export type Query_RootEspin_Coach_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Coach_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Coach_Profile_Order_By>>;
  where?: InputMaybe<Espin_Coach_Profile_Bool_Exp>;
};


export type Query_RootEspin_Coach_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_CollegeArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Order_By>>;
  where?: InputMaybe<Espin_College_Bool_Exp>;
};


export type Query_RootEspin_College_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Order_By>>;
  where?: InputMaybe<Espin_College_Bool_Exp>;
};


export type Query_RootEspin_College_Automatic_Message_Response_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Automatic_Message_Response_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Automatic_Message_Response_Type_Order_By>>;
  where?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Bool_Exp>;
};


export type Query_RootEspin_College_Automatic_Message_Response_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Automatic_Message_Response_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Automatic_Message_Response_Type_Order_By>>;
  where?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Bool_Exp>;
};


export type Query_RootEspin_College_Automatic_Message_Response_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_College_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_College_GameArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Game_Order_By>>;
  where?: InputMaybe<Espin_College_Game_Bool_Exp>;
};


export type Query_RootEspin_College_Game_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Game_Order_By>>;
  where?: InputMaybe<Espin_College_Game_Bool_Exp>;
};


export type Query_RootEspin_College_Game_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_College_ImageArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Image_Order_By>>;
  where?: InputMaybe<Espin_College_Image_Bool_Exp>;
};


export type Query_RootEspin_College_Image_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Image_Order_By>>;
  where?: InputMaybe<Espin_College_Image_Bool_Exp>;
};


export type Query_RootEspin_College_Image_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_College_InviteArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Invite_Order_By>>;
  where?: InputMaybe<Espin_College_Invite_Bool_Exp>;
};


export type Query_RootEspin_College_Invite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Invite_Order_By>>;
  where?: InputMaybe<Espin_College_Invite_Bool_Exp>;
};


export type Query_RootEspin_College_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_College_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Preferences_Order_By>>;
  where?: InputMaybe<Espin_College_Preferences_Bool_Exp>;
};


export type Query_RootEspin_College_Preferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Preferences_Order_By>>;
  where?: InputMaybe<Espin_College_Preferences_Bool_Exp>;
};


export type Query_RootEspin_College_Preferences_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_College_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Profile_Order_By>>;
  where?: InputMaybe<Espin_College_Profile_Bool_Exp>;
};


export type Query_RootEspin_College_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Profile_Order_By>>;
  where?: InputMaybe<Espin_College_Profile_Bool_Exp>;
};


export type Query_RootEspin_College_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_College_RosterArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Roster_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Roster_Order_By>>;
  where?: InputMaybe<Espin_College_Roster_Bool_Exp>;
};


export type Query_RootEspin_College_Roster_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Roster_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Roster_Order_By>>;
  where?: InputMaybe<Espin_College_Roster_Bool_Exp>;
};


export type Query_RootEspin_College_Roster_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_College_Staff_MemberArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Staff_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Staff_Member_Order_By>>;
  where?: InputMaybe<Espin_College_Staff_Member_Bool_Exp>;
};


export type Query_RootEspin_College_Staff_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Staff_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Staff_Member_Order_By>>;
  where?: InputMaybe<Espin_College_Staff_Member_Bool_Exp>;
};


export type Query_RootEspin_College_Staff_Member_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_College_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Subscription_Order_By>>;
  where?: InputMaybe<Espin_College_Subscription_Bool_Exp>;
};


export type Query_RootEspin_College_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Subscription_Order_By>>;
  where?: InputMaybe<Espin_College_Subscription_Bool_Exp>;
};


export type Query_RootEspin_College_Subscription_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_College_Verification_Status_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Verification_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Verification_Status_Type_Order_By>>;
  where?: InputMaybe<Espin_College_Verification_Status_Type_Bool_Exp>;
};


export type Query_RootEspin_College_Verification_Status_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Verification_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Verification_Status_Type_Order_By>>;
  where?: InputMaybe<Espin_College_Verification_Status_Type_Bool_Exp>;
};


export type Query_RootEspin_College_Verification_Status_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Draft_Player_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Espin_Draft_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Draft_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Draft_Player_Profile_Bool_Exp>;
};


export type Query_RootEspin_Draft_Player_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Draft_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Draft_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Draft_Player_Profile_Bool_Exp>;
};


export type Query_RootEspin_Draft_Player_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Editable_Site_ContentArgs = {
  distinct_on?: InputMaybe<Array<Espin_Editable_Site_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Editable_Site_Content_Order_By>>;
  where?: InputMaybe<Espin_Editable_Site_Content_Bool_Exp>;
};


export type Query_RootEspin_Editable_Site_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Editable_Site_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Editable_Site_Content_Order_By>>;
  where?: InputMaybe<Espin_Editable_Site_Content_Bool_Exp>;
};


export type Query_RootEspin_Editable_Site_Content_By_PkArgs = {
  key: Scalars['String'];
};


export type Query_RootEspin_Ethnicity_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Ethnicity_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Ethnicity_Options_Order_By>>;
  where?: InputMaybe<Espin_Ethnicity_Options_Bool_Exp>;
};


export type Query_RootEspin_Ethnicity_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Ethnicity_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Ethnicity_Options_Order_By>>;
  where?: InputMaybe<Espin_Ethnicity_Options_Bool_Exp>;
};


export type Query_RootEspin_Ethnicity_Options_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_EventArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Order_By>>;
  where?: InputMaybe<Espin_Event_Bool_Exp>;
};


export type Query_RootEspin_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Order_By>>;
  where?: InputMaybe<Espin_Event_Bool_Exp>;
};


export type Query_RootEspin_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Event_Custom_FieldArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Custom_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Custom_Field_Order_By>>;
  where?: InputMaybe<Espin_Event_Custom_Field_Bool_Exp>;
};


export type Query_RootEspin_Event_Custom_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Custom_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Custom_Field_Order_By>>;
  where?: InputMaybe<Espin_Event_Custom_Field_Bool_Exp>;
};


export type Query_RootEspin_Event_Custom_Field_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Event_Custom_Field_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Custom_Field_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Custom_Field_Type_Order_By>>;
  where?: InputMaybe<Espin_Event_Custom_Field_Type_Bool_Exp>;
};


export type Query_RootEspin_Event_Custom_Field_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Custom_Field_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Custom_Field_Type_Order_By>>;
  where?: InputMaybe<Espin_Event_Custom_Field_Type_Bool_Exp>;
};


export type Query_RootEspin_Event_Custom_Field_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Event_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Document_Order_By>>;
  where?: InputMaybe<Espin_Event_Document_Bool_Exp>;
};


export type Query_RootEspin_Event_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Document_Order_By>>;
  where?: InputMaybe<Espin_Event_Document_Bool_Exp>;
};


export type Query_RootEspin_Event_Document_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Event_GameArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Game_Order_By>>;
  where?: InputMaybe<Espin_Event_Game_Bool_Exp>;
};


export type Query_RootEspin_Event_Game_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Game_Order_By>>;
  where?: InputMaybe<Espin_Event_Game_Bool_Exp>;
};


export type Query_RootEspin_Event_Game_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Event_RegistrationArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
};


export type Query_RootEspin_Event_Registration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
};


export type Query_RootEspin_Event_Registration_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Event_Registration_Custom_Field_EntryArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Bool_Exp>;
};


export type Query_RootEspin_Event_Registration_Custom_Field_Entry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Bool_Exp>;
};


export type Query_RootEspin_Event_Registration_Custom_Field_Entry_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Event_Registration_Document_SignoffArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Document_Signoff_Bool_Exp>;
};


export type Query_RootEspin_Event_Registration_Document_Signoff_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Document_Signoff_Bool_Exp>;
};


export type Query_RootEspin_Event_Registration_Document_Signoff_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Event_Registration_StatusArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Status_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Status_Bool_Exp>;
};


export type Query_RootEspin_Event_Registration_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Status_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Status_Bool_Exp>;
};


export type Query_RootEspin_Event_Registration_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Event_TicketArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Ticket_Order_By>>;
  where?: InputMaybe<Espin_Event_Ticket_Bool_Exp>;
};


export type Query_RootEspin_Event_Ticket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Ticket_Order_By>>;
  where?: InputMaybe<Espin_Event_Ticket_Bool_Exp>;
};


export type Query_RootEspin_Event_Ticket_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Event_Ticket_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Ticket_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Ticket_Type_Order_By>>;
  where?: InputMaybe<Espin_Event_Ticket_Type_Bool_Exp>;
};


export type Query_RootEspin_Event_Ticket_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Ticket_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Ticket_Type_Order_By>>;
  where?: InputMaybe<Espin_Event_Ticket_Type_Bool_Exp>;
};


export type Query_RootEspin_Event_Ticket_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Type_Order_By>>;
  where?: InputMaybe<Espin_Event_Type_Bool_Exp>;
};


export type Query_RootEspin_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Type_Order_By>>;
  where?: InputMaybe<Espin_Event_Type_Bool_Exp>;
};


export type Query_RootEspin_Event_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_External_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Espin_External_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_External_Provider_Order_By>>;
  where?: InputMaybe<Espin_External_Provider_Bool_Exp>;
};


export type Query_RootEspin_External_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_External_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_External_Provider_Order_By>>;
  where?: InputMaybe<Espin_External_Provider_Bool_Exp>;
};


export type Query_RootEspin_External_Provider_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_External_Provider_LinkArgs = {
  distinct_on?: InputMaybe<Array<Espin_External_Provider_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_External_Provider_Link_Order_By>>;
  where?: InputMaybe<Espin_External_Provider_Link_Bool_Exp>;
};


export type Query_RootEspin_External_Provider_Link_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_External_Provider_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_External_Provider_Link_Order_By>>;
  where?: InputMaybe<Espin_External_Provider_Link_Bool_Exp>;
};


export type Query_RootEspin_External_Provider_Link_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_FollowArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Order_By>>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};


export type Query_RootEspin_Follow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Order_By>>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};


export type Query_RootEspin_Follow_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Follow_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Type_Order_By>>;
  where?: InputMaybe<Espin_Follow_Type_Bool_Exp>;
};


export type Query_RootEspin_Follow_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Type_Order_By>>;
  where?: InputMaybe<Espin_Follow_Type_Bool_Exp>;
};


export type Query_RootEspin_Follow_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Follower_Email_Notification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follower_Email_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follower_Email_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Follower_Email_Notification_Type_Bool_Exp>;
};


export type Query_RootEspin_Follower_Email_Notification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follower_Email_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follower_Email_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Follower_Email_Notification_Type_Bool_Exp>;
};


export type Query_RootEspin_Follower_Email_Notification_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Force_Notification_ReloadArgs = {
  distinct_on?: InputMaybe<Array<Espin_Force_Notification_Reload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Force_Notification_Reload_Order_By>>;
  where?: InputMaybe<Espin_Force_Notification_Reload_Bool_Exp>;
};


export type Query_RootEspin_Force_Notification_Reload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Force_Notification_Reload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Force_Notification_Reload_Order_By>>;
  where?: InputMaybe<Espin_Force_Notification_Reload_Bool_Exp>;
};


export type Query_RootEspin_Force_Notification_Reload_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEspin_GameArgs = {
  distinct_on?: InputMaybe<Array<Espin_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Game_Order_By>>;
  where?: InputMaybe<Espin_Game_Bool_Exp>;
};


export type Query_RootEspin_Game_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Game_Order_By>>;
  where?: InputMaybe<Espin_Game_Bool_Exp>;
};


export type Query_RootEspin_Game_By_PkArgs = {
  game_definition: Espin_Game_Definition_Enum;
};


export type Query_RootEspin_Game_DefinitionArgs = {
  distinct_on?: InputMaybe<Array<Espin_Game_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Game_Definition_Order_By>>;
  where?: InputMaybe<Espin_Game_Definition_Bool_Exp>;
};


export type Query_RootEspin_Game_Definition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Game_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Game_Definition_Order_By>>;
  where?: InputMaybe<Espin_Game_Definition_Bool_Exp>;
};


export type Query_RootEspin_Game_Definition_By_PkArgs = {
  game_name: Scalars['String'];
};


export type Query_RootEspin_Game_PlatformArgs = {
  distinct_on?: InputMaybe<Array<Espin_Game_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Game_Platform_Order_By>>;
  where?: InputMaybe<Espin_Game_Platform_Bool_Exp>;
};


export type Query_RootEspin_Game_Platform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Game_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Game_Platform_Order_By>>;
  where?: InputMaybe<Espin_Game_Platform_Bool_Exp>;
};


export type Query_RootEspin_Game_Platform_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Gender_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Gender_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Gender_Options_Order_By>>;
  where?: InputMaybe<Espin_Gender_Options_Bool_Exp>;
};


export type Query_RootEspin_Gender_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Gender_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Gender_Options_Order_By>>;
  where?: InputMaybe<Espin_Gender_Options_Bool_Exp>;
};


export type Query_RootEspin_Gender_Options_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Graduating_ClassArgs = {
  distinct_on?: InputMaybe<Array<Espin_Graduating_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Graduating_Class_Order_By>>;
  where?: InputMaybe<Espin_Graduating_Class_Bool_Exp>;
};


export type Query_RootEspin_Graduating_Class_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Graduating_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Graduating_Class_Order_By>>;
  where?: InputMaybe<Espin_Graduating_Class_Bool_Exp>;
};


export type Query_RootEspin_Graduating_Class_By_PkArgs = {
  grad_class_years: Scalars['String'];
};


export type Query_RootEspin_High_SchoolArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Order_By>>;
  where?: InputMaybe<Espin_High_School_Bool_Exp>;
};


export type Query_RootEspin_High_School_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Order_By>>;
  where?: InputMaybe<Espin_High_School_Bool_Exp>;
};


export type Query_RootEspin_High_School_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_High_School_InviteArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Invite_Order_By>>;
  where?: InputMaybe<Espin_High_School_Invite_Bool_Exp>;
};


export type Query_RootEspin_High_School_Invite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Invite_Order_By>>;
  where?: InputMaybe<Espin_High_School_Invite_Bool_Exp>;
};


export type Query_RootEspin_High_School_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_High_School_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Profile_Order_By>>;
  where?: InputMaybe<Espin_High_School_Profile_Bool_Exp>;
};


export type Query_RootEspin_High_School_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Profile_Order_By>>;
  where?: InputMaybe<Espin_High_School_Profile_Bool_Exp>;
};


export type Query_RootEspin_High_School_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Invite_Status_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Invite_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Invite_Status_Type_Order_By>>;
  where?: InputMaybe<Espin_Invite_Status_Type_Bool_Exp>;
};


export type Query_RootEspin_Invite_Status_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Invite_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Invite_Status_Type_Order_By>>;
  where?: InputMaybe<Espin_Invite_Status_Type_Bool_Exp>;
};


export type Query_RootEspin_Invite_Status_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_LeaderboardArgs = {
  distinct_on?: InputMaybe<Array<Espin_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Leaderboard_Order_By>>;
  where?: InputMaybe<Espin_Leaderboard_Bool_Exp>;
};


export type Query_RootEspin_Leaderboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Leaderboard_Order_By>>;
  where?: InputMaybe<Espin_Leaderboard_Bool_Exp>;
};


export type Query_RootEspin_Leaderboard_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_MembershipArgs = {
  distinct_on?: InputMaybe<Array<Espin_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Membership_Order_By>>;
  where?: InputMaybe<Espin_Membership_Bool_Exp>;
};


export type Query_RootEspin_Membership_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Membership_Order_By>>;
  where?: InputMaybe<Espin_Membership_Bool_Exp>;
};


export type Query_RootEspin_Membership_By_PkArgs = {
  membership_id: Scalars['Int'];
};


export type Query_RootEspin_MessageArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Order_By>>;
  where?: InputMaybe<Espin_Message_Bool_Exp>;
};


export type Query_RootEspin_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Order_By>>;
  where?: InputMaybe<Espin_Message_Bool_Exp>;
};


export type Query_RootEspin_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Message_Email_Notification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Email_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Email_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Message_Email_Notification_Type_Bool_Exp>;
};


export type Query_RootEspin_Message_Email_Notification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Email_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Email_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Message_Email_Notification_Type_Bool_Exp>;
};


export type Query_RootEspin_Message_Email_Notification_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Message_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Type_Order_By>>;
  where?: InputMaybe<Espin_Message_Type_Bool_Exp>;
};


export type Query_RootEspin_Message_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Type_Order_By>>;
  where?: InputMaybe<Espin_Message_Type_Bool_Exp>;
};


export type Query_RootEspin_Message_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Moderation_StatusArgs = {
  distinct_on?: InputMaybe<Array<Espin_Moderation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Moderation_Status_Order_By>>;
  where?: InputMaybe<Espin_Moderation_Status_Bool_Exp>;
};


export type Query_RootEspin_Moderation_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Moderation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Moderation_Status_Order_By>>;
  where?: InputMaybe<Espin_Moderation_Status_Bool_Exp>;
};


export type Query_RootEspin_Moderation_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Newsletter_RequestArgs = {
  distinct_on?: InputMaybe<Array<Espin_Newsletter_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Newsletter_Request_Order_By>>;
  where?: InputMaybe<Espin_Newsletter_Request_Bool_Exp>;
};


export type Query_RootEspin_Newsletter_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Newsletter_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Newsletter_Request_Order_By>>;
  where?: InputMaybe<Espin_Newsletter_Request_Bool_Exp>;
};


export type Query_RootEspin_Newsletter_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Espin_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Notification_Order_By>>;
  where?: InputMaybe<Espin_Notification_Bool_Exp>;
};


export type Query_RootEspin_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Notification_Order_By>>;
  where?: InputMaybe<Espin_Notification_Bool_Exp>;
};


export type Query_RootEspin_Notification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Notification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Notification_Type_Bool_Exp>;
};


export type Query_RootEspin_Notification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Notification_Type_Bool_Exp>;
};


export type Query_RootEspin_Notification_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_OrgArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Order_By>>;
  where?: InputMaybe<Espin_Org_Bool_Exp>;
};


export type Query_RootEspin_Org_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Order_By>>;
  where?: InputMaybe<Espin_Org_Bool_Exp>;
};


export type Query_RootEspin_Org_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Org_MonthArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Month_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Month_Order_By>>;
  where?: InputMaybe<Espin_Org_Month_Bool_Exp>;
};


export type Query_RootEspin_Org_Month_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Month_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Month_Order_By>>;
  where?: InputMaybe<Espin_Org_Month_Bool_Exp>;
};


export type Query_RootEspin_Org_Month_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Org_Month_DayArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Month_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Month_Day_Order_By>>;
  where?: InputMaybe<Espin_Org_Month_Day_Bool_Exp>;
};


export type Query_RootEspin_Org_Month_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Month_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Month_Day_Order_By>>;
  where?: InputMaybe<Espin_Org_Month_Day_Bool_Exp>;
};


export type Query_RootEspin_Org_Month_Day_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Org_PlayerArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Player_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Player_Order_By>>;
  where?: InputMaybe<Espin_Org_Player_Bool_Exp>;
};


export type Query_RootEspin_Org_Player_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Player_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Player_Order_By>>;
  where?: InputMaybe<Espin_Org_Player_Bool_Exp>;
};


export type Query_RootEspin_Org_Player_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Org_SchoolArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_School_Order_By>>;
  where?: InputMaybe<Espin_Org_School_Bool_Exp>;
};


export type Query_RootEspin_Org_School_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_School_Order_By>>;
  where?: InputMaybe<Espin_Org_School_Bool_Exp>;
};


export type Query_RootEspin_Org_School_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Org_School_RecordArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_School_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_School_Record_Order_By>>;
  where?: InputMaybe<Espin_Org_School_Record_Bool_Exp>;
};


export type Query_RootEspin_Org_School_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_School_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_School_Record_Order_By>>;
  where?: InputMaybe<Espin_Org_School_Record_Bool_Exp>;
};


export type Query_RootEspin_Org_School_Record_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Paid_ProductArgs = {
  distinct_on?: InputMaybe<Array<Espin_Paid_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Paid_Product_Order_By>>;
  where?: InputMaybe<Espin_Paid_Product_Bool_Exp>;
};


export type Query_RootEspin_Paid_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Paid_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Paid_Product_Order_By>>;
  where?: InputMaybe<Espin_Paid_Product_Bool_Exp>;
};


export type Query_RootEspin_Paid_Product_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Parent_InviteArgs = {
  distinct_on?: InputMaybe<Array<Espin_Parent_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Parent_Invite_Order_By>>;
  where?: InputMaybe<Espin_Parent_Invite_Bool_Exp>;
};


export type Query_RootEspin_Parent_Invite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Parent_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Parent_Invite_Order_By>>;
  where?: InputMaybe<Espin_Parent_Invite_Bool_Exp>;
};


export type Query_RootEspin_Parent_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Parent_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Espin_Parent_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Parent_Profile_Order_By>>;
  where?: InputMaybe<Espin_Parent_Profile_Bool_Exp>;
};


export type Query_RootEspin_Parent_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Parent_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Parent_Profile_Order_By>>;
  where?: InputMaybe<Espin_Parent_Profile_Bool_Exp>;
};


export type Query_RootEspin_Parent_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Player_GameArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Game_Order_By>>;
  where?: InputMaybe<Espin_Player_Game_Bool_Exp>;
};


export type Query_RootEspin_Player_Game_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Game_Order_By>>;
  where?: InputMaybe<Espin_Player_Game_Bool_Exp>;
};


export type Query_RootEspin_Player_Game_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Player_JourneyArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Player_Journey_StageArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_Stage_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Player_Journey_Stage_CollegeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_College_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_Stage_College_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_College_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_Stage_College_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Player_Journey_Stage_DefArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Def_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Def_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Def_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_Stage_Def_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Def_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Def_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Def_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_Stage_Def_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Player_Journey_Stage_ImageArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Image_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_Stage_Image_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Image_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_Stage_Image_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Player_Journey_Stage_QuoteArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Quote_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_Stage_Quote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Quote_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_Stage_Quote_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Player_Journey_Stage_VideoArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Video_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Video_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_Stage_Video_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Video_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Video_Bool_Exp>;
};


export type Query_RootEspin_Player_Journey_Stage_Video_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Player_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};


export type Query_RootEspin_Player_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};


export type Query_RootEspin_Player_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Player_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Subscription_Order_By>>;
  where?: InputMaybe<Espin_Player_Subscription_Bool_Exp>;
};


export type Query_RootEspin_Player_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Subscription_Order_By>>;
  where?: InputMaybe<Espin_Player_Subscription_Bool_Exp>;
};


export type Query_RootEspin_Player_Subscription_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Player_VodArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Vod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Vod_Order_By>>;
  where?: InputMaybe<Espin_Player_Vod_Bool_Exp>;
};


export type Query_RootEspin_Player_Vod_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Vod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Vod_Order_By>>;
  where?: InputMaybe<Espin_Player_Vod_Bool_Exp>;
};


export type Query_RootEspin_Player_Vod_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Profile_ViewArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};


export type Query_RootEspin_Profile_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};


export type Query_RootEspin_Profile_View_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Profile_View_Email_Notification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Email_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Email_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Bool_Exp>;
};


export type Query_RootEspin_Profile_View_Email_Notification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Email_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Email_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Bool_Exp>;
};


export type Query_RootEspin_Profile_View_Email_Notification_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Profile_View_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Type_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Type_Bool_Exp>;
};


export type Query_RootEspin_Profile_View_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Type_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Type_Bool_Exp>;
};


export type Query_RootEspin_Profile_View_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Referral_CodeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Code_Order_By>>;
  where?: InputMaybe<Espin_Referral_Code_Bool_Exp>;
};


export type Query_RootEspin_Referral_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Code_Order_By>>;
  where?: InputMaybe<Espin_Referral_Code_Bool_Exp>;
};


export type Query_RootEspin_Referral_Code_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Referral_Code_RedemptionArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Code_Redemption_Order_By>>;
  where?: InputMaybe<Espin_Referral_Code_Redemption_Bool_Exp>;
};


export type Query_RootEspin_Referral_Code_Redemption_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Code_Redemption_Order_By>>;
  where?: InputMaybe<Espin_Referral_Code_Redemption_Bool_Exp>;
};


export type Query_RootEspin_Referral_Code_Redemption_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Referral_OptionArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Option_Order_By>>;
  where?: InputMaybe<Espin_Referral_Option_Bool_Exp>;
};


export type Query_RootEspin_Referral_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Option_Order_By>>;
  where?: InputMaybe<Espin_Referral_Option_Bool_Exp>;
};


export type Query_RootEspin_Referral_Option_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_RoleArgs = {
  distinct_on?: InputMaybe<Array<Espin_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Role_Order_By>>;
  where?: InputMaybe<Espin_Role_Bool_Exp>;
};


export type Query_RootEspin_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Role_Order_By>>;
  where?: InputMaybe<Espin_Role_Bool_Exp>;
};


export type Query_RootEspin_Role_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Site_ContentArgs = {
  distinct_on?: InputMaybe<Array<Espin_Site_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Site_Content_Order_By>>;
  where?: InputMaybe<Espin_Site_Content_Bool_Exp>;
};


export type Query_RootEspin_Site_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Site_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Site_Content_Order_By>>;
  where?: InputMaybe<Espin_Site_Content_Bool_Exp>;
};


export type Query_RootEspin_Site_Content_By_PkArgs = {
  key: Espin_Editable_Site_Content_Enum;
};


export type Query_RootEspin_SocialArgs = {
  distinct_on?: InputMaybe<Array<Espin_Social_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Social_Order_By>>;
  where?: InputMaybe<Espin_Social_Bool_Exp>;
};


export type Query_RootEspin_Social_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Social_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Social_Order_By>>;
  where?: InputMaybe<Espin_Social_Bool_Exp>;
};


export type Query_RootEspin_Social_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Stickied_CollegeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Stickied_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Stickied_College_Order_By>>;
  where?: InputMaybe<Espin_Stickied_College_Bool_Exp>;
};


export type Query_RootEspin_Stickied_College_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Stickied_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Stickied_College_Order_By>>;
  where?: InputMaybe<Espin_Stickied_College_Bool_Exp>;
};


export type Query_RootEspin_Stickied_College_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Stickied_PlayerArgs = {
  distinct_on?: InputMaybe<Array<Espin_Stickied_Player_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Stickied_Player_Order_By>>;
  where?: InputMaybe<Espin_Stickied_Player_Bool_Exp>;
};


export type Query_RootEspin_Stickied_Player_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Stickied_Player_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Stickied_Player_Order_By>>;
  where?: InputMaybe<Espin_Stickied_Player_Bool_Exp>;
};


export type Query_RootEspin_Stickied_Player_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Study_FieldArgs = {
  distinct_on?: InputMaybe<Array<Espin_Study_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Study_Field_Order_By>>;
  where?: InputMaybe<Espin_Study_Field_Bool_Exp>;
};


export type Query_RootEspin_Study_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Study_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Study_Field_Order_By>>;
  where?: InputMaybe<Espin_Study_Field_Bool_Exp>;
};


export type Query_RootEspin_Study_Field_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Study_SubjectArgs = {
  distinct_on?: InputMaybe<Array<Espin_Study_Subject_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Study_Subject_Order_By>>;
  where?: InputMaybe<Espin_Study_Subject_Bool_Exp>;
};


export type Query_RootEspin_Study_Subject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Study_Subject_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Study_Subject_Order_By>>;
  where?: InputMaybe<Espin_Study_Subject_Bool_Exp>;
};


export type Query_RootEspin_Study_Subject_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Subscription_StatusArgs = {
  distinct_on?: InputMaybe<Array<Espin_Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Subscription_Status_Order_By>>;
  where?: InputMaybe<Espin_Subscription_Status_Bool_Exp>;
};


export type Query_RootEspin_Subscription_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Subscription_Status_Order_By>>;
  where?: InputMaybe<Espin_Subscription_Status_Bool_Exp>;
};


export type Query_RootEspin_Subscription_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Subscription_Tier_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Subscription_Tier_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Subscription_Tier_Type_Order_By>>;
  where?: InputMaybe<Espin_Subscription_Tier_Type_Bool_Exp>;
};


export type Query_RootEspin_Subscription_Tier_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Subscription_Tier_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Subscription_Tier_Type_Order_By>>;
  where?: InputMaybe<Espin_Subscription_Tier_Type_Bool_Exp>;
};


export type Query_RootEspin_Subscription_Tier_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_TeamArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Order_By>>;
  where?: InputMaybe<Espin_Team_Bool_Exp>;
};


export type Query_RootEspin_Team_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Order_By>>;
  where?: InputMaybe<Espin_Team_Bool_Exp>;
};


export type Query_RootEspin_Team_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Team_InviteArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Invite_Order_By>>;
  where?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
};


export type Query_RootEspin_Team_Invite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Invite_Order_By>>;
  where?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
};


export type Query_RootEspin_Team_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Team_MembersArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Members_Order_By>>;
  where?: InputMaybe<Espin_Team_Members_Bool_Exp>;
};


export type Query_RootEspin_Team_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Members_Order_By>>;
  where?: InputMaybe<Espin_Team_Members_Bool_Exp>;
};


export type Query_RootEspin_Team_Members_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_Team_RoleArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Role_Order_By>>;
  where?: InputMaybe<Espin_Team_Role_Bool_Exp>;
};


export type Query_RootEspin_Team_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Role_Order_By>>;
  where?: InputMaybe<Espin_Team_Role_Bool_Exp>;
};


export type Query_RootEspin_Team_Role_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Team_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Type_Order_By>>;
  where?: InputMaybe<Espin_Team_Type_Bool_Exp>;
};


export type Query_RootEspin_Team_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Type_Order_By>>;
  where?: InputMaybe<Espin_Team_Type_Bool_Exp>;
};


export type Query_RootEspin_Team_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEspin_Unregistered_CollegeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Unregistered_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Unregistered_College_Order_By>>;
  where?: InputMaybe<Espin_Unregistered_College_Bool_Exp>;
};


export type Query_RootEspin_Unregistered_College_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Unregistered_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Unregistered_College_Order_By>>;
  where?: InputMaybe<Espin_Unregistered_College_Bool_Exp>;
};


export type Query_RootEspin_Unregistered_College_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_UserArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Order_By>>;
  where?: InputMaybe<Espin_User_Bool_Exp>;
};


export type Query_RootEspin_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Order_By>>;
  where?: InputMaybe<Espin_User_Bool_Exp>;
};


export type Query_RootEspin_User_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootEspin_User_Linked_External_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Linked_External_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Linked_External_Provider_Order_By>>;
  where?: InputMaybe<Espin_User_Linked_External_Provider_Bool_Exp>;
};


export type Query_RootEspin_User_Linked_External_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Linked_External_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Linked_External_Provider_Order_By>>;
  where?: InputMaybe<Espin_User_Linked_External_Provider_Bool_Exp>;
};


export type Query_RootEspin_User_Linked_External_Provider_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_User_MembershipArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Membership_Order_By>>;
  where?: InputMaybe<Espin_User_Membership_Bool_Exp>;
};


export type Query_RootEspin_User_Membership_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Membership_Order_By>>;
  where?: InputMaybe<Espin_User_Membership_Bool_Exp>;
};


export type Query_RootEspin_User_Membership_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootEspin_User_SourceArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Source_Order_By>>;
  where?: InputMaybe<Espin_User_Source_Bool_Exp>;
};


export type Query_RootEspin_User_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Source_Order_By>>;
  where?: InputMaybe<Espin_User_Source_Bool_Exp>;
};


export type Query_RootEspin_User_Source_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEspin_User_Subscription_StatusArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Subscription_Status_Order_By>>;
  where?: InputMaybe<Espin_User_Subscription_Status_Bool_Exp>;
};


export type Query_RootEspin_User_Subscription_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Subscription_Status_Order_By>>;
  where?: InputMaybe<Espin_User_Subscription_Status_Bool_Exp>;
};


export type Query_RootQueue_JobArgs = {
  distinct_on?: InputMaybe<Array<Queue_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Queue_Job_Order_By>>;
  where?: InputMaybe<Queue_Job_Bool_Exp>;
};


export type Query_RootQueue_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Queue_Job_Order_By>>;
  where?: InputMaybe<Queue_Job_Bool_Exp>;
};


export type Query_RootQueue_Job_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootQueue_Job_Status_TypeArgs = {
  distinct_on?: InputMaybe<Array<Queue_Job_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Queue_Job_Status_Type_Order_By>>;
  where?: InputMaybe<Queue_Job_Status_Type_Bool_Exp>;
};


export type Query_RootQueue_Job_Status_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Job_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Queue_Job_Status_Type_Order_By>>;
  where?: InputMaybe<Queue_Job_Status_Type_Bool_Exp>;
};


export type Query_RootQueue_Job_Status_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootQueue_Job_TypeArgs = {
  distinct_on?: InputMaybe<Array<Queue_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Queue_Job_Type_Order_By>>;
  where?: InputMaybe<Queue_Job_Type_Bool_Exp>;
};


export type Query_RootQueue_Job_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Queue_Job_Type_Order_By>>;
  where?: InputMaybe<Queue_Job_Type_Bool_Exp>;
};


export type Query_RootQueue_Job_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootStripe_Customer_DataArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Customer_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Customer_Data_Order_By>>;
  where?: InputMaybe<Stripe_Customer_Data_Bool_Exp>;
};


export type Query_RootStripe_Customer_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Customer_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Customer_Data_Order_By>>;
  where?: InputMaybe<Stripe_Customer_Data_Bool_Exp>;
};


export type Query_RootStripe_Customer_Data_By_PkArgs = {
  customer_id: Scalars['String'];
};


export type Query_RootStripe_Invoice_DataArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Invoice_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Invoice_Data_Order_By>>;
  where?: InputMaybe<Stripe_Invoice_Data_Bool_Exp>;
};


export type Query_RootStripe_Invoice_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Invoice_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Invoice_Data_Order_By>>;
  where?: InputMaybe<Stripe_Invoice_Data_Bool_Exp>;
};


export type Query_RootStripe_Invoice_Data_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootStripe_Stripe_Payment_DataArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Stripe_Payment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Stripe_Payment_Data_Order_By>>;
  where?: InputMaybe<Stripe_Stripe_Payment_Data_Bool_Exp>;
};


export type Query_RootStripe_Stripe_Payment_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Stripe_Payment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Stripe_Payment_Data_Order_By>>;
  where?: InputMaybe<Stripe_Stripe_Payment_Data_Bool_Exp>;
};


export type Query_RootStripe_Stripe_Payment_Data_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootStripe_Stripe_Subscription_DataArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Stripe_Subscription_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Stripe_Subscription_Data_Order_By>>;
  where?: InputMaybe<Stripe_Stripe_Subscription_Data_Bool_Exp>;
};


export type Query_RootStripe_Stripe_Subscription_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Stripe_Subscription_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Stripe_Subscription_Data_Order_By>>;
  where?: InputMaybe<Stripe_Stripe_Subscription_Data_Bool_Exp>;
};


export type Query_RootStripe_Stripe_Subscription_Data_By_PkArgs = {
  customer: Scalars['String'];
  id: Scalars['String'];
};


export type Query_RootTempstorage_KeyvalueArgs = {
  distinct_on?: InputMaybe<Array<Tempstorage_Keyvalue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tempstorage_Keyvalue_Order_By>>;
  where?: InputMaybe<Tempstorage_Keyvalue_Bool_Exp>;
};


export type Query_RootTempstorage_Keyvalue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tempstorage_Keyvalue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tempstorage_Keyvalue_Order_By>>;
  where?: InputMaybe<Tempstorage_Keyvalue_Bool_Exp>;
};


export type Query_RootTempstorage_Keyvalue_By_PkArgs = {
  id: Scalars['uuid'];
};

/** Jobs for the hasura server */
export type Queue_Job = {
  __typename?: 'queue_job';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Queue_Job_Type_Enum;
  payload: Scalars['jsonb'];
  result?: Maybe<Scalars['jsonb']>;
  status: Queue_Job_Status_Type_Enum;
  updated_at: Scalars['timestamptz'];
};


/** Jobs for the hasura server */
export type Queue_JobPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Jobs for the hasura server */
export type Queue_JobResultArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "queue.job" */
export type Queue_Job_Aggregate = {
  __typename?: 'queue_job_aggregate';
  aggregate?: Maybe<Queue_Job_Aggregate_Fields>;
  nodes: Array<Queue_Job>;
};

/** aggregate fields of "queue.job" */
export type Queue_Job_Aggregate_Fields = {
  __typename?: 'queue_job_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Queue_Job_Max_Fields>;
  min?: Maybe<Queue_Job_Min_Fields>;
};


/** aggregate fields of "queue.job" */
export type Queue_Job_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Queue_Job_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Queue_Job_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
  result?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "queue.job". All fields are combined with a logical 'AND'. */
export type Queue_Job_Bool_Exp = {
  _and?: InputMaybe<Array<Queue_Job_Bool_Exp>>;
  _not?: InputMaybe<Queue_Job_Bool_Exp>;
  _or?: InputMaybe<Array<Queue_Job_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<Queue_Job_Type_Enum_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  result?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<Queue_Job_Status_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "queue.job" */
export enum Queue_Job_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobPkey = 'job_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Queue_Job_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
  result?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Queue_Job_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
  result?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Queue_Job_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "queue.job" */
export type Queue_Job_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Queue_Job_Type_Enum>;
  payload?: InputMaybe<Scalars['jsonb']>;
  result?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Queue_Job_Status_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Queue_Job_Max_Fields = {
  __typename?: 'queue_job_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Queue_Job_Min_Fields = {
  __typename?: 'queue_job_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "queue.job" */
export type Queue_Job_Mutation_Response = {
  __typename?: 'queue_job_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Queue_Job>;
};

/** on_conflict condition type for table "queue.job" */
export type Queue_Job_On_Conflict = {
  constraint: Queue_Job_Constraint;
  update_columns?: Array<Queue_Job_Update_Column>;
  where?: InputMaybe<Queue_Job_Bool_Exp>;
};

/** Ordering options when selecting data from "queue.job". */
export type Queue_Job_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  result?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: queue.job */
export type Queue_Job_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Queue_Job_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
  result?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "queue.job" */
export enum Queue_Job_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Payload = 'payload',
  /** column name */
  Result = 'result',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "queue.job" */
export type Queue_Job_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Queue_Job_Type_Enum>;
  payload?: InputMaybe<Scalars['jsonb']>;
  result?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Queue_Job_Status_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Enum for job statuses */
export type Queue_Job_Status_Type = {
  __typename?: 'queue_job_status_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "queue.job_status_type" */
export type Queue_Job_Status_Type_Aggregate = {
  __typename?: 'queue_job_status_type_aggregate';
  aggregate?: Maybe<Queue_Job_Status_Type_Aggregate_Fields>;
  nodes: Array<Queue_Job_Status_Type>;
};

/** aggregate fields of "queue.job_status_type" */
export type Queue_Job_Status_Type_Aggregate_Fields = {
  __typename?: 'queue_job_status_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Queue_Job_Status_Type_Max_Fields>;
  min?: Maybe<Queue_Job_Status_Type_Min_Fields>;
};


/** aggregate fields of "queue.job_status_type" */
export type Queue_Job_Status_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Queue_Job_Status_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "queue.job_status_type". All fields are combined with a logical 'AND'. */
export type Queue_Job_Status_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Queue_Job_Status_Type_Bool_Exp>>;
  _not?: InputMaybe<Queue_Job_Status_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Queue_Job_Status_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "queue.job_status_type" */
export enum Queue_Job_Status_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  JobStatusTypePkey = 'job_status_type_pkey'
}

export enum Queue_Job_Status_Type_Enum {
  /** Job marked as complete */
  Complete = 'complete',
  /** Job has failed */
  Failed = 'failed',
  /** Job picked up and being handled */
  Processing = 'processing',
  /** Job waiting to be handled */
  Waiting = 'waiting'
}

/** Boolean expression to compare columns of type "queue_job_status_type_enum". All fields are combined with logical 'AND'. */
export type Queue_Job_Status_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Queue_Job_Status_Type_Enum>;
  _in?: InputMaybe<Array<Queue_Job_Status_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Queue_Job_Status_Type_Enum>;
  _nin?: InputMaybe<Array<Queue_Job_Status_Type_Enum>>;
};

/** input type for inserting data into table "queue.job_status_type" */
export type Queue_Job_Status_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Queue_Job_Status_Type_Max_Fields = {
  __typename?: 'queue_job_status_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Queue_Job_Status_Type_Min_Fields = {
  __typename?: 'queue_job_status_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "queue.job_status_type" */
export type Queue_Job_Status_Type_Mutation_Response = {
  __typename?: 'queue_job_status_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Queue_Job_Status_Type>;
};

/** on_conflict condition type for table "queue.job_status_type" */
export type Queue_Job_Status_Type_On_Conflict = {
  constraint: Queue_Job_Status_Type_Constraint;
  update_columns?: Array<Queue_Job_Status_Type_Update_Column>;
  where?: InputMaybe<Queue_Job_Status_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "queue.job_status_type". */
export type Queue_Job_Status_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: queue.job_status_type */
export type Queue_Job_Status_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "queue.job_status_type" */
export enum Queue_Job_Status_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "queue.job_status_type" */
export type Queue_Job_Status_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "queue_job_status_type" */
export type Queue_Job_Status_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Queue_Job_Status_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Queue_Job_Status_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "queue.job_status_type" */
export enum Queue_Job_Status_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Queue_Job_Status_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Queue_Job_Status_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Queue_Job_Status_Type_Bool_Exp;
};

/** Streaming cursor of the table "queue_job" */
export type Queue_Job_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Queue_Job_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Queue_Job_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Queue_Job_Type_Enum>;
  payload?: InputMaybe<Scalars['jsonb']>;
  result?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Queue_Job_Status_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Enum for job types / name */
export type Queue_Job_Type = {
  __typename?: 'queue_job_type';
  comment: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "queue.job_type" */
export type Queue_Job_Type_Aggregate = {
  __typename?: 'queue_job_type_aggregate';
  aggregate?: Maybe<Queue_Job_Type_Aggregate_Fields>;
  nodes: Array<Queue_Job_Type>;
};

/** aggregate fields of "queue.job_type" */
export type Queue_Job_Type_Aggregate_Fields = {
  __typename?: 'queue_job_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Queue_Job_Type_Max_Fields>;
  min?: Maybe<Queue_Job_Type_Min_Fields>;
};


/** aggregate fields of "queue.job_type" */
export type Queue_Job_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Queue_Job_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "queue.job_type". All fields are combined with a logical 'AND'. */
export type Queue_Job_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Queue_Job_Type_Bool_Exp>>;
  _not?: InputMaybe<Queue_Job_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Queue_Job_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "queue.job_type" */
export enum Queue_Job_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  JobTypePkey = 'job_type_pkey'
}

export enum Queue_Job_Type_Enum {
  /** Send monthly college follows summary */
  SpinCollegeFollowerMonthlyEmail = 'spin_college_follower_monthly_email',
  /** Send weekly college follows summary */
  SpinCollegeFollowerWeeklyEmail = 'spin_college_follower_weekly_email',
  /** Send monthly college message summary */
  SpinCollegeMessagesMonthlyEmail = 'spin_college_messages_monthly_email',
  /** Send weekly college message summary */
  SpinCollegeMessagesWeeklyEmail = 'spin_college_messages_weekly_email',
  /** Send monthly college profile views summary */
  SpinCollegeProfileViewMonthlyEmail = 'spin_college_profile_view_monthly_email',
  /** Send weekly college profile views summary */
  SpinCollegeProfileViewWeeklyEmail = 'spin_college_profile_view_weekly_email',
  /** Send an email summary of player followers per month */
  SpinHsFollowerMonthlyEmail = 'spin_hs_follower_monthly_email',
  /** Send an email summary of high school followers per week */
  SpinHsFollowerWeeklyEmail = 'spin_hs_follower_weekly_email',
  /** Send an email summary of high school messages per month */
  SpinHsMessagesMonthlyEmail = 'spin_hs_messages_monthly_email',
  /** Send an email summary of high school messages per week */
  SpinHsMessagesWeeklyEmail = 'spin_hs_messages_weekly_email',
  /** Send an email summary of high school profile views per month */
  SpinHsProfileViewMonthlyEmail = 'spin_hs_profile_view_monthly_email',
  /** Send an email summary of player profile views */
  SpinHsProfileViewWeeklyEmail = 'spin_hs_profile_view_weekly_email',
  /** Send an email summary of player followers per month */
  SpinPlayerFollowerMonthlyEmail = 'spin_player_follower_monthly_email',
  /** Send an email summary of player followers per week */
  SpinPlayerFollowerWeeklyEmail = 'spin_player_follower_weekly_email',
  /** Send an email summary of player messages per month */
  SpinPlayerMessagesMonthlyEmail = 'spin_player_messages_monthly_email',
  /** Send an email summary of player messages per week */
  SpinPlayerMessagesWeeklyEmail = 'spin_player_messages_weekly_email',
  /** Send an email summary of player profile views per month */
  SpinPlayerProfileViewMonthlyEmail = 'spin_player_profile_view_monthly_email',
  /** Send an email summary of player profile views */
  SpinPlayerProfileViewWeeklyEmail = 'spin_player_profile_view_weekly_email'
}

/** Boolean expression to compare columns of type "queue_job_type_enum". All fields are combined with logical 'AND'. */
export type Queue_Job_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Queue_Job_Type_Enum>;
  _in?: InputMaybe<Array<Queue_Job_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Queue_Job_Type_Enum>;
  _nin?: InputMaybe<Array<Queue_Job_Type_Enum>>;
};

/** input type for inserting data into table "queue.job_type" */
export type Queue_Job_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Queue_Job_Type_Max_Fields = {
  __typename?: 'queue_job_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Queue_Job_Type_Min_Fields = {
  __typename?: 'queue_job_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "queue.job_type" */
export type Queue_Job_Type_Mutation_Response = {
  __typename?: 'queue_job_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Queue_Job_Type>;
};

/** on_conflict condition type for table "queue.job_type" */
export type Queue_Job_Type_On_Conflict = {
  constraint: Queue_Job_Type_Constraint;
  update_columns?: Array<Queue_Job_Type_Update_Column>;
  where?: InputMaybe<Queue_Job_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "queue.job_type". */
export type Queue_Job_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: queue.job_type */
export type Queue_Job_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "queue.job_type" */
export enum Queue_Job_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "queue.job_type" */
export type Queue_Job_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "queue_job_type" */
export type Queue_Job_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Queue_Job_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Queue_Job_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "queue.job_type" */
export enum Queue_Job_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Queue_Job_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Queue_Job_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Queue_Job_Type_Bool_Exp;
};

/** update columns of table "queue.job" */
export enum Queue_Job_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Payload = 'payload',
  /** column name */
  Result = 'result',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Queue_Job_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Queue_Job_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Queue_Job_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Queue_Job_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Queue_Job_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Queue_Job_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Queue_Job_Set_Input>;
  /** filter the rows which have to be updated */
  where: Queue_Job_Bool_Exp;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: InputMaybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

/** Customer id lookup */
export type Stripe_Customer_Data = {
  __typename?: 'stripe_customer_data';
  customer_id: Scalars['String'];
  email: Scalars['String'];
  project: Content_Project_Name_Enum;
  user_id: Scalars['String'];
};

/** aggregated selection of "stripe.customer_data" */
export type Stripe_Customer_Data_Aggregate = {
  __typename?: 'stripe_customer_data_aggregate';
  aggregate?: Maybe<Stripe_Customer_Data_Aggregate_Fields>;
  nodes: Array<Stripe_Customer_Data>;
};

/** aggregate fields of "stripe.customer_data" */
export type Stripe_Customer_Data_Aggregate_Fields = {
  __typename?: 'stripe_customer_data_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Stripe_Customer_Data_Max_Fields>;
  min?: Maybe<Stripe_Customer_Data_Min_Fields>;
};


/** aggregate fields of "stripe.customer_data" */
export type Stripe_Customer_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stripe_Customer_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "stripe.customer_data". All fields are combined with a logical 'AND'. */
export type Stripe_Customer_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Stripe_Customer_Data_Bool_Exp>>;
  _not?: InputMaybe<Stripe_Customer_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Stripe_Customer_Data_Bool_Exp>>;
  customer_id?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Content_Project_Name_Enum_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "stripe.customer_data" */
export enum Stripe_Customer_Data_Constraint {
  /** unique or primary key constraint on columns "project", "email" */
  CustomerDataEmailProjectKey = 'customer_data_email_project_key',
  /** unique or primary key constraint on columns "customer_id" */
  CustomerDataPkey = 'customer_data_pkey'
}

/** input type for inserting data into table "stripe.customer_data" */
export type Stripe_Customer_Data_Insert_Input = {
  customer_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Content_Project_Name_Enum>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Stripe_Customer_Data_Max_Fields = {
  __typename?: 'stripe_customer_data_max_fields';
  customer_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Stripe_Customer_Data_Min_Fields = {
  __typename?: 'stripe_customer_data_min_fields';
  customer_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "stripe.customer_data" */
export type Stripe_Customer_Data_Mutation_Response = {
  __typename?: 'stripe_customer_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stripe_Customer_Data>;
};

/** on_conflict condition type for table "stripe.customer_data" */
export type Stripe_Customer_Data_On_Conflict = {
  constraint: Stripe_Customer_Data_Constraint;
  update_columns?: Array<Stripe_Customer_Data_Update_Column>;
  where?: InputMaybe<Stripe_Customer_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "stripe.customer_data". */
export type Stripe_Customer_Data_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  project?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stripe.customer_data */
export type Stripe_Customer_Data_Pk_Columns_Input = {
  customer_id: Scalars['String'];
};

/** select columns of table "stripe.customer_data" */
export enum Stripe_Customer_Data_Select_Column {
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  Email = 'email',
  /** column name */
  Project = 'project',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "stripe.customer_data" */
export type Stripe_Customer_Data_Set_Input = {
  customer_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Content_Project_Name_Enum>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "stripe_customer_data" */
export type Stripe_Customer_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stripe_Customer_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stripe_Customer_Data_Stream_Cursor_Value_Input = {
  customer_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Content_Project_Name_Enum>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "stripe.customer_data" */
export enum Stripe_Customer_Data_Update_Column {
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  Email = 'email',
  /** column name */
  Project = 'project',
  /** column name */
  UserId = 'user_id'
}

export type Stripe_Customer_Data_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stripe_Customer_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stripe_Customer_Data_Bool_Exp;
};

/** columns and relationships of "stripe.invoice_data" */
export type Stripe_Invoice_Data = {
  __typename?: 'stripe_invoice_data';
  account_country: Scalars['String'];
  amount_paid: Scalars['float8'];
  attempt_count: Scalars['Int'];
  customer: Scalars['String'];
  customer_email: Scalars['String'];
  id: Scalars['String'];
  status: Scalars['String'];
  subscription: Scalars['String'];
};

/** aggregated selection of "stripe.invoice_data" */
export type Stripe_Invoice_Data_Aggregate = {
  __typename?: 'stripe_invoice_data_aggregate';
  aggregate?: Maybe<Stripe_Invoice_Data_Aggregate_Fields>;
  nodes: Array<Stripe_Invoice_Data>;
};

/** aggregate fields of "stripe.invoice_data" */
export type Stripe_Invoice_Data_Aggregate_Fields = {
  __typename?: 'stripe_invoice_data_aggregate_fields';
  avg?: Maybe<Stripe_Invoice_Data_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stripe_Invoice_Data_Max_Fields>;
  min?: Maybe<Stripe_Invoice_Data_Min_Fields>;
  stddev?: Maybe<Stripe_Invoice_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Stripe_Invoice_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stripe_Invoice_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Stripe_Invoice_Data_Sum_Fields>;
  var_pop?: Maybe<Stripe_Invoice_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Stripe_Invoice_Data_Var_Samp_Fields>;
  variance?: Maybe<Stripe_Invoice_Data_Variance_Fields>;
};


/** aggregate fields of "stripe.invoice_data" */
export type Stripe_Invoice_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stripe_Invoice_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Stripe_Invoice_Data_Avg_Fields = {
  __typename?: 'stripe_invoice_data_avg_fields';
  amount_paid?: Maybe<Scalars['Float']>;
  attempt_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "stripe.invoice_data". All fields are combined with a logical 'AND'. */
export type Stripe_Invoice_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Stripe_Invoice_Data_Bool_Exp>>;
  _not?: InputMaybe<Stripe_Invoice_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Stripe_Invoice_Data_Bool_Exp>>;
  account_country?: InputMaybe<String_Comparison_Exp>;
  amount_paid?: InputMaybe<Float8_Comparison_Exp>;
  attempt_count?: InputMaybe<Int_Comparison_Exp>;
  customer?: InputMaybe<String_Comparison_Exp>;
  customer_email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "stripe.invoice_data" */
export enum Stripe_Invoice_Data_Constraint {
  /** unique or primary key constraint on columns "id" */
  StripeInvoiceDataPkey = 'stripe_invoice_data_pkey'
}

/** input type for incrementing numeric columns in table "stripe.invoice_data" */
export type Stripe_Invoice_Data_Inc_Input = {
  amount_paid?: InputMaybe<Scalars['float8']>;
  attempt_count?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stripe.invoice_data" */
export type Stripe_Invoice_Data_Insert_Input = {
  account_country?: InputMaybe<Scalars['String']>;
  amount_paid?: InputMaybe<Scalars['float8']>;
  attempt_count?: InputMaybe<Scalars['Int']>;
  customer?: InputMaybe<Scalars['String']>;
  customer_email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Stripe_Invoice_Data_Max_Fields = {
  __typename?: 'stripe_invoice_data_max_fields';
  account_country?: Maybe<Scalars['String']>;
  amount_paid?: Maybe<Scalars['float8']>;
  attempt_count?: Maybe<Scalars['Int']>;
  customer?: Maybe<Scalars['String']>;
  customer_email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscription?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Stripe_Invoice_Data_Min_Fields = {
  __typename?: 'stripe_invoice_data_min_fields';
  account_country?: Maybe<Scalars['String']>;
  amount_paid?: Maybe<Scalars['float8']>;
  attempt_count?: Maybe<Scalars['Int']>;
  customer?: Maybe<Scalars['String']>;
  customer_email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscription?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "stripe.invoice_data" */
export type Stripe_Invoice_Data_Mutation_Response = {
  __typename?: 'stripe_invoice_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stripe_Invoice_Data>;
};

/** on_conflict condition type for table "stripe.invoice_data" */
export type Stripe_Invoice_Data_On_Conflict = {
  constraint: Stripe_Invoice_Data_Constraint;
  update_columns?: Array<Stripe_Invoice_Data_Update_Column>;
  where?: InputMaybe<Stripe_Invoice_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "stripe.invoice_data". */
export type Stripe_Invoice_Data_Order_By = {
  account_country?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  customer_email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stripe.invoice_data */
export type Stripe_Invoice_Data_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "stripe.invoice_data" */
export enum Stripe_Invoice_Data_Select_Column {
  /** column name */
  AccountCountry = 'account_country',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerEmail = 'customer_email',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  Subscription = 'subscription'
}

/** input type for updating data in table "stripe.invoice_data" */
export type Stripe_Invoice_Data_Set_Input = {
  account_country?: InputMaybe<Scalars['String']>;
  amount_paid?: InputMaybe<Scalars['float8']>;
  attempt_count?: InputMaybe<Scalars['Int']>;
  customer?: InputMaybe<Scalars['String']>;
  customer_email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Stripe_Invoice_Data_Stddev_Fields = {
  __typename?: 'stripe_invoice_data_stddev_fields';
  amount_paid?: Maybe<Scalars['Float']>;
  attempt_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Stripe_Invoice_Data_Stddev_Pop_Fields = {
  __typename?: 'stripe_invoice_data_stddev_pop_fields';
  amount_paid?: Maybe<Scalars['Float']>;
  attempt_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Stripe_Invoice_Data_Stddev_Samp_Fields = {
  __typename?: 'stripe_invoice_data_stddev_samp_fields';
  amount_paid?: Maybe<Scalars['Float']>;
  attempt_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "stripe_invoice_data" */
export type Stripe_Invoice_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stripe_Invoice_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stripe_Invoice_Data_Stream_Cursor_Value_Input = {
  account_country?: InputMaybe<Scalars['String']>;
  amount_paid?: InputMaybe<Scalars['float8']>;
  attempt_count?: InputMaybe<Scalars['Int']>;
  customer?: InputMaybe<Scalars['String']>;
  customer_email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Stripe_Invoice_Data_Sum_Fields = {
  __typename?: 'stripe_invoice_data_sum_fields';
  amount_paid?: Maybe<Scalars['float8']>;
  attempt_count?: Maybe<Scalars['Int']>;
};

/** update columns of table "stripe.invoice_data" */
export enum Stripe_Invoice_Data_Update_Column {
  /** column name */
  AccountCountry = 'account_country',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerEmail = 'customer_email',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  Subscription = 'subscription'
}

export type Stripe_Invoice_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stripe_Invoice_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stripe_Invoice_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stripe_Invoice_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stripe_Invoice_Data_Var_Pop_Fields = {
  __typename?: 'stripe_invoice_data_var_pop_fields';
  amount_paid?: Maybe<Scalars['Float']>;
  attempt_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Stripe_Invoice_Data_Var_Samp_Fields = {
  __typename?: 'stripe_invoice_data_var_samp_fields';
  amount_paid?: Maybe<Scalars['Float']>;
  attempt_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Stripe_Invoice_Data_Variance_Fields = {
  __typename?: 'stripe_invoice_data_variance_fields';
  amount_paid?: Maybe<Scalars['Float']>;
  attempt_count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "stripe.stripe_payment_data" */
export type Stripe_Stripe_Payment_Data = {
  __typename?: 'stripe_stripe_payment_data';
  amount: Scalars['float8'];
  confirmation_method: Scalars['String'];
  created_at: Scalars['date'];
  currency: Scalars['String'];
  customer?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  object_type: Scalars['String'];
  payment_method?: Maybe<Scalars['String']>;
  shipping_city?: Maybe<Scalars['String']>;
  shipping_country?: Maybe<Scalars['String']>;
  shipping_line?: Maybe<Scalars['String']>;
  shipping_line_two?: Maybe<Scalars['String']>;
  shipping_name?: Maybe<Scalars['String']>;
  shipping_phone?: Maybe<Scalars['String']>;
  shipping_postal_code?: Maybe<Scalars['String']>;
  shipping_state?: Maybe<Scalars['String']>;
  shipping_tracking_number?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

/** aggregated selection of "stripe.stripe_payment_data" */
export type Stripe_Stripe_Payment_Data_Aggregate = {
  __typename?: 'stripe_stripe_payment_data_aggregate';
  aggregate?: Maybe<Stripe_Stripe_Payment_Data_Aggregate_Fields>;
  nodes: Array<Stripe_Stripe_Payment_Data>;
};

/** aggregate fields of "stripe.stripe_payment_data" */
export type Stripe_Stripe_Payment_Data_Aggregate_Fields = {
  __typename?: 'stripe_stripe_payment_data_aggregate_fields';
  avg?: Maybe<Stripe_Stripe_Payment_Data_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stripe_Stripe_Payment_Data_Max_Fields>;
  min?: Maybe<Stripe_Stripe_Payment_Data_Min_Fields>;
  stddev?: Maybe<Stripe_Stripe_Payment_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Stripe_Stripe_Payment_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stripe_Stripe_Payment_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Stripe_Stripe_Payment_Data_Sum_Fields>;
  var_pop?: Maybe<Stripe_Stripe_Payment_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Stripe_Stripe_Payment_Data_Var_Samp_Fields>;
  variance?: Maybe<Stripe_Stripe_Payment_Data_Variance_Fields>;
};


/** aggregate fields of "stripe.stripe_payment_data" */
export type Stripe_Stripe_Payment_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stripe_Stripe_Payment_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Stripe_Stripe_Payment_Data_Avg_Fields = {
  __typename?: 'stripe_stripe_payment_data_avg_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "stripe.stripe_payment_data". All fields are combined with a logical 'AND'. */
export type Stripe_Stripe_Payment_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Stripe_Stripe_Payment_Data_Bool_Exp>>;
  _not?: InputMaybe<Stripe_Stripe_Payment_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Stripe_Stripe_Payment_Data_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  confirmation_method?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Date_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  customer?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  object_type?: InputMaybe<String_Comparison_Exp>;
  payment_method?: InputMaybe<String_Comparison_Exp>;
  shipping_city?: InputMaybe<String_Comparison_Exp>;
  shipping_country?: InputMaybe<String_Comparison_Exp>;
  shipping_line?: InputMaybe<String_Comparison_Exp>;
  shipping_line_two?: InputMaybe<String_Comparison_Exp>;
  shipping_name?: InputMaybe<String_Comparison_Exp>;
  shipping_phone?: InputMaybe<String_Comparison_Exp>;
  shipping_postal_code?: InputMaybe<String_Comparison_Exp>;
  shipping_state?: InputMaybe<String_Comparison_Exp>;
  shipping_tracking_number?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "stripe.stripe_payment_data" */
export enum Stripe_Stripe_Payment_Data_Constraint {
  /** unique or primary key constraint on columns "id" */
  StripePaymentDataPkey = 'stripe_payment_data_pkey'
}

/** input type for incrementing numeric columns in table "stripe.stripe_payment_data" */
export type Stripe_Stripe_Payment_Data_Inc_Input = {
  amount?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "stripe.stripe_payment_data" */
export type Stripe_Stripe_Payment_Data_Insert_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  confirmation_method?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['date']>;
  currency?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  object_type?: InputMaybe<Scalars['String']>;
  payment_method?: InputMaybe<Scalars['String']>;
  shipping_city?: InputMaybe<Scalars['String']>;
  shipping_country?: InputMaybe<Scalars['String']>;
  shipping_line?: InputMaybe<Scalars['String']>;
  shipping_line_two?: InputMaybe<Scalars['String']>;
  shipping_name?: InputMaybe<Scalars['String']>;
  shipping_phone?: InputMaybe<Scalars['String']>;
  shipping_postal_code?: InputMaybe<Scalars['String']>;
  shipping_state?: InputMaybe<Scalars['String']>;
  shipping_tracking_number?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Stripe_Stripe_Payment_Data_Max_Fields = {
  __typename?: 'stripe_stripe_payment_data_max_fields';
  amount?: Maybe<Scalars['float8']>;
  confirmation_method?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['date']>;
  currency?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  object_type?: Maybe<Scalars['String']>;
  payment_method?: Maybe<Scalars['String']>;
  shipping_city?: Maybe<Scalars['String']>;
  shipping_country?: Maybe<Scalars['String']>;
  shipping_line?: Maybe<Scalars['String']>;
  shipping_line_two?: Maybe<Scalars['String']>;
  shipping_name?: Maybe<Scalars['String']>;
  shipping_phone?: Maybe<Scalars['String']>;
  shipping_postal_code?: Maybe<Scalars['String']>;
  shipping_state?: Maybe<Scalars['String']>;
  shipping_tracking_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Stripe_Stripe_Payment_Data_Min_Fields = {
  __typename?: 'stripe_stripe_payment_data_min_fields';
  amount?: Maybe<Scalars['float8']>;
  confirmation_method?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['date']>;
  currency?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  object_type?: Maybe<Scalars['String']>;
  payment_method?: Maybe<Scalars['String']>;
  shipping_city?: Maybe<Scalars['String']>;
  shipping_country?: Maybe<Scalars['String']>;
  shipping_line?: Maybe<Scalars['String']>;
  shipping_line_two?: Maybe<Scalars['String']>;
  shipping_name?: Maybe<Scalars['String']>;
  shipping_phone?: Maybe<Scalars['String']>;
  shipping_postal_code?: Maybe<Scalars['String']>;
  shipping_state?: Maybe<Scalars['String']>;
  shipping_tracking_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "stripe.stripe_payment_data" */
export type Stripe_Stripe_Payment_Data_Mutation_Response = {
  __typename?: 'stripe_stripe_payment_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stripe_Stripe_Payment_Data>;
};

/** on_conflict condition type for table "stripe.stripe_payment_data" */
export type Stripe_Stripe_Payment_Data_On_Conflict = {
  constraint: Stripe_Stripe_Payment_Data_Constraint;
  update_columns?: Array<Stripe_Stripe_Payment_Data_Update_Column>;
  where?: InputMaybe<Stripe_Stripe_Payment_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "stripe.stripe_payment_data". */
export type Stripe_Stripe_Payment_Data_Order_By = {
  amount?: InputMaybe<Order_By>;
  confirmation_method?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_type?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Order_By>;
  shipping_city?: InputMaybe<Order_By>;
  shipping_country?: InputMaybe<Order_By>;
  shipping_line?: InputMaybe<Order_By>;
  shipping_line_two?: InputMaybe<Order_By>;
  shipping_name?: InputMaybe<Order_By>;
  shipping_phone?: InputMaybe<Order_By>;
  shipping_postal_code?: InputMaybe<Order_By>;
  shipping_state?: InputMaybe<Order_By>;
  shipping_tracking_number?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stripe.stripe_payment_data */
export type Stripe_Stripe_Payment_Data_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "stripe.stripe_payment_data" */
export enum Stripe_Stripe_Payment_Data_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ConfirmationMethod = 'confirmation_method',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Customer = 'customer',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectType = 'object_type',
  /** column name */
  PaymentMethod = 'payment_method',
  /** column name */
  ShippingCity = 'shipping_city',
  /** column name */
  ShippingCountry = 'shipping_country',
  /** column name */
  ShippingLine = 'shipping_line',
  /** column name */
  ShippingLineTwo = 'shipping_line_two',
  /** column name */
  ShippingName = 'shipping_name',
  /** column name */
  ShippingPhone = 'shipping_phone',
  /** column name */
  ShippingPostalCode = 'shipping_postal_code',
  /** column name */
  ShippingState = 'shipping_state',
  /** column name */
  ShippingTrackingNumber = 'shipping_tracking_number',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "stripe.stripe_payment_data" */
export type Stripe_Stripe_Payment_Data_Set_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  confirmation_method?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['date']>;
  currency?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  object_type?: InputMaybe<Scalars['String']>;
  payment_method?: InputMaybe<Scalars['String']>;
  shipping_city?: InputMaybe<Scalars['String']>;
  shipping_country?: InputMaybe<Scalars['String']>;
  shipping_line?: InputMaybe<Scalars['String']>;
  shipping_line_two?: InputMaybe<Scalars['String']>;
  shipping_name?: InputMaybe<Scalars['String']>;
  shipping_phone?: InputMaybe<Scalars['String']>;
  shipping_postal_code?: InputMaybe<Scalars['String']>;
  shipping_state?: InputMaybe<Scalars['String']>;
  shipping_tracking_number?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Stripe_Stripe_Payment_Data_Stddev_Fields = {
  __typename?: 'stripe_stripe_payment_data_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Stripe_Stripe_Payment_Data_Stddev_Pop_Fields = {
  __typename?: 'stripe_stripe_payment_data_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Stripe_Stripe_Payment_Data_Stddev_Samp_Fields = {
  __typename?: 'stripe_stripe_payment_data_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "stripe_stripe_payment_data" */
export type Stripe_Stripe_Payment_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stripe_Stripe_Payment_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stripe_Stripe_Payment_Data_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  confirmation_method?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['date']>;
  currency?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  object_type?: InputMaybe<Scalars['String']>;
  payment_method?: InputMaybe<Scalars['String']>;
  shipping_city?: InputMaybe<Scalars['String']>;
  shipping_country?: InputMaybe<Scalars['String']>;
  shipping_line?: InputMaybe<Scalars['String']>;
  shipping_line_two?: InputMaybe<Scalars['String']>;
  shipping_name?: InputMaybe<Scalars['String']>;
  shipping_phone?: InputMaybe<Scalars['String']>;
  shipping_postal_code?: InputMaybe<Scalars['String']>;
  shipping_state?: InputMaybe<Scalars['String']>;
  shipping_tracking_number?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Stripe_Stripe_Payment_Data_Sum_Fields = {
  __typename?: 'stripe_stripe_payment_data_sum_fields';
  amount?: Maybe<Scalars['float8']>;
};

/** update columns of table "stripe.stripe_payment_data" */
export enum Stripe_Stripe_Payment_Data_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ConfirmationMethod = 'confirmation_method',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Customer = 'customer',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectType = 'object_type',
  /** column name */
  PaymentMethod = 'payment_method',
  /** column name */
  ShippingCity = 'shipping_city',
  /** column name */
  ShippingCountry = 'shipping_country',
  /** column name */
  ShippingLine = 'shipping_line',
  /** column name */
  ShippingLineTwo = 'shipping_line_two',
  /** column name */
  ShippingName = 'shipping_name',
  /** column name */
  ShippingPhone = 'shipping_phone',
  /** column name */
  ShippingPostalCode = 'shipping_postal_code',
  /** column name */
  ShippingState = 'shipping_state',
  /** column name */
  ShippingTrackingNumber = 'shipping_tracking_number',
  /** column name */
  Status = 'status'
}

export type Stripe_Stripe_Payment_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stripe_Stripe_Payment_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stripe_Stripe_Payment_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stripe_Stripe_Payment_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stripe_Stripe_Payment_Data_Var_Pop_Fields = {
  __typename?: 'stripe_stripe_payment_data_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Stripe_Stripe_Payment_Data_Var_Samp_Fields = {
  __typename?: 'stripe_stripe_payment_data_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Stripe_Stripe_Payment_Data_Variance_Fields = {
  __typename?: 'stripe_stripe_payment_data_variance_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "stripe.stripe_subscription_data" */
export type Stripe_Stripe_Subscription_Data = {
  __typename?: 'stripe_stripe_subscription_data';
  active: Scalars['Boolean'];
  amount?: Maybe<Scalars['float8']>;
  billing_cycle_anchor: Scalars['date'];
  collection_method: Scalars['String'];
  currency: Scalars['String'];
  current_period_end: Scalars['date'];
  current_period_start: Scalars['date'];
  customer: Scalars['String'];
  id: Scalars['String'];
  object: Scalars['String'];
  plan_id: Scalars['String'];
  quantity: Scalars['Int'];
  start_date: Scalars['date'];
  status: Scalars['String'];
};

/** aggregated selection of "stripe.stripe_subscription_data" */
export type Stripe_Stripe_Subscription_Data_Aggregate = {
  __typename?: 'stripe_stripe_subscription_data_aggregate';
  aggregate?: Maybe<Stripe_Stripe_Subscription_Data_Aggregate_Fields>;
  nodes: Array<Stripe_Stripe_Subscription_Data>;
};

/** aggregate fields of "stripe.stripe_subscription_data" */
export type Stripe_Stripe_Subscription_Data_Aggregate_Fields = {
  __typename?: 'stripe_stripe_subscription_data_aggregate_fields';
  avg?: Maybe<Stripe_Stripe_Subscription_Data_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stripe_Stripe_Subscription_Data_Max_Fields>;
  min?: Maybe<Stripe_Stripe_Subscription_Data_Min_Fields>;
  stddev?: Maybe<Stripe_Stripe_Subscription_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Stripe_Stripe_Subscription_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stripe_Stripe_Subscription_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Stripe_Stripe_Subscription_Data_Sum_Fields>;
  var_pop?: Maybe<Stripe_Stripe_Subscription_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Stripe_Stripe_Subscription_Data_Var_Samp_Fields>;
  variance?: Maybe<Stripe_Stripe_Subscription_Data_Variance_Fields>;
};


/** aggregate fields of "stripe.stripe_subscription_data" */
export type Stripe_Stripe_Subscription_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stripe_Stripe_Subscription_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Stripe_Stripe_Subscription_Data_Avg_Fields = {
  __typename?: 'stripe_stripe_subscription_data_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "stripe.stripe_subscription_data". All fields are combined with a logical 'AND'. */
export type Stripe_Stripe_Subscription_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Stripe_Stripe_Subscription_Data_Bool_Exp>>;
  _not?: InputMaybe<Stripe_Stripe_Subscription_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Stripe_Stripe_Subscription_Data_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  billing_cycle_anchor?: InputMaybe<Date_Comparison_Exp>;
  collection_method?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  current_period_end?: InputMaybe<Date_Comparison_Exp>;
  current_period_start?: InputMaybe<Date_Comparison_Exp>;
  customer?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  object?: InputMaybe<String_Comparison_Exp>;
  plan_id?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "stripe.stripe_subscription_data" */
export enum Stripe_Stripe_Subscription_Data_Constraint {
  /** unique or primary key constraint on columns "customer" */
  StripeSubscriptionDataCustomerKey = 'stripe_subscription_data_customer_key',
  /** unique or primary key constraint on columns "id", "customer" */
  StripeSubscriptionDataPkey = 'stripe_subscription_data_pkey'
}

/** input type for incrementing numeric columns in table "stripe.stripe_subscription_data" */
export type Stripe_Stripe_Subscription_Data_Inc_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stripe.stripe_subscription_data" */
export type Stripe_Stripe_Subscription_Data_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['float8']>;
  billing_cycle_anchor?: InputMaybe<Scalars['date']>;
  collection_method?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  current_period_end?: InputMaybe<Scalars['date']>;
  current_period_start?: InputMaybe<Scalars['date']>;
  customer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  object?: InputMaybe<Scalars['String']>;
  plan_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Stripe_Stripe_Subscription_Data_Max_Fields = {
  __typename?: 'stripe_stripe_subscription_data_max_fields';
  amount?: Maybe<Scalars['float8']>;
  billing_cycle_anchor?: Maybe<Scalars['date']>;
  collection_method?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  current_period_end?: Maybe<Scalars['date']>;
  current_period_start?: Maybe<Scalars['date']>;
  customer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
  plan_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Stripe_Stripe_Subscription_Data_Min_Fields = {
  __typename?: 'stripe_stripe_subscription_data_min_fields';
  amount?: Maybe<Scalars['float8']>;
  billing_cycle_anchor?: Maybe<Scalars['date']>;
  collection_method?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  current_period_end?: Maybe<Scalars['date']>;
  current_period_start?: Maybe<Scalars['date']>;
  customer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
  plan_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "stripe.stripe_subscription_data" */
export type Stripe_Stripe_Subscription_Data_Mutation_Response = {
  __typename?: 'stripe_stripe_subscription_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stripe_Stripe_Subscription_Data>;
};

/** on_conflict condition type for table "stripe.stripe_subscription_data" */
export type Stripe_Stripe_Subscription_Data_On_Conflict = {
  constraint: Stripe_Stripe_Subscription_Data_Constraint;
  update_columns?: Array<Stripe_Stripe_Subscription_Data_Update_Column>;
  where?: InputMaybe<Stripe_Stripe_Subscription_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "stripe.stripe_subscription_data". */
export type Stripe_Stripe_Subscription_Data_Order_By = {
  active?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  billing_cycle_anchor?: InputMaybe<Order_By>;
  collection_method?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  current_period_end?: InputMaybe<Order_By>;
  current_period_start?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stripe.stripe_subscription_data */
export type Stripe_Stripe_Subscription_Data_Pk_Columns_Input = {
  customer: Scalars['String'];
  id: Scalars['String'];
};

/** select columns of table "stripe.stripe_subscription_data" */
export enum Stripe_Stripe_Subscription_Data_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Amount = 'amount',
  /** column name */
  BillingCycleAnchor = 'billing_cycle_anchor',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Currency = 'currency',
  /** column name */
  CurrentPeriodEnd = 'current_period_end',
  /** column name */
  CurrentPeriodStart = 'current_period_start',
  /** column name */
  Customer = 'customer',
  /** column name */
  Id = 'id',
  /** column name */
  Object = 'object',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "stripe.stripe_subscription_data" */
export type Stripe_Stripe_Subscription_Data_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['float8']>;
  billing_cycle_anchor?: InputMaybe<Scalars['date']>;
  collection_method?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  current_period_end?: InputMaybe<Scalars['date']>;
  current_period_start?: InputMaybe<Scalars['date']>;
  customer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  object?: InputMaybe<Scalars['String']>;
  plan_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Stripe_Stripe_Subscription_Data_Stddev_Fields = {
  __typename?: 'stripe_stripe_subscription_data_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Stripe_Stripe_Subscription_Data_Stddev_Pop_Fields = {
  __typename?: 'stripe_stripe_subscription_data_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Stripe_Stripe_Subscription_Data_Stddev_Samp_Fields = {
  __typename?: 'stripe_stripe_subscription_data_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "stripe_stripe_subscription_data" */
export type Stripe_Stripe_Subscription_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stripe_Stripe_Subscription_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stripe_Stripe_Subscription_Data_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['float8']>;
  billing_cycle_anchor?: InputMaybe<Scalars['date']>;
  collection_method?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  current_period_end?: InputMaybe<Scalars['date']>;
  current_period_start?: InputMaybe<Scalars['date']>;
  customer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  object?: InputMaybe<Scalars['String']>;
  plan_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Stripe_Stripe_Subscription_Data_Sum_Fields = {
  __typename?: 'stripe_stripe_subscription_data_sum_fields';
  amount?: Maybe<Scalars['float8']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** update columns of table "stripe.stripe_subscription_data" */
export enum Stripe_Stripe_Subscription_Data_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Amount = 'amount',
  /** column name */
  BillingCycleAnchor = 'billing_cycle_anchor',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Currency = 'currency',
  /** column name */
  CurrentPeriodEnd = 'current_period_end',
  /** column name */
  CurrentPeriodStart = 'current_period_start',
  /** column name */
  Customer = 'customer',
  /** column name */
  Id = 'id',
  /** column name */
  Object = 'object',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status'
}

export type Stripe_Stripe_Subscription_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stripe_Stripe_Subscription_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stripe_Stripe_Subscription_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stripe_Stripe_Subscription_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stripe_Stripe_Subscription_Data_Var_Pop_Fields = {
  __typename?: 'stripe_stripe_subscription_data_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Stripe_Stripe_Subscription_Data_Var_Samp_Fields = {
  __typename?: 'stripe_stripe_subscription_data_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Stripe_Stripe_Subscription_Data_Variance_Fields = {
  __typename?: 'stripe_stripe_subscription_data_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "cehsite.ms_available_site_terms" */
  cehsite_ms_available_site_terms: Array<Cehsite_Ms_Available_Site_Terms>;
  /** fetch aggregated fields from the table: "cehsite.ms_available_site_terms" */
  cehsite_ms_available_site_terms_aggregate: Cehsite_Ms_Available_Site_Terms_Aggregate;
  /** fetch data from the table: "cehsite.ms_available_site_terms" using primary key columns */
  cehsite_ms_available_site_terms_by_pk?: Maybe<Cehsite_Ms_Available_Site_Terms>;
  /** fetch data from the table in a streaming manner: "cehsite.ms_available_site_terms" */
  cehsite_ms_available_site_terms_stream: Array<Cehsite_Ms_Available_Site_Terms>;
  /** fetch data from the table: "cehsite.ms_contact_form_entry" */
  cehsite_ms_contact_form_entry: Array<Cehsite_Ms_Contact_Form_Entry>;
  /** fetch aggregated fields from the table: "cehsite.ms_contact_form_entry" */
  cehsite_ms_contact_form_entry_aggregate: Cehsite_Ms_Contact_Form_Entry_Aggregate;
  /** fetch data from the table: "cehsite.ms_contact_form_entry" using primary key columns */
  cehsite_ms_contact_form_entry_by_pk?: Maybe<Cehsite_Ms_Contact_Form_Entry>;
  /** fetch data from the table in a streaming manner: "cehsite.ms_contact_form_entry" */
  cehsite_ms_contact_form_entry_stream: Array<Cehsite_Ms_Contact_Form_Entry>;
  /** fetch data from the table: "cehsite.ms_newsletter_signup" */
  cehsite_ms_newsletter_signup: Array<Cehsite_Ms_Newsletter_Signup>;
  /** fetch aggregated fields from the table: "cehsite.ms_newsletter_signup" */
  cehsite_ms_newsletter_signup_aggregate: Cehsite_Ms_Newsletter_Signup_Aggregate;
  /** fetch data from the table: "cehsite.ms_newsletter_signup" using primary key columns */
  cehsite_ms_newsletter_signup_by_pk?: Maybe<Cehsite_Ms_Newsletter_Signup>;
  /** fetch data from the table in a streaming manner: "cehsite.ms_newsletter_signup" */
  cehsite_ms_newsletter_signup_stream: Array<Cehsite_Ms_Newsletter_Signup>;
  /** fetch data from the table: "cehsite.ms_site_content" */
  cehsite_ms_site_content: Array<Cehsite_Ms_Site_Content>;
  /** fetch aggregated fields from the table: "cehsite.ms_site_content" */
  cehsite_ms_site_content_aggregate: Cehsite_Ms_Site_Content_Aggregate;
  /** fetch data from the table: "cehsite.ms_site_content" using primary key columns */
  cehsite_ms_site_content_by_pk?: Maybe<Cehsite_Ms_Site_Content>;
  /** fetch data from the table in a streaming manner: "cehsite.ms_site_content" */
  cehsite_ms_site_content_stream: Array<Cehsite_Ms_Site_Content>;
  /** fetch data from the table: "content.file" */
  content_file: Array<Content_File>;
  /** fetch aggregated fields from the table: "content.file" */
  content_file_aggregate: Content_File_Aggregate;
  /** fetch data from the table: "content.file" using primary key columns */
  content_file_by_pk?: Maybe<Content_File>;
  /** fetch data from the table: "content.file_metadata" */
  content_file_metadata: Array<Content_File_Metadata>;
  /** fetch aggregated fields from the table: "content.file_metadata" */
  content_file_metadata_aggregate: Content_File_Metadata_Aggregate;
  /** fetch data from the table: "content.file_metadata" using primary key columns */
  content_file_metadata_by_pk?: Maybe<Content_File_Metadata>;
  /** fetch data from the table in a streaming manner: "content.file_metadata" */
  content_file_metadata_stream: Array<Content_File_Metadata>;
  /** fetch data from the table: "content.file_status" */
  content_file_status: Array<Content_File_Status>;
  /** fetch aggregated fields from the table: "content.file_status" */
  content_file_status_aggregate: Content_File_Status_Aggregate;
  /** fetch data from the table: "content.file_status" using primary key columns */
  content_file_status_by_pk?: Maybe<Content_File_Status>;
  /** fetch data from the table in a streaming manner: "content.file_status" */
  content_file_status_stream: Array<Content_File_Status>;
  /** fetch data from the table in a streaming manner: "content.file" */
  content_file_stream: Array<Content_File>;
  /** fetch data from the table: "content.media_link" */
  content_media_link: Array<Content_Media_Link>;
  /** fetch aggregated fields from the table: "content.media_link" */
  content_media_link_aggregate: Content_Media_Link_Aggregate;
  /** fetch data from the table: "content.media_link" using primary key columns */
  content_media_link_by_pk?: Maybe<Content_Media_Link>;
  /** fetch data from the table in a streaming manner: "content.media_link" */
  content_media_link_stream: Array<Content_Media_Link>;
  /** fetch data from the table: "content.media_link_type" */
  content_media_link_type: Array<Content_Media_Link_Type>;
  /** fetch aggregated fields from the table: "content.media_link_type" */
  content_media_link_type_aggregate: Content_Media_Link_Type_Aggregate;
  /** fetch data from the table: "content.media_link_type" using primary key columns */
  content_media_link_type_by_pk?: Maybe<Content_Media_Link_Type>;
  /** fetch data from the table in a streaming manner: "content.media_link_type" */
  content_media_link_type_stream: Array<Content_Media_Link_Type>;
  /** fetch data from the table: "content.project_name" */
  content_project_name: Array<Content_Project_Name>;
  /** fetch aggregated fields from the table: "content.project_name" */
  content_project_name_aggregate: Content_Project_Name_Aggregate;
  /** fetch data from the table: "content.project_name" using primary key columns */
  content_project_name_by_pk?: Maybe<Content_Project_Name>;
  /** fetch data from the table in a streaming manner: "content.project_name" */
  content_project_name_stream: Array<Content_Project_Name>;
  /** fetch data from the table: "content.status" */
  content_status: Array<Content_Status>;
  /** fetch aggregated fields from the table: "content.status" */
  content_status_aggregate: Content_Status_Aggregate;
  /** fetch data from the table: "content.status" using primary key columns */
  content_status_by_pk?: Maybe<Content_Status>;
  /** fetch data from the table in a streaming manner: "content.status" */
  content_status_stream: Array<Content_Status>;
  /** fetch data from the table: "espin.address" */
  espin_address: Array<Espin_Address>;
  /** fetch aggregated fields from the table: "espin.address" */
  espin_address_aggregate: Espin_Address_Aggregate;
  /** fetch data from the table: "espin.address" using primary key columns */
  espin_address_by_pk?: Maybe<Espin_Address>;
  /** fetch data from the table in a streaming manner: "espin.address" */
  espin_address_stream: Array<Espin_Address>;
  /** fetch data from the table: "espin.boolean_feature_flag" */
  espin_boolean_feature_flag: Array<Espin_Boolean_Feature_Flag>;
  /** fetch aggregated fields from the table: "espin.boolean_feature_flag" */
  espin_boolean_feature_flag_aggregate: Espin_Boolean_Feature_Flag_Aggregate;
  /** fetch data from the table: "espin.boolean_feature_flag" using primary key columns */
  espin_boolean_feature_flag_by_pk?: Maybe<Espin_Boolean_Feature_Flag>;
  /** fetch data from the table in a streaming manner: "espin.boolean_feature_flag" */
  espin_boolean_feature_flag_stream: Array<Espin_Boolean_Feature_Flag>;
  /** fetch data from the table: "espin.coach_profile" */
  espin_coach_profile: Array<Espin_Coach_Profile>;
  /** fetch aggregated fields from the table: "espin.coach_profile" */
  espin_coach_profile_aggregate: Espin_Coach_Profile_Aggregate;
  /** fetch data from the table: "espin.coach_profile" using primary key columns */
  espin_coach_profile_by_pk?: Maybe<Espin_Coach_Profile>;
  /** fetch data from the table in a streaming manner: "espin.coach_profile" */
  espin_coach_profile_stream: Array<Espin_Coach_Profile>;
  /** fetch data from the table: "espin.college" */
  espin_college: Array<Espin_College>;
  /** fetch aggregated fields from the table: "espin.college" */
  espin_college_aggregate: Espin_College_Aggregate;
  /** fetch data from the table: "espin.college_automatic_message_response_type" */
  espin_college_automatic_message_response_type: Array<Espin_College_Automatic_Message_Response_Type>;
  /** fetch aggregated fields from the table: "espin.college_automatic_message_response_type" */
  espin_college_automatic_message_response_type_aggregate: Espin_College_Automatic_Message_Response_Type_Aggregate;
  /** fetch data from the table: "espin.college_automatic_message_response_type" using primary key columns */
  espin_college_automatic_message_response_type_by_pk?: Maybe<Espin_College_Automatic_Message_Response_Type>;
  /** fetch data from the table in a streaming manner: "espin.college_automatic_message_response_type" */
  espin_college_automatic_message_response_type_stream: Array<Espin_College_Automatic_Message_Response_Type>;
  /** fetch data from the table: "espin.college" using primary key columns */
  espin_college_by_pk?: Maybe<Espin_College>;
  /** fetch data from the table: "espin.college_game" */
  espin_college_game: Array<Espin_College_Game>;
  /** fetch aggregated fields from the table: "espin.college_game" */
  espin_college_game_aggregate: Espin_College_Game_Aggregate;
  /** fetch data from the table: "espin.college_game" using primary key columns */
  espin_college_game_by_pk?: Maybe<Espin_College_Game>;
  /** fetch data from the table in a streaming manner: "espin.college_game" */
  espin_college_game_stream: Array<Espin_College_Game>;
  /** fetch data from the table: "espin.college_image" */
  espin_college_image: Array<Espin_College_Image>;
  /** fetch aggregated fields from the table: "espin.college_image" */
  espin_college_image_aggregate: Espin_College_Image_Aggregate;
  /** fetch data from the table: "espin.college_image" using primary key columns */
  espin_college_image_by_pk?: Maybe<Espin_College_Image>;
  /** fetch data from the table in a streaming manner: "espin.college_image" */
  espin_college_image_stream: Array<Espin_College_Image>;
  /** fetch data from the table: "espin.college_invite" */
  espin_college_invite: Array<Espin_College_Invite>;
  /** fetch aggregated fields from the table: "espin.college_invite" */
  espin_college_invite_aggregate: Espin_College_Invite_Aggregate;
  /** fetch data from the table: "espin.college_invite" using primary key columns */
  espin_college_invite_by_pk?: Maybe<Espin_College_Invite>;
  /** fetch data from the table in a streaming manner: "espin.college_invite" */
  espin_college_invite_stream: Array<Espin_College_Invite>;
  /** fetch data from the table: "espin.college_preferences" */
  espin_college_preferences: Array<Espin_College_Preferences>;
  /** fetch aggregated fields from the table: "espin.college_preferences" */
  espin_college_preferences_aggregate: Espin_College_Preferences_Aggregate;
  /** fetch data from the table: "espin.college_preferences" using primary key columns */
  espin_college_preferences_by_pk?: Maybe<Espin_College_Preferences>;
  /** fetch data from the table in a streaming manner: "espin.college_preferences" */
  espin_college_preferences_stream: Array<Espin_College_Preferences>;
  /** fetch data from the table: "espin.college_profile" */
  espin_college_profile: Array<Espin_College_Profile>;
  /** fetch aggregated fields from the table: "espin.college_profile" */
  espin_college_profile_aggregate: Espin_College_Profile_Aggregate;
  /** fetch data from the table: "espin.college_profile" using primary key columns */
  espin_college_profile_by_pk?: Maybe<Espin_College_Profile>;
  /** fetch data from the table in a streaming manner: "espin.college_profile" */
  espin_college_profile_stream: Array<Espin_College_Profile>;
  /** fetch data from the table: "espin.college_roster" */
  espin_college_roster: Array<Espin_College_Roster>;
  /** fetch aggregated fields from the table: "espin.college_roster" */
  espin_college_roster_aggregate: Espin_College_Roster_Aggregate;
  /** fetch data from the table: "espin.college_roster" using primary key columns */
  espin_college_roster_by_pk?: Maybe<Espin_College_Roster>;
  /** fetch data from the table in a streaming manner: "espin.college_roster" */
  espin_college_roster_stream: Array<Espin_College_Roster>;
  /** fetch data from the table: "espin.college_staff_member" */
  espin_college_staff_member: Array<Espin_College_Staff_Member>;
  /** fetch aggregated fields from the table: "espin.college_staff_member" */
  espin_college_staff_member_aggregate: Espin_College_Staff_Member_Aggregate;
  /** fetch data from the table: "espin.college_staff_member" using primary key columns */
  espin_college_staff_member_by_pk?: Maybe<Espin_College_Staff_Member>;
  /** fetch data from the table in a streaming manner: "espin.college_staff_member" */
  espin_college_staff_member_stream: Array<Espin_College_Staff_Member>;
  /** fetch data from the table in a streaming manner: "espin.college" */
  espin_college_stream: Array<Espin_College>;
  /** fetch data from the table: "espin.college_subscription" */
  espin_college_subscription: Array<Espin_College_Subscription>;
  /** fetch aggregated fields from the table: "espin.college_subscription" */
  espin_college_subscription_aggregate: Espin_College_Subscription_Aggregate;
  /** fetch data from the table: "espin.college_subscription" using primary key columns */
  espin_college_subscription_by_pk?: Maybe<Espin_College_Subscription>;
  /** fetch data from the table in a streaming manner: "espin.college_subscription" */
  espin_college_subscription_stream: Array<Espin_College_Subscription>;
  /** fetch data from the table: "espin.college_verification_status_type" */
  espin_college_verification_status_type: Array<Espin_College_Verification_Status_Type>;
  /** fetch aggregated fields from the table: "espin.college_verification_status_type" */
  espin_college_verification_status_type_aggregate: Espin_College_Verification_Status_Type_Aggregate;
  /** fetch data from the table: "espin.college_verification_status_type" using primary key columns */
  espin_college_verification_status_type_by_pk?: Maybe<Espin_College_Verification_Status_Type>;
  /** fetch data from the table in a streaming manner: "espin.college_verification_status_type" */
  espin_college_verification_status_type_stream: Array<Espin_College_Verification_Status_Type>;
  /** fetch data from the table: "espin.draft_player_profile" */
  espin_draft_player_profile: Array<Espin_Draft_Player_Profile>;
  /** fetch aggregated fields from the table: "espin.draft_player_profile" */
  espin_draft_player_profile_aggregate: Espin_Draft_Player_Profile_Aggregate;
  /** fetch data from the table: "espin.draft_player_profile" using primary key columns */
  espin_draft_player_profile_by_pk?: Maybe<Espin_Draft_Player_Profile>;
  /** fetch data from the table in a streaming manner: "espin.draft_player_profile" */
  espin_draft_player_profile_stream: Array<Espin_Draft_Player_Profile>;
  /** fetch data from the table: "espin.editable_site_content" */
  espin_editable_site_content: Array<Espin_Editable_Site_Content>;
  /** fetch aggregated fields from the table: "espin.editable_site_content" */
  espin_editable_site_content_aggregate: Espin_Editable_Site_Content_Aggregate;
  /** fetch data from the table: "espin.editable_site_content" using primary key columns */
  espin_editable_site_content_by_pk?: Maybe<Espin_Editable_Site_Content>;
  /** fetch data from the table in a streaming manner: "espin.editable_site_content" */
  espin_editable_site_content_stream: Array<Espin_Editable_Site_Content>;
  /** fetch data from the table: "espin.ethnicity_options" */
  espin_ethnicity_options: Array<Espin_Ethnicity_Options>;
  /** fetch aggregated fields from the table: "espin.ethnicity_options" */
  espin_ethnicity_options_aggregate: Espin_Ethnicity_Options_Aggregate;
  /** fetch data from the table: "espin.ethnicity_options" using primary key columns */
  espin_ethnicity_options_by_pk?: Maybe<Espin_Ethnicity_Options>;
  /** fetch data from the table in a streaming manner: "espin.ethnicity_options" */
  espin_ethnicity_options_stream: Array<Espin_Ethnicity_Options>;
  /** fetch data from the table: "espin.event" */
  espin_event: Array<Espin_Event>;
  /** fetch aggregated fields from the table: "espin.event" */
  espin_event_aggregate: Espin_Event_Aggregate;
  /** fetch data from the table: "espin.event" using primary key columns */
  espin_event_by_pk?: Maybe<Espin_Event>;
  /** fetch data from the table: "espin.event_custom_field" */
  espin_event_custom_field: Array<Espin_Event_Custom_Field>;
  /** fetch aggregated fields from the table: "espin.event_custom_field" */
  espin_event_custom_field_aggregate: Espin_Event_Custom_Field_Aggregate;
  /** fetch data from the table: "espin.event_custom_field" using primary key columns */
  espin_event_custom_field_by_pk?: Maybe<Espin_Event_Custom_Field>;
  /** fetch data from the table in a streaming manner: "espin.event_custom_field" */
  espin_event_custom_field_stream: Array<Espin_Event_Custom_Field>;
  /** fetch data from the table: "espin.event_custom_field_type" */
  espin_event_custom_field_type: Array<Espin_Event_Custom_Field_Type>;
  /** fetch aggregated fields from the table: "espin.event_custom_field_type" */
  espin_event_custom_field_type_aggregate: Espin_Event_Custom_Field_Type_Aggregate;
  /** fetch data from the table: "espin.event_custom_field_type" using primary key columns */
  espin_event_custom_field_type_by_pk?: Maybe<Espin_Event_Custom_Field_Type>;
  /** fetch data from the table in a streaming manner: "espin.event_custom_field_type" */
  espin_event_custom_field_type_stream: Array<Espin_Event_Custom_Field_Type>;
  /** fetch data from the table: "espin.event_document" */
  espin_event_document: Array<Espin_Event_Document>;
  /** fetch aggregated fields from the table: "espin.event_document" */
  espin_event_document_aggregate: Espin_Event_Document_Aggregate;
  /** fetch data from the table: "espin.event_document" using primary key columns */
  espin_event_document_by_pk?: Maybe<Espin_Event_Document>;
  /** fetch data from the table in a streaming manner: "espin.event_document" */
  espin_event_document_stream: Array<Espin_Event_Document>;
  /** fetch data from the table: "espin.event_game" */
  espin_event_game: Array<Espin_Event_Game>;
  /** fetch aggregated fields from the table: "espin.event_game" */
  espin_event_game_aggregate: Espin_Event_Game_Aggregate;
  /** fetch data from the table: "espin.event_game" using primary key columns */
  espin_event_game_by_pk?: Maybe<Espin_Event_Game>;
  /** fetch data from the table in a streaming manner: "espin.event_game" */
  espin_event_game_stream: Array<Espin_Event_Game>;
  /** fetch data from the table: "espin.event_registration" */
  espin_event_registration: Array<Espin_Event_Registration>;
  /** fetch aggregated fields from the table: "espin.event_registration" */
  espin_event_registration_aggregate: Espin_Event_Registration_Aggregate;
  /** fetch data from the table: "espin.event_registration" using primary key columns */
  espin_event_registration_by_pk?: Maybe<Espin_Event_Registration>;
  /** fetch data from the table: "espin.event_registration_custom_field_entry" */
  espin_event_registration_custom_field_entry: Array<Espin_Event_Registration_Custom_Field_Entry>;
  /** fetch aggregated fields from the table: "espin.event_registration_custom_field_entry" */
  espin_event_registration_custom_field_entry_aggregate: Espin_Event_Registration_Custom_Field_Entry_Aggregate;
  /** fetch data from the table: "espin.event_registration_custom_field_entry" using primary key columns */
  espin_event_registration_custom_field_entry_by_pk?: Maybe<Espin_Event_Registration_Custom_Field_Entry>;
  /** fetch data from the table in a streaming manner: "espin.event_registration_custom_field_entry" */
  espin_event_registration_custom_field_entry_stream: Array<Espin_Event_Registration_Custom_Field_Entry>;
  /** fetch data from the table: "espin.event_registration_document_signoff" */
  espin_event_registration_document_signoff: Array<Espin_Event_Registration_Document_Signoff>;
  /** fetch aggregated fields from the table: "espin.event_registration_document_signoff" */
  espin_event_registration_document_signoff_aggregate: Espin_Event_Registration_Document_Signoff_Aggregate;
  /** fetch data from the table: "espin.event_registration_document_signoff" using primary key columns */
  espin_event_registration_document_signoff_by_pk?: Maybe<Espin_Event_Registration_Document_Signoff>;
  /** fetch data from the table in a streaming manner: "espin.event_registration_document_signoff" */
  espin_event_registration_document_signoff_stream: Array<Espin_Event_Registration_Document_Signoff>;
  /** fetch data from the table: "espin.event_registration_status" */
  espin_event_registration_status: Array<Espin_Event_Registration_Status>;
  /** fetch aggregated fields from the table: "espin.event_registration_status" */
  espin_event_registration_status_aggregate: Espin_Event_Registration_Status_Aggregate;
  /** fetch data from the table: "espin.event_registration_status" using primary key columns */
  espin_event_registration_status_by_pk?: Maybe<Espin_Event_Registration_Status>;
  /** fetch data from the table in a streaming manner: "espin.event_registration_status" */
  espin_event_registration_status_stream: Array<Espin_Event_Registration_Status>;
  /** fetch data from the table in a streaming manner: "espin.event_registration" */
  espin_event_registration_stream: Array<Espin_Event_Registration>;
  /** fetch data from the table in a streaming manner: "espin.event" */
  espin_event_stream: Array<Espin_Event>;
  /** fetch data from the table: "espin.event_ticket" */
  espin_event_ticket: Array<Espin_Event_Ticket>;
  /** fetch aggregated fields from the table: "espin.event_ticket" */
  espin_event_ticket_aggregate: Espin_Event_Ticket_Aggregate;
  /** fetch data from the table: "espin.event_ticket" using primary key columns */
  espin_event_ticket_by_pk?: Maybe<Espin_Event_Ticket>;
  /** fetch data from the table in a streaming manner: "espin.event_ticket" */
  espin_event_ticket_stream: Array<Espin_Event_Ticket>;
  /** fetch data from the table: "espin.event_ticket_type" */
  espin_event_ticket_type: Array<Espin_Event_Ticket_Type>;
  /** fetch aggregated fields from the table: "espin.event_ticket_type" */
  espin_event_ticket_type_aggregate: Espin_Event_Ticket_Type_Aggregate;
  /** fetch data from the table: "espin.event_ticket_type" using primary key columns */
  espin_event_ticket_type_by_pk?: Maybe<Espin_Event_Ticket_Type>;
  /** fetch data from the table in a streaming manner: "espin.event_ticket_type" */
  espin_event_ticket_type_stream: Array<Espin_Event_Ticket_Type>;
  /** fetch data from the table: "espin.event_type" */
  espin_event_type: Array<Espin_Event_Type>;
  /** fetch aggregated fields from the table: "espin.event_type" */
  espin_event_type_aggregate: Espin_Event_Type_Aggregate;
  /** fetch data from the table: "espin.event_type" using primary key columns */
  espin_event_type_by_pk?: Maybe<Espin_Event_Type>;
  /** fetch data from the table in a streaming manner: "espin.event_type" */
  espin_event_type_stream: Array<Espin_Event_Type>;
  /** fetch data from the table: "espin.external_provider" */
  espin_external_provider: Array<Espin_External_Provider>;
  /** fetch aggregated fields from the table: "espin.external_provider" */
  espin_external_provider_aggregate: Espin_External_Provider_Aggregate;
  /** fetch data from the table: "espin.external_provider" using primary key columns */
  espin_external_provider_by_pk?: Maybe<Espin_External_Provider>;
  /** fetch data from the table: "espin.external_provider_link" */
  espin_external_provider_link: Array<Espin_External_Provider_Link>;
  /** fetch aggregated fields from the table: "espin.external_provider_link" */
  espin_external_provider_link_aggregate: Espin_External_Provider_Link_Aggregate;
  /** fetch data from the table: "espin.external_provider_link" using primary key columns */
  espin_external_provider_link_by_pk?: Maybe<Espin_External_Provider_Link>;
  /** fetch data from the table in a streaming manner: "espin.external_provider_link" */
  espin_external_provider_link_stream: Array<Espin_External_Provider_Link>;
  /** fetch data from the table in a streaming manner: "espin.external_provider" */
  espin_external_provider_stream: Array<Espin_External_Provider>;
  /** fetch data from the table: "espin.follow" */
  espin_follow: Array<Espin_Follow>;
  /** fetch aggregated fields from the table: "espin.follow" */
  espin_follow_aggregate: Espin_Follow_Aggregate;
  /** fetch data from the table: "espin.follow" using primary key columns */
  espin_follow_by_pk?: Maybe<Espin_Follow>;
  /** fetch data from the table in a streaming manner: "espin.follow" */
  espin_follow_stream: Array<Espin_Follow>;
  /** fetch data from the table: "espin.follow_type" */
  espin_follow_type: Array<Espin_Follow_Type>;
  /** fetch aggregated fields from the table: "espin.follow_type" */
  espin_follow_type_aggregate: Espin_Follow_Type_Aggregate;
  /** fetch data from the table: "espin.follow_type" using primary key columns */
  espin_follow_type_by_pk?: Maybe<Espin_Follow_Type>;
  /** fetch data from the table in a streaming manner: "espin.follow_type" */
  espin_follow_type_stream: Array<Espin_Follow_Type>;
  /** fetch data from the table: "espin.follower_email_notification_type" */
  espin_follower_email_notification_type: Array<Espin_Follower_Email_Notification_Type>;
  /** fetch aggregated fields from the table: "espin.follower_email_notification_type" */
  espin_follower_email_notification_type_aggregate: Espin_Follower_Email_Notification_Type_Aggregate;
  /** fetch data from the table: "espin.follower_email_notification_type" using primary key columns */
  espin_follower_email_notification_type_by_pk?: Maybe<Espin_Follower_Email_Notification_Type>;
  /** fetch data from the table in a streaming manner: "espin.follower_email_notification_type" */
  espin_follower_email_notification_type_stream: Array<Espin_Follower_Email_Notification_Type>;
  /** fetch data from the table: "espin.force_notification_reload" */
  espin_force_notification_reload: Array<Espin_Force_Notification_Reload>;
  /** fetch aggregated fields from the table: "espin.force_notification_reload" */
  espin_force_notification_reload_aggregate: Espin_Force_Notification_Reload_Aggregate;
  /** fetch data from the table: "espin.force_notification_reload" using primary key columns */
  espin_force_notification_reload_by_pk?: Maybe<Espin_Force_Notification_Reload>;
  /** fetch data from the table in a streaming manner: "espin.force_notification_reload" */
  espin_force_notification_reload_stream: Array<Espin_Force_Notification_Reload>;
  /** fetch data from the table: "espin.game" */
  espin_game: Array<Espin_Game>;
  /** fetch aggregated fields from the table: "espin.game" */
  espin_game_aggregate: Espin_Game_Aggregate;
  /** fetch data from the table: "espin.game" using primary key columns */
  espin_game_by_pk?: Maybe<Espin_Game>;
  /** fetch data from the table: "espin.game_definition" */
  espin_game_definition: Array<Espin_Game_Definition>;
  /** fetch aggregated fields from the table: "espin.game_definition" */
  espin_game_definition_aggregate: Espin_Game_Definition_Aggregate;
  /** fetch data from the table: "espin.game_definition" using primary key columns */
  espin_game_definition_by_pk?: Maybe<Espin_Game_Definition>;
  /** fetch data from the table in a streaming manner: "espin.game_definition" */
  espin_game_definition_stream: Array<Espin_Game_Definition>;
  /** fetch data from the table: "espin.game_platform" */
  espin_game_platform: Array<Espin_Game_Platform>;
  /** fetch aggregated fields from the table: "espin.game_platform" */
  espin_game_platform_aggregate: Espin_Game_Platform_Aggregate;
  /** fetch data from the table: "espin.game_platform" using primary key columns */
  espin_game_platform_by_pk?: Maybe<Espin_Game_Platform>;
  /** fetch data from the table in a streaming manner: "espin.game_platform" */
  espin_game_platform_stream: Array<Espin_Game_Platform>;
  /** fetch data from the table in a streaming manner: "espin.game" */
  espin_game_stream: Array<Espin_Game>;
  /** fetch data from the table: "espin.gender_options" */
  espin_gender_options: Array<Espin_Gender_Options>;
  /** fetch aggregated fields from the table: "espin.gender_options" */
  espin_gender_options_aggregate: Espin_Gender_Options_Aggregate;
  /** fetch data from the table: "espin.gender_options" using primary key columns */
  espin_gender_options_by_pk?: Maybe<Espin_Gender_Options>;
  /** fetch data from the table in a streaming manner: "espin.gender_options" */
  espin_gender_options_stream: Array<Espin_Gender_Options>;
  /** fetch data from the table: "espin.graduating_class" */
  espin_graduating_class: Array<Espin_Graduating_Class>;
  /** fetch aggregated fields from the table: "espin.graduating_class" */
  espin_graduating_class_aggregate: Espin_Graduating_Class_Aggregate;
  /** fetch data from the table: "espin.graduating_class" using primary key columns */
  espin_graduating_class_by_pk?: Maybe<Espin_Graduating_Class>;
  /** fetch data from the table in a streaming manner: "espin.graduating_class" */
  espin_graduating_class_stream: Array<Espin_Graduating_Class>;
  /** fetch data from the table: "espin.high_school" */
  espin_high_school: Array<Espin_High_School>;
  /** fetch aggregated fields from the table: "espin.high_school" */
  espin_high_school_aggregate: Espin_High_School_Aggregate;
  /** fetch data from the table: "espin.high_school" using primary key columns */
  espin_high_school_by_pk?: Maybe<Espin_High_School>;
  /** fetch data from the table: "espin.high_school_invite" */
  espin_high_school_invite: Array<Espin_High_School_Invite>;
  /** fetch aggregated fields from the table: "espin.high_school_invite" */
  espin_high_school_invite_aggregate: Espin_High_School_Invite_Aggregate;
  /** fetch data from the table: "espin.high_school_invite" using primary key columns */
  espin_high_school_invite_by_pk?: Maybe<Espin_High_School_Invite>;
  /** fetch data from the table in a streaming manner: "espin.high_school_invite" */
  espin_high_school_invite_stream: Array<Espin_High_School_Invite>;
  /** fetch data from the table: "espin.high_school_profile" */
  espin_high_school_profile: Array<Espin_High_School_Profile>;
  /** fetch aggregated fields from the table: "espin.high_school_profile" */
  espin_high_school_profile_aggregate: Espin_High_School_Profile_Aggregate;
  /** fetch data from the table: "espin.high_school_profile" using primary key columns */
  espin_high_school_profile_by_pk?: Maybe<Espin_High_School_Profile>;
  /** fetch data from the table in a streaming manner: "espin.high_school_profile" */
  espin_high_school_profile_stream: Array<Espin_High_School_Profile>;
  /** fetch data from the table in a streaming manner: "espin.high_school" */
  espin_high_school_stream: Array<Espin_High_School>;
  /** fetch data from the table: "espin.invite_status_type" */
  espin_invite_status_type: Array<Espin_Invite_Status_Type>;
  /** fetch aggregated fields from the table: "espin.invite_status_type" */
  espin_invite_status_type_aggregate: Espin_Invite_Status_Type_Aggregate;
  /** fetch data from the table: "espin.invite_status_type" using primary key columns */
  espin_invite_status_type_by_pk?: Maybe<Espin_Invite_Status_Type>;
  /** fetch data from the table in a streaming manner: "espin.invite_status_type" */
  espin_invite_status_type_stream: Array<Espin_Invite_Status_Type>;
  /** fetch data from the table: "espin.leaderboard" */
  espin_leaderboard: Array<Espin_Leaderboard>;
  /** fetch aggregated fields from the table: "espin.leaderboard" */
  espin_leaderboard_aggregate: Espin_Leaderboard_Aggregate;
  /** fetch data from the table: "espin.leaderboard" using primary key columns */
  espin_leaderboard_by_pk?: Maybe<Espin_Leaderboard>;
  /** fetch data from the table in a streaming manner: "espin.leaderboard" */
  espin_leaderboard_stream: Array<Espin_Leaderboard>;
  /** fetch data from the table: "espin.membership" */
  espin_membership: Array<Espin_Membership>;
  /** fetch aggregated fields from the table: "espin.membership" */
  espin_membership_aggregate: Espin_Membership_Aggregate;
  /** fetch data from the table: "espin.membership" using primary key columns */
  espin_membership_by_pk?: Maybe<Espin_Membership>;
  /** fetch data from the table in a streaming manner: "espin.membership" */
  espin_membership_stream: Array<Espin_Membership>;
  /** fetch data from the table: "espin.message" */
  espin_message: Array<Espin_Message>;
  /** fetch aggregated fields from the table: "espin.message" */
  espin_message_aggregate: Espin_Message_Aggregate;
  /** fetch data from the table: "espin.message" using primary key columns */
  espin_message_by_pk?: Maybe<Espin_Message>;
  /** fetch data from the table: "espin.message_email_notification_type" */
  espin_message_email_notification_type: Array<Espin_Message_Email_Notification_Type>;
  /** fetch aggregated fields from the table: "espin.message_email_notification_type" */
  espin_message_email_notification_type_aggregate: Espin_Message_Email_Notification_Type_Aggregate;
  /** fetch data from the table: "espin.message_email_notification_type" using primary key columns */
  espin_message_email_notification_type_by_pk?: Maybe<Espin_Message_Email_Notification_Type>;
  /** fetch data from the table in a streaming manner: "espin.message_email_notification_type" */
  espin_message_email_notification_type_stream: Array<Espin_Message_Email_Notification_Type>;
  /** fetch data from the table in a streaming manner: "espin.message" */
  espin_message_stream: Array<Espin_Message>;
  /** fetch data from the table: "espin.message_type" */
  espin_message_type: Array<Espin_Message_Type>;
  /** fetch aggregated fields from the table: "espin.message_type" */
  espin_message_type_aggregate: Espin_Message_Type_Aggregate;
  /** fetch data from the table: "espin.message_type" using primary key columns */
  espin_message_type_by_pk?: Maybe<Espin_Message_Type>;
  /** fetch data from the table in a streaming manner: "espin.message_type" */
  espin_message_type_stream: Array<Espin_Message_Type>;
  /** fetch data from the table: "espin.moderation_status" */
  espin_moderation_status: Array<Espin_Moderation_Status>;
  /** fetch aggregated fields from the table: "espin.moderation_status" */
  espin_moderation_status_aggregate: Espin_Moderation_Status_Aggregate;
  /** fetch data from the table: "espin.moderation_status" using primary key columns */
  espin_moderation_status_by_pk?: Maybe<Espin_Moderation_Status>;
  /** fetch data from the table in a streaming manner: "espin.moderation_status" */
  espin_moderation_status_stream: Array<Espin_Moderation_Status>;
  /** fetch data from the table: "espin.newsletter_request" */
  espin_newsletter_request: Array<Espin_Newsletter_Request>;
  /** fetch aggregated fields from the table: "espin.newsletter_request" */
  espin_newsletter_request_aggregate: Espin_Newsletter_Request_Aggregate;
  /** fetch data from the table: "espin.newsletter_request" using primary key columns */
  espin_newsletter_request_by_pk?: Maybe<Espin_Newsletter_Request>;
  /** fetch data from the table in a streaming manner: "espin.newsletter_request" */
  espin_newsletter_request_stream: Array<Espin_Newsletter_Request>;
  /** fetch data from the table: "espin.notification" */
  espin_notification: Array<Espin_Notification>;
  /** fetch aggregated fields from the table: "espin.notification" */
  espin_notification_aggregate: Espin_Notification_Aggregate;
  /** fetch data from the table: "espin.notification" using primary key columns */
  espin_notification_by_pk?: Maybe<Espin_Notification>;
  /** fetch data from the table in a streaming manner: "espin.notification" */
  espin_notification_stream: Array<Espin_Notification>;
  /** fetch data from the table: "espin.notification_type" */
  espin_notification_type: Array<Espin_Notification_Type>;
  /** fetch aggregated fields from the table: "espin.notification_type" */
  espin_notification_type_aggregate: Espin_Notification_Type_Aggregate;
  /** fetch data from the table: "espin.notification_type" using primary key columns */
  espin_notification_type_by_pk?: Maybe<Espin_Notification_Type>;
  /** fetch data from the table in a streaming manner: "espin.notification_type" */
  espin_notification_type_stream: Array<Espin_Notification_Type>;
  /** fetch data from the table: "espin.org" */
  espin_org: Array<Espin_Org>;
  /** fetch aggregated fields from the table: "espin.org" */
  espin_org_aggregate: Espin_Org_Aggregate;
  /** fetch data from the table: "espin.org" using primary key columns */
  espin_org_by_pk?: Maybe<Espin_Org>;
  /** fetch data from the table: "espin.org_month" */
  espin_org_month: Array<Espin_Org_Month>;
  /** fetch aggregated fields from the table: "espin.org_month" */
  espin_org_month_aggregate: Espin_Org_Month_Aggregate;
  /** fetch data from the table: "espin.org_month" using primary key columns */
  espin_org_month_by_pk?: Maybe<Espin_Org_Month>;
  /** fetch data from the table: "espin.org_month_day" */
  espin_org_month_day: Array<Espin_Org_Month_Day>;
  /** fetch aggregated fields from the table: "espin.org_month_day" */
  espin_org_month_day_aggregate: Espin_Org_Month_Day_Aggregate;
  /** fetch data from the table: "espin.org_month_day" using primary key columns */
  espin_org_month_day_by_pk?: Maybe<Espin_Org_Month_Day>;
  /** fetch data from the table in a streaming manner: "espin.org_month_day" */
  espin_org_month_day_stream: Array<Espin_Org_Month_Day>;
  /** fetch data from the table in a streaming manner: "espin.org_month" */
  espin_org_month_stream: Array<Espin_Org_Month>;
  /** fetch data from the table: "espin.org_player" */
  espin_org_player: Array<Espin_Org_Player>;
  /** fetch aggregated fields from the table: "espin.org_player" */
  espin_org_player_aggregate: Espin_Org_Player_Aggregate;
  /** fetch data from the table: "espin.org_player" using primary key columns */
  espin_org_player_by_pk?: Maybe<Espin_Org_Player>;
  /** fetch data from the table in a streaming manner: "espin.org_player" */
  espin_org_player_stream: Array<Espin_Org_Player>;
  /** fetch data from the table: "espin.org_school" */
  espin_org_school: Array<Espin_Org_School>;
  /** fetch aggregated fields from the table: "espin.org_school" */
  espin_org_school_aggregate: Espin_Org_School_Aggregate;
  /** fetch data from the table: "espin.org_school" using primary key columns */
  espin_org_school_by_pk?: Maybe<Espin_Org_School>;
  /** fetch data from the table: "espin.org_school_record" */
  espin_org_school_record: Array<Espin_Org_School_Record>;
  /** fetch aggregated fields from the table: "espin.org_school_record" */
  espin_org_school_record_aggregate: Espin_Org_School_Record_Aggregate;
  /** fetch data from the table: "espin.org_school_record" using primary key columns */
  espin_org_school_record_by_pk?: Maybe<Espin_Org_School_Record>;
  /** fetch data from the table in a streaming manner: "espin.org_school_record" */
  espin_org_school_record_stream: Array<Espin_Org_School_Record>;
  /** fetch data from the table in a streaming manner: "espin.org_school" */
  espin_org_school_stream: Array<Espin_Org_School>;
  /** fetch data from the table in a streaming manner: "espin.org" */
  espin_org_stream: Array<Espin_Org>;
  /** fetch data from the table: "espin.paid_product" */
  espin_paid_product: Array<Espin_Paid_Product>;
  /** fetch aggregated fields from the table: "espin.paid_product" */
  espin_paid_product_aggregate: Espin_Paid_Product_Aggregate;
  /** fetch data from the table: "espin.paid_product" using primary key columns */
  espin_paid_product_by_pk?: Maybe<Espin_Paid_Product>;
  /** fetch data from the table in a streaming manner: "espin.paid_product" */
  espin_paid_product_stream: Array<Espin_Paid_Product>;
  /** fetch data from the table: "espin.parent_invite" */
  espin_parent_invite: Array<Espin_Parent_Invite>;
  /** fetch aggregated fields from the table: "espin.parent_invite" */
  espin_parent_invite_aggregate: Espin_Parent_Invite_Aggregate;
  /** fetch data from the table: "espin.parent_invite" using primary key columns */
  espin_parent_invite_by_pk?: Maybe<Espin_Parent_Invite>;
  /** fetch data from the table in a streaming manner: "espin.parent_invite" */
  espin_parent_invite_stream: Array<Espin_Parent_Invite>;
  /** fetch data from the table: "espin.parent_profile" */
  espin_parent_profile: Array<Espin_Parent_Profile>;
  /** fetch aggregated fields from the table: "espin.parent_profile" */
  espin_parent_profile_aggregate: Espin_Parent_Profile_Aggregate;
  /** fetch data from the table: "espin.parent_profile" using primary key columns */
  espin_parent_profile_by_pk?: Maybe<Espin_Parent_Profile>;
  /** fetch data from the table in a streaming manner: "espin.parent_profile" */
  espin_parent_profile_stream: Array<Espin_Parent_Profile>;
  /** fetch data from the table: "espin.player_game" */
  espin_player_game: Array<Espin_Player_Game>;
  /** fetch aggregated fields from the table: "espin.player_game" */
  espin_player_game_aggregate: Espin_Player_Game_Aggregate;
  /** fetch data from the table: "espin.player_game" using primary key columns */
  espin_player_game_by_pk?: Maybe<Espin_Player_Game>;
  /** fetch data from the table in a streaming manner: "espin.player_game" */
  espin_player_game_stream: Array<Espin_Player_Game>;
  /** fetch data from the table: "espin.player_journey" */
  espin_player_journey: Array<Espin_Player_Journey>;
  /** fetch aggregated fields from the table: "espin.player_journey" */
  espin_player_journey_aggregate: Espin_Player_Journey_Aggregate;
  /** fetch data from the table: "espin.player_journey" using primary key columns */
  espin_player_journey_by_pk?: Maybe<Espin_Player_Journey>;
  /** fetch data from the table: "espin.player_journey_stage" */
  espin_player_journey_stage: Array<Espin_Player_Journey_Stage>;
  /** fetch aggregated fields from the table: "espin.player_journey_stage" */
  espin_player_journey_stage_aggregate: Espin_Player_Journey_Stage_Aggregate;
  /** fetch data from the table: "espin.player_journey_stage" using primary key columns */
  espin_player_journey_stage_by_pk?: Maybe<Espin_Player_Journey_Stage>;
  /** fetch data from the table: "espin.player_journey_stage_college" */
  espin_player_journey_stage_college: Array<Espin_Player_Journey_Stage_College>;
  /** fetch aggregated fields from the table: "espin.player_journey_stage_college" */
  espin_player_journey_stage_college_aggregate: Espin_Player_Journey_Stage_College_Aggregate;
  /** fetch data from the table: "espin.player_journey_stage_college" using primary key columns */
  espin_player_journey_stage_college_by_pk?: Maybe<Espin_Player_Journey_Stage_College>;
  /** fetch data from the table in a streaming manner: "espin.player_journey_stage_college" */
  espin_player_journey_stage_college_stream: Array<Espin_Player_Journey_Stage_College>;
  /** fetch data from the table: "espin.player_journey_stage_def" */
  espin_player_journey_stage_def: Array<Espin_Player_Journey_Stage_Def>;
  /** fetch aggregated fields from the table: "espin.player_journey_stage_def" */
  espin_player_journey_stage_def_aggregate: Espin_Player_Journey_Stage_Def_Aggregate;
  /** fetch data from the table: "espin.player_journey_stage_def" using primary key columns */
  espin_player_journey_stage_def_by_pk?: Maybe<Espin_Player_Journey_Stage_Def>;
  /** fetch data from the table in a streaming manner: "espin.player_journey_stage_def" */
  espin_player_journey_stage_def_stream: Array<Espin_Player_Journey_Stage_Def>;
  /** fetch data from the table: "espin.player_journey_stage_image" */
  espin_player_journey_stage_image: Array<Espin_Player_Journey_Stage_Image>;
  /** fetch aggregated fields from the table: "espin.player_journey_stage_image" */
  espin_player_journey_stage_image_aggregate: Espin_Player_Journey_Stage_Image_Aggregate;
  /** fetch data from the table: "espin.player_journey_stage_image" using primary key columns */
  espin_player_journey_stage_image_by_pk?: Maybe<Espin_Player_Journey_Stage_Image>;
  /** fetch data from the table in a streaming manner: "espin.player_journey_stage_image" */
  espin_player_journey_stage_image_stream: Array<Espin_Player_Journey_Stage_Image>;
  /** fetch data from the table: "espin.player_journey_stage_quote" */
  espin_player_journey_stage_quote: Array<Espin_Player_Journey_Stage_Quote>;
  /** fetch aggregated fields from the table: "espin.player_journey_stage_quote" */
  espin_player_journey_stage_quote_aggregate: Espin_Player_Journey_Stage_Quote_Aggregate;
  /** fetch data from the table: "espin.player_journey_stage_quote" using primary key columns */
  espin_player_journey_stage_quote_by_pk?: Maybe<Espin_Player_Journey_Stage_Quote>;
  /** fetch data from the table in a streaming manner: "espin.player_journey_stage_quote" */
  espin_player_journey_stage_quote_stream: Array<Espin_Player_Journey_Stage_Quote>;
  /** fetch data from the table in a streaming manner: "espin.player_journey_stage" */
  espin_player_journey_stage_stream: Array<Espin_Player_Journey_Stage>;
  /** fetch data from the table: "espin.player_journey_stage_video" */
  espin_player_journey_stage_video: Array<Espin_Player_Journey_Stage_Video>;
  /** fetch aggregated fields from the table: "espin.player_journey_stage_video" */
  espin_player_journey_stage_video_aggregate: Espin_Player_Journey_Stage_Video_Aggregate;
  /** fetch data from the table: "espin.player_journey_stage_video" using primary key columns */
  espin_player_journey_stage_video_by_pk?: Maybe<Espin_Player_Journey_Stage_Video>;
  /** fetch data from the table in a streaming manner: "espin.player_journey_stage_video" */
  espin_player_journey_stage_video_stream: Array<Espin_Player_Journey_Stage_Video>;
  /** fetch data from the table in a streaming manner: "espin.player_journey" */
  espin_player_journey_stream: Array<Espin_Player_Journey>;
  /** fetch data from the table: "espin.player_profile" */
  espin_player_profile: Array<Espin_Player_Profile>;
  /** fetch aggregated fields from the table: "espin.player_profile" */
  espin_player_profile_aggregate: Espin_Player_Profile_Aggregate;
  /** fetch data from the table: "espin.player_profile" using primary key columns */
  espin_player_profile_by_pk?: Maybe<Espin_Player_Profile>;
  /** fetch data from the table in a streaming manner: "espin.player_profile" */
  espin_player_profile_stream: Array<Espin_Player_Profile>;
  /** fetch data from the table: "espin.player_subscription" */
  espin_player_subscription: Array<Espin_Player_Subscription>;
  /** fetch aggregated fields from the table: "espin.player_subscription" */
  espin_player_subscription_aggregate: Espin_Player_Subscription_Aggregate;
  /** fetch data from the table: "espin.player_subscription" using primary key columns */
  espin_player_subscription_by_pk?: Maybe<Espin_Player_Subscription>;
  /** fetch data from the table in a streaming manner: "espin.player_subscription" */
  espin_player_subscription_stream: Array<Espin_Player_Subscription>;
  /** fetch data from the table: "espin.player_vod" */
  espin_player_vod: Array<Espin_Player_Vod>;
  /** fetch aggregated fields from the table: "espin.player_vod" */
  espin_player_vod_aggregate: Espin_Player_Vod_Aggregate;
  /** fetch data from the table: "espin.player_vod" using primary key columns */
  espin_player_vod_by_pk?: Maybe<Espin_Player_Vod>;
  /** fetch data from the table in a streaming manner: "espin.player_vod" */
  espin_player_vod_stream: Array<Espin_Player_Vod>;
  /** fetch data from the table: "espin.profile_view" */
  espin_profile_view: Array<Espin_Profile_View>;
  /** fetch aggregated fields from the table: "espin.profile_view" */
  espin_profile_view_aggregate: Espin_Profile_View_Aggregate;
  /** fetch data from the table: "espin.profile_view" using primary key columns */
  espin_profile_view_by_pk?: Maybe<Espin_Profile_View>;
  /** fetch data from the table: "espin.profile_view_email_notification_type" */
  espin_profile_view_email_notification_type: Array<Espin_Profile_View_Email_Notification_Type>;
  /** fetch aggregated fields from the table: "espin.profile_view_email_notification_type" */
  espin_profile_view_email_notification_type_aggregate: Espin_Profile_View_Email_Notification_Type_Aggregate;
  /** fetch data from the table: "espin.profile_view_email_notification_type" using primary key columns */
  espin_profile_view_email_notification_type_by_pk?: Maybe<Espin_Profile_View_Email_Notification_Type>;
  /** fetch data from the table in a streaming manner: "espin.profile_view_email_notification_type" */
  espin_profile_view_email_notification_type_stream: Array<Espin_Profile_View_Email_Notification_Type>;
  /** fetch data from the table in a streaming manner: "espin.profile_view" */
  espin_profile_view_stream: Array<Espin_Profile_View>;
  /** fetch data from the table: "espin.profile_view_type" */
  espin_profile_view_type: Array<Espin_Profile_View_Type>;
  /** fetch aggregated fields from the table: "espin.profile_view_type" */
  espin_profile_view_type_aggregate: Espin_Profile_View_Type_Aggregate;
  /** fetch data from the table: "espin.profile_view_type" using primary key columns */
  espin_profile_view_type_by_pk?: Maybe<Espin_Profile_View_Type>;
  /** fetch data from the table in a streaming manner: "espin.profile_view_type" */
  espin_profile_view_type_stream: Array<Espin_Profile_View_Type>;
  /** fetch data from the table: "espin.referral_code" */
  espin_referral_code: Array<Espin_Referral_Code>;
  /** fetch aggregated fields from the table: "espin.referral_code" */
  espin_referral_code_aggregate: Espin_Referral_Code_Aggregate;
  /** fetch data from the table: "espin.referral_code" using primary key columns */
  espin_referral_code_by_pk?: Maybe<Espin_Referral_Code>;
  /** fetch data from the table: "espin.referral_code_redemption" */
  espin_referral_code_redemption: Array<Espin_Referral_Code_Redemption>;
  /** fetch aggregated fields from the table: "espin.referral_code_redemption" */
  espin_referral_code_redemption_aggregate: Espin_Referral_Code_Redemption_Aggregate;
  /** fetch data from the table: "espin.referral_code_redemption" using primary key columns */
  espin_referral_code_redemption_by_pk?: Maybe<Espin_Referral_Code_Redemption>;
  /** fetch data from the table in a streaming manner: "espin.referral_code_redemption" */
  espin_referral_code_redemption_stream: Array<Espin_Referral_Code_Redemption>;
  /** fetch data from the table in a streaming manner: "espin.referral_code" */
  espin_referral_code_stream: Array<Espin_Referral_Code>;
  /** fetch data from the table: "espin.referral_option" */
  espin_referral_option: Array<Espin_Referral_Option>;
  /** fetch aggregated fields from the table: "espin.referral_option" */
  espin_referral_option_aggregate: Espin_Referral_Option_Aggregate;
  /** fetch data from the table: "espin.referral_option" using primary key columns */
  espin_referral_option_by_pk?: Maybe<Espin_Referral_Option>;
  /** fetch data from the table in a streaming manner: "espin.referral_option" */
  espin_referral_option_stream: Array<Espin_Referral_Option>;
  /** fetch data from the table: "espin.role" */
  espin_role: Array<Espin_Role>;
  /** fetch aggregated fields from the table: "espin.role" */
  espin_role_aggregate: Espin_Role_Aggregate;
  /** fetch data from the table: "espin.role" using primary key columns */
  espin_role_by_pk?: Maybe<Espin_Role>;
  /** fetch data from the table in a streaming manner: "espin.role" */
  espin_role_stream: Array<Espin_Role>;
  /** fetch data from the table: "espin.site_content" */
  espin_site_content: Array<Espin_Site_Content>;
  /** fetch aggregated fields from the table: "espin.site_content" */
  espin_site_content_aggregate: Espin_Site_Content_Aggregate;
  /** fetch data from the table: "espin.site_content" using primary key columns */
  espin_site_content_by_pk?: Maybe<Espin_Site_Content>;
  /** fetch data from the table in a streaming manner: "espin.site_content" */
  espin_site_content_stream: Array<Espin_Site_Content>;
  /** fetch data from the table: "espin.social" */
  espin_social: Array<Espin_Social>;
  /** fetch aggregated fields from the table: "espin.social" */
  espin_social_aggregate: Espin_Social_Aggregate;
  /** fetch data from the table: "espin.social" using primary key columns */
  espin_social_by_pk?: Maybe<Espin_Social>;
  /** fetch data from the table in a streaming manner: "espin.social" */
  espin_social_stream: Array<Espin_Social>;
  /** fetch data from the table: "espin.stickied_college" */
  espin_stickied_college: Array<Espin_Stickied_College>;
  /** fetch aggregated fields from the table: "espin.stickied_college" */
  espin_stickied_college_aggregate: Espin_Stickied_College_Aggregate;
  /** fetch data from the table: "espin.stickied_college" using primary key columns */
  espin_stickied_college_by_pk?: Maybe<Espin_Stickied_College>;
  /** fetch data from the table in a streaming manner: "espin.stickied_college" */
  espin_stickied_college_stream: Array<Espin_Stickied_College>;
  /** fetch data from the table: "espin.stickied_player" */
  espin_stickied_player: Array<Espin_Stickied_Player>;
  /** fetch aggregated fields from the table: "espin.stickied_player" */
  espin_stickied_player_aggregate: Espin_Stickied_Player_Aggregate;
  /** fetch data from the table: "espin.stickied_player" using primary key columns */
  espin_stickied_player_by_pk?: Maybe<Espin_Stickied_Player>;
  /** fetch data from the table in a streaming manner: "espin.stickied_player" */
  espin_stickied_player_stream: Array<Espin_Stickied_Player>;
  /** fetch data from the table: "espin.study_field" */
  espin_study_field: Array<Espin_Study_Field>;
  /** fetch aggregated fields from the table: "espin.study_field" */
  espin_study_field_aggregate: Espin_Study_Field_Aggregate;
  /** fetch data from the table: "espin.study_field" using primary key columns */
  espin_study_field_by_pk?: Maybe<Espin_Study_Field>;
  /** fetch data from the table in a streaming manner: "espin.study_field" */
  espin_study_field_stream: Array<Espin_Study_Field>;
  /** fetch data from the table: "espin.study_subject" */
  espin_study_subject: Array<Espin_Study_Subject>;
  /** fetch aggregated fields from the table: "espin.study_subject" */
  espin_study_subject_aggregate: Espin_Study_Subject_Aggregate;
  /** fetch data from the table: "espin.study_subject" using primary key columns */
  espin_study_subject_by_pk?: Maybe<Espin_Study_Subject>;
  /** fetch data from the table in a streaming manner: "espin.study_subject" */
  espin_study_subject_stream: Array<Espin_Study_Subject>;
  /** fetch data from the table: "espin.subscription_status" */
  espin_subscription_status: Array<Espin_Subscription_Status>;
  /** fetch aggregated fields from the table: "espin.subscription_status" */
  espin_subscription_status_aggregate: Espin_Subscription_Status_Aggregate;
  /** fetch data from the table: "espin.subscription_status" using primary key columns */
  espin_subscription_status_by_pk?: Maybe<Espin_Subscription_Status>;
  /** fetch data from the table in a streaming manner: "espin.subscription_status" */
  espin_subscription_status_stream: Array<Espin_Subscription_Status>;
  /** fetch data from the table: "espin.subscription_tier_type" */
  espin_subscription_tier_type: Array<Espin_Subscription_Tier_Type>;
  /** fetch aggregated fields from the table: "espin.subscription_tier_type" */
  espin_subscription_tier_type_aggregate: Espin_Subscription_Tier_Type_Aggregate;
  /** fetch data from the table: "espin.subscription_tier_type" using primary key columns */
  espin_subscription_tier_type_by_pk?: Maybe<Espin_Subscription_Tier_Type>;
  /** fetch data from the table in a streaming manner: "espin.subscription_tier_type" */
  espin_subscription_tier_type_stream: Array<Espin_Subscription_Tier_Type>;
  /** fetch data from the table: "espin.team" */
  espin_team: Array<Espin_Team>;
  /** fetch aggregated fields from the table: "espin.team" */
  espin_team_aggregate: Espin_Team_Aggregate;
  /** fetch data from the table: "espin.team" using primary key columns */
  espin_team_by_pk?: Maybe<Espin_Team>;
  /** fetch data from the table: "espin.team_invite" */
  espin_team_invite: Array<Espin_Team_Invite>;
  /** fetch aggregated fields from the table: "espin.team_invite" */
  espin_team_invite_aggregate: Espin_Team_Invite_Aggregate;
  /** fetch data from the table: "espin.team_invite" using primary key columns */
  espin_team_invite_by_pk?: Maybe<Espin_Team_Invite>;
  /** fetch data from the table in a streaming manner: "espin.team_invite" */
  espin_team_invite_stream: Array<Espin_Team_Invite>;
  /** fetch data from the table: "espin.team_members" */
  espin_team_members: Array<Espin_Team_Members>;
  /** fetch aggregated fields from the table: "espin.team_members" */
  espin_team_members_aggregate: Espin_Team_Members_Aggregate;
  /** fetch data from the table: "espin.team_members" using primary key columns */
  espin_team_members_by_pk?: Maybe<Espin_Team_Members>;
  /** fetch data from the table in a streaming manner: "espin.team_members" */
  espin_team_members_stream: Array<Espin_Team_Members>;
  /** fetch data from the table: "espin.team_role" */
  espin_team_role: Array<Espin_Team_Role>;
  /** fetch aggregated fields from the table: "espin.team_role" */
  espin_team_role_aggregate: Espin_Team_Role_Aggregate;
  /** fetch data from the table: "espin.team_role" using primary key columns */
  espin_team_role_by_pk?: Maybe<Espin_Team_Role>;
  /** fetch data from the table in a streaming manner: "espin.team_role" */
  espin_team_role_stream: Array<Espin_Team_Role>;
  /** fetch data from the table in a streaming manner: "espin.team" */
  espin_team_stream: Array<Espin_Team>;
  /** fetch data from the table: "espin.team_type" */
  espin_team_type: Array<Espin_Team_Type>;
  /** fetch aggregated fields from the table: "espin.team_type" */
  espin_team_type_aggregate: Espin_Team_Type_Aggregate;
  /** fetch data from the table: "espin.team_type" using primary key columns */
  espin_team_type_by_pk?: Maybe<Espin_Team_Type>;
  /** fetch data from the table in a streaming manner: "espin.team_type" */
  espin_team_type_stream: Array<Espin_Team_Type>;
  /** fetch data from the table: "espin.unregistered_college" */
  espin_unregistered_college: Array<Espin_Unregistered_College>;
  /** fetch aggregated fields from the table: "espin.unregistered_college" */
  espin_unregistered_college_aggregate: Espin_Unregistered_College_Aggregate;
  /** fetch data from the table: "espin.unregistered_college" using primary key columns */
  espin_unregistered_college_by_pk?: Maybe<Espin_Unregistered_College>;
  /** fetch data from the table in a streaming manner: "espin.unregistered_college" */
  espin_unregistered_college_stream: Array<Espin_Unregistered_College>;
  /** fetch data from the table: "espin.user" */
  espin_user: Array<Espin_User>;
  /** fetch aggregated fields from the table: "espin.user" */
  espin_user_aggregate: Espin_User_Aggregate;
  /** fetch data from the table: "espin.user" using primary key columns */
  espin_user_by_pk?: Maybe<Espin_User>;
  /** fetch data from the table: "espin.user_linked_external_provider" */
  espin_user_linked_external_provider: Array<Espin_User_Linked_External_Provider>;
  /** fetch aggregated fields from the table: "espin.user_linked_external_provider" */
  espin_user_linked_external_provider_aggregate: Espin_User_Linked_External_Provider_Aggregate;
  /** fetch data from the table: "espin.user_linked_external_provider" using primary key columns */
  espin_user_linked_external_provider_by_pk?: Maybe<Espin_User_Linked_External_Provider>;
  /** fetch data from the table in a streaming manner: "espin.user_linked_external_provider" */
  espin_user_linked_external_provider_stream: Array<Espin_User_Linked_External_Provider>;
  /** fetch data from the table: "espin.user_membership" */
  espin_user_membership: Array<Espin_User_Membership>;
  /** fetch aggregated fields from the table: "espin.user_membership" */
  espin_user_membership_aggregate: Espin_User_Membership_Aggregate;
  /** fetch data from the table: "espin.user_membership" using primary key columns */
  espin_user_membership_by_pk?: Maybe<Espin_User_Membership>;
  /** fetch data from the table in a streaming manner: "espin.user_membership" */
  espin_user_membership_stream: Array<Espin_User_Membership>;
  /** fetch data from the table: "espin.user_source" */
  espin_user_source: Array<Espin_User_Source>;
  /** fetch aggregated fields from the table: "espin.user_source" */
  espin_user_source_aggregate: Espin_User_Source_Aggregate;
  /** fetch data from the table: "espin.user_source" using primary key columns */
  espin_user_source_by_pk?: Maybe<Espin_User_Source>;
  /** fetch data from the table in a streaming manner: "espin.user_source" */
  espin_user_source_stream: Array<Espin_User_Source>;
  /** fetch data from the table in a streaming manner: "espin.user" */
  espin_user_stream: Array<Espin_User>;
  /** fetch data from the table: "espin.user_subscription_status" */
  espin_user_subscription_status: Array<Espin_User_Subscription_Status>;
  /** fetch aggregated fields from the table: "espin.user_subscription_status" */
  espin_user_subscription_status_aggregate: Espin_User_Subscription_Status_Aggregate;
  /** fetch data from the table in a streaming manner: "espin.user_subscription_status" */
  espin_user_subscription_status_stream: Array<Espin_User_Subscription_Status>;
  /** fetch data from the table: "queue.job" */
  queue_job: Array<Queue_Job>;
  /** fetch aggregated fields from the table: "queue.job" */
  queue_job_aggregate: Queue_Job_Aggregate;
  /** fetch data from the table: "queue.job" using primary key columns */
  queue_job_by_pk?: Maybe<Queue_Job>;
  /** fetch data from the table: "queue.job_status_type" */
  queue_job_status_type: Array<Queue_Job_Status_Type>;
  /** fetch aggregated fields from the table: "queue.job_status_type" */
  queue_job_status_type_aggregate: Queue_Job_Status_Type_Aggregate;
  /** fetch data from the table: "queue.job_status_type" using primary key columns */
  queue_job_status_type_by_pk?: Maybe<Queue_Job_Status_Type>;
  /** fetch data from the table in a streaming manner: "queue.job_status_type" */
  queue_job_status_type_stream: Array<Queue_Job_Status_Type>;
  /** fetch data from the table in a streaming manner: "queue.job" */
  queue_job_stream: Array<Queue_Job>;
  /** fetch data from the table: "queue.job_type" */
  queue_job_type: Array<Queue_Job_Type>;
  /** fetch aggregated fields from the table: "queue.job_type" */
  queue_job_type_aggregate: Queue_Job_Type_Aggregate;
  /** fetch data from the table: "queue.job_type" using primary key columns */
  queue_job_type_by_pk?: Maybe<Queue_Job_Type>;
  /** fetch data from the table in a streaming manner: "queue.job_type" */
  queue_job_type_stream: Array<Queue_Job_Type>;
  /** fetch data from the table: "stripe.customer_data" */
  stripe_customer_data: Array<Stripe_Customer_Data>;
  /** fetch aggregated fields from the table: "stripe.customer_data" */
  stripe_customer_data_aggregate: Stripe_Customer_Data_Aggregate;
  /** fetch data from the table: "stripe.customer_data" using primary key columns */
  stripe_customer_data_by_pk?: Maybe<Stripe_Customer_Data>;
  /** fetch data from the table in a streaming manner: "stripe.customer_data" */
  stripe_customer_data_stream: Array<Stripe_Customer_Data>;
  /** fetch data from the table: "stripe.invoice_data" */
  stripe_invoice_data: Array<Stripe_Invoice_Data>;
  /** fetch aggregated fields from the table: "stripe.invoice_data" */
  stripe_invoice_data_aggregate: Stripe_Invoice_Data_Aggregate;
  /** fetch data from the table: "stripe.invoice_data" using primary key columns */
  stripe_invoice_data_by_pk?: Maybe<Stripe_Invoice_Data>;
  /** fetch data from the table in a streaming manner: "stripe.invoice_data" */
  stripe_invoice_data_stream: Array<Stripe_Invoice_Data>;
  /** fetch data from the table: "stripe.stripe_payment_data" */
  stripe_stripe_payment_data: Array<Stripe_Stripe_Payment_Data>;
  /** fetch aggregated fields from the table: "stripe.stripe_payment_data" */
  stripe_stripe_payment_data_aggregate: Stripe_Stripe_Payment_Data_Aggregate;
  /** fetch data from the table: "stripe.stripe_payment_data" using primary key columns */
  stripe_stripe_payment_data_by_pk?: Maybe<Stripe_Stripe_Payment_Data>;
  /** fetch data from the table in a streaming manner: "stripe.stripe_payment_data" */
  stripe_stripe_payment_data_stream: Array<Stripe_Stripe_Payment_Data>;
  /** fetch data from the table: "stripe.stripe_subscription_data" */
  stripe_stripe_subscription_data: Array<Stripe_Stripe_Subscription_Data>;
  /** fetch aggregated fields from the table: "stripe.stripe_subscription_data" */
  stripe_stripe_subscription_data_aggregate: Stripe_Stripe_Subscription_Data_Aggregate;
  /** fetch data from the table: "stripe.stripe_subscription_data" using primary key columns */
  stripe_stripe_subscription_data_by_pk?: Maybe<Stripe_Stripe_Subscription_Data>;
  /** fetch data from the table in a streaming manner: "stripe.stripe_subscription_data" */
  stripe_stripe_subscription_data_stream: Array<Stripe_Stripe_Subscription_Data>;
  /** fetch data from the table: "tempstorage.keyvalue" */
  tempstorage_keyvalue: Array<Tempstorage_Keyvalue>;
  /** fetch aggregated fields from the table: "tempstorage.keyvalue" */
  tempstorage_keyvalue_aggregate: Tempstorage_Keyvalue_Aggregate;
  /** fetch data from the table: "tempstorage.keyvalue" using primary key columns */
  tempstorage_keyvalue_by_pk?: Maybe<Tempstorage_Keyvalue>;
  /** fetch data from the table in a streaming manner: "tempstorage.keyvalue" */
  tempstorage_keyvalue_stream: Array<Tempstorage_Keyvalue>;
};


export type Subscription_RootCehsite_Ms_Available_Site_TermsArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Available_Site_Terms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Available_Site_Terms_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Bool_Exp>;
};


export type Subscription_RootCehsite_Ms_Available_Site_Terms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Available_Site_Terms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Available_Site_Terms_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Bool_Exp>;
};


export type Subscription_RootCehsite_Ms_Available_Site_Terms_By_PkArgs = {
  key: Scalars['String'];
};


export type Subscription_RootCehsite_Ms_Available_Site_Terms_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cehsite_Ms_Available_Site_Terms_Stream_Cursor_Input>>;
  where?: InputMaybe<Cehsite_Ms_Available_Site_Terms_Bool_Exp>;
};


export type Subscription_RootCehsite_Ms_Contact_Form_EntryArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Contact_Form_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Contact_Form_Entry_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Contact_Form_Entry_Bool_Exp>;
};


export type Subscription_RootCehsite_Ms_Contact_Form_Entry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Contact_Form_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Contact_Form_Entry_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Contact_Form_Entry_Bool_Exp>;
};


export type Subscription_RootCehsite_Ms_Contact_Form_Entry_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCehsite_Ms_Contact_Form_Entry_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cehsite_Ms_Contact_Form_Entry_Stream_Cursor_Input>>;
  where?: InputMaybe<Cehsite_Ms_Contact_Form_Entry_Bool_Exp>;
};


export type Subscription_RootCehsite_Ms_Newsletter_SignupArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Newsletter_Signup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Newsletter_Signup_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Newsletter_Signup_Bool_Exp>;
};


export type Subscription_RootCehsite_Ms_Newsletter_Signup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Newsletter_Signup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Newsletter_Signup_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Newsletter_Signup_Bool_Exp>;
};


export type Subscription_RootCehsite_Ms_Newsletter_Signup_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCehsite_Ms_Newsletter_Signup_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cehsite_Ms_Newsletter_Signup_Stream_Cursor_Input>>;
  where?: InputMaybe<Cehsite_Ms_Newsletter_Signup_Bool_Exp>;
};


export type Subscription_RootCehsite_Ms_Site_ContentArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Site_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Site_Content_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Site_Content_Bool_Exp>;
};


export type Subscription_RootCehsite_Ms_Site_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cehsite_Ms_Site_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cehsite_Ms_Site_Content_Order_By>>;
  where?: InputMaybe<Cehsite_Ms_Site_Content_Bool_Exp>;
};


export type Subscription_RootCehsite_Ms_Site_Content_By_PkArgs = {
  key: Cehsite_Ms_Available_Site_Terms_Enum;
};


export type Subscription_RootCehsite_Ms_Site_Content_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cehsite_Ms_Site_Content_Stream_Cursor_Input>>;
  where?: InputMaybe<Cehsite_Ms_Site_Content_Bool_Exp>;
};


export type Subscription_RootContent_FileArgs = {
  distinct_on?: InputMaybe<Array<Content_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_File_Order_By>>;
  where?: InputMaybe<Content_File_Bool_Exp>;
};


export type Subscription_RootContent_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_File_Order_By>>;
  where?: InputMaybe<Content_File_Bool_Exp>;
};


export type Subscription_RootContent_File_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootContent_File_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Content_File_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_File_Metadata_Order_By>>;
  where?: InputMaybe<Content_File_Metadata_Bool_Exp>;
};


export type Subscription_RootContent_File_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_File_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_File_Metadata_Order_By>>;
  where?: InputMaybe<Content_File_Metadata_Bool_Exp>;
};


export type Subscription_RootContent_File_Metadata_By_PkArgs = {
  file_id: Scalars['uuid'];
};


export type Subscription_RootContent_File_Metadata_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Content_File_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Content_File_Metadata_Bool_Exp>;
};


export type Subscription_RootContent_File_StatusArgs = {
  distinct_on?: InputMaybe<Array<Content_File_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_File_Status_Order_By>>;
  where?: InputMaybe<Content_File_Status_Bool_Exp>;
};


export type Subscription_RootContent_File_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_File_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_File_Status_Order_By>>;
  where?: InputMaybe<Content_File_Status_Bool_Exp>;
};


export type Subscription_RootContent_File_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootContent_File_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Content_File_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Content_File_Status_Bool_Exp>;
};


export type Subscription_RootContent_File_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Content_File_Stream_Cursor_Input>>;
  where?: InputMaybe<Content_File_Bool_Exp>;
};


export type Subscription_RootContent_Media_LinkArgs = {
  distinct_on?: InputMaybe<Array<Content_Media_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Media_Link_Order_By>>;
  where?: InputMaybe<Content_Media_Link_Bool_Exp>;
};


export type Subscription_RootContent_Media_Link_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_Media_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Media_Link_Order_By>>;
  where?: InputMaybe<Content_Media_Link_Bool_Exp>;
};


export type Subscription_RootContent_Media_Link_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootContent_Media_Link_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Content_Media_Link_Stream_Cursor_Input>>;
  where?: InputMaybe<Content_Media_Link_Bool_Exp>;
};


export type Subscription_RootContent_Media_Link_TypeArgs = {
  distinct_on?: InputMaybe<Array<Content_Media_Link_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Media_Link_Type_Order_By>>;
  where?: InputMaybe<Content_Media_Link_Type_Bool_Exp>;
};


export type Subscription_RootContent_Media_Link_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_Media_Link_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Media_Link_Type_Order_By>>;
  where?: InputMaybe<Content_Media_Link_Type_Bool_Exp>;
};


export type Subscription_RootContent_Media_Link_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootContent_Media_Link_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Content_Media_Link_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Content_Media_Link_Type_Bool_Exp>;
};


export type Subscription_RootContent_Project_NameArgs = {
  distinct_on?: InputMaybe<Array<Content_Project_Name_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Project_Name_Order_By>>;
  where?: InputMaybe<Content_Project_Name_Bool_Exp>;
};


export type Subscription_RootContent_Project_Name_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_Project_Name_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Project_Name_Order_By>>;
  where?: InputMaybe<Content_Project_Name_Bool_Exp>;
};


export type Subscription_RootContent_Project_Name_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootContent_Project_Name_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Content_Project_Name_Stream_Cursor_Input>>;
  where?: InputMaybe<Content_Project_Name_Bool_Exp>;
};


export type Subscription_RootContent_StatusArgs = {
  distinct_on?: InputMaybe<Array<Content_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Status_Order_By>>;
  where?: InputMaybe<Content_Status_Bool_Exp>;
};


export type Subscription_RootContent_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Status_Order_By>>;
  where?: InputMaybe<Content_Status_Bool_Exp>;
};


export type Subscription_RootContent_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootContent_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Content_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Content_Status_Bool_Exp>;
};


export type Subscription_RootEspin_AddressArgs = {
  distinct_on?: InputMaybe<Array<Espin_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Address_Order_By>>;
  where?: InputMaybe<Espin_Address_Bool_Exp>;
};


export type Subscription_RootEspin_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Address_Order_By>>;
  where?: InputMaybe<Espin_Address_Bool_Exp>;
};


export type Subscription_RootEspin_Address_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Address_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Address_Bool_Exp>;
};


export type Subscription_RootEspin_Boolean_Feature_FlagArgs = {
  distinct_on?: InputMaybe<Array<Espin_Boolean_Feature_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Boolean_Feature_Flag_Order_By>>;
  where?: InputMaybe<Espin_Boolean_Feature_Flag_Bool_Exp>;
};


export type Subscription_RootEspin_Boolean_Feature_Flag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Boolean_Feature_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Boolean_Feature_Flag_Order_By>>;
  where?: InputMaybe<Espin_Boolean_Feature_Flag_Bool_Exp>;
};


export type Subscription_RootEspin_Boolean_Feature_Flag_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Boolean_Feature_Flag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Boolean_Feature_Flag_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Boolean_Feature_Flag_Bool_Exp>;
};


export type Subscription_RootEspin_Coach_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Espin_Coach_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Coach_Profile_Order_By>>;
  where?: InputMaybe<Espin_Coach_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_Coach_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Coach_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Coach_Profile_Order_By>>;
  where?: InputMaybe<Espin_Coach_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_Coach_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Coach_Profile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Coach_Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Coach_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_CollegeArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Order_By>>;
  where?: InputMaybe<Espin_College_Bool_Exp>;
};


export type Subscription_RootEspin_College_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Order_By>>;
  where?: InputMaybe<Espin_College_Bool_Exp>;
};


export type Subscription_RootEspin_College_Automatic_Message_Response_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Automatic_Message_Response_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Automatic_Message_Response_Type_Order_By>>;
  where?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Bool_Exp>;
};


export type Subscription_RootEspin_College_Automatic_Message_Response_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Automatic_Message_Response_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Automatic_Message_Response_Type_Order_By>>;
  where?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Bool_Exp>;
};


export type Subscription_RootEspin_College_Automatic_Message_Response_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_College_Automatic_Message_Response_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_College_Automatic_Message_Response_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_College_Automatic_Message_Response_Type_Bool_Exp>;
};


export type Subscription_RootEspin_College_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_College_GameArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Game_Order_By>>;
  where?: InputMaybe<Espin_College_Game_Bool_Exp>;
};


export type Subscription_RootEspin_College_Game_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Game_Order_By>>;
  where?: InputMaybe<Espin_College_Game_Bool_Exp>;
};


export type Subscription_RootEspin_College_Game_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_College_Game_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_College_Game_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_College_Game_Bool_Exp>;
};


export type Subscription_RootEspin_College_ImageArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Image_Order_By>>;
  where?: InputMaybe<Espin_College_Image_Bool_Exp>;
};


export type Subscription_RootEspin_College_Image_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Image_Order_By>>;
  where?: InputMaybe<Espin_College_Image_Bool_Exp>;
};


export type Subscription_RootEspin_College_Image_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_College_Image_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_College_Image_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_College_Image_Bool_Exp>;
};


export type Subscription_RootEspin_College_InviteArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Invite_Order_By>>;
  where?: InputMaybe<Espin_College_Invite_Bool_Exp>;
};


export type Subscription_RootEspin_College_Invite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Invite_Order_By>>;
  where?: InputMaybe<Espin_College_Invite_Bool_Exp>;
};


export type Subscription_RootEspin_College_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_College_Invite_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_College_Invite_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_College_Invite_Bool_Exp>;
};


export type Subscription_RootEspin_College_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Preferences_Order_By>>;
  where?: InputMaybe<Espin_College_Preferences_Bool_Exp>;
};


export type Subscription_RootEspin_College_Preferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Preferences_Order_By>>;
  where?: InputMaybe<Espin_College_Preferences_Bool_Exp>;
};


export type Subscription_RootEspin_College_Preferences_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_College_Preferences_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_College_Preferences_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_College_Preferences_Bool_Exp>;
};


export type Subscription_RootEspin_College_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Profile_Order_By>>;
  where?: InputMaybe<Espin_College_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_College_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Profile_Order_By>>;
  where?: InputMaybe<Espin_College_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_College_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_College_Profile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_College_Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_College_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_College_RosterArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Roster_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Roster_Order_By>>;
  where?: InputMaybe<Espin_College_Roster_Bool_Exp>;
};


export type Subscription_RootEspin_College_Roster_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Roster_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Roster_Order_By>>;
  where?: InputMaybe<Espin_College_Roster_Bool_Exp>;
};


export type Subscription_RootEspin_College_Roster_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_College_Roster_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_College_Roster_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_College_Roster_Bool_Exp>;
};


export type Subscription_RootEspin_College_Staff_MemberArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Staff_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Staff_Member_Order_By>>;
  where?: InputMaybe<Espin_College_Staff_Member_Bool_Exp>;
};


export type Subscription_RootEspin_College_Staff_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Staff_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Staff_Member_Order_By>>;
  where?: InputMaybe<Espin_College_Staff_Member_Bool_Exp>;
};


export type Subscription_RootEspin_College_Staff_Member_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_College_Staff_Member_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_College_Staff_Member_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_College_Staff_Member_Bool_Exp>;
};


export type Subscription_RootEspin_College_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_College_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_College_Bool_Exp>;
};


export type Subscription_RootEspin_College_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Subscription_Order_By>>;
  where?: InputMaybe<Espin_College_Subscription_Bool_Exp>;
};


export type Subscription_RootEspin_College_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Subscription_Order_By>>;
  where?: InputMaybe<Espin_College_Subscription_Bool_Exp>;
};


export type Subscription_RootEspin_College_Subscription_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_College_Subscription_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_College_Subscription_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_College_Subscription_Bool_Exp>;
};


export type Subscription_RootEspin_College_Verification_Status_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Verification_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Verification_Status_Type_Order_By>>;
  where?: InputMaybe<Espin_College_Verification_Status_Type_Bool_Exp>;
};


export type Subscription_RootEspin_College_Verification_Status_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_College_Verification_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_College_Verification_Status_Type_Order_By>>;
  where?: InputMaybe<Espin_College_Verification_Status_Type_Bool_Exp>;
};


export type Subscription_RootEspin_College_Verification_Status_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_College_Verification_Status_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_College_Verification_Status_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_College_Verification_Status_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Draft_Player_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Espin_Draft_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Draft_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Draft_Player_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_Draft_Player_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Draft_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Draft_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Draft_Player_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_Draft_Player_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Draft_Player_Profile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Draft_Player_Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Draft_Player_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_Editable_Site_ContentArgs = {
  distinct_on?: InputMaybe<Array<Espin_Editable_Site_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Editable_Site_Content_Order_By>>;
  where?: InputMaybe<Espin_Editable_Site_Content_Bool_Exp>;
};


export type Subscription_RootEspin_Editable_Site_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Editable_Site_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Editable_Site_Content_Order_By>>;
  where?: InputMaybe<Espin_Editable_Site_Content_Bool_Exp>;
};


export type Subscription_RootEspin_Editable_Site_Content_By_PkArgs = {
  key: Scalars['String'];
};


export type Subscription_RootEspin_Editable_Site_Content_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Editable_Site_Content_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Editable_Site_Content_Bool_Exp>;
};


export type Subscription_RootEspin_Ethnicity_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Ethnicity_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Ethnicity_Options_Order_By>>;
  where?: InputMaybe<Espin_Ethnicity_Options_Bool_Exp>;
};


export type Subscription_RootEspin_Ethnicity_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Ethnicity_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Ethnicity_Options_Order_By>>;
  where?: InputMaybe<Espin_Ethnicity_Options_Bool_Exp>;
};


export type Subscription_RootEspin_Ethnicity_Options_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Ethnicity_Options_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Ethnicity_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Ethnicity_Options_Bool_Exp>;
};


export type Subscription_RootEspin_EventArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Order_By>>;
  where?: InputMaybe<Espin_Event_Bool_Exp>;
};


export type Subscription_RootEspin_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Order_By>>;
  where?: InputMaybe<Espin_Event_Bool_Exp>;
};


export type Subscription_RootEspin_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Event_Custom_FieldArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Custom_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Custom_Field_Order_By>>;
  where?: InputMaybe<Espin_Event_Custom_Field_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Custom_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Custom_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Custom_Field_Order_By>>;
  where?: InputMaybe<Espin_Event_Custom_Field_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Custom_Field_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Event_Custom_Field_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Event_Custom_Field_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Event_Custom_Field_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Custom_Field_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Custom_Field_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Custom_Field_Type_Order_By>>;
  where?: InputMaybe<Espin_Event_Custom_Field_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Custom_Field_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Custom_Field_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Custom_Field_Type_Order_By>>;
  where?: InputMaybe<Espin_Event_Custom_Field_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Custom_Field_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Event_Custom_Field_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Event_Custom_Field_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Event_Custom_Field_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Event_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Document_Order_By>>;
  where?: InputMaybe<Espin_Event_Document_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Document_Order_By>>;
  where?: InputMaybe<Espin_Event_Document_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Document_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Event_Document_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Event_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Event_Document_Bool_Exp>;
};


export type Subscription_RootEspin_Event_GameArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Game_Order_By>>;
  where?: InputMaybe<Espin_Event_Game_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Game_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Game_Order_By>>;
  where?: InputMaybe<Espin_Event_Game_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Game_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Event_Game_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Event_Game_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Event_Game_Bool_Exp>;
};


export type Subscription_RootEspin_Event_RegistrationArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Registration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Registration_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Event_Registration_Custom_Field_EntryArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Registration_Custom_Field_Entry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Custom_Field_Entry_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Registration_Custom_Field_Entry_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Event_Registration_Custom_Field_Entry_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Event_Registration_Custom_Field_Entry_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Registration_Document_SignoffArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Document_Signoff_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Registration_Document_Signoff_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Document_Signoff_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Document_Signoff_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Registration_Document_Signoff_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Event_Registration_Document_Signoff_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Event_Registration_Document_Signoff_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Event_Registration_Document_Signoff_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Registration_StatusArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Status_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Status_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Registration_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Registration_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Registration_Status_Order_By>>;
  where?: InputMaybe<Espin_Event_Registration_Status_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Registration_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Event_Registration_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Event_Registration_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Event_Registration_Status_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Registration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Event_Registration_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Event_Registration_Bool_Exp>;
};


export type Subscription_RootEspin_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Event_Bool_Exp>;
};


export type Subscription_RootEspin_Event_TicketArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Ticket_Order_By>>;
  where?: InputMaybe<Espin_Event_Ticket_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Ticket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Ticket_Order_By>>;
  where?: InputMaybe<Espin_Event_Ticket_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Ticket_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Event_Ticket_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Event_Ticket_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Event_Ticket_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Ticket_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Ticket_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Ticket_Type_Order_By>>;
  where?: InputMaybe<Espin_Event_Ticket_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Ticket_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Ticket_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Ticket_Type_Order_By>>;
  where?: InputMaybe<Espin_Event_Ticket_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Ticket_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Event_Ticket_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Event_Ticket_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Event_Ticket_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Type_Order_By>>;
  where?: InputMaybe<Espin_Event_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Event_Type_Order_By>>;
  where?: InputMaybe<Espin_Event_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Event_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Event_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Event_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Event_Type_Bool_Exp>;
};


export type Subscription_RootEspin_External_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Espin_External_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_External_Provider_Order_By>>;
  where?: InputMaybe<Espin_External_Provider_Bool_Exp>;
};


export type Subscription_RootEspin_External_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_External_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_External_Provider_Order_By>>;
  where?: InputMaybe<Espin_External_Provider_Bool_Exp>;
};


export type Subscription_RootEspin_External_Provider_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_External_Provider_LinkArgs = {
  distinct_on?: InputMaybe<Array<Espin_External_Provider_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_External_Provider_Link_Order_By>>;
  where?: InputMaybe<Espin_External_Provider_Link_Bool_Exp>;
};


export type Subscription_RootEspin_External_Provider_Link_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_External_Provider_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_External_Provider_Link_Order_By>>;
  where?: InputMaybe<Espin_External_Provider_Link_Bool_Exp>;
};


export type Subscription_RootEspin_External_Provider_Link_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_External_Provider_Link_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_External_Provider_Link_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_External_Provider_Link_Bool_Exp>;
};


export type Subscription_RootEspin_External_Provider_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_External_Provider_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_External_Provider_Bool_Exp>;
};


export type Subscription_RootEspin_FollowArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Order_By>>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};


export type Subscription_RootEspin_Follow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Order_By>>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};


export type Subscription_RootEspin_Follow_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Follow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Follow_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Follow_Bool_Exp>;
};


export type Subscription_RootEspin_Follow_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Type_Order_By>>;
  where?: InputMaybe<Espin_Follow_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Follow_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follow_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follow_Type_Order_By>>;
  where?: InputMaybe<Espin_Follow_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Follow_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Follow_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Follow_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Follow_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Follower_Email_Notification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follower_Email_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follower_Email_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Follower_Email_Notification_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Follower_Email_Notification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Follower_Email_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Follower_Email_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Follower_Email_Notification_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Follower_Email_Notification_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Follower_Email_Notification_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Follower_Email_Notification_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Follower_Email_Notification_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Force_Notification_ReloadArgs = {
  distinct_on?: InputMaybe<Array<Espin_Force_Notification_Reload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Force_Notification_Reload_Order_By>>;
  where?: InputMaybe<Espin_Force_Notification_Reload_Bool_Exp>;
};


export type Subscription_RootEspin_Force_Notification_Reload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Force_Notification_Reload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Force_Notification_Reload_Order_By>>;
  where?: InputMaybe<Espin_Force_Notification_Reload_Bool_Exp>;
};


export type Subscription_RootEspin_Force_Notification_Reload_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEspin_Force_Notification_Reload_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Force_Notification_Reload_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Force_Notification_Reload_Bool_Exp>;
};


export type Subscription_RootEspin_GameArgs = {
  distinct_on?: InputMaybe<Array<Espin_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Game_Order_By>>;
  where?: InputMaybe<Espin_Game_Bool_Exp>;
};


export type Subscription_RootEspin_Game_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Game_Order_By>>;
  where?: InputMaybe<Espin_Game_Bool_Exp>;
};


export type Subscription_RootEspin_Game_By_PkArgs = {
  game_definition: Espin_Game_Definition_Enum;
};


export type Subscription_RootEspin_Game_DefinitionArgs = {
  distinct_on?: InputMaybe<Array<Espin_Game_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Game_Definition_Order_By>>;
  where?: InputMaybe<Espin_Game_Definition_Bool_Exp>;
};


export type Subscription_RootEspin_Game_Definition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Game_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Game_Definition_Order_By>>;
  where?: InputMaybe<Espin_Game_Definition_Bool_Exp>;
};


export type Subscription_RootEspin_Game_Definition_By_PkArgs = {
  game_name: Scalars['String'];
};


export type Subscription_RootEspin_Game_Definition_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Game_Definition_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Game_Definition_Bool_Exp>;
};


export type Subscription_RootEspin_Game_PlatformArgs = {
  distinct_on?: InputMaybe<Array<Espin_Game_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Game_Platform_Order_By>>;
  where?: InputMaybe<Espin_Game_Platform_Bool_Exp>;
};


export type Subscription_RootEspin_Game_Platform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Game_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Game_Platform_Order_By>>;
  where?: InputMaybe<Espin_Game_Platform_Bool_Exp>;
};


export type Subscription_RootEspin_Game_Platform_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Game_Platform_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Game_Platform_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Game_Platform_Bool_Exp>;
};


export type Subscription_RootEspin_Game_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Game_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Game_Bool_Exp>;
};


export type Subscription_RootEspin_Gender_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Espin_Gender_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Gender_Options_Order_By>>;
  where?: InputMaybe<Espin_Gender_Options_Bool_Exp>;
};


export type Subscription_RootEspin_Gender_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Gender_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Gender_Options_Order_By>>;
  where?: InputMaybe<Espin_Gender_Options_Bool_Exp>;
};


export type Subscription_RootEspin_Gender_Options_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Gender_Options_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Gender_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Gender_Options_Bool_Exp>;
};


export type Subscription_RootEspin_Graduating_ClassArgs = {
  distinct_on?: InputMaybe<Array<Espin_Graduating_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Graduating_Class_Order_By>>;
  where?: InputMaybe<Espin_Graduating_Class_Bool_Exp>;
};


export type Subscription_RootEspin_Graduating_Class_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Graduating_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Graduating_Class_Order_By>>;
  where?: InputMaybe<Espin_Graduating_Class_Bool_Exp>;
};


export type Subscription_RootEspin_Graduating_Class_By_PkArgs = {
  grad_class_years: Scalars['String'];
};


export type Subscription_RootEspin_Graduating_Class_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Graduating_Class_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Graduating_Class_Bool_Exp>;
};


export type Subscription_RootEspin_High_SchoolArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Order_By>>;
  where?: InputMaybe<Espin_High_School_Bool_Exp>;
};


export type Subscription_RootEspin_High_School_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Order_By>>;
  where?: InputMaybe<Espin_High_School_Bool_Exp>;
};


export type Subscription_RootEspin_High_School_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_High_School_InviteArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Invite_Order_By>>;
  where?: InputMaybe<Espin_High_School_Invite_Bool_Exp>;
};


export type Subscription_RootEspin_High_School_Invite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Invite_Order_By>>;
  where?: InputMaybe<Espin_High_School_Invite_Bool_Exp>;
};


export type Subscription_RootEspin_High_School_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_High_School_Invite_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_High_School_Invite_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_High_School_Invite_Bool_Exp>;
};


export type Subscription_RootEspin_High_School_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Profile_Order_By>>;
  where?: InputMaybe<Espin_High_School_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_High_School_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_High_School_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_High_School_Profile_Order_By>>;
  where?: InputMaybe<Espin_High_School_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_High_School_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_High_School_Profile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_High_School_Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_High_School_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_High_School_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_High_School_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_High_School_Bool_Exp>;
};


export type Subscription_RootEspin_Invite_Status_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Invite_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Invite_Status_Type_Order_By>>;
  where?: InputMaybe<Espin_Invite_Status_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Invite_Status_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Invite_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Invite_Status_Type_Order_By>>;
  where?: InputMaybe<Espin_Invite_Status_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Invite_Status_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Invite_Status_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Invite_Status_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Invite_Status_Type_Bool_Exp>;
};


export type Subscription_RootEspin_LeaderboardArgs = {
  distinct_on?: InputMaybe<Array<Espin_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Leaderboard_Order_By>>;
  where?: InputMaybe<Espin_Leaderboard_Bool_Exp>;
};


export type Subscription_RootEspin_Leaderboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Leaderboard_Order_By>>;
  where?: InputMaybe<Espin_Leaderboard_Bool_Exp>;
};


export type Subscription_RootEspin_Leaderboard_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Leaderboard_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Leaderboard_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Leaderboard_Bool_Exp>;
};


export type Subscription_RootEspin_MembershipArgs = {
  distinct_on?: InputMaybe<Array<Espin_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Membership_Order_By>>;
  where?: InputMaybe<Espin_Membership_Bool_Exp>;
};


export type Subscription_RootEspin_Membership_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Membership_Order_By>>;
  where?: InputMaybe<Espin_Membership_Bool_Exp>;
};


export type Subscription_RootEspin_Membership_By_PkArgs = {
  membership_id: Scalars['Int'];
};


export type Subscription_RootEspin_Membership_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Membership_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Membership_Bool_Exp>;
};


export type Subscription_RootEspin_MessageArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Order_By>>;
  where?: InputMaybe<Espin_Message_Bool_Exp>;
};


export type Subscription_RootEspin_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Order_By>>;
  where?: InputMaybe<Espin_Message_Bool_Exp>;
};


export type Subscription_RootEspin_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Message_Email_Notification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Email_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Email_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Message_Email_Notification_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Message_Email_Notification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Email_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Email_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Message_Email_Notification_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Message_Email_Notification_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Message_Email_Notification_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Message_Email_Notification_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Message_Email_Notification_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Message_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Message_Bool_Exp>;
};


export type Subscription_RootEspin_Message_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Type_Order_By>>;
  where?: InputMaybe<Espin_Message_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Message_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Message_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Message_Type_Order_By>>;
  where?: InputMaybe<Espin_Message_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Message_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Message_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Message_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Message_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Moderation_StatusArgs = {
  distinct_on?: InputMaybe<Array<Espin_Moderation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Moderation_Status_Order_By>>;
  where?: InputMaybe<Espin_Moderation_Status_Bool_Exp>;
};


export type Subscription_RootEspin_Moderation_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Moderation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Moderation_Status_Order_By>>;
  where?: InputMaybe<Espin_Moderation_Status_Bool_Exp>;
};


export type Subscription_RootEspin_Moderation_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Moderation_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Moderation_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Moderation_Status_Bool_Exp>;
};


export type Subscription_RootEspin_Newsletter_RequestArgs = {
  distinct_on?: InputMaybe<Array<Espin_Newsletter_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Newsletter_Request_Order_By>>;
  where?: InputMaybe<Espin_Newsletter_Request_Bool_Exp>;
};


export type Subscription_RootEspin_Newsletter_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Newsletter_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Newsletter_Request_Order_By>>;
  where?: InputMaybe<Espin_Newsletter_Request_Bool_Exp>;
};


export type Subscription_RootEspin_Newsletter_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Newsletter_Request_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Newsletter_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Newsletter_Request_Bool_Exp>;
};


export type Subscription_RootEspin_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Espin_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Notification_Order_By>>;
  where?: InputMaybe<Espin_Notification_Bool_Exp>;
};


export type Subscription_RootEspin_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Notification_Order_By>>;
  where?: InputMaybe<Espin_Notification_Bool_Exp>;
};


export type Subscription_RootEspin_Notification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Notification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Notification_Bool_Exp>;
};


export type Subscription_RootEspin_Notification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Notification_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Notification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Notification_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Notification_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Notification_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Notification_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Notification_Type_Bool_Exp>;
};


export type Subscription_RootEspin_OrgArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Order_By>>;
  where?: InputMaybe<Espin_Org_Bool_Exp>;
};


export type Subscription_RootEspin_Org_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Order_By>>;
  where?: InputMaybe<Espin_Org_Bool_Exp>;
};


export type Subscription_RootEspin_Org_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Org_MonthArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Month_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Month_Order_By>>;
  where?: InputMaybe<Espin_Org_Month_Bool_Exp>;
};


export type Subscription_RootEspin_Org_Month_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Month_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Month_Order_By>>;
  where?: InputMaybe<Espin_Org_Month_Bool_Exp>;
};


export type Subscription_RootEspin_Org_Month_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Org_Month_DayArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Month_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Month_Day_Order_By>>;
  where?: InputMaybe<Espin_Org_Month_Day_Bool_Exp>;
};


export type Subscription_RootEspin_Org_Month_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Month_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Month_Day_Order_By>>;
  where?: InputMaybe<Espin_Org_Month_Day_Bool_Exp>;
};


export type Subscription_RootEspin_Org_Month_Day_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Org_Month_Day_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Org_Month_Day_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Org_Month_Day_Bool_Exp>;
};


export type Subscription_RootEspin_Org_Month_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Org_Month_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Org_Month_Bool_Exp>;
};


export type Subscription_RootEspin_Org_PlayerArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Player_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Player_Order_By>>;
  where?: InputMaybe<Espin_Org_Player_Bool_Exp>;
};


export type Subscription_RootEspin_Org_Player_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_Player_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_Player_Order_By>>;
  where?: InputMaybe<Espin_Org_Player_Bool_Exp>;
};


export type Subscription_RootEspin_Org_Player_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Org_Player_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Org_Player_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Org_Player_Bool_Exp>;
};


export type Subscription_RootEspin_Org_SchoolArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_School_Order_By>>;
  where?: InputMaybe<Espin_Org_School_Bool_Exp>;
};


export type Subscription_RootEspin_Org_School_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_School_Order_By>>;
  where?: InputMaybe<Espin_Org_School_Bool_Exp>;
};


export type Subscription_RootEspin_Org_School_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Org_School_RecordArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_School_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_School_Record_Order_By>>;
  where?: InputMaybe<Espin_Org_School_Record_Bool_Exp>;
};


export type Subscription_RootEspin_Org_School_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Org_School_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Org_School_Record_Order_By>>;
  where?: InputMaybe<Espin_Org_School_Record_Bool_Exp>;
};


export type Subscription_RootEspin_Org_School_Record_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Org_School_Record_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Org_School_Record_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Org_School_Record_Bool_Exp>;
};


export type Subscription_RootEspin_Org_School_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Org_School_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Org_School_Bool_Exp>;
};


export type Subscription_RootEspin_Org_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Org_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Org_Bool_Exp>;
};


export type Subscription_RootEspin_Paid_ProductArgs = {
  distinct_on?: InputMaybe<Array<Espin_Paid_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Paid_Product_Order_By>>;
  where?: InputMaybe<Espin_Paid_Product_Bool_Exp>;
};


export type Subscription_RootEspin_Paid_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Paid_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Paid_Product_Order_By>>;
  where?: InputMaybe<Espin_Paid_Product_Bool_Exp>;
};


export type Subscription_RootEspin_Paid_Product_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Paid_Product_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Paid_Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Paid_Product_Bool_Exp>;
};


export type Subscription_RootEspin_Parent_InviteArgs = {
  distinct_on?: InputMaybe<Array<Espin_Parent_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Parent_Invite_Order_By>>;
  where?: InputMaybe<Espin_Parent_Invite_Bool_Exp>;
};


export type Subscription_RootEspin_Parent_Invite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Parent_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Parent_Invite_Order_By>>;
  where?: InputMaybe<Espin_Parent_Invite_Bool_Exp>;
};


export type Subscription_RootEspin_Parent_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Parent_Invite_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Parent_Invite_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Parent_Invite_Bool_Exp>;
};


export type Subscription_RootEspin_Parent_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Espin_Parent_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Parent_Profile_Order_By>>;
  where?: InputMaybe<Espin_Parent_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_Parent_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Parent_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Parent_Profile_Order_By>>;
  where?: InputMaybe<Espin_Parent_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_Parent_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Parent_Profile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Parent_Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Parent_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_Player_GameArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Game_Order_By>>;
  where?: InputMaybe<Espin_Player_Game_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Game_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Game_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Game_Order_By>>;
  where?: InputMaybe<Espin_Player_Game_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Game_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Player_Game_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Player_Game_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Player_Game_Bool_Exp>;
};


export type Subscription_RootEspin_Player_JourneyArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Player_Journey_StageArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Player_Journey_Stage_CollegeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_College_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_College_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_College_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_College_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_College_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Player_Journey_Stage_College_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Player_Journey_Stage_College_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_College_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_DefArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Def_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Def_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Def_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_Def_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Def_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Def_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Def_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_Def_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Player_Journey_Stage_Def_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Player_Journey_Stage_Def_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Def_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_ImageArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Image_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_Image_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Image_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Image_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_Image_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Player_Journey_Stage_Image_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Player_Journey_Stage_Image_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Image_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_QuoteArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Quote_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_Quote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Quote_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Quote_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_Quote_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Player_Journey_Stage_Quote_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Player_Journey_Stage_Quote_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Quote_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Player_Journey_Stage_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_VideoArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Video_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Video_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_Video_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Journey_Stage_Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Journey_Stage_Video_Order_By>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Video_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_Stage_Video_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Player_Journey_Stage_Video_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Player_Journey_Stage_Video_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Player_Journey_Stage_Video_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Journey_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Player_Journey_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Player_Journey_Bool_Exp>;
};


export type Subscription_RootEspin_Player_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Profile_Order_By>>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Player_Profile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Player_Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Player_Profile_Bool_Exp>;
};


export type Subscription_RootEspin_Player_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Subscription_Order_By>>;
  where?: InputMaybe<Espin_Player_Subscription_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Subscription_Order_By>>;
  where?: InputMaybe<Espin_Player_Subscription_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Subscription_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Player_Subscription_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Player_Subscription_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Player_Subscription_Bool_Exp>;
};


export type Subscription_RootEspin_Player_VodArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Vod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Vod_Order_By>>;
  where?: InputMaybe<Espin_Player_Vod_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Vod_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Player_Vod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Player_Vod_Order_By>>;
  where?: InputMaybe<Espin_Player_Vod_Bool_Exp>;
};


export type Subscription_RootEspin_Player_Vod_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Player_Vod_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Player_Vod_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Player_Vod_Bool_Exp>;
};


export type Subscription_RootEspin_Profile_ViewArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};


export type Subscription_RootEspin_Profile_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};


export type Subscription_RootEspin_Profile_View_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Profile_View_Email_Notification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Email_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Email_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Profile_View_Email_Notification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Email_Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Email_Notification_Type_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Profile_View_Email_Notification_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Profile_View_Email_Notification_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Profile_View_Email_Notification_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Profile_View_Email_Notification_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Profile_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Profile_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Profile_View_Bool_Exp>;
};


export type Subscription_RootEspin_Profile_View_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Type_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Profile_View_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Profile_View_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Profile_View_Type_Order_By>>;
  where?: InputMaybe<Espin_Profile_View_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Profile_View_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Profile_View_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Profile_View_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Profile_View_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Referral_CodeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Code_Order_By>>;
  where?: InputMaybe<Espin_Referral_Code_Bool_Exp>;
};


export type Subscription_RootEspin_Referral_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Code_Order_By>>;
  where?: InputMaybe<Espin_Referral_Code_Bool_Exp>;
};


export type Subscription_RootEspin_Referral_Code_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Referral_Code_RedemptionArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Code_Redemption_Order_By>>;
  where?: InputMaybe<Espin_Referral_Code_Redemption_Bool_Exp>;
};


export type Subscription_RootEspin_Referral_Code_Redemption_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Code_Redemption_Order_By>>;
  where?: InputMaybe<Espin_Referral_Code_Redemption_Bool_Exp>;
};


export type Subscription_RootEspin_Referral_Code_Redemption_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Referral_Code_Redemption_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Referral_Code_Redemption_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Referral_Code_Redemption_Bool_Exp>;
};


export type Subscription_RootEspin_Referral_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Referral_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Referral_Code_Bool_Exp>;
};


export type Subscription_RootEspin_Referral_OptionArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Option_Order_By>>;
  where?: InputMaybe<Espin_Referral_Option_Bool_Exp>;
};


export type Subscription_RootEspin_Referral_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Referral_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Referral_Option_Order_By>>;
  where?: InputMaybe<Espin_Referral_Option_Bool_Exp>;
};


export type Subscription_RootEspin_Referral_Option_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Referral_Option_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Referral_Option_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Referral_Option_Bool_Exp>;
};


export type Subscription_RootEspin_RoleArgs = {
  distinct_on?: InputMaybe<Array<Espin_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Role_Order_By>>;
  where?: InputMaybe<Espin_Role_Bool_Exp>;
};


export type Subscription_RootEspin_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Role_Order_By>>;
  where?: InputMaybe<Espin_Role_Bool_Exp>;
};


export type Subscription_RootEspin_Role_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Role_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Role_Bool_Exp>;
};


export type Subscription_RootEspin_Site_ContentArgs = {
  distinct_on?: InputMaybe<Array<Espin_Site_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Site_Content_Order_By>>;
  where?: InputMaybe<Espin_Site_Content_Bool_Exp>;
};


export type Subscription_RootEspin_Site_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Site_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Site_Content_Order_By>>;
  where?: InputMaybe<Espin_Site_Content_Bool_Exp>;
};


export type Subscription_RootEspin_Site_Content_By_PkArgs = {
  key: Espin_Editable_Site_Content_Enum;
};


export type Subscription_RootEspin_Site_Content_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Site_Content_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Site_Content_Bool_Exp>;
};


export type Subscription_RootEspin_SocialArgs = {
  distinct_on?: InputMaybe<Array<Espin_Social_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Social_Order_By>>;
  where?: InputMaybe<Espin_Social_Bool_Exp>;
};


export type Subscription_RootEspin_Social_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Social_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Social_Order_By>>;
  where?: InputMaybe<Espin_Social_Bool_Exp>;
};


export type Subscription_RootEspin_Social_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Social_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Social_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Social_Bool_Exp>;
};


export type Subscription_RootEspin_Stickied_CollegeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Stickied_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Stickied_College_Order_By>>;
  where?: InputMaybe<Espin_Stickied_College_Bool_Exp>;
};


export type Subscription_RootEspin_Stickied_College_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Stickied_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Stickied_College_Order_By>>;
  where?: InputMaybe<Espin_Stickied_College_Bool_Exp>;
};


export type Subscription_RootEspin_Stickied_College_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Stickied_College_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Stickied_College_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Stickied_College_Bool_Exp>;
};


export type Subscription_RootEspin_Stickied_PlayerArgs = {
  distinct_on?: InputMaybe<Array<Espin_Stickied_Player_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Stickied_Player_Order_By>>;
  where?: InputMaybe<Espin_Stickied_Player_Bool_Exp>;
};


export type Subscription_RootEspin_Stickied_Player_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Stickied_Player_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Stickied_Player_Order_By>>;
  where?: InputMaybe<Espin_Stickied_Player_Bool_Exp>;
};


export type Subscription_RootEspin_Stickied_Player_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Stickied_Player_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Stickied_Player_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Stickied_Player_Bool_Exp>;
};


export type Subscription_RootEspin_Study_FieldArgs = {
  distinct_on?: InputMaybe<Array<Espin_Study_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Study_Field_Order_By>>;
  where?: InputMaybe<Espin_Study_Field_Bool_Exp>;
};


export type Subscription_RootEspin_Study_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Study_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Study_Field_Order_By>>;
  where?: InputMaybe<Espin_Study_Field_Bool_Exp>;
};


export type Subscription_RootEspin_Study_Field_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Study_Field_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Study_Field_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Study_Field_Bool_Exp>;
};


export type Subscription_RootEspin_Study_SubjectArgs = {
  distinct_on?: InputMaybe<Array<Espin_Study_Subject_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Study_Subject_Order_By>>;
  where?: InputMaybe<Espin_Study_Subject_Bool_Exp>;
};


export type Subscription_RootEspin_Study_Subject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Study_Subject_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Study_Subject_Order_By>>;
  where?: InputMaybe<Espin_Study_Subject_Bool_Exp>;
};


export type Subscription_RootEspin_Study_Subject_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Study_Subject_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Study_Subject_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Study_Subject_Bool_Exp>;
};


export type Subscription_RootEspin_Subscription_StatusArgs = {
  distinct_on?: InputMaybe<Array<Espin_Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Subscription_Status_Order_By>>;
  where?: InputMaybe<Espin_Subscription_Status_Bool_Exp>;
};


export type Subscription_RootEspin_Subscription_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Subscription_Status_Order_By>>;
  where?: InputMaybe<Espin_Subscription_Status_Bool_Exp>;
};


export type Subscription_RootEspin_Subscription_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Subscription_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Subscription_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Subscription_Status_Bool_Exp>;
};


export type Subscription_RootEspin_Subscription_Tier_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Subscription_Tier_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Subscription_Tier_Type_Order_By>>;
  where?: InputMaybe<Espin_Subscription_Tier_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Subscription_Tier_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Subscription_Tier_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Subscription_Tier_Type_Order_By>>;
  where?: InputMaybe<Espin_Subscription_Tier_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Subscription_Tier_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Subscription_Tier_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Subscription_Tier_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Subscription_Tier_Type_Bool_Exp>;
};


export type Subscription_RootEspin_TeamArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Order_By>>;
  where?: InputMaybe<Espin_Team_Bool_Exp>;
};


export type Subscription_RootEspin_Team_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Order_By>>;
  where?: InputMaybe<Espin_Team_Bool_Exp>;
};


export type Subscription_RootEspin_Team_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Team_InviteArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Invite_Order_By>>;
  where?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
};


export type Subscription_RootEspin_Team_Invite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Invite_Order_By>>;
  where?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
};


export type Subscription_RootEspin_Team_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Team_Invite_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Team_Invite_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Team_Invite_Bool_Exp>;
};


export type Subscription_RootEspin_Team_MembersArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Members_Order_By>>;
  where?: InputMaybe<Espin_Team_Members_Bool_Exp>;
};


export type Subscription_RootEspin_Team_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Members_Order_By>>;
  where?: InputMaybe<Espin_Team_Members_Bool_Exp>;
};


export type Subscription_RootEspin_Team_Members_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Team_Members_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Team_Members_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Team_Members_Bool_Exp>;
};


export type Subscription_RootEspin_Team_RoleArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Role_Order_By>>;
  where?: InputMaybe<Espin_Team_Role_Bool_Exp>;
};


export type Subscription_RootEspin_Team_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Role_Order_By>>;
  where?: InputMaybe<Espin_Team_Role_Bool_Exp>;
};


export type Subscription_RootEspin_Team_Role_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Team_Role_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Team_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Team_Role_Bool_Exp>;
};


export type Subscription_RootEspin_Team_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Team_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Team_Bool_Exp>;
};


export type Subscription_RootEspin_Team_TypeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Type_Order_By>>;
  where?: InputMaybe<Espin_Team_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Team_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Team_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Team_Type_Order_By>>;
  where?: InputMaybe<Espin_Team_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Team_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEspin_Team_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Team_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Team_Type_Bool_Exp>;
};


export type Subscription_RootEspin_Unregistered_CollegeArgs = {
  distinct_on?: InputMaybe<Array<Espin_Unregistered_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Unregistered_College_Order_By>>;
  where?: InputMaybe<Espin_Unregistered_College_Bool_Exp>;
};


export type Subscription_RootEspin_Unregistered_College_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_Unregistered_College_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_Unregistered_College_Order_By>>;
  where?: InputMaybe<Espin_Unregistered_College_Bool_Exp>;
};


export type Subscription_RootEspin_Unregistered_College_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_Unregistered_College_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_Unregistered_College_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_Unregistered_College_Bool_Exp>;
};


export type Subscription_RootEspin_UserArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Order_By>>;
  where?: InputMaybe<Espin_User_Bool_Exp>;
};


export type Subscription_RootEspin_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Order_By>>;
  where?: InputMaybe<Espin_User_Bool_Exp>;
};


export type Subscription_RootEspin_User_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootEspin_User_Linked_External_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Linked_External_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Linked_External_Provider_Order_By>>;
  where?: InputMaybe<Espin_User_Linked_External_Provider_Bool_Exp>;
};


export type Subscription_RootEspin_User_Linked_External_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Linked_External_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Linked_External_Provider_Order_By>>;
  where?: InputMaybe<Espin_User_Linked_External_Provider_Bool_Exp>;
};


export type Subscription_RootEspin_User_Linked_External_Provider_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_User_Linked_External_Provider_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_User_Linked_External_Provider_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_User_Linked_External_Provider_Bool_Exp>;
};


export type Subscription_RootEspin_User_MembershipArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Membership_Order_By>>;
  where?: InputMaybe<Espin_User_Membership_Bool_Exp>;
};


export type Subscription_RootEspin_User_Membership_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Membership_Order_By>>;
  where?: InputMaybe<Espin_User_Membership_Bool_Exp>;
};


export type Subscription_RootEspin_User_Membership_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootEspin_User_Membership_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_User_Membership_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_User_Membership_Bool_Exp>;
};


export type Subscription_RootEspin_User_SourceArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Source_Order_By>>;
  where?: InputMaybe<Espin_User_Source_Bool_Exp>;
};


export type Subscription_RootEspin_User_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Source_Order_By>>;
  where?: InputMaybe<Espin_User_Source_Bool_Exp>;
};


export type Subscription_RootEspin_User_Source_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEspin_User_Source_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_User_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_User_Source_Bool_Exp>;
};


export type Subscription_RootEspin_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_User_Bool_Exp>;
};


export type Subscription_RootEspin_User_Subscription_StatusArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Subscription_Status_Order_By>>;
  where?: InputMaybe<Espin_User_Subscription_Status_Bool_Exp>;
};


export type Subscription_RootEspin_User_Subscription_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Espin_User_Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Espin_User_Subscription_Status_Order_By>>;
  where?: InputMaybe<Espin_User_Subscription_Status_Bool_Exp>;
};


export type Subscription_RootEspin_User_Subscription_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Espin_User_Subscription_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Espin_User_Subscription_Status_Bool_Exp>;
};


export type Subscription_RootQueue_JobArgs = {
  distinct_on?: InputMaybe<Array<Queue_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Queue_Job_Order_By>>;
  where?: InputMaybe<Queue_Job_Bool_Exp>;
};


export type Subscription_RootQueue_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Queue_Job_Order_By>>;
  where?: InputMaybe<Queue_Job_Bool_Exp>;
};


export type Subscription_RootQueue_Job_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootQueue_Job_Status_TypeArgs = {
  distinct_on?: InputMaybe<Array<Queue_Job_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Queue_Job_Status_Type_Order_By>>;
  where?: InputMaybe<Queue_Job_Status_Type_Bool_Exp>;
};


export type Subscription_RootQueue_Job_Status_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Job_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Queue_Job_Status_Type_Order_By>>;
  where?: InputMaybe<Queue_Job_Status_Type_Bool_Exp>;
};


export type Subscription_RootQueue_Job_Status_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootQueue_Job_Status_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Queue_Job_Status_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Queue_Job_Status_Type_Bool_Exp>;
};


export type Subscription_RootQueue_Job_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Queue_Job_Stream_Cursor_Input>>;
  where?: InputMaybe<Queue_Job_Bool_Exp>;
};


export type Subscription_RootQueue_Job_TypeArgs = {
  distinct_on?: InputMaybe<Array<Queue_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Queue_Job_Type_Order_By>>;
  where?: InputMaybe<Queue_Job_Type_Bool_Exp>;
};


export type Subscription_RootQueue_Job_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Queue_Job_Type_Order_By>>;
  where?: InputMaybe<Queue_Job_Type_Bool_Exp>;
};


export type Subscription_RootQueue_Job_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootQueue_Job_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Queue_Job_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Queue_Job_Type_Bool_Exp>;
};


export type Subscription_RootStripe_Customer_DataArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Customer_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Customer_Data_Order_By>>;
  where?: InputMaybe<Stripe_Customer_Data_Bool_Exp>;
};


export type Subscription_RootStripe_Customer_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Customer_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Customer_Data_Order_By>>;
  where?: InputMaybe<Stripe_Customer_Data_Bool_Exp>;
};


export type Subscription_RootStripe_Customer_Data_By_PkArgs = {
  customer_id: Scalars['String'];
};


export type Subscription_RootStripe_Customer_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stripe_Customer_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Stripe_Customer_Data_Bool_Exp>;
};


export type Subscription_RootStripe_Invoice_DataArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Invoice_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Invoice_Data_Order_By>>;
  where?: InputMaybe<Stripe_Invoice_Data_Bool_Exp>;
};


export type Subscription_RootStripe_Invoice_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Invoice_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Invoice_Data_Order_By>>;
  where?: InputMaybe<Stripe_Invoice_Data_Bool_Exp>;
};


export type Subscription_RootStripe_Invoice_Data_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootStripe_Invoice_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stripe_Invoice_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Stripe_Invoice_Data_Bool_Exp>;
};


export type Subscription_RootStripe_Stripe_Payment_DataArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Stripe_Payment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Stripe_Payment_Data_Order_By>>;
  where?: InputMaybe<Stripe_Stripe_Payment_Data_Bool_Exp>;
};


export type Subscription_RootStripe_Stripe_Payment_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Stripe_Payment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Stripe_Payment_Data_Order_By>>;
  where?: InputMaybe<Stripe_Stripe_Payment_Data_Bool_Exp>;
};


export type Subscription_RootStripe_Stripe_Payment_Data_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootStripe_Stripe_Payment_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stripe_Stripe_Payment_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Stripe_Stripe_Payment_Data_Bool_Exp>;
};


export type Subscription_RootStripe_Stripe_Subscription_DataArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Stripe_Subscription_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Stripe_Subscription_Data_Order_By>>;
  where?: InputMaybe<Stripe_Stripe_Subscription_Data_Bool_Exp>;
};


export type Subscription_RootStripe_Stripe_Subscription_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Stripe_Subscription_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Stripe_Subscription_Data_Order_By>>;
  where?: InputMaybe<Stripe_Stripe_Subscription_Data_Bool_Exp>;
};


export type Subscription_RootStripe_Stripe_Subscription_Data_By_PkArgs = {
  customer: Scalars['String'];
  id: Scalars['String'];
};


export type Subscription_RootStripe_Stripe_Subscription_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stripe_Stripe_Subscription_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Stripe_Stripe_Subscription_Data_Bool_Exp>;
};


export type Subscription_RootTempstorage_KeyvalueArgs = {
  distinct_on?: InputMaybe<Array<Tempstorage_Keyvalue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tempstorage_Keyvalue_Order_By>>;
  where?: InputMaybe<Tempstorage_Keyvalue_Bool_Exp>;
};


export type Subscription_RootTempstorage_Keyvalue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tempstorage_Keyvalue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tempstorage_Keyvalue_Order_By>>;
  where?: InputMaybe<Tempstorage_Keyvalue_Bool_Exp>;
};


export type Subscription_RootTempstorage_Keyvalue_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTempstorage_Keyvalue_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tempstorage_Keyvalue_Stream_Cursor_Input>>;
  where?: InputMaybe<Tempstorage_Keyvalue_Bool_Exp>;
};

/** Used to temporarily store keyvalue data pairs. Should be cleaned out periodically. */
export type Tempstorage_Keyvalue = {
  __typename?: 'tempstorage_keyvalue';
  content: Scalars['jsonb'];
  content_type?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
};


/** Used to temporarily store keyvalue data pairs. Should be cleaned out periodically. */
export type Tempstorage_KeyvalueContentArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "tempstorage.keyvalue" */
export type Tempstorage_Keyvalue_Aggregate = {
  __typename?: 'tempstorage_keyvalue_aggregate';
  aggregate?: Maybe<Tempstorage_Keyvalue_Aggregate_Fields>;
  nodes: Array<Tempstorage_Keyvalue>;
};

/** aggregate fields of "tempstorage.keyvalue" */
export type Tempstorage_Keyvalue_Aggregate_Fields = {
  __typename?: 'tempstorage_keyvalue_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tempstorage_Keyvalue_Max_Fields>;
  min?: Maybe<Tempstorage_Keyvalue_Min_Fields>;
};


/** aggregate fields of "tempstorage.keyvalue" */
export type Tempstorage_Keyvalue_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tempstorage_Keyvalue_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tempstorage_Keyvalue_Append_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "tempstorage.keyvalue". All fields are combined with a logical 'AND'. */
export type Tempstorage_Keyvalue_Bool_Exp = {
  _and?: InputMaybe<Array<Tempstorage_Keyvalue_Bool_Exp>>;
  _not?: InputMaybe<Tempstorage_Keyvalue_Bool_Exp>;
  _or?: InputMaybe<Array<Tempstorage_Keyvalue_Bool_Exp>>;
  content?: InputMaybe<Jsonb_Comparison_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "tempstorage.keyvalue" */
export enum Tempstorage_Keyvalue_Constraint {
  /** unique or primary key constraint on columns "id" */
  KeyvaluePkey = 'keyvalue_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tempstorage_Keyvalue_Delete_At_Path_Input = {
  content?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tempstorage_Keyvalue_Delete_Elem_Input = {
  content?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tempstorage_Keyvalue_Delete_Key_Input = {
  content?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "tempstorage.keyvalue" */
export type Tempstorage_Keyvalue_Insert_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Tempstorage_Keyvalue_Max_Fields = {
  __typename?: 'tempstorage_keyvalue_max_fields';
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Tempstorage_Keyvalue_Min_Fields = {
  __typename?: 'tempstorage_keyvalue_min_fields';
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "tempstorage.keyvalue" */
export type Tempstorage_Keyvalue_Mutation_Response = {
  __typename?: 'tempstorage_keyvalue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tempstorage_Keyvalue>;
};

/** on_conflict condition type for table "tempstorage.keyvalue" */
export type Tempstorage_Keyvalue_On_Conflict = {
  constraint: Tempstorage_Keyvalue_Constraint;
  update_columns?: Array<Tempstorage_Keyvalue_Update_Column>;
  where?: InputMaybe<Tempstorage_Keyvalue_Bool_Exp>;
};

/** Ordering options when selecting data from "tempstorage.keyvalue". */
export type Tempstorage_Keyvalue_Order_By = {
  content?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tempstorage.keyvalue */
export type Tempstorage_Keyvalue_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tempstorage_Keyvalue_Prepend_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "tempstorage.keyvalue" */
export enum Tempstorage_Keyvalue_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "tempstorage.keyvalue" */
export type Tempstorage_Keyvalue_Set_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "tempstorage_keyvalue" */
export type Tempstorage_Keyvalue_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tempstorage_Keyvalue_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tempstorage_Keyvalue_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "tempstorage.keyvalue" */
export enum Tempstorage_Keyvalue_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

export type Tempstorage_Keyvalue_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tempstorage_Keyvalue_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tempstorage_Keyvalue_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tempstorage_Keyvalue_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tempstorage_Keyvalue_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tempstorage_Keyvalue_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tempstorage_Keyvalue_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tempstorage_Keyvalue_Bool_Exp;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type LoginDataFragment = { __typename?: 'espin_user', id: string, role: Espin_Role_Enum, email: string, last_login?: any | null | undefined, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined, tierlookup?: number | null | undefined } | null | undefined, college_profile?: { __typename?: 'espin_college_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, last_group_message?: any | null | undefined, college: { __typename?: 'espin_college', id: any, subscribed: boolean, manual_subtier?: number | null | undefined, program_name?: string | null | undefined, verified: boolean, owner_profile_id?: any | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', location?: any | null | undefined, state: string } | null | undefined, subscription?: { __typename?: 'espin_college_subscription', referral_code_redemption_id?: any | null | undefined } | null | undefined } } | null | undefined, high_school_profile?: { __typename?: 'espin_high_school_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, high_school: { __typename?: 'espin_high_school', id: any, name: string, verified: boolean, owner_profile_id?: any | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined } } | null | undefined, parent_profile?: { __typename?: 'espin_parent_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, id: any, child_profiles: Array<{ __typename?: 'espin_player_profile', id: any, slug: string, user_id: string, trial_end_date?: any | null | undefined, referral_option_id?: any | null | undefined, spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, user: { __typename?: 'espin_user', subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined, tierlookup?: number | null | undefined } | null | undefined }, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, subscription?: { __typename?: 'espin_player_subscription', id: any, expires: any, referral_code_redemption_id?: any | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }> }>, address?: { __typename?: 'espin_address', location?: any | null | undefined, state: string } | null | undefined } | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string, ack_terms: boolean, ack_waiver: boolean, ack_displayed: boolean, trial_end_date?: any | null | undefined, referral_option_id?: any | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, address?: { __typename?: 'espin_address', location?: any | null | undefined, state: string } | null | undefined, subscription?: { __typename?: 'espin_player_subscription', referral_code_redemption_id?: any | null | undefined } | null | undefined } | null | undefined };

export type LoginToSpinMutationVariables = Exact<{ [key: string]: never; }>;


export type LoginToSpinMutation = { __typename?: 'mutation_root', insert_espin_user_one?: { __typename?: 'espin_user', id: string, role: Espin_Role_Enum, email: string, last_login?: any | null | undefined, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined, tierlookup?: number | null | undefined } | null | undefined, college_profile?: { __typename?: 'espin_college_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, last_group_message?: any | null | undefined, college: { __typename?: 'espin_college', id: any, subscribed: boolean, manual_subtier?: number | null | undefined, program_name?: string | null | undefined, verified: boolean, owner_profile_id?: any | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', location?: any | null | undefined, state: string } | null | undefined, subscription?: { __typename?: 'espin_college_subscription', referral_code_redemption_id?: any | null | undefined } | null | undefined } } | null | undefined, high_school_profile?: { __typename?: 'espin_high_school_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, high_school: { __typename?: 'espin_high_school', id: any, name: string, verified: boolean, owner_profile_id?: any | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined } } | null | undefined, parent_profile?: { __typename?: 'espin_parent_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, id: any, child_profiles: Array<{ __typename?: 'espin_player_profile', id: any, slug: string, user_id: string, trial_end_date?: any | null | undefined, referral_option_id?: any | null | undefined, spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, user: { __typename?: 'espin_user', subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined, tierlookup?: number | null | undefined } | null | undefined }, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, subscription?: { __typename?: 'espin_player_subscription', id: any, expires: any, referral_code_redemption_id?: any | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }> }>, address?: { __typename?: 'espin_address', location?: any | null | undefined, state: string } | null | undefined } | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string, ack_terms: boolean, ack_waiver: boolean, ack_displayed: boolean, trial_end_date?: any | null | undefined, referral_option_id?: any | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, address?: { __typename?: 'espin_address', location?: any | null | undefined, state: string } | null | undefined, subscription?: { __typename?: 'espin_player_subscription', referral_code_redemption_id?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type SpinNotificationDataFragment = { __typename?: 'espin_notification', player_user_id?: string | null | undefined, id: any, created_at: any, viewed_at?: any | null | undefined, notification_type: Espin_Notification_Type_Enum, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type HighSchoolNotificationsSubscriptionVariables = Exact<{
  highSchoolId: Scalars['uuid'];
}>;


export type HighSchoolNotificationsSubscription = { __typename?: 'subscription_root', espin_notification: Array<{ __typename?: 'espin_notification', player_user_id?: string | null | undefined, id: any, created_at: any, viewed_at?: any | null | undefined, notification_type: Espin_Notification_Type_Enum, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }> };

export type CollegeNotificationsSubscriptionVariables = Exact<{
  collegeId: Scalars['uuid'];
}>;


export type CollegeNotificationsSubscription = { __typename?: 'subscription_root', espin_notification: Array<{ __typename?: 'espin_notification', player_user_id?: string | null | undefined, id: any, created_at: any, viewed_at?: any | null | undefined, notification_type: Espin_Notification_Type_Enum, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }> };

export type PlayerNotificationsSubscriptionVariables = Exact<{
  playerUserId: Scalars['String'];
}>;


export type PlayerNotificationsSubscription = { __typename?: 'subscription_root', espin_notification: Array<{ __typename?: 'espin_notification', player_user_id?: string | null | undefined, id: any, created_at: any, viewed_at?: any | null | undefined, notification_type: Espin_Notification_Type_Enum, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }> };

export type ParentNotificationsSubscriptionVariables = Exact<{
  playerUserIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ParentNotificationsSubscription = { __typename?: 'subscription_root', espin_notification: Array<{ __typename?: 'espin_notification', player_user_id?: string | null | undefined, id: any, created_at: any, viewed_at?: any | null | undefined, notification_type: Espin_Notification_Type_Enum, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }> };

export type RefreshOnSocialMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshOnSocialMutation = { __typename?: 'mutation_root', delete_espin_force_notification_reload?: { __typename?: 'espin_force_notification_reload_mutation_response', affected_rows: number } | null | undefined };

export type ActivationCollegeAttendingFragment = { __typename?: 'espin_college', slug?: string | null | undefined, scholarships: boolean, program_name?: string | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type CollegeUserEditProfileFormQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CollegeUserEditProfileFormQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', college_profile?: { __typename?: 'espin_college_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, college: { __typename?: 'espin_college', id: any, min_gpa?: string | null | undefined, min_act?: string | null | undefined, min_sat?: string | null | undefined, academic_notes?: string | null | undefined, scholarships: boolean, in_state_tuition?: string | null | undefined, out_of_state_tuition?: string | null | undefined, contact_email?: string | null | undefined, name: string, program_name?: string | null | undefined, varsity: boolean, phone?: string | null | undefined, bio?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }>, header_media_link?: { __typename?: 'content_media_link', id: any, link_data: string, link_type: Content_Media_Link_Type_Enum } | null | undefined, college_images: Array<{ __typename?: 'espin_college_image', id: any, deleted_at?: any | null | undefined, order: number, file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined }>, socials?: { __typename?: 'espin_social', id: any, website?: string | null | undefined, twitter?: string | null | undefined, facebook?: string | null | undefined, instagram?: string | null | undefined, discord?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', id: any, state: string, zip?: string | null | undefined, city: string, country?: string | null | undefined } | null | undefined } } | null | undefined } | null | undefined };

export type SetCollegeOwnerMutationVariables = Exact<{
  owner_profile_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
}>;


export type SetCollegeOwnerMutation = { __typename?: 'mutation_root', update_espin_college_by_pk?: { __typename?: 'espin_college', id: any } | null | undefined };

export type UpsertCollegeProfileMutationVariables = Exact<{
  collegeId?: Maybe<Scalars['uuid']>;
  input: Espin_College_Profile_Insert_Input;
  onConflict: Espin_College_Profile_On_Conflict;
}>;


export type UpsertCollegeProfileMutation = { __typename?: 'mutation_root', delete_espin_college_game?: { __typename?: 'espin_college_game_mutation_response', affected_rows: number } | null | undefined, insert_espin_college_profile_one?: { __typename?: 'espin_college_profile', id: any, college: { __typename?: 'espin_college', id: any } } | null | undefined };

export type CollegeCardFragment = { __typename?: 'espin_college', slug?: string | null | undefined, scholarships: boolean, program_name?: string | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type CollegeCardContentFragment = { __typename?: 'espin_college', program_name?: string | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type CollegeDetailsFragment = { __typename?: 'espin_college', program_name?: string | null | undefined, scholarships: boolean, bio?: string | null | undefined, contact_email?: string | null | undefined, phone?: string | null | undefined, academic_notes?: string | null | undefined, min_gpa?: string | null | undefined, min_sat?: string | null | undefined, min_act?: string | null | undefined, name: string, id: any, in_state_tuition?: string | null | undefined, out_of_state_tuition?: string | null | undefined, slug?: string | null | undefined, header_media_link?: { __typename?: 'content_media_link', link_data: string, link_type: Content_Media_Link_Type_Enum } | null | undefined, college_images: Array<{ __typename?: 'espin_college_image', file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }>, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, address?: { __typename?: 'espin_address', state: string, city: string, country?: string | null | undefined, location?: any | null | undefined } | null | undefined, socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, website?: string | null | undefined, twitch?: string | null | undefined, discord?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type CollegeRostersFragment = { __typename?: 'espin_college', college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', name: string }, college_rosters: Array<{ __typename?: 'espin_college_roster', first_name?: string | null | undefined, last_name?: string | null | undefined, gamertag: string }> }> };

export type CollegeSocialsFragment = { __typename?: 'espin_college', socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, website?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined };

export type UnregisteredCollegesDisplayComponentFragment = { __typename?: 'espin_unregistered_college', id: any, program_name: string };

export type CollegeImageHandlerFragment = { __typename?: 'espin_college_image', id: any, deleted_at?: any | null | undefined, order: number, file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type AcademicRequirementsCardFragment = { __typename?: 'espin_college', academic_notes?: string | null | undefined, min_gpa?: string | null | undefined, min_sat?: string | null | undefined, min_act?: string | null | undefined };

export type CollegeBioCardFragment = { __typename?: 'espin_college', bio?: string | null | undefined, contact_email?: string | null | undefined, phone?: string | null | undefined, id: any, program_name?: string | null | undefined, in_state_tuition?: string | null | undefined, out_of_state_tuition?: string | null | undefined, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitch?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, discord?: string | null | undefined, website?: string | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined };

export type CollegeInfoButtonsFragment = { __typename?: 'espin_college', slug?: string | null | undefined, contact_email?: string | null | undefined, phone?: string | null | undefined, socials?: { __typename?: 'espin_social', discord?: string | null | undefined } | null | undefined };

export type CollegeLocationCardFragment = { __typename?: 'espin_college', name: string, address?: { __typename?: 'espin_address', state: string, city: string, country?: string | null | undefined, location?: any | null | undefined } | null | undefined };

export type CollegeMediaCardFragment = { __typename?: 'espin_college', name: string, program_name?: string | null | undefined, header_media_link?: { __typename?: 'content_media_link', link_type: Content_Media_Link_Type_Enum, link_data: string } | null | undefined, college_images: Array<{ __typename?: 'espin_college_image', file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> };

export type CollegeProfileFragment = { __typename?: 'espin_college', program_name?: string | null | undefined, scholarships: boolean, bio?: string | null | undefined, contact_email?: string | null | undefined, phone?: string | null | undefined, academic_notes?: string | null | undefined, min_gpa?: string | null | undefined, min_sat?: string | null | undefined, min_act?: string | null | undefined, name: string, id: any, in_state_tuition?: string | null | undefined, out_of_state_tuition?: string | null | undefined, slug?: string | null | undefined, header_media_link?: { __typename?: 'content_media_link', link_data: string, link_type: Content_Media_Link_Type_Enum } | null | undefined, college_images: Array<{ __typename?: 'espin_college_image', file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }>, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, address?: { __typename?: 'espin_address', state: string, city: string, country?: string | null | undefined, location?: any | null | undefined } | null | undefined, socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, website?: string | null | undefined, twitch?: string | null | undefined, discord?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type ParentFollowsMutationVariables = Exact<{
  input: Array<Espin_Follow_Insert_Input> | Espin_Follow_Insert_Input;
}>;


export type ParentFollowsMutation = { __typename?: 'mutation_root', insert_espin_follow?: { __typename?: 'espin_follow_mutation_response', returning: Array<{ __typename?: 'espin_follow', id: any }> } | null | undefined };

export type ParentUnfollowsMutationVariables = Exact<{
  playerUserId: Array<Scalars['String']> | Scalars['String'];
  collegeId: Scalars['uuid'];
}>;


export type ParentUnfollowsMutation = { __typename?: 'mutation_root', delete_espin_follow?: { __typename?: 'espin_follow_mutation_response', returning: Array<{ __typename?: 'espin_follow', id: any }> } | null | undefined };

export type FollowMutationVariables = Exact<{
  input: Espin_Follow_Insert_Input;
}>;


export type FollowMutation = { __typename?: 'mutation_root', insert_espin_follow_one?: { __typename?: 'espin_follow', id: any } | null | undefined };

export type UnfollowMutationVariables = Exact<{
  where: Espin_Follow_Bool_Exp;
}>;


export type UnfollowMutation = { __typename?: 'mutation_root', delete_espin_follow?: { __typename?: 'espin_follow_mutation_response', returning: Array<{ __typename?: 'espin_follow', id: any }> } | null | undefined };

export type CheckFollowingStatusQueryVariables = Exact<{
  where: Espin_Follow_Bool_Exp;
}>;


export type CheckFollowingStatusQuery = { __typename?: 'query_root', espin_follow: Array<{ __typename?: 'espin_follow', id: any }> };

export type CollegeProfileInfoFragment = { __typename?: 'espin_college', id: any, program_name?: string | null | undefined, in_state_tuition?: string | null | undefined, phone?: string | null | undefined, contact_email?: string | null | undefined, out_of_state_tuition?: string | null | undefined, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitch?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, discord?: string | null | undefined, website?: string | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined };

export type OurEsportsCardFragment = { __typename?: 'espin_college_game', game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } };

export type CollegeSearchFilterComponentFragment = { __typename?: 'query_root', espin_game_definition: Array<{ __typename?: 'espin_game_definition', display_name: string, game_name: string }> };

export type DocumentDownloadDisplayFragment = { __typename?: 'content_file', id: any, original_name?: string | null | undefined, cdn_url?: string | null | undefined, ext?: string | null | undefined };

export type PlainTextLocationDisplayFragment = { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string };

export type SpinContentImageDisplayFragment = { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined };

export type ReferralOptionPopupContentQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralOptionPopupContentQuery = { __typename?: 'query_root', espin_referral_option: Array<{ __typename?: 'espin_referral_option', id: any, name: string, sort_order?: number | null | undefined, description?: string | null | undefined }> };

export type ReferralOptionFragment = { __typename?: 'espin_referral_option', id: any, name: string, sort_order?: number | null | undefined, description?: string | null | undefined };

export type AddOrEditGamePopupContentFragment = { __typename?: 'espin_player_game', id: any, in_game_username?: string | null | undefined, rank?: string | null | undefined, role?: string | null | undefined, primary: boolean, tracker?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } };

export type AddPlayerGameFromPopupMutationVariables = Exact<{
  input: Espin_Player_Game_Insert_Input;
}>;


export type AddPlayerGameFromPopupMutation = { __typename?: 'mutation_root', insert_espin_player_game_one?: { __typename?: 'espin_player_game', id: any } | null | undefined };

export type AddPlayerGameAndUpdatePrimaryFromPopupMutationVariables = Exact<{
  input: Espin_Player_Game_Insert_Input;
  id: Scalars['uuid'];
}>;


export type AddPlayerGameAndUpdatePrimaryFromPopupMutation = { __typename?: 'mutation_root', update_espin_player_game_by_pk?: { __typename?: 'espin_player_game', id: any } | null | undefined, insert_espin_player_game_one?: { __typename?: 'espin_player_game', id: any } | null | undefined };

export type SendMassPlayerMessageActionMutationVariables = Exact<{
  input: SendMassPlayerMessageInput;
}>;


export type SendMassPlayerMessageActionMutation = { __typename?: 'mutation_root', sendMassPlayerMessage?: { __typename?: 'SendMassPlayerMessageOutput', messages_sent: any } | null | undefined };

export type UpdatePlayerGameMutationVariables = Exact<{
  input: Espin_Player_Game_Set_Input;
  id: Scalars['uuid'];
  primaryGameId: Scalars['uuid'];
}>;


export type UpdatePlayerGameMutation = { __typename?: 'mutation_root', updatePrimary?: { __typename?: 'espin_player_game', id: any } | null | undefined, update_espin_player_game_by_pk?: { __typename?: 'espin_player_game', id: any } | null | undefined };

export type FindCollegesSearchQueryVariables = Exact<{
  subbedSearch: Espin_College_Bool_Exp;
  unsubbedSearch: Espin_College_Bool_Exp;
}>;


export type FindCollegesSearchQuery = { __typename?: 'query_root', unsubbedColleges: Array<{ __typename?: 'espin_college', id: any, name: string, program_name?: string | null | undefined, subscribed: boolean, slug?: string | null | undefined, scholarships: boolean, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }>, subbedColleges: Array<{ __typename?: 'espin_college', id: any, name: string, program_name?: string | null | undefined, subscribed: boolean, slug?: string | null | undefined, scholarships: boolean, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> };

export type FindCollegesResultsFragment = { __typename?: 'espin_college', id: any, name: string, program_name?: string | null | undefined, subscribed: boolean, slug?: string | null | undefined, scholarships: boolean, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type FindPlayersFormQueryVariables = Exact<{ [key: string]: never; }>;


export type FindPlayersFormQuery = { __typename?: 'query_root', espin_study_field: Array<{ __typename?: 'espin_study_field', name: string }>, espin_study_subject: Array<{ __typename?: 'espin_study_subject', name: string, study_field: { __typename?: 'espin_study_field', name: string } }> };

export type FindPlayersSearchQueryVariables = Exact<{
  search: Espin_Player_Profile_Bool_Exp;
}>;


export type FindPlayersSearchQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', id: any, slug: string, first_name?: string | null | undefined, last_name?: string | null | undefined, spin_username: string, gpa: any, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, primary_game: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> }> };

export type FindPlayersResultsFragment = { __typename?: 'espin_player_profile', id: any, slug: string, first_name?: string | null | undefined, last_name?: string | null | undefined, spin_username: string, gpa: any, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, primary_game: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> };

export type InvitePlayersToHighSchoolTeamMutationVariables = Exact<{
  input: InvitePlayersToTeamActionInput;
}>;


export type InvitePlayersToHighSchoolTeamMutation = { __typename?: 'mutation_root', invitePlayersToTeamAction?: { __typename?: 'InvitePlayersToTeamActionOutput', notFound?: Array<string | null | undefined> | null | undefined, alreadyInvited?: Array<string | null | undefined> | null | undefined, status: string } | null | undefined };

export type PlayerInviteOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerInviteOptionsQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', id: any, spin_username: string, user_id: string }> };

export type CreateHighSchoolTeamActionMutationVariables = Exact<{
  input: CreateHighSchoolTeamInput;
}>;


export type CreateHighSchoolTeamActionMutation = { __typename?: 'mutation_root', createHighSchoolTeam?: { __typename?: 'CreateHighSchoolTeamOutput', id: any, notFound?: Array<string | null | undefined> | null | undefined, status: string, comments?: string | null | undefined } | null | undefined };

export type EditHighSchoolTeamActionMutationVariables = Exact<{
  input: EditHighSchoolTeamInput;
}>;


export type EditHighSchoolTeamActionMutation = { __typename?: 'mutation_root', editHighSchoolTeam?: { __typename?: 'EditHighSchoolTeamOutput', id: any, notFound?: Array<string | null | undefined> | null | undefined, status: string, comments?: string | null | undefined } | null | undefined };

export type CreatePlayerTeamActionMutationVariables = Exact<{
  input: CreatePlayerTeamInput;
}>;


export type CreatePlayerTeamActionMutation = { __typename?: 'mutation_root', createPlayerTeam?: { __typename?: 'CreatePlayerTeamOutput', id: any, notFound?: Array<string | null | undefined> | null | undefined, status: string, comments?: string | null | undefined } | null | undefined };

export type EditPlayerTeamActionMutationVariables = Exact<{
  input: EditPlayerTeamInput;
}>;


export type EditPlayerTeamActionMutation = { __typename?: 'mutation_root', editPlayerTeam?: { __typename?: 'EditPlayerTeamOutput', id: any, notFound?: Array<string | null | undefined> | null | undefined, status: string, comments?: string | null | undefined } | null | undefined };

export type PlayerDeleteTeamInviteByIdMutationVariables = Exact<{
  inviteId: Scalars['uuid'];
}>;


export type PlayerDeleteTeamInviteByIdMutation = { __typename?: 'mutation_root', delete_espin_team_invite_by_pk?: { __typename?: 'espin_team_invite', id: any } | null | undefined };

export type PlayerAcceptTeamInviteByIdMutationVariables = Exact<{
  player_profile_id: Scalars['uuid'];
  inviteId: Scalars['uuid'];
  teamId: Scalars['uuid'];
}>;


export type PlayerAcceptTeamInviteByIdMutation = { __typename?: 'mutation_root', insert_espin_team_members_one?: { __typename?: 'espin_team_members', id: any } | null | undefined, update_espin_team_invite_by_pk?: { __typename?: 'espin_team_invite', id: any } | null | undefined };

export type UpdatePlayerHsOnTeamInviteMutationVariables = Exact<{
  player_profile_id: Scalars['uuid'];
  hsId: Scalars['uuid'];
}>;


export type UpdatePlayerHsOnTeamInviteMutation = { __typename?: 'mutation_root', update_espin_player_profile?: { __typename?: 'espin_player_profile_mutation_response', returning: Array<{ __typename?: 'espin_player_profile', id: any }> } | null | undefined };

export type UnreadCollegeMessagesQueryVariables = Exact<{
  collegeId?: Maybe<Scalars['uuid']>;
}>;


export type UnreadCollegeMessagesQuery = { __typename?: 'query_root', espin_message: Array<{ __typename?: 'espin_message', id: any }> };

export type UnreadPlayerMessagesQueryVariables = Exact<{
  playerUserId?: Maybe<Scalars['String']>;
}>;


export type UnreadPlayerMessagesQuery = { __typename?: 'query_root', espin_message: Array<{ __typename?: 'espin_message', id: any }> };

export type UnreadParentMessagesQueryVariables = Exact<{
  playerUserIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UnreadParentMessagesQuery = { __typename?: 'query_root', espin_message: Array<{ __typename?: 'espin_message', id: any }> };

export type ParentChildDropdownFragment = { __typename?: 'espin_parent_profile', child_profiles: Array<{ __typename?: 'espin_player_profile', user_id: string, spin_username: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> };

export type CollegePasswordResetEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type CollegePasswordResetEmailMutation = { __typename?: 'mutation_root', generatePasswordResetEmail?: { __typename?: 'PasswordResetOutput', status?: boolean | null | undefined } | null | undefined };

export type HighSchoolPasswordResetEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type HighSchoolPasswordResetEmailMutation = { __typename?: 'mutation_root', generatePasswordResetEmail?: { __typename?: 'PasswordResetOutput', status?: boolean | null | undefined } | null | undefined };

export type ParentPasswordResetEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ParentPasswordResetEmailMutation = { __typename?: 'mutation_root', generatePasswordResetEmail?: { __typename?: 'PasswordResetOutput', status?: boolean | null | undefined } | null | undefined };

export type PlayerPasswordResetEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type PlayerPasswordResetEmailMutation = { __typename?: 'mutation_root', generatePasswordResetEmail?: { __typename?: 'PasswordResetOutput', status?: boolean | null | undefined } | null | undefined };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUserMutation = { __typename?: 'mutation_root', update_espin_user_by_pk?: { __typename?: 'espin_user', id: string } | null | undefined };

export type ColleagueCardFragment = { __typename?: 'espin_college_invite', id: any, email: string, status: Espin_Invite_Status_Type_Enum };

export type ColleagueInvitesFragment = { __typename?: 'espin_college_invite', id: any, email: string, status: Espin_Invite_Status_Type_Enum };

export type ClearCollegeInviteMutationVariables = Exact<{
  id: Scalars['uuid'];
  email: Scalars['String'];
}>;


export type ClearCollegeInviteMutation = { __typename?: 'mutation_root', delete_espin_college_invite_by_pk?: { __typename?: 'espin_college_invite', id: any } | null | undefined, delete_espin_college_profile?: { __typename?: 'espin_college_profile_mutation_response', affected_rows: number } | null | undefined };

export type HighSchoolColleagueCardFragment = { __typename?: 'espin_high_school_invite', id: any, email: string, status: Espin_Invite_Status_Type_Enum };

export type HighSchoolColleagueInvitesFragment = { __typename?: 'espin_high_school_invite', id: any, email: string, status: Espin_Invite_Status_Type_Enum };

export type ClearHighSchoolInviteMutationVariables = Exact<{
  id: Scalars['uuid'];
  email: Scalars['String'];
}>;


export type ClearHighSchoolInviteMutation = { __typename?: 'mutation_root', delete_espin_high_school_invite_by_pk?: { __typename?: 'espin_high_school_invite', id: any } | null | undefined, delete_espin_high_school_profile?: { __typename?: 'espin_high_school_profile_mutation_response', affected_rows: number } | null | undefined };

export type InviteHighSchoolUsersActionMutationVariables = Exact<{
  input: InviteHighSchoolColleagueActionInput;
}>;


export type InviteHighSchoolUsersActionMutation = { __typename?: 'mutation_root', inviteHighSchoolColleague?: { __typename?: 'InviteHighSchoolColleagueActionOutput', message: string, status: string } | null | undefined };

export type InviteCollegeUsersMutationVariables = Exact<{
  input: Array<Espin_College_Invite_Insert_Input> | Espin_College_Invite_Insert_Input;
}>;


export type InviteCollegeUsersMutation = { __typename?: 'mutation_root', insert_espin_college_invite?: { __typename?: 'espin_college_invite_mutation_response', affected_rows: number } | null | undefined };

export type MessagePreferencesFragment = { __typename?: 'espin_college_preferences', automatic_message_custom?: string | null | undefined, automatic_message_response_type: Espin_College_Automatic_Message_Response_Type_Enum };

export type UpdateCollegePreferencesMutationVariables = Exact<{
  input: Espin_College_Preferences_Insert_Input;
  onConflict: Espin_College_Preferences_On_Conflict;
}>;


export type UpdateCollegePreferencesMutation = { __typename?: 'mutation_root', insert_espin_college_preferences_one?: { __typename?: 'espin_college_preferences', id: any } | null | undefined };

export type NotificationPreferencesFragment = { __typename?: 'espin_user', id: string, email_follow_preference: Espin_Follower_Email_Notification_Type_Enum, email_message_preference?: Espin_Message_Email_Notification_Type_Enum | null | undefined, email_profile_view_preference?: Espin_Profile_View_Email_Notification_Type_Enum | null | undefined };

export type UpdateEmailNotificationPreferencesMutationVariables = Exact<{
  update: Espin_User_Set_Input;
  userId: Scalars['String'];
}>;


export type UpdateEmailNotificationPreferencesMutation = { __typename?: 'mutation_root', update_espin_user_by_pk?: { __typename?: 'espin_user', id: string } | null | undefined };

export type GetFollowersForCollegesQueryVariables = Exact<{
  collegeId: Scalars['uuid'];
  date: Scalars['timestamptz'];
}>;


export type GetFollowersForCollegesQuery = { __typename?: 'query_root', my_follows: Array<{ __typename?: 'espin_follow', high_school_id?: any | null | undefined, player_user_id?: string | null | undefined }>, espin_follow: Array<{ __typename?: 'espin_follow', id: any, player_user?: { __typename?: 'espin_user', id: string, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', id: any, name: string, slug?: string | null | undefined, contact_name?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, espin_follow_aggregate: { __typename?: 'espin_follow_aggregate', aggregate?: { __typename?: 'espin_follow_aggregate_fields', count: number } | null | undefined }, high_school_follows: Array<{ __typename?: 'espin_follow', id: any, player_user?: { __typename?: 'espin_user', id: string, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', id: any, name: string, slug?: string | null | undefined, contact_name?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, espin_graduating_class: Array<{ __typename?: 'espin_graduating_class', grad_class_years: string }> };

export type GetFollowersForHighSchoolsQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
  date: Scalars['timestamptz'];
}>;


export type GetFollowersForHighSchoolsQuery = { __typename?: 'query_root', following: Array<{ __typename?: 'espin_follow', college_id: any }>, espin_follow: Array<{ __typename?: 'espin_follow', id: any, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } }>, espin_follow_aggregate: { __typename?: 'espin_follow_aggregate', aggregate?: { __typename?: 'espin_follow_aggregate_fields', count: number } | null | undefined } };

export type PlayerFollowersFragment = { __typename?: 'espin_follow', id: any, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } };

export type FollowCollegeMutationVariables = Exact<{
  collegeId: Scalars['uuid'];
}>;


export type FollowCollegeMutation = { __typename?: 'mutation_root', insert_espin_follow_one?: { __typename?: 'espin_follow', id: any } | null | undefined };

export type UnfollowCollegeMutationVariables = Exact<{
  playerUserId?: Maybe<Scalars['String']>;
  collegeId: Scalars['uuid'];
}>;


export type UnfollowCollegeMutation = { __typename?: 'mutation_root', delete_espin_follow?: { __typename?: 'espin_follow_mutation_response', returning: Array<{ __typename?: 'espin_follow', id: any }> } | null | undefined };

export type FollowerCollegesForPlayersQueryVariables = Exact<{
  closeSearch: Espin_College_Bool_Exp;
  farSearch: Espin_College_Bool_Exp;
  playerUserId: Scalars['String'];
  date: Scalars['timestamptz'];
}>;


export type FollowerCollegesForPlayersQuery = { __typename?: 'query_root', following: Array<{ __typename?: 'espin_follow', college_id: any }>, close_follow: Array<{ __typename?: 'espin_follow', id: any, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } }>, close_aggregate: { __typename?: 'espin_follow_aggregate', aggregate?: { __typename?: 'espin_follow_aggregate_fields', count: number } | null | undefined }, far_follow: Array<{ __typename?: 'espin_follow', id: any, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } }>, far_aggregate: { __typename?: 'espin_follow_aggregate', aggregate?: { __typename?: 'espin_follow_aggregate_fields', count: number } | null | undefined } };

export type GetFollowingPlayersForCollegesQueryVariables = Exact<{
  collegeId: Scalars['uuid'];
}>;


export type GetFollowingPlayersForCollegesQuery = { __typename?: 'query_root', espin_follow: Array<{ __typename?: 'espin_follow', id: any, player_user?: { __typename?: 'espin_user', id: string, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', id: any, name: string, slug?: string | null | undefined, contact_name?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, high_school_following: Array<{ __typename?: 'espin_follow', id: any, player_user?: { __typename?: 'espin_user', id: string, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', id: any, name: string, slug?: string | null | undefined, contact_name?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, espin_graduating_class: Array<{ __typename?: 'espin_graduating_class', grad_class_years: string }> };

export type GetFollowingCollegesForHighSchoolQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
}>;


export type GetFollowingCollegesForHighSchoolQuery = { __typename?: 'query_root', espin_follow: Array<{ __typename?: 'espin_follow', id: any, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } }> };

export type GetChildProfilesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetChildProfilesQuery = { __typename?: 'query_root', espin_parent_profile: Array<{ __typename?: 'espin_parent_profile', child_profiles: Array<{ __typename?: 'espin_player_profile', user_id: string, spin_username: string, address?: { __typename?: 'espin_address', location?: any | null | undefined } | null | undefined, profile_image?: { __typename?: 'content_file', cdn_url?: string | null | undefined } | null | undefined }> }> };

export type PlayerFollowingFragment = { __typename?: 'espin_follow', id: any, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } };

export type FollowingCollegesForPlayersQueryVariables = Exact<{
  closeSearch: Espin_College_Bool_Exp;
  farSearch: Espin_College_Bool_Exp;
}>;


export type FollowingCollegesForPlayersQuery = { __typename?: 'query_root', all_follows: Array<{ __typename?: 'espin_follow', id: any, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } }>, close_colleges: Array<{ __typename?: 'espin_follow', id: any, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } }>, far_colleges: Array<{ __typename?: 'espin_follow', id: any, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } }> };

export type CollegeFollowCardFragment = { __typename?: 'espin_follow', id: any, player_user?: { __typename?: 'espin_user', id: string, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', id: any, name: string, slug?: string | null | undefined, contact_name?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type FollowCardFragment = { __typename?: 'espin_follow', id: any, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } };

export type HighSchoolFollowCardFragment = { __typename?: 'espin_follow', id: any, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } };

export type NotificationCardFragment = { __typename?: 'espin_notification', id: any, notification_type: Espin_Notification_Type_Enum, viewed_at?: any | null | undefined, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type NotificationsCardFragment = { __typename?: 'espin_notification', id: any, notification_type: Espin_Notification_Type_Enum, viewed_at?: any | null | undefined, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type MarkAllAsReadMutationVariables = Exact<{
  _in?: Maybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type MarkAllAsReadMutation = { __typename?: 'mutation_root', update_espin_notification?: { __typename?: 'espin_notification_mutation_response', affected_rows: number } | null | undefined };

export type ParentRecruitingHubNotificationsFragment = { __typename?: 'espin_notification', player_user_id?: string | null | undefined, id: any, notification_type: Espin_Notification_Type_Enum, viewed_at?: any | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, parent_profile?: { __typename?: 'espin_parent_profile', child_profiles: Array<{ __typename?: 'espin_player_profile', user_id: string, spin_username: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> } | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type ParentRecruitingHubFollowsFragment = { __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined };

export type ParentRecruitingHubMessagesFragment = { __typename?: 'espin_message', id: any, player_user_id?: string | null | undefined };

export type ParentRecruitingHubProfileViewsFragment = { __typename?: 'espin_profile_view', id: any, player_user_id?: string | null | undefined };

export type RecruitingHubEventsFragment = { __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type RecruitingHubNotificationsFragment = { __typename?: 'espin_notification', id: any, notification_type: Espin_Notification_Type_Enum, viewed_at?: any | null | undefined, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type RecruitingHubFollowsFragment = { __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined };

export type RecruitingHubMessagesFragment = { __typename?: 'espin_message', id: any, player_user_id?: string | null | undefined };

export type RecruitingHubProfileViewsFragment = { __typename?: 'espin_profile_view', id: any, player_user_id?: string | null | undefined };

export type UpcomingEventsCardFragment = { __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type ConversationStartedCardFragment = { __typename?: 'espin_notification', college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type FollowerCardFragment = { __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type InterestedInCardFragment = { __typename?: 'espin_notification', player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type MessageCardFragment = { __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined };

export type ProfileViewCardFragment = { __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined };

export type ConversationCardFragment = { __typename?: 'espin_message', player_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, id: any, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type ConversationContainerFragment = { __typename?: 'espin_message', player_user_id?: string | null | undefined, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, college_user_id?: string | null | undefined, message_type: Espin_Message_Type_Enum, contents: string, created_at: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', id: any, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type InboxFragment = { __typename?: 'espin_message', player_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, id: any, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type InboxContainerFragment = { __typename?: 'espin_message', player_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, id: any, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type MessageContainerFragment = { __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, contents: string, created_at: any, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string } | null | undefined };

export type MessagesCardFragment = { __typename?: 'espin_message', player_user_id?: string | null | undefined, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, college_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, id: any, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, id: any, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type SelectedConversationContentFragment = { __typename?: 'espin_message', player_user_id?: string | null | undefined, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, college_user_id?: string | null | undefined, message_type: Espin_Message_Type_Enum, contents: string, created_at: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', id: any, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type CreateMessageMutationVariables = Exact<{
  input: Espin_Message_Insert_Input;
}>;


export type CreateMessageMutation = { __typename?: 'mutation_root', insert_espin_message_one?: { __typename?: 'espin_message', id: any } | null | undefined };

export type CollegeChatBubblesFragment = { __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, contents: string, created_at: any, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string } | null | undefined };

export type CollegeConversationCardFragment = { __typename?: 'espin_message', college_id?: any | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, parent_user_id?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type CollegeIncomingChatBubbleFragment = { __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, contents: string, created_at: any, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string } | null | undefined };

export type CollegeSelectedConversationFragment = { __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, contents: string, created_at: any, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', id: any, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string } | null | undefined };

export type CollegeSendsMessageFragment = { __typename?: 'espin_message', contents: string, created_at: any, college?: { __typename?: 'espin_college', name: string } | null | undefined };

export type PlayerChatBubblesFragment = { __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, contents: string, created_at: any, parent_user_id?: string | null | undefined, college?: { __typename?: 'espin_college', name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string } | null | undefined };

export type PlayerSelectedConversationFragment = { __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, contents: string, created_at: any, parent_user_id?: string | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string } | null | undefined };

export type HighSchoolSendsMessageFragment = { __typename?: 'espin_message', contents: string, created_at: any, high_school?: { __typename?: 'espin_high_school', name: string } | null | undefined };

export type MyChatBubbleFragment = { __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, contents: string, created_at: any, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string } | null | undefined };

export type PlayerConversationCardFragment = { __typename?: 'espin_message', player_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type PlayerIncomingChatBubbleFragment = { __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, contents: string, created_at: any, parent_user_id?: string | null | undefined, college?: { __typename?: 'espin_college', name: string } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string } | null | undefined };

export type PlayerSendsMessageFragment = { __typename?: 'espin_message', contents: string, created_at: any, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined };

export type HighSchoolMyEventsQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
}>;


export type HighSchoolMyEventsQuery = { __typename?: 'query_root', espin_team: Array<{ __typename?: 'espin_team', display_name: string, event_registrations: Array<{ __typename?: 'espin_event_registration', event: { __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> } }> }> };

export type HighSchoolTeamEventRegistrationsCardFragment = { __typename?: 'espin_team', display_name: string, event_registrations: Array<{ __typename?: 'espin_event_registration', event: { __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> } }> };

export type MyEventsCardFragment = { __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type MyEventsCardPlayerFragment = { __typename?: 'espin_player_profile', spin_username: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type MyUpcomingEventsFragment = { __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, event_registrations: Array<{ __typename?: 'espin_event_registration', id: any }>, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type ParentMyEventsQueryVariables = Exact<{
  id: Scalars['String'];
  primaryGames: Array<Espin_Game_Definition_Enum> | Espin_Game_Definition_Enum;
  hasPrimaries: Scalars['Boolean'];
}>;


export type ParentMyEventsQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', parent_profile?: { __typename?: 'espin_parent_profile', child_profiles: Array<{ __typename?: 'espin_player_profile', spin_username: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> } | null | undefined } | null | undefined, admin_recommended_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, event_registrations: Array<{ __typename?: 'espin_event_registration', id: any }>, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }>, recommended_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, event_registrations: Array<{ __typename?: 'espin_event_registration', id: any }>, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }>, any_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, event_registrations: Array<{ __typename?: 'espin_event_registration', id: any }>, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }>, registered_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }> };

export type PlayerMyEventsQueryVariables = Exact<{
  id: Scalars['String'];
  playerPrimaryGame?: Maybe<Espin_Game_Definition_Enum>;
  hasPrimary: Scalars['Boolean'];
}>;


export type PlayerMyEventsQuery = { __typename?: 'query_root', admin_recommended_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, event_registrations: Array<{ __typename?: 'espin_event_registration', id: any }>, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }>, recommended_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, event_registrations: Array<{ __typename?: 'espin_event_registration', id: any }>, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }>, any_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, event_registrations: Array<{ __typename?: 'espin_event_registration', id: any }>, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }>, registered_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }> };

export type EditableGameFragment = { __typename?: 'espin_player_game', id: any, rank?: string | null | undefined, role?: string | null | undefined, primary: boolean, tracker?: string | null | undefined, in_game_username?: string | null | undefined, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } };

export type ParentMyGamesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ParentMyGamesQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', parent_profile?: { __typename?: 'espin_parent_profile', child_profiles: Array<{ __typename?: 'espin_player_profile', spin_username: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', id: any, rank?: string | null | undefined, role?: string | null | undefined, primary: boolean, tracker?: string | null | undefined, in_game_username?: string | null | undefined, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }> } | null | undefined } | null | undefined };

export type PlayerMyGamesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PlayerMyGamesQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', player_games: Array<{ __typename?: 'espin_player_game', id: any, rank?: string | null | undefined, role?: string | null | undefined, primary: boolean, tracker?: string | null | undefined, in_game_username?: string | null | undefined, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> } | null | undefined } | null | undefined };

export type DeleteMyPlayerGameMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteMyPlayerGameMutation = { __typename?: 'mutation_root', delete_espin_player_game_by_pk?: { __typename?: 'espin_player_game', id: any } | null | undefined };

export type DeleteMyPlayerGameAndChangePrimaryGameMutationVariables = Exact<{
  id: Scalars['uuid'];
  newPrimaryId: Scalars['uuid'];
}>;


export type DeleteMyPlayerGameAndChangePrimaryGameMutation = { __typename?: 'mutation_root', delete_espin_player_game_by_pk?: { __typename?: 'espin_player_game', id: any } | null | undefined, update_espin_player_game?: { __typename?: 'espin_player_game_mutation_response', affected_rows: number } | null | undefined };

export type CollegeMyProfileQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type CollegeMyProfileQuery = { __typename?: 'query_root', espin_college_by_pk?: { __typename?: 'espin_college', program_name?: string | null | undefined, scholarships: boolean, bio?: string | null | undefined, contact_email?: string | null | undefined, phone?: string | null | undefined, academic_notes?: string | null | undefined, min_gpa?: string | null | undefined, min_sat?: string | null | undefined, min_act?: string | null | undefined, name: string, id: any, in_state_tuition?: string | null | undefined, out_of_state_tuition?: string | null | undefined, slug?: string | null | undefined, header_media_link?: { __typename?: 'content_media_link', link_data: string, link_type: Content_Media_Link_Type_Enum } | null | undefined, college_images: Array<{ __typename?: 'espin_college_image', file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }>, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, address?: { __typename?: 'espin_address', state: string, city: string, country?: string | null | undefined, location?: any | null | undefined } | null | undefined, socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, website?: string | null | undefined, twitch?: string | null | undefined, discord?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined };

export type HighSchoolMyProfileQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type HighSchoolMyProfileQuery = { __typename?: 'query_root', espin_high_school_by_pk?: { __typename?: 'espin_high_school', name: string, bio?: string | null | undefined, contact_email?: string | null | undefined, contact_name?: string | null | undefined, id: any, contact_phone?: string | null | undefined, slug?: string | null | undefined, address?: { __typename?: 'espin_address', state: string, city: string, country?: string | null | undefined, location?: any | null | undefined } | null | undefined, teams: Array<{ __typename?: 'espin_team', id: any, display_name: string, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string }, members: Array<{ __typename?: 'espin_team_members', team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, slug: string, id: any } | null | undefined }> }>, esportsTeams: Array<{ __typename?: 'espin_team', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }>, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitch?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, discord?: string | null | undefined, website?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined } | null | undefined };

export type PlayerMyProfileQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type PlayerMyProfileQuery = { __typename?: 'query_root', espin_player_profile_by_pk?: { __typename?: 'espin_player_profile', id: any, spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, bio?: string | null | undefined, slug: string, committed_to_college?: string | null | undefined, user_id: string, phone?: string | null | undefined, gpa: any, graduating_class?: string | null | undefined, preferred_study_fields?: any | null | undefined, preferred_schools?: any | null | undefined, college_name?: string | null | undefined, hs_name?: string | null | undefined, is_hs: boolean, player_vods: Array<{ __typename?: 'espin_player_vod', id: any, label?: string | null | undefined, media_link: { __typename?: 'content_media_link', id: any, link_data: string, link_type: Content_Media_Link_Type_Enum } }>, primary_game: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, role?: string | null | undefined, tracker?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, user: { __typename?: 'espin_user', email: string, id: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined }, social?: { __typename?: 'espin_social', discord?: string | null | undefined, twitter?: string | null | undefined, facebook?: string | null | undefined, tiktok?: string | null | undefined, instagram?: string | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, linked_high_school_details?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined } | null | undefined } | null | undefined };

export type DeleteHighSchoolTeamInvitesMutationVariables = Exact<{
  inviteIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type DeleteHighSchoolTeamInvitesMutation = { __typename?: 'mutation_root', delete_espin_team_invite?: { __typename?: 'espin_team_invite_mutation_response', affected_rows: number } | null | undefined };

export type HighSchoolTeamInviteFragment = { __typename?: 'espin_team_invite', id: any, status: Espin_Invite_Status_Type_Enum, user?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined } | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined };

export type DeleteHighSchoolTeamMembersMutationVariables = Exact<{
  memberIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type DeleteHighSchoolTeamMembersMutation = { __typename?: 'mutation_root', delete_espin_team_members?: { __typename: 'espin_team_members_mutation_response', affected_rows: number } | null | undefined };

export type HighSchoolTeamMemberFragment = { __typename?: 'espin_team_members', id: any, team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, id: any, social?: { __typename?: 'espin_social', discord?: string | null | undefined } | null | undefined } | null | undefined };

export type HighSchoolEmptyTeamCardFragment = { __typename?: 'espin_team', team_invites: Array<{ __typename?: 'espin_team_invite', id: any }>, members: Array<{ __typename?: 'espin_team_members', id: any }> };

export type HighSchoolMyPlayerCardFragment = { __typename?: 'espin_player_profile', id: any, spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_teams: Array<{ __typename?: 'espin_team_members', team?: { __typename?: 'espin_team', display_name: string, high_school?: { __typename?: 'espin_high_school', high_school_profiles: Array<{ __typename?: 'espin_high_school_profile', user_id: string }> } | null | undefined } | null | undefined }>, user: { __typename?: 'espin_user', player_user_messages: Array<{ __typename?: 'espin_message', college_user?: { __typename?: 'espin_user', college_profile?: { __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, college_owner?: { __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined }> } };

export type HighSchoolMyPlayersPageQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
}>;


export type HighSchoolMyPlayersPageQuery = { __typename?: 'query_root', espin_team: Array<{ __typename?: 'espin_team', members: Array<{ __typename?: 'espin_team_members', player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_teams: Array<{ __typename?: 'espin_team_members', team?: { __typename?: 'espin_team', display_name: string, high_school?: { __typename?: 'espin_high_school', high_school_profiles: Array<{ __typename?: 'espin_high_school_profile', user_id: string }> } | null | undefined } | null | undefined }>, user: { __typename?: 'espin_user', player_user_messages: Array<{ __typename?: 'espin_message', college_user?: { __typename?: 'espin_user', college_profile?: { __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, college_owner?: { __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined }> } } | null | undefined }> }> };

export type UniqueTeamMemberFragment = { __typename?: 'espin_team_members', player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_teams: Array<{ __typename?: 'espin_team_members', team?: { __typename?: 'espin_team', display_name: string, high_school?: { __typename?: 'espin_high_school', high_school_profiles: Array<{ __typename?: 'espin_high_school_profile', user_id: string }> } | null | undefined } | null | undefined }>, user: { __typename?: 'espin_user', player_user_messages: Array<{ __typename?: 'espin_message', college_user?: { __typename?: 'espin_user', college_profile?: { __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, college_owner?: { __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined }> } } | null | undefined };

export type HighSchoolMyTeamsPageQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
}>;


export type HighSchoolMyTeamsPageQuery = { __typename?: 'query_root', espin_team: Array<{ __typename?: 'espin_team', id: any, display_name: string, team_type: Espin_Team_Type_Enum, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string }, event_registrations: Array<{ __typename?: 'espin_event_registration', event: { __typename?: 'espin_event', name: string } }>, team_invites: Array<{ __typename?: 'espin_team_invite', id: any, status: Espin_Invite_Status_Type_Enum, user?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined } | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined }>, members: Array<{ __typename?: 'espin_team_members', id: any, team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, id: any, social?: { __typename?: 'espin_social', discord?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type DeleteHighSchoolTeamMutationVariables = Exact<{
  teamId: Scalars['uuid'];
}>;


export type DeleteHighSchoolTeamMutation = { __typename?: 'mutation_root', delete_espin_event_registration?: { __typename?: 'espin_event_registration_mutation_response', returning: Array<{ __typename?: 'espin_event_registration', event: { __typename?: 'espin_event', id: any, name: string }, event_ticket: { __typename?: 'espin_event_ticket', id: any, price_temp: any, price_id?: string | null | undefined } }> } | null | undefined, delete_espin_team_invite?: { __typename?: 'espin_team_invite_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'espin_team_invite', id: any }> } | null | undefined, update_espin_team_by_pk?: { __typename?: 'espin_team', id: any } | null | undefined };

export type HighSchoolTeamCardFragment = { __typename?: 'espin_team', id: any, display_name: string, team_type: Espin_Team_Type_Enum, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string }, event_registrations: Array<{ __typename?: 'espin_event_registration', event: { __typename?: 'espin_event', name: string } }>, team_invites: Array<{ __typename?: 'espin_team_invite', id: any, status: Espin_Invite_Status_Type_Enum, user?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined } | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined }>, members: Array<{ __typename?: 'espin_team_members', id: any, team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, id: any, social?: { __typename?: 'espin_social', discord?: string | null | undefined } | null | undefined } | null | undefined }> };

export type HighSchoolTeamInviteListFragment = { __typename?: 'espin_team', team_invites: Array<{ __typename?: 'espin_team_invite', id: any, status: Espin_Invite_Status_Type_Enum, user?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined } | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined }> };

export type HighSchoolTeamPlayerListFragment = { __typename?: 'espin_team', members: Array<{ __typename?: 'espin_team_members', id: any, team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, id: any, social?: { __typename?: 'espin_social', discord?: string | null | undefined } | null | undefined } | null | undefined }> };

export type EditableMyPlayerCardFragment = { __typename?: 'espin_player_profile', spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, user: { __typename?: 'espin_user', email: string } };

export type MyPlayerCardFragment = { __typename?: 'espin_player_profile', spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type ParentMyPlayersFieldsFragment = { __typename?: 'espin_player_profile', id: any, spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, user: { __typename?: 'espin_user', email: string } };

export type ParentMyPlayersFieldsOnRemoveCallbackFragment = { __typename?: 'espin_player_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined };

export type ParentMyPlayersProfileFragment = { __typename?: 'espin_player_profile', id: any, spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, bio?: string | null | undefined, slug: string, committed_to_college?: string | null | undefined, user_id: string, phone?: string | null | undefined, gpa: any, graduating_class?: string | null | undefined, preferred_study_fields?: any | null | undefined, preferred_schools?: any | null | undefined, college_name?: string | null | undefined, hs_name?: string | null | undefined, is_hs: boolean, player_vods: Array<{ __typename?: 'espin_player_vod', id: any, label?: string | null | undefined, media_link: { __typename?: 'content_media_link', id: any, link_data: string, link_type: Content_Media_Link_Type_Enum } }>, primary_game: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, role?: string | null | undefined, tracker?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, user: { __typename?: 'espin_user', email: string, id: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined }, social?: { __typename?: 'espin_social', discord?: string | null | undefined, twitter?: string | null | undefined, facebook?: string | null | undefined, tiktok?: string | null | undefined, instagram?: string | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, linked_high_school_details?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined } | null | undefined };

export type ParentMyPlayersProfilesQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ParentMyPlayersProfilesQuery = { __typename?: 'query_root', espin_parent_profile_by_pk?: { __typename?: 'espin_parent_profile', child_profiles: Array<{ __typename?: 'espin_player_profile', spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> } | null | undefined };

export type ParentMyProfileQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ParentMyProfileQuery = { __typename?: 'query_root', espin_parent_profile_by_pk?: { __typename?: 'espin_parent_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, phone?: string | null | undefined, child_profiles: Array<{ __typename?: 'espin_player_profile', id: any, spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, user: { __typename?: 'espin_user', email: string } }> } | null | undefined };

export type ParentProfileFormFragment = { __typename?: 'espin_parent_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, phone?: string | null | undefined, child_profiles: Array<{ __typename?: 'espin_player_profile', id: any, spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, user: { __typename?: 'espin_user', email: string } }> };

export type UpdateParentProfileFormMutationVariables = Exact<{
  id: Scalars['uuid'];
  input: Espin_Parent_Profile_Set_Input;
}>;


export type UpdateParentProfileFormMutation = { __typename?: 'mutation_root', update_espin_parent_profile_by_pk?: { __typename?: 'espin_parent_profile', id: any } | null | undefined };

export type RemoveChildProfileParentProfileFormMutationVariables = Exact<{
  playerProfileId: Scalars['uuid'];
}>;


export type RemoveChildProfileParentProfileFormMutation = { __typename?: 'mutation_root', removeChildPlayer?: { __typename?: 'RemoveChildPlayerOutput', valid: boolean } | null | undefined };

export type SubscriptionMyPlayerCardFragment = { __typename?: 'espin_player_profile', spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, subscription?: { __typename?: 'espin_player_subscription', expires: any } | null | undefined };

export type PlayerEmptyTeamCardFragment = { __typename?: 'espin_team', team_invites: Array<{ __typename?: 'espin_team_invite', id: any }>, members: Array<{ __typename?: 'espin_team_members', id: any }> };

export type PlayerMyTeamsPageQueryVariables = Exact<{
  user_id: Scalars['String'];
}>;


export type PlayerMyTeamsPageQuery = { __typename?: 'query_root', espin_team_invite: Array<{ __typename?: 'espin_team_invite', id: any, status: Espin_Invite_Status_Type_Enum, team: { __typename?: 'espin_team', id: any, team_type: Espin_Team_Type_Enum, display_name: string, high_school?: { __typename?: 'espin_high_school', id: any, name: string, slug?: string | null | undefined } | null | undefined, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } } }>, espin_team: Array<{ __typename?: 'espin_team', id: any, team_type: Espin_Team_Type_Enum, display_name: string, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string }, members: Array<{ __typename?: 'espin_team_members', id: any, team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, id: any, social?: { __typename?: 'espin_social', discord?: string | null | undefined } | null | undefined } | null | undefined }>, event_registrations: Array<{ __typename?: 'espin_event_registration', event: { __typename?: 'espin_event', name: string } }>, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined } | null | undefined, team_invites: Array<{ __typename?: 'espin_team_invite', id: any, status: Espin_Invite_Status_Type_Enum, user?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined } | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined }> }>, espin_player_profile: Array<{ __typename?: 'espin_player_profile', id: any, linked_high_school?: any | null | undefined, hs_name?: string | null | undefined }> };

export type PlayerMyTeamsInviteFragment = { __typename?: 'espin_team_invite', id: any, status: Espin_Invite_Status_Type_Enum, team: { __typename?: 'espin_team', id: any, team_type: Espin_Team_Type_Enum, display_name: string, high_school?: { __typename?: 'espin_high_school', id: any, name: string, slug?: string | null | undefined } | null | undefined, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } } };

export type PlayerMyTeamsTeamFragment = { __typename?: 'espin_team', id: any, team_type: Espin_Team_Type_Enum, display_name: string, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string }, members: Array<{ __typename?: 'espin_team_members', id: any, team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, id: any, social?: { __typename?: 'espin_social', discord?: string | null | undefined } | null | undefined } | null | undefined }>, event_registrations: Array<{ __typename?: 'espin_event_registration', event: { __typename?: 'espin_event', name: string } }>, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined } | null | undefined, team_invites: Array<{ __typename?: 'espin_team_invite', id: any, status: Espin_Invite_Status_Type_Enum, user?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined } | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined }> };

export type PlayerTeamPlayerListFragment = { __typename?: 'espin_team', members: Array<{ __typename?: 'espin_team_members', id: any, team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string } | null | undefined }> };

export type PlayerVodMediaLinkTypesFragment = { __typename?: 'content_media_link_type', comment: string, name: string };

export type AddPlayerVodMutationVariables = Exact<{
  input: Espin_Player_Vod_Insert_Input;
}>;


export type AddPlayerVodMutation = { __typename?: 'mutation_root', insert_espin_player_vod_one?: { __typename?: 'espin_player_vod', id: any } | null | undefined };

export type PlayerVodsPageQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type PlayerVodsPageQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', bio?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, spin_username: string, slug: string, player_vods: Array<{ __typename?: 'espin_player_vod', id: any, label?: string | null | undefined, media_link: { __typename?: 'content_media_link', id: any, link_data: string, link_type: Content_Media_Link_Type_Enum } }> } | null | undefined } | null | undefined, content_media_link_type: Array<{ __typename?: 'content_media_link_type', comment: string, name: string }> };

export type DeletePlayerVodMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeletePlayerVodMutation = { __typename?: 'mutation_root', update_espin_player_vod_by_pk?: { __typename?: 'espin_player_vod', id: any } | null | undefined };

export type ProfileVodDisplayComponentFragment = { __typename?: 'espin_player_vod', id: any, label?: string | null | undefined, media_link: { __typename?: 'content_media_link', id: any, link_data: string, link_type: Content_Media_Link_Type_Enum } };

export type AllProfileViewsCardFragment = { __typename?: 'espin_profile_view', id: any, college_id: any, college_user_id?: string | null | undefined, college_user_full_name?: string | null | undefined, parent_user_id?: string | null | undefined, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', id: string, deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', id: any, slug?: string | null | undefined, name: string, contact_name?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined };

export type GetAllProfileViewDataForCollegesQueryVariables = Exact<{
  id: Scalars['uuid'];
  vt?: Maybe<Array<Espin_Profile_View_Type_Enum> | Espin_Profile_View_Type_Enum>;
  date?: Maybe<Scalars['timestamptz']>;
}>;


export type GetAllProfileViewDataForCollegesQuery = { __typename?: 'query_root', espin_follow: Array<{ __typename?: 'espin_follow', player_user_id?: string | null | undefined, high_school_id?: any | null | undefined }>, espin_profile_view: Array<{ __typename?: 'espin_profile_view', id: any, college_id: any, college_user_id?: string | null | undefined, college_user_full_name?: string | null | undefined, parent_user_id?: string | null | undefined, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', id: string, deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', id: any, slug?: string | null | undefined, name: string, contact_name?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, espin_profile_view_aggregate: { __typename?: 'espin_profile_view_aggregate', aggregate?: { __typename?: 'espin_profile_view_aggregate_fields', count: number } | null | undefined } };

export type GetAllProfileViewDataForHighSchoolsQueryVariables = Exact<{
  id: Scalars['uuid'];
  vt?: Maybe<Array<Espin_Profile_View_Type_Enum> | Espin_Profile_View_Type_Enum>;
  date?: Maybe<Scalars['timestamptz']>;
}>;


export type GetAllProfileViewDataForHighSchoolsQuery = { __typename?: 'query_root', espin_follow: Array<{ __typename?: 'espin_follow', college_id: any }>, espin_profile_view: Array<{ __typename?: 'espin_profile_view', id: any, college_id: any, college_user_id?: string | null | undefined, college_user_full_name?: string | null | undefined, parent_user_id?: string | null | undefined, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', id: string, deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', id: any, slug?: string | null | undefined, name: string, contact_name?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, espin_profile_view_aggregate: { __typename?: 'espin_profile_view_aggregate', aggregate?: { __typename?: 'espin_profile_view_aggregate_fields', count: number } | null | undefined } };

export type ChildDataFragment = { __typename?: 'espin_parent_profile', child_profiles: Array<{ __typename?: 'espin_player_profile', user_id: string, spin_username: string, address?: { __typename?: 'espin_address', location?: any | null | undefined } | null | undefined, profile_image?: { __typename?: 'content_file', cdn_url?: string | null | undefined } | null | undefined }> };

export type GetAllProfileViewDataForPlayersQueryVariables = Exact<{
  userId?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['timestamptz']>;
}>;


export type GetAllProfileViewDataForPlayersQuery = { __typename?: 'query_root', espin_follow: Array<{ __typename?: 'espin_follow', college_id: any }>, espin_profile_view: Array<{ __typename?: 'espin_profile_view', id: any, college_id: any, college_user_id?: string | null | undefined, college_user_full_name?: string | null | undefined, parent_user_id?: string | null | undefined, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', id: string, deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', id: any, slug?: string | null | undefined, name: string, contact_name?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, espin_profile_view_aggregate: { __typename?: 'espin_profile_view_aggregate', aggregate?: { __typename?: 'espin_profile_view_aggregate_fields', count: number } | null | undefined } };

export type ProfileViewsFragment = { __typename?: 'espin_profile_view', id: any, college_id: any, college_user_id?: string | null | undefined, college_user_full_name?: string | null | undefined, parent_user_id?: string | null | undefined, college: { __typename?: 'espin_college', id: any, slug?: string | null | undefined, name: string, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', id: string, deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', id: any, slug?: string | null | undefined, name: string, contact_name?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined };

export type PlayerReportCardInfoFragment = { __typename?: 'espin_event_registration', registration_details?: any | null | undefined, event_ticket: { __typename?: 'espin_event_ticket', ticket_type: Espin_Event_Ticket_Type_Enum }, user: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } };

export type PlayerReportGameContainerFragment = { __typename?: 'espin_event_registration', event_ticket: { __typename?: 'espin_event_ticket', game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } | null | undefined }, user: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', player_games: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, role?: string | null | undefined, tracker?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } };

export type EventReportFragment = { __typename?: 'espin_event', name: string, slug: string, stream_url?: string | null | undefined, prize: any, event_start_date: any, event_end_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type ScoutingReportPlayerCardFragment = { __typename?: 'espin_event_registration', registration_details?: any | null | undefined, user: { __typename?: 'espin_user', id: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined, player_profile?: { __typename?: 'espin_player_profile', graduating_class?: string | null | undefined, gpa: any, slug: string, first_name?: string | null | undefined, last_name?: string | null | undefined, phone?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, role?: string | null | undefined, tracker?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, social?: { __typename?: 'espin_social', discord?: string | null | undefined } | null | undefined, user: { __typename?: 'espin_user', email: string, id: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined } } | null | undefined }, event_ticket: { __typename?: 'espin_event_ticket', ticket_type: Espin_Event_Ticket_Type_Enum, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } | null | undefined } };

export type ScoutingReportPlayerCardsFragment = { __typename?: 'espin_event_registration', registration_details?: any | null | undefined, user: { __typename?: 'espin_user', id: string, player_profile?: { __typename?: 'espin_player_profile', id: any, graduating_class?: string | null | undefined, gpa: any, slug: string, first_name?: string | null | undefined, last_name?: string | null | undefined, phone?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, role?: string | null | undefined, tracker?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, social?: { __typename?: 'espin_social', discord?: string | null | undefined } | null | undefined, user: { __typename?: 'espin_user', email: string, id: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined } } | null | undefined, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined }, event_ticket: { __typename?: 'espin_event_ticket', ticket_type: Espin_Event_Ticket_Type_Enum, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } | null | undefined } };

export type CreateCollegeReferralCodeRedemptionMutationVariables = Exact<{
  input: RedeemCollegeReferralCodeInsertInput;
}>;


export type CreateCollegeReferralCodeRedemptionMutation = { __typename?: 'mutation_root', redeemCollegeReferralCode?: { __typename?: 'RedeemCollegeReferralCodeInsertOutput', codeId: any } | null | undefined };

export type ParentChildSubscriptionsFragment = { __typename?: 'espin_player_profile', spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, subscription?: { __typename?: 'espin_player_subscription', id: any, expires: any } | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type CreatePlayerReferralCodeRedemptionMutationVariables = Exact<{
  input: RedeemPlayerReferralCodeInsertInput;
}>;


export type CreatePlayerReferralCodeRedemptionMutation = { __typename?: 'mutation_root', redeemPlayerReferralCode?: { __typename?: 'RedeemPlayerReferralCodeInsertOutput', codeId: any } | null | undefined };

export type PlayerSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerSubscriptionsQuery = { __typename?: 'query_root', espin_boolean_feature_flag: Array<{ __typename?: 'espin_boolean_feature_flag', value: boolean }>, espin_referral_option: Array<{ __typename?: 'espin_referral_option', id: any }> };

export type EventGameDisplayFragment = { __typename?: 'espin_event', event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', name: string } }> };

export type EventInfoWidgetFragment = { __typename?: 'espin_event', name: string, event_start_date: any, event_end_date: any, type: Espin_Event_Type_Enum, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type EventListingFragment = { __typename?: 'espin_event', slug: string, id: any, name: string, event_start_date: any, event_end_date: any, type: Espin_Event_Type_Enum, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', name: string } }> };

export type EventCardFragment = { __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type EventCardContentFragment = { __typename?: 'espin_event', name: string, slug: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type EventCardHeaderFragment = { __typename?: 'espin_event', name: string, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type EventGamesFragment = { __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } };

export type EventHeaderFragment = { __typename?: 'espin_event', name: string, event_start_date: any, prize: any, event_end_date: any, type: Espin_Event_Type_Enum, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type EventInfoFragment = { __typename?: 'espin_event', short_description?: string | null | undefined, event_start_date: any, event_end_date: any, body_content?: string | null | undefined, rules_content?: string | null | undefined };

export type EventRegistrationFragment = { __typename?: 'espin_event', prize: any, registration_disclaimer?: string | null | undefined, register_end_date: any, register_start_date: any, event_tickets: Array<{ __typename?: 'espin_event_ticket', id: any, ticket_type: Espin_Event_Ticket_Type_Enum, description?: string | null | undefined, price_temp: any, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } | null | undefined, event: { __typename?: 'espin_event', slug: string } }> };

export type EventTicketRegistrationsFragment = { __typename?: 'espin_event', event_tickets: Array<{ __typename?: 'espin_event_ticket', id: any, event_registrations: Array<{ __typename?: 'espin_event_registration', id: any }> }> };

export type EventTicketsFragment = { __typename?: 'espin_event_ticket', id: any, ticket_type: Espin_Event_Ticket_Type_Enum, description?: string | null | undefined, price_temp: any, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } | null | undefined, event: { __typename?: 'espin_event', slug: string } };

export type TicketRegistrationsFragment = { __typename?: 'espin_event', event_tickets: Array<{ __typename?: 'espin_event_ticket', id: any, event_registrations: Array<{ __typename?: 'espin_event_registration', id: any }> }> };

export type EventCustomFieldFormEntryFragment = { __typename?: 'espin_event', event_custom_fields: Array<{ __typename?: 'espin_event_custom_field', id: any, default_value?: string | null | undefined, field_type: Espin_Event_Custom_Field_Type_Enum, name: string, label?: string | null | undefined }> };

export type EventCustomFieldsHandlerFragment = { __typename?: 'espin_event_custom_field', id: any, default_value?: string | null | undefined, field_type: Espin_Event_Custom_Field_Type_Enum, name: string, label?: string | null | undefined };

export type EventDocumentSignOffsFragment = { __typename?: 'espin_event', event_documents: Array<{ __typename?: 'espin_event_document', id: any, name?: string | null | undefined, file?: { __typename?: 'content_file', id: any, original_name?: string | null | undefined, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> };

export type DocumentSignOffHandlerFragment = { __typename?: 'espin_event_document', id: any, name?: string | null | undefined, file?: { __typename?: 'content_file', id: any, original_name?: string | null | undefined, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type CannotRegisterAsNonPlayerFragment = { __typename?: 'espin_event_ticket', id: any, ticket_type: Espin_Event_Ticket_Type_Enum, description?: string | null | undefined, price_temp: any, event: { __typename?: 'espin_event', id: any, slug: string }, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } | null | undefined };

export type CreateEventTicketRegistrationMutationVariables = Exact<{
  input: Espin_Event_Registration_Insert_Input;
}>;


export type CreateEventTicketRegistrationMutation = { __typename?: 'mutation_root', insert_espin_event_registration_one?: { __typename?: 'espin_event_registration', id: any } | null | undefined };

export type CreateEventTicketPaymentIntentMutationVariables = Exact<{
  registrationId: Scalars['uuid'];
}>;


export type CreateEventTicketPaymentIntentMutation = { __typename?: 'mutation_root', createEventTicketPaymentIntent?: { __typename?: 'EventTicketPaymentIntentOutput', paymentSecret: string } | null | undefined };

export type EventRegistrationFormFragment = { __typename?: 'espin_event_ticket', price_temp: any, price_id?: string | null | undefined, id: any, ticket_type: Espin_Event_Ticket_Type_Enum, description?: string | null | undefined, event: { __typename?: 'espin_event', slug: string, id: any, name: string, event_start_date: any, prize: any, event_end_date: any, type: Espin_Event_Type_Enum, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }>, event_custom_fields: Array<{ __typename?: 'espin_event_custom_field', id: any, default_value?: string | null | undefined, field_type: Espin_Event_Custom_Field_Type_Enum, name: string, label?: string | null | undefined }>, event_documents: Array<{ __typename?: 'espin_event_document', id: any, name?: string | null | undefined, file?: { __typename?: 'content_file', id: any, original_name?: string | null | undefined, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> }, game?: { __typename?: 'espin_game', team_max_size: number, game_definition: Espin_Game_Definition_Enum, name: string } | null | undefined };

export type FreeTicketCheckoutComponentFragment = { __typename?: 'espin_event_ticket', ticket_type: Espin_Event_Ticket_Type_Enum, game?: { __typename?: 'espin_game', name: string } | null | undefined };

export type PaidTicketCheckoutComponentFragment = { __typename?: 'espin_event_ticket', price_temp: any, ticket_type: Espin_Event_Ticket_Type_Enum, id: any, game?: { __typename?: 'espin_game', name: string } | null | undefined, event: { __typename?: 'espin_event', id: any, slug: string } };

export type NeedsToFinishOnboardingBeforeRegFragment = { __typename?: 'espin_event_ticket', id: any, ticket_type: Espin_Event_Ticket_Type_Enum, description?: string | null | undefined, price_temp: any, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } | null | undefined, event: { __typename?: 'espin_event', slug: string } };

export type OrderSubtotalFragment = { __typename?: 'espin_event_ticket', price_temp: any, ticket_type: Espin_Event_Ticket_Type_Enum, game?: { __typename?: 'espin_game', name: string } | null | undefined };

export type FreeTicketOrderDisplayFragment = { __typename?: 'espin_event_ticket', ticket_type: Espin_Event_Ticket_Type_Enum, game?: { __typename?: 'espin_game', name: string } | null | undefined };

export type RegistrationInfoFormFragment = { __typename?: 'espin_event_ticket', ticket_type: Espin_Event_Ticket_Type_Enum, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, team_max_size: number } | null | undefined, event: { __typename?: 'espin_event', event_custom_fields: Array<{ __typename?: 'espin_event_custom_field', id: any, default_value?: string | null | undefined, field_type: Espin_Event_Custom_Field_Type_Enum, name: string, label?: string | null | undefined }>, event_documents: Array<{ __typename?: 'espin_event_document', id: any, name?: string | null | undefined, file?: { __typename?: 'content_file', id: any, original_name?: string | null | undefined, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> } };

export type SignInToRegisterFragment = { __typename?: 'espin_event_ticket', id: any, ticket_type: Espin_Event_Ticket_Type_Enum, description?: string | null | undefined, price_temp: any, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } | null | undefined, event: { __typename?: 'espin_event', slug: string } };

export type EventTicketCardFragment = { __typename?: 'espin_event_ticket', id: any, ticket_type: Espin_Event_Ticket_Type_Enum, description?: string | null | undefined, price_temp: any, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } | null | undefined, event: { __typename?: 'espin_event', slug: string } };

export type EventTicketCheckoutFormFragment = { __typename?: 'espin_event_ticket', id: any, event: { __typename?: 'espin_event', id: any, slug: string } };

export type NewsletterRequestMutationVariables = Exact<{
  input: Espin_Newsletter_Request_Insert_Input;
}>;


export type NewsletterRequestMutation = { __typename?: 'mutation_root', insert_espin_newsletter_request_one?: { __typename?: 'espin_newsletter_request', id: any } | null | undefined };

export type FormImageFileFragment = { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined };

export type GamesSelectComponentQueryVariables = Exact<{ [key: string]: never; }>;


export type GamesSelectComponentQuery = { __typename?: 'query_root', espin_game: Array<{ __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string, image_url?: string | null | undefined, team_max_size: number, website?: string | null | undefined }> };

export type PlayerTeamSelectComponentQueryVariables = Exact<{
  userId: Scalars['String'];
  game: Scalars['String'];
}>;


export type PlayerTeamSelectComponentQuery = { __typename?: 'query_root', espin_team: Array<{ __typename?: 'espin_team', id: any, display_name: string }> };

export type TeamSelectComponentQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
  game: Scalars['String'];
}>;


export type TeamSelectComponentQuery = { __typename?: 'query_root', espin_team: Array<{ __typename?: 'espin_team', id: any, display_name: string }> };

export type CreateUploadUrlMutationVariables = Exact<{
  input: FileUploadUrlRequestInput;
}>;


export type CreateUploadUrlMutation = { __typename?: 'mutation_root', createFileUploadUrl?: { __typename?: 'FileUploadUrlRequestOutput', id: any, key: string, uploadUrl: string } | null | undefined };

export type ConfirmFileUploadMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ConfirmFileUploadMutation = { __typename?: 'mutation_root', update_content_file_by_pk?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type FormFileFragment = { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined };

export type HighSchoolCardFragment = { __typename?: 'espin_high_school', slug?: string | null | undefined, name: string, teams: Array<{ __typename?: 'espin_team', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }>, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type HighSchoolCardContentFragment = { __typename?: 'espin_high_school', name: string, teams: Array<{ __typename?: 'espin_team', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }>, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined };

export type HighSchoolDetailsFragment = { __typename?: 'espin_high_school', name: string, bio?: string | null | undefined, contact_email?: string | null | undefined, contact_name?: string | null | undefined, id: any, contact_phone?: string | null | undefined, slug?: string | null | undefined, address?: { __typename?: 'espin_address', state: string, city: string, country?: string | null | undefined, location?: any | null | undefined } | null | undefined, teams: Array<{ __typename?: 'espin_team', id: any, display_name: string, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string }, members: Array<{ __typename?: 'espin_team_members', team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, slug: string, id: any } | null | undefined }> }>, esportsTeams: Array<{ __typename?: 'espin_team', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }>, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitch?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, discord?: string | null | undefined, website?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined };

export type HighSchoolSocialsFragment = { __typename?: 'espin_high_school', socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, website?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined };

export type HighSchoolBioCardFragment = { __typename?: 'espin_high_school', bio?: string | null | undefined, contact_email?: string | null | undefined, contact_name?: string | null | undefined, name: string, id: any, contact_phone?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitch?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, discord?: string | null | undefined, website?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined };

export type HighSchoolInfoButtonsFragment = { __typename?: 'espin_high_school', slug?: string | null | undefined, contact_email?: string | null | undefined, contact_name?: string | null | undefined, contact_phone?: string | null | undefined, socials?: { __typename?: 'espin_social', discord?: string | null | undefined } | null | undefined };

export type HighSchoolLocationCardFragment = { __typename?: 'espin_high_school', name: string, address?: { __typename?: 'espin_address', state: string, city: string, country?: string | null | undefined, location?: any | null | undefined } | null | undefined };

export type HighSchoolOurTeamsCardFragment = { __typename?: 'espin_high_school', bio?: string | null | undefined, contact_email?: string | null | undefined, contact_name?: string | null | undefined, name: string, id: any, contact_phone?: string | null | undefined, slug?: string | null | undefined, teams: Array<{ __typename?: 'espin_team', id: any, display_name: string, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string }, members: Array<{ __typename?: 'espin_team_members', team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, slug: string, id: any } | null | undefined }> }>, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitch?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, discord?: string | null | undefined, website?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined };

export type HighSchoolProfileFragment = { __typename?: 'espin_high_school', name: string, bio?: string | null | undefined, contact_email?: string | null | undefined, contact_name?: string | null | undefined, id: any, contact_phone?: string | null | undefined, slug?: string | null | undefined, address?: { __typename?: 'espin_address', state: string, city: string, country?: string | null | undefined, location?: any | null | undefined } | null | undefined, teams: Array<{ __typename?: 'espin_team', id: any, display_name: string, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string }, members: Array<{ __typename?: 'espin_team_members', team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, slug: string, id: any } | null | undefined }> }>, esportsTeams: Array<{ __typename?: 'espin_team', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }>, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitch?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, discord?: string | null | undefined, website?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined };

export type HighSchoolProfileInfoFragment = { __typename?: 'espin_high_school', id: any, name: string, contact_email?: string | null | undefined, contact_name?: string | null | undefined, contact_phone?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitch?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, discord?: string | null | undefined, website?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined };

export type HighSchoolOurEsportsCardFragment = { __typename?: 'espin_high_school', esportsTeams: Array<{ __typename?: 'espin_team', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type TeamCardFragment = { __typename?: 'espin_team', id: any, display_name: string, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string }, members: Array<{ __typename?: 'espin_team_members', team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, slug: string, id: any } | null | undefined }> };

export type TeamMemberFragment = { __typename?: 'espin_team_members', team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, slug: string, id: any } | null | undefined };

export type HighSchoolUserEditProfileFormQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type HighSchoolUserEditProfileFormQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', high_school_profile?: { __typename?: 'espin_high_school_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, high_school: { __typename?: 'espin_high_school', id: any, name: string, bio?: string | null | undefined, contact_email?: string | null | undefined, contact_name?: string | null | undefined, contact_phone?: string | null | undefined, socials?: { __typename?: 'espin_social', id: any, website?: string | null | undefined, twitter?: string | null | undefined, facebook?: string | null | undefined, instagram?: string | null | undefined, discord?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', id: any, state: string, zip?: string | null | undefined, city: string, country?: string | null | undefined } | null | undefined } } | null | undefined } | null | undefined };

export type UpsertHighSchoolProfileMutationVariables = Exact<{
  input: Espin_High_School_Profile_Insert_Input;
  onConflict: Espin_High_School_Profile_On_Conflict;
}>;


export type UpsertHighSchoolProfileMutation = { __typename?: 'mutation_root', insert_espin_high_school_profile_one?: { __typename?: 'espin_high_school_profile', id: any, high_school: { __typename?: 'espin_high_school', id: any } } | null | undefined };

export type SetHighSchoolOwnerMutationVariables = Exact<{
  owner_profile_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
}>;


export type SetHighSchoolOwnerMutation = { __typename?: 'mutation_root', update_espin_high_school_by_pk?: { __typename?: 'espin_high_school', id: any } | null | undefined };

export type HighSchoolSearchFilterComponentFragment = { __typename?: 'query_root', espin_game_definition: Array<{ __typename?: 'espin_game_definition', display_name: string, game_name: string }> };

export type UpcomingEventsFragment = { __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type UpsertParentProfileMutationVariables = Exact<{
  input: Espin_Parent_Profile_Insert_Input;
  onConflict: Espin_Parent_Profile_On_Conflict;
}>;


export type UpsertParentProfileMutation = { __typename?: 'mutation_root', insert_espin_parent_profile_one?: { __typename?: 'espin_parent_profile', id: any } | null | undefined };

export type MonthDaysFragment = { __typename?: 'espin_org_month', month: string, total_days: number, start_day: number, month_of_year?: number | null | undefined, days: Array<{ __typename?: 'espin_org_month_day', date: number, title: string, time?: string | null | undefined, game_def?: string | null | undefined }> };

export type OrgFeaturedPlayerFragment = { __typename?: 'espin_org_player', player_review?: string | null | undefined, rank?: number | null | undefined, featured: boolean, gpa?: any | null | undefined, grad_class?: number | null | undefined, game_rank?: string | null | undefined, username?: string | null | undefined, game?: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined } | null | undefined };

export type OrgFeaturedSchoolFragment = { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined, rank?: number | null | undefined, bio?: string | null | undefined, records: Array<{ __typename?: 'espin_org_school_record', wins: number, losses: number, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type DayFragment = { __typename?: 'espin_org_month_day', date: number, title: string, time?: string | null | undefined, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } | null | undefined };

export type FeatCardAddressFragment = { __typename?: 'espin_org_player', school?: { __typename?: 'espin_org_school', city?: string | null | undefined, state?: string | null | undefined } | null | undefined };

export type FeatPlayerBioFragment = { __typename?: 'espin_org_player', username?: string | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined } | null | undefined };

export type FeatPlayerCardContentFragment = { __typename?: 'espin_org_player', player_review?: string | null | undefined, gpa?: any | null | undefined, grad_class?: number | null | undefined, game_rank?: string | null | undefined, username?: string | null | undefined, game?: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined } | null | undefined };

export type FeatPlayerCardRankFragment = { __typename?: 'espin_org_player', game_rank?: string | null | undefined, game?: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } | null | undefined };

export type OrgFeatInfoPanelFragment = { __typename?: 'espin_org_player', rank?: number | null | undefined, gpa?: any | null | undefined, grad_class?: number | null | undefined };

export type OrgFeaturedPlayerCardFragment = { __typename?: 'espin_org_player', player_review?: string | null | undefined, rank?: number | null | undefined, featured: boolean, gpa?: any | null | undefined, grad_class?: number | null | undefined, game_rank?: string | null | undefined, username?: string | null | undefined, game?: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined } | null | undefined };

export type OrgFeaturedSchoolCardFragment = { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined, rank?: number | null | undefined, bio?: string | null | undefined, records: Array<{ __typename?: 'espin_org_school_record', wins: number, losses: number, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type OrgSchoolInfoPanelFragment = { __typename?: 'espin_org_school', rank?: number | null | undefined, records: Array<{ __typename?: 'espin_org_school_record', wins: number, losses: number, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type RankLineItemFragment = { __typename?: 'espin_org_player', rank?: number | null | undefined, gpa?: any | null | undefined, grad_class?: number | null | undefined, game_rank?: string | null | undefined, username?: string | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string } | null | undefined };

export type RankingsCardFragment = { __typename?: 'espin_org_player', rank?: number | null | undefined, gpa?: any | null | undefined, grad_class?: number | null | undefined, game_rank?: string | null | undefined, username?: string | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string } | null | undefined };

export type SchoolLineItemFragment = { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, rank?: number | null | undefined, records: Array<{ __typename?: 'espin_org_school_record', wins: number, losses: number, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type SchoolRankCardFragment = { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, rank?: number | null | undefined, records: Array<{ __typename?: 'espin_org_school_record', wins: number, losses: number, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> };

export type StageWrapperInfoFragment = { __typename?: 'espin_player_journey_stage', id: any, order: number, def: Espin_Player_Journey_Stage_Def_Enum, title: string, player_journey_stage_def: { __typename?: 'espin_player_journey_stage_def', name: string, display_name: string } };

export type PlayerJourneyCardBioFragment = { __typename?: 'espin_player_journey', display_name: string, city?: string | null | undefined, state?: string | null | undefined };

export type PlayerProfileForJourneyFragment = { __typename?: 'espin_player_journey', display_name: string, slug: string, city?: string | null | undefined, state?: string | null | undefined, description?: string | null | undefined, game?: Espin_Game_Definition_Enum | null | undefined, rank?: string | null | undefined, profile_slug?: string | null | undefined, profile_image_url?: string | null | undefined };

export type PlayerJourneyInfoCardFragment = { __typename?: 'espin_player_journey', grad_class?: number | null | undefined, game?: Espin_Game_Definition_Enum | null | undefined, game_definition?: { __typename?: 'espin_game_definition', game_name: string, display_name: string } | null | undefined };

export type PlayerJourneyCollegeFragment = { __typename?: 'espin_player_journey_stage_college', college_id: any, college: { __typename?: 'espin_college', id: any, program_name?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined, original_name?: string | null | undefined } | null | undefined } };

export type PlayerInfoWidgetFragment = { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, spin_username: string };

export type PlayerListItemFragment = { __typename?: 'espin_player_profile', slug: string, first_name?: string | null | undefined, last_name?: string | null | undefined, spin_username: string };

export type PlayerProfileFragment = { __typename?: 'espin_player_profile', id: any, spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, bio?: string | null | undefined, slug: string, committed_to_college?: string | null | undefined, user_id: string, phone?: string | null | undefined, gpa: any, graduating_class?: string | null | undefined, preferred_study_fields?: any | null | undefined, preferred_schools?: any | null | undefined, college_name?: string | null | undefined, hs_name?: string | null | undefined, is_hs: boolean, player_vods: Array<{ __typename?: 'espin_player_vod', id: any, label?: string | null | undefined, media_link: { __typename?: 'content_media_link', id: any, link_data: string, link_type: Content_Media_Link_Type_Enum } }>, primary_game: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, role?: string | null | undefined, tracker?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, user: { __typename?: 'espin_user', email: string, id: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined }, social?: { __typename?: 'espin_social', discord?: string | null | undefined, twitter?: string | null | undefined, facebook?: string | null | undefined, tiktok?: string | null | undefined, instagram?: string | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, linked_high_school_details?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined } | null | undefined };

export type VoDsCardFragment = { __typename?: 'espin_player_vod', id: any, label?: string | null | undefined, media_link: { __typename?: 'content_media_link', id: any, link_data: string, link_type: Content_Media_Link_Type_Enum } };

export type PrimaryGameCardFragment = { __typename?: 'espin_player_game', rank?: string | null | undefined, role?: string | null | undefined, tracker?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } };

export type PlayerCardFragment = { __typename?: 'espin_player_profile', slug: string, spin_username: string, gpa: any, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, primary_game: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> };

export type PlayerCardBioFragment = { __typename?: 'espin_player_profile', spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined };

export type PlayerCardContentFragment = { __typename?: 'espin_player_profile', spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, primary_game: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> };

export type PlayerCardInfoPanelFragment = { __typename?: 'espin_player_profile', gpa: any, graduating_class?: string | null | undefined };

export type PlayerCardRankFragment = { __typename?: 'espin_player_profile', primary_game: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> };

export type ClassOfCardFragment = { __typename?: 'espin_player_profile', graduating_class?: string | null | undefined };

export type CommittedToCollegeCardFragment = { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, committed_to_college?: string | null | undefined };

export type GpaCardFragment = { __typename?: 'espin_player_profile', gpa: any };

export type PlayerBioCardFragment = { __typename?: 'espin_player_profile', bio?: string | null | undefined, phone?: string | null | undefined, spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, college_name?: string | null | undefined, hs_name?: string | null | undefined, is_hs: boolean, user_id: string, slug: string, user: { __typename?: 'espin_user', email: string, id: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined }, social?: { __typename?: 'espin_social', discord?: string | null | undefined, twitter?: string | null | undefined, facebook?: string | null | undefined, tiktok?: string | null | undefined, instagram?: string | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, linked_high_school_details?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined } | null | undefined };

export type PlayerInfoButtonsFragment = { __typename?: 'espin_player_profile', phone?: string | null | undefined, social?: { __typename?: 'espin_social', discord?: string | null | undefined } | null | undefined, user: { __typename?: 'espin_user', email: string, id: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined } };

export type PlayerProfileInfoFragment = { __typename?: 'espin_player_profile', spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, college_name?: string | null | undefined, hs_name?: string | null | undefined, is_hs: boolean, user_id: string, slug: string, user: { __typename?: 'espin_user', subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined }, social?: { __typename?: 'espin_social', discord?: string | null | undefined, twitter?: string | null | undefined, facebook?: string | null | undefined, tiktok?: string | null | undefined, instagram?: string | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, linked_high_school_details?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined } | null | undefined };

export type FollowPlayerMutationVariables = Exact<{
  collegeId: Scalars['uuid'];
  playerUserId: Scalars['String'];
  collegeName: Scalars['String'];
}>;


export type FollowPlayerMutation = { __typename?: 'mutation_root', insert_espin_follow_one?: { __typename?: 'espin_follow', id: any } | null | undefined };

export type UnfollowPlayerMutationVariables = Exact<{
  playerUserId?: Maybe<Scalars['String']>;
  collegeId: Scalars['uuid'];
}>;


export type UnfollowPlayerMutation = { __typename?: 'mutation_root', delete_espin_follow?: { __typename?: 'espin_follow_mutation_response', returning: Array<{ __typename?: 'espin_follow', id: any }> } | null | undefined };

export type CheckFollowingStatusForCollegesQueryVariables = Exact<{
  playerUserId: Scalars['String'];
  collegeId: Scalars['uuid'];
}>;


export type CheckFollowingStatusForCollegesQuery = { __typename?: 'query_root', espin_follow: Array<{ __typename?: 'espin_follow', id: any }> };

export type PlayerProfileUserControlsFragment = { __typename?: 'espin_player_profile', user_id: string, slug: string };

export type PlayerSocialDisplaysFragment = { __typename?: 'espin_social', discord?: string | null | undefined, twitter?: string | null | undefined, facebook?: string | null | undefined, tiktok?: string | null | undefined, instagram?: string | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined };

export type PlayerHighSchoolNamesFragment = { __typename?: 'espin_high_school', id: any, name: string };

export type PlayerAcademicInterestsStudyFieldsFragment = { __typename?: 'espin_study_field', name: string };

export type PlayerAcademicInterestsStudySubjectsFragment = { __typename?: 'espin_study_subject', name: string, study_field: { __typename?: 'espin_study_field', name: string } };

export type PlayerAcademicInformationFieldsStudyFieldsFragment = { __typename?: 'espin_study_field', name: string };

export type PlayerAcademicInformationFieldsStudySubjectsFragment = { __typename?: 'espin_study_subject', name: string, study_field: { __typename?: 'espin_study_field', name: string } };

export type PlayerAcademicInformationFieldsCollegesFragment = { __typename?: 'espin_college', name: string };

export type GetAllVerifiedHighSchoolsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllVerifiedHighSchoolsQuery = { __typename?: 'query_root', GetAllVerifiedHighSchoolNames?: { __typename?: 'GetAllVerifiedHighSchoolNamesOutput', highSchoolData?: { __typename?: 'VerifiedHighSchoolData', highSchools?: Array<{ __typename?: 'VerifiedHighSchool', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type PlayerProfileEditingFormFragment = { __typename?: 'espin_player_profile', bio?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, spin_username: string, graduating_class?: string | null | undefined, phone?: string | null | undefined, parent_email?: string | null | undefined, gpa: any, gender?: Espin_Gender_Options_Enum | null | undefined, ethnicity?: Espin_Ethnicity_Options_Enum | null | undefined, committed_to_college?: string | null | undefined, gender_not_listed_entry?: string | null | undefined, college_name?: string | null | undefined, college_coach_name?: string | null | undefined, college_coach_email?: string | null | undefined, hs_name?: string | null | undefined, hs_coach_name?: string | null | undefined, hs_coach_email?: string | null | undefined, user_source?: string | null | undefined, is_hs: boolean, preferred_schools?: any | null | undefined, preferred_study_fields?: any | null | undefined, birthdate?: any | null | undefined, linked_high_school?: any | null | undefined, ack_displayed: boolean, ack_terms: boolean, ack_waiver: boolean, address?: { __typename?: 'espin_address', city: string, state: string, zip?: string | null | undefined, country?: string | null | undefined } | null | undefined, social?: { __typename?: 'espin_social', discord?: string | null | undefined, tiktok?: string | null | undefined, twitter?: string | null | undefined, facebook?: string | null | undefined, instagram?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, primary_games: Array<{ __typename?: 'espin_player_game', in_game_username?: string | null | undefined, rank?: string | null | undefined, role?: string | null | undefined, tracker?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, all_games: Array<{ __typename?: 'espin_player_game', id: any }> };

export type PlayerProfileUpdateMutationVariables = Exact<{
  input: SubmitPlayerProfileUpdateEspinDraftPlayerProfileInsertInput;
}>;


export type PlayerProfileUpdateMutation = { __typename?: 'mutation_root', SubmitPlayerProfileUpdate?: { __typename?: 'SubmitPlayerProfileUpdateOutput', id?: any | null | undefined, status: string, comments: string } | null | undefined };

export type PlayerProfileEditingFormStudyFieldsFragment = { __typename?: 'espin_study_field', name: string };

export type PlayerProfileEditingFormStudySubjectsFragment = { __typename?: 'espin_study_subject', name: string, study_field: { __typename?: 'espin_study_field', name: string } };

export type PlayerProfileEditingFormCollegesFragment = { __typename?: 'espin_college', name: string };

export type EditProfilePageQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type EditProfilePageQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', bio?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, spin_username: string, graduating_class?: string | null | undefined, phone?: string | null | undefined, parent_email?: string | null | undefined, gpa: any, gender?: Espin_Gender_Options_Enum | null | undefined, ethnicity?: Espin_Ethnicity_Options_Enum | null | undefined, committed_to_college?: string | null | undefined, gender_not_listed_entry?: string | null | undefined, college_name?: string | null | undefined, college_coach_name?: string | null | undefined, college_coach_email?: string | null | undefined, hs_name?: string | null | undefined, hs_coach_name?: string | null | undefined, hs_coach_email?: string | null | undefined, user_source?: string | null | undefined, is_hs: boolean, preferred_schools?: any | null | undefined, preferred_study_fields?: any | null | undefined, birthdate?: any | null | undefined, linked_high_school?: any | null | undefined, ack_displayed: boolean, ack_terms: boolean, ack_waiver: boolean, address?: { __typename?: 'espin_address', city: string, state: string, zip?: string | null | undefined, country?: string | null | undefined } | null | undefined, social?: { __typename?: 'espin_social', discord?: string | null | undefined, tiktok?: string | null | undefined, twitter?: string | null | undefined, facebook?: string | null | undefined, instagram?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, primary_games: Array<{ __typename?: 'espin_player_game', in_game_username?: string | null | undefined, rank?: string | null | undefined, role?: string | null | undefined, tracker?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, all_games: Array<{ __typename?: 'espin_player_game', id: any }> } | null | undefined } | null | undefined, espin_gender_options: Array<{ __typename?: 'espin_gender_options', display_name: string, name: string }>, espin_ethnicity_options: Array<{ __typename?: 'espin_ethnicity_options', display_name: string, name: string }>, espin_user_source: Array<{ __typename?: 'espin_user_source', id: any, name: string }>, espin_study_field: Array<{ __typename?: 'espin_study_field', name: string }>, espin_study_subject: Array<{ __typename?: 'espin_study_subject', name: string, study_field: { __typename?: 'espin_study_field', name: string } }>, espin_college: Array<{ __typename?: 'espin_college', name: string }> };

export type PlayerSchoolsOfInterestCollegesFragment = { __typename?: 'espin_college', name: string };

export type AdminClearEventRegistrationsMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminClearEventRegistrationsMutation = { __typename?: 'mutation_root', delete_espin_event_registration?: { __typename?: 'espin_event_registration_mutation_response', affected_rows: number } | null | undefined };

export type UpdateUserLastLoginMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UpdateUserLastLoginMutation = { __typename?: 'mutation_root', update_espin_user_by_pk?: { __typename?: 'espin_user', updated_at?: any | null | undefined, last_login?: any | null | undefined } | null | undefined };

export type AdminAcceptCollegeInviteMutationVariables = Exact<{
  input: Espin_College_Profile_Insert_Input;
  inviteId: Scalars['uuid'];
}>;


export type AdminAcceptCollegeInviteMutation = { __typename?: 'mutation_root', insert_espin_college_profile_one?: { __typename?: 'espin_college_profile', id: any } | null | undefined, update_espin_college_invite_by_pk?: { __typename?: 'espin_college_invite', id: any } | null | undefined };

export type AdminGetCollegeInviteByIdQueryVariables = Exact<{
  inviteId: Scalars['uuid'];
}>;


export type AdminGetCollegeInviteByIdQuery = { __typename?: 'query_root', espin_college_invite_by_pk?: { __typename?: 'espin_college_invite', id: any, email: string, status: Espin_Invite_Status_Type_Enum, college: { __typename?: 'espin_college', id: any } } | null | undefined };

export type GetAccountInfoForCollegeEmailQueryVariables = Exact<{
  collegeId: Scalars['uuid'];
}>;


export type GetAccountInfoForCollegeEmailQuery = { __typename?: 'query_root', espin_college_by_pk?: { __typename?: 'espin_college', college_profiles: Array<{ __typename?: 'espin_college_profile', id: any, last_name?: string | null | undefined, first_name?: string | null | undefined }> } | null | undefined };

export type GetEventRegistrationDetailsQueryVariables = Exact<{
  teamId: Scalars['uuid'];
  ticketId: Scalars['uuid'];
}>;


export type GetEventRegistrationDetailsQuery = { __typename?: 'query_root', espin_team_by_pk?: { __typename?: 'espin_team', display_name: string, deleted_at?: any | null | undefined, members: Array<{ __typename?: 'espin_team_members', player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, user: { __typename?: 'espin_user', email: string } } | null | undefined }> } | null | undefined, espin_event_ticket_by_pk?: { __typename?: 'espin_event_ticket', id: any, game?: { __typename?: 'espin_game', name: string } | null | undefined, event: { __typename?: 'espin_event', name: string, slug: string, event_start_date: any } } | null | undefined };

export type GetDeletedEventRegistrationDetailsQueryVariables = Exact<{
  ticketId: Scalars['uuid'];
}>;


export type GetDeletedEventRegistrationDetailsQuery = { __typename?: 'query_root', espin_event_ticket_by_pk?: { __typename?: 'espin_event_ticket', id: any, game?: { __typename?: 'espin_game', name: string } | null | undefined, event: { __typename?: 'espin_event', name: string, slug: string, event_start_date: any } } | null | undefined };

export type CreateFileRecordMutationVariables = Exact<{
  input: Content_File_Insert_Input;
}>;


export type CreateFileRecordMutation = { __typename?: 'mutation_root', insert_content_file_one?: { __typename?: 'content_file', id: any } | null | undefined };

export type ActionCreateHighSchoolTeamMutationVariables = Exact<{
  input: Espin_Team_Insert_Input;
}>;


export type ActionCreateHighSchoolTeamMutation = { __typename?: 'mutation_root', insert_espin_team_one?: { __typename?: 'espin_team', id: any } | null | undefined };

export type ActionCheckTeamNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type ActionCheckTeamNameQuery = { __typename?: 'query_root', espin_team: Array<{ __typename?: 'espin_team', id: any, display_name: string, deleted_at?: any | null | undefined }> };

export type ActionCheckNamesForHighSchoolTeamQueryVariables = Exact<{
  input: Array<Scalars['String']> | Scalars['String'];
}>;


export type ActionCheckNamesForHighSchoolTeamQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', id: any, spin_username: string, user: { __typename?: 'espin_user', id: string, email: string } }> };

export type InsertTeamInvitesMutationVariables = Exact<{
  input: Array<Espin_Team_Invite_Insert_Input> | Espin_Team_Invite_Insert_Input;
}>;


export type InsertTeamInvitesMutation = { __typename?: 'mutation_root', insert_espin_team_invite?: { __typename?: 'espin_team_invite_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'espin_team_invite', email: string, status: Espin_Invite_Status_Type_Enum, created_at: any, updated_at: any, id: any, team_id: any }> } | null | undefined };

export type GetHighSchoolUserIdByHighSchoolIdQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
}>;


export type GetHighSchoolUserIdByHighSchoolIdQuery = { __typename?: 'query_root', espin_high_school_profile: Array<{ __typename?: 'espin_high_school_profile', user_id: string }> };

export type ActionGetTeamMembersQueryVariables = Exact<{
  teamId: Scalars['uuid'];
}>;


export type ActionGetTeamMembersQuery = { __typename?: 'query_root', espin_team_members: Array<{ __typename?: 'espin_team_members', player_profile_id: any, id: any }> };

export type ActionEditHighSchoolTeamMutationVariables = Exact<{
  input: Espin_Team_Insert_Input;
  onConflict: Espin_Team_On_Conflict;
}>;


export type ActionEditHighSchoolTeamMutation = { __typename?: 'mutation_root', insert_espin_team_one?: { __typename?: 'espin_team', id: any } | null | undefined };

export type GetAccountInfoForHighSchoolEmailQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
}>;


export type GetAccountInfoForHighSchoolEmailQuery = { __typename?: 'query_root', espin_high_school_by_pk?: { __typename?: 'espin_high_school', high_school_profiles: Array<{ __typename?: 'espin_high_school_profile', id: any, last_name?: string | null | undefined, first_name?: string | null | undefined }> } | null | undefined };

export type IsColleagueExistingUserQueryVariables = Exact<{
  emails: Array<Scalars['String']> | Scalars['String'];
}>;


export type IsColleagueExistingUserQuery = { __typename?: 'query_root', espin_user: Array<{ __typename?: 'espin_user', id: string }> };

export type InviteHighSchoolUsersMutationVariables = Exact<{
  input: Array<Espin_High_School_Invite_Insert_Input> | Espin_High_School_Invite_Insert_Input;
}>;


export type InviteHighSchoolUsersMutation = { __typename?: 'mutation_root', insert_espin_high_school_invite?: { __typename?: 'espin_high_school_invite_mutation_response', affected_rows: number } | null | undefined };

export type GetAllVerifiedHighSchoolNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllVerifiedHighSchoolNamesQuery = { __typename?: 'query_root', espin_high_school: Array<{ __typename?: 'espin_high_school', id: any, name: string }> };

export type SendMassPlayerMessagesMutationVariables = Exact<{
  collegeProfileId: Scalars['uuid'];
  input: Array<Espin_Message_Insert_Input> | Espin_Message_Insert_Input;
}>;


export type SendMassPlayerMessagesMutation = { __typename?: 'mutation_root', insert_espin_message?: { __typename?: 'espin_message_mutation_response', returning: Array<{ __typename?: 'espin_message', id: any }> } | null | undefined, update_espin_college_profile_by_pk?: { __typename?: 'espin_college_profile', id: any } | null | undefined };

export type GetCollegeSenderInfoQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetCollegeSenderInfoQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', college_profile?: { __typename?: 'espin_college_profile', id: any, last_group_message?: any | null | undefined, college: { __typename?: 'espin_college', id: any, name: string, address?: { __typename?: 'espin_address', state: string } | null | undefined, follows: Array<{ __typename?: 'espin_follow', player_user_id?: string | null | undefined }> } } | null | undefined, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined, tierlookup?: number | null | undefined } | null | undefined } | null | undefined };

export type SearchPlayersForMassMessageQueryVariables = Exact<{
  search: Espin_User_Bool_Exp;
}>;


export type SearchPlayersForMassMessageQuery = { __typename?: 'query_root', espin_user: Array<{ __typename?: 'espin_user', id: string, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, player_games: Array<{ __typename?: 'espin_player_game', game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, address?: { __typename?: 'espin_address', state: string } | null | undefined } | null | undefined }> };

export type RejectDraftPlayerProfileMutationVariables = Exact<{
  draftId: Scalars['uuid'];
  comments: Scalars['String'];
}>;


export type RejectDraftPlayerProfileMutation = { __typename?: 'mutation_root', update_espin_draft_player_profile_by_pk?: { __typename?: 'espin_draft_player_profile', id: any, status: Espin_Moderation_Status_Enum, updated_at: any } | null | undefined };

export type ApprovePlayerProfileUpdateMutationVariables = Exact<{
  userId: Scalars['String'];
  input: Espin_Player_Profile_Insert_Input;
  onConflict: Espin_Player_Profile_On_Conflict;
}>;


export type ApprovePlayerProfileUpdateMutation = { __typename?: 'mutation_root', delete_espin_player_game?: { __typename?: 'espin_player_game_mutation_response', affected_rows: number } | null | undefined, insert_espin_player_profile_one?: { __typename?: 'espin_player_profile', id: any } | null | undefined };

export type GetCurrentPlayerProfileIdsForReviewQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetCurrentPlayerProfileIdsForReviewQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', id: any, address_id?: any | null | undefined, parent_email?: string | null | undefined, preferred_schools?: any | null | undefined, preferred_study_fields?: any | null | undefined, parent_profile?: { __typename?: 'espin_parent_profile', id: any, user?: { __typename?: 'espin_user', email: string } | null | undefined } | null | undefined, social?: { __typename?: 'espin_social', id: any, twitch_channel?: { __typename?: 'content_media_link', id: any } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any } | null | undefined } | null | undefined }> };

export type CheckForDuplicateUsernamesQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type CheckForDuplicateUsernamesQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', id: any }> };

export type GetCollegeIdsFromNamesQueryVariables = Exact<{
  input: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetCollegeIdsFromNamesQuery = { __typename?: 'query_root', espin_college: Array<{ __typename?: 'espin_college', id: any, name: string }> };

export type InviteParentForPlayerMutationVariables = Exact<{
  input: Espin_Parent_Invite_Insert_Input;
}>;


export type InviteParentForPlayerMutation = { __typename?: 'mutation_root', insert_espin_parent_invite_one?: { __typename?: 'espin_parent_invite', id: any } | null | undefined };

export type NotifyCollegesOfInterestMutationVariables = Exact<{
  input: Array<Espin_Notification_Insert_Input> | Espin_Notification_Insert_Input;
}>;


export type NotifyCollegesOfInterestMutation = { __typename?: 'mutation_root', insert_espin_notification?: { __typename?: 'espin_notification_mutation_response', returning: Array<{ __typename?: 'espin_notification', id: any }> } | null | undefined };

export type GetParentProfileByPlayerProfileIdQueryVariables = Exact<{
  playerProfileId: Scalars['uuid'];
}>;


export type GetParentProfileByPlayerProfileIdQuery = { __typename?: 'query_root', espin_player_profile_by_pk?: { __typename?: 'espin_player_profile', parent_profile?: { __typename?: 'espin_parent_profile', user_id?: string | null | undefined } | null | undefined } | null | undefined };

export type RemoveParentFromPlayerMutationVariables = Exact<{
  playerProfileId: Scalars['uuid'];
}>;


export type RemoveParentFromPlayerMutation = { __typename?: 'mutation_root', update_espin_player_profile_by_pk?: { __typename?: 'espin_player_profile', id: any } | null | undefined };

export type GetTicketForRegistrationIdQueryVariables = Exact<{
  registrationId: Scalars['uuid'];
}>;


export type GetTicketForRegistrationIdQuery = { __typename?: 'query_root', espin_event_registration_by_pk?: { __typename?: 'espin_event_registration', event_ticket: { __typename?: 'espin_event_ticket', price_temp: any } } | null | undefined };

export type AddPaymentIntentIdMutationVariables = Exact<{
  registrationId: Scalars['uuid'];
  paymentIntentId: Scalars['String'];
}>;


export type AddPaymentIntentIdMutation = { __typename?: 'mutation_root', update_espin_event_registration_by_pk?: { __typename?: 'espin_event_registration', id: any, updated_at?: any | null | undefined } | null | undefined };

export type GetUserInfoBySubQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserInfoBySubQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', id: string, player_profile?: { __typename?: 'espin_player_profile', spin_username: string } | null | undefined } | null | undefined };

export type AdminRedeemCollegeReferralCodeMutationVariables = Exact<{
  input: Espin_Referral_Code_Redemption_Insert_Input;
}>;


export type AdminRedeemCollegeReferralCodeMutation = { __typename?: 'mutation_root', insert_espin_referral_code_redemption_one?: { __typename?: 'espin_referral_code_redemption', id: any, college?: { __typename?: 'espin_college', id: any, name: string, college_subscription_id?: any | null | undefined } | null | undefined } | null | undefined };

export type AdminGetCollegeReferralCodeByKeyQueryVariables = Exact<{
  codeKey: Scalars['String'];
}>;


export type AdminGetCollegeReferralCodeByKeyQuery = { __typename?: 'query_root', espin_referral_code: Array<{ __typename?: 'espin_referral_code', id: any, code_key: string, code_active_start_date?: any | null | undefined, code_active_end_date?: any | null | undefined, subscription_duration: number, referral_code_redemptions: Array<{ __typename?: 'espin_referral_code_redemption', redeemed_by_college?: any | null | undefined }> }> };

export type AdminRedeemPlayerReferralCodeMutationVariables = Exact<{
  input: Espin_Referral_Code_Redemption_Insert_Input;
}>;


export type AdminRedeemPlayerReferralCodeMutation = { __typename?: 'mutation_root', insert_espin_referral_code_redemption_one?: { __typename?: 'espin_referral_code_redemption', id: any, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, slug: string, player_subscription_id?: any | null | undefined } | null | undefined } | null | undefined };

export type AdminGetPlayerReferralCodeByKeyQueryVariables = Exact<{
  codeKey: Scalars['String'];
}>;


export type AdminGetPlayerReferralCodeByKeyQuery = { __typename?: 'query_root', espin_referral_code: Array<{ __typename?: 'espin_referral_code', id: any, code_key: string, code_active_start_date?: any | null | undefined, code_active_end_date?: any | null | undefined, subscription_duration: number, referral_code_redemptions: Array<{ __typename?: 'espin_referral_code_redemption', redeemed_by_player?: any | null | undefined }> }> };

export type GetAlreadyInvitedTeamMembersQueryVariables = Exact<{
  playerIds: Array<Scalars['uuid']> | Scalars['uuid'];
  teamId: Scalars['uuid'];
  emails: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetAlreadyInvitedTeamMembersQuery = { __typename?: 'query_root', espin_team_members: Array<{ __typename?: 'espin_team_members', player_profile_id: any }>, espin_team_invite: Array<{ __typename?: 'espin_team_invite', status: Espin_Invite_Status_Type_Enum, user?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', id: any } | null | undefined } | null | undefined }> };

export type GetPlayerOwnedTeamsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetPlayerOwnedTeamsQuery = { __typename?: 'query_root', espin_team: Array<{ __typename?: 'espin_team', id: any }> };

export type GetHighSchoolUserIdByTeamIdQueryVariables = Exact<{
  teamId: Scalars['uuid'];
}>;


export type GetHighSchoolUserIdByTeamIdQuery = { __typename?: 'query_root', espin_high_school_profile: Array<{ __typename?: 'espin_high_school_profile', user_id: string }> };

export type SetTeamCaptainMutationVariables = Exact<{
  player_profile_id: Scalars['uuid'];
  teamId: Scalars['uuid'];
}>;


export type SetTeamCaptainMutation = { __typename?: 'mutation_root', insert_espin_team_members_one?: { __typename?: 'espin_team_members', id: any } | null | undefined };

export type AdminGetTeamInviteInformationByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type AdminGetTeamInviteInformationByIdQuery = { __typename?: 'query_root', espin_team_invite_by_pk?: { __typename?: 'espin_team_invite', email: string, status: Espin_Invite_Status_Type_Enum, user_id: string, created_at: any, updated_at: any, id: any, team_id: any, team: { __typename?: 'espin_team', display_name: string } } | null | undefined };

export type ActivationCollegeFairQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivationCollegeFairQuery = { __typename?: 'query_root', espin_college: Array<{ __typename?: 'espin_college', slug?: string | null | undefined, scholarships: boolean, program_name?: string | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> };

export type College_DetailsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type College_DetailsQuery = { __typename?: 'query_root', espin_college: Array<{ __typename?: 'espin_college', id: any, program_name?: string | null | undefined, scholarships: boolean, bio?: string | null | undefined, contact_email?: string | null | undefined, phone?: string | null | undefined, academic_notes?: string | null | undefined, min_gpa?: string | null | undefined, min_sat?: string | null | undefined, min_act?: string | null | undefined, name: string, in_state_tuition?: string | null | undefined, out_of_state_tuition?: string | null | undefined, slug?: string | null | undefined, header_media_link?: { __typename?: 'content_media_link', link_data: string, link_type: Content_Media_Link_Type_Enum } | null | undefined, college_images: Array<{ __typename?: 'espin_college_image', file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }>, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, address?: { __typename?: 'espin_address', state: string, city: string, country?: string | null | undefined, location?: any | null | undefined } | null | undefined, socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, website?: string | null | undefined, twitch?: string | null | undefined, discord?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> };

export type RecordParentViewsProfileMutationVariables = Exact<{
  input: Array<Espin_Profile_View_Insert_Input> | Espin_Profile_View_Insert_Input;
}>;


export type RecordParentViewsProfileMutation = { __typename?: 'mutation_root', insert_espin_profile_view?: { __typename?: 'espin_profile_view_mutation_response', returning: Array<{ __typename?: 'espin_profile_view', id: any }> } | null | undefined };

export type SsgCollegesBySlugQueryVariables = Exact<{ [key: string]: never; }>;


export type SsgCollegesBySlugQuery = { __typename?: 'query_root', espin_college: Array<{ __typename?: 'espin_college', id: any, slug?: string | null | undefined }> };

export type Colleges_IndexQueryVariables = Exact<{ [key: string]: never; }>;


export type Colleges_IndexQuery = { __typename?: 'query_root', subbedCount: { __typename?: 'espin_college_aggregate', aggregate?: { __typename?: 'espin_college_aggregate_fields', count: number } | null | undefined }, espin_game_definition: Array<{ __typename?: 'espin_game_definition', display_name: string, game_name: string }> };

export type SearchCollegesQueryVariables = Exact<{
  subbedSearch: Espin_College_Bool_Exp;
  unsubbedSearch: Espin_College_Bool_Exp;
  subbedOffset?: Scalars['Int'];
  subbedPageSize?: Scalars['Int'];
  unsubbedOffset?: Scalars['Int'];
  unsubbedPageSize?: Scalars['Int'];
}>;


export type SearchCollegesQuery = { __typename?: 'query_root', unsubbedColleges: Array<{ __typename?: 'espin_college', id: any, name: string, program_name?: string | null | undefined, subscribed: boolean, slug?: string | null | undefined, scholarships: boolean, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }>, subbedColleges: Array<{ __typename?: 'espin_college', id: any, name: string, program_name?: string | null | undefined, subscribed: boolean, slug?: string | null | undefined, scholarships: boolean, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }>, subbedCount: { __typename?: 'espin_college_aggregate', aggregate?: { __typename?: 'espin_college_aggregate_fields', count: number } | null | undefined }, allCount: { __typename?: 'espin_college_aggregate', aggregate?: { __typename?: 'espin_college_aggregate_fields', count: number } | null | undefined } };

export type CollegeInvitesQueryVariables = Exact<{
  collegeId: Scalars['uuid'];
}>;


export type CollegeInvitesQuery = { __typename?: 'query_root', espin_college_invite: Array<{ __typename?: 'espin_college_invite', id: any, email: string, status: Espin_Invite_Status_Type_Enum }> };

export type HighSchoolInvitesQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
}>;


export type HighSchoolInvitesQuery = { __typename?: 'query_root', espin_high_school_invite: Array<{ __typename?: 'espin_high_school_invite', id: any, email: string, status: Espin_Invite_Status_Type_Enum }> };

export type AccountSettingsMessagesQueryVariables = Exact<{
  collegeId: Scalars['uuid'];
}>;


export type AccountSettingsMessagesQuery = { __typename?: 'query_root', espin_college_preferences: Array<{ __typename?: 'espin_college_preferences', automatic_message_custom?: string | null | undefined, automatic_message_response_type: Espin_College_Automatic_Message_Response_Type_Enum }>, espin_college_by_pk?: { __typename?: 'espin_college', program_name?: string | null | undefined, manual_subtier?: number | null | undefined, subscription?: { __typename?: 'espin_college_subscription', status: Espin_Subscription_Status_Enum } | null | undefined } | null | undefined };

export type AccountEmailPreferenceSettingsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type AccountEmailPreferenceSettingsQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', id: string, email_follow_preference: Espin_Follower_Email_Notification_Type_Enum, email_message_preference?: Espin_Message_Email_Notification_Type_Enum | null | undefined, email_profile_view_preference?: Espin_Profile_View_Email_Notification_Type_Enum | null | undefined } | null | undefined };

export type DashboardQueryVariables = Exact<{
  id: Scalars['String'];
  playerPrimaryGame?: Maybe<Espin_Game_Definition_Enum>;
  hasPrimary: Scalars['Boolean'];
  collegeId?: Maybe<Scalars['uuid']>;
  highSchoolId?: Maybe<Scalars['uuid']>;
  showRegistrations?: Maybe<Scalars['Boolean']>;
  showCollegeNotifs?: Maybe<Scalars['Boolean']>;
  showPlayerNotifs?: Maybe<Scalars['Boolean']>;
  showParentNotifs?: Maybe<Scalars['Boolean']>;
  showHighSchoolNotifs?: Maybe<Scalars['Boolean']>;
  playerUserIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type DashboardQuery = { __typename?: 'query_root', admin_recommended_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }>, recommended_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }>, any_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }>, registered_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }>, college_notifications: Array<{ __typename?: 'espin_notification', id: any, notification_type: Espin_Notification_Type_Enum, viewed_at?: any | null | undefined, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, high_school_notifications: Array<{ __typename?: 'espin_notification', id: any, notification_type: Espin_Notification_Type_Enum, viewed_at?: any | null | undefined, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, player_notifications: Array<{ __typename?: 'espin_notification', id: any, notification_type: Espin_Notification_Type_Enum, viewed_at?: any | null | undefined, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, parent_notifications: Array<{ __typename?: 'espin_notification', player_user_id?: string | null | undefined, id: any, notification_type: Espin_Notification_Type_Enum, viewed_at?: any | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, parent_profile?: { __typename?: 'espin_parent_profile', child_profiles: Array<{ __typename?: 'espin_player_profile', user_id: string, spin_username: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> } | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', contact_name?: string | null | undefined, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, high_school_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, contact_name?: string | null | undefined, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, parent_children: Array<{ __typename?: 'espin_parent_profile', child_profiles: Array<{ __typename?: 'espin_player_profile', user_id: string, spin_username: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> }>, unread_college_messages: Array<{ __typename?: 'espin_message', id: any, player_user_id?: string | null | undefined }>, all_college_messages: Array<{ __typename?: 'espin_message', player_user_id?: string | null | undefined, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, college_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, id: any, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, id: any, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, college_followers: Array<{ __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined }>, college_deleted_followers: Array<{ __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined }>, college_following: Array<{ __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined }>, college_profile_views: Array<{ __typename?: 'espin_profile_view', id: any, player_user_id?: string | null | undefined }>, high_school_followers: Array<{ __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined }>, high_school_deleted_followers: Array<{ __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined }>, high_school_following: Array<{ __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined }>, high_school_profile_views: Array<{ __typename?: 'espin_profile_view', id: any, player_user_id?: string | null | undefined }>, unread_player_messages: Array<{ __typename?: 'espin_message', id: any, player_user_id?: string | null | undefined }>, all_player_messages: Array<{ __typename?: 'espin_message', player_user_id?: string | null | undefined, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, college_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, id: any, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, id: any, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, player_followers: Array<{ __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined }>, player_deleted_followers: Array<{ __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined }>, player_following: Array<{ __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined }>, player_profile_views: Array<{ __typename?: 'espin_profile_view', id: any, player_user_id?: string | null | undefined }>, unread_parent_messages: Array<{ __typename?: 'espin_message', id: any, player_user_id?: string | null | undefined }>, all_parent_messages: Array<{ __typename?: 'espin_message', player_user_id?: string | null | undefined, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, college_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, id: any, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, id: any, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, parent_followers: Array<{ __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined }>, parent_deleted_followers: Array<{ __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined }>, parent_following: Array<{ __typename?: 'espin_follow', id: any, player_user_id?: string | null | undefined }>, parent_profile_views: Array<{ __typename?: 'espin_profile_view', id: any, player_user_id?: string | null | undefined }> };

export type CollegeMessagesQueryVariables = Exact<{
  collegeId?: Maybe<Scalars['uuid']>;
}>;


export type CollegeMessagesQuery = { __typename?: 'query_root', espin_message: Array<{ __typename?: 'espin_message', player_user_id?: string | null | undefined, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, college_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, id: any, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, id: any, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }> };

export type HighSchoolMessagesQueryVariables = Exact<{
  highSchoolId?: Maybe<Scalars['uuid']>;
}>;


export type HighSchoolMessagesQuery = { __typename?: 'query_root', espin_message: Array<{ __typename?: 'espin_message', player_user_id?: string | null | undefined, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, college_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, id: any, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, id: any, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }> };

export type SearchPlayerMessagesQueryVariables = Exact<{
  playerSearch: Espin_Message_Bool_Exp;
}>;


export type SearchPlayerMessagesQuery = { __typename?: 'query_root', espin_message: Array<{ __typename?: 'espin_message', player_user_id?: string | null | undefined, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, college_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, id: any, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, id: any, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }> };

export type PlayerMessagesQueryVariables = Exact<{
  playerUserId?: Maybe<Scalars['String']>;
}>;


export type PlayerMessagesQuery = { __typename?: 'query_root', espin_message: Array<{ __typename?: 'espin_message', player_user_id?: string | null | undefined, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, college_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, id: any, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, id: any, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }> };

export type ParentMessagesQueryVariables = Exact<{
  playerUserIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ParentMessagesQuery = { __typename?: 'query_root', espin_message: Array<{ __typename?: 'espin_message', player_user_id?: string | null | undefined, college_id?: any | null | undefined, parent_user_id?: string | null | undefined, college_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, id: any, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined, id: any, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }> };

export type ChildProfileDataQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ChildProfileDataQuery = { __typename?: 'query_root', espin_parent_profile: Array<{ __typename?: 'espin_parent_profile', child_profiles: Array<{ __typename?: 'espin_player_profile', user_id: string, spin_username: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> }> };

export type ConversationWithCollegeBySlugQueryVariables = Exact<{
  slug?: Scalars['String'];
}>;


export type ConversationWithCollegeBySlugQuery = { __typename?: 'query_root', collegeIdBySlug: Array<{ __typename?: 'espin_college', id: any, name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> };

export type ConversationWithHighSchoolBySlugQueryVariables = Exact<{
  slug?: Scalars['String'];
}>;


export type ConversationWithHighSchoolBySlugQuery = { __typename?: 'query_root', highSchoolIdBySlug: Array<{ __typename?: 'espin_high_school', id: any, name: string, slug?: string | null | undefined, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> };

export type ConversationWithPlayerBySlugQueryVariables = Exact<{
  slug?: Scalars['String'];
}>;


export type ConversationWithPlayerBySlugQuery = { __typename?: 'query_root', playerIdBySlug: Array<{ __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> };

export type RecordMessageViewsMutationVariables = Exact<{
  collegeId?: Maybe<Scalars['uuid']>;
  playerUserId?: Maybe<Scalars['String']>;
  messageType: Espin_Message_Type_Enum;
}>;


export type RecordMessageViewsMutation = { __typename?: 'mutation_root', update_espin_message?: { __typename?: 'espin_message_mutation_response', affected_rows: number } | null | undefined };

export type RecordAdminPlayerMessageViewsMutationVariables = Exact<{
  playerUserId: Scalars['String'];
  messageType: Espin_Message_Type_Enum;
}>;


export type RecordAdminPlayerMessageViewsMutation = { __typename?: 'mutation_root', update_espin_message?: { __typename?: 'espin_message_mutation_response', affected_rows: number } | null | undefined };

export type RecordAdminCollegeMessageViewsMutationVariables = Exact<{
  collegeId: Scalars['uuid'];
  messageType: Espin_Message_Type_Enum;
}>;


export type RecordAdminCollegeMessageViewsMutation = { __typename?: 'mutation_root', update_espin_message?: { __typename?: 'espin_message_mutation_response', affected_rows: number } | null | undefined };

export type ParentPlayerProfileBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ParentPlayerProfileBySlugQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', spin_username: string, id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, bio?: string | null | undefined, slug: string, committed_to_college?: string | null | undefined, user_id: string, phone?: string | null | undefined, gpa: any, graduating_class?: string | null | undefined, preferred_study_fields?: any | null | undefined, preferred_schools?: any | null | undefined, college_name?: string | null | undefined, hs_name?: string | null | undefined, is_hs: boolean, player_vods: Array<{ __typename?: 'espin_player_vod', id: any, label?: string | null | undefined, media_link: { __typename?: 'content_media_link', id: any, link_data: string, link_type: Content_Media_Link_Type_Enum } }>, primary_game: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, role?: string | null | undefined, tracker?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, user: { __typename?: 'espin_user', email: string, id: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined }, social?: { __typename?: 'espin_social', discord?: string | null | undefined, twitter?: string | null | undefined, facebook?: string | null | undefined, tiktok?: string | null | undefined, instagram?: string | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, linked_high_school_details?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined } | null | undefined }> };

export type EventScoutingReportBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type EventScoutingReportBySlugQuery = { __typename?: 'query_root', espin_event: Array<{ __typename?: 'espin_event', name: string, event_start_date: any, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> }> };

export type SearchScoutingReportsQueryVariables = Exact<{
  slug: Scalars['String'];
  search: Espin_Event_Registration_Bool_Exp;
}>;


export type SearchScoutingReportsQuery = { __typename?: 'query_root', espin_event_registration: Array<{ __typename?: 'espin_event_registration', registration_details?: any | null | undefined, user: { __typename?: 'espin_user', id: string, player_profile?: { __typename?: 'espin_player_profile', id: any, graduating_class?: string | null | undefined, gpa: any, slug: string, first_name?: string | null | undefined, last_name?: string | null | undefined, phone?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, role?: string | null | undefined, tracker?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, social?: { __typename?: 'espin_social', discord?: string | null | undefined } | null | undefined, user: { __typename?: 'espin_user', email: string, id: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined } } | null | undefined, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined }, event_ticket: { __typename?: 'espin_event_ticket', ticket_type: Espin_Event_Ticket_Type_Enum, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } | null | undefined } }> };

export type ScoutingReports_IndexQueryVariables = Exact<{ [key: string]: never; }>;


export type ScoutingReports_IndexQuery = { __typename?: 'query_root', espin_event: Array<{ __typename?: 'espin_event', name: string, slug: string, stream_url?: string | null | undefined, prize: any, event_start_date: any, event_end_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }> };

export type EspinGetSiteEducationContentQueryVariables = Exact<{ [key: string]: never; }>;


export type EspinGetSiteEducationContentQuery = { __typename?: 'query_root', educationContent?: { __typename?: 'espin_site_content', key: Espin_Editable_Site_Content_Enum, value?: string | null | undefined } | null | undefined };

export type GetRegistrationConfirmedQueryVariables = Exact<{
  registrationId: Scalars['uuid'];
}>;


export type GetRegistrationConfirmedQuery = { __typename?: 'query_root', espin_event_registration_by_pk?: { __typename?: 'espin_event_registration', event_ticket: { __typename?: 'espin_event_ticket', id: any, ticket_type: Espin_Event_Ticket_Type_Enum, description?: string | null | undefined, price_temp: any, game?: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } | null | undefined, event: { __typename?: 'espin_event', name: string, event_start_date: any, event_end_date: any, success_page?: string | null | undefined, slug: string, prize: any, type: Espin_Event_Type_Enum, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> } } } | null | undefined };

export type ConfirmedRegistrationForEventFragment = { __typename?: 'espin_event_ticket', id: any, ticket_type: Espin_Event_Ticket_Type_Enum, description?: string | null | undefined, price_temp: any, event: { __typename?: 'espin_event', name: string, success_page?: string | null | undefined, slug: string }, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } | null | undefined };

export type GetPaidRegistrationIdQueryVariables = Exact<{
  ticketId: Scalars['uuid'];
  userId: Scalars['String'];
}>;


export type GetPaidRegistrationIdQuery = { __typename?: 'query_root', espin_event_registration: Array<{ __typename?: 'espin_event_registration', id: any, event: { __typename?: 'espin_event', slug: string } }> };

export type EventBySlugQueryVariables = Exact<{
  eventSlug: Scalars['String'];
}>;


export type EventBySlugQuery = { __typename?: 'query_root', espin_event: Array<{ __typename?: 'espin_event', id: any, name: string, short_description?: string | null | undefined, slug: string, event_start_date: any, event_end_date: any, url?: string | null | undefined, register_start_date: any, register_end_date: any, stream_url?: string | null | undefined, body_content?: string | null | undefined, type: Espin_Event_Type_Enum, prize: any, rules_content?: string | null | undefined, registration_disclaimer?: string | null | undefined, event_tickets: Array<{ __typename?: 'espin_event_ticket', id: any, ticket_type: Espin_Event_Ticket_Type_Enum, description?: string | null | undefined, price_temp: any, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } | null | undefined, event: { __typename?: 'espin_event', slug: string } }>, logo?: { __typename?: 'content_file', id: any, ext?: string | null | undefined, cdn_url?: string | null | undefined } | null | undefined, icon?: { __typename?: 'content_file', id: any, ext?: string | null | undefined, cdn_url?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', id: any, game_id: string, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string, website?: string | null | undefined, image_url?: string | null | undefined, team_max_size: number } }> }> };

export type EventTicketRegistrationsForUserQueryVariables = Exact<{
  eventSlug: Scalars['String'];
}>;


export type EventTicketRegistrationsForUserQuery = { __typename?: 'query_root', espin_event: Array<{ __typename?: 'espin_event', event_tickets: Array<{ __typename?: 'espin_event_ticket', id: any, event_registrations: Array<{ __typename?: 'espin_event_registration', id: any }> }> }> };

export type SsgEventsBySlugQueryVariables = Exact<{ [key: string]: never; }>;


export type SsgEventsBySlugQuery = { __typename?: 'query_root', espin_event: Array<{ __typename?: 'espin_event', id: any, slug: string }> };

export type RegisterForEventQueryVariables = Exact<{
  ticketId: Scalars['uuid'];
}>;


export type RegisterForEventQuery = { __typename?: 'query_root', espin_event_ticket_by_pk?: { __typename?: 'espin_event_ticket', price_temp: any, price_id?: string | null | undefined, id: any, ticket_type: Espin_Event_Ticket_Type_Enum, description?: string | null | undefined, event: { __typename?: 'espin_event', slug: string, id: any, name: string, event_start_date: any, prize: any, event_end_date: any, type: Espin_Event_Type_Enum, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }>, event_custom_fields: Array<{ __typename?: 'espin_event_custom_field', id: any, default_value?: string | null | undefined, field_type: Espin_Event_Custom_Field_Type_Enum, name: string, label?: string | null | undefined }>, event_documents: Array<{ __typename?: 'espin_event_document', id: any, name?: string | null | undefined, file?: { __typename?: 'content_file', id: any, original_name?: string | null | undefined, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> }, game?: { __typename?: 'espin_game', team_max_size: number, game_definition: Espin_Game_Definition_Enum, name: string } | null | undefined } | null | undefined };

export type Events_IndexQueryVariables = Exact<{ [key: string]: never; }>;


export type Events_IndexQuery = { __typename?: 'query_root', stickied_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }>, espin_event: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }>, espin_game_definition: Array<{ __typename?: 'espin_game_definition', display_name: string, game_name: string }> };

export type HighSchool_DetailsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type HighSchool_DetailsQuery = { __typename?: 'query_root', espin_high_school: Array<{ __typename?: 'espin_high_school', id: any, name: string, bio?: string | null | undefined, contact_email?: string | null | undefined, contact_name?: string | null | undefined, contact_phone?: string | null | undefined, slug?: string | null | undefined, address?: { __typename?: 'espin_address', state: string, city: string, country?: string | null | undefined, location?: any | null | undefined } | null | undefined, teams: Array<{ __typename?: 'espin_team', id: any, display_name: string, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string }, members: Array<{ __typename?: 'espin_team_members', team_role: Espin_Team_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, slug: string, id: any } | null | undefined }> }>, esportsTeams: Array<{ __typename?: 'espin_team', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }>, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, socials?: { __typename?: 'espin_social', facebook?: string | null | undefined, twitch?: string | null | undefined, twitter?: string | null | undefined, instagram?: string | null | undefined, discord?: string | null | undefined, website?: string | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined }> };

export type HighSchools_IndexQueryVariables = Exact<{ [key: string]: never; }>;


export type HighSchools_IndexQuery = { __typename?: 'query_root', espin_game_definition: Array<{ __typename?: 'espin_game_definition', display_name: string, game_name: string }> };

export type SearchHighSchoolsQueryVariables = Exact<{
  search: Espin_High_School_Bool_Exp;
  offset?: Scalars['Int'];
  pageSize?: Scalars['Int'];
}>;


export type SearchHighSchoolsQuery = { __typename?: 'query_root', espin_high_school: Array<{ __typename?: 'espin_high_school', id: any, name: string, slug?: string | null | undefined, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, teams: Array<{ __typename?: 'espin_team', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }>, profile_pic_file?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }>, allCount: { __typename?: 'espin_high_school_aggregate', aggregate?: { __typename?: 'espin_high_school_aggregate_fields', count: number } | null | undefined } };

export type HomePageQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageQuery = { __typename?: 'query_root', stickied_events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }>, events: Array<{ __typename?: 'espin_event', id: any, slug: string, name: string, type: Espin_Event_Type_Enum, prize: any, event_start_date: any, event_end_date: any, register_end_date: any, register_start_date: any, icon?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, event_games: Array<{ __typename?: 'espin_event_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }> };

export type AcceptInvitationMutationVariables = Exact<{
  inviteId: Scalars['uuid'];
}>;


export type AcceptInvitationMutation = { __typename?: 'mutation_root', acceptCollegeInvite?: { __typename?: 'AcceptCollegeInviteOutput', valid: boolean } | null | undefined };

export type GetCollegeInviteByIdQueryVariables = Exact<{
  inviteId: Scalars['uuid'];
}>;


export type GetCollegeInviteByIdQuery = { __typename?: 'query_root', espin_college_invite_by_pk?: { __typename?: 'espin_college_invite', id: any, email: string } | null | undefined };

export type CheckCollegeEmailExistsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type CheckCollegeEmailExistsQuery = { __typename?: 'query_root', espin_user: Array<{ __typename?: 'espin_user', id: string, college_profile?: { __typename?: 'espin_college_profile', id: any } | null | undefined }> };

export type AdminCreateCollegeFromInviteMutationVariables = Exact<{
  input: Espin_College_Profile_Insert_Input;
  inviteId: Scalars['uuid'];
}>;


export type AdminCreateCollegeFromInviteMutation = { __typename?: 'mutation_root', insert_espin_college_profile_one?: { __typename?: 'espin_college_profile', id: any } | null | undefined, update_espin_college_invite_by_pk?: { __typename?: 'espin_college_invite', id: any, status: Espin_Invite_Status_Type_Enum } | null | undefined };

export type PostInviteLoginFragment = { __typename?: 'espin_college_invite', id: any, email: string };

export type GetHighSchoolInviteByIdQueryVariables = Exact<{
  inviteId: Scalars['uuid'];
}>;


export type GetHighSchoolInviteByIdQuery = { __typename?: 'query_root', espin_high_school_invite_by_pk?: { __typename?: 'espin_high_school_invite', id: any, email: string, status: Espin_Invite_Status_Type_Enum, high_school: { __typename?: 'espin_high_school', id: any } } | null | undefined };

export type CheckHighSchoolEmailExistsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type CheckHighSchoolEmailExistsQuery = { __typename?: 'query_root', espin_user: Array<{ __typename?: 'espin_user', id: string, high_school_profile?: { __typename?: 'espin_high_school_profile', id: any } | null | undefined }> };

export type AdminCreateHighSchoolProfileFromInviteMutationVariables = Exact<{
  input: Espin_High_School_Profile_Insert_Input;
  inviteId: Scalars['uuid'];
}>;


export type AdminCreateHighSchoolProfileFromInviteMutation = { __typename?: 'mutation_root', insert_espin_high_school_profile_one?: { __typename?: 'espin_high_school_profile', id: any } | null | undefined, update_espin_high_school_invite_by_pk?: { __typename?: 'espin_high_school_invite', id: any, status: Espin_Invite_Status_Type_Enum } | null | undefined };

export type PostHsInviteLoginFragment = { __typename?: 'espin_high_school_invite', id: any, email: string, status: Espin_Invite_Status_Type_Enum, high_school: { __typename?: 'espin_high_school', id: any } };

export type AdminGetParentInviteByIdQueryVariables = Exact<{
  inviteId: Scalars['uuid'];
}>;


export type AdminGetParentInviteByIdQuery = { __typename?: 'query_root', espin_parent_invite_by_pk?: { __typename?: 'espin_parent_invite', id: any, parent_email: string, status: Espin_Invite_Status_Type_Enum, player_profile: { __typename?: 'espin_player_profile', id: any } } | null | undefined };

export type CheckParentEmailExistsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type CheckParentEmailExistsQuery = { __typename?: 'query_root', espin_user: Array<{ __typename?: 'espin_user', id: string, parent_profile?: { __typename?: 'espin_parent_profile', id: any } | null | undefined }> };

export type AdminLinkParentToChildMutationVariables = Exact<{
  playerProfileId: Scalars['uuid'];
  parentProfileId: Scalars['uuid'];
}>;


export type AdminLinkParentToChildMutation = { __typename?: 'mutation_root', update_espin_player_profile_by_pk?: { __typename?: 'espin_player_profile', id: any } | null | undefined };

export type AdminCreateParentFromInviteMutationVariables = Exact<{
  input: Espin_Parent_Profile_Insert_Input;
  inviteId: Scalars['uuid'];
}>;


export type AdminCreateParentFromInviteMutation = { __typename?: 'mutation_root', insert_espin_parent_profile_one?: { __typename?: 'espin_parent_profile', id: any } | null | undefined, update_espin_parent_invite_by_pk?: { __typename?: 'espin_parent_invite', id: any, status: Espin_Invite_Status_Type_Enum } | null | undefined };

export type OrgIhsenIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgIhsenIndexQuery = { __typename?: 'query_root', espin_org_month: Array<{ __typename?: 'espin_org_month', month: string, total_days: number, start_day: number, month_of_year?: number | null | undefined, days: Array<{ __typename?: 'espin_org_month_day', date: number, title: string, time?: string | null | undefined, game_def?: string | null | undefined, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } | null | undefined }> }> };

export type OrgIhsenRankingsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgIhsenRankingsQuery = { __typename?: 'query_root', espin_org_player: Array<{ __typename?: 'espin_org_player', rank?: number | null | undefined, gpa?: any | null | undefined, grad_class?: number | null | undefined, game_rank?: string | null | undefined, username?: string | null | undefined, game?: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined } | null | undefined }>, espin_org_school: Array<{ __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined, rank?: number | null | undefined, bio?: string | null | undefined, records: Array<{ __typename?: 'espin_org_school_record', wins: number, losses: number, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }> };

export type OrgIhsenRecruitingQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgIhsenRecruitingQuery = { __typename?: 'query_root', espin_college: Array<{ __typename?: 'espin_college', id: any, name: string, program_name?: string | null | undefined, subscribed: boolean, slug?: string | null | undefined, scholarships: boolean, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }>, espin_org_player: Array<{ __typename?: 'espin_org_player', player_review?: string | null | undefined, rank?: number | null | undefined, featured: boolean, gpa?: any | null | undefined, grad_class?: number | null | undefined, game_rank?: string | null | undefined, username?: string | null | undefined, game?: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined } | null | undefined }>, espin_org_school: Array<{ __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined, rank?: number | null | undefined, bio?: string | null | undefined, featured: boolean, records: Array<{ __typename?: 'espin_org_school_record', wins: number, losses: number, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }> };

export type OrgIhseaIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgIhseaIndexQuery = { __typename?: 'query_root', espin_org_month: Array<{ __typename?: 'espin_org_month', month: string, total_days: number, start_day: number, month_of_year?: number | null | undefined, days: Array<{ __typename?: 'espin_org_month_day', date: number, title: string, time?: string | null | undefined, game_def?: string | null | undefined, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } | null | undefined }> }> };

export type OrgIhseaRankingQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgIhseaRankingQuery = { __typename?: 'query_root', espin_org_player: Array<{ __typename?: 'espin_org_player', rank?: number | null | undefined, gpa?: any | null | undefined, grad_class?: number | null | undefined, game_rank?: string | null | undefined, username?: string | null | undefined, game?: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined } | null | undefined }>, espin_org_school: Array<{ __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined, rank?: number | null | undefined, bio?: string | null | undefined, records: Array<{ __typename?: 'espin_org_school_record', wins: number, losses: number, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }> };

export type OrgIhseaRecruitingQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgIhseaRecruitingQuery = { __typename?: 'query_root', espin_college: Array<{ __typename?: 'espin_college', id: any, name: string, program_name?: string | null | undefined, subscribed: boolean, slug?: string | null | undefined, scholarships: boolean, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }>, espin_org_player: Array<{ __typename?: 'espin_org_player', player_review?: string | null | undefined, rank?: number | null | undefined, featured: boolean, gpa?: any | null | undefined, grad_class?: number | null | undefined, game_rank?: string | null | undefined, username?: string | null | undefined, game?: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined } | null | undefined }>, espin_org_school: Array<{ __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined, rank?: number | null | undefined, bio?: string | null | undefined, featured: boolean, records: Array<{ __typename?: 'espin_org_school_record', wins: number, losses: number, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }> };

export type OrgPlayvsIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgPlayvsIndexQuery = { __typename?: 'query_root', espin_org_month: Array<{ __typename?: 'espin_org_month', month: string, total_days: number, start_day: number, month_of_year?: number | null | undefined, days: Array<{ __typename?: 'espin_org_month_day', date: number, title: string, time?: string | null | undefined, game_def?: string | null | undefined, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } | null | undefined }> }> };

export type OrgPlayVsRankingsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgPlayVsRankingsQuery = { __typename?: 'query_root', espin_org_player: Array<{ __typename?: 'espin_org_player', rank?: number | null | undefined, gpa?: any | null | undefined, grad_class?: number | null | undefined, game_rank?: string | null | undefined, username?: string | null | undefined, game?: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined } | null | undefined }>, espin_org_school: Array<{ __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined, rank?: number | null | undefined, bio?: string | null | undefined, records: Array<{ __typename?: 'espin_org_school_record', wins: number, losses: number, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }> };

export type OrgPlayVsRecruitingQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgPlayVsRecruitingQuery = { __typename?: 'query_root', espin_college: Array<{ __typename?: 'espin_college', id: any, name: string, program_name?: string | null | undefined, subscribed: boolean, slug?: string | null | undefined, scholarships: boolean, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }>, espin_org_player: Array<{ __typename?: 'espin_org_player', player_review?: string | null | undefined, rank?: number | null | undefined, featured: boolean, gpa?: any | null | undefined, grad_class?: number | null | undefined, game_rank?: string | null | undefined, username?: string | null | undefined, game?: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined } | null | undefined }>, espin_org_school: Array<{ __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined, rank?: number | null | undefined, bio?: string | null | undefined, featured: boolean, records: Array<{ __typename?: 'espin_org_school_record', wins: number, losses: number, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }> };

export type OrgUfeaIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgUfeaIndexQuery = { __typename?: 'query_root', espin_org_month: Array<{ __typename?: 'espin_org_month', month: string, total_days: number, start_day: number, month_of_year?: number | null | undefined, days: Array<{ __typename?: 'espin_org_month_day', date: number, title: string, time?: string | null | undefined, game_def?: string | null | undefined, game?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } | null | undefined }> }> };

export type OrgUfeaRankingQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgUfeaRankingQuery = { __typename?: 'query_root', espin_org_player: Array<{ __typename?: 'espin_org_player', rank?: number | null | undefined, gpa?: any | null | undefined, grad_class?: number | null | undefined, game_rank?: string | null | undefined, username?: string | null | undefined, game?: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined } | null | undefined }>, espin_org_school: Array<{ __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined, rank?: number | null | undefined, bio?: string | null | undefined, featured: boolean, records: Array<{ __typename?: 'espin_org_school_record', wins: number, losses: number, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }> };

export type OrgUfeaRecruitingQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgUfeaRecruitingQuery = { __typename?: 'query_root', espin_college: Array<{ __typename?: 'espin_college', id: any, name: string, program_name?: string | null | undefined, subscribed: boolean, slug?: string | null | undefined, scholarships: boolean, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, college_games: Array<{ __typename?: 'espin_college_game', game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } }>, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }>, espin_org_player: Array<{ __typename?: 'espin_org_player', player_review?: string | null | undefined, rank?: number | null | undefined, featured: boolean, gpa?: any | null | undefined, grad_class?: number | null | undefined, game_rank?: string | null | undefined, username?: string | null | undefined, game?: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } | null | undefined, school?: { __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined } | null | undefined }>, espin_org_school: Array<{ __typename?: 'espin_org_school', display_name: string, city?: string | null | undefined, state?: string | null | undefined, rank?: number | null | undefined, bio?: string | null | undefined, records: Array<{ __typename?: 'espin_org_school_record', wins: number, losses: number, game: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string } }> }> };

export type PlayerJourneyBySlugQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerJourneyBySlugQuery = { __typename?: 'query_root', espin_player_journey: Array<{ __typename?: 'espin_player_journey', id: any, display_name: string, slug: string, city?: string | null | undefined, state?: string | null | undefined, description?: string | null | undefined, game?: Espin_Game_Definition_Enum | null | undefined, rank?: string | null | undefined, profile_slug?: string | null | undefined, profile_image_url?: string | null | undefined, player_journey_stages: Array<{ __typename?: 'espin_player_journey_stage', id: any, order: number, def: Espin_Player_Journey_Stage_Def_Enum, title: string, colleges: Array<{ __typename?: 'espin_player_journey_stage_college', college_id: any, college: { __typename?: 'espin_college', id: any, program_name?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined, original_name?: string | null | undefined } | null | undefined } }>, player_journey_stage_def: { __typename?: 'espin_player_journey_stage_def', name: string, display_name: string } }> }> };

export type Player_DetailsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type Player_DetailsQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', id: any, spin_username: string, first_name?: string | null | undefined, last_name?: string | null | undefined, bio?: string | null | undefined, slug: string, committed_to_college?: string | null | undefined, user_id: string, phone?: string | null | undefined, gpa: any, graduating_class?: string | null | undefined, preferred_study_fields?: any | null | undefined, preferred_schools?: any | null | undefined, college_name?: string | null | undefined, hs_name?: string | null | undefined, is_hs: boolean, player_vods: Array<{ __typename?: 'espin_player_vod', id: any, label?: string | null | undefined, media_link: { __typename?: 'content_media_link', id: any, link_data: string, link_type: Content_Media_Link_Type_Enum } }>, primary_game: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, role?: string | null | undefined, tracker?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }>, user: { __typename?: 'espin_user', email: string, id: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined }, social?: { __typename?: 'espin_social', discord?: string | null | undefined, twitter?: string | null | undefined, facebook?: string | null | undefined, tiktok?: string | null | undefined, instagram?: string | null | undefined, youtube_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined, twitch_channel?: { __typename?: 'content_media_link', id: any, link_data: string } | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', city: string, state: string, country?: string | null | undefined } | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, linked_high_school_details?: { __typename?: 'espin_high_school', name: string, slug?: string | null | undefined } | null | undefined }> };

export type RecordProfileViewMutationVariables = Exact<{
  input: Espin_Profile_View_Insert_Input;
}>;


export type RecordProfileViewMutation = { __typename?: 'mutation_root', insert_espin_profile_view_one?: { __typename?: 'espin_profile_view', id: any } | null | undefined };

export type Players_IndexQueryVariables = Exact<{ [key: string]: never; }>;


export type Players_IndexQuery = { __typename?: 'query_root', espin_game_definition: Array<{ __typename?: 'espin_game_definition', display_name: string, game_name: string }>, espin_study_field: Array<{ __typename?: 'espin_study_field', name: string }>, espin_study_subject: Array<{ __typename?: 'espin_study_subject', name: string, study_field: { __typename?: 'espin_study_field', name: string } }> };

export type PlayerSearchFilterFragment = { __typename?: 'query_root', espin_game_definition: Array<{ __typename?: 'espin_game_definition', display_name: string, game_name: string }>, espin_study_field: Array<{ __typename?: 'espin_study_field', name: string }>, espin_study_subject: Array<{ __typename?: 'espin_study_subject', name: string, study_field: { __typename?: 'espin_study_field', name: string } }> };

export type SearchPlayersQueryVariables = Exact<{
  search: Espin_Player_Profile_Bool_Exp;
  offset?: Scalars['Int'];
  pageSize?: Scalars['Int'];
  orderBy?: Maybe<Array<Espin_Player_Profile_Order_By> | Espin_Player_Profile_Order_By>;
}>;


export type SearchPlayersQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', id: any, slug: string, first_name?: string | null | undefined, last_name?: string | null | undefined, spin_username: string, gpa: any, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, original_name?: string | null | undefined, ext?: string | null | undefined } | null | undefined, address?: { __typename?: 'espin_address', country?: string | null | undefined, city: string, state: string } | null | undefined, primary_game: Array<{ __typename?: 'espin_player_game', rank?: string | null | undefined, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> }>, espin_player_profile_aggregate: { __typename?: 'espin_player_profile_aggregate', aggregate?: { __typename?: 'espin_player_profile_aggregate_fields', count: number } | null | undefined } };

export type GetCurrentCollegeUserLocationQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetCurrentCollegeUserLocationQuery = { __typename?: 'query_root', espin_college_by_pk?: { __typename?: 'espin_college', address?: { __typename?: 'espin_address', location?: any | null | undefined } | null | undefined } | null | undefined };

export type GetCollegeUserIdPairsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollegeUserIdPairsQuery = { __typename?: 'query_root', espin_user: Array<{ __typename?: 'espin_user', id: string, college_profile?: { __typename?: 'espin_college_profile', college_id: any } | null | undefined }> };

export type ChangeCollegeToManualSubMutationVariables = Exact<{
  collegeId: Scalars['uuid'];
}>;


export type ChangeCollegeToManualSubMutation = { __typename?: 'mutation_root', update_espin_college_by_pk?: { __typename?: 'espin_college', id: any, updated_at?: any | null | undefined, name: string } | null | undefined };

export type FindCollegeBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type FindCollegeBySlugQuery = { __typename?: 'query_root', espin_college: Array<{ __typename?: 'espin_college', id: any }> };

export type ContentFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type ContentFilesQuery = { __typename?: 'query_root', content_file: Array<{ __typename?: 'content_file', original_name?: string | null | undefined, id: any }> };

export type CreateGameMutationVariables = Exact<{
  input: Espin_Game_Insert_Input;
}>;


export type CreateGameMutation = { __typename?: 'mutation_root', insert_espin_game_one?: { __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum } | null | undefined };

export type CreateGamesMutationVariables = Exact<{
  input: Array<Espin_Game_Insert_Input> | Espin_Game_Insert_Input;
}>;


export type CreateGamesMutation = { __typename?: 'mutation_root', insert_espin_game?: { __typename?: 'espin_game_mutation_response', returning: Array<{ __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum }> } | null | undefined };

export type CreatePlayerMutationVariables = Exact<{
  input: Espin_User_Insert_Input;
}>;


export type CreatePlayerMutation = { __typename?: 'mutation_root', insert_espin_user_one?: { __typename?: 'espin_user', id: string } | null | undefined };

export type CreateCollegeMutationVariables = Exact<{
  input: Espin_College_Insert_Input;
}>;


export type CreateCollegeMutation = { __typename?: 'mutation_root', insert_espin_college_one?: { __typename?: 'espin_college', id: any } | null | undefined };

export type SeedCreatePlayerTeamMutationVariables = Exact<{
  input: Espin_Team_Insert_Input;
}>;


export type SeedCreatePlayerTeamMutation = { __typename?: 'mutation_root', insert_espin_team_one?: { __typename?: 'espin_team', id: any } | null | undefined };

export type CreateHighSchoolMutationVariables = Exact<{
  input: Espin_High_School_Insert_Input;
}>;


export type CreateHighSchoolMutation = { __typename?: 'mutation_root', insert_espin_high_school_one?: { __typename?: 'espin_high_school', id: any } | null | undefined };

export type BulkCreateCollegeMutationVariables = Exact<{
  input: Array<Espin_College_Insert_Input> | Espin_College_Insert_Input;
}>;


export type BulkCreateCollegeMutation = { __typename?: 'mutation_root', insert_espin_college?: { __typename?: 'espin_college_mutation_response', returning: Array<{ __typename?: 'espin_college', id: any }> } | null | undefined };

export type SeedCreateEventMutationVariables = Exact<{
  input: Espin_Event_Insert_Input;
}>;


export type SeedCreateEventMutation = { __typename?: 'mutation_root', insert_espin_event_one?: { __typename?: 'espin_event', id: any, event_tickets: Array<{ __typename?: 'espin_event_ticket', id: any }> } | null | undefined };

export type SeedEventCreatedReturnFragment = { __typename?: 'espin_event', id: any, event_tickets: Array<{ __typename?: 'espin_event_ticket', id: any }> };

export type SeedHighSchoolAndProfileMutationVariables = Exact<{
  input: Espin_High_School_Profile_Insert_Input;
}>;


export type SeedHighSchoolAndProfileMutation = { __typename?: 'mutation_root', insert_espin_high_school_profile_one?: { __typename?: 'espin_high_school_profile', id: any, user_id: string } | null | undefined };

export type SeedPlayerAndProfileMutationVariables = Exact<{
  input: Espin_Player_Profile_Insert_Input;
}>;


export type SeedPlayerAndProfileMutation = { __typename?: 'mutation_root', insert_espin_player_profile_one?: { __typename?: 'espin_player_profile', id: any, user_id: string, user: { __typename?: 'espin_user', email: string } } | null | undefined };

export type BulkSeedPlayerAndProfileMutationVariables = Exact<{
  input: Array<Espin_Player_Profile_Insert_Input> | Espin_Player_Profile_Insert_Input;
}>;


export type BulkSeedPlayerAndProfileMutation = { __typename?: 'mutation_root', insert_espin_player_profile?: { __typename?: 'espin_player_profile_mutation_response', returning: Array<{ __typename?: 'espin_player_profile', id: any, user_id: string }> } | null | undefined };

export type SeedCollegeUserAndProfileMutationVariables = Exact<{
  input: Espin_College_Profile_Insert_Input;
}>;


export type SeedCollegeUserAndProfileMutation = { __typename?: 'mutation_root', insert_espin_college_profile_one?: { __typename?: 'espin_college_profile', id: any } | null | undefined };

export type SeedHighSchoolUserAndProfileMutationVariables = Exact<{
  input: Espin_High_School_Profile_Insert_Input;
}>;


export type SeedHighSchoolUserAndProfileMutation = { __typename?: 'mutation_root', insert_espin_high_school_profile_one?: { __typename?: 'espin_high_school_profile', id: any } | null | undefined };

export type BulkSeedCollegeUserAndProfileMutationVariables = Exact<{
  input: Array<Espin_College_Profile_Insert_Input> | Espin_College_Profile_Insert_Input;
}>;


export type BulkSeedCollegeUserAndProfileMutation = { __typename?: 'mutation_root', insert_espin_college_profile?: { __typename?: 'espin_college_profile_mutation_response', returning: Array<{ __typename?: 'espin_college_profile', id: any }> } | null | undefined };

export type BulkSeedParentUserAndProfileMutationVariables = Exact<{
  input: Array<Espin_Parent_Profile_Insert_Input> | Espin_Parent_Profile_Insert_Input;
}>;


export type BulkSeedParentUserAndProfileMutation = { __typename?: 'mutation_root', insert_espin_parent_profile?: { __typename?: 'espin_parent_profile_mutation_response', returning: Array<{ __typename?: 'espin_parent_profile', id: any }> } | null | undefined };

export type SeedAddNewUnregisteredCollegeMutationVariables = Exact<{
  programName?: Maybe<Scalars['String']>;
}>;


export type SeedAddNewUnregisteredCollegeMutation = { __typename?: 'mutation_root', insert_espin_unregistered_college_one?: { __typename?: 'espin_unregistered_college', id: any, program_name: string } | null | undefined };

export type SeedAddNewLeaderboardMutationVariables = Exact<{
  leaderboard: Espin_Leaderboard_Insert_Input;
}>;


export type SeedAddNewLeaderboardMutation = { __typename?: 'mutation_root', insert_espin_leaderboard_one?: { __typename?: 'espin_leaderboard', id: any } | null | undefined };

export type SeedAddUserSourcesMutationVariables = Exact<{
  input: Array<Espin_User_Source_Insert_Input> | Espin_User_Source_Insert_Input;
}>;


export type SeedAddUserSourcesMutation = { __typename?: 'mutation_root', insert_espin_user_source?: { __typename?: 'espin_user_source_mutation_response', affected_rows: number } | null | undefined };

export type SeedAddNewReferralOptionMutationVariables = Exact<{
  option: Espin_Referral_Option_Insert_Input;
}>;


export type SeedAddNewReferralOptionMutation = { __typename?: 'mutation_root', insert_espin_referral_option_one?: { __typename?: 'espin_referral_option', id: any } | null | undefined };

export type SeedAddContentFilesMutationVariables = Exact<{
  input: Array<Content_File_Insert_Input> | Content_File_Insert_Input;
}>;


export type SeedAddContentFilesMutation = { __typename?: 'mutation_root', insert_content_file?: { __typename?: 'content_file_mutation_response', returning: Array<{ __typename?: 'content_file', id: any }> } | null | undefined };

export type SeedAddMediaLinksMutationVariables = Exact<{
  input: Array<Content_Media_Link_Insert_Input> | Content_Media_Link_Insert_Input;
}>;


export type SeedAddMediaLinksMutation = { __typename?: 'mutation_root', insert_content_media_link?: { __typename?: 'content_media_link_mutation_response', returning: Array<{ __typename?: 'content_media_link', id: any }> } | null | undefined };

export type UpdateCollegeUserProfileMutationVariables = Exact<{
  profileId: Scalars['uuid'];
  input: Espin_College_Profile_Set_Input;
}>;


export type UpdateCollegeUserProfileMutation = { __typename?: 'mutation_root', update_espin_college_profile_by_pk?: { __typename?: 'espin_college_profile', id: any } | null | undefined };

export type SeedParentUserAndProfileMutationVariables = Exact<{
  input: Espin_Parent_Profile_Insert_Input;
}>;


export type SeedParentUserAndProfileMutation = { __typename?: 'mutation_root', insert_espin_parent_profile_one?: { __typename?: 'espin_parent_profile', id: any } | null | undefined };

export type SeedAddNotificationsMutationVariables = Exact<{
  input: Array<Espin_Notification_Insert_Input> | Espin_Notification_Insert_Input;
}>;


export type SeedAddNotificationsMutation = { __typename?: 'mutation_root', insert_espin_notification?: { __typename?: 'espin_notification_mutation_response', returning: Array<{ __typename?: 'espin_notification', id: any }> } | null | undefined };

export type SeedCreateReferralCodesMutationVariables = Exact<{
  input: Array<Espin_Referral_Code_Insert_Input> | Espin_Referral_Code_Insert_Input;
}>;


export type SeedCreateReferralCodesMutation = { __typename?: 'mutation_root', insert_espin_referral_code?: { __typename?: 'espin_referral_code_mutation_response', returning: Array<{ __typename?: 'espin_referral_code', id: any }> } | null | undefined };

export type SeedCreateEventRegistrationsMutationVariables = Exact<{
  input: Array<Espin_Event_Registration_Insert_Input> | Espin_Event_Registration_Insert_Input;
}>;


export type SeedCreateEventRegistrationsMutation = { __typename?: 'mutation_root', insert_espin_event_registration?: { __typename?: 'espin_event_registration_mutation_response', affected_rows: number } | null | undefined };

export type ScriptSetCollegeOwnerMutationVariables = Exact<{
  collegeId: Scalars['uuid'];
  collegeOwnerId: Scalars['uuid'];
}>;


export type ScriptSetCollegeOwnerMutation = { __typename?: 'mutation_root', update_espin_college_by_pk?: { __typename?: 'espin_college', id: any, updated_at?: any | null | undefined, owner_profile_id?: any | null | undefined } | null | undefined };

export type ScriptGetCollegesWithoutOwnersQueryVariables = Exact<{ [key: string]: never; }>;


export type ScriptGetCollegesWithoutOwnersQuery = { __typename?: 'query_root', espin_college: Array<{ __typename?: 'espin_college', id: any, name: string, college_profiles: Array<{ __typename?: 'espin_college_profile', id: any, user_id: string, user: { __typename?: 'espin_user', email: string } }> }> };

export type AdminCreateUserMutationVariables = Exact<{
  input: Espin_User_Insert_Input;
}>;


export type AdminCreateUserMutation = { __typename?: 'mutation_root', insert_espin_user_one?: { __typename?: 'espin_user', id: string, role: Espin_Role_Enum, email: string } | null | undefined };

export type LinkExternalProviderMutationVariables = Exact<{
  link: Espin_External_Provider_Link_Insert_Input;
}>;


export type LinkExternalProviderMutation = { __typename?: 'mutation_root', insert_espin_external_provider_link_one?: { __typename?: 'espin_external_provider_link', id: any, external_id: string } | null | undefined };

export type LinkEspinUserToExternalProviderMutationVariables = Exact<{
  userID: Scalars['String'];
  externalLinkID: Scalars['uuid'];
}>;


export type LinkEspinUserToExternalProviderMutation = { __typename?: 'mutation_root', insert_espin_user_linked_external_provider_one?: { __typename?: 'espin_user_linked_external_provider', id: any, link_id: any, user_id: string } | null | undefined };

export type GetUserByIdQueryVariables = Exact<{
  userId?: Maybe<Scalars['String']>;
}>;


export type GetUserByIdQuery = { __typename?: 'query_root', espin_user: Array<{ __typename?: 'espin_user', role: Espin_Role_Enum, college_profile?: { __typename?: 'espin_college_profile', id: any, user_id: string } | null | undefined }> };

export type GetSchoolIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetSchoolIdQuery = { __typename?: 'query_root', espin_user: Array<{ __typename?: 'espin_user', college_profile?: { __typename?: 'espin_college_profile', college_id: any } | null | undefined }> };

export type LinkedUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type LinkedUserQuery = { __typename?: 'query_root', espin_user_linked_external_provider: Array<{ __typename?: 'espin_user_linked_external_provider', id: any }> };

export type UnlinkUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UnlinkUserMutation = { __typename?: 'mutation_root', delete_espin_user_linked_external_provider?: { __typename?: 'espin_user_linked_external_provider_mutation_response', returning: Array<{ __typename?: 'espin_user_linked_external_provider', id: any }> } | null | undefined };

export type GetExternalProviderLinkByExternalIdQueryVariables = Exact<{
  externalId: Scalars['String'];
}>;


export type GetExternalProviderLinkByExternalIdQuery = { __typename?: 'query_root', espin_external_provider_link: Array<{ __typename?: 'espin_external_provider_link', id: any }> };

export type AdminSetAutomatedMessageResponseMutationVariables = Exact<{
  collegeId: Scalars['uuid'];
  automaticMessageResponseType: Espin_College_Automatic_Message_Response_Type_Enum;
}>;


export type AdminSetAutomatedMessageResponseMutation = { __typename?: 'mutation_root', update_espin_college_preferences?: { __typename?: 'espin_college_preferences_mutation_response', returning: Array<{ __typename?: 'espin_college_preferences', id: any }> } | null | undefined };

export type AdminGetPlayerSlugFromSpinUsernameQueryVariables = Exact<{
  spin_username: Scalars['String'];
}>;


export type AdminGetPlayerSlugFromSpinUsernameQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', slug: string }> };

export type AdminBulkGetPlayerSlugFromSpinUsernameQueryVariables = Exact<{
  spin_usernames: Array<Scalars['String']> | Scalars['String'];
}>;


export type AdminBulkGetPlayerSlugFromSpinUsernameQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', spin_username: string, slug: string }> };

export type CreateKeyValueStoreMutationVariables = Exact<{
  content: Scalars['jsonb'];
}>;


export type CreateKeyValueStoreMutation = { __typename?: 'mutation_root', insert_tempstorage_keyvalue_one?: { __typename?: 'tempstorage_keyvalue', id: any } | null | undefined };

export type GetKeyValueStoreQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetKeyValueStoreQuery = { __typename?: 'query_root', tempstorage_keyvalue_by_pk?: { __typename?: 'tempstorage_keyvalue', content: any } | null | undefined };

export type FindPurchaserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type FindPurchaserByEmailQuery = { __typename?: 'query_root', espin_user: Array<{ __typename?: 'espin_user', id: string, email: string, role: Espin_Role_Enum, player_profile?: { __typename?: 'espin_player_profile', spin_username: string, slug: string, player_subscription_id?: any | null | undefined, trial_end_date?: any | null | undefined } | null | undefined, college_profile?: { __typename?: 'espin_college_profile', college: { __typename?: 'espin_college', id: any, name: string, college_subscription_id?: any | null | undefined } } | null | undefined }>, stripe_customer_data: Array<{ __typename?: 'stripe_customer_data', user_id: string, customer_id: string, email: string }> };

export type AddCustomerMutationVariables = Exact<{
  input: Stripe_Customer_Data_Insert_Input;
  onConflict: Stripe_Customer_Data_On_Conflict;
}>;


export type AddCustomerMutation = { __typename?: 'mutation_root', insert_stripe_customer_data_one?: { __typename?: 'stripe_customer_data', customer_id: string, email: string } | null | undefined };

export type UpsertCollegeSubscriptionMutationVariables = Exact<{
  invoice: Stripe_Invoice_Data_Insert_Input;
  sub: Espin_College_Insert_Input;
}>;


export type UpsertCollegeSubscriptionMutation = { __typename?: 'mutation_root', insert_stripe_invoice_data_one?: { __typename?: 'stripe_invoice_data', id: string } | null | undefined, insert_espin_college_one?: { __typename?: 'espin_college', id: any, subscribed: boolean, subscription?: { __typename?: 'espin_college_subscription', expires: any, id: any } | null | undefined } | null | undefined };

export type UpsertPlayerSubscriptionMutationVariables = Exact<{
  invoice: Stripe_Invoice_Data_Insert_Input;
  sub: Espin_Player_Profile_Insert_Input;
}>;


export type UpsertPlayerSubscriptionMutation = { __typename?: 'mutation_root', insert_stripe_invoice_data_one?: { __typename?: 'stripe_invoice_data', id: string } | null | undefined, insert_espin_player_profile_one?: { __typename?: 'espin_player_profile', id: any, subscription?: { __typename?: 'espin_player_subscription', expires: any, id: any } | null | undefined } | null | undefined };

export type CreateReferralPlayerSubscriptionMutationVariables = Exact<{
  sub: Espin_Player_Profile_Insert_Input;
}>;


export type CreateReferralPlayerSubscriptionMutation = { __typename?: 'mutation_root', insert_espin_player_profile_one?: { __typename?: 'espin_player_profile', id: any, subscription?: { __typename?: 'espin_player_subscription', expires: any, id: any } | null | undefined } | null | undefined };

export type CreateReferralCollegeSubscriptionMutationVariables = Exact<{
  sub: Espin_College_Insert_Input;
}>;


export type CreateReferralCollegeSubscriptionMutation = { __typename?: 'mutation_root', insert_espin_college_one?: { __typename?: 'espin_college', id: any, subscription?: { __typename?: 'espin_college_subscription', expires: any, id: any } | null | undefined } | null | undefined };

export type ExpireLapsedSubscriptionsMutationVariables = Exact<{
  ts: Scalars['bigint'];
}>;


export type ExpireLapsedSubscriptionsMutation = { __typename?: 'mutation_root', update_espin_college_subscription?: { __typename?: 'espin_college_subscription_mutation_response', affected_rows: number } | null | undefined, update_espin_player_subscription?: { __typename?: 'espin_player_subscription_mutation_response', affected_rows: number } | null | undefined };

export type UpdateGeoLocationMutationVariables = Exact<{
  id: Scalars['uuid'];
  input: Espin_Address_Set_Input;
}>;


export type UpdateGeoLocationMutation = { __typename?: 'mutation_root', update_espin_address_by_pk?: { __typename?: 'espin_address', id: any } | null | undefined };

export type FindNullAddressLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindNullAddressLocationsQuery = { __typename?: 'query_root', espin_address: Array<{ __typename?: 'espin_address', id: any, state: string, city: string, country?: string | null | undefined, street_one?: string | null | undefined }> };

export type SpinJobDataFragment = { __typename?: 'queue_job', id: any, name: Queue_Job_Type_Enum, status: Queue_Job_Status_Type_Enum, created_at: any, updated_at: any, payload: any, result?: any | null | undefined };

export type FindSpinJobsForProcessingQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
}>;


export type FindSpinJobsForProcessingQuery = { __typename?: 'query_root', queue_job: Array<{ __typename?: 'queue_job', id: any, name: Queue_Job_Type_Enum, status: Queue_Job_Status_Type_Enum, created_at: any, updated_at: any, payload: any, result?: any | null | undefined }> };

export type SetJobsAsProcessingMutationVariables = Exact<{
  jobIdArray?: Maybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type SetJobsAsProcessingMutation = { __typename?: 'mutation_root', update_queue_job?: { __typename?: 'queue_job_mutation_response', affected_rows: number } | null | undefined };

export type UpdateJobResultMutationVariables = Exact<{
  jobId: Scalars['uuid'];
  update: Queue_Job_Set_Input;
}>;


export type UpdateJobResultMutation = { __typename?: 'mutation_root', update_queue_job_by_pk?: { __typename?: 'queue_job', updated_at: any } | null | undefined };

export type FindCollegesWithFollowsSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  followPreference: Espin_Follower_Email_Notification_Type_Enum;
}>;


export type FindCollegesWithFollowsSinceQuery = { __typename?: 'query_root', espin_follow: Array<{ __typename?: 'espin_follow', college_id: any }>, high_school_follows: Array<{ __typename?: 'espin_follow', college_id: any }> };

export type FindHighSchoolsWithFollowsSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  followPreference: Espin_Follower_Email_Notification_Type_Enum;
}>;


export type FindHighSchoolsWithFollowsSinceQuery = { __typename?: 'query_root', espin_follow: Array<{ __typename?: 'espin_follow', high_school_id?: any | null | undefined }> };

export type GrabUserRoleByEmailQueryVariables = Exact<{
  email?: Maybe<Scalars['String']>;
}>;


export type GrabUserRoleByEmailQuery = { __typename?: 'query_root', espin_user: Array<{ __typename?: 'espin_user', role: Espin_Role_Enum }> };

export type IsNewSubscriberQueryVariables = Exact<{
  email?: Maybe<Scalars['String']>;
}>;


export type IsNewSubscriberQuery = { __typename?: 'query_root', stripe_invoice_data_aggregate: { __typename?: 'stripe_invoice_data_aggregate', aggregate?: { __typename?: 'stripe_invoice_data_aggregate_fields', count: number } | null | undefined } };

export type FindPlayersWithFollowsSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  followPreference: Espin_Follower_Email_Notification_Type_Enum;
}>;


export type FindPlayersWithFollowsSinceQuery = { __typename?: 'query_root', espin_follow: Array<{ __typename?: 'espin_follow', player_user_id?: string | null | undefined }> };

export type FindPlayersWithNewMessagesSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  messagePreference: Espin_Message_Email_Notification_Type_Enum;
}>;


export type FindPlayersWithNewMessagesSinceQuery = { __typename?: 'query_root', espin_message: Array<{ __typename?: 'espin_message', player_user_id?: string | null | undefined }> };

export type FindCollegesWithNewMessagesSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  messagePreference: Espin_Message_Email_Notification_Type_Enum;
}>;


export type FindCollegesWithNewMessagesSinceQuery = { __typename?: 'query_root', espin_message: Array<{ __typename?: 'espin_message', college_id?: any | null | undefined }>, high_school_messages: Array<{ __typename?: 'espin_message', college_id?: any | null | undefined }> };

export type FindHighSchoolsWithNewMessagesSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  messagePreference: Espin_Message_Email_Notification_Type_Enum;
}>;


export type FindHighSchoolsWithNewMessagesSinceQuery = { __typename?: 'query_root', espin_message: Array<{ __typename?: 'espin_message', high_school_id?: any | null | undefined }> };

export type FindPlayersWithProfileViewsSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  profileViewPreference: Espin_Profile_View_Email_Notification_Type_Enum;
}>;


export type FindPlayersWithProfileViewsSinceQuery = { __typename?: 'query_root', espin_profile_view: Array<{ __typename?: 'espin_profile_view', player_user_id?: string | null | undefined }> };

export type FindCollegesWithProfileViewsSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  profileViewPreference: Espin_Profile_View_Email_Notification_Type_Enum;
}>;


export type FindCollegesWithProfileViewsSinceQuery = { __typename?: 'query_root', espin_profile_view: Array<{ __typename?: 'espin_profile_view', college_id: any }> };

export type FindHighSchoolsWithProfileViewsSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  profileViewPreference: Espin_Profile_View_Email_Notification_Type_Enum;
}>;


export type FindHighSchoolsWithProfileViewsSinceQuery = { __typename?: 'query_root', espin_profile_view: Array<{ __typename?: 'espin_profile_view', high_school_id?: any | null | undefined }> };

export type GetNumberOfPlayerProfileViewsSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  playerUserId: Scalars['String'];
}>;


export type GetNumberOfPlayerProfileViewsSinceQuery = { __typename?: 'query_root', espin_profile_view_aggregate: { __typename?: 'espin_profile_view_aggregate', aggregate?: { __typename?: 'espin_profile_view_aggregate_fields', count: number } | null | undefined }, espin_user_by_pk?: { __typename?: 'espin_user', email: string, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, parent_email?: string | null | undefined } | null | undefined } | null | undefined };

export type GetNumberOfCollegeProfileViewsSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  collegeId: Scalars['uuid'];
}>;


export type GetNumberOfCollegeProfileViewsSinceQuery = { __typename?: 'query_root', espin_profile_view_aggregate: { __typename?: 'espin_profile_view_aggregate', aggregate?: { __typename?: 'espin_profile_view_aggregate_fields', count: number } | null | undefined }, espin_college_by_pk?: { __typename?: 'espin_college', name: string, program_name?: string | null | undefined, college_profiles: Array<{ __typename?: 'espin_college_profile', user: { __typename?: 'espin_user', email: string } }> } | null | undefined };

export type GetNumberOfHighSchoolProfileViewsSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  highSchoolId: Scalars['uuid'];
}>;


export type GetNumberOfHighSchoolProfileViewsSinceQuery = { __typename?: 'query_root', espin_profile_view_aggregate: { __typename?: 'espin_profile_view_aggregate', aggregate?: { __typename?: 'espin_profile_view_aggregate_fields', count: number } | null | undefined }, espin_high_school_by_pk?: { __typename?: 'espin_high_school', name: string, high_school_profiles: Array<{ __typename?: 'espin_high_school_profile', user: { __typename?: 'espin_user', email: string } }> } | null | undefined };

export type GetDetailsForNewMessageToCollegeEmailQueryVariables = Exact<{
  playerUserId: Scalars['String'];
  collegeId: Scalars['uuid'];
}>;


export type GetDetailsForNewMessageToCollegeEmailQuery = { __typename?: 'query_root', espin_college_by_pk?: { __typename?: 'espin_college', name: string, college_profiles: Array<{ __typename?: 'espin_college_profile', user: { __typename?: 'espin_user', email_message_preference?: Espin_Message_Email_Notification_Type_Enum | null | undefined, email: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined } }> } | null | undefined, espin_user_by_pk?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, espin_message_aggregate: { __typename?: 'espin_message_aggregate', aggregate?: { __typename?: 'espin_message_aggregate_fields', count: number } | null | undefined } };

export type GetDetailsForNewMessageToCollegeEmailFromHsQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
  collegeId: Scalars['uuid'];
}>;


export type GetDetailsForNewMessageToCollegeEmailFromHsQuery = { __typename?: 'query_root', espin_college_by_pk?: { __typename?: 'espin_college', name: string, college_profiles: Array<{ __typename?: 'espin_college_profile', user: { __typename?: 'espin_user', email_message_preference?: Espin_Message_Email_Notification_Type_Enum | null | undefined, email: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined } }> } | null | undefined, espin_high_school_by_pk?: { __typename?: 'espin_high_school', name: string } | null | undefined, espin_message_aggregate: { __typename?: 'espin_message_aggregate', aggregate?: { __typename?: 'espin_message_aggregate_fields', count: number } | null | undefined } };

export type GetDetailsForNewMessageToHighSchoolEmailQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
  collegeUserId: Scalars['String'];
  collegeId: Scalars['uuid'];
}>;


export type GetDetailsForNewMessageToHighSchoolEmailQuery = { __typename?: 'query_root', espin_college_by_pk?: { __typename?: 'espin_college', name: string, program_name?: string | null | undefined, college_owner?: { __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', college_profile?: { __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, espin_high_school_by_pk?: { __typename?: 'espin_high_school', name: string, high_school_profiles: Array<{ __typename?: 'espin_high_school_profile', user: { __typename?: 'espin_user', email: string, email_message_preference?: Espin_Message_Email_Notification_Type_Enum | null | undefined } }> } | null | undefined, espin_message_aggregate: { __typename?: 'espin_message_aggregate', aggregate?: { __typename?: 'espin_message_aggregate_fields', count: number } | null | undefined } };

export type GetDetailsForNewMessageToPlayerEmailQueryVariables = Exact<{
  playerUserId: Scalars['String'];
  collegeUserId: Scalars['String'];
  collegeId: Scalars['uuid'];
}>;


export type GetDetailsForNewMessageToPlayerEmailQuery = { __typename?: 'query_root', espin_college_by_pk?: { __typename?: 'espin_college', name: string, program_name?: string | null | undefined, college_owner?: { __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', college_profile?: { __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', email: string, email_message_preference?: Espin_Message_Email_Notification_Type_Enum | null | undefined, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, parent_email?: string | null | undefined } | null | undefined } | null | undefined, espin_message_aggregate: { __typename?: 'espin_message_aggregate', aggregate?: { __typename?: 'espin_message_aggregate_fields', count: number } | null | undefined } };

export type GetNewConversationsForPlayerSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  playerUserId: Scalars['String'];
}>;


export type GetNewConversationsForPlayerSinceQuery = { __typename?: 'query_root', last_ten_messages: Array<{ __typename?: 'espin_message', college_id?: any | null | undefined, contents: string, college?: { __typename?: 'espin_college', name: string } | null | undefined }>, message_count: { __typename?: 'espin_message_aggregate', aggregate?: { __typename?: 'espin_message_aggregate_fields', count: number } | null | undefined }, player_info?: { __typename?: 'espin_user', email: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, parent_email?: string | null | undefined } | null | undefined } | null | undefined };

export type GetNewConversationsForHighSchoolSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  highSchoolId: Scalars['uuid'];
}>;


export type GetNewConversationsForHighSchoolSinceQuery = { __typename?: 'query_root', last_ten_messages: Array<{ __typename?: 'espin_message', college_id?: any | null | undefined, contents: string, college?: { __typename?: 'espin_college', name: string } | null | undefined }>, message_count: { __typename?: 'espin_message_aggregate', aggregate?: { __typename?: 'espin_message_aggregate_fields', count: number } | null | undefined }, espin_high_school_by_pk?: { __typename?: 'espin_high_school', name: string, high_school_profiles: Array<{ __typename?: 'espin_high_school_profile', user: { __typename?: 'espin_user', email: string, email_message_preference?: Espin_Message_Email_Notification_Type_Enum | null | undefined } }> } | null | undefined };

export type GetNewConversationsForCollegeSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  collegeId: Scalars['uuid'];
}>;


export type GetNewConversationsForCollegeSinceQuery = { __typename?: 'query_root', last_ten_messages: Array<{ __typename?: 'espin_message', contents: string, player_user?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined }>, hs_last_ten_messages: Array<{ __typename?: 'espin_message', contents: string, high_school?: { __typename?: 'espin_high_school', name: string } | null | undefined }>, message_count: { __typename?: 'espin_message_aggregate', aggregate?: { __typename?: 'espin_message_aggregate_fields', count: number } | null | undefined }, hs_message_count: { __typename?: 'espin_message_aggregate', aggregate?: { __typename?: 'espin_message_aggregate_fields', count: number } | null | undefined }, college_info?: { __typename?: 'espin_college', name: string, program_name?: string | null | undefined, college_profiles: Array<{ __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, user: { __typename?: 'espin_user', email: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined } }> } | null | undefined };

export type GetDetailsForNewFollowOfPlayerQueryVariables = Exact<{
  playerUserId: Scalars['String'];
  collegeUserId: Scalars['String'];
  collegeId: Scalars['uuid'];
}>;


export type GetDetailsForNewFollowOfPlayerQuery = { __typename?: 'query_root', espin_college_by_pk?: { __typename?: 'espin_college', name: string, program_name?: string | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', college_profile?: { __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, player_user?: { __typename?: 'espin_user', email: string, email_follow_preference: Espin_Follower_Email_Notification_Type_Enum, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, parent_email?: string | null | undefined } | null | undefined, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined } | null | undefined };

export type GetDetailsForNewFollowOfHighSchoolQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
  collegeUserId: Scalars['String'];
  collegeId: Scalars['uuid'];
}>;


export type GetDetailsForNewFollowOfHighSchoolQuery = { __typename?: 'query_root', espin_college_by_pk?: { __typename?: 'espin_college', name: string, program_name?: string | null | undefined } | null | undefined, espin_high_school_by_pk?: { __typename?: 'espin_high_school', name: string, high_school_profiles: Array<{ __typename?: 'espin_high_school_profile', user: { __typename?: 'espin_user', email_follow_preference: Espin_Follower_Email_Notification_Type_Enum, email: string } }> } | null | undefined, college_user?: { __typename?: 'espin_user', college_profile?: { __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined };

export type GetDetailsForNewFollowOfCollegeQueryVariables = Exact<{
  playerUserId: Scalars['String'];
  collegeId: Scalars['uuid'];
}>;


export type GetDetailsForNewFollowOfCollegeQuery = { __typename?: 'query_root', espin_college_by_pk?: { __typename?: 'espin_college', name: string, program_name?: string | null | undefined, college_profiles: Array<{ __typename?: 'espin_college_profile', user: { __typename?: 'espin_user', email_follow_preference: Espin_Follower_Email_Notification_Type_Enum, email: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined } }> } | null | undefined, player_user?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined };

export type GetDetailsForNewFollowOfCollegeByHighSchoolQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
  collegeId: Scalars['uuid'];
}>;


export type GetDetailsForNewFollowOfCollegeByHighSchoolQuery = { __typename?: 'query_root', espin_college_by_pk?: { __typename?: 'espin_college', name: string, program_name?: string | null | undefined, college_profiles: Array<{ __typename?: 'espin_college_profile', user: { __typename?: 'espin_user', email_follow_preference: Espin_Follower_Email_Notification_Type_Enum, email: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined } }> } | null | undefined, high_school?: { __typename?: 'espin_high_school', name: string } | null | undefined };

export type GetNewFollowsForPlayerSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  playerUserId: Scalars['String'];
}>;


export type GetNewFollowsForPlayerSinceQuery = { __typename?: 'query_root', last_ten_follows: Array<{ __typename?: 'espin_follow', college_id: any, college: { __typename?: 'espin_college', name: string } }>, follow_count: { __typename?: 'espin_follow_aggregate', aggregate?: { __typename?: 'espin_follow_aggregate_fields', count: number } | null | undefined }, player_info?: { __typename?: 'espin_user', email: string, player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, parent_email?: string | null | undefined } | null | undefined, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined } | null | undefined };

export type GetNewFollowsForHighSchoolSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  highSchoolId: Scalars['uuid'];
}>;


export type GetNewFollowsForHighSchoolSinceQuery = { __typename?: 'query_root', last_ten_follows: Array<{ __typename?: 'espin_follow', college_id: any, college: { __typename?: 'espin_college', name: string } }>, follow_count: { __typename?: 'espin_follow_aggregate', aggregate?: { __typename?: 'espin_follow_aggregate_fields', count: number } | null | undefined }, high_school_info?: { __typename?: 'espin_high_school', name: string, high_school_profiles: Array<{ __typename?: 'espin_high_school_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, user: { __typename?: 'espin_user', email: string } }> } | null | undefined };

export type AddHighSchoolSlugMutationVariables = Exact<{
  hsId: Scalars['uuid'];
  newSlug: Scalars['String'];
}>;


export type AddHighSchoolSlugMutation = { __typename?: 'mutation_root', update_espin_high_school_by_pk?: { __typename?: 'espin_high_school', id: any } | null | undefined };

export type GetNewFollowsForCollegeSinceQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  collegeId: Scalars['uuid'];
}>;


export type GetNewFollowsForCollegeSinceQuery = { __typename?: 'query_root', last_ten_follows: Array<{ __typename?: 'espin_follow', player_user?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined }>, follow_count: { __typename?: 'espin_follow_aggregate', aggregate?: { __typename?: 'espin_follow_aggregate_fields', count: number } | null | undefined }, hs_last_ten_follows: Array<{ __typename?: 'espin_follow', high_school?: { __typename?: 'espin_high_school', name: string } | null | undefined }>, hs_follow_count: { __typename?: 'espin_follow_aggregate', aggregate?: { __typename?: 'espin_follow_aggregate_fields', count: number } | null | undefined }, college_info?: { __typename?: 'espin_college', name: string, program_name?: string | null | undefined, college_profiles: Array<{ __typename?: 'espin_college_profile', first_name?: string | null | undefined, last_name?: string | null | undefined, user: { __typename?: 'espin_user', email: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined } }> } | null | undefined };

export type LeaderboardsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type LeaderboardsPageQuery = { __typename?: 'query_root', espin_leaderboard: Array<{ __typename?: 'espin_leaderboard', name: string, info_title?: string | null | undefined, info_contents?: string | null | undefined, dropdown_label: string, file?: { __typename?: 'content_file', id: any, original_name?: string | null | undefined, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }> };

export type IsConversationQueryVariables = Exact<{
  playerUserId: Scalars['String'];
  collegeId: Scalars['uuid'];
}>;


export type IsConversationQuery = { __typename?: 'query_root', espin_message_aggregate: { __typename?: 'espin_message_aggregate', aggregate?: { __typename?: 'espin_message_aggregate_fields', count: number } | null | undefined } };

export type GetCollegeAndHighSchoolDetailsQueryVariables = Exact<{
  highSchoolId: Scalars['uuid'];
  collegeId: Scalars['uuid'];
}>;


export type GetCollegeAndHighSchoolDetailsQuery = { __typename?: 'query_root', high_school?: { __typename?: 'espin_high_school', id: any, name: string, high_school_owner?: { __typename?: 'espin_high_school_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', id: any, name: string, program_name?: string | null | undefined, college_owner?: { __typename?: 'espin_college_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined };

export type GetCollegeAndPlayerDetailsQueryVariables = Exact<{
  playerUserId: Scalars['String'];
  collegeId: Scalars['uuid'];
}>;


export type GetCollegeAndPlayerDetailsQuery = { __typename?: 'query_root', player: Array<{ __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined }>, college?: { __typename?: 'espin_college', id: any, name: string, program_name?: string | null | undefined, college_owner?: { __typename?: 'espin_college_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined };

export type AdminCreateNotificationForFollowMutationVariables = Exact<{
  input: Espin_Follow_Insert_Input;
}>;


export type AdminCreateNotificationForFollowMutation = { __typename?: 'mutation_root', insert_espin_follow_one?: { __typename?: 'espin_follow', id: any, notification_id?: any | null | undefined } | null | undefined };

export type NotifyHighSchoolCoachesMutationVariables = Exact<{
  input: Array<Espin_Notification_Insert_Input> | Espin_Notification_Insert_Input;
}>;


export type NotifyHighSchoolCoachesMutation = { __typename?: 'mutation_root', insert_espin_notification?: { __typename?: 'espin_notification_mutation_response', returning: Array<{ __typename?: 'espin_notification', id: any }> } | null | undefined };

export type AdminCreateNotificationForMessageMutationVariables = Exact<{
  input: Espin_Message_Insert_Input;
}>;


export type AdminCreateNotificationForMessageMutation = { __typename?: 'mutation_root', insert_espin_message_one?: { __typename?: 'espin_message', id: any, notification_id?: any | null | undefined } | null | undefined };

export type AdminCreateNotificationForProfileViewMutationVariables = Exact<{
  input: Espin_Profile_View_Insert_Input;
}>;


export type AdminCreateNotificationForProfileViewMutation = { __typename?: 'mutation_root', insert_espin_profile_view_one?: { __typename?: 'espin_profile_view', id: any, notification_id?: any | null | undefined } | null | undefined };

export type HighSchoolsToNotifyQueryVariables = Exact<{
  highSchoolPlayerId?: Maybe<Scalars['String']>;
}>;


export type HighSchoolsToNotifyQuery = { __typename?: 'query_root', espin_team: Array<{ __typename?: 'espin_team', high_school?: { __typename?: 'espin_high_school', id: any } | null | undefined }> };

export type CheckIfConversationStartedQueryVariables = Exact<{
  collegeId?: Maybe<Scalars['uuid']>;
  playerUserId?: Maybe<Scalars['String']>;
}>;


export type CheckIfConversationStartedQuery = { __typename?: 'query_root', espin_message: Array<{ __typename?: 'espin_message', id: any }> };

export type SetPlayerFreeTrialEndDateMutationVariables = Exact<{
  trialEndDate: Scalars['timestamptz'];
  id: Scalars['String'];
}>;


export type SetPlayerFreeTrialEndDateMutation = { __typename?: 'mutation_root', update_espin_player_profile?: { __typename?: 'espin_player_profile_mutation_response', affected_rows: number } | null | undefined };

export type SetPlayerReferralOptionMutationVariables = Exact<{
  referralOptionId: Scalars['uuid'];
  id: Scalars['String'];
}>;


export type SetPlayerReferralOptionMutation = { __typename?: 'mutation_root', update_espin_player_profile?: { __typename?: 'espin_player_profile_mutation_response', affected_rows: number } | null | undefined };

export type GetPlayerReferralOptionDataQueryVariables = Exact<{
  referralOptionId: Scalars['uuid'];
}>;


export type GetPlayerReferralOptionDataQuery = { __typename?: 'query_root', espin_referral_option_by_pk?: { __typename?: 'espin_referral_option', id: any, name: string } | null | undefined };

export type GetUserIdForStripeAnalyticsQueryVariables = Exact<{
  customer: Scalars['String'];
}>;


export type GetUserIdForStripeAnalyticsQuery = { __typename?: 'query_root', stripe_customer_data: Array<{ __typename?: 'stripe_customer_data', user_id: string }> };

export type CreateSpinJobsMutationVariables = Exact<{
  objects: Array<Queue_Job_Insert_Input> | Queue_Job_Insert_Input;
}>;


export type CreateSpinJobsMutation = { __typename?: 'mutation_root', insert_queue_job?: { __typename?: 'queue_job_mutation_response', affected_rows: number } | null | undefined };

export type AdminGetEventRegistrationsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminGetEventRegistrationsQuery = { __typename?: 'query_root', espin_event_registration: Array<{ __typename?: 'espin_event_registration', id: any }> };

export type AddSubscriptionInvoiceMutationVariables = Exact<{
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
}>;


export type AddSubscriptionInvoiceMutation = { __typename?: 'mutation_root', insert_stripe_invoice_data_one?: { __typename?: 'stripe_invoice_data', id: string } | null | undefined };

export type TestGetPlayerProfileFromParentQueryVariables = Exact<{
  parentId: Scalars['String'];
}>;


export type TestGetPlayerProfileFromParentQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', parent_profile?: { __typename?: 'espin_parent_profile', child_profiles: Array<{ __typename?: 'espin_player_profile', id: any, user_id: string }> } | null | undefined } | null | undefined };

export type TestGetParentProfileFromPlayerQueryVariables = Exact<{
  childId: Scalars['String'];
}>;


export type TestGetParentProfileFromPlayerQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', player_profile?: { __typename?: 'espin_player_profile', parent_email?: string | null | undefined, parent_profile?: { __typename?: 'espin_parent_profile', id: any } | null | undefined } | null | undefined } | null | undefined };

export type TestInviteCollegeUserMutationVariables = Exact<{
  input: Espin_College_Invite_Insert_Input;
}>;


export type TestInviteCollegeUserMutation = { __typename?: 'mutation_root', insert_espin_college_invite_one?: { __typename?: 'espin_college_invite', id: any } | null | undefined };

export type TestInviteHighSchoolUserMutationVariables = Exact<{
  input: Espin_High_School_Invite_Insert_Input;
}>;


export type TestInviteHighSchoolUserMutation = { __typename?: 'mutation_root', insert_espin_high_school_invite_one?: { __typename?: 'espin_high_school_invite', id: any } | null | undefined };

export type TestAddParentEmailToPlayerMutationVariables = Exact<{
  profileId: Scalars['uuid'];
  email: Scalars['String'];
}>;


export type TestAddParentEmailToPlayerMutation = { __typename?: 'mutation_root', update_espin_player_profile_by_pk?: { __typename?: 'espin_player_profile', updated_at: any } | null | undefined };

export type AdminUpdateEventRegEndDateMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  registerEndDate: Scalars['timestamptz'];
}>;


export type AdminUpdateEventRegEndDateMutation = { __typename?: 'mutation_root', update_espin_event_by_pk?: { __typename?: 'espin_event', id: any } | null | undefined };

export type GetTicketListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTicketListQuery = { __typename?: 'query_root', espin_event_ticket: Array<{ __typename?: 'espin_event_ticket', id: any, price_temp: any, ticket_type: Espin_Event_Ticket_Type_Enum, event_id: any, game?: { __typename?: 'espin_game', name: string, team_max_size: number } | null | undefined }> };

export type TestUpdateHighSchoolProfileMutationVariables = Exact<{
  _set: Espin_High_School_Profile_Set_Input;
  where: Espin_High_School_Profile_Bool_Exp;
}>;


export type TestUpdateHighSchoolProfileMutation = { __typename?: 'mutation_root', update_espin_high_school_profile?: { __typename?: 'espin_high_school_profile_mutation_response', affected_rows: number } | null | undefined };

export type TestInsertHighSchoolProfileMutationVariables = Exact<{
  input: Espin_High_School_Profile_Insert_Input;
}>;


export type TestInsertHighSchoolProfileMutation = { __typename?: 'mutation_root', insert_espin_high_school_profile_one?: { __typename?: 'espin_high_school_profile', id: any, high_school: { __typename?: 'espin_high_school', id: any, teams: Array<{ __typename?: 'espin_team', id: any }> } } | null | undefined };

export type TestCreateHighSchoolMutationVariables = Exact<{
  input: Espin_High_School_Insert_Input;
}>;


export type TestCreateHighSchoolMutation = { __typename?: 'mutation_root', insert_espin_high_school_one?: { __typename?: 'espin_high_school', id: any } | null | undefined };

export type TestUpdateHighSchoolMutationVariables = Exact<{
  _set: Espin_High_School_Set_Input;
  where: Espin_High_School_Bool_Exp;
}>;


export type TestUpdateHighSchoolMutation = { __typename?: 'mutation_root', update_espin_high_school?: { __typename?: 'espin_high_school_mutation_response', affected_rows: number } | null | undefined };

export type TestInsertHighSchoolMutationVariables = Exact<{
  input: Espin_High_School_Insert_Input;
}>;


export type TestInsertHighSchoolMutation = { __typename?: 'mutation_root', insert_espin_high_school_one?: { __typename?: 'espin_high_school', id: any } | null | undefined };

export type GetProfileViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileViewDataQuery = { __typename?: 'query_root', espin_profile_view: Array<{ __typename?: 'espin_profile_view', college_id: any, profile_view_type: Espin_Profile_View_Type_Enum, notification?: { __typename?: 'espin_notification', id: any } | null | undefined }> };

export type GetHsProfileViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHsProfileViewDataQuery = { __typename?: 'query_root', espin_profile_view: Array<{ __typename?: 'espin_profile_view', college_id: any, high_school_id?: any | null | undefined, profile_view_type: Espin_Profile_View_Type_Enum, notification?: { __typename?: 'espin_notification', id: any } | null | undefined }> };

export type TestUpdateInviteStatusMutationVariables = Exact<{
  id: Scalars['uuid'];
  input?: Maybe<Espin_Team_Invite_Set_Input>;
}>;


export type TestUpdateInviteStatusMutation = { __typename?: 'mutation_root', update_espin_team_invite_by_pk?: { __typename?: 'espin_team_invite', id: any } | null | undefined };

export type TestGetPlayersByCreatedAtQueryVariables = Exact<{ [key: string]: never; }>;


export type TestGetPlayersByCreatedAtQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', id: any }> };

export type TestGetTeamInvitesQueryVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type TestGetTeamInvitesQuery = { __typename?: 'query_root', espin_team_invite: Array<{ __typename?: 'espin_team_invite', id: any, status: Espin_Invite_Status_Type_Enum, player_profile?: { __typename?: 'espin_player_profile', id: any } | null | undefined }> };

export type TestGetHsTeamQueryVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type TestGetHsTeamQuery = { __typename?: 'query_root', espin_team: Array<{ __typename?: 'espin_team', id: any }> };

export type TestGetPlayerTeamQueryVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type TestGetPlayerTeamQuery = { __typename?: 'query_root', espin_team: Array<{ __typename?: 'espin_team', id: any, display_name: string, primary_game: string, members: Array<{ __typename: 'espin_team_members', id: any, team_role: Espin_Team_Role_Enum, player_profile_id: any }> }> };

export type TestInsertPlayerTeamMutationVariables = Exact<{
  input: Espin_Team_Insert_Input;
}>;


export type TestInsertPlayerTeamMutation = { __typename?: 'mutation_root', insert_espin_team_one?: { __typename?: 'espin_team', id: any, display_name: string, primary_game: string, members: Array<{ __typename?: 'espin_team_members', id: any, team_role: Espin_Team_Role_Enum, player_profile_id: any, player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string, user: { __typename?: 'espin_user', id: string } } | null | undefined }>, team_invites: Array<{ __typename?: 'espin_team_invite', id: any, status: Espin_Invite_Status_Type_Enum, player_profile?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined }> } | null | undefined };

export type TestGetPlayerProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type TestGetPlayerProfileQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', id: any, spin_username: string }> };

export type TestGetPlayerProfileByPkQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type TestGetPlayerProfileByPkQuery = { __typename?: 'query_root', espin_player_profile_by_pk?: { __typename?: 'espin_player_profile', id: any, spin_username: string } | null | undefined };

export type TestPublicFindPlayerProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type TestPublicFindPlayerProfilesQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', id: any }> };

export type TestPlayerFindPlayerProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type TestPlayerFindPlayerProfilesQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', id: any }> };

export type TestAllEspinGamesQueryVariables = Exact<{ [key: string]: never; }>;


export type TestAllEspinGamesQuery = { __typename?: 'query_root', espin_game: Array<{ __typename?: 'espin_game', game_definition: Espin_Game_Definition_Enum, name: string }> };

export type TestGetByUserPkQueryVariables = Exact<{
  sub: Scalars['String'];
}>;


export type TestGetByUserPkQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', id: string, role: Espin_Role_Enum, college_profile?: { __typename?: 'espin_college_profile', id: any } | null | undefined, player_profile?: { __typename?: 'espin_player_profile', id: any } | null | undefined } | null | undefined };

export type TestLastLoginForUserByPkQueryVariables = Exact<{
  sub: Scalars['String'];
}>;


export type TestLastLoginForUserByPkQuery = { __typename?: 'query_root', espin_user_by_pk?: { __typename?: 'espin_user', id: string, last_login?: any | null | undefined, updated_at?: any | null | undefined } | null | undefined };

export type TestAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type TestAddressesQuery = { __typename?: 'query_root', espin_address: Array<{ __typename?: 'espin_address', id: any }> };

export type TestParentProfileQueryVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type TestParentProfileQuery = { __typename?: 'query_root', espin_parent_profile_by_pk?: { __typename?: 'espin_parent_profile', id: any } | null | undefined };

export type TestPlayerProfileQueryVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type TestPlayerProfileQuery = { __typename?: 'query_root', espin_player_profile_by_pk?: { __typename?: 'espin_player_profile', id: any } | null | undefined };

export type TestPlayerVodsQueryVariables = Exact<{ [key: string]: never; }>;


export type TestPlayerVodsQuery = { __typename?: 'query_root', espin_player_vod: Array<{ __typename?: 'espin_player_vod', id: any }> };

export type TestUserSearchQueryVariables = Exact<{ [key: string]: never; }>;


export type TestUserSearchQuery = { __typename?: 'query_root', espin_user: Array<{ __typename?: 'espin_user', id: string }> };

export type TestGetPlayerSubsQueryVariables = Exact<{ [key: string]: never; }>;


export type TestGetPlayerSubsQuery = { __typename?: 'query_root', espin_player_subscription: Array<{ __typename?: 'espin_player_subscription', id: any, player_profile: Array<{ __typename?: 'espin_player_profile', id: any, user_id: string }> }> };

export type TestAdminPlayerLookupQueryVariables = Exact<{ [key: string]: never; }>;


export type TestAdminPlayerLookupQuery = { __typename?: 'query_root', espin_player_profile: Array<{ __typename?: 'espin_player_profile', id: any, spin_username: string, created_at: any, hs_name?: string | null | undefined, graduating_class?: string | null | undefined, subscribed_override: boolean, sub_last_meeting?: any | null | undefined, sub_sales_notes?: string | null | undefined, sub_connected_colleges?: any | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, rank?: string | null | undefined, game: { __typename?: 'espin_game', name: string } }>, social?: { __typename?: 'espin_social', discord?: string | null | undefined } | null | undefined, user: { __typename?: 'espin_user', email: string, subscription_status?: { __typename?: 'espin_user_subscription_status', is_subscribed?: boolean | null | undefined } | null | undefined }, address?: { __typename?: 'espin_address', state: string } | null | undefined }> };

export type TestUpdatePlayerSubscriptionNotesMutationVariables = Exact<{
  id: Scalars['uuid'];
  input?: Maybe<Espin_Player_Profile_Set_Input>;
}>;


export type TestUpdatePlayerSubscriptionNotesMutation = { __typename?: 'mutation_root', update_espin_player_profile_by_pk?: { __typename?: 'espin_player_profile', id: any } | null | undefined };

export type TestToggleSubscribedOverrideMutationVariables = Exact<{
  userId: Scalars['String'];
  status: Scalars['Boolean'];
}>;


export type TestToggleSubscribedOverrideMutation = { __typename?: 'mutation_root', update_espin_player_profile?: { __typename?: 'espin_player_profile_mutation_response', affected_rows: number } | null | undefined };

export type TestToggleManualCollegeSubscriptionTierMutationVariables = Exact<{
  collegeId: Scalars['uuid'];
  subTier: Scalars['Int'];
}>;


export type TestToggleManualCollegeSubscriptionTierMutation = { __typename?: 'mutation_root', update_espin_college_by_pk?: { __typename?: 'espin_college', id: any } | null | undefined };

export type TestUpdateAddressMutationVariables = Exact<{
  _set?: Maybe<Espin_Address_Set_Input>;
  where: Espin_Address_Bool_Exp;
}>;


export type TestUpdateAddressMutation = { __typename?: 'mutation_root', update_espin_address?: { __typename?: 'espin_address_mutation_response', affected_rows: number } | null | undefined };

export type TestUpdateParentProfileMutationVariables = Exact<{
  _set?: Maybe<Espin_Parent_Profile_Set_Input>;
  where: Espin_Parent_Profile_Bool_Exp;
}>;


export type TestUpdateParentProfileMutation = { __typename?: 'mutation_root', update_espin_parent_profile?: { __typename?: 'espin_parent_profile_mutation_response', affected_rows: number } | null | undefined };

export type TestUpdatePlayerProfileMutationVariables = Exact<{
  _set?: Maybe<Espin_Player_Profile_Set_Input>;
  where: Espin_Player_Profile_Bool_Exp;
}>;


export type TestUpdatePlayerProfileMutation = { __typename?: 'mutation_root', update_espin_player_profile?: { __typename?: 'espin_player_profile_mutation_response', affected_rows: number } | null | undefined };

export type TestCreatePlayerVodMutationVariables = Exact<{
  input: Espin_Player_Vod_Insert_Input;
}>;


export type TestCreatePlayerVodMutation = { __typename?: 'mutation_root', insert_espin_player_vod_one?: { __typename?: 'espin_player_vod', id: any } | null | undefined };

export type TestUpdatePlayerVodMutationVariables = Exact<{
  _set?: Maybe<Espin_Player_Vod_Set_Input>;
  where: Espin_Player_Vod_Bool_Exp;
}>;


export type TestUpdatePlayerVodMutation = { __typename?: 'mutation_root', update_espin_player_vod?: { __typename?: 'espin_player_vod_mutation_response', affected_rows: number } | null | undefined };

export type TestCreateUserMutationVariables = Exact<{
  input: Espin_User_Insert_Input;
}>;


export type TestCreateUserMutation = { __typename?: 'mutation_root', insert_espin_user_one?: { __typename?: 'espin_user', id: string } | null | undefined };

export type TestUpdateUserMutationVariables = Exact<{
  _set?: Maybe<Espin_User_Set_Input>;
  where: Espin_User_Bool_Exp;
}>;


export type TestUpdateUserMutation = { __typename?: 'mutation_root', update_espin_user?: { __typename?: 'espin_user_mutation_response', affected_rows: number } | null | undefined };

export type TestCreatePlainUsersMutationVariables = Exact<{
  input: Array<Espin_User_Insert_Input> | Espin_User_Insert_Input;
}>;


export type TestCreatePlainUsersMutation = { __typename?: 'mutation_root', insert_espin_user?: { __typename?: 'espin_user_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'espin_user', id: string, role: Espin_Role_Enum }> } | null | undefined };

export type TestLinkParentToChildMutationVariables = Exact<{
  playerProfileId: Scalars['uuid'];
  parentProfileId: Scalars['uuid'];
}>;


export type TestLinkParentToChildMutation = { __typename?: 'mutation_root', update_espin_player_profile_by_pk?: { __typename?: 'espin_player_profile', id: any } | null | undefined };

export type TestUnstickyPlayerMutationVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type TestUnstickyPlayerMutation = { __typename?: 'mutation_root', delete_espin_stickied_player?: { __typename?: 'espin_stickied_player_mutation_response', affected_rows: number } | null | undefined };

export type TestCreatePlayerProfileMutationVariables = Exact<{
  input: Espin_Player_Profile_Insert_Input;
}>;


export type TestCreatePlayerProfileMutation = { __typename?: 'mutation_root', insert_espin_player_profile_one?: { __typename?: 'espin_player_profile', id: any, slug: string, spin_username: string, user: { __typename?: 'espin_user', id: string, email: string } } | null | undefined };

export type TestCreateSpinUserOneMutationVariables = Exact<{
  input: Espin_User_Insert_Input;
}>;


export type TestCreateSpinUserOneMutation = { __typename?: 'mutation_root', insert_espin_user_one?: { __typename?: 'espin_user', id: string, email: string } | null | undefined };

export type TestSubbedPlayerViewingQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type TestSubbedPlayerViewingQuery = { __typename?: 'query_root', espin_message: Array<{ __typename?: 'espin_message', player_user_id?: string | null | undefined, contents: string, created_at: any, viewed_at?: any | null | undefined, message_type: Espin_Message_Type_Enum, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined }>, espin_notification: Array<{ __typename?: 'espin_notification', id: any, notification_type: Espin_Notification_Type_Enum, viewed_at?: any | null | undefined, follows: Array<{ __typename?: 'espin_follow', follow_type: Espin_Follow_Type_Enum, parent_user_id?: string | null | undefined, college_user_name?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, graduating_class?: string | null | undefined, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, profile_views: Array<{ __typename?: 'espin_profile_view', profile_view_type: Espin_Profile_View_Type_Enum, college_user_full_name?: string | null | undefined, id: any, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, graduating_class?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined, player_games: Array<{ __typename?: 'espin_player_game', primary: boolean, game: { __typename?: 'espin_game', name: string, game_definition: Espin_Game_Definition_Enum } }> } | null | undefined } | null | undefined, college: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined }, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }>, messages: Array<{ __typename?: 'espin_message', message_type: Espin_Message_Type_Enum, viewed_at?: any | null | undefined, contents: string, parent_user_id?: string | null | undefined, player_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined, player_profile?: { __typename?: 'espin_player_profile', user_id: string, first_name?: string | null | undefined, last_name?: string | null | undefined, slug: string, profile_image?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, college?: { __typename?: 'espin_college', name: string, slug?: string | null | undefined, logo?: { __typename?: 'content_file', id: any, cdn_url?: string | null | undefined, ext?: string | null | undefined } | null | undefined } | null | undefined, college_user?: { __typename?: 'espin_user', deleted_at?: any | null | undefined } | null | undefined }> }> };

export type TestCreateParentProfileMutationVariables = Exact<{
  input: Espin_Parent_Profile_Insert_Input;
}>;


export type TestCreateParentProfileMutation = { __typename?: 'mutation_root', insert_espin_parent_profile_one?: { __typename?: 'espin_parent_profile', id: any, child_profiles: Array<{ __typename?: 'espin_player_profile', id: any, spin_username: string, user: { __typename?: 'espin_user', id: string } }>, user?: { __typename?: 'espin_user', id: string } | null | undefined } | null | undefined };

export type TestCreateEventTicketMutationVariables = Exact<{
  input: Espin_Event_Ticket_Insert_Input;
}>;


export type TestCreateEventTicketMutation = { __typename?: 'mutation_root', insert_espin_event_ticket_one?: { __typename?: 'espin_event_ticket', id: any } | null | undefined };

export type TestCreateHighSchoolAndUserAndStuffMutationVariables = Exact<{
  input: Espin_High_School_Profile_Insert_Input;
}>;


export type TestCreateHighSchoolAndUserAndStuffMutation = { __typename?: 'mutation_root', insert_espin_high_school_profile_one?: { __typename?: 'espin_high_school_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, user: { __typename?: 'espin_user', id: string, email: string }, high_school: { __typename?: 'espin_high_school', id: any, name: string } } | null | undefined };

export type TestCreateCollegeAndUserAndStuffMutationVariables = Exact<{
  input: Espin_College_Profile_Insert_Input;
}>;


export type TestCreateCollegeAndUserAndStuffMutation = { __typename?: 'mutation_root', insert_espin_college_profile_one?: { __typename?: 'espin_college_profile', id: any, first_name?: string | null | undefined, last_name?: string | null | undefined, user: { __typename?: 'espin_user', id: string, email: string }, college: { __typename?: 'espin_college', id: any, name: string, program_name?: string | null | undefined, subscribed: boolean, subscription?: { __typename?: 'espin_college_subscription', status: Espin_Subscription_Status_Enum } | null | undefined } } | null | undefined };

export type TestUpdateCollegeSubscriptionEndDateMutationVariables = Exact<{
  collegeId: Scalars['uuid'];
  expires: Scalars['bigint'];
}>;


export type TestUpdateCollegeSubscriptionEndDateMutation = { __typename?: 'mutation_root', update_espin_college_subscription?: { __typename?: 'espin_college_subscription_mutation_response', returning: Array<{ __typename?: 'espin_college_subscription', status: Espin_Subscription_Status_Enum }> } | null | undefined };

export type TestUpdatePlayerSubscriptionEndDateMutationVariables = Exact<{
  playerId: Scalars['uuid'];
  expires: Scalars['bigint'];
}>;


export type TestUpdatePlayerSubscriptionEndDateMutation = { __typename?: 'mutation_root', update_espin_player_subscription?: { __typename?: 'espin_player_subscription_mutation_response', returning: Array<{ __typename?: 'espin_player_subscription', status: Espin_Subscription_Status_Enum }> } | null | undefined };

export type TestUpdateCollegeSubscriptionTierMutationVariables = Exact<{
  collegeId: Scalars['uuid'];
  tier: Espin_Subscription_Tier_Type_Enum;
}>;


export type TestUpdateCollegeSubscriptionTierMutation = { __typename?: 'mutation_root', update_espin_college_subscription?: { __typename?: 'espin_college_subscription_mutation_response', returning: Array<{ __typename?: 'espin_college_subscription', status: Espin_Subscription_Status_Enum }> } | null | undefined };

export type TestCheckPlayerSubscriptionStatusQueryVariables = Exact<{
  playerId: Scalars['uuid'];
}>;


export type TestCheckPlayerSubscriptionStatusQuery = { __typename?: 'query_root', espin_player_subscription: Array<{ __typename?: 'espin_player_subscription', status: Espin_Subscription_Status_Enum }> };

export type TestCheckCollegeSubscriptionStatusQueryVariables = Exact<{
  collegeId: Scalars['uuid'];
}>;


export type TestCheckCollegeSubscriptionStatusQuery = { __typename?: 'query_root', espin_college_subscription: Array<{ __typename?: 'espin_college_subscription', status: Espin_Subscription_Status_Enum }> };

export type TestCreateReferralCodeMutationVariables = Exact<{
  input: Espin_Referral_Code_Insert_Input;
}>;


export type TestCreateReferralCodeMutation = { __typename?: 'mutation_root', insert_espin_referral_code_one?: { __typename?: 'espin_referral_code', code_key: string } | null | undefined };

export type TestCheckSubscriberTierByUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type TestCheckSubscriberTierByUserQuery = { __typename?: 'query_root', espin_user_subscription_status: Array<{ __typename?: 'espin_user_subscription_status', tier?: string | null | undefined, id?: string | null | undefined, is_subscribed?: boolean | null | undefined, tierlookup?: number | null | undefined }> };

export type TestsCreateStudyFieldMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type TestsCreateStudyFieldMutation = { __typename?: 'mutation_root', insert_espin_study_field?: { __typename?: 'espin_study_field_mutation_response', returning: Array<{ __typename?: 'espin_study_field', id: any, name: string }> } | null | undefined };

export type TestsCreateStudySubjectMutationVariables = Exact<{
  input: Scalars['String'];
  generalStudyID: Scalars['uuid'];
}>;


export type TestsCreateStudySubjectMutation = { __typename?: 'mutation_root', insert_espin_study_subject?: { __typename?: 'espin_study_subject_mutation_response', returning: Array<{ __typename?: 'espin_study_subject', id: any }> } | null | undefined };

export type TestInsertNotificationMutationVariables = Exact<{
  input: Espin_Notification_Insert_Input;
}>;


export type TestInsertNotificationMutation = { __typename?: 'mutation_root', insert_espin_notification_one?: { __typename?: 'espin_notification', id: any } | null | undefined };

export type TestGetNotificationByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type TestGetNotificationByIdQuery = { __typename?: 'query_root', espin_notification_by_pk?: { __typename?: 'espin_notification', notification_type: Espin_Notification_Type_Enum } | null | undefined };

export const FormFileFragmentDoc = gql`
    fragment FormFile on content_file {
  id
  cdn_url
  original_name
  ext
}
    `;
export const LoginDataFragmentDoc = gql`
    fragment LoginData on espin_user {
  id
  role
  email
  last_login
  subscription_status {
    is_subscribed
    tierlookup
  }
  college_profile {
    id
    first_name
    last_name
    last_group_message
    college {
      id
      logo {
        ...FormFile
      }
      subscribed
      manual_subtier
      program_name
      address {
        location
        state
      }
      verified
      owner_profile_id
      subscription {
        referral_code_redemption_id
      }
    }
  }
  high_school_profile {
    id
    first_name
    last_name
    high_school {
      id
      name
      verified
      owner_profile_id
      profile_pic_file {
        ...FormFile
      }
    }
  }
  parent_profile {
    first_name
    last_name
    id
    child_profiles(where: {user: {deleted_at: {_is_null: true}}}) {
      id
      slug
      user_id
      user {
        subscription_status {
          is_subscribed
          tierlookup
        }
      }
      trial_end_date
      referral_option_id
      spin_username
      first_name
      last_name
      profile_image {
        ...FormFile
      }
      subscription {
        id
        expires
        referral_code_redemption_id
      }
      player_games {
        primary
        game {
          game_definition
        }
      }
    }
    address {
      location
      state
    }
  }
  player_profile {
    id
    spin_username
    ack_terms
    ack_waiver
    ack_displayed
    trial_end_date
    referral_option_id
    profile_image {
      ...FormFile
    }
    player_games {
      primary
      game {
        game_definition
      }
    }
    address {
      location
      state
    }
    subscription {
      referral_code_redemption_id
    }
  }
}
    ${FormFileFragmentDoc}`;
export const SpinContentImageDisplayFragmentDoc = gql`
    fragment SpinContentImageDisplay on content_file {
  id
  cdn_url
  ext
}
    `;
export const InterestedInCardFragmentDoc = gql`
    fragment InterestedInCard on espin_notification {
  player_user {
    deleted_at
    player_profile {
      user_id
      first_name
      last_name
      slug
      profile_image {
        ...SpinContentImageDisplay
      }
    }
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const ConversationStartedCardFragmentDoc = gql`
    fragment ConversationStartedCard on espin_notification {
  college {
    name
    slug
    logo {
      ...SpinContentImageDisplay
    }
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const FollowerCardFragmentDoc = gql`
    fragment FollowerCard on espin_follow {
  follow_type
  player_user {
    deleted_at
    player_profile {
      user_id
      first_name
      last_name
      slug
      graduating_class
      profile_image {
        ...SpinContentImageDisplay
      }
      player_games {
        primary
        game {
          name
          game_definition
        }
      }
    }
  }
  parent_user_id
  college_user_name
  college {
    name
    slug
    logo {
      ...SpinContentImageDisplay
    }
  }
  college_user {
    deleted_at
  }
  high_school_user {
    deleted_at
  }
  high_school {
    contact_name
    name
    slug
    profile_pic_file {
      ...SpinContentImageDisplay
    }
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const ProfileViewCardFragmentDoc = gql`
    fragment ProfileViewCard on espin_profile_view {
  profile_view_type
  player_user {
    deleted_at
    player_profile {
      user_id
      graduating_class
      first_name
      last_name
      slug
      profile_image {
        ...SpinContentImageDisplay
      }
      player_games {
        primary
        game {
          name
          game_definition
        }
      }
    }
  }
  college_user_full_name
  id
  high_school_user {
    deleted_at
  }
  high_school {
    name
    contact_name
    slug
    profile_pic_file {
      ...SpinContentImageDisplay
    }
  }
  college {
    name
    slug
    logo {
      ...SpinContentImageDisplay
    }
  }
  college_user {
    deleted_at
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const MessageCardFragmentDoc = gql`
    fragment MessageCard on espin_message {
  message_type
  viewed_at
  contents
  parent_user_id
  player_user {
    deleted_at
    player_profile {
      user_id
      first_name
      last_name
      slug
      profile_image {
        ...SpinContentImageDisplay
      }
    }
  }
  college {
    name
    slug
    logo {
      ...SpinContentImageDisplay
    }
  }
  high_school {
    name
    slug
    profile_pic_file {
      ...SpinContentImageDisplay
    }
  }
  college_user {
    deleted_at
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const SpinNotificationDataFragmentDoc = gql`
    fragment SpinNotificationData on espin_notification {
  player_user_id
  id
  created_at
  viewed_at
  notification_type
  ...InterestedInCard
  ...ConversationStartedCard
  follows {
    ...FollowerCard
  }
  profile_views {
    ...ProfileViewCard
  }
  messages {
    ...MessageCard
  }
}
    ${InterestedInCardFragmentDoc}
${ConversationStartedCardFragmentDoc}
${FollowerCardFragmentDoc}
${ProfileViewCardFragmentDoc}
${MessageCardFragmentDoc}`;
export const PlainTextLocationDisplayFragmentDoc = gql`
    fragment PlainTextLocationDisplay on espin_address {
  country
  city
  state
}
    `;
export const CollegeCardContentFragmentDoc = gql`
    fragment CollegeCardContent on espin_college {
  program_name
  college_games {
    game {
      game_definition
    }
  }
  address {
    ...PlainTextLocationDisplay
  }
  logo {
    ...SpinContentImageDisplay
  }
}
    ${PlainTextLocationDisplayFragmentDoc}
${SpinContentImageDisplayFragmentDoc}`;
export const ActivationCollegeAttendingFragmentDoc = gql`
    fragment ActivationCollegeAttending on espin_college {
  slug
  scholarships
  ...CollegeCardContent
}
    ${CollegeCardContentFragmentDoc}`;
export const CollegeSocialsFragmentDoc = gql`
    fragment CollegeSocials on espin_college {
  socials {
    facebook
    twitter
    instagram
    twitch_channel {
      id
      link_data
    }
    website
    youtube_channel {
      id
      link_data
    }
  }
}
    `;
export const CollegeInfoButtonsFragmentDoc = gql`
    fragment CollegeInfoButtons on espin_college {
  slug
  contact_email
  phone
  socials {
    discord
  }
}
    `;
export const CollegeProfileInfoFragmentDoc = gql`
    fragment CollegeProfileInfo on espin_college {
  id
  program_name
  in_state_tuition
  phone
  logo {
    ...FormFile
  }
  contact_email
  out_of_state_tuition
  address {
    ...PlainTextLocationDisplay
  }
  socials {
    facebook
    twitch
    twitter
    instagram
    discord
    youtube_channel {
      id
    }
  }
  ...CollegeSocials
  ...CollegeInfoButtons
}
    ${FormFileFragmentDoc}
${PlainTextLocationDisplayFragmentDoc}
${CollegeSocialsFragmentDoc}
${CollegeInfoButtonsFragmentDoc}`;
export const CollegeBioCardFragmentDoc = gql`
    fragment CollegeBioCard on espin_college {
  bio
  contact_email
  phone
  ...CollegeProfileInfo
}
    ${CollegeProfileInfoFragmentDoc}`;
export const AcademicRequirementsCardFragmentDoc = gql`
    fragment AcademicRequirementsCard on espin_college {
  academic_notes
  min_gpa
  min_sat
  min_act
}
    `;
export const OurEsportsCardFragmentDoc = gql`
    fragment OurEsportsCard on espin_college_game {
  game {
    name
    game_definition
  }
}
    `;
export const CollegeLocationCardFragmentDoc = gql`
    fragment CollegeLocationCard on espin_college {
  name
  address {
    state
    city
    country
    location
  }
}
    `;
export const CollegeMediaCardFragmentDoc = gql`
    fragment CollegeMediaCard on espin_college {
  name
  program_name
  header_media_link {
    link_type
    link_data
  }
  college_images {
    file {
      ...SpinContentImageDisplay
    }
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const CollegeProfileFragmentDoc = gql`
    fragment CollegeProfile on espin_college {
  program_name
  scholarships
  ...CollegeBioCard
  ...AcademicRequirementsCard
  header_media_link {
    link_data
    link_type
  }
  college_images {
    file {
      id
    }
  }
  college_games {
    ...OurEsportsCard
  }
  ...CollegeLocationCard
  ...CollegeSocials
  ...CollegeMediaCard
}
    ${CollegeBioCardFragmentDoc}
${AcademicRequirementsCardFragmentDoc}
${OurEsportsCardFragmentDoc}
${CollegeLocationCardFragmentDoc}
${CollegeSocialsFragmentDoc}
${CollegeMediaCardFragmentDoc}`;
export const CollegeDetailsFragmentDoc = gql`
    fragment CollegeDetails on espin_college {
  ...CollegeProfile
}
    ${CollegeProfileFragmentDoc}`;
export const CollegeRostersFragmentDoc = gql`
    fragment CollegeRosters on espin_college {
  college_games {
    game {
      name
    }
    college_rosters {
      first_name
      last_name
      gamertag
    }
  }
}
    `;
export const UnregisteredCollegesDisplayComponentFragmentDoc = gql`
    fragment UnregisteredCollegesDisplayComponent on espin_unregistered_college {
  id
  program_name
}
    `;
export const CollegeImageHandlerFragmentDoc = gql`
    fragment CollegeImageHandler on espin_college_image {
  id
  deleted_at
  order
  file {
    ...FormFile
  }
}
    ${FormFileFragmentDoc}`;
export const CollegeSearchFilterComponentFragmentDoc = gql`
    fragment CollegeSearchFilterComponent on query_root {
  espin_game_definition {
    display_name
    game_name
  }
}
    `;
export const ReferralOptionFragmentDoc = gql`
    fragment ReferralOption on espin_referral_option {
  id
  name
  sort_order
  description
}
    `;
export const AddOrEditGamePopupContentFragmentDoc = gql`
    fragment AddOrEditGamePopupContent on espin_player_game {
  id
  game {
    name
    game_definition
  }
  in_game_username
  rank
  role
  primary
  tracker
}
    `;
export const CollegeCardFragmentDoc = gql`
    fragment CollegeCard on espin_college {
  slug
  scholarships
  ...CollegeCardContent
}
    ${CollegeCardContentFragmentDoc}`;
export const FindCollegesResultsFragmentDoc = gql`
    fragment FindCollegesResults on espin_college {
  ...CollegeCard
  id
  name
  program_name
  subscribed
  address {
    city
    state
    country
  }
}
    ${CollegeCardFragmentDoc}`;
export const PlayerInfoWidgetFragmentDoc = gql`
    fragment PlayerInfoWidget on espin_player_profile {
  first_name
  last_name
  slug
  spin_username
}
    `;
export const PlayerListItemFragmentDoc = gql`
    fragment PlayerListItem on espin_player_profile {
  slug
  ...PlayerInfoWidget
}
    ${PlayerInfoWidgetFragmentDoc}`;
export const PlayerCardBioFragmentDoc = gql`
    fragment PlayerCardBio on espin_player_profile {
  spin_username
  first_name
  last_name
  address {
    ...PlainTextLocationDisplay
  }
}
    ${PlainTextLocationDisplayFragmentDoc}`;
export const PlayerCardRankFragmentDoc = gql`
    fragment PlayerCardRank on espin_player_profile {
  primary_game: player_games(where: {primary: {_eq: true}}) {
    game {
      name
      game_definition
    }
    rank
  }
}
    `;
export const PlayerCardContentFragmentDoc = gql`
    fragment PlayerCardContent on espin_player_profile {
  spin_username
  profile_image {
    ...FormFile
  }
  ...PlayerCardBio
  ...PlayerCardRank
}
    ${FormFileFragmentDoc}
${PlayerCardBioFragmentDoc}
${PlayerCardRankFragmentDoc}`;
export const PlayerCardInfoPanelFragmentDoc = gql`
    fragment PlayerCardInfoPanel on espin_player_profile {
  gpa
  graduating_class
}
    `;
export const PlayerCardFragmentDoc = gql`
    fragment PlayerCard on espin_player_profile {
  ...PlayerCardContent
  ...PlayerCardInfoPanel
  slug
}
    ${PlayerCardContentFragmentDoc}
${PlayerCardInfoPanelFragmentDoc}`;
export const FindPlayersResultsFragmentDoc = gql`
    fragment FindPlayersResults on espin_player_profile {
  id
  ...PlayerListItem
  ...PlayerCard
}
    ${PlayerListItemFragmentDoc}
${PlayerCardFragmentDoc}`;
export const ColleagueCardFragmentDoc = gql`
    fragment ColleagueCard on espin_college_invite {
  id
  email
  status
}
    `;
export const ColleagueInvitesFragmentDoc = gql`
    fragment ColleagueInvites on espin_college_invite {
  ...ColleagueCard
}
    ${ColleagueCardFragmentDoc}`;
export const HighSchoolColleagueCardFragmentDoc = gql`
    fragment HighSchoolColleagueCard on espin_high_school_invite {
  id
  email
  status
}
    `;
export const HighSchoolColleagueInvitesFragmentDoc = gql`
    fragment HighSchoolColleagueInvites on espin_high_school_invite {
  ...HighSchoolColleagueCard
}
    ${HighSchoolColleagueCardFragmentDoc}`;
export const MessagePreferencesFragmentDoc = gql`
    fragment MessagePreferences on espin_college_preferences {
  automatic_message_custom
  automatic_message_response_type
}
    `;
export const NotificationPreferencesFragmentDoc = gql`
    fragment NotificationPreferences on espin_user {
  id
  email_follow_preference
  email_message_preference
  email_profile_view_preference
}
    `;
export const FollowCardFragmentDoc = gql`
    fragment FollowCard on espin_follow {
  id
  college {
    id
    slug
    name
    logo {
      ...SpinContentImageDisplay
    }
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const PlayerFollowersFragmentDoc = gql`
    fragment PlayerFollowers on espin_follow {
  ...FollowCard
}
    ${FollowCardFragmentDoc}`;
export const PlayerFollowingFragmentDoc = gql`
    fragment PlayerFollowing on espin_follow {
  id
  ...FollowCard
}
    ${FollowCardFragmentDoc}`;
export const CollegeFollowCardFragmentDoc = gql`
    fragment CollegeFollowCard on espin_follow {
  id
  player_user {
    id
    player_profile {
      first_name
      last_name
      slug
      profile_image {
        ...SpinContentImageDisplay
      }
      graduating_class
      player_games {
        primary
        game {
          name
          game_definition
        }
      }
    }
  }
  high_school {
    id
    name
    slug
    contact_name
    profile_pic_file {
      ...SpinContentImageDisplay
    }
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const HighSchoolFollowCardFragmentDoc = gql`
    fragment HighSchoolFollowCard on espin_follow {
  id
  college {
    id
    slug
    name
    logo {
      ...SpinContentImageDisplay
    }
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const ParentChildDropdownFragmentDoc = gql`
    fragment ParentChildDropdown on espin_parent_profile {
  child_profiles(where: {user: {deleted_at: {_is_null: true}}}) {
    user_id
    spin_username
    profile_image {
      ...SpinContentImageDisplay
    }
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const NotificationCardFragmentDoc = gql`
    fragment NotificationCard on espin_notification {
  id
  notification_type
  viewed_at
  ...InterestedInCard
  follows {
    ...FollowerCard
  }
  profile_views {
    ...ProfileViewCard
  }
  messages {
    ...MessageCard
  }
}
    ${InterestedInCardFragmentDoc}
${FollowerCardFragmentDoc}
${ProfileViewCardFragmentDoc}
${MessageCardFragmentDoc}`;
export const NotificationsCardFragmentDoc = gql`
    fragment NotificationsCard on espin_notification {
  ...NotificationCard
  ...InterestedInCard
  ...ConversationStartedCard
}
    ${NotificationCardFragmentDoc}
${InterestedInCardFragmentDoc}
${ConversationStartedCardFragmentDoc}`;
export const ParentRecruitingHubNotificationsFragmentDoc = gql`
    fragment ParentRecruitingHubNotifications on espin_notification {
  player_user_id
  player_user {
    player_profile {
      parent_profile {
        ...ParentChildDropdown
      }
    }
  }
  ...NotificationsCard
}
    ${ParentChildDropdownFragmentDoc}
${NotificationsCardFragmentDoc}`;
export const RecruitingHubFollowsFragmentDoc = gql`
    fragment RecruitingHubFollows on espin_follow {
  id
  player_user_id
}
    `;
export const ParentRecruitingHubFollowsFragmentDoc = gql`
    fragment ParentRecruitingHubFollows on espin_follow {
  ...RecruitingHubFollows
}
    ${RecruitingHubFollowsFragmentDoc}`;
export const RecruitingHubMessagesFragmentDoc = gql`
    fragment RecruitingHubMessages on espin_message {
  id
  player_user_id
}
    `;
export const ParentRecruitingHubMessagesFragmentDoc = gql`
    fragment ParentRecruitingHubMessages on espin_message {
  ...RecruitingHubMessages
}
    ${RecruitingHubMessagesFragmentDoc}`;
export const RecruitingHubProfileViewsFragmentDoc = gql`
    fragment RecruitingHubProfileViews on espin_profile_view {
  id
  player_user_id
}
    `;
export const ParentRecruitingHubProfileViewsFragmentDoc = gql`
    fragment ParentRecruitingHubProfileViews on espin_profile_view {
  ...RecruitingHubProfileViews
}
    ${RecruitingHubProfileViewsFragmentDoc}`;
export const EventCardHeaderFragmentDoc = gql`
    fragment EventCardHeader on espin_event {
  name
  icon {
    ...FormFile
  }
  logo {
    ...FormFile
  }
}
    ${FormFileFragmentDoc}`;
export const EventCardContentFragmentDoc = gql`
    fragment EventCardContent on espin_event {
  name
  slug
  type
  prize
  event_start_date
  event_end_date
  register_end_date
  register_start_date
  event_games {
    game {
      game_definition
      name
    }
  }
}
    `;
export const EventCardFragmentDoc = gql`
    fragment EventCard on espin_event {
  id
  slug
  ...EventCardHeader
  ...EventCardContent
}
    ${EventCardHeaderFragmentDoc}
${EventCardContentFragmentDoc}`;
export const UpcomingEventsCardFragmentDoc = gql`
    fragment UpcomingEventsCard on espin_event {
  ...EventCard
}
    ${EventCardFragmentDoc}`;
export const RecruitingHubEventsFragmentDoc = gql`
    fragment RecruitingHubEvents on espin_event {
  ...UpcomingEventsCard
}
    ${UpcomingEventsCardFragmentDoc}`;
export const RecruitingHubNotificationsFragmentDoc = gql`
    fragment RecruitingHubNotifications on espin_notification {
  ...NotificationsCard
}
    ${NotificationsCardFragmentDoc}`;
export const PlayerConversationCardFragmentDoc = gql`
    fragment PlayerConversationCard on espin_message {
  player_user_id
  contents
  created_at
  viewed_at
  message_type
  college {
    logo {
      ...SpinContentImageDisplay
    }
    name
    slug
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const CollegeConversationCardFragmentDoc = gql`
    fragment CollegeConversationCard on espin_message {
  college_id
  contents
  created_at
  viewed_at
  message_type
  player_user {
    player_profile {
      profile_image {
        ...SpinContentImageDisplay
      }
      first_name
      last_name
      slug
    }
    deleted_at
  }
  high_school {
    name
    profile_pic_file {
      ...SpinContentImageDisplay
    }
    slug
  }
  parent_user_id
  id
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const ConversationCardFragmentDoc = gql`
    fragment ConversationCard on espin_message {
  ...PlayerConversationCard
  ...CollegeConversationCard
}
    ${PlayerConversationCardFragmentDoc}
${CollegeConversationCardFragmentDoc}`;
export const InboxFragmentDoc = gql`
    fragment Inbox on espin_message {
  ...ConversationCard
}
    ${ConversationCardFragmentDoc}`;
export const InboxContainerFragmentDoc = gql`
    fragment InboxContainer on espin_message {
  ...ConversationCard
}
    ${ConversationCardFragmentDoc}`;
export const PlayerSendsMessageFragmentDoc = gql`
    fragment PlayerSendsMessage on espin_message {
  contents
  created_at
  player_user {
    player_profile {
      first_name
      last_name
    }
    deleted_at
  }
  parent_user_id
}
    `;
export const CollegeSendsMessageFragmentDoc = gql`
    fragment CollegeSendsMessage on espin_message {
  contents
  created_at
  college {
    name
  }
}
    `;
export const HighSchoolSendsMessageFragmentDoc = gql`
    fragment HighSchoolSendsMessage on espin_message {
  contents
  created_at
  high_school {
    name
  }
}
    `;
export const MessageContainerFragmentDoc = gql`
    fragment MessageContainer on espin_message {
  message_type
  ...PlayerSendsMessage
  ...CollegeSendsMessage
  ...HighSchoolSendsMessage
}
    ${PlayerSendsMessageFragmentDoc}
${CollegeSendsMessageFragmentDoc}
${HighSchoolSendsMessageFragmentDoc}`;
export const CollegeIncomingChatBubbleFragmentDoc = gql`
    fragment CollegeIncomingChatBubble on espin_message {
  ...MessageContainer
  player_user {
    player_profile {
      first_name
      last_name
    }
    deleted_at
  }
  high_school {
    name
    profile_pic_file {
      ...SpinContentImageDisplay
    }
  }
}
    ${MessageContainerFragmentDoc}
${SpinContentImageDisplayFragmentDoc}`;
export const MyChatBubbleFragmentDoc = gql`
    fragment MyChatBubble on espin_message {
  ...MessageContainer
}
    ${MessageContainerFragmentDoc}`;
export const CollegeChatBubblesFragmentDoc = gql`
    fragment CollegeChatBubbles on espin_message {
  ...CollegeIncomingChatBubble
  ...MyChatBubble
  message_type
  player_user {
    player_profile {
      profile_image {
        ...SpinContentImageDisplay
      }
    }
    deleted_at
  }
  high_school {
    name
    profile_pic_file {
      ...SpinContentImageDisplay
    }
  }
}
    ${CollegeIncomingChatBubbleFragmentDoc}
${MyChatBubbleFragmentDoc}
${SpinContentImageDisplayFragmentDoc}`;
export const CollegeSelectedConversationFragmentDoc = gql`
    fragment CollegeSelectedConversation on espin_message {
  ...CollegeChatBubbles
  player_user {
    player_profile {
      profile_image {
        ...SpinContentImageDisplay
      }
      first_name
      last_name
      slug
    }
    deleted_at
  }
  high_school {
    id
    name
    profile_pic_file {
      ...SpinContentImageDisplay
    }
    slug
  }
}
    ${CollegeChatBubblesFragmentDoc}
${SpinContentImageDisplayFragmentDoc}`;
export const PlayerIncomingChatBubbleFragmentDoc = gql`
    fragment PlayerIncomingChatBubble on espin_message {
  ...MessageContainer
  college {
    name
  }
}
    ${MessageContainerFragmentDoc}`;
export const PlayerChatBubblesFragmentDoc = gql`
    fragment PlayerChatBubbles on espin_message {
  ...PlayerIncomingChatBubble
  ...MyChatBubble
  message_type
  college {
    logo {
      ...SpinContentImageDisplay
    }
  }
}
    ${PlayerIncomingChatBubbleFragmentDoc}
${MyChatBubbleFragmentDoc}
${SpinContentImageDisplayFragmentDoc}`;
export const PlayerSelectedConversationFragmentDoc = gql`
    fragment PlayerSelectedConversation on espin_message {
  ...PlayerChatBubbles
  college {
    logo {
      ...SpinContentImageDisplay
    }
    name
    slug
  }
}
    ${PlayerChatBubblesFragmentDoc}
${SpinContentImageDisplayFragmentDoc}`;
export const SelectedConversationContentFragmentDoc = gql`
    fragment SelectedConversationContent on espin_message {
  player_user_id
  college_id
  parent_user_id
  college_user_id
  ...CollegeSelectedConversation
  ...PlayerSelectedConversation
}
    ${CollegeSelectedConversationFragmentDoc}
${PlayerSelectedConversationFragmentDoc}`;
export const ConversationContainerFragmentDoc = gql`
    fragment ConversationContainer on espin_message {
  ...SelectedConversationContent
}
    ${SelectedConversationContentFragmentDoc}`;
export const MessagesCardFragmentDoc = gql`
    fragment MessagesCard on espin_message {
  ...InboxContainer
  ...ConversationContainer
}
    ${InboxContainerFragmentDoc}
${ConversationContainerFragmentDoc}`;
export const MyEventsCardFragmentDoc = gql`
    fragment MyEventsCard on espin_event {
  ...EventCard
}
    ${EventCardFragmentDoc}`;
export const HighSchoolTeamEventRegistrationsCardFragmentDoc = gql`
    fragment HighSchoolTeamEventRegistrationsCard on espin_team {
  display_name
  event_registrations(
    order_by: {event: {event_start_date: asc}}
    where: {team: {high_school_id: {_eq: $highSchoolId}}, event: {event_end_date: {_gte: "now()"}, status: {_eq: published}}}
  ) {
    event {
      ...MyEventsCard
    }
  }
}
    ${MyEventsCardFragmentDoc}`;
export const MyEventsCardPlayerFragmentDoc = gql`
    fragment MyEventsCardPlayer on espin_player_profile {
  profile_image {
    ...SpinContentImageDisplay
  }
  spin_username
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const MyUpcomingEventsFragmentDoc = gql`
    fragment MyUpcomingEvents on espin_event {
  ...EventCard
  event_registrations {
    id
  }
}
    ${EventCardFragmentDoc}`;
export const EditableGameFragmentDoc = gql`
    fragment EditableGame on espin_player_game {
  id
  game {
    game_definition
    name
  }
  rank
  role
  primary
  tracker
  in_game_username
}
    `;
export const HighSchoolEmptyTeamCardFragmentDoc = gql`
    fragment HighSchoolEmptyTeamCard on espin_team {
  team_invites(where: {status: {_eq: pending}}) {
    id
  }
  members {
    id
  }
}
    `;
export const HighSchoolMyPlayerCardFragmentDoc = gql`
    fragment HighSchoolMyPlayerCard on espin_player_profile {
  profile_image {
    ...FormFile
  }
  id
  spin_username
  first_name
  last_name
  player_teams(
    where: {team: {team_type: {_eq: school}, high_school_id: {_eq: $highSchoolId}, deleted_at: {_is_null: true}}}
  ) {
    team {
      display_name
      high_school {
        high_school_profiles {
          user_id
        }
      }
    }
  }
  user {
    player_user_messages {
      college_user {
        college_profile {
          first_name
          last_name
        }
      }
      college {
        college_owner {
          first_name
          last_name
        }
        name
        slug
      }
    }
  }
}
    ${FormFileFragmentDoc}`;
export const UniqueTeamMemberFragmentDoc = gql`
    fragment UniqueTeamMember on espin_team_members {
  player_profile {
    ...HighSchoolMyPlayerCard
  }
}
    ${HighSchoolMyPlayerCardFragmentDoc}`;
export const HighSchoolTeamInviteFragmentDoc = gql`
    fragment HighSchoolTeamInvite on espin_team_invite {
  id
  status
  user {
    player_profile {
      id
      spin_username
    }
  }
  player_profile {
    id
    spin_username
  }
}
    `;
export const HighSchoolTeamInviteListFragmentDoc = gql`
    fragment HighSchoolTeamInviteList on espin_team {
  team_invites(where: {status: {_eq: pending}}) {
    ...HighSchoolTeamInvite
  }
}
    ${HighSchoolTeamInviteFragmentDoc}`;
export const HighSchoolTeamMemberFragmentDoc = gql`
    fragment HighSchoolTeamMember on espin_team_members {
  id
  team_role
  player_profile {
    spin_username
    id
    social {
      discord
    }
  }
}
    `;
export const HighSchoolTeamPlayerListFragmentDoc = gql`
    fragment HighSchoolTeamPlayerList on espin_team {
  members {
    ...HighSchoolTeamMember
  }
}
    ${HighSchoolTeamMemberFragmentDoc}`;
export const HighSchoolTeamCardFragmentDoc = gql`
    fragment HighSchoolTeamCard on espin_team {
  id
  display_name
  team_type
  game {
    game_definition
    name
  }
  event_registrations(where: {event: {event_end_date: {_gte: "now()"}}}) {
    event {
      name
    }
  }
  ...HighSchoolTeamInviteList
  ...HighSchoolTeamPlayerList
}
    ${HighSchoolTeamInviteListFragmentDoc}
${HighSchoolTeamPlayerListFragmentDoc}`;
export const MyPlayerCardFragmentDoc = gql`
    fragment MyPlayerCard on espin_player_profile {
  profile_image {
    ...SpinContentImageDisplay
  }
  spin_username
  first_name
  last_name
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const ParentMyPlayersFieldsOnRemoveCallbackFragmentDoc = gql`
    fragment ParentMyPlayersFieldsOnRemoveCallback on espin_player_profile {
  id
  first_name
  last_name
}
    `;
export const VoDsCardFragmentDoc = gql`
    fragment VODsCard on espin_player_vod {
  id
  label
  media_link {
    id
    link_data
    link_type
  }
}
    `;
export const PrimaryGameCardFragmentDoc = gql`
    fragment PrimaryGameCard on espin_player_game {
  game {
    name
    game_definition
  }
  rank
  role
  tracker
}
    `;
export const PlayerProfileUserControlsFragmentDoc = gql`
    fragment PlayerProfileUserControls on espin_player_profile {
  user_id
  slug
}
    `;
export const PlayerSocialDisplaysFragmentDoc = gql`
    fragment PlayerSocialDisplays on espin_social {
  discord
  twitter
  facebook
  tiktok
  instagram
  youtube_channel {
    id
    link_data
  }
  twitch_channel {
    id
    link_data
  }
}
    `;
export const PlayerProfileInfoFragmentDoc = gql`
    fragment PlayerProfileInfo on espin_player_profile {
  ...PlayerProfileUserControls
  spin_username
  first_name
  last_name
  user {
    subscription_status {
      is_subscribed
    }
  }
  social {
    ...PlayerSocialDisplays
  }
  address {
    city
    state
    country
  }
  profile_image {
    ...FormFile
  }
  linked_high_school_details {
    name
    slug
  }
  college_name
  hs_name
  is_hs
  ...PlayerProfileUserControls
}
    ${PlayerProfileUserControlsFragmentDoc}
${PlayerSocialDisplaysFragmentDoc}
${FormFileFragmentDoc}`;
export const PlayerInfoButtonsFragmentDoc = gql`
    fragment PlayerInfoButtons on espin_player_profile {
  social {
    discord
  }
  user {
    email
    id
    subscription_status {
      is_subscribed
    }
  }
  phone
}
    `;
export const PlayerBioCardFragmentDoc = gql`
    fragment PlayerBioCard on espin_player_profile {
  bio
  phone
  user {
    email
    subscription_status {
      is_subscribed
    }
  }
  social {
    discord
  }
  ...PlayerProfileInfo
  ...PlayerInfoButtons
}
    ${PlayerProfileInfoFragmentDoc}
${PlayerInfoButtonsFragmentDoc}`;
export const GpaCardFragmentDoc = gql`
    fragment GPACard on espin_player_profile {
  gpa
}
    `;
export const ClassOfCardFragmentDoc = gql`
    fragment ClassOfCard on espin_player_profile {
  graduating_class
}
    `;
export const CommittedToCollegeCardFragmentDoc = gql`
    fragment CommittedToCollegeCard on espin_player_profile {
  first_name
  last_name
  committed_to_college
}
    `;
export const PlayerProfileFragmentDoc = gql`
    fragment PlayerProfile on espin_player_profile {
  id
  spin_username
  first_name
  last_name
  bio
  slug
  committed_to_college
  user_id
  phone
  gpa
  graduating_class
  preferred_study_fields
  preferred_schools
  player_vods {
    ...VODsCard
  }
  primary_game: player_games(where: {primary: {_eq: true}}) {
    ...PrimaryGameCard
  }
  user {
    email
    subscription_status {
      is_subscribed
    }
  }
  ...PlayerBioCard
  ...GPACard
  ...ClassOfCard
  ...CommittedToCollegeCard
}
    ${VoDsCardFragmentDoc}
${PrimaryGameCardFragmentDoc}
${PlayerBioCardFragmentDoc}
${GpaCardFragmentDoc}
${ClassOfCardFragmentDoc}
${CommittedToCollegeCardFragmentDoc}`;
export const ParentMyPlayersProfileFragmentDoc = gql`
    fragment ParentMyPlayersProfile on espin_player_profile {
  ...PlayerProfile
}
    ${PlayerProfileFragmentDoc}`;
export const EditableMyPlayerCardFragmentDoc = gql`
    fragment EditableMyPlayerCard on espin_player_profile {
  profile_image {
    ...SpinContentImageDisplay
  }
  spin_username
  first_name
  last_name
  user {
    email
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const ParentMyPlayersFieldsFragmentDoc = gql`
    fragment ParentMyPlayersFields on espin_player_profile {
  id
  ...EditableMyPlayerCard
}
    ${EditableMyPlayerCardFragmentDoc}`;
export const ParentProfileFormFragmentDoc = gql`
    fragment ParentProfileForm on espin_parent_profile {
  id
  first_name
  last_name
  phone
  child_profiles(where: {user: {deleted_at: {_is_null: true}}}) {
    ...ParentMyPlayersFields
  }
}
    ${ParentMyPlayersFieldsFragmentDoc}`;
export const PlayerEmptyTeamCardFragmentDoc = gql`
    fragment PlayerEmptyTeamCard on espin_team {
  team_invites(where: {status: {_eq: pending}}) {
    id
  }
  members {
    id
  }
}
    `;
export const PlayerMyTeamsInviteFragmentDoc = gql`
    fragment PlayerMyTeamsInvite on espin_team_invite {
  id
  status
  team {
    id
    team_type
    high_school {
      id
      name
      slug
    }
    game {
      game_definition
      name
    }
    display_name
  }
}
    `;
export const PlayerMyTeamsTeamFragmentDoc = gql`
    fragment PlayerMyTeamsTeam on espin_team {
  id
  team_type
  game {
    game_definition
    name
  }
  display_name
  ...HighSchoolTeamInviteList
  members {
    ...HighSchoolTeamMember
  }
  event_registrations(where: {event: {event_end_date: {_gte: "now()"}}}) {
    event {
      name
    }
  }
  high_school {
    name
    slug
  }
}
    ${HighSchoolTeamInviteListFragmentDoc}
${HighSchoolTeamMemberFragmentDoc}`;
export const PlayerTeamPlayerListFragmentDoc = gql`
    fragment PlayerTeamPlayerList on espin_team {
  members {
    id
    player_profile {
      spin_username
    }
    team_role
  }
}
    `;
export const PlayerVodMediaLinkTypesFragmentDoc = gql`
    fragment PlayerVODMediaLinkTypes on content_media_link_type {
  comment
  name
}
    `;
export const ProfileVodDisplayComponentFragmentDoc = gql`
    fragment ProfileVODDisplayComponent on espin_player_vod {
  id
  label
  media_link {
    id
    link_data
    link_type
  }
}
    `;
export const ChildDataFragmentDoc = gql`
    fragment ChildData on espin_parent_profile {
  child_profiles(where: {user: {deleted_at: {_is_null: true}}}) {
    user_id
    address {
      location
    }
    spin_username
    profile_image {
      cdn_url
    }
  }
}
    `;
export const AllProfileViewsCardFragmentDoc = gql`
    fragment AllProfileViewsCard on espin_profile_view {
  id
  college_id
  college_user_id
  college_user_full_name
  college {
    id
    slug
    name
    logo {
      ...SpinContentImageDisplay
    }
  }
  college_user {
    deleted_at
  }
  parent_user_id
  player_user {
    id
    deleted_at
    player_profile {
      id
      first_name
      last_name
      player_games {
        primary
        game {
          name
          game_definition
        }
      }
      profile_image {
        ...SpinContentImageDisplay
      }
      slug
      graduating_class
    }
  }
  high_school {
    id
    slug
    name
    contact_name
    profile_pic_file {
      ...SpinContentImageDisplay
    }
  }
  high_school_user {
    deleted_at
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const ProfileViewsFragmentDoc = gql`
    fragment ProfileViews on espin_profile_view {
  ...AllProfileViewsCard
}
    ${AllProfileViewsCardFragmentDoc}`;
export const EventReportFragmentDoc = gql`
    fragment EventReport on espin_event {
  name
  slug
  stream_url
  icon {
    ...FormFile
  }
  prize
  event_start_date
  event_end_date
  event_games {
    game {
      game_definition
      name
    }
  }
}
    ${FormFileFragmentDoc}`;
export const PlayerReportCardInfoFragmentDoc = gql`
    fragment PlayerReportCardInfo on espin_event_registration {
  registration_details
  event_ticket {
    ticket_type
  }
  user {
    player_profile {
      profile_image {
        ...FormFile
      }
      first_name
      last_name
    }
  }
}
    ${FormFileFragmentDoc}`;
export const PlayerReportGameContainerFragmentDoc = gql`
    fragment PlayerReportGameContainer on espin_event_registration {
  event_ticket {
    game {
      game_definition
    }
  }
  user {
    player_profile {
      player_games {
        game {
          name
          game_definition
        }
        rank
        role
        tracker
      }
    }
  }
}
    `;
export const ScoutingReportPlayerCardFragmentDoc = gql`
    fragment ScoutingReportPlayerCard on espin_event_registration {
  ...PlayerReportCardInfo
  user {
    subscription_status {
      is_subscribed
    }
    id
    player_profile {
      graduating_class
      gpa
      slug
      ...PlayerInfoButtons
    }
  }
  ...PlayerReportGameContainer
}
    ${PlayerReportCardInfoFragmentDoc}
${PlayerInfoButtonsFragmentDoc}
${PlayerReportGameContainerFragmentDoc}`;
export const ScoutingReportPlayerCardsFragmentDoc = gql`
    fragment ScoutingReportPlayerCards on espin_event_registration {
  ...ScoutingReportPlayerCard
  user {
    id
    player_profile {
      id
    }
  }
  event_ticket {
    ticket_type
  }
}
    ${ScoutingReportPlayerCardFragmentDoc}`;
export const SubscriptionMyPlayerCardFragmentDoc = gql`
    fragment SubscriptionMyPlayerCard on espin_player_profile {
  profile_image {
    ...SpinContentImageDisplay
  }
  spin_username
  first_name
  last_name
  subscription {
    expires
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const ParentChildSubscriptionsFragmentDoc = gql`
    fragment ParentChildSubscriptions on espin_player_profile {
  subscription {
    id
  }
  ...SubscriptionMyPlayerCard
}
    ${SubscriptionMyPlayerCardFragmentDoc}`;
export const EventInfoWidgetFragmentDoc = gql`
    fragment EventInfoWidget on espin_event {
  name
  logo {
    ...SpinContentImageDisplay
  }
  icon {
    ...SpinContentImageDisplay
  }
  event_start_date
  event_end_date
  type
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const EventGameDisplayFragmentDoc = gql`
    fragment EventGameDisplay on espin_event {
  event_games {
    game {
      name
    }
  }
}
    `;
export const EventListingFragmentDoc = gql`
    fragment EventListing on espin_event {
  ...EventInfoWidget
  ...EventGameDisplay
  slug
  id
}
    ${EventInfoWidgetFragmentDoc}
${EventGameDisplayFragmentDoc}`;
export const EventInfoFragmentDoc = gql`
    fragment EventInfo on espin_event {
  short_description
  event_start_date
  event_end_date
  body_content
  rules_content
}
    `;
export const EventTicketCardFragmentDoc = gql`
    fragment EventTicketCard on espin_event_ticket {
  id
  ticket_type
  description
  game {
    game_definition
    name
  }
  price_temp
  event {
    slug
  }
}
    `;
export const EventTicketsFragmentDoc = gql`
    fragment EventTickets on espin_event_ticket {
  id
  ...EventTicketCard
}
    ${EventTicketCardFragmentDoc}`;
export const EventRegistrationFragmentDoc = gql`
    fragment EventRegistration on espin_event {
  prize
  registration_disclaimer
  register_end_date
  register_start_date
  event_tickets {
    ...EventTickets
  }
}
    ${EventTicketsFragmentDoc}`;
export const TicketRegistrationsFragmentDoc = gql`
    fragment TicketRegistrations on espin_event {
  event_tickets {
    id
    event_registrations {
      id
    }
  }
}
    `;
export const EventTicketRegistrationsFragmentDoc = gql`
    fragment EventTicketRegistrations on espin_event {
  ...TicketRegistrations
}
    ${TicketRegistrationsFragmentDoc}`;
export const CannotRegisterAsNonPlayerFragmentDoc = gql`
    fragment CannotRegisterAsNonPlayer on espin_event_ticket {
  ...EventTicketCard
  event {
    id
    slug
  }
}
    ${EventTicketCardFragmentDoc}`;
export const EventTicketCheckoutFormFragmentDoc = gql`
    fragment EventTicketCheckoutForm on espin_event_ticket {
  id
  event {
    id
    slug
  }
}
    `;
export const EventGamesFragmentDoc = gql`
    fragment EventGames on espin_event_game {
  game {
    game_definition
    name
  }
}
    `;
export const EventHeaderFragmentDoc = gql`
    fragment EventHeader on espin_event {
  name
  event_start_date
  prize
  event_end_date
  logo {
    ...SpinContentImageDisplay
  }
  icon {
    ...SpinContentImageDisplay
  }
  type
  event_games {
    ...EventGames
  }
}
    ${SpinContentImageDisplayFragmentDoc}
${EventGamesFragmentDoc}`;
export const EventCustomFieldsHandlerFragmentDoc = gql`
    fragment EventCustomFieldsHandler on espin_event_custom_field {
  id
  default_value
  field_type
  name
  label
}
    `;
export const EventCustomFieldFormEntryFragmentDoc = gql`
    fragment EventCustomFieldFormEntry on espin_event {
  event_custom_fields {
    ...EventCustomFieldsHandler
  }
}
    ${EventCustomFieldsHandlerFragmentDoc}`;
export const DocumentDownloadDisplayFragmentDoc = gql`
    fragment DocumentDownloadDisplay on content_file {
  id
  original_name
  cdn_url
  ext
}
    `;
export const DocumentSignOffHandlerFragmentDoc = gql`
    fragment DocumentSignOffHandler on espin_event_document {
  id
  file {
    ...DocumentDownloadDisplay
  }
  name
}
    ${DocumentDownloadDisplayFragmentDoc}`;
export const EventDocumentSignOffsFragmentDoc = gql`
    fragment EventDocumentSignOffs on espin_event {
  event_documents {
    ...DocumentSignOffHandler
  }
}
    ${DocumentSignOffHandlerFragmentDoc}`;
export const RegistrationInfoFormFragmentDoc = gql`
    fragment RegistrationInfoForm on espin_event_ticket {
  ticket_type
  game {
    game_definition
    team_max_size
  }
  event {
    ...EventCustomFieldFormEntry
    ...EventDocumentSignOffs
  }
}
    ${EventCustomFieldFormEntryFragmentDoc}
${EventDocumentSignOffsFragmentDoc}`;
export const OrderSubtotalFragmentDoc = gql`
    fragment OrderSubtotal on espin_event_ticket {
  price_temp
  ticket_type
  game {
    name
  }
}
    `;
export const PaidTicketCheckoutComponentFragmentDoc = gql`
    fragment PaidTicketCheckoutComponent on espin_event_ticket {
  ...OrderSubtotal
  ...EventTicketCheckoutForm
}
    ${OrderSubtotalFragmentDoc}
${EventTicketCheckoutFormFragmentDoc}`;
export const FreeTicketOrderDisplayFragmentDoc = gql`
    fragment FreeTicketOrderDisplay on espin_event_ticket {
  game {
    name
  }
  ticket_type
}
    `;
export const FreeTicketCheckoutComponentFragmentDoc = gql`
    fragment FreeTicketCheckoutComponent on espin_event_ticket {
  ...FreeTicketOrderDisplay
}
    ${FreeTicketOrderDisplayFragmentDoc}`;
export const EventRegistrationFormFragmentDoc = gql`
    fragment EventRegistrationForm on espin_event_ticket {
  ...EventTicketCheckoutForm
  event {
    slug
    ...EventHeader
    ...EventCustomFieldFormEntry
    ...EventDocumentSignOffs
  }
  ...EventTicketCard
  game {
    team_max_size
  }
  price_temp
  price_id
  ...RegistrationInfoForm
  ...PaidTicketCheckoutComponent
  ...FreeTicketCheckoutComponent
}
    ${EventTicketCheckoutFormFragmentDoc}
${EventHeaderFragmentDoc}
${EventCustomFieldFormEntryFragmentDoc}
${EventDocumentSignOffsFragmentDoc}
${EventTicketCardFragmentDoc}
${RegistrationInfoFormFragmentDoc}
${PaidTicketCheckoutComponentFragmentDoc}
${FreeTicketCheckoutComponentFragmentDoc}`;
export const NeedsToFinishOnboardingBeforeRegFragmentDoc = gql`
    fragment NeedsToFinishOnboardingBeforeReg on espin_event_ticket {
  ...EventTicketCard
}
    ${EventTicketCardFragmentDoc}`;
export const SignInToRegisterFragmentDoc = gql`
    fragment SignInToRegister on espin_event_ticket {
  ...EventTicketCard
}
    ${EventTicketCardFragmentDoc}`;
export const FormImageFileFragmentDoc = gql`
    fragment FormImageFile on content_file {
  id
  cdn_url
  ext
}
    `;
export const HighSchoolCardContentFragmentDoc = gql`
    fragment HighSchoolCardContent on espin_high_school {
  name
  teams(where: {deleted_at: {_is_null: true}}) {
    game {
      game_definition
      name
    }
  }
  address {
    ...PlainTextLocationDisplay
  }
  profile_pic_file {
    ...SpinContentImageDisplay
  }
}
    ${PlainTextLocationDisplayFragmentDoc}
${SpinContentImageDisplayFragmentDoc}`;
export const HighSchoolCardFragmentDoc = gql`
    fragment HighSchoolCard on espin_high_school {
  slug
  ...HighSchoolCardContent
}
    ${HighSchoolCardContentFragmentDoc}`;
export const HighSchoolSocialsFragmentDoc = gql`
    fragment HighSchoolSocials on espin_high_school {
  socials {
    facebook
    twitter
    instagram
    twitch_channel {
      id
      link_data
    }
    website
    youtube_channel {
      id
      link_data
    }
  }
}
    `;
export const HighSchoolInfoButtonsFragmentDoc = gql`
    fragment HighSchoolInfoButtons on espin_high_school {
  slug
  contact_email
  contact_name
  contact_phone
  socials {
    discord
  }
}
    `;
export const HighSchoolProfileInfoFragmentDoc = gql`
    fragment HighSchoolProfileInfo on espin_high_school {
  id
  name
  profile_pic_file {
    ...FormFile
  }
  contact_email
  contact_name
  contact_phone
  address {
    ...PlainTextLocationDisplay
  }
  socials {
    facebook
    twitch
    twitter
    instagram
    discord
    twitch_channel {
      id
    }
    youtube_channel {
      id
    }
  }
  ...HighSchoolSocials
  ...HighSchoolInfoButtons
}
    ${FormFileFragmentDoc}
${PlainTextLocationDisplayFragmentDoc}
${HighSchoolSocialsFragmentDoc}
${HighSchoolInfoButtonsFragmentDoc}`;
export const HighSchoolBioCardFragmentDoc = gql`
    fragment HighSchoolBioCard on espin_high_school {
  bio
  contact_email
  contact_name
  name
  ...HighSchoolProfileInfo
}
    ${HighSchoolProfileInfoFragmentDoc}`;
export const HighSchoolLocationCardFragmentDoc = gql`
    fragment HighSchoolLocationCard on espin_high_school {
  name
  address {
    state
    city
    country
    location
  }
}
    `;
export const TeamMemberFragmentDoc = gql`
    fragment TeamMember on espin_team_members {
  team_role
  player_profile {
    spin_username
    slug
    id
  }
}
    `;
export const TeamCardFragmentDoc = gql`
    fragment TeamCard on espin_team {
  id
  display_name
  game {
    game_definition
    name
  }
  members {
    ...TeamMember
  }
}
    ${TeamMemberFragmentDoc}`;
export const HighSchoolOurTeamsCardFragmentDoc = gql`
    fragment HighSchoolOurTeamsCard on espin_high_school {
  bio
  contact_email
  contact_name
  name
  teams(where: {team_type: {_eq: school}, deleted_at: {_is_null: true}}) {
    ...TeamCard
  }
  ...HighSchoolProfileInfo
}
    ${TeamCardFragmentDoc}
${HighSchoolProfileInfoFragmentDoc}`;
export const HighSchoolOurEsportsCardFragmentDoc = gql`
    fragment HighSchoolOurEsportsCard on espin_high_school {
  esportsTeams: teams(where: {deleted_at: {_is_null: true}}) {
    game {
      game_definition
      name
    }
  }
}
    `;
export const HighSchoolProfileFragmentDoc = gql`
    fragment HighSchoolProfile on espin_high_school {
  name
  ...HighSchoolBioCard
  ...HighSchoolLocationCard
  ...HighSchoolOurTeamsCard
  ...HighSchoolOurEsportsCard
}
    ${HighSchoolBioCardFragmentDoc}
${HighSchoolLocationCardFragmentDoc}
${HighSchoolOurTeamsCardFragmentDoc}
${HighSchoolOurEsportsCardFragmentDoc}`;
export const HighSchoolDetailsFragmentDoc = gql`
    fragment HighSchoolDetails on espin_high_school {
  ...HighSchoolProfile
}
    ${HighSchoolProfileFragmentDoc}`;
export const HighSchoolSearchFilterComponentFragmentDoc = gql`
    fragment HighSchoolSearchFilterComponent on query_root {
  espin_game_definition {
    display_name
    game_name
  }
}
    `;
export const UpcomingEventsFragmentDoc = gql`
    fragment UpcomingEvents on espin_event {
  ...EventCard
}
    ${EventCardFragmentDoc}`;
export const MonthDaysFragmentDoc = gql`
    fragment MonthDays on espin_org_month {
  month
  total_days
  start_day
  month_of_year
  days {
    date
    title
    time
    game_def
  }
}
    `;
export const OrgFeaturedPlayerFragmentDoc = gql`
    fragment OrgFeaturedPlayer on espin_org_player {
  player_review
  rank
  featured
  gpa
  grad_class
  game_rank
  username
  game {
    name
    game_definition
  }
  school {
    display_name
    city
    state
  }
}
    `;
export const OrgFeaturedSchoolFragmentDoc = gql`
    fragment OrgFeaturedSchool on espin_org_school {
  display_name
  city
  state
  rank
  bio
  records {
    wins
    losses
    game {
      game_definition
      name
    }
  }
}
    `;
export const DayFragmentDoc = gql`
    fragment Day on espin_org_month_day {
  date
  title
  time
  game {
    game_definition
  }
}
    `;
export const FeatCardAddressFragmentDoc = gql`
    fragment FeatCardAddress on espin_org_player {
  school {
    city
    state
  }
}
    `;
export const FeatPlayerBioFragmentDoc = gql`
    fragment FeatPlayerBio on espin_org_player {
  username
  school {
    display_name
    city
    state
  }
}
    `;
export const FeatPlayerCardContentFragmentDoc = gql`
    fragment FeatPlayerCardContent on espin_org_player {
  player_review
  gpa
  grad_class
  game_rank
  username
  game {
    name
    game_definition
  }
  school {
    display_name
    city
    state
  }
}
    `;
export const FeatPlayerCardRankFragmentDoc = gql`
    fragment FeatPlayerCardRank on espin_org_player {
  game_rank
  game {
    name
    game_definition
  }
}
    `;
export const OrgFeatInfoPanelFragmentDoc = gql`
    fragment OrgFeatInfoPanel on espin_org_player {
  rank
  gpa
  grad_class
}
    `;
export const OrgFeaturedPlayerCardFragmentDoc = gql`
    fragment OrgFeaturedPlayerCard on espin_org_player {
  player_review
  rank
  featured
  gpa
  grad_class
  game_rank
  username
  game {
    name
    game_definition
  }
  school {
    display_name
    city
    state
  }
}
    `;
export const OrgFeaturedSchoolCardFragmentDoc = gql`
    fragment OrgFeaturedSchoolCard on espin_org_school {
  display_name
  city
  state
  rank
  bio
  records {
    wins
    losses
    game {
      game_definition
      name
    }
  }
}
    `;
export const OrgSchoolInfoPanelFragmentDoc = gql`
    fragment OrgSchoolInfoPanel on espin_org_school {
  rank
  records {
    wins
    losses
    game {
      game_definition
      name
    }
  }
}
    `;
export const RankLineItemFragmentDoc = gql`
    fragment RankLineItem on espin_org_player {
  rank
  gpa
  grad_class
  game_rank
  username
  school {
    display_name
  }
}
    `;
export const RankingsCardFragmentDoc = gql`
    fragment RankingsCard on espin_org_player {
  rank
  gpa
  grad_class
  game_rank
  username
  school {
    display_name
  }
}
    `;
export const SchoolLineItemFragmentDoc = gql`
    fragment SchoolLineItem on espin_org_school {
  display_name
  city
  rank
  records {
    wins
    losses
    game {
      game_definition
      name
    }
  }
}
    `;
export const SchoolRankCardFragmentDoc = gql`
    fragment SchoolRankCard on espin_org_school {
  display_name
  city
  rank
  records {
    wins
    losses
    game {
      game_definition
      name
    }
  }
}
    `;
export const StageWrapperInfoFragmentDoc = gql`
    fragment StageWrapperInfo on espin_player_journey_stage {
  id
  order
  def
  title
  player_journey_stage_def {
    name
    display_name
  }
}
    `;
export const PlayerJourneyCardBioFragmentDoc = gql`
    fragment PlayerJourneyCardBio on espin_player_journey {
  display_name
  city
  state
}
    `;
export const PlayerProfileForJourneyFragmentDoc = gql`
    fragment PlayerProfileForJourney on espin_player_journey {
  display_name
  slug
  city
  state
  description
  game
  rank
  profile_slug
  profile_image_url
}
    `;
export const PlayerJourneyInfoCardFragmentDoc = gql`
    fragment PlayerJourneyInfoCard on espin_player_journey {
  grad_class
  game
  game_definition {
    game_name
    display_name
  }
}
    `;
export const PlayerJourneyCollegeFragmentDoc = gql`
    fragment PlayerJourneyCollege on espin_player_journey_stage_college {
  college_id
  college {
    id
    program_name
    logo {
      id
      cdn_url
      ext
      original_name
    }
  }
}
    `;
export const PlayerHighSchoolNamesFragmentDoc = gql`
    fragment PlayerHighSchoolNames on espin_high_school {
  id
  name
}
    `;
export const PlayerProfileEditingFormFragmentDoc = gql`
    fragment PlayerProfileEditingForm on espin_player_profile {
  bio
  first_name
  last_name
  spin_username
  graduating_class
  phone
  parent_email
  gpa
  address {
    city
    state
    zip
    country
  }
  social {
    discord
    tiktok
    twitter
    facebook
    instagram
    twitch_channel {
      id
      link_data
    }
    youtube_channel {
      id
      link_data
    }
  }
  gender
  ethnicity
  committed_to_college
  gender_not_listed_entry
  college_name
  college_coach_name
  college_coach_email
  hs_name
  hs_coach_name
  hs_coach_email
  user_source
  is_hs
  preferred_schools
  preferred_study_fields
  profile_image {
    ...FormFile
  }
  birthdate
  linked_high_school
  primary_games: player_games(where: {primary: {_eq: true}}) {
    game {
      name
      game_definition
    }
    in_game_username
    rank
    role
    tracker
  }
  all_games: player_games {
    id
  }
  ack_displayed
  ack_terms
  ack_waiver
}
    ${FormFileFragmentDoc}`;
export const PlayerAcademicInterestsStudyFieldsFragmentDoc = gql`
    fragment PlayerAcademicInterestsStudyFields on espin_study_field {
  name
}
    `;
export const PlayerAcademicInformationFieldsStudyFieldsFragmentDoc = gql`
    fragment PlayerAcademicInformationFieldsStudyFields on espin_study_field {
  ...PlayerAcademicInterestsStudyFields
}
    ${PlayerAcademicInterestsStudyFieldsFragmentDoc}`;
export const PlayerProfileEditingFormStudyFieldsFragmentDoc = gql`
    fragment PlayerProfileEditingFormStudyFields on espin_study_field {
  ...PlayerAcademicInformationFieldsStudyFields
}
    ${PlayerAcademicInformationFieldsStudyFieldsFragmentDoc}`;
export const PlayerAcademicInterestsStudySubjectsFragmentDoc = gql`
    fragment PlayerAcademicInterestsStudySubjects on espin_study_subject {
  name
  study_field {
    name
  }
}
    `;
export const PlayerAcademicInformationFieldsStudySubjectsFragmentDoc = gql`
    fragment PlayerAcademicInformationFieldsStudySubjects on espin_study_subject {
  ...PlayerAcademicInterestsStudySubjects
}
    ${PlayerAcademicInterestsStudySubjectsFragmentDoc}`;
export const PlayerProfileEditingFormStudySubjectsFragmentDoc = gql`
    fragment PlayerProfileEditingFormStudySubjects on espin_study_subject {
  ...PlayerAcademicInformationFieldsStudySubjects
}
    ${PlayerAcademicInformationFieldsStudySubjectsFragmentDoc}`;
export const PlayerSchoolsOfInterestCollegesFragmentDoc = gql`
    fragment PlayerSchoolsOfInterestColleges on espin_college {
  name
}
    `;
export const PlayerAcademicInformationFieldsCollegesFragmentDoc = gql`
    fragment PlayerAcademicInformationFieldsColleges on espin_college {
  ...PlayerSchoolsOfInterestColleges
}
    ${PlayerSchoolsOfInterestCollegesFragmentDoc}`;
export const PlayerProfileEditingFormCollegesFragmentDoc = gql`
    fragment PlayerProfileEditingFormColleges on espin_college {
  ...PlayerAcademicInformationFieldsColleges
}
    ${PlayerAcademicInformationFieldsCollegesFragmentDoc}`;
export const ConfirmedRegistrationForEventFragmentDoc = gql`
    fragment ConfirmedRegistrationForEvent on espin_event_ticket {
  event {
    name
    success_page
  }
  ...EventTicketCard
}
    ${EventTicketCardFragmentDoc}`;
export const PostInviteLoginFragmentDoc = gql`
    fragment PostInviteLogin on espin_college_invite {
  id
  email
}
    `;
export const PostHsInviteLoginFragmentDoc = gql`
    fragment PostHSInviteLogin on espin_high_school_invite {
  id
  email
  status
  high_school {
    id
  }
}
    `;
export const PlayerSearchFilterFragmentDoc = gql`
    fragment PlayerSearchFilter on query_root {
  espin_game_definition {
    display_name
    game_name
  }
  espin_study_field {
    ...PlayerAcademicInterestsStudyFields
  }
  espin_study_subject {
    ...PlayerAcademicInterestsStudySubjects
  }
}
    ${PlayerAcademicInterestsStudyFieldsFragmentDoc}
${PlayerAcademicInterestsStudySubjectsFragmentDoc}`;
export const SeedEventCreatedReturnFragmentDoc = gql`
    fragment SeedEventCreatedReturn on espin_event {
  id
  event_tickets {
    id
  }
}
    `;
export const SpinJobDataFragmentDoc = gql`
    fragment SpinJobData on queue_job {
  id
  name
  status
  created_at
  updated_at
  payload
  result
}
    `;
export const LoginToSpinDocument = gql`
    mutation LoginToSpin {
  insert_espin_user_one(
    object: {client_login: "now()"}
    on_conflict: {constraint: user_pkey, update_columns: [updated_at, client_login], where: {deleted_at: {_is_null: true}}}
  ) {
    ...LoginData
  }
}
    ${LoginDataFragmentDoc}`;
export const HighSchoolNotificationsDocument = gql`
    subscription HighSchoolNotifications($highSchoolId: uuid!) {
  espin_notification(
    limit: 10
    order_by: {created_at: desc}
    where: {high_school_id: {_eq: $highSchoolId}}
  ) {
    ...SpinNotificationData
  }
}
    ${SpinNotificationDataFragmentDoc}`;
export const CollegeNotificationsDocument = gql`
    subscription CollegeNotifications($collegeId: uuid!) {
  espin_notification(
    limit: 10
    order_by: {created_at: desc}
    where: {notification_type: {_neq: conversation_started}, college_id: {_eq: $collegeId}}
  ) {
    ...SpinNotificationData
  }
}
    ${SpinNotificationDataFragmentDoc}`;
export const PlayerNotificationsDocument = gql`
    subscription PlayerNotifications($playerUserId: String!) {
  espin_notification(
    limit: 10
    order_by: {created_at: desc}
    where: {notification_type: {_nin: [conversation_started, interested_in]}, player_user_id: {_eq: $playerUserId}}
  ) {
    ...SpinNotificationData
  }
}
    ${SpinNotificationDataFragmentDoc}`;
export const ParentNotificationsDocument = gql`
    subscription ParentNotifications($playerUserIds: [String!]!) {
  espin_notification(
    limit: 10
    order_by: {created_at: desc}
    where: {player_user_id: {_in: $playerUserIds}}
  ) {
    ...SpinNotificationData
  }
}
    ${SpinNotificationDataFragmentDoc}`;
export const RefreshOnSocialDocument = gql`
    mutation RefreshOnSocial {
  delete_espin_force_notification_reload(where: {id: {_is_null: true}}) {
    affected_rows
  }
}
    `;
export const CollegeUserEditProfileFormDocument = gql`
    query CollegeUserEditProfileForm($id: String!) {
  espin_user_by_pk(id: $id) {
    college_profile {
      id
      first_name
      last_name
      college {
        id
        logo {
          ...FormFile
        }
        college_games {
          game {
            game_definition
            name
          }
        }
        min_gpa
        min_act
        min_sat
        academic_notes
        scholarships
        in_state_tuition
        out_of_state_tuition
        header_media_link {
          id
          link_data
          link_type
        }
        college_images {
          ...CollegeImageHandler
        }
        socials {
          id
          website
          twitter
          facebook
          instagram
          discord
          twitch_channel {
            id
            link_data
          }
          youtube_channel {
            id
            link_data
          }
        }
        contact_email
        name
        program_name
        varsity
        phone
        address {
          id
          state
          zip
          city
          country
        }
        bio
      }
    }
  }
}
    ${FormFileFragmentDoc}
${CollegeImageHandlerFragmentDoc}`;
export const SetCollegeOwnerDocument = gql`
    mutation SetCollegeOwner($owner_profile_id: uuid = "", $id: uuid = "") {
  update_espin_college_by_pk(
    pk_columns: {id: $id}
    _set: {owner_profile_id: $owner_profile_id}
  ) {
    id
  }
}
    `;
export const UpsertCollegeProfileDocument = gql`
    mutation UpsertCollegeProfile($collegeId: uuid = "00000000-0000-0000-0000-000000000000", $input: espin_college_profile_insert_input!, $onConflict: espin_college_profile_on_conflict!) {
  delete_espin_college_game(where: {college_id: {_eq: $collegeId}}) {
    affected_rows
  }
  insert_espin_college_profile_one(object: $input, on_conflict: $onConflict) {
    id
    college {
      id
    }
  }
}
    `;
export const ParentFollowsDocument = gql`
    mutation ParentFollows($input: [espin_follow_insert_input!]!) {
  insert_espin_follow(objects: $input) {
    returning {
      id
    }
  }
}
    `;
export const ParentUnfollowsDocument = gql`
    mutation ParentUnfollows($playerUserId: [String!]!, $collegeId: uuid!) {
  delete_espin_follow(
    where: {player_user_id: {_in: $playerUserId}, college_id: {_eq: $collegeId}}
  ) {
    returning {
      id
    }
  }
}
    `;
export const FollowDocument = gql`
    mutation Follow($input: espin_follow_insert_input!) {
  insert_espin_follow_one(object: $input) {
    id
  }
}
    `;
export const UnfollowDocument = gql`
    mutation Unfollow($where: espin_follow_bool_exp!) {
  delete_espin_follow(where: $where) {
    returning {
      id
    }
  }
}
    `;
export const CheckFollowingStatusDocument = gql`
    query CheckFollowingStatus($where: espin_follow_bool_exp!) {
  espin_follow(where: $where) {
    id
  }
}
    `;
export const ReferralOptionPopupContentDocument = gql`
    query ReferralOptionPopupContent {
  espin_referral_option(order_by: {sort_order: asc}) {
    ...ReferralOption
  }
}
    ${ReferralOptionFragmentDoc}`;
export const AddPlayerGameFromPopupDocument = gql`
    mutation AddPlayerGameFromPopup($input: espin_player_game_insert_input!) {
  insert_espin_player_game_one(object: $input) {
    id
  }
}
    `;
export const AddPlayerGameAndUpdatePrimaryFromPopupDocument = gql`
    mutation AddPlayerGameAndUpdatePrimaryFromPopup($input: espin_player_game_insert_input!, $id: uuid!) {
  update_espin_player_game_by_pk(_set: {primary: false}, pk_columns: {id: $id}) {
    id
  }
  insert_espin_player_game_one(object: $input) {
    id
  }
}
    `;
export const SendMassPlayerMessageActionDocument = gql`
    mutation SendMassPlayerMessageAction($input: SendMassPlayerMessageInput!) {
  sendMassPlayerMessage(input: $input) {
    messages_sent
  }
}
    `;
export const UpdatePlayerGameDocument = gql`
    mutation UpdatePlayerGame($input: espin_player_game_set_input!, $id: uuid!, $primaryGameId: uuid!) {
  updatePrimary: update_espin_player_game_by_pk(
    _set: {primary: false}
    pk_columns: {id: $primaryGameId}
  ) {
    id
  }
  update_espin_player_game_by_pk(_set: $input, pk_columns: {id: $id}) {
    id
  }
}
    `;
export const FindCollegesSearchDocument = gql`
    query FindCollegesSearch($subbedSearch: espin_college_bool_exp!, $unsubbedSearch: espin_college_bool_exp!) {
  unsubbedColleges: espin_college(
    where: $unsubbedSearch
    order_by: {name: asc}
    limit: 4
  ) {
    ...FindCollegesResults
  }
  subbedColleges: espin_college(
    where: $subbedSearch
    order_by: {name: asc}
    limit: 4
  ) {
    ...FindCollegesResults
  }
}
    ${FindCollegesResultsFragmentDoc}`;
export const FindPlayersFormDocument = gql`
    query FindPlayersForm {
  espin_study_field {
    ...PlayerProfileEditingFormStudyFields
  }
  espin_study_subject {
    ...PlayerProfileEditingFormStudySubjects
  }
}
    ${PlayerProfileEditingFormStudyFieldsFragmentDoc}
${PlayerProfileEditingFormStudySubjectsFragmentDoc}`;
export const FindPlayersSearchDocument = gql`
    query FindPlayersSearch($search: espin_player_profile_bool_exp!) {
  espin_player_profile(
    where: $search
    order_by: [{spin_username: asc}, {user: {subscription_status: {is_subscribed: desc}}}]
    limit: 4
  ) {
    ...FindPlayersResults
  }
}
    ${FindPlayersResultsFragmentDoc}`;
export const InvitePlayersToHighSchoolTeamDocument = gql`
    mutation InvitePlayersToHighSchoolTeam($input: InvitePlayersToTeamActionInput!) {
  invitePlayersToTeamAction(input: $input) {
    notFound
    alreadyInvited
    status
  }
}
    `;
export const PlayerInviteOptionsDocument = gql`
    query PlayerInviteOptions {
  espin_player_profile(order_by: [{spin_username: asc}]) {
    id
    spin_username
    user_id
  }
}
    `;
export const CreateHighSchoolTeamActionDocument = gql`
    mutation CreateHighSchoolTeamAction($input: CreateHighSchoolTeamInput!) {
  createHighSchoolTeam(input: $input) {
    id
    notFound
    status
    comments
  }
}
    `;
export const EditHighSchoolTeamActionDocument = gql`
    mutation EditHighSchoolTeamAction($input: EditHighSchoolTeamInput!) {
  editHighSchoolTeam(input: $input) {
    id
    notFound
    status
    comments
  }
}
    `;
export const CreatePlayerTeamActionDocument = gql`
    mutation CreatePlayerTeamAction($input: CreatePlayerTeamInput!) {
  createPlayerTeam(input: $input) {
    id
    notFound
    status
    comments
  }
}
    `;
export const EditPlayerTeamActionDocument = gql`
    mutation EditPlayerTeamAction($input: EditPlayerTeamInput!) {
  editPlayerTeam(input: $input) {
    id
    notFound
    status
    comments
  }
}
    `;
export const PlayerDeleteTeamInviteByIdDocument = gql`
    mutation PlayerDeleteTeamInviteById($inviteId: uuid!) {
  delete_espin_team_invite_by_pk(id: $inviteId) {
    id
  }
}
    `;
export const PlayerAcceptTeamInviteByIdDocument = gql`
    mutation PlayerAcceptTeamInviteById($player_profile_id: uuid!, $inviteId: uuid!, $teamId: uuid!) {
  insert_espin_team_members_one(
    object: {player_profile_id: $player_profile_id, team_id: $teamId}
  ) {
    id
  }
  update_espin_team_invite_by_pk(
    pk_columns: {id: $inviteId}
    _set: {status: accepted}
  ) {
    id
  }
}
    `;
export const UpdatePlayerHsOnTeamInviteDocument = gql`
    mutation UpdatePlayerHSOnTeamInvite($player_profile_id: uuid!, $hsId: uuid!) {
  update_espin_player_profile(
    where: {id: {_eq: $player_profile_id}}
    _set: {hs_name: "", linked_high_school: $hsId}
  ) {
    returning {
      id
    }
  }
}
    `;
export const UnreadCollegeMessagesDocument = gql`
    query UnreadCollegeMessages($collegeId: uuid) {
  espin_message(
    where: {_and: {college_id: {_eq: $collegeId}, viewed_at: {_is_null: true}, message_type: {_eq: player_messages_college}}}
    order_by: {created_at: asc}
  ) {
    id
  }
}
    `;
export const UnreadPlayerMessagesDocument = gql`
    query UnreadPlayerMessages($playerUserId: String) {
  espin_message(
    where: {_and: {player_user_id: {_eq: $playerUserId}, viewed_at: {_is_null: true}, message_type: {_eq: college_messages_player}}}
    order_by: {created_at: asc}
  ) {
    id
  }
}
    `;
export const UnreadParentMessagesDocument = gql`
    query UnreadParentMessages($playerUserIds: [String!]) {
  espin_message(
    where: {_and: {player_user_id: {_in: $playerUserIds}, viewed_at: {_is_null: true}, message_type: {_eq: college_messages_player}}}
    order_by: {created_at: asc}
  ) {
    id
  }
}
    `;
export const CollegePasswordResetEmailDocument = gql`
    mutation CollegePasswordResetEmail {
  generatePasswordResetEmail {
    status
  }
}
    `;
export const HighSchoolPasswordResetEmailDocument = gql`
    mutation HighSchoolPasswordResetEmail {
  generatePasswordResetEmail {
    status
  }
}
    `;
export const ParentPasswordResetEmailDocument = gql`
    mutation ParentPasswordResetEmail {
  generatePasswordResetEmail {
    status
  }
}
    `;
export const PlayerPasswordResetEmailDocument = gql`
    mutation PlayerPasswordResetEmail {
  generatePasswordResetEmail {
    status
  }
}
    `;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: String!) {
  update_espin_user_by_pk(pk_columns: {id: $id}, _set: {deleted_at: "now()"}) {
    id
  }
}
    `;
export const ClearCollegeInviteDocument = gql`
    mutation ClearCollegeInvite($id: uuid!, $email: String!) {
  delete_espin_college_invite_by_pk(id: $id) {
    id
  }
  delete_espin_college_profile(where: {user: {email: {_eq: $email}}}) {
    affected_rows
  }
}
    `;
export const ClearHighSchoolInviteDocument = gql`
    mutation ClearHighSchoolInvite($id: uuid!, $email: String!) {
  delete_espin_high_school_invite_by_pk(id: $id) {
    id
  }
  delete_espin_high_school_profile(where: {user: {email: {_eq: $email}}}) {
    affected_rows
  }
}
    `;
export const InviteHighSchoolUsersActionDocument = gql`
    mutation InviteHighSchoolUsersAction($input: InviteHighSchoolColleagueActionInput!) {
  inviteHighSchoolColleague(input: $input) {
    message
    status
  }
}
    `;
export const InviteCollegeUsersDocument = gql`
    mutation InviteCollegeUsers($input: [espin_college_invite_insert_input!]!) {
  insert_espin_college_invite(
    objects: $input
    on_conflict: {constraint: college_invite_email_college_id_key, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export const UpdateCollegePreferencesDocument = gql`
    mutation UpdateCollegePreferences($input: espin_college_preferences_insert_input!, $onConflict: espin_college_preferences_on_conflict!) {
  insert_espin_college_preferences_one(object: $input, on_conflict: $onConflict) {
    id
  }
}
    `;
export const UpdateEmailNotificationPreferencesDocument = gql`
    mutation UpdateEmailNotificationPreferences($update: espin_user_set_input!, $userId: String!) {
  update_espin_user_by_pk(pk_columns: {id: $userId}, _set: $update) {
    id
  }
}
    `;
export const GetFollowersForCollegesDocument = gql`
    query GetFollowersForColleges($collegeId: uuid!, $date: timestamptz!) {
  my_follows: espin_follow(
    where: {college_id: {_eq: $collegeId}, follow_type: {_in: [college_follows_player, college_follows_high_school]}}
  ) {
    high_school_id
    player_user_id
  }
  espin_follow(
    where: {college_id: {_eq: $collegeId}, follow_type: {_eq: player_follows_college}, player_user: {deleted_at: {_is_null: true}}}
  ) {
    ...CollegeFollowCard
  }
  espin_follow_aggregate(
    where: {college_id: {_eq: $collegeId}, follow_type: {_in: [player_follows_college, high_school_follows_college]}, created_at: {_gt: $date}}
  ) {
    aggregate {
      count
    }
  }
  high_school_follows: espin_follow(
    where: {college_id: {_eq: $collegeId}, follow_type: {_eq: high_school_follows_college}}
  ) {
    ...CollegeFollowCard
  }
  espin_graduating_class {
    grad_class_years
  }
}
    ${CollegeFollowCardFragmentDoc}`;
export const GetFollowersForHighSchoolsDocument = gql`
    query GetFollowersForHighSchools($highSchoolId: uuid!, $date: timestamptz!) {
  following: espin_follow(
    where: {high_school_id: {_eq: $highSchoolId}, follow_type: {_eq: high_school_follows_college}}
  ) {
    college_id
  }
  espin_follow(
    where: {high_school_id: {_eq: $highSchoolId}, follow_type: {_eq: college_follows_high_school}, college_user: {deleted_at: {_is_null: true}}}
  ) {
    ...HighSchoolFollowCard
  }
  espin_follow_aggregate(
    where: {high_school_id: {_eq: $highSchoolId}, follow_type: {_eq: college_follows_high_school}, created_at: {_gt: $date}, college_user: {deleted_at: {_is_null: true}}}
  ) {
    aggregate {
      count
    }
  }
}
    ${HighSchoolFollowCardFragmentDoc}`;
export const FollowCollegeDocument = gql`
    mutation FollowCollege($collegeId: uuid!) {
  insert_espin_follow_one(object: {college_id: $collegeId}) {
    id
  }
}
    `;
export const UnfollowCollegeDocument = gql`
    mutation UnfollowCollege($playerUserId: String, $collegeId: uuid!) {
  delete_espin_follow(
    where: {player_user_id: {_eq: $playerUserId}, follow_type: {_eq: player_follows_college}, college_id: {_eq: $collegeId}}
  ) {
    returning {
      id
    }
  }
}
    `;
export const FollowerCollegesForPlayersDocument = gql`
    query FollowerCollegesForPlayers($closeSearch: espin_college_bool_exp!, $farSearch: espin_college_bool_exp!, $playerUserId: String!, $date: timestamptz!) {
  following: espin_follow(
    where: {player_user_id: {_eq: $playerUserId}, follow_type: {_eq: player_follows_college}}
  ) {
    college_id
  }
  close_follow: espin_follow(
    where: {college: $closeSearch, player_user_id: {_eq: $playerUserId}, follow_type: {_eq: college_follows_player}}
  ) {
    ...PlayerFollowers
  }
  close_aggregate: espin_follow_aggregate(
    where: {college: $closeSearch, player_user_id: {_eq: $playerUserId}, follow_type: {_eq: college_follows_player}, created_at: {_gt: $date}}
  ) {
    aggregate {
      count
    }
  }
  far_follow: espin_follow(
    where: {college: $farSearch, player_user_id: {_eq: $playerUserId}, follow_type: {_eq: college_follows_player}}
  ) {
    ...PlayerFollowers
  }
  far_aggregate: espin_follow_aggregate(
    where: {college: $farSearch, player_user_id: {_eq: $playerUserId}, follow_type: {_eq: college_follows_player}, created_at: {_gt: $date}}
  ) {
    aggregate {
      count
    }
  }
}
    ${PlayerFollowersFragmentDoc}`;
export const GetFollowingPlayersForCollegesDocument = gql`
    query GetFollowingPlayersForColleges($collegeId: uuid!) {
  espin_follow(
    where: {follow_type: {_eq: college_follows_player}, college_id: {_eq: $collegeId}, player_user: {deleted_at: {_is_null: true}}}
  ) {
    ...CollegeFollowCard
  }
  high_school_following: espin_follow(
    where: {college_id: {_eq: $collegeId}, follow_type: {_eq: college_follows_high_school}}
  ) {
    ...CollegeFollowCard
  }
  espin_graduating_class {
    grad_class_years
  }
}
    ${CollegeFollowCardFragmentDoc}`;
export const GetFollowingCollegesForHighSchoolDocument = gql`
    query GetFollowingCollegesForHighSchool($highSchoolId: uuid!) {
  espin_follow(
    where: {follow_type: {_eq: high_school_follows_college}, high_school_id: {_eq: $highSchoolId}}
  ) {
    ...HighSchoolFollowCard
  }
}
    ${HighSchoolFollowCardFragmentDoc}`;
export const GetChildProfilesDocument = gql`
    query GetChildProfiles($id: String!) {
  espin_parent_profile(where: {user_id: {_eq: $id}}) {
    ...ChildData
  }
}
    ${ChildDataFragmentDoc}`;
export const FollowingCollegesForPlayersDocument = gql`
    query FollowingCollegesForPlayers($closeSearch: espin_college_bool_exp!, $farSearch: espin_college_bool_exp!) {
  all_follows: espin_follow(where: {follow_type: {_eq: player_follows_college}}) {
    ...PlayerFollowing
  }
  close_colleges: espin_follow(
    where: {college: $closeSearch, follow_type: {_eq: player_follows_college}}
  ) {
    ...PlayerFollowing
  }
  far_colleges: espin_follow(
    where: {college: $farSearch, follow_type: {_eq: player_follows_college}}
  ) {
    ...PlayerFollowing
  }
}
    ${PlayerFollowingFragmentDoc}`;
export const MarkAllAsReadDocument = gql`
    mutation MarkAllAsRead($_in: [uuid!] = "") {
  update_espin_notification(
    where: {_and: {id: {_in: $_in}, viewed_at: {_is_null: true}}}
    _set: {viewed_at: "now()"}
  ) {
    affected_rows
  }
}
    `;
export const CreateMessageDocument = gql`
    mutation CreateMessage($input: espin_message_insert_input!) {
  insert_espin_message_one(
    object: $input
    on_conflict: {constraint: message_pkey, update_columns: []}
  ) {
    id
  }
}
    `;
export const HighSchoolMyEventsDocument = gql`
    query HighSchoolMyEvents($highSchoolId: uuid!) {
  espin_team {
    ...HighSchoolTeamEventRegistrationsCard
  }
}
    ${HighSchoolTeamEventRegistrationsCardFragmentDoc}`;
export const ParentMyEventsDocument = gql`
    query ParentMyEvents($id: String!, $primaryGames: [espin_game_definition_enum!]!, $hasPrimaries: Boolean!) {
  espin_user_by_pk(id: $id) {
    parent_profile {
      child_profiles(where: {user: {deleted_at: {_is_null: true}}}) {
        ...MyEventsCardPlayer
      }
    }
  }
  admin_recommended_events: espin_event(
    limit: 2
    order_by: {event_start_date: asc}
    where: {admin_recommended: {_eq: true}, status: {_eq: published}, event_end_date: {_gte: "now()"}}
  ) {
    ...MyUpcomingEvents
  }
  recommended_events: espin_event(
    limit: 2
    order_by: {event_start_date: asc}
    where: {event_end_date: {_gte: "now()"}, status: {_eq: published}, event_games: {game: {game_definition: {_in: $primaryGames}}}}
  ) @include(if: $hasPrimaries) {
    ...MyUpcomingEvents
  }
  any_events: espin_event(
    limit: 2
    order_by: {event_start_date: asc}
    where: {event_end_date: {_gte: "now()"}, status: {_eq: published}}
  ) @skip(if: $hasPrimaries) {
    ...MyUpcomingEvents
  }
  registered_events: espin_event(
    order_by: {event_start_date: asc}
    where: {event_end_date: {_gte: "now()"}, status: {_eq: published}, event_registrations: {_or: [{user: {player_profile: {parent_profile: {user_id: {_eq: $id}}}}}, {team: {members: {player_profile: {parent_profile: {user_id: {_eq: $id}}}}}}]}}
  ) {
    ...MyEventsCard
  }
}
    ${MyEventsCardPlayerFragmentDoc}
${MyUpcomingEventsFragmentDoc}
${MyEventsCardFragmentDoc}`;
export const PlayerMyEventsDocument = gql`
    query PlayerMyEvents($id: String!, $playerPrimaryGame: espin_game_definition_enum, $hasPrimary: Boolean!) {
  admin_recommended_events: espin_event(
    limit: 2
    order_by: {event_start_date: asc}
    where: {admin_recommended: {_eq: true}, status: {_eq: published}, event_end_date: {_gte: "now()"}}
  ) {
    ...MyUpcomingEvents
  }
  recommended_events: espin_event(
    limit: 2
    order_by: {event_start_date: asc}
    where: {event_end_date: {_gte: "now()"}, status: {_eq: published}, event_games: {game: {game_definition: {_eq: $playerPrimaryGame}}}}
  ) @include(if: $hasPrimary) {
    ...MyUpcomingEvents
  }
  any_events: espin_event(
    limit: 2
    order_by: {event_start_date: asc}
    where: {event_end_date: {_gte: "now()"}, status: {_eq: published}}
  ) @skip(if: $hasPrimary) {
    ...MyUpcomingEvents
  }
  registered_events: espin_event(
    order_by: {event_start_date: asc}
    where: {event_end_date: {_gte: "now()"}, status: {_eq: published}, event_registrations: {_or: [{user_id: {_eq: $id}}, {team: {members: {player_profile: {user_id: {_eq: $id}}}}}]}}
  ) {
    ...MyEventsCard
  }
}
    ${MyUpcomingEventsFragmentDoc}
${MyEventsCardFragmentDoc}`;
export const ParentMyGamesDocument = gql`
    query ParentMyGames($id: String!) {
  espin_user_by_pk(id: $id) {
    parent_profile {
      child_profiles(where: {user: {deleted_at: {_is_null: true}}}) {
        spin_username
        profile_image {
          ...SpinContentImageDisplay
        }
        player_games(order_by: {primary: desc}) {
          ...EditableGame
        }
      }
    }
  }
}
    ${SpinContentImageDisplayFragmentDoc}
${EditableGameFragmentDoc}`;
export const PlayerMyGamesDocument = gql`
    query PlayerMyGames($id: String!) {
  espin_user_by_pk(id: $id) {
    player_profile {
      player_games(order_by: {primary: desc}) {
        ...EditableGame
      }
    }
  }
}
    ${EditableGameFragmentDoc}`;
export const DeleteMyPlayerGameDocument = gql`
    mutation DeleteMyPlayerGame($id: uuid!) {
  delete_espin_player_game_by_pk(id: $id) {
    id
  }
}
    `;
export const DeleteMyPlayerGameAndChangePrimaryGameDocument = gql`
    mutation DeleteMyPlayerGameAndChangePrimaryGame($id: uuid!, $newPrimaryId: uuid!) {
  delete_espin_player_game_by_pk(id: $id) {
    id
  }
  update_espin_player_game(
    where: {id: {_eq: $newPrimaryId}}
    _set: {primary: true}
  ) {
    affected_rows
  }
}
    `;
export const CollegeMyProfileDocument = gql`
    query CollegeMyProfile($id: uuid!) {
  espin_college_by_pk(id: $id) {
    ...CollegeProfile
  }
}
    ${CollegeProfileFragmentDoc}`;
export const HighSchoolMyProfileDocument = gql`
    query HighSchoolMyProfile($id: uuid!) {
  espin_high_school_by_pk(id: $id) {
    ...HighSchoolProfile
  }
}
    ${HighSchoolProfileFragmentDoc}`;
export const PlayerMyProfileDocument = gql`
    query PlayerMyProfile($id: uuid!) {
  espin_player_profile_by_pk(id: $id) {
    ...PlayerProfile
  }
}
    ${PlayerProfileFragmentDoc}`;
export const DeleteHighSchoolTeamInvitesDocument = gql`
    mutation DeleteHighSchoolTeamInvites($inviteIds: [uuid!]!) {
  delete_espin_team_invite(where: {id: {_in: $inviteIds}}) {
    affected_rows
  }
}
    `;
export const DeleteHighSchoolTeamMembersDocument = gql`
    mutation DeleteHighSchoolTeamMembers($memberIds: [uuid!]!) {
  delete_espin_team_members(where: {id: {_in: $memberIds}}) {
    __typename
    affected_rows
  }
}
    `;
export const HighSchoolMyPlayersPageDocument = gql`
    query HighSchoolMyPlayersPage($highSchoolId: uuid!) {
  espin_team(
    where: {team_type: {_eq: school}, high_school_id: {_eq: $highSchoolId}, deleted_at: {_is_null: true}}
  ) {
    members {
      ...UniqueTeamMember
    }
  }
}
    ${UniqueTeamMemberFragmentDoc}`;
export const HighSchoolMyTeamsPageDocument = gql`
    query HighSchoolMyTeamsPage($highSchoolId: uuid!) {
  espin_team(
    where: {team_type: {_eq: school}, high_school_id: {_eq: $highSchoolId}, deleted_at: {_is_null: true}}
  ) {
    ...HighSchoolTeamCard
  }
}
    ${HighSchoolTeamCardFragmentDoc}`;
export const DeleteHighSchoolTeamDocument = gql`
    mutation DeleteHighSchoolTeam($teamId: uuid!) {
  delete_espin_event_registration(where: {team_id: {_eq: $teamId}}) {
    returning {
      event {
        id
        name
      }
      event_ticket {
        id
        price_temp
        price_id
      }
    }
  }
  delete_espin_team_invite(where: {team_id: {_eq: $teamId}}) {
    returning {
      id
    }
  }
  update_espin_team_by_pk(pk_columns: {id: $teamId}, _set: {deleted_at: "now()"}) {
    id
  }
  delete_espin_team_invite(where: {team_id: {_eq: $teamId}}) {
    affected_rows
  }
}
    `;
export const ParentMyPlayersProfilesDocument = gql`
    query ParentMyPlayersProfiles($id: uuid!) {
  espin_parent_profile_by_pk(id: $id) {
    child_profiles(where: {user: {deleted_at: {_is_null: true}}}) {
      ...MyPlayerCard
    }
  }
}
    ${MyPlayerCardFragmentDoc}`;
export const ParentMyProfileDocument = gql`
    query ParentMyProfile($id: uuid!) {
  espin_parent_profile_by_pk(id: $id) {
    ...ParentProfileForm
  }
}
    ${ParentProfileFormFragmentDoc}`;
export const UpdateParentProfileFormDocument = gql`
    mutation UpdateParentProfileForm($id: uuid!, $input: espin_parent_profile_set_input!) {
  update_espin_parent_profile_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export const RemoveChildProfileParentProfileFormDocument = gql`
    mutation RemoveChildProfileParentProfileForm($playerProfileId: uuid!) {
  removeChildPlayer(playerProfileId: $playerProfileId) {
    valid
  }
}
    `;
export const PlayerMyTeamsPageDocument = gql`
    query PlayerMyTeamsPage($user_id: String!) {
  espin_team_invite(
    where: {status: {_eq: pending}, team: {deleted_at: {_is_null: true}}, user_id: {_eq: $user_id}}
  ) {
    ...PlayerMyTeamsInvite
  }
  espin_team(
    where: {members: {player_profile: {user_id: {_eq: $user_id}}}, deleted_at: {_is_null: true}}
  ) {
    ...PlayerMyTeamsTeam
  }
  espin_player_profile(where: {user_id: {_eq: $user_id}}) {
    id
    linked_high_school
    hs_name
  }
}
    ${PlayerMyTeamsInviteFragmentDoc}
${PlayerMyTeamsTeamFragmentDoc}`;
export const AddPlayerVodDocument = gql`
    mutation AddPlayerVod($input: espin_player_vod_insert_input!) {
  insert_espin_player_vod_one(object: $input) {
    id
  }
}
    `;
export const PlayerVodsPageDocument = gql`
    query PlayerVodsPage($userId: String!) {
  espin_user_by_pk(id: $userId) {
    player_profile {
      bio
      first_name
      last_name
      spin_username
      slug
      player_vods {
        ...ProfileVODDisplayComponent
      }
    }
  }
  content_media_link_type {
    comment
    name
  }
}
    ${ProfileVodDisplayComponentFragmentDoc}`;
export const DeletePlayerVodDocument = gql`
    mutation DeletePlayerVod($id: uuid!) {
  update_espin_player_vod_by_pk(
    _set: {deleted_at: "now()"}
    pk_columns: {id: $id}
  ) {
    id
  }
}
    `;
export const GetAllProfileViewDataForCollegesDocument = gql`
    query GetAllProfileViewDataForColleges($id: uuid!, $vt: [espin_profile_view_type_enum!], $date: timestamptz) {
  espin_follow(
    where: {college_id: {_eq: $id}, follow_type: {_in: [college_follows_player, college_follows_high_school]}}
  ) {
    player_user_id
    high_school_id
  }
  espin_profile_view(
    where: {college_id: {_eq: $id}, profile_view_type: {_in: $vt}}
    order_by: {created_at: desc}
  ) {
    id
    ...ProfileViews
  }
  espin_profile_view_aggregate(
    where: {college_id: {_eq: $id}, profile_view_type: {_in: $vt}, created_at: {_gt: $date}}
  ) {
    aggregate {
      count
    }
  }
}
    ${ProfileViewsFragmentDoc}`;
export const GetAllProfileViewDataForHighSchoolsDocument = gql`
    query GetAllProfileViewDataForHighSchools($id: uuid!, $vt: [espin_profile_view_type_enum!], $date: timestamptz) {
  espin_follow(
    where: {high_school_id: {_eq: $id}, follow_type: {_eq: high_school_follows_college}}
  ) {
    college_id
  }
  espin_profile_view(
    where: {high_school_id: {_eq: $id}, profile_view_type: {_in: $vt}}
    order_by: {created_at: desc}
  ) {
    id
    ...ProfileViews
  }
  espin_profile_view_aggregate(
    where: {high_school_id: {_eq: $id}, profile_view_type: {_in: $vt}, created_at: {_gt: $date}}
  ) {
    aggregate {
      count
    }
  }
}
    ${ProfileViewsFragmentDoc}`;
export const GetAllProfileViewDataForPlayersDocument = gql`
    query GetAllProfileViewDataForPlayers($userId: String, $date: timestamptz) {
  espin_follow(
    where: {player_user_id: {_eq: $userId}, follow_type: {_eq: player_follows_college}}
  ) {
    college_id
  }
  espin_profile_view(
    where: {player_user_id: {_eq: $userId}, profile_view_type: {_eq: college_views_player}}
    order_by: {created_at: desc}
  ) {
    ...ProfileViews
  }
  espin_profile_view_aggregate(
    where: {player_user_id: {_eq: $userId}, profile_view_type: {_eq: college_views_player}, created_at: {_gt: $date}}
  ) {
    aggregate {
      count
    }
  }
}
    ${ProfileViewsFragmentDoc}`;
export const CreateCollegeReferralCodeRedemptionDocument = gql`
    mutation CreateCollegeReferralCodeRedemption($input: RedeemCollegeReferralCodeInsertInput!) {
  redeemCollegeReferralCode(input: $input) {
    codeId
  }
}
    `;
export const CreatePlayerReferralCodeRedemptionDocument = gql`
    mutation CreatePlayerReferralCodeRedemption($input: RedeemPlayerReferralCodeInsertInput!) {
  redeemPlayerReferralCode(input: $input) {
    codeId
  }
}
    `;
export const PlayerSubscriptionsDocument = gql`
    query PlayerSubscriptions {
  espin_boolean_feature_flag(where: {name: {_eq: "players_set_as_subscribed"}}) {
    value
  }
  espin_referral_option {
    id
  }
}
    `;
export const CreateEventTicketRegistrationDocument = gql`
    mutation CreateEventTicketRegistration($input: espin_event_registration_insert_input!) {
  insert_espin_event_registration_one(object: $input) {
    id
  }
}
    `;
export const CreateEventTicketPaymentIntentDocument = gql`
    mutation CreateEventTicketPaymentIntent($registrationId: uuid!) {
  createEventTicketPaymentIntent(input: {eventRegistrationId: $registrationId}) {
    paymentSecret
  }
}
    `;
export const NewsletterRequestDocument = gql`
    mutation NewsletterRequest($input: espin_newsletter_request_insert_input!) {
  insert_espin_newsletter_request_one(object: $input) {
    id
  }
}
    `;
export const GamesSelectComponentDocument = gql`
    query GamesSelectComponent {
  espin_game {
    game_definition
    name
    image_url
    team_max_size
    website
  }
}
    `;
export const PlayerTeamSelectComponentDocument = gql`
    query PlayerTeamSelectComponent($userId: String!, $game: String!) {
  espin_team(
    where: {_and: {primary_game: {_eq: $game}, deleted_at: {_is_null: true}, members: {_and: {player_profile: {user: {id: {_eq: $userId}}}}, team_role: {_eq: captain}}, team_type: {_eq: pick_up}}}
  ) {
    id
    display_name
  }
}
    `;
export const TeamSelectComponentDocument = gql`
    query TeamSelectComponent($highSchoolId: uuid!, $game: String!) {
  espin_team(
    where: {_and: {high_school_id: {_eq: $highSchoolId}, primary_game: {_eq: $game}, deleted_at: {_is_null: true}}}
  ) {
    id
    display_name
  }
}
    `;
export const CreateUploadUrlDocument = gql`
    mutation CreateUploadUrl($input: FileUploadUrlRequestInput!) {
  createFileUploadUrl(input: $input) {
    id
    key
    uploadUrl
  }
}
    `;
export const ConfirmFileUploadDocument = gql`
    mutation ConfirmFileUpload($id: uuid!) {
  update_content_file_by_pk(pk_columns: {id: $id}, _set: {status: ready}) {
    ...FormFile
  }
}
    ${FormFileFragmentDoc}`;
export const HighSchoolUserEditProfileFormDocument = gql`
    query HighSchoolUserEditProfileForm($id: String!) {
  espin_user_by_pk(id: $id) {
    high_school_profile {
      id
      first_name
      last_name
      high_school {
        id
        name
        bio
        socials {
          id
          website
          twitter
          facebook
          instagram
          discord
          twitch_channel {
            id
            link_data
          }
          youtube_channel {
            id
            link_data
          }
        }
        contact_email
        contact_name
        contact_phone
        profile_pic_file {
          ...FormFile
        }
        address {
          id
          state
          zip
          city
          country
        }
      }
    }
  }
}
    ${FormFileFragmentDoc}`;
export const UpsertHighSchoolProfileDocument = gql`
    mutation UpsertHighSchoolProfile($input: espin_high_school_profile_insert_input!, $onConflict: espin_high_school_profile_on_conflict!) {
  insert_espin_high_school_profile_one(object: $input, on_conflict: $onConflict) {
    id
    high_school {
      id
    }
  }
}
    `;
export const SetHighSchoolOwnerDocument = gql`
    mutation SetHighSchoolOwner($owner_profile_id: uuid = "", $id: uuid = "") {
  update_espin_high_school_by_pk(
    pk_columns: {id: $id}
    _set: {owner_profile_id: $owner_profile_id}
  ) {
    id
  }
}
    `;
export const UpsertParentProfileDocument = gql`
    mutation UpsertParentProfile($input: espin_parent_profile_insert_input!, $onConflict: espin_parent_profile_on_conflict!) {
  insert_espin_parent_profile_one(object: $input, on_conflict: $onConflict) {
    id
  }
}
    `;
export const FollowPlayerDocument = gql`
    mutation FollowPlayer($collegeId: uuid!, $playerUserId: String!, $collegeName: String!) {
  insert_espin_follow_one(
    object: {college_id: $collegeId, player_user_id: $playerUserId, college_user_name: $collegeName, follow_type: college_follows_player}
  ) {
    id
  }
}
    `;
export const UnfollowPlayerDocument = gql`
    mutation UnfollowPlayer($playerUserId: String, $collegeId: uuid!) {
  delete_espin_follow(
    where: {player_user_id: {_eq: $playerUserId}, college_id: {_eq: $collegeId}, follow_type: {_eq: college_follows_player}}
  ) {
    returning {
      id
    }
  }
}
    `;
export const CheckFollowingStatusForCollegesDocument = gql`
    query CheckFollowingStatusForColleges($playerUserId: String!, $collegeId: uuid!) {
  espin_follow(
    where: {player_user_id: {_eq: $playerUserId}, college_id: {_eq: $collegeId}, follow_type: {_eq: college_follows_player}}
  ) {
    id
  }
}
    `;
export const GetAllVerifiedHighSchoolsDocument = gql`
    query GetAllVerifiedHighSchools {
  GetAllVerifiedHighSchoolNames {
    highSchoolData {
      highSchools {
        id
        name
      }
    }
  }
}
    `;
export const PlayerProfileUpdateDocument = gql`
    mutation PlayerProfileUpdate($input: SubmitPlayerProfileUpdateEspinDraftPlayerProfileInsertInput!) {
  SubmitPlayerProfileUpdate(input: $input) {
    id
    status
    comments
  }
}
    `;
export const EditProfilePageDocument = gql`
    query EditProfilePage($userId: String!) {
  espin_user_by_pk(id: $userId) {
    player_profile {
      ...PlayerProfileEditingForm
    }
  }
  espin_gender_options {
    display_name
    name
  }
  espin_ethnicity_options {
    display_name
    name
  }
  espin_user_source(where: {deleted_at: {_is_null: true}}) {
    id
    name
  }
  espin_study_field {
    ...PlayerProfileEditingFormStudyFields
  }
  espin_study_subject {
    ...PlayerProfileEditingFormStudySubjects
  }
  espin_college(
    where: {_and: {verified: {_eq: true}, slug: {_is_null: false}}}
    order_by: {name: asc}
  ) {
    ...PlayerProfileEditingFormColleges
  }
}
    ${PlayerProfileEditingFormFragmentDoc}
${PlayerProfileEditingFormStudyFieldsFragmentDoc}
${PlayerProfileEditingFormStudySubjectsFragmentDoc}
${PlayerProfileEditingFormCollegesFragmentDoc}`;
export const AdminClearEventRegistrationsDocument = gql`
    mutation AdminClearEventRegistrations($id: String!) {
  delete_espin_event_registration(where: {user_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export const UpdateUserLastLoginDocument = gql`
    mutation UpdateUserLastLogin($id: String!) {
  update_espin_user_by_pk(pk_columns: {id: $id}, _set: {last_login: "now()"}) {
    updated_at
    last_login
  }
}
    `;
export const AdminAcceptCollegeInviteDocument = gql`
    mutation AdminAcceptCollegeInvite($input: espin_college_profile_insert_input!, $inviteId: uuid!) {
  insert_espin_college_profile_one(
    object: $input
    on_conflict: {constraint: college_profile_user_id_key, update_columns: []}
  ) {
    id
  }
  update_espin_college_invite_by_pk(
    pk_columns: {id: $inviteId}
    _set: {status: accepted}
  ) {
    id
  }
}
    `;
export const AdminGetCollegeInviteByIdDocument = gql`
    query AdminGetCollegeInviteById($inviteId: uuid!) {
  espin_college_invite_by_pk(id: $inviteId) {
    id
    college {
      id
    }
    email
    status
  }
}
    `;
export const GetAccountInfoForCollegeEmailDocument = gql`
    query GetAccountInfoForCollegeEmail($collegeId: uuid!) {
  espin_college_by_pk(id: $collegeId) {
    college_profiles {
      id
      last_name
      first_name
    }
  }
}
    `;
export const GetEventRegistrationDetailsDocument = gql`
    query GetEventRegistrationDetails($teamId: uuid!, $ticketId: uuid!) {
  espin_team_by_pk(id: $teamId) {
    display_name
    deleted_at
    members {
      player_profile {
        first_name
        user {
          email
        }
      }
    }
  }
  espin_event_ticket_by_pk(id: $ticketId) {
    id
    game {
      name
    }
    event {
      name
      slug
      event_start_date
    }
  }
}
    `;
export const GetDeletedEventRegistrationDetailsDocument = gql`
    query GetDeletedEventRegistrationDetails($ticketId: uuid!) {
  espin_event_ticket_by_pk(id: $ticketId) {
    id
    game {
      name
    }
    event {
      name
      slug
      event_start_date
    }
  }
}
    `;
export const CreateFileRecordDocument = gql`
    mutation CreateFileRecord($input: content_file_insert_input!) {
  insert_content_file_one(object: $input) {
    id
  }
}
    `;
export const ActionCreateHighSchoolTeamDocument = gql`
    mutation ActionCreateHighSchoolTeam($input: espin_team_insert_input!) {
  insert_espin_team_one(object: $input) {
    id
  }
}
    `;
export const ActionCheckTeamNameDocument = gql`
    query ActionCheckTeamName($name: String!) {
  espin_team(where: {display_name: {_ilike: $name}}) {
    id
    display_name
    deleted_at
  }
}
    `;
export const ActionCheckNamesForHighSchoolTeamDocument = gql`
    query ActionCheckNamesForHighSchoolTeam($input: [String!]!) {
  espin_player_profile(
    where: {_or: [{user: {email: {_in: $input}}}, {spin_username: {_in: $input}}]}
  ) {
    id
    spin_username
    user {
      id
      email
    }
  }
}
    `;
export const InsertTeamInvitesDocument = gql`
    mutation InsertTeamInvites($input: [espin_team_invite_insert_input!]!) {
  insert_espin_team_invite(
    objects: $input
    on_conflict: {constraint: team_invite_team_id_user_id_key, update_columns: [status]}
  ) {
    affected_rows
    returning {
      email
      status
      created_at
      updated_at
      id
      team_id
    }
  }
}
    `;
export const GetHighSchoolUserIdByHighSchoolIdDocument = gql`
    query GetHighSchoolUserIdByHighSchoolId($highSchoolId: uuid!) {
  espin_high_school_profile(where: {high_school_id: {_eq: $highSchoolId}}) {
    user_id
  }
}
    `;
export const ActionGetTeamMembersDocument = gql`
    query ActionGetTeamMembers($teamId: uuid!) {
  espin_team_members(where: {team_id: {_eq: $teamId}}) {
    player_profile_id
    id
  }
}
    `;
export const ActionEditHighSchoolTeamDocument = gql`
    mutation ActionEditHighSchoolTeam($input: espin_team_insert_input!, $onConflict: espin_team_on_conflict!) {
  insert_espin_team_one(object: $input, on_conflict: $onConflict) {
    id
  }
}
    `;
export const GetAccountInfoForHighSchoolEmailDocument = gql`
    query GetAccountInfoForHighSchoolEmail($highSchoolId: uuid!) {
  espin_high_school_by_pk(id: $highSchoolId) {
    high_school_profiles {
      id
      last_name
      first_name
    }
  }
}
    `;
export const IsColleagueExistingUserDocument = gql`
    query IsColleagueExistingUser($emails: [String!]!) {
  espin_user(where: {email: {_in: $emails}}) {
    id
  }
}
    `;
export const InviteHighSchoolUsersDocument = gql`
    mutation InviteHighSchoolUsers($input: [espin_high_school_invite_insert_input!]!) {
  insert_espin_high_school_invite(
    objects: $input
    on_conflict: {constraint: espin_high_school_invite_email_high_school_id_key, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export const GetAllVerifiedHighSchoolNamesDocument = gql`
    query GetAllVerifiedHighSchoolNames {
  espin_high_school(where: {verified: {_eq: true}}) {
    ...PlayerHighSchoolNames
  }
}
    ${PlayerHighSchoolNamesFragmentDoc}`;
export const SendMassPlayerMessagesDocument = gql`
    mutation SendMassPlayerMessages($collegeProfileId: uuid!, $input: [espin_message_insert_input!]!) {
  insert_espin_message(objects: $input) {
    returning {
      id
    }
  }
  update_espin_college_profile_by_pk(
    pk_columns: {id: $collegeProfileId}
    _set: {last_group_message: "now()"}
  ) {
    id
  }
}
    `;
export const GetCollegeSenderInfoDocument = gql`
    query GetCollegeSenderInfo($userId: String!) {
  espin_user_by_pk(id: $userId) {
    college_profile {
      id
      last_group_message
      college {
        id
        name
        address {
          state
        }
        follows {
          player_user_id
        }
      }
    }
    subscription_status {
      is_subscribed
      tierlookup
    }
  }
}
    `;
export const SearchPlayersForMassMessageDocument = gql`
    query SearchPlayersForMassMessage($search: espin_user_bool_exp!) {
  espin_user(where: $search) {
    id
    player_profile {
      spin_username
      player_games(where: {primary: {_eq: true}}) {
        game {
          name
          game_definition
        }
      }
      address {
        state
      }
    }
  }
}
    `;
export const RejectDraftPlayerProfileDocument = gql`
    mutation RejectDraftPlayerProfile($draftId: uuid!, $comments: String!) {
  update_espin_draft_player_profile_by_pk(
    _set: {status: rejected, comments: $comments}
    pk_columns: {id: $draftId}
  ) {
    id
    status
    updated_at
  }
}
    `;
export const ApprovePlayerProfileUpdateDocument = gql`
    mutation ApprovePlayerProfileUpdate($userId: String!, $input: espin_player_profile_insert_input!, $onConflict: espin_player_profile_on_conflict!) {
  delete_espin_player_game(where: {player_profile: {user_id: {_eq: $userId}}}) {
    affected_rows
  }
  insert_espin_player_profile_one(object: $input, on_conflict: $onConflict) {
    id
  }
}
    `;
export const GetCurrentPlayerProfileIdsForReviewDocument = gql`
    query GetCurrentPlayerProfileIdsForReview($userId: String!) {
  espin_player_profile(where: {user_id: {_eq: $userId}}) {
    id
    address_id
    parent_email
    preferred_schools
    preferred_study_fields
    parent_profile {
      id
      user {
        email
      }
    }
    social {
      id
      twitch_channel {
        id
      }
      youtube_channel {
        id
      }
    }
  }
}
    `;
export const CheckForDuplicateUsernamesDocument = gql`
    query CheckForDuplicateUsernames($username: String!) {
  espin_player_profile(where: {spin_username: {_ilike: $username}}) {
    id
  }
}
    `;
export const GetCollegeIdsFromNamesDocument = gql`
    query GetCollegeIdsFromNames($input: [String!]!) {
  espin_college(where: {name: {_in: $input}}) {
    id
    name
  }
}
    `;
export const InviteParentForPlayerDocument = gql`
    mutation InviteParentForPlayer($input: espin_parent_invite_insert_input!) {
  insert_espin_parent_invite_one(
    object: $input
    on_conflict: {constraint: parent_invite_pkey, update_columns: []}
  ) {
    id
  }
}
    `;
export const NotifyCollegesOfInterestDocument = gql`
    mutation NotifyCollegesOfInterest($input: [espin_notification_insert_input!]!) {
  insert_espin_notification(objects: $input) {
    returning {
      id
    }
  }
}
    `;
export const GetParentProfileByPlayerProfileIdDocument = gql`
    query GetParentProfileByPlayerProfileId($playerProfileId: uuid!) {
  espin_player_profile_by_pk(id: $playerProfileId) {
    parent_profile {
      user_id
    }
  }
}
    `;
export const RemoveParentFromPlayerDocument = gql`
    mutation RemoveParentFromPlayer($playerProfileId: uuid!) {
  update_espin_player_profile_by_pk(
    pk_columns: {id: $playerProfileId}
    _set: {parent_profile_id: null}
  ) {
    id
  }
}
    `;
export const GetTicketForRegistrationIdDocument = gql`
    query GetTicketForRegistrationId($registrationId: uuid!) {
  espin_event_registration_by_pk(id: $registrationId) {
    event_ticket {
      price_temp
    }
  }
}
    `;
export const AddPaymentIntentIdDocument = gql`
    mutation AddPaymentIntentId($registrationId: uuid!, $paymentIntentId: String!) {
  update_espin_event_registration_by_pk(
    pk_columns: {id: $registrationId}
    _set: {payment_intent_id: $paymentIntentId}
  ) {
    id
    updated_at
  }
}
    `;
export const GetUserInfoBySubDocument = gql`
    query GetUserInfoBySub($id: String!) {
  espin_user_by_pk(id: $id) {
    id
    player_profile {
      spin_username
    }
  }
}
    `;
export const AdminRedeemCollegeReferralCodeDocument = gql`
    mutation AdminRedeemCollegeReferralCode($input: espin_referral_code_redemption_insert_input!) {
  insert_espin_referral_code_redemption_one(object: $input) {
    id
    college {
      id
      name
      college_subscription_id
    }
  }
}
    `;
export const AdminGetCollegeReferralCodeByKeyDocument = gql`
    query AdminGetCollegeReferralCodeByKey($codeKey: String!) {
  espin_referral_code(where: {code_key: {_eq: $codeKey}}) {
    id
    code_key
    code_active_start_date
    code_active_end_date
    subscription_duration
    referral_code_redemptions {
      redeemed_by_college
    }
  }
}
    `;
export const AdminRedeemPlayerReferralCodeDocument = gql`
    mutation AdminRedeemPlayerReferralCode($input: espin_referral_code_redemption_insert_input!) {
  insert_espin_referral_code_redemption_one(object: $input) {
    id
    player_profile {
      spin_username
      slug
      player_subscription_id
    }
  }
}
    `;
export const AdminGetPlayerReferralCodeByKeyDocument = gql`
    query AdminGetPlayerReferralCodeByKey($codeKey: String!) {
  espin_referral_code(where: {code_key: {_eq: $codeKey}}) {
    id
    code_key
    code_active_start_date
    code_active_end_date
    subscription_duration
    referral_code_redemptions {
      redeemed_by_player
    }
  }
}
    `;
export const GetAlreadyInvitedTeamMembersDocument = gql`
    query GetAlreadyInvitedTeamMembers($playerIds: [uuid!]!, $teamId: uuid!, $emails: [String!]!) {
  espin_team_members(
    where: {_and: [{player_profile_id: {_in: $playerIds}}, {team_id: {_eq: $teamId}}]}
  ) {
    player_profile_id
  }
  espin_team_invite(
    where: {_and: [{email: {_in: $emails}}, {team_id: {_eq: $teamId}}]}
  ) {
    status
    user {
      player_profile {
        id
      }
    }
  }
}
    `;
export const GetPlayerOwnedTeamsDocument = gql`
    query GetPlayerOwnedTeams($id: String = "") {
  espin_team(
    where: {members: {player_profile: {user_id: {_eq: $id}}, team_role: {_eq: captain}}}
  ) {
    id
  }
}
    `;
export const GetHighSchoolUserIdByTeamIdDocument = gql`
    query GetHighSchoolUserIdByTeamId($teamId: uuid!) {
  espin_high_school_profile(
    where: {high_school: {teams: {id: {_eq: $teamId}, deleted_at: {_is_null: true}}}}
  ) {
    user_id
  }
}
    `;
export const SetTeamCaptainDocument = gql`
    mutation SetTeamCaptain($player_profile_id: uuid!, $teamId: uuid!) {
  insert_espin_team_members_one(
    object: {player_profile_id: $player_profile_id, team_id: $teamId, team_role: captain}
  ) {
    id
  }
}
    `;
export const AdminGetTeamInviteInformationByIdDocument = gql`
    query AdminGetTeamInviteInformationById($id: uuid!) {
  espin_team_invite_by_pk(id: $id) {
    email
    status
    user_id
    created_at
    updated_at
    id
    team_id
    team {
      display_name
    }
  }
}
    `;
export const ActivationCollegeFairDocument = gql`
    query ActivationCollegeFair {
  espin_college(where: {att_college_fair: {_eq: true}}) {
    ...ActivationCollegeAttending
  }
}
    ${ActivationCollegeAttendingFragmentDoc}`;
export const College_DetailsDocument = gql`
    query College_Details($slug: String!) {
  espin_college(
    where: {_and: [{slug: {_eq: $slug}}, {verified: {_eq: true}}]}
    limit: 1
  ) {
    id
    ...CollegeDetails
  }
}
    ${CollegeDetailsFragmentDoc}`;
export const RecordParentViewsProfileDocument = gql`
    mutation RecordParentViewsProfile($input: [espin_profile_view_insert_input!]!) {
  insert_espin_profile_view(objects: $input) {
    returning {
      id
    }
  }
}
    `;
export const SsgCollegesBySlugDocument = gql`
    query SSGCollegesBySlug {
  espin_college(
    where: {_and: [{verified: {_eq: true}}, {slug: {_is_null: false}}]}
    order_by: {name: asc}
  ) {
    id
    slug
  }
}
    `;
export const Colleges_IndexDocument = gql`
    query Colleges_Index {
  ...CollegeSearchFilterComponent
  subbedCount: espin_college_aggregate(
    where: {_and: [{verified: {_eq: true}}, {slug: {_is_null: false}}, {_or: [{subscribed: {_eq: true}}, {subscription: {status: {_eq: active}}}]}]}
    order_by: {name: asc}
  ) {
    aggregate {
      count
    }
  }
}
    ${CollegeSearchFilterComponentFragmentDoc}`;
export const SearchCollegesDocument = gql`
    query SearchColleges($subbedSearch: espin_college_bool_exp!, $unsubbedSearch: espin_college_bool_exp!, $subbedOffset: Int! = 0, $subbedPageSize: Int! = 50, $unsubbedOffset: Int! = 0, $unsubbedPageSize: Int! = 50) {
  unsubbedColleges: espin_college(
    where: $unsubbedSearch
    order_by: {name: asc}
    limit: $unsubbedPageSize
    offset: $unsubbedOffset
  ) {
    ...CollegeCard
    id
    name
    program_name
    subscribed
    address {
      city
      state
      country
    }
  }
  subbedColleges: espin_college(
    where: $subbedSearch
    order_by: {name: asc}
    limit: $subbedPageSize
    offset: $subbedOffset
  ) {
    ...CollegeCard
    id
    name
    program_name
    subscribed
    address {
      city
      state
      country
    }
  }
  subbedCount: espin_college_aggregate(
    where: {_and: [{verified: {_eq: true}}, {slug: {_is_null: false}}, {_or: [{subscribed: {_eq: true}}, {subscription: {status: {_eq: active}}}]}]}
    order_by: {name: asc}
  ) {
    aggregate {
      count
    }
  }
  allCount: espin_college_aggregate(
    where: {_or: [$subbedSearch, $unsubbedSearch]}
    order_by: {name: asc}
  ) {
    aggregate {
      count
    }
  }
}
    ${CollegeCardFragmentDoc}`;
export const CollegeInvitesDocument = gql`
    query CollegeInvites($collegeId: uuid!) {
  espin_college_invite(where: {college_id: {_eq: $collegeId}}) {
    ...ColleagueInvites
  }
}
    ${ColleagueInvitesFragmentDoc}`;
export const HighSchoolInvitesDocument = gql`
    query HighSchoolInvites($highSchoolId: uuid!) {
  espin_high_school_invite(where: {high_school_id: {_eq: $highSchoolId}}) {
    ...HighSchoolColleagueInvites
  }
}
    ${HighSchoolColleagueInvitesFragmentDoc}`;
export const AccountSettingsMessagesDocument = gql`
    query AccountSettingsMessages($collegeId: uuid!) {
  espin_college_preferences(where: {college_id: {_eq: $collegeId}}) {
    ...MessagePreferences
  }
  espin_college_by_pk(id: $collegeId) {
    program_name
    manual_subtier
    subscription {
      status
    }
  }
}
    ${MessagePreferencesFragmentDoc}`;
export const AccountEmailPreferenceSettingsDocument = gql`
    query AccountEmailPreferenceSettings($userId: String!) {
  espin_user_by_pk(id: $userId) {
    ...NotificationPreferences
  }
}
    ${NotificationPreferencesFragmentDoc}`;
export const DashboardDocument = gql`
    query Dashboard($id: String!, $playerPrimaryGame: espin_game_definition_enum, $hasPrimary: Boolean!, $collegeId: uuid, $highSchoolId: uuid, $showRegistrations: Boolean = true, $showCollegeNotifs: Boolean = false, $showPlayerNotifs: Boolean = false, $showParentNotifs: Boolean = false, $showHighSchoolNotifs: Boolean = false, $playerUserIds: [String!]) {
  admin_recommended_events: espin_event(
    limit: 2
    order_by: {event_start_date: asc}
    where: {admin_recommended: {_eq: true}, status: {_eq: published}, event_end_date: {_gte: "now()"}}
  ) {
    ...RecruitingHubEvents
  }
  recommended_events: espin_event(
    limit: 3
    order_by: {event_start_date: asc}
    where: {event_end_date: {_gte: "now()"}, status: {_eq: published}, event_games: {game: {game_definition: {_eq: $playerPrimaryGame}}}}
  ) @include(if: $hasPrimary) {
    ...RecruitingHubEvents
  }
  any_events: espin_event(
    limit: 3
    order_by: {event_start_date: asc}
    where: {event_end_date: {_gte: "now()"}, status: {_eq: published}}
  ) @skip(if: $hasPrimary) {
    ...RecruitingHubEvents
  }
  registered_events: espin_event(
    limit: 3
    order_by: {event_start_date: asc}
    where: {event_end_date: {_gte: "now()"}, status: {_eq: published}, event_registrations: {user_id: {_eq: $id}}}
  ) @include(if: $showRegistrations) {
    ...RecruitingHubEvents
  }
  college_notifications: espin_notification(
    limit: 6
    order_by: {created_at: desc}
    where: {notification_type: {_neq: conversation_started}, college_id: {_eq: $collegeId}}
  ) @include(if: $showCollegeNotifs) {
    ...RecruitingHubNotifications
  }
  high_school_notifications: espin_notification(
    limit: 6
    order_by: {created_at: desc}
    where: {high_school_id: {_eq: $highSchoolId}}
  ) @include(if: $showHighSchoolNotifs) {
    ...RecruitingHubNotifications
  }
  player_notifications: espin_notification(
    limit: 6
    order_by: {created_at: desc}
    where: {player_user_id: {_eq: $id}, notification_type: {_nin: [interested_in, conversation_started]}}
  ) @include(if: $showPlayerNotifs) {
    ...RecruitingHubNotifications
  }
  parent_notifications: espin_notification(
    where: {player_user_id: {_in: $playerUserIds}}
    order_by: {created_at: desc}
  ) @include(if: $showParentNotifs) {
    ...ParentRecruitingHubNotifications
  }
  parent_children: espin_parent_profile(where: {user_id: {_eq: $id}}) @include(if: $showParentNotifs) {
    ...ParentChildDropdown
  }
  unread_college_messages: espin_message(
    where: {_and: {college_id: {_eq: $collegeId}, viewed_at: {_is_null: true}, message_type: {_eq: player_messages_college}}}
  ) @include(if: $showCollegeNotifs) {
    ...RecruitingHubMessages
  }
  all_college_messages: espin_message(
    where: {_and: {college_id: {_eq: $collegeId}}}
  ) @include(if: $showCollegeNotifs) {
    ...MessagesCard
  }
  college_followers: espin_follow(
    where: {_and: {college_id: {_eq: $collegeId}, follow_type: {_eq: player_follows_college}}}
  ) @include(if: $showCollegeNotifs) {
    ...RecruitingHubFollows
  }
  college_deleted_followers: espin_follow(
    where: {_and: {college_id: {_eq: $collegeId}, follow_type: {_eq: player_follows_college}, player_user: {deleted_at: {_is_null: false}}}}
  ) @include(if: $showCollegeNotifs) {
    ...RecruitingHubFollows
  }
  college_following: espin_follow(
    where: {_and: {college_id: {_eq: $collegeId}, follow_type: {_eq: college_follows_player}}}
  ) @include(if: $showCollegeNotifs) {
    ...RecruitingHubFollows
  }
  college_profile_views: espin_profile_view(
    where: {_and: {college_id: {_eq: $collegeId}, profile_view_type: {_in: [parent_views_college, player_views_college]}}}
  ) @include(if: $showCollegeNotifs) {
    ...RecruitingHubProfileViews
  }
  high_school_followers: espin_follow(
    where: {_and: {high_school_id: {_eq: $highSchoolId}, follow_type: {_eq: college_follows_high_school}}}
  ) @include(if: $showHighSchoolNotifs) {
    ...RecruitingHubFollows
  }
  high_school_deleted_followers: espin_follow(
    where: {_and: {high_school_id: {_eq: $highSchoolId}, follow_type: {_eq: college_follows_high_school}, college_user: {deleted_at: {_is_null: false}}}}
  ) @include(if: $showHighSchoolNotifs) {
    ...RecruitingHubFollows
  }
  high_school_following: espin_follow(
    where: {_and: {high_school_id: {_eq: $highSchoolId}, follow_type: {_eq: high_school_follows_college}}}
  ) @include(if: $showHighSchoolNotifs) {
    ...RecruitingHubFollows
  }
  high_school_profile_views: espin_profile_view(
    where: {_and: {high_school_id: {_eq: $highSchoolId}, profile_view_type: {_in: [college_views_high_school]}}}
  ) @include(if: $showHighSchoolNotifs) {
    ...RecruitingHubProfileViews
  }
  unread_player_messages: espin_message(
    where: {_and: {player_user_id: {_eq: $id}, viewed_at: {_is_null: true}, message_type: {_eq: college_messages_player}}}
  ) @include(if: $showPlayerNotifs) {
    ...RecruitingHubMessages
  }
  all_player_messages: espin_message(where: {_and: {player_user_id: {_eq: $id}}}) @include(if: $showPlayerNotifs) {
    ...MessagesCard
  }
  player_followers: espin_follow(
    where: {_and: {player_user_id: {_eq: $id}, follow_type: {_eq: college_follows_player}}}
  ) @include(if: $showPlayerNotifs) {
    ...RecruitingHubFollows
  }
  player_deleted_followers: espin_follow(
    where: {_and: {player_user_id: {_eq: $id}, follow_type: {_eq: college_follows_player}}}
  ) @include(if: $showPlayerNotifs) {
    ...RecruitingHubFollows
  }
  player_following: espin_follow(
    where: {_and: {player_user_id: {_eq: $id}, follow_type: {_eq: player_follows_college}}}
  ) @include(if: $showPlayerNotifs) {
    ...RecruitingHubFollows
  }
  player_profile_views: espin_profile_view(
    where: {_and: {player_user_id: {_eq: $id}, profile_view_type: {_eq: college_views_player}}}
  ) @include(if: $showPlayerNotifs) {
    ...RecruitingHubProfileViews
  }
  unread_parent_messages: espin_message(
    where: {_and: {player_user_id: {_in: $playerUserIds}, viewed_at: {_is_null: true}, message_type: {_eq: college_messages_player}}}
  ) @include(if: $showParentNotifs) {
    ...ParentRecruitingHubMessages
  }
  all_parent_messages: espin_message(
    where: {_and: {player_user_id: {_in: $playerUserIds}}}
  ) @include(if: $showParentNotifs) {
    ...MessagesCard
  }
  parent_followers: espin_follow(
    where: {_and: {player_user_id: {_in: $playerUserIds}, follow_type: {_eq: college_follows_player}}}
  ) @include(if: $showParentNotifs) {
    ...RecruitingHubFollows
  }
  parent_deleted_followers: espin_follow(
    where: {_and: {player_user_id: {_in: $playerUserIds}, follow_type: {_eq: college_follows_player}}}
  ) @include(if: $showParentNotifs) {
    ...RecruitingHubFollows
  }
  parent_following: espin_follow(
    where: {_and: {player_user_id: {_in: $playerUserIds}, follow_type: {_eq: player_follows_college}}}
  ) @include(if: $showParentNotifs) {
    ...RecruitingHubFollows
  }
  parent_profile_views: espin_profile_view(
    where: {_and: {player_user_id: {_in: $playerUserIds}, profile_view_type: {_eq: college_views_player}}}
  ) @include(if: $showParentNotifs) {
    ...RecruitingHubProfileViews
  }
}
    ${RecruitingHubEventsFragmentDoc}
${RecruitingHubNotificationsFragmentDoc}
${ParentRecruitingHubNotificationsFragmentDoc}
${ParentChildDropdownFragmentDoc}
${RecruitingHubMessagesFragmentDoc}
${MessagesCardFragmentDoc}
${RecruitingHubFollowsFragmentDoc}
${RecruitingHubProfileViewsFragmentDoc}
${ParentRecruitingHubMessagesFragmentDoc}`;
export const CollegeMessagesDocument = gql`
    query CollegeMessages($collegeId: uuid) {
  espin_message(
    where: {college_id: {_eq: $collegeId}}
    order_by: {created_at: asc}
  ) {
    ...MessagesCard
  }
}
    ${MessagesCardFragmentDoc}`;
export const HighSchoolMessagesDocument = gql`
    query HighSchoolMessages($highSchoolId: uuid) {
  espin_message(
    where: {high_school_id: {_eq: $highSchoolId}}
    order_by: {created_at: asc}
  ) {
    ...MessagesCard
  }
}
    ${MessagesCardFragmentDoc}`;
export const SearchPlayerMessagesDocument = gql`
    query SearchPlayerMessages($playerSearch: espin_message_bool_exp!) {
  espin_message(where: $playerSearch, order_by: {created_at: asc}) {
    ...MessagesCard
  }
}
    ${MessagesCardFragmentDoc}`;
export const PlayerMessagesDocument = gql`
    query PlayerMessages($playerUserId: String) {
  espin_message(
    where: {player_user_id: {_eq: $playerUserId}}
    order_by: {created_at: asc}
  ) {
    ...MessagesCard
  }
}
    ${MessagesCardFragmentDoc}`;
export const ParentMessagesDocument = gql`
    query ParentMessages($playerUserIds: [String!]) {
  espin_message(
    where: {player_user_id: {_in: $playerUserIds}}
    order_by: {created_at: asc}
  ) {
    ...MessagesCard
  }
}
    ${MessagesCardFragmentDoc}`;
export const ChildProfileDataDocument = gql`
    query ChildProfileData($id: String!) {
  espin_parent_profile(where: {user_id: {_eq: $id}}) {
    ...ParentChildDropdown
  }
}
    ${ParentChildDropdownFragmentDoc}`;
export const ConversationWithCollegeBySlugDocument = gql`
    query ConversationWithCollegeBySlug($slug: String! = "") {
  collegeIdBySlug: espin_college(where: {slug: {_eq: $slug}}) {
    id
    name
    logo {
      ...SpinContentImageDisplay
    }
    slug
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const ConversationWithHighSchoolBySlugDocument = gql`
    query ConversationWithHighSchoolBySlug($slug: String! = "") {
  highSchoolIdBySlug: espin_high_school(where: {slug: {_eq: $slug}}) {
    id
    name
    profile_pic_file {
      ...SpinContentImageDisplay
    }
    slug
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const ConversationWithPlayerBySlugDocument = gql`
    query ConversationWithPlayerBySlug($slug: String! = "") {
  playerIdBySlug: espin_player_profile(where: {slug: {_eq: $slug}}) {
    user_id
    first_name
    last_name
    slug
    profile_image {
      ...SpinContentImageDisplay
    }
  }
}
    ${SpinContentImageDisplayFragmentDoc}`;
export const RecordMessageViewsDocument = gql`
    mutation RecordMessageViews($collegeId: uuid = "", $playerUserId: String = "", $messageType: espin_message_type_enum!) {
  update_espin_message(
    where: {player_user_id: {_eq: $playerUserId}, college_id: {_eq: $collegeId}, message_type: {_eq: $messageType}, viewed_at: {_is_null: true}}
    _set: {viewed_at: "now()"}
  ) {
    affected_rows
  }
}
    `;
export const RecordAdminPlayerMessageViewsDocument = gql`
    mutation RecordAdminPlayerMessageViews($playerUserId: String!, $messageType: espin_message_type_enum!) {
  update_espin_message(
    where: {player_user_id: {_eq: $playerUserId}, message_type: {_eq: $messageType}, viewed_at: {_is_null: true}}
    _set: {viewed_at: "now()"}
  ) {
    affected_rows
  }
}
    `;
export const RecordAdminCollegeMessageViewsDocument = gql`
    mutation RecordAdminCollegeMessageViews($collegeId: uuid!, $messageType: espin_message_type_enum!) {
  update_espin_message(
    where: {college_id: {_eq: $collegeId}, message_type: {_eq: $messageType}, viewed_at: {_is_null: true}}
    _set: {viewed_at: "now()"}
  ) {
    affected_rows
  }
}
    `;
export const ParentPlayerProfileBySlugDocument = gql`
    query ParentPlayerProfileBySlug($slug: String!) {
  espin_player_profile(
    where: {_and: [{slug: {_eq: $slug}}, {user: {deleted_at: {_is_null: true}}}]}
  ) {
    spin_username
    ...ParentMyPlayersProfile
  }
}
    ${ParentMyPlayersProfileFragmentDoc}`;
export const EventScoutingReportBySlugDocument = gql`
    query EventScoutingReportBySlug($slug: String!) {
  espin_event(where: {slug: {_eq: $slug}}) {
    name
    event_start_date
    event_games {
      game {
        name
        game_definition
      }
    }
  }
}
    `;
export const SearchScoutingReportsDocument = gql`
    query SearchScoutingReports($slug: String!, $search: espin_event_registration_bool_exp!) {
  espin_event_registration(
    order_by: {user: {player_profile: {graduating_class: asc}, created_at: desc}}
    where: {_and: [{event: {slug: {_eq: $slug}}}, $search]}
  ) {
    ...ScoutingReportPlayerCards
  }
}
    ${ScoutingReportPlayerCardsFragmentDoc}`;
export const ScoutingReports_IndexDocument = gql`
    query ScoutingReports_Index {
  espin_event(
    order_by: {event_start_date: desc}
    where: {status: {_eq: published}}
  ) {
    ...EventReport
  }
}
    ${EventReportFragmentDoc}`;
export const EspinGetSiteEducationContentDocument = gql`
    query EspinGetSiteEducationContent {
  educationContent: espin_site_content_by_pk(key: education_page_content) {
    key
    value
  }
}
    `;
export const GetRegistrationConfirmedDocument = gql`
    query GetRegistrationConfirmed($registrationId: uuid!) {
  espin_event_registration_by_pk(id: $registrationId) {
    event_ticket {
      id
      game {
        name
      }
      ticket_type
      event {
        name
        event_start_date
        event_end_date
        ...EventHeader
      }
      ...ConfirmedRegistrationForEvent
    }
  }
}
    ${EventHeaderFragmentDoc}
${ConfirmedRegistrationForEventFragmentDoc}`;
export const GetPaidRegistrationIdDocument = gql`
    query GetPaidRegistrationId($ticketId: uuid!, $userId: String!) {
  espin_event_registration(
    where: {ticket_id: {_eq: $ticketId}, user_id: {_eq: $userId}}
  ) {
    id
    event {
      slug
    }
  }
}
    `;
export const EventBySlugDocument = gql`
    query EventBySlug($eventSlug: String!) {
  espin_event(where: {slug: {_eq: $eventSlug}, status: {_eq: published}}) {
    id
    ...EventHeader
    ...EventInfo
    ...EventRegistration
    name
    short_description
    slug
    event_start_date
    event_end_date
    url
    register_start_date
    register_end_date
    stream_url
    body_content
    event_tickets {
      ...EventTicketCard
    }
    logo {
      id
      ext
      cdn_url
    }
    icon {
      id
      ext
      cdn_url
    }
    type
    event_games {
      id
      game_id
      game {
        game_definition
        name
        website
        image_url
        team_max_size
      }
    }
  }
}
    ${EventHeaderFragmentDoc}
${EventInfoFragmentDoc}
${EventRegistrationFragmentDoc}
${EventTicketCardFragmentDoc}`;
export const EventTicketRegistrationsForUserDocument = gql`
    query EventTicketRegistrationsForUser($eventSlug: String!) {
  espin_event(where: {slug: {_eq: $eventSlug}, status: {_eq: published}}) {
    ...TicketRegistrations
  }
}
    ${TicketRegistrationsFragmentDoc}`;
export const SsgEventsBySlugDocument = gql`
    query SSGEventsBySlug {
  espin_event(
    where: {_and: [{status: {_eq: published}}, {slug: {_is_null: false}}]}
  ) {
    id
    slug
  }
}
    `;
export const RegisterForEventDocument = gql`
    query RegisterForEvent($ticketId: uuid!) {
  espin_event_ticket_by_pk(id: $ticketId) {
    ...EventRegistrationForm
    ...SignInToRegister
    ...CannotRegisterAsNonPlayer
    ...NeedsToFinishOnboardingBeforeReg
  }
}
    ${EventRegistrationFormFragmentDoc}
${SignInToRegisterFragmentDoc}
${CannotRegisterAsNonPlayerFragmentDoc}
${NeedsToFinishOnboardingBeforeRegFragmentDoc}`;
export const Events_IndexDocument = gql`
    query Events_Index {
  stickied_events: espin_event(
    where: {event_end_date: {_gte: "now()"}, status: {_eq: published}, stickied: {_is_null: false}}
    order_by: {stickied: asc}
  ) {
    id
    ...EventCard
  }
  espin_event(
    order_by: {event_start_date: asc}
    where: {event_end_date: {_gte: "now()"}, status: {_eq: published}}
  ) {
    id
    ...EventCard
  }
  espin_game_definition {
    display_name
    game_name
  }
}
    ${EventCardFragmentDoc}`;
export const HighSchool_DetailsDocument = gql`
    query HighSchool_Details($slug: String!) {
  espin_high_school(
    where: {_and: [{slug: {_eq: $slug}}, {verified: {_eq: true}}]}
    limit: 1
  ) {
    id
    ...HighSchoolDetails
  }
}
    ${HighSchoolDetailsFragmentDoc}`;
export const HighSchools_IndexDocument = gql`
    query HighSchools_Index {
  ...HighSchoolSearchFilterComponent
}
    ${HighSchoolSearchFilterComponentFragmentDoc}`;
export const SearchHighSchoolsDocument = gql`
    query SearchHighSchools($search: espin_high_school_bool_exp!, $offset: Int! = 0, $pageSize: Int! = 50) {
  espin_high_school(
    where: $search
    order_by: {name: asc}
    limit: $pageSize
    offset: $offset
  ) {
    ...HighSchoolCard
    id
    name
    address {
      city
      state
      country
    }
  }
  allCount: espin_high_school_aggregate(where: $search, order_by: {name: asc}) {
    aggregate {
      count
    }
  }
}
    ${HighSchoolCardFragmentDoc}`;
export const HomePageDocument = gql`
    query HomePage {
  stickied_events: espin_event(
    where: {event_end_date: {_gte: "now()"}, status: {_eq: published}, stickied: {_is_null: false}}
    order_by: {stickied: asc}
  ) {
    ...UpcomingEvents
  }
  events: espin_event(
    limit: 5
    order_by: {event_start_date: asc}
    where: {event_end_date: {_gte: "now()"}, status: {_eq: published}}
  ) {
    ...UpcomingEvents
  }
}
    ${UpcomingEventsFragmentDoc}`;
export const AcceptInvitationDocument = gql`
    mutation AcceptInvitation($inviteId: uuid!) {
  acceptCollegeInvite(input: {inviteId: $inviteId}) {
    valid
  }
}
    `;
export const GetCollegeInviteByIdDocument = gql`
    query GetCollegeInviteById($inviteId: uuid!) {
  espin_college_invite_by_pk(id: $inviteId) {
    ...PostInviteLogin
  }
}
    ${PostInviteLoginFragmentDoc}`;
export const CheckCollegeEmailExistsDocument = gql`
    query CheckCollegeEmailExists($email: String!) {
  espin_user(where: {email: {_eq: $email}, role: {_eq: espin_college_user}}) {
    id
    college_profile {
      id
    }
  }
}
    `;
export const AdminCreateCollegeFromInviteDocument = gql`
    mutation AdminCreateCollegeFromInvite($input: espin_college_profile_insert_input!, $inviteId: uuid!) {
  insert_espin_college_profile_one(
    object: $input
    on_conflict: {constraint: college_profile_user_id_key, update_columns: [updated_at]}
  ) {
    id
  }
  update_espin_college_invite_by_pk(
    pk_columns: {id: $inviteId}
    _set: {status: accepted}
  ) {
    id
    status
  }
}
    `;
export const GetHighSchoolInviteByIdDocument = gql`
    query GetHighSchoolInviteById($inviteId: uuid!) {
  espin_high_school_invite_by_pk(id: $inviteId) {
    ...PostHSInviteLogin
  }
}
    ${PostHsInviteLoginFragmentDoc}`;
export const CheckHighSchoolEmailExistsDocument = gql`
    query CheckHighSchoolEmailExists($email: String!) {
  espin_user(where: {email: {_eq: $email}, role: {_eq: espin_highschool_user}}) {
    id
    high_school_profile {
      id
    }
  }
}
    `;
export const AdminCreateHighSchoolProfileFromInviteDocument = gql`
    mutation AdminCreateHighSchoolProfileFromInvite($input: espin_high_school_profile_insert_input!, $inviteId: uuid!) {
  insert_espin_high_school_profile_one(
    object: $input
    on_conflict: {constraint: high_school_profile_user_id_key, update_columns: [updated_at]}
  ) {
    id
  }
  update_espin_high_school_invite_by_pk(
    pk_columns: {id: $inviteId}
    _set: {status: accepted}
  ) {
    id
    status
  }
}
    `;
export const AdminGetParentInviteByIdDocument = gql`
    query AdminGetParentInviteById($inviteId: uuid!) {
  espin_parent_invite_by_pk(id: $inviteId) {
    id
    parent_email
    player_profile {
      id
    }
    status
  }
}
    `;
export const CheckParentEmailExistsDocument = gql`
    query CheckParentEmailExists($email: String!) {
  espin_user(where: {email: {_eq: $email}, role: {_eq: espin_parent_user}}) {
    id
    parent_profile {
      id
    }
  }
}
    `;
export const AdminLinkParentToChildDocument = gql`
    mutation AdminLinkParentToChild($playerProfileId: uuid!, $parentProfileId: uuid!) {
  update_espin_player_profile_by_pk(
    pk_columns: {id: $playerProfileId}
    _set: {parent_profile_id: $parentProfileId}
  ) {
    id
  }
}
    `;
export const AdminCreateParentFromInviteDocument = gql`
    mutation AdminCreateParentFromInvite($input: espin_parent_profile_insert_input!, $inviteId: uuid!) {
  insert_espin_parent_profile_one(
    object: $input
    on_conflict: {constraint: parent_profile_user_id_key, update_columns: [updated_at]}
  ) {
    id
  }
  update_espin_parent_invite_by_pk(
    pk_columns: {id: $inviteId}
    _set: {status: accepted}
  ) {
    id
    status
  }
}
    `;
export const OrgIhsenIndexDocument = gql`
    query OrgIhsenIndex {
  espin_org_month(where: {org: {definition: {_eq: "ihsen_fed"}}}) {
    month
    total_days
    start_day
    month_of_year
    days {
      date
      title
      time
      game_def
      game {
        game_definition
      }
    }
  }
}
    `;
export const OrgIhsenRankingsDocument = gql`
    query OrgIhsenRankings {
  espin_org_player(
    where: {org: {definition: {_eq: "ihsen_fed"}}}
    order_by: {rank: asc}
    limit: 20
  ) {
    rank
    gpa
    grad_class
    game_rank
    username
    game {
      name
      game_definition
    }
    school {
      display_name
      city
      state
    }
  }
  espin_org_school(
    where: {org: {definition: {_eq: "ihsen_fed"}}}
    limit: 10
    order_by: {rank: asc}
  ) {
    display_name
    city
    state
    rank
    bio
    records {
      wins
      losses
      game {
        game_definition
        name
      }
    }
  }
}
    `;
export const OrgIhsenRecruitingDocument = gql`
    query OrgIhsenRecruiting {
  espin_college(limit: 8, where: {address: {state: {_eq: "Indiana"}}}) {
    ...CollegeCard
    id
    name
    program_name
    subscribed
    address {
      city
      state
      country
    }
  }
  espin_org_player(
    where: {_and: [{org: {definition: {_eq: "ihsen_fed"}}}, {featured: {_eq: true}}]}
    limit: 8
  ) {
    player_review
    rank
    featured
    gpa
    grad_class
    game_rank
    username
    game {
      name
      game_definition
    }
    school {
      display_name
      city
      state
    }
  }
  espin_org_school(
    where: {_and: [{org: {definition: {_eq: "ihsen_fed"}}}, {featured: {_eq: true}}]}
    limit: 6
  ) {
    display_name
    city
    state
    rank
    bio
    featured
    records {
      wins
      losses
      game {
        game_definition
        name
      }
    }
  }
}
    ${CollegeCardFragmentDoc}`;
export const OrgIhseaIndexDocument = gql`
    query OrgIhseaIndex {
  espin_org_month(where: {org: {definition: {_eq: "ihsea_fed"}}}) {
    month
    total_days
    start_day
    month_of_year
    days {
      date
      title
      time
      game_def
      game {
        game_definition
      }
    }
  }
}
    `;
export const OrgIhseaRankingDocument = gql`
    query OrgIhseaRanking {
  espin_org_player(
    where: {org: {definition: {_eq: "ihsea_fed"}}}
    order_by: {rank: asc}
    limit: 20
  ) {
    rank
    gpa
    grad_class
    game_rank
    username
    game {
      name
      game_definition
    }
    school {
      display_name
      city
      state
    }
  }
  espin_org_school(
    where: {org: {definition: {_eq: "ihsea_fed"}}}
    limit: 10
    order_by: {rank: asc}
  ) {
    display_name
    city
    state
    rank
    bio
    records {
      wins
      losses
      game {
        game_definition
        name
      }
    }
  }
}
    `;
export const OrgIhseaRecruitingDocument = gql`
    query OrgIhseaRecruiting {
  espin_college(limit: 8, where: {address: {state: {_eq: "Illinois"}}}) {
    ...CollegeCard
    id
    name
    program_name
    subscribed
    address {
      city
      state
      country
    }
  }
  espin_org_player(
    where: {_and: [{org: {definition: {_eq: "ihsea_fed"}}}, {featured: {_eq: true}}]}
    limit: 8
  ) {
    player_review
    rank
    featured
    gpa
    grad_class
    game_rank
    username
    game {
      name
      game_definition
    }
    school {
      display_name
      city
      state
    }
  }
  espin_org_school(
    where: {_and: [{org: {definition: {_eq: "ihsea_fed"}}}, {featured: {_eq: true}}]}
    limit: 6
  ) {
    display_name
    city
    state
    rank
    bio
    featured
    records {
      wins
      losses
      game {
        game_definition
        name
      }
    }
  }
}
    ${CollegeCardFragmentDoc}`;
export const OrgPlayvsIndexDocument = gql`
    query OrgPlayvsIndex {
  espin_org_month(where: {org: {definition: {_eq: "playvs"}}}) {
    month
    total_days
    start_day
    month_of_year
    days {
      date
      title
      time
      game_def
      game {
        game_definition
      }
    }
  }
}
    `;
export const OrgPlayVsRankingsDocument = gql`
    query OrgPlayVsRankings {
  espin_org_player(
    where: {org: {definition: {_eq: "playvs"}}}
    order_by: {rank: asc}
    limit: 20
  ) {
    rank
    gpa
    grad_class
    game_rank
    username
    game {
      name
      game_definition
    }
    school {
      display_name
      city
      state
    }
  }
  espin_org_school(
    where: {org: {definition: {_eq: "playvs"}}}
    limit: 10
    order_by: {rank: asc}
  ) {
    display_name
    city
    state
    rank
    bio
    records {
      wins
      losses
      game {
        game_definition
        name
      }
    }
  }
}
    `;
export const OrgPlayVsRecruitingDocument = gql`
    query OrgPlayVsRecruiting {
  espin_college(limit: 12) {
    ...CollegeCard
    id
    name
    program_name
    subscribed
    address {
      city
      state
      country
    }
  }
  espin_org_player(
    where: {_and: [{org: {definition: {_eq: "playvs"}}}, {featured: {_eq: true}}]}
    limit: 8
  ) {
    player_review
    rank
    featured
    gpa
    grad_class
    game_rank
    username
    game {
      name
      game_definition
    }
    school {
      display_name
      city
      state
    }
  }
  espin_org_school(
    where: {_and: [{org: {definition: {_eq: "playvs"}}}, {featured: {_eq: true}}]}
    limit: 6
  ) {
    display_name
    city
    state
    rank
    bio
    featured
    records {
      wins
      losses
      game {
        game_definition
        name
      }
    }
  }
}
    ${CollegeCardFragmentDoc}`;
export const OrgUfeaIndexDocument = gql`
    query OrgUfeaIndex {
  espin_org_month(where: {org: {definition: {_eq: "ufea"}}}) {
    month
    total_days
    start_day
    month_of_year
    days {
      date
      title
      time
      game_def
      game {
        game_definition
      }
    }
  }
}
    `;
export const OrgUfeaRankingDocument = gql`
    query OrgUfeaRanking {
  espin_org_player(
    where: {org: {definition: {_eq: "ufea"}}}
    order_by: {rank: asc}
    limit: 25
  ) {
    rank
    gpa
    grad_class
    game_rank
    username
    game {
      name
      game_definition
    }
    school {
      display_name
      city
      state
    }
  }
  espin_org_school(
    where: {org: {definition: {_eq: "ufea"}}}
    limit: 10
    order_by: {rank: asc}
  ) {
    display_name
    city
    state
    rank
    bio
    featured
    records {
      wins
      losses
      game {
        game_definition
        name
      }
    }
  }
}
    `;
export const OrgUfeaRecruitingDocument = gql`
    query OrgUfeaRecruiting {
  espin_college(
    limit: 12
    where: {_or: [{subscribed: {_eq: true}}, {subscription: {status: {_eq: active}}}]}
  ) {
    ...CollegeCard
    id
    name
    program_name
    subscribed
    address {
      city
      state
      country
    }
  }
  espin_org_player(
    where: {_and: [{org: {definition: {_eq: "ufea"}}}, {featured: {_eq: true}}]}
    limit: 8
  ) {
    player_review
    rank
    featured
    gpa
    grad_class
    game_rank
    username
    game {
      name
      game_definition
    }
    school {
      display_name
      city
      state
    }
  }
  espin_org_school(
    where: {_and: [{org: {definition: {_eq: "ufea"}}}, {featured: {_eq: true}}]}
    limit: 6
  ) {
    display_name
    city
    state
    rank
    bio
    records {
      wins
      losses
      game {
        game_definition
        name
      }
    }
  }
}
    ${CollegeCardFragmentDoc}`;
export const PlayerJourneyBySlugDocument = gql`
    query PlayerJourneyBySlug {
  espin_player_journey {
    id
    ...PlayerProfileForJourney
    player_journey_stages {
      ...StageWrapperInfo
      colleges {
        ...PlayerJourneyCollege
      }
    }
  }
}
    ${PlayerProfileForJourneyFragmentDoc}
${StageWrapperInfoFragmentDoc}
${PlayerJourneyCollegeFragmentDoc}`;
export const Player_DetailsDocument = gql`
    query Player_Details($slug: String!) {
  espin_player_profile(
    where: {_and: [{slug: {_ilike: $slug}}, {user: {deleted_at: {_is_null: true}}}]}
  ) {
    ...PlayerProfile
  }
}
    ${PlayerProfileFragmentDoc}`;
export const RecordProfileViewDocument = gql`
    mutation RecordProfileView($input: espin_profile_view_insert_input!) {
  insert_espin_profile_view_one(object: $input) {
    id
  }
}
    `;
export const Players_IndexDocument = gql`
    query Players_Index {
  ...PlayerSearchFilter
}
    ${PlayerSearchFilterFragmentDoc}`;
export const SearchPlayersDocument = gql`
    query SearchPlayers($search: espin_player_profile_bool_exp!, $offset: Int! = 0, $pageSize: Int! = 50, $orderBy: [espin_player_profile_order_by!] = {spin_username: asc}) {
  espin_player_profile(
    where: $search
    order_by: $orderBy
    limit: $pageSize
    offset: $offset
  ) {
    id
    ...PlayerListItem
    ...PlayerCard
  }
  espin_player_profile_aggregate(where: $search, order_by: $orderBy) {
    aggregate {
      count
    }
  }
}
    ${PlayerListItemFragmentDoc}
${PlayerCardFragmentDoc}`;
export const GetCurrentCollegeUserLocationDocument = gql`
    query GetCurrentCollegeUserLocation($id: uuid!) {
  espin_college_by_pk(id: $id) {
    address {
      location
    }
  }
}
    `;
export const GetCollegeUserIdPairsDocument = gql`
    query GetCollegeUserIdPairs {
  espin_user(where: {role: {_eq: espin_college_user}}, limit: 10) {
    id
    college_profile {
      college_id
    }
  }
}
    `;
export const ChangeCollegeToManualSubDocument = gql`
    mutation ChangeCollegeToManualSub($collegeId: uuid!) {
  update_espin_college_by_pk(
    pk_columns: {id: $collegeId}
    _set: {subscribed: true, manual_subtier: 1}
  ) {
    id
    updated_at
    name
  }
}
    `;
export const FindCollegeBySlugDocument = gql`
    query FindCollegeBySlug($slug: String!) {
  espin_college(where: {slug: {_eq: $slug}}) {
    id
  }
}
    `;
export const ContentFilesDocument = gql`
    query ContentFiles {
  content_file {
    original_name
    id
  }
}
    `;
export const CreateGameDocument = gql`
    mutation CreateGame($input: espin_game_insert_input!) {
  insert_espin_game_one(object: $input) {
    game_definition
  }
}
    `;
export const CreateGamesDocument = gql`
    mutation CreateGames($input: [espin_game_insert_input!]!) {
  insert_espin_game(
    objects: $input
    on_conflict: {constraint: game_name_key, update_columns: [website, image_url, team_max_size]}
  ) {
    returning {
      game_definition
    }
  }
}
    `;
export const CreatePlayerDocument = gql`
    mutation CreatePlayer($input: espin_user_insert_input!) {
  insert_espin_user_one(object: $input) {
    id
  }
}
    `;
export const CreateCollegeDocument = gql`
    mutation CreateCollege($input: espin_college_insert_input!) {
  insert_espin_college_one(object: $input) {
    id
  }
}
    `;
export const SeedCreatePlayerTeamDocument = gql`
    mutation SeedCreatePlayerTeam($input: espin_team_insert_input!) {
  insert_espin_team_one(object: $input) {
    id
  }
}
    `;
export const CreateHighSchoolDocument = gql`
    mutation CreateHighSchool($input: espin_high_school_insert_input!) {
  insert_espin_high_school_one(object: $input) {
    id
  }
}
    `;
export const BulkCreateCollegeDocument = gql`
    mutation BulkCreateCollege($input: [espin_college_insert_input!]!) {
  insert_espin_college(objects: $input) {
    returning {
      id
    }
  }
}
    `;
export const SeedCreateEventDocument = gql`
    mutation SeedCreateEvent($input: espin_event_insert_input!) {
  insert_espin_event_one(object: $input) {
    ...SeedEventCreatedReturn
  }
}
    ${SeedEventCreatedReturnFragmentDoc}`;
export const SeedHighSchoolAndProfileDocument = gql`
    mutation SeedHighSchoolAndProfile($input: espin_high_school_profile_insert_input!) {
  insert_espin_high_school_profile_one(object: $input) {
    id
    user_id
  }
}
    `;
export const SeedPlayerAndProfileDocument = gql`
    mutation SeedPlayerAndProfile($input: espin_player_profile_insert_input!) {
  insert_espin_player_profile_one(
    object: $input
    on_conflict: {constraint: player_profile_user_id_key, update_columns: [bio, spin_username, slug]}
  ) {
    id
    user_id
    user {
      email
    }
  }
}
    `;
export const BulkSeedPlayerAndProfileDocument = gql`
    mutation BulkSeedPlayerAndProfile($input: [espin_player_profile_insert_input!]!) {
  insert_espin_player_profile(
    objects: $input
    on_conflict: {constraint: player_profile_user_id_key, update_columns: [bio, spin_username, slug]}
  ) {
    returning {
      id
      user_id
    }
  }
}
    `;
export const SeedCollegeUserAndProfileDocument = gql`
    mutation SeedCollegeUserAndProfile($input: espin_college_profile_insert_input!) {
  insert_espin_college_profile_one(
    object: $input
    on_conflict: {constraint: college_profile_user_id_key, update_columns: [first_name, last_name]}
  ) {
    id
  }
}
    `;
export const SeedHighSchoolUserAndProfileDocument = gql`
    mutation SeedHighSchoolUserAndProfile($input: espin_high_school_profile_insert_input!) {
  insert_espin_high_school_profile_one(
    object: $input
    on_conflict: {constraint: high_school_profile_user_id_key, update_columns: [first_name, last_name]}
  ) {
    id
  }
}
    `;
export const BulkSeedCollegeUserAndProfileDocument = gql`
    mutation BulkSeedCollegeUserAndProfile($input: [espin_college_profile_insert_input!]!) {
  insert_espin_college_profile(
    objects: $input
    on_conflict: {constraint: college_profile_user_id_key, update_columns: [first_name, last_name]}
  ) {
    returning {
      id
    }
  }
}
    `;
export const BulkSeedParentUserAndProfileDocument = gql`
    mutation BulkSeedParentUserAndProfile($input: [espin_parent_profile_insert_input!]!) {
  insert_espin_parent_profile(
    objects: $input
    on_conflict: {constraint: parent_profile_user_id_key, update_columns: [first_name, last_name]}
  ) {
    returning {
      id
    }
  }
}
    `;
export const SeedAddNewUnregisteredCollegeDocument = gql`
    mutation SeedAddNewUnregisteredCollege($programName: String) {
  insert_espin_unregistered_college_one(object: {program_name: $programName}) {
    id
    program_name
  }
}
    `;
export const SeedAddNewLeaderboardDocument = gql`
    mutation SeedAddNewLeaderboard($leaderboard: espin_leaderboard_insert_input!) {
  insert_espin_leaderboard_one(object: $leaderboard) {
    id
  }
}
    `;
export const SeedAddUserSourcesDocument = gql`
    mutation SeedAddUserSources($input: [espin_user_source_insert_input!]!) {
  insert_espin_user_source(objects: $input) {
    affected_rows
  }
}
    `;
export const SeedAddNewReferralOptionDocument = gql`
    mutation SeedAddNewReferralOption($option: espin_referral_option_insert_input!) {
  insert_espin_referral_option_one(object: $option) {
    id
  }
}
    `;
export const SeedAddContentFilesDocument = gql`
    mutation SeedAddContentFiles($input: [content_file_insert_input!]!) {
  insert_content_file(
    objects: $input
    on_conflict: {constraint: file_pkey, update_columns: []}
  ) {
    returning {
      id
    }
  }
}
    `;
export const SeedAddMediaLinksDocument = gql`
    mutation SeedAddMediaLinks($input: [content_media_link_insert_input!]!) {
  insert_content_media_link(
    objects: $input
    on_conflict: {constraint: media_link_pkey, update_columns: []}
  ) {
    returning {
      id
    }
  }
}
    `;
export const UpdateCollegeUserProfileDocument = gql`
    mutation UpdateCollegeUserProfile($profileId: uuid!, $input: espin_college_profile_set_input!) {
  update_espin_college_profile_by_pk(pk_columns: {id: $profileId}, _set: $input) {
    id
  }
}
    `;
export const SeedParentUserAndProfileDocument = gql`
    mutation SeedParentUserAndProfile($input: espin_parent_profile_insert_input!) {
  insert_espin_parent_profile_one(
    object: $input
    on_conflict: {constraint: parent_profile_user_id_key, update_columns: [first_name, last_name]}
  ) {
    id
  }
}
    `;
export const SeedAddNotificationsDocument = gql`
    mutation SeedAddNotifications($input: [espin_notification_insert_input!]!) {
  insert_espin_notification(
    objects: $input
    on_conflict: {constraint: notification_pkey, update_columns: []}
  ) {
    returning {
      id
    }
  }
}
    `;
export const SeedCreateReferralCodesDocument = gql`
    mutation SeedCreateReferralCodes($input: [espin_referral_code_insert_input!]!) {
  insert_espin_referral_code(
    objects: $input
    on_conflict: {constraint: referral_code_pkey, update_columns: []}
  ) {
    returning {
      id
    }
  }
}
    `;
export const SeedCreateEventRegistrationsDocument = gql`
    mutation SeedCreateEventRegistrations($input: [espin_event_registration_insert_input!]!) {
  insert_espin_event_registration(objects: $input) {
    affected_rows
  }
}
    `;
export const ScriptSetCollegeOwnerDocument = gql`
    mutation ScriptSetCollegeOwner($collegeId: uuid!, $collegeOwnerId: uuid!) {
  update_espin_college_by_pk(
    pk_columns: {id: $collegeId}
    _set: {owner_profile_id: $collegeOwnerId}
  ) {
    id
    updated_at
    owner_profile_id
  }
}
    `;
export const ScriptGetCollegesWithoutOwnersDocument = gql`
    query ScriptGetCollegesWithoutOwners {
  espin_college(where: {owner_profile_id: {_is_null: true}}) {
    id
    name
    college_profiles {
      id
      user_id
      user {
        email
      }
    }
  }
}
    `;
export const AdminCreateUserDocument = gql`
    mutation AdminCreateUser($input: espin_user_insert_input!) {
  insert_espin_user_one(
    object: $input
    on_conflict: {update_columns: [updated_at, email], constraint: user_pkey}
  ) {
    id
    role
    email
  }
}
    `;
export const LinkExternalProviderDocument = gql`
    mutation LinkExternalProvider($link: espin_external_provider_link_insert_input!) {
  insert_espin_external_provider_link_one(
    object: $link
    on_conflict: {constraint: unique_provider_external_link_id, update_columns: [subscription_expiry]}
  ) {
    id
    external_id
  }
}
    `;
export const LinkEspinUserToExternalProviderDocument = gql`
    mutation LinkEspinUserToExternalProvider($userID: String!, $externalLinkID: uuid!) {
  insert_espin_user_linked_external_provider_one(
    object: {user_id: $userID, link_id: $externalLinkID}
  ) {
    id
    link_id
    user_id
  }
}
    `;
export const GetUserByIdDocument = gql`
    query GetUserById($userId: String) {
  espin_user(where: {id: {_eq: $userId}}) {
    college_profile {
      id
      user_id
    }
    role
  }
}
    `;
export const GetSchoolIdDocument = gql`
    query GetSchoolID($userId: String!) {
  espin_user(where: {id: {_eq: $userId}}) {
    college_profile {
      college_id
    }
  }
}
    `;
export const LinkedUserDocument = gql`
    query LinkedUser($userId: String!) {
  espin_user_linked_external_provider(where: {user_id: {_eq: $userId}}) {
    id
  }
}
    `;
export const UnlinkUserDocument = gql`
    mutation UnlinkUser($userId: String!) {
  delete_espin_user_linked_external_provider(where: {user_id: {_eq: $userId}}) {
    returning {
      id
    }
  }
}
    `;
export const GetExternalProviderLinkByExternalIdDocument = gql`
    query GetExternalProviderLinkByExternalId($externalId: String!) {
  espin_external_provider_link(where: {external_id: {_eq: $externalId}}) {
    id
  }
}
    `;
export const AdminSetAutomatedMessageResponseDocument = gql`
    mutation AdminSetAutomatedMessageResponse($collegeId: uuid!, $automaticMessageResponseType: espin_college_automatic_message_response_type_enum!) {
  update_espin_college_preferences(
    where: {college_id: {_eq: $collegeId}}
    _set: {automatic_message_response_type: $automaticMessageResponseType}
  ) {
    returning {
      id
    }
  }
}
    `;
export const AdminGetPlayerSlugFromSpinUsernameDocument = gql`
    query AdminGetPlayerSlugFromSpinUsername($spin_username: String!) {
  espin_player_profile(where: {spin_username: {_eq: $spin_username}}) {
    slug
  }
}
    `;
export const AdminBulkGetPlayerSlugFromSpinUsernameDocument = gql`
    query AdminBulkGetPlayerSlugFromSpinUsername($spin_usernames: [String!]!) {
  espin_player_profile(where: {spin_username: {_in: $spin_usernames}}) {
    spin_username
    slug
  }
}
    `;
export const CreateKeyValueStoreDocument = gql`
    mutation CreateKeyValueStore($content: jsonb!) {
  insert_tempstorage_keyvalue_one(object: {content: $content}) {
    id
  }
}
    `;
export const GetKeyValueStoreDocument = gql`
    query GetKeyValueStore($id: uuid!) {
  tempstorage_keyvalue_by_pk(id: $id) {
    content
  }
}
    `;
export const FindPurchaserByEmailDocument = gql`
    query FindPurchaserByEmail($email: String!) {
  espin_user(where: {email: {_eq: $email}}) {
    id
    email
    role
    player_profile {
      spin_username
      slug
      player_subscription_id
      trial_end_date
    }
    college_profile {
      college {
        id
        name
        college_subscription_id
      }
    }
  }
  stripe_customer_data(where: {email: {_eq: $email}}) {
    user_id
    customer_id
    email
  }
}
    `;
export const AddCustomerDocument = gql`
    mutation AddCustomer($input: stripe_customer_data_insert_input!, $onConflict: stripe_customer_data_on_conflict!) {
  insert_stripe_customer_data_one(object: $input, on_conflict: $onConflict) {
    customer_id
    email
  }
}
    `;
export const UpsertCollegeSubscriptionDocument = gql`
    mutation UpsertCollegeSubscription($invoice: stripe_invoice_data_insert_input!, $sub: espin_college_insert_input!) {
  insert_stripe_invoice_data_one(object: $invoice) {
    id
  }
  insert_espin_college_one(
    object: $sub
    on_conflict: {constraint: college_pkey, update_columns: [college_subscription_id]}
  ) {
    id
    subscribed
    subscription {
      expires
      id
    }
  }
}
    `;
export const UpsertPlayerSubscriptionDocument = gql`
    mutation UpsertPlayerSubscription($invoice: stripe_invoice_data_insert_input!, $sub: espin_player_profile_insert_input!) {
  insert_stripe_invoice_data_one(object: $invoice) {
    id
  }
  insert_espin_player_profile_one(
    object: $sub
    on_conflict: {constraint: player_profile_user_id_key, update_columns: [player_subscription_id]}
  ) {
    id
    subscription {
      expires
      id
    }
  }
}
    `;
export const CreateReferralPlayerSubscriptionDocument = gql`
    mutation CreateReferralPlayerSubscription($sub: espin_player_profile_insert_input!) {
  insert_espin_player_profile_one(
    object: $sub
    on_conflict: {constraint: player_profile_user_id_key, update_columns: [player_subscription_id]}
  ) {
    id
    subscription {
      expires
      id
    }
  }
}
    `;
export const CreateReferralCollegeSubscriptionDocument = gql`
    mutation CreateReferralCollegeSubscription($sub: espin_college_insert_input!) {
  insert_espin_college_one(
    object: $sub
    on_conflict: {constraint: college_pkey, update_columns: [college_subscription_id]}
  ) {
    id
    subscription {
      expires
      id
    }
  }
}
    `;
export const ExpireLapsedSubscriptionsDocument = gql`
    mutation ExpireLapsedSubscriptions($ts: bigint!) {
  update_espin_college_subscription(
    where: {status: {_eq: active}, expires: {_lt: $ts}}
    _set: {status: lapsed}
  ) {
    affected_rows
  }
  update_espin_player_subscription(
    where: {status: {_eq: active}, expires: {_lt: $ts}}
    _set: {status: lapsed}
  ) {
    affected_rows
  }
}
    `;
export const UpdateGeoLocationDocument = gql`
    mutation UpdateGeoLocation($id: uuid!, $input: espin_address_set_input!) {
  update_espin_address_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export const FindNullAddressLocationsDocument = gql`
    query FindNullAddressLocations {
  espin_address(
    where: {_or: [{_and: [{location: {_is_null: true}}, {country: {_eq: "United States"}}, {city: {_neq: ""}}, {state: {_neq: ""}}]}, {_and: [{location: {_is_null: true}}, {city: {_neq: ""}}, {country: {_neq: "United States"}}, {country: {_neq: ""}}]}]}
    limit: 50
  ) {
    id
    state
    city
    country
    street_one
  }
}
    `;
export const FindSpinJobsForProcessingDocument = gql`
    query FindSpinJobsForProcessing($limit: Int = 100) {
  queue_job(
    where: {status: {_eq: waiting}}
    limit: $limit
    order_by: {created_at: desc}
  ) {
    ...SpinJobData
  }
}
    ${SpinJobDataFragmentDoc}`;
export const SetJobsAsProcessingDocument = gql`
    mutation SetJobsAsProcessing($jobIdArray: [uuid!] = []) {
  update_queue_job(where: {id: {_in: $jobIdArray}}, _set: {status: processing}) {
    affected_rows
  }
}
    `;
export const UpdateJobResultDocument = gql`
    mutation UpdateJobResult($jobId: uuid!, $update: queue_job_set_input!) {
  update_queue_job_by_pk(pk_columns: {id: $jobId}, _set: $update) {
    updated_at
  }
}
    `;
export const FindCollegesWithFollowsSinceDocument = gql`
    query FindCollegesWithFollowsSince($since: timestamptz!, $followPreference: espin_follower_email_notification_type_enum!) {
  espin_follow(
    distinct_on: player_user_id
    where: {follow_type: {_eq: player_follows_college}, created_at: {_gte: $since}, college: {college_profiles: {user: {email_follow_preference: {_eq: $followPreference}}}}}
  ) {
    college_id
  }
  high_school_follows: espin_follow(
    distinct_on: high_school_id
    where: {follow_type: {_eq: high_school_follows_college}, created_at: {_gte: $since}, college: {college_profiles: {user: {email_follow_preference: {_eq: $followPreference}}}}}
  ) {
    college_id
  }
}
    `;
export const FindHighSchoolsWithFollowsSinceDocument = gql`
    query FindHighSchoolsWithFollowsSince($since: timestamptz!, $followPreference: espin_follower_email_notification_type_enum!) {
  espin_follow(
    distinct_on: college_id
    where: {follow_type: {_eq: college_follows_high_school}, created_at: {_gte: $since}, high_school: {high_school_profiles: {user: {email_follow_preference: {_eq: $followPreference}}}}}
  ) {
    high_school_id
  }
}
    `;
export const GrabUserRoleByEmailDocument = gql`
    query GrabUserRoleByEmail($email: String) {
  espin_user(where: {email: {_eq: $email}}) {
    role
  }
}
    `;
export const IsNewSubscriberDocument = gql`
    query IsNewSubscriber($email: String) {
  stripe_invoice_data_aggregate(where: {customer_email: {_eq: $email}}) {
    aggregate {
      count
    }
  }
}
    `;
export const FindPlayersWithFollowsSinceDocument = gql`
    query FindPlayersWithFollowsSince($since: timestamptz!, $followPreference: espin_follower_email_notification_type_enum!) {
  espin_follow(
    distinct_on: college_id
    where: {follow_type: {_eq: college_follows_player}, created_at: {_gte: $since}, player_user: {email_follow_preference: {_eq: $followPreference}}}
  ) {
    player_user_id
  }
}
    `;
export const FindPlayersWithNewMessagesSinceDocument = gql`
    query FindPlayersWithNewMessagesSince($since: timestamptz!, $messagePreference: espin_message_email_notification_type_enum!) {
  espin_message(
    distinct_on: [college_id, player_user_id]
    where: {message_type: {_eq: college_messages_player}, created_at: {_gte: $since}, player_user: {email_message_preference: {_eq: $messagePreference}}}
  ) {
    player_user_id
  }
}
    `;
export const FindCollegesWithNewMessagesSinceDocument = gql`
    query FindCollegesWithNewMessagesSince($since: timestamptz!, $messagePreference: espin_message_email_notification_type_enum!) {
  espin_message(
    distinct_on: [player_user_id, college_id]
    where: {message_type: {_eq: player_messages_college}, created_at: {_gte: $since}, college: {college_profiles: {user: {email_message_preference: {_eq: $messagePreference}}}}}
  ) {
    college_id
  }
  high_school_messages: espin_message(
    distinct_on: [high_school_id, college_id]
    where: {message_type: {_eq: high_school_messages_college}, created_at: {_gte: $since}, college: {college_profiles: {user: {email_message_preference: {_eq: $messagePreference}}}}}
  ) {
    college_id
  }
}
    `;
export const FindHighSchoolsWithNewMessagesSinceDocument = gql`
    query FindHighSchoolsWithNewMessagesSince($since: timestamptz!, $messagePreference: espin_message_email_notification_type_enum!) {
  espin_message(
    distinct_on: [high_school_id, college_id]
    where: {message_type: {_eq: college_messages_high_school}, created_at: {_gte: $since}, high_school: {high_school_profiles: {user: {email_message_preference: {_eq: $messagePreference}}}}}
  ) {
    high_school_id
  }
}
    `;
export const FindPlayersWithProfileViewsSinceDocument = gql`
    query FindPlayersWithProfileViewsSince($since: timestamptz!, $profileViewPreference: espin_profile_view_email_notification_type_enum!) {
  espin_profile_view(
    distinct_on: player_user_id
    where: {profile_view_type: {_eq: college_views_player}, created_at: {_gte: $since}, player_user: {email_profile_view_preference: {_eq: $profileViewPreference}}}
  ) {
    player_user_id
  }
}
    `;
export const FindCollegesWithProfileViewsSinceDocument = gql`
    query FindCollegesWithProfileViewsSince($since: timestamptz!, $profileViewPreference: espin_profile_view_email_notification_type_enum!) {
  espin_profile_view(
    distinct_on: college_id
    where: {profile_view_type: {_in: [parent_views_college, player_views_college, high_school_views_college]}, created_at: {_gte: $since}, college: {college_profiles: {user: {email_profile_view_preference: {_eq: $profileViewPreference}}}}}
  ) {
    college_id
  }
}
    `;
export const FindHighSchoolsWithProfileViewsSinceDocument = gql`
    query FindHighSchoolsWithProfileViewsSince($since: timestamptz!, $profileViewPreference: espin_profile_view_email_notification_type_enum!) {
  espin_profile_view(
    distinct_on: high_school_id
    where: {profile_view_type: {_eq: college_views_high_school}, created_at: {_gte: $since}, high_school: {high_school_profiles: {user: {email_profile_view_preference: {_eq: $profileViewPreference}}}}}
  ) {
    high_school_id
  }
}
    `;
export const GetNumberOfPlayerProfileViewsSinceDocument = gql`
    query GetNumberOfPlayerProfileViewsSince($since: timestamptz!, $playerUserId: String!) {
  espin_profile_view_aggregate(
    where: {profile_view_type: {_eq: college_views_player}, created_at: {_gte: $since}, player_user_id: {_eq: $playerUserId}}
  ) {
    aggregate {
      count
    }
  }
  espin_user_by_pk(id: $playerUserId) {
    email
    player_profile {
      first_name
      last_name
      parent_email
    }
  }
}
    `;
export const GetNumberOfCollegeProfileViewsSinceDocument = gql`
    query GetNumberOfCollegeProfileViewsSince($since: timestamptz!, $collegeId: uuid!) {
  espin_profile_view_aggregate(
    where: {profile_view_type: {_in: [high_school_views_college, parent_views_college, player_views_college]}, created_at: {_gte: $since}, college_id: {_eq: $collegeId}}
  ) {
    aggregate {
      count
    }
  }
  espin_college_by_pk(id: $collegeId) {
    name
    program_name
    college_profiles {
      user {
        email
      }
    }
  }
}
    `;
export const GetNumberOfHighSchoolProfileViewsSinceDocument = gql`
    query GetNumberOfHighSchoolProfileViewsSince($since: timestamptz!, $highSchoolId: uuid!) {
  espin_profile_view_aggregate(
    where: {profile_view_type: {_eq: college_views_high_school}, created_at: {_gte: $since}, high_school_id: {_eq: $highSchoolId}}
  ) {
    aggregate {
      count
    }
  }
  espin_high_school_by_pk(id: $highSchoolId) {
    name
    high_school_profiles {
      user {
        email
      }
    }
  }
}
    `;
export const GetDetailsForNewMessageToCollegeEmailDocument = gql`
    query GetDetailsForNewMessageToCollegeEmail($playerUserId: String!, $collegeId: uuid!) {
  espin_college_by_pk(id: $collegeId) {
    name
    college_profiles {
      user {
        email_message_preference
        email
        subscription_status {
          is_subscribed
        }
      }
    }
  }
  espin_user_by_pk(id: $playerUserId) {
    player_profile {
      first_name
      last_name
    }
  }
  espin_message_aggregate(
    where: {player_user_id: {_eq: $playerUserId}, college_id: {_eq: $collegeId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const GetDetailsForNewMessageToCollegeEmailFromHsDocument = gql`
    query GetDetailsForNewMessageToCollegeEmailFromHs($highSchoolId: uuid!, $collegeId: uuid!) {
  espin_college_by_pk(id: $collegeId) {
    name
    college_profiles {
      user {
        email_message_preference
        email
        subscription_status {
          is_subscribed
        }
      }
    }
  }
  espin_high_school_by_pk(id: $highSchoolId) {
    name
  }
  espin_message_aggregate(
    where: {high_school_id: {_eq: $highSchoolId}, college_id: {_eq: $collegeId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const GetDetailsForNewMessageToHighSchoolEmailDocument = gql`
    query GetDetailsForNewMessageToHighSchoolEmail($highSchoolId: uuid!, $collegeUserId: String!, $collegeId: uuid!) {
  espin_college_by_pk(id: $collegeId) {
    name
    program_name
    college_owner {
      first_name
      last_name
    }
  }
  college_user: espin_user_by_pk(id: $collegeUserId) {
    college_profile {
      first_name
      last_name
    }
  }
  espin_high_school_by_pk(id: $highSchoolId) {
    name
    high_school_profiles {
      user {
        email
        email_message_preference
      }
    }
  }
  espin_message_aggregate(
    where: {high_school_id: {_eq: $highSchoolId}, college_id: {_eq: $collegeId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const GetDetailsForNewMessageToPlayerEmailDocument = gql`
    query GetDetailsForNewMessageToPlayerEmail($playerUserId: String!, $collegeUserId: String!, $collegeId: uuid!) {
  espin_college_by_pk(id: $collegeId) {
    name
    program_name
    college_owner {
      first_name
      last_name
    }
  }
  college_user: espin_user_by_pk(id: $collegeUserId) {
    college_profile {
      first_name
      last_name
    }
  }
  player_user: espin_user_by_pk(id: $playerUserId) {
    email
    email_message_preference
    subscription_status {
      is_subscribed
    }
    player_profile {
      first_name
      last_name
      parent_email
    }
  }
  espin_message_aggregate(
    where: {player_user_id: {_eq: $playerUserId}, college_id: {_eq: $collegeId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const GetNewConversationsForPlayerSinceDocument = gql`
    query GetNewConversationsForPlayerSince($since: timestamptz!, $playerUserId: String!) {
  last_ten_messages: espin_message(
    distinct_on: college_id
    where: {message_type: {_eq: college_messages_player}, player_user_id: {_eq: $playerUserId}, created_at: {_gte: $since}}
    limit: 10
    order_by: [{college_id: asc}, {created_at: desc}]
  ) {
    college_id
    college {
      name
    }
    contents
  }
  message_count: espin_message_aggregate(
    distinct_on: college_id
    where: {message_type: {_eq: college_messages_player}, player_user_id: {_eq: $playerUserId}, created_at: {_gte: $since}}
    order_by: [{college_id: asc}, {created_at: desc}]
  ) {
    aggregate {
      count
    }
  }
  player_info: espin_user_by_pk(id: $playerUserId) {
    email
    subscription_status {
      is_subscribed
    }
    player_profile {
      first_name
      last_name
      parent_email
    }
  }
}
    `;
export const GetNewConversationsForHighSchoolSinceDocument = gql`
    query GetNewConversationsForHighSchoolSince($since: timestamptz!, $highSchoolId: uuid!) {
  last_ten_messages: espin_message(
    distinct_on: college_id
    where: {message_type: {_eq: college_messages_high_school}, high_school_id: {_eq: $highSchoolId}, created_at: {_gte: $since}}
    limit: 10
    order_by: [{college_id: asc}, {created_at: desc}]
  ) {
    college_id
    college {
      name
    }
    contents
  }
  message_count: espin_message_aggregate(
    distinct_on: college_id
    where: {message_type: {_eq: college_messages_high_school}, high_school_id: {_eq: $highSchoolId}, created_at: {_gte: $since}}
    order_by: [{college_id: asc}, {created_at: desc}]
  ) {
    aggregate {
      count
    }
  }
  espin_high_school_by_pk(id: $highSchoolId) {
    name
    high_school_profiles {
      user {
        email
        email_message_preference
      }
    }
  }
}
    `;
export const GetNewConversationsForCollegeSinceDocument = gql`
    query GetNewConversationsForCollegeSince($since: timestamptz!, $collegeId: uuid!) {
  last_ten_messages: espin_message(
    distinct_on: player_user_id
    where: {message_type: {_eq: player_messages_college}, college_id: {_eq: $collegeId}, created_at: {_gte: $since}}
    limit: 10
    order_by: [{player_user_id: asc}, {created_at: desc}]
  ) {
    player_user {
      player_profile {
        first_name
        last_name
      }
    }
    contents
  }
  hs_last_ten_messages: espin_message(
    distinct_on: high_school_id
    where: {message_type: {_eq: high_school_messages_college}, college_id: {_eq: $collegeId}, created_at: {_gte: $since}}
    limit: 10
    order_by: [{high_school_id: asc}, {created_at: desc}]
  ) {
    high_school {
      name
    }
    contents
  }
  message_count: espin_message_aggregate(
    distinct_on: player_user_id
    where: {message_type: {_eq: player_messages_college}, college_id: {_eq: $collegeId}, created_at: {_gte: $since}}
    limit: 10
    order_by: [{player_user_id: asc}, {created_at: desc}]
  ) {
    aggregate {
      count
    }
  }
  hs_message_count: espin_message_aggregate(
    distinct_on: high_school_id
    where: {message_type: {_eq: high_school_messages_college}, college_id: {_eq: $collegeId}, created_at: {_gte: $since}}
    limit: 10
    order_by: [{high_school_id: asc}, {created_at: desc}]
  ) {
    aggregate {
      count
    }
  }
  college_info: espin_college_by_pk(id: $collegeId) {
    name
    program_name
    college_profiles {
      first_name
      last_name
      user {
        email
        subscription_status {
          is_subscribed
        }
      }
    }
  }
}
    `;
export const GetDetailsForNewFollowOfPlayerDocument = gql`
    query GetDetailsForNewFollowOfPlayer($playerUserId: String!, $collegeUserId: String!, $collegeId: uuid!) {
  espin_college_by_pk(id: $collegeId) {
    name
    program_name
  }
  college_user: espin_user_by_pk(id: $collegeUserId) {
    college_profile {
      first_name
      last_name
    }
  }
  player_user: espin_user_by_pk(id: $playerUserId) {
    email
    email_follow_preference
    player_profile {
      first_name
      last_name
      parent_email
    }
    subscription_status {
      is_subscribed
    }
  }
}
    `;
export const GetDetailsForNewFollowOfHighSchoolDocument = gql`
    query GetDetailsForNewFollowOfHighSchool($highSchoolId: uuid!, $collegeUserId: String!, $collegeId: uuid!) {
  espin_college_by_pk(id: $collegeId) {
    name
    program_name
  }
  espin_high_school_by_pk(id: $highSchoolId) {
    name
    high_school_profiles {
      user {
        email_follow_preference
        email
      }
    }
  }
  college_user: espin_user_by_pk(id: $collegeUserId) {
    college_profile {
      first_name
      last_name
    }
  }
}
    `;
export const GetDetailsForNewFollowOfCollegeDocument = gql`
    query GetDetailsForNewFollowOfCollege($playerUserId: String!, $collegeId: uuid!) {
  espin_college_by_pk(id: $collegeId) {
    name
    program_name
    college_profiles {
      user {
        email_follow_preference
        email
        subscription_status {
          is_subscribed
        }
      }
    }
  }
  player_user: espin_user_by_pk(id: $playerUserId) {
    player_profile {
      first_name
      last_name
    }
  }
}
    `;
export const GetDetailsForNewFollowOfCollegeByHighSchoolDocument = gql`
    query GetDetailsForNewFollowOfCollegeByHighSchool($highSchoolId: uuid!, $collegeId: uuid!) {
  espin_college_by_pk(id: $collegeId) {
    name
    program_name
    college_profiles {
      user {
        email_follow_preference
        email
        subscription_status {
          is_subscribed
        }
      }
    }
  }
  high_school: espin_high_school_by_pk(id: $highSchoolId) {
    name
  }
}
    `;
export const GetNewFollowsForPlayerSinceDocument = gql`
    query GetNewFollowsForPlayerSince($since: timestamptz!, $playerUserId: String!) {
  last_ten_follows: espin_follow(
    distinct_on: college_id
    where: {follow_type: {_eq: college_follows_player}, player_user_id: {_eq: $playerUserId}, created_at: {_gte: $since}}
    limit: 10
    order_by: [{college_id: asc}, {created_at: desc}]
  ) {
    college_id
    college {
      name
    }
  }
  follow_count: espin_follow_aggregate(
    distinct_on: college_id
    where: {follow_type: {_eq: college_follows_player}, player_user_id: {_eq: $playerUserId}, created_at: {_gte: $since}}
    order_by: [{college_id: asc}, {created_at: desc}]
  ) {
    aggregate {
      count
    }
  }
  player_info: espin_user_by_pk(id: $playerUserId) {
    email
    player_profile {
      first_name
      last_name
      parent_email
    }
    subscription_status {
      is_subscribed
    }
  }
}
    `;
export const GetNewFollowsForHighSchoolSinceDocument = gql`
    query GetNewFollowsForHighSchoolSince($since: timestamptz!, $highSchoolId: uuid!) {
  last_ten_follows: espin_follow(
    distinct_on: college_id
    where: {follow_type: {_eq: college_follows_high_school}, high_school_id: {_eq: $highSchoolId}, created_at: {_gte: $since}}
    limit: 10
    order_by: [{college_id: asc}, {created_at: desc}]
  ) {
    college_id
    college {
      name
    }
  }
  follow_count: espin_follow_aggregate(
    distinct_on: college_id
    where: {follow_type: {_eq: college_follows_high_school}, high_school_id: {_eq: $highSchoolId}, created_at: {_gte: $since}}
    order_by: [{college_id: asc}, {created_at: desc}]
  ) {
    aggregate {
      count
    }
  }
  high_school_info: espin_high_school_by_pk(id: $highSchoolId) {
    name
    high_school_profiles {
      first_name
      last_name
      user {
        email
      }
    }
  }
}
    `;
export const AddHighSchoolSlugDocument = gql`
    mutation AddHighSchoolSlug($hsId: uuid!, $newSlug: String!) {
  update_espin_high_school_by_pk(pk_columns: {id: $hsId}, _set: {slug: $newSlug}) {
    id
  }
}
    `;
export const GetNewFollowsForCollegeSinceDocument = gql`
    query GetNewFollowsForCollegeSince($since: timestamptz!, $collegeId: uuid!) {
  last_ten_follows: espin_follow(
    distinct_on: player_user_id
    where: {follow_type: {_eq: player_follows_college}, college_id: {_eq: $collegeId}, created_at: {_gte: $since}}
    limit: 10
    order_by: [{player_user_id: asc}, {created_at: desc}]
  ) {
    player_user {
      player_profile {
        first_name
        last_name
      }
    }
  }
  follow_count: espin_follow_aggregate(
    distinct_on: player_user_id
    where: {follow_type: {_eq: player_follows_college}, college_id: {_eq: $collegeId}, created_at: {_gte: $since}}
    order_by: [{player_user_id: asc}, {created_at: desc}]
  ) {
    aggregate {
      count
    }
  }
  hs_last_ten_follows: espin_follow(
    distinct_on: high_school_id
    where: {follow_type: {_eq: high_school_follows_college}, college_id: {_eq: $collegeId}, created_at: {_gte: $since}}
    limit: 10
    order_by: [{high_school_id: asc}, {created_at: desc}]
  ) {
    high_school {
      name
    }
  }
  hs_follow_count: espin_follow_aggregate(
    distinct_on: high_school_id
    where: {follow_type: {_eq: high_school_follows_college}, college_id: {_eq: $collegeId}, created_at: {_gte: $since}}
    order_by: [{high_school_id: asc}, {created_at: desc}]
  ) {
    aggregate {
      count
    }
  }
  college_info: espin_college_by_pk(id: $collegeId) {
    name
    program_name
    college_profiles {
      first_name
      last_name
      user {
        email
        subscription_status {
          is_subscribed
        }
      }
    }
  }
}
    `;
export const LeaderboardsPageDocument = gql`
    query LeaderboardsPage {
  espin_leaderboard {
    name
    info_title
    info_contents
    dropdown_label
    file {
      id
      original_name
      cdn_url
      ext
    }
  }
}
    `;
export const IsConversationDocument = gql`
    query IsConversation($playerUserId: String!, $collegeId: uuid!) {
  espin_message_aggregate(
    where: {player_user_id: {_eq: $playerUserId}, college_id: {_eq: $collegeId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const GetCollegeAndHighSchoolDetailsDocument = gql`
    query GetCollegeAndHighSchoolDetails($highSchoolId: uuid!, $collegeId: uuid!) {
  high_school: espin_high_school_by_pk(id: $highSchoolId) {
    id
    high_school_owner {
      user_id
      first_name
      last_name
    }
    name
  }
  college: espin_college_by_pk(id: $collegeId) {
    id
    college_owner {
      user_id
      first_name
      last_name
    }
    name
    program_name
  }
}
    `;
export const GetCollegeAndPlayerDetailsDocument = gql`
    query GetCollegeAndPlayerDetails($playerUserId: String!, $collegeId: uuid!) {
  player: espin_user(where: {id: {_eq: $playerUserId}}) {
    player_profile {
      graduating_class
      first_name
      last_name
    }
  }
  college: espin_college_by_pk(id: $collegeId) {
    id
    college_owner {
      user_id
      first_name
      last_name
    }
    name
    program_name
  }
}
    `;
export const AdminCreateNotificationForFollowDocument = gql`
    mutation AdminCreateNotificationForFollow($input: espin_follow_insert_input!) {
  insert_espin_follow_one(
    object: $input
    on_conflict: {constraint: follow_pkey, update_columns: [notification_id]}
  ) {
    id
    notification_id
  }
}
    `;
export const NotifyHighSchoolCoachesDocument = gql`
    mutation NotifyHighSchoolCoaches($input: [espin_notification_insert_input!]!) {
  insert_espin_notification(objects: $input) {
    returning {
      id
    }
  }
}
    `;
export const AdminCreateNotificationForMessageDocument = gql`
    mutation AdminCreateNotificationForMessage($input: espin_message_insert_input!) {
  insert_espin_message_one(
    object: $input
    on_conflict: {constraint: message_pkey, update_columns: [notification_id]}
  ) {
    id
    notification_id
  }
}
    `;
export const AdminCreateNotificationForProfileViewDocument = gql`
    mutation AdminCreateNotificationForProfileView($input: espin_profile_view_insert_input!) {
  insert_espin_profile_view_one(
    object: $input
    on_conflict: {constraint: profile_view_pkey, update_columns: [notification_id]}
  ) {
    id
    notification_id
  }
}
    `;
export const HighSchoolsToNotifyDocument = gql`
    query HighSchoolsToNotify($highSchoolPlayerId: String) {
  espin_team(
    where: {members: {player_profile: {user_id: {_eq: $highSchoolPlayerId}}}, deleted_at: {_is_null: true}}
  ) {
    high_school {
      id
    }
  }
}
    `;
export const CheckIfConversationStartedDocument = gql`
    query CheckIfConversationStarted($collegeId: uuid, $playerUserId: String) {
  espin_message(
    where: {college_id: {_eq: $collegeId}, player_user_id: {_eq: $playerUserId}}
  ) {
    id
  }
}
    `;
export const SetPlayerFreeTrialEndDateDocument = gql`
    mutation SetPlayerFreeTrialEndDate($trialEndDate: timestamptz!, $id: String!) {
  update_espin_player_profile(
    where: {user_id: {_eq: $id}}
    _set: {trial_end_date: $trialEndDate}
  ) {
    affected_rows
  }
}
    `;
export const SetPlayerReferralOptionDocument = gql`
    mutation SetPlayerReferralOption($referralOptionId: uuid!, $id: String!) {
  update_espin_player_profile(
    where: {user_id: {_eq: $id}}
    _set: {referral_option_id: $referralOptionId}
  ) {
    affected_rows
  }
}
    `;
export const GetPlayerReferralOptionDataDocument = gql`
    query GetPlayerReferralOptionData($referralOptionId: uuid!) {
  espin_referral_option_by_pk(id: $referralOptionId) {
    id
    name
  }
}
    `;
export const GetUserIdForStripeAnalyticsDocument = gql`
    query GetUserIdForStripeAnalytics($customer: String!) {
  stripe_customer_data(where: {customer_id: {_eq: $customer}}) {
    user_id
  }
}
    `;
export const CreateSpinJobsDocument = gql`
    mutation CreateSpinJobs($objects: [queue_job_insert_input!]!) {
  insert_queue_job(objects: $objects) {
    affected_rows
  }
}
    `;
export const AdminGetEventRegistrationsDocument = gql`
    query AdminGetEventRegistrations($id: String!) {
  espin_event_registration(
    order_by: {created_at: desc}
    where: {user_id: {_eq: $id}}
  ) {
    id
  }
}
    `;
export const AddSubscriptionInvoiceDocument = gql`
    mutation AddSubscriptionInvoice($email: String, $id: String = "1") {
  insert_stripe_invoice_data_one(
    object: {id: $id, customer_email: $email, account_country: "Canada", amount_paid: 20, attempt_count: 1, customer: "no", status: "idk", subscription: "idc"}
  ) {
    id
  }
}
    `;
export const TestGetPlayerProfileFromParentDocument = gql`
    query TestGetPlayerProfileFromParent($parentId: String!) {
  espin_user_by_pk(id: $parentId) {
    parent_profile {
      child_profiles {
        id
        user_id
      }
    }
  }
}
    `;
export const TestGetParentProfileFromPlayerDocument = gql`
    query TestGetParentProfileFromPlayer($childId: String!) {
  espin_user_by_pk(id: $childId) {
    player_profile {
      parent_email
      parent_profile {
        id
      }
    }
  }
}
    `;
export const TestInviteCollegeUserDocument = gql`
    mutation TestInviteCollegeUser($input: espin_college_invite_insert_input!) {
  insert_espin_college_invite_one(
    object: $input
    on_conflict: {constraint: college_invite_email_key, update_columns: []}
  ) {
    id
  }
}
    `;
export const TestInviteHighSchoolUserDocument = gql`
    mutation TestInviteHighSchoolUser($input: espin_high_school_invite_insert_input!) {
  insert_espin_high_school_invite_one(
    object: $input
    on_conflict: {constraint: espin_high_school_invite_email_high_school_id_key, update_columns: []}
  ) {
    id
  }
}
    `;
export const TestAddParentEmailToPlayerDocument = gql`
    mutation TestAddParentEmailToPlayer($profileId: uuid!, $email: String!) {
  update_espin_player_profile_by_pk(
    pk_columns: {id: $profileId}
    _set: {parent_email: $email}
  ) {
    updated_at
  }
}
    `;
export const AdminUpdateEventRegEndDateDocument = gql`
    mutation AdminUpdateEventRegEndDate($eventId: uuid!, $registerEndDate: timestamptz!) {
  update_espin_event_by_pk(
    pk_columns: {id: $eventId}
    _set: {register_end_date: $registerEndDate}
  ) {
    id
  }
}
    `;
export const GetTicketListDocument = gql`
    query GetTicketList {
  espin_event_ticket {
    id
    price_temp
    game {
      name
      team_max_size
    }
    ticket_type
    event_id
  }
}
    `;
export const TestUpdateHighSchoolProfileDocument = gql`
    mutation TestUpdateHighSchoolProfile($_set: espin_high_school_profile_set_input!, $where: espin_high_school_profile_bool_exp!) {
  update_espin_high_school_profile(_set: $_set, where: $where) {
    affected_rows
  }
}
    `;
export const TestInsertHighSchoolProfileDocument = gql`
    mutation TestInsertHighSchoolProfile($input: espin_high_school_profile_insert_input!) {
  insert_espin_high_school_profile_one(object: $input) {
    id
    high_school {
      id
      teams {
        id
      }
    }
  }
}
    `;
export const TestCreateHighSchoolDocument = gql`
    mutation TestCreateHighSchool($input: espin_high_school_insert_input!) {
  insert_espin_high_school_one(object: $input) {
    id
  }
}
    `;
export const TestUpdateHighSchoolDocument = gql`
    mutation TestUpdateHighSchool($_set: espin_high_school_set_input!, $where: espin_high_school_bool_exp!) {
  update_espin_high_school(_set: $_set, where: $where) {
    affected_rows
  }
}
    `;
export const TestInsertHighSchoolDocument = gql`
    mutation TestInsertHighSchool($input: espin_high_school_insert_input!) {
  insert_espin_high_school_one(object: $input) {
    id
  }
}
    `;
export const GetProfileViewDataDocument = gql`
    query GetProfileViewData {
  espin_profile_view {
    college_id
    notification {
      id
    }
    profile_view_type
  }
}
    `;
export const GetHsProfileViewDataDocument = gql`
    query GetHSProfileViewData {
  espin_profile_view {
    college_id
    high_school_id
    notification {
      id
    }
    profile_view_type
  }
}
    `;
export const TestUpdateInviteStatusDocument = gql`
    mutation TestUpdateInviteStatus($id: uuid!, $input: espin_team_invite_set_input) {
  update_espin_team_invite_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export const TestGetPlayersByCreatedAtDocument = gql`
    query TestGetPlayersByCreatedAt {
  espin_player_profile(order_by: {created_at: asc}) {
    id
  }
}
    `;
export const TestGetTeamInvitesDocument = gql`
    query TestGetTeamInvites($id: uuid = "") {
  espin_team_invite(where: {team_id: {_eq: $id}}) {
    id
    status
    player_profile {
      id
    }
  }
}
    `;
export const TestGetHsTeamDocument = gql`
    query TestGetHSTeam($id: uuid = "") {
  espin_team(where: {high_school_id: {_eq: $id}}) {
    id
  }
}
    `;
export const TestGetPlayerTeamDocument = gql`
    query TestGetPlayerTeam($id: uuid = "") {
  espin_team(where: {members: {player_profile: {id: {_eq: $id}}}}) {
    id
    display_name
    primary_game
    members {
      __typename
      id
      team_role
      player_profile_id
    }
  }
}
    `;
export const TestInsertPlayerTeamDocument = gql`
    mutation TestInsertPlayerTeam($input: espin_team_insert_input!) {
  insert_espin_team_one(object: $input) {
    id
    display_name
    primary_game
    members {
      id
      team_role
      player_profile_id
      player_profile {
        id
        spin_username
        user {
          id
        }
      }
    }
    team_invites {
      id
      status
      player_profile {
        id
        spin_username
      }
    }
  }
}
    `;
export const TestGetPlayerProfileDocument = gql`
    query TestGetPlayerProfile {
  espin_player_profile {
    id
    spin_username
  }
}
    `;
export const TestGetPlayerProfileByPkDocument = gql`
    query TestGetPlayerProfileByPk($id: uuid!) {
  espin_player_profile_by_pk(id: $id) {
    id
    spin_username
  }
}
    `;
export const TestPublicFindPlayerProfilesDocument = gql`
    query TestPublicFindPlayerProfiles {
  espin_player_profile {
    id
  }
}
    `;
export const TestPlayerFindPlayerProfilesDocument = gql`
    query TestPlayerFindPlayerProfiles {
  espin_player_profile {
    id
  }
}
    `;
export const TestAllEspinGamesDocument = gql`
    query TestAllEspinGames {
  espin_game {
    game_definition
    name
  }
}
    `;
export const TestGetByUserPkDocument = gql`
    query TestGetByUserPk($sub: String!) {
  espin_user_by_pk(id: $sub) {
    id
    role
    college_profile {
      id
    }
    player_profile {
      id
    }
  }
}
    `;
export const TestLastLoginForUserByPkDocument = gql`
    query TestLastLoginForUserByPk($sub: String!) {
  espin_user_by_pk(id: $sub) {
    id
    last_login
    updated_at
  }
}
    `;
export const TestAddressesDocument = gql`
    query TestAddresses {
  espin_address {
    id
  }
}
    `;
export const TestParentProfileDocument = gql`
    query TestParentProfile($id: uuid = "") {
  espin_parent_profile_by_pk(id: $id) {
    id
  }
}
    `;
export const TestPlayerProfileDocument = gql`
    query TestPlayerProfile($id: uuid = "") {
  espin_player_profile_by_pk(id: $id) {
    id
  }
}
    `;
export const TestPlayerVodsDocument = gql`
    query TestPlayerVods {
  espin_player_vod {
    id
  }
}
    `;
export const TestUserSearchDocument = gql`
    query TestUserSearch {
  espin_user {
    id
  }
}
    `;
export const TestGetPlayerSubsDocument = gql`
    query TestGetPlayerSubs {
  espin_player_subscription {
    id
    player_profile {
      id
      user_id
    }
  }
}
    `;
export const TestAdminPlayerLookupDocument = gql`
    query TestAdminPlayerLookup {
  espin_player_profile(limit: 100) {
    id
    spin_username
    created_at
    hs_name
    graduating_class
    subscribed_override
    sub_last_meeting
    sub_sales_notes
    sub_connected_colleges
    player_games {
      primary
      rank
      game {
        name
      }
    }
    social {
      discord
    }
    user {
      email
      subscription_status {
        is_subscribed
      }
    }
    address {
      state
    }
  }
}
    `;
export const TestUpdatePlayerSubscriptionNotesDocument = gql`
    mutation TestUpdatePlayerSubscriptionNotes($id: uuid!, $input: espin_player_profile_set_input) {
  update_espin_player_profile_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export const TestToggleSubscribedOverrideDocument = gql`
    mutation TestToggleSubscribedOverride($userId: String!, $status: Boolean!) {
  update_espin_player_profile(
    where: {user_id: {_eq: $userId}}
    _set: {subscribed_override: $status}
  ) {
    affected_rows
  }
}
    `;
export const TestToggleManualCollegeSubscriptionTierDocument = gql`
    mutation TestToggleManualCollegeSubscriptionTier($collegeId: uuid!, $subTier: Int!) {
  update_espin_college_by_pk(
    pk_columns: {id: $collegeId}
    _set: {manual_subtier: $subTier}
  ) {
    id
  }
}
    `;
export const TestUpdateAddressDocument = gql`
    mutation TestUpdateAddress($_set: espin_address_set_input, $where: espin_address_bool_exp!) {
  update_espin_address(_set: $_set, where: $where) {
    affected_rows
  }
}
    `;
export const TestUpdateParentProfileDocument = gql`
    mutation TestUpdateParentProfile($_set: espin_parent_profile_set_input, $where: espin_parent_profile_bool_exp!) {
  update_espin_parent_profile(_set: $_set, where: $where) {
    affected_rows
  }
}
    `;
export const TestUpdatePlayerProfileDocument = gql`
    mutation TestUpdatePlayerProfile($_set: espin_player_profile_set_input, $where: espin_player_profile_bool_exp!) {
  update_espin_player_profile(_set: $_set, where: $where) {
    affected_rows
  }
}
    `;
export const TestCreatePlayerVodDocument = gql`
    mutation TestCreatePlayerVod($input: espin_player_vod_insert_input!) {
  insert_espin_player_vod_one(object: $input) {
    id
  }
}
    `;
export const TestUpdatePlayerVodDocument = gql`
    mutation TestUpdatePlayerVod($_set: espin_player_vod_set_input, $where: espin_player_vod_bool_exp!) {
  update_espin_player_vod(_set: $_set, where: $where) {
    affected_rows
  }
}
    `;
export const TestCreateUserDocument = gql`
    mutation TestCreateUser($input: espin_user_insert_input!) {
  insert_espin_user_one(object: $input) {
    id
  }
}
    `;
export const TestUpdateUserDocument = gql`
    mutation TestUpdateUser($_set: espin_user_set_input, $where: espin_user_bool_exp!) {
  update_espin_user(_set: $_set, where: $where) {
    affected_rows
  }
}
    `;
export const TestCreatePlainUsersDocument = gql`
    mutation TestCreatePlainUsers($input: [espin_user_insert_input!]!) {
  insert_espin_user(objects: $input) {
    affected_rows
    returning {
      id
      role
    }
  }
}
    `;
export const TestLinkParentToChildDocument = gql`
    mutation TestLinkParentToChild($playerProfileId: uuid!, $parentProfileId: uuid!) {
  update_espin_player_profile_by_pk(
    pk_columns: {id: $playerProfileId}
    _set: {parent_profile_id: $parentProfileId}
  ) {
    id
  }
}
    `;
export const TestUnstickyPlayerDocument = gql`
    mutation TestUnstickyPlayer($id: uuid = "") {
  delete_espin_stickied_player(where: {player_profile_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export const TestCreatePlayerProfileDocument = gql`
    mutation TestCreatePlayerProfile($input: espin_player_profile_insert_input!) {
  insert_espin_player_profile_one(object: $input) {
    id
    slug
    spin_username
    user {
      id
      email
    }
  }
}
    `;
export const TestCreateSpinUserOneDocument = gql`
    mutation TestCreateSpinUserOne($input: espin_user_insert_input!) {
  insert_espin_user_one(object: $input) {
    id
    email
  }
}
    `;
export const TestSubbedPlayerViewingDocument = gql`
    query TestSubbedPlayerViewing($userId: String!) {
  espin_message(where: {player_user_id: {_eq: $userId}}) {
    player_user_id
    contents
    created_at
    viewed_at
    message_type
    college {
      logo {
        id
        cdn_url
        ext
      }
      name
      slug
    }
  }
  espin_notification {
    id
    notification_type
    viewed_at
    follows {
      follow_type
      player_user {
        deleted_at
        player_profile {
          user_id
          first_name
          last_name
          slug
          graduating_class
          profile_image {
            id
            cdn_url
            ext
          }
          player_games {
            primary
            game {
              name
              game_definition
            }
          }
        }
      }
      parent_user_id
      college_user_name
      college {
        name
        slug
        logo {
          id
          cdn_url
          ext
        }
      }
      college_user {
        deleted_at
      }
    }
    profile_views {
      profile_view_type
      player_user {
        deleted_at
        player_profile {
          user_id
          graduating_class
          first_name
          last_name
          slug
          profile_image {
            id
            cdn_url
            ext
          }
          player_games {
            primary
            game {
              name
              game_definition
            }
          }
        }
      }
      college_user_full_name
      id
      college {
        name
        slug
        logo {
          id
          cdn_url
          ext
        }
      }
      college_user {
        deleted_at
      }
    }
    messages {
      message_type
      viewed_at
      contents
      parent_user_id
      player_user {
        deleted_at
        player_profile {
          user_id
          first_name
          last_name
          slug
          profile_image {
            id
            cdn_url
            ext
          }
        }
      }
      college {
        name
        slug
        logo {
          id
          cdn_url
          ext
        }
      }
      college_user {
        deleted_at
      }
    }
  }
}
    `;
export const TestCreateParentProfileDocument = gql`
    mutation TestCreateParentProfile($input: espin_parent_profile_insert_input!) {
  insert_espin_parent_profile_one(object: $input) {
    id
    child_profiles {
      id
      spin_username
      user {
        id
      }
    }
    user {
      id
    }
  }
}
    `;
export const TestCreateEventTicketDocument = gql`
    mutation TestCreateEventTicket($input: espin_event_ticket_insert_input!) {
  insert_espin_event_ticket_one(object: $input) {
    id
  }
}
    `;
export const TestCreateHighSchoolAndUserAndStuffDocument = gql`
    mutation TestCreateHighSchoolAndUserAndStuff($input: espin_high_school_profile_insert_input!) {
  insert_espin_high_school_profile_one(
    object: $input
    on_conflict: {constraint: high_school_profile_user_id_key, update_columns: [first_name, last_name]}
  ) {
    id
    first_name
    last_name
    user {
      id
      email
    }
    high_school {
      id
      name
    }
  }
}
    `;
export const TestCreateCollegeAndUserAndStuffDocument = gql`
    mutation TestCreateCollegeAndUserAndStuff($input: espin_college_profile_insert_input!) {
  insert_espin_college_profile_one(
    object: $input
    on_conflict: {constraint: college_profile_user_id_key, update_columns: [first_name, last_name]}
  ) {
    id
    first_name
    last_name
    user {
      id
      email
    }
    college {
      id
      name
      program_name
      subscribed
      subscription {
        status
      }
    }
  }
}
    `;
export const TestUpdateCollegeSubscriptionEndDateDocument = gql`
    mutation TestUpdateCollegeSubscriptionEndDate($collegeId: uuid!, $expires: bigint!) {
  update_espin_college_subscription(
    where: {colleges: {id: {_eq: $collegeId}}}
    _set: {expires: $expires}
  ) {
    returning {
      status
    }
  }
}
    `;
export const TestUpdatePlayerSubscriptionEndDateDocument = gql`
    mutation TestUpdatePlayerSubscriptionEndDate($playerId: uuid!, $expires: bigint!) {
  update_espin_player_subscription(
    where: {player_profile: {id: {_eq: $playerId}}}
    _set: {expires: $expires}
  ) {
    returning {
      status
    }
  }
}
    `;
export const TestUpdateCollegeSubscriptionTierDocument = gql`
    mutation TestUpdateCollegeSubscriptionTier($collegeId: uuid!, $tier: espin_subscription_tier_type_enum!) {
  update_espin_college_subscription(
    where: {colleges: {id: {_eq: $collegeId}}}
    _set: {sub_tier: $tier}
  ) {
    returning {
      status
    }
  }
}
    `;
export const TestCheckPlayerSubscriptionStatusDocument = gql`
    query TestCheckPlayerSubscriptionStatus($playerId: uuid!) {
  espin_player_subscription(where: {player_profile: {id: {_eq: $playerId}}}) {
    status
  }
}
    `;
export const TestCheckCollegeSubscriptionStatusDocument = gql`
    query TestCheckCollegeSubscriptionStatus($collegeId: uuid!) {
  espin_college_subscription(where: {colleges: {id: {_eq: $collegeId}}}) {
    status
  }
}
    `;
export const TestCreateReferralCodeDocument = gql`
    mutation TestCreateReferralCode($input: espin_referral_code_insert_input!) {
  insert_espin_referral_code_one(object: $input) {
    code_key
  }
}
    `;
export const TestCheckSubscriberTierByUserDocument = gql`
    query TestCheckSubscriberTierByUser($userId: String!) {
  espin_user_subscription_status(where: {user: {id: {_eq: $userId}}}) {
    tier
    id
    is_subscribed
    tierlookup
  }
}
    `;
export const TestsCreateStudyFieldDocument = gql`
    mutation TestsCreateStudyField($input: String!) {
  insert_espin_study_field(objects: {name: $input}) {
    returning {
      id
      name
    }
  }
}
    `;
export const TestsCreateStudySubjectDocument = gql`
    mutation TestsCreateStudySubject($input: String!, $generalStudyID: uuid!) {
  insert_espin_study_subject(
    objects: {name: $input, study_field_id: $generalStudyID}
  ) {
    returning {
      id
    }
  }
}
    `;
export const TestInsertNotificationDocument = gql`
    mutation TestInsertNotification($input: espin_notification_insert_input!) {
  insert_espin_notification_one(object: $input) {
    id
  }
}
    `;
export const TestGetNotificationByIdDocument = gql`
    query TestGetNotificationById($id: uuid!) {
  espin_notification_by_pk(id: $id) {
    notification_type
  }
}
    `;